/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * A date-time string at UTC, such as 2007-12-03T10:15:30Z,
   *     compliant with the 'date-time' format outlined in section 5.6 of
   *     the RFC 3339 profile of the ISO 8601 standard for representation
   *     of dates and times using the Gregorian calendar.
   */
  DateTime: { input: any; output: any; }
  /** The 'Dimension' type represents dimensions as whole numeric values between `1` and `4000`. */
  Dimension: { input: any; output: any; }
  /** The 'HexColor' type represents color in `rgb:ffffff` string format. */
  HexColor: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The 'Quality' type represents quality as whole numeric values between `1` and `100`. */
  Quality: { input: any; output: any; }
};

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/annualReport) */
export type AnnualReport = Entry & _Node & {
  __typename: 'AnnualReport';
  _id: Scalars['ID']['output'];
  articleBodyPart1: Maybe<Scalars['String']['output']>;
  articleBodyPart2: Maybe<AnnualReportArticleBodyPart2>;
  audio: Maybe<Asset>;
  callToActionCtaText: Maybe<Scalars['String']['output']>;
  callToActionText: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  date: Maybe<Scalars['DateTime']['output']>;
  description: Maybe<Scalars['String']['output']>;
  header: Maybe<Scalars['String']['output']>;
  headline: Maybe<Asset>;
  introImagesCollection: Maybe<AssetCollection>;
  introImagesCursorCollection: Maybe<AssetCursorCollection>;
  isLookingForAnnualReportsSectionVisible: Maybe<Scalars['Boolean']['output']>;
  linkedFrom: Maybe<AnnualReportLinkingCollections>;
  moreAnnualReportsCollection: Maybe<AnnualReportMoreAnnualReportsCollection>;
  moreAnnualReportsCursorCollection: Maybe<AnnualReportMoreAnnualReportsCursorCollection>;
  moreAnnualReportsTitle: Maybe<Scalars['String']['output']>;
  person: Maybe<Person>;
  quickLinks: Maybe<ConnectWith>;
  slug: Maybe<Scalars['String']['output']>;
  sys: Sys;
  year: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/annualReport) */
export type AnnualReportArticleBodyPart1Args = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/annualReport) */
export type AnnualReportArticleBodyPart2Args = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/annualReport) */
export type AnnualReportAudioArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/annualReport) */
export type AnnualReportCallToActionCtaTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/annualReport) */
export type AnnualReportCallToActionTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/annualReport) */
export type AnnualReportDateArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/annualReport) */
export type AnnualReportDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/annualReport) */
export type AnnualReportHeaderArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/annualReport) */
export type AnnualReportHeadlineArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/annualReport) */
export type AnnualReportIntroImagesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/annualReport) */
export type AnnualReportIntroImagesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/annualReport) */
export type AnnualReportIsLookingForAnnualReportsSectionVisibleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/annualReport) */
export type AnnualReportLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/annualReport) */
export type AnnualReportMoreAnnualReportsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<AnnualReportMoreAnnualReportsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/annualReport) */
export type AnnualReportMoreAnnualReportsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<AnnualReportMoreAnnualReportsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/annualReport) */
export type AnnualReportMoreAnnualReportsTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/annualReport) */
export type AnnualReportPersonArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PersonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/annualReport) */
export type AnnualReportQuickLinksArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ConnectWithFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/annualReport) */
export type AnnualReportSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/annualReport) */
export type AnnualReportYearArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type AnnualReportArticleBodyPart2 = {
  __typename: 'AnnualReportArticleBodyPart2';
  json: Scalars['JSON']['output'];
  links: AnnualReportArticleBodyPart2Links;
};

export type AnnualReportArticleBodyPart2Assets = {
  __typename: 'AnnualReportArticleBodyPart2Assets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type AnnualReportArticleBodyPart2Entries = {
  __typename: 'AnnualReportArticleBodyPart2Entries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type AnnualReportArticleBodyPart2Links = {
  __typename: 'AnnualReportArticleBodyPart2Links';
  assets: AnnualReportArticleBodyPart2Assets;
  entries: AnnualReportArticleBodyPart2Entries;
  resources: AnnualReportArticleBodyPart2Resources;
};

export type AnnualReportArticleBodyPart2Resources = {
  __typename: 'AnnualReportArticleBodyPart2Resources';
  block: Array<AnnualReportArticleBodyPart2ResourcesBlock>;
  hyperlink: Array<AnnualReportArticleBodyPart2ResourcesHyperlink>;
  inline: Array<AnnualReportArticleBodyPart2ResourcesInline>;
};

export type AnnualReportArticleBodyPart2ResourcesBlock = ResourceLink & {
  __typename: 'AnnualReportArticleBodyPart2ResourcesBlock';
  sys: ResourceSys;
};

export type AnnualReportArticleBodyPart2ResourcesHyperlink = ResourceLink & {
  __typename: 'AnnualReportArticleBodyPart2ResourcesHyperlink';
  sys: ResourceSys;
};

export type AnnualReportArticleBodyPart2ResourcesInline = ResourceLink & {
  __typename: 'AnnualReportArticleBodyPart2ResourcesInline';
  sys: ResourceSys;
};

export type AnnualReportCollection = {
  __typename: 'AnnualReportCollection';
  items: Array<Maybe<AnnualReport>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AnnualReportCursorCollection = {
  __typename: 'AnnualReportCursorCollection';
  items: Array<Maybe<AnnualReport>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type AnnualReportFilter = {
  AND: InputMaybe<Array<InputMaybe<AnnualReportFilter>>>;
  OR: InputMaybe<Array<InputMaybe<AnnualReportFilter>>>;
  articleBodyPart1: InputMaybe<Scalars['String']['input']>;
  articleBodyPart1_contains: InputMaybe<Scalars['String']['input']>;
  articleBodyPart1_exists: InputMaybe<Scalars['Boolean']['input']>;
  articleBodyPart1_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  articleBodyPart1_not: InputMaybe<Scalars['String']['input']>;
  articleBodyPart1_not_contains: InputMaybe<Scalars['String']['input']>;
  articleBodyPart1_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  articleBodyPart2_contains: InputMaybe<Scalars['String']['input']>;
  articleBodyPart2_exists: InputMaybe<Scalars['Boolean']['input']>;
  articleBodyPart2_not_contains: InputMaybe<Scalars['String']['input']>;
  audio_exists: InputMaybe<Scalars['Boolean']['input']>;
  callToActionCtaText: InputMaybe<Scalars['String']['input']>;
  callToActionCtaText_contains: InputMaybe<Scalars['String']['input']>;
  callToActionCtaText_exists: InputMaybe<Scalars['Boolean']['input']>;
  callToActionCtaText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionCtaText_not: InputMaybe<Scalars['String']['input']>;
  callToActionCtaText_not_contains: InputMaybe<Scalars['String']['input']>;
  callToActionCtaText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionText: InputMaybe<Scalars['String']['input']>;
  callToActionText_contains: InputMaybe<Scalars['String']['input']>;
  callToActionText_exists: InputMaybe<Scalars['Boolean']['input']>;
  callToActionText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionText_not: InputMaybe<Scalars['String']['input']>;
  callToActionText_not_contains: InputMaybe<Scalars['String']['input']>;
  callToActionText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  date: InputMaybe<Scalars['DateTime']['input']>;
  date_exists: InputMaybe<Scalars['Boolean']['input']>;
  date_gt: InputMaybe<Scalars['DateTime']['input']>;
  date_gte: InputMaybe<Scalars['DateTime']['input']>;
  date_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_lt: InputMaybe<Scalars['DateTime']['input']>;
  date_lte: InputMaybe<Scalars['DateTime']['input']>;
  date_not: InputMaybe<Scalars['DateTime']['input']>;
  date_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  header: InputMaybe<Scalars['String']['input']>;
  header_contains: InputMaybe<Scalars['String']['input']>;
  header_exists: InputMaybe<Scalars['Boolean']['input']>;
  header_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  header_not: InputMaybe<Scalars['String']['input']>;
  header_not_contains: InputMaybe<Scalars['String']['input']>;
  header_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline_exists: InputMaybe<Scalars['Boolean']['input']>;
  introImagesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  isLookingForAnnualReportsSectionVisible: InputMaybe<Scalars['Boolean']['input']>;
  isLookingForAnnualReportsSectionVisible_exists: InputMaybe<Scalars['Boolean']['input']>;
  isLookingForAnnualReportsSectionVisible_not: InputMaybe<Scalars['Boolean']['input']>;
  moreAnnualReports: InputMaybe<CfmoreAnnualReportsMultiTypeNestedFilter>;
  moreAnnualReportsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  moreAnnualReportsTitle: InputMaybe<Scalars['String']['input']>;
  moreAnnualReportsTitle_contains: InputMaybe<Scalars['String']['input']>;
  moreAnnualReportsTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  moreAnnualReportsTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  moreAnnualReportsTitle_not: InputMaybe<Scalars['String']['input']>;
  moreAnnualReportsTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  moreAnnualReportsTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  person: InputMaybe<CfPersonNestedFilter>;
  person_exists: InputMaybe<Scalars['Boolean']['input']>;
  quickLinks: InputMaybe<CfConnectWithNestedFilter>;
  quickLinks_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  year: InputMaybe<Scalars['String']['input']>;
  year_contains: InputMaybe<Scalars['String']['input']>;
  year_exists: InputMaybe<Scalars['Boolean']['input']>;
  year_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  year_not: InputMaybe<Scalars['String']['input']>;
  year_not_contains: InputMaybe<Scalars['String']['input']>;
  year_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AnnualReportLinkingCollections = {
  __typename: 'AnnualReportLinkingCollections';
  annualReportCollection: Maybe<AnnualReportCollection>;
  annualReportCursorCollection: Maybe<AnnualReportCursorCollection>;
  connectWithLinkCollection: Maybe<ConnectWithLinkCollection>;
  connectWithLinkCursorCollection: Maybe<ConnectWithLinkCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  homePageCollection: Maybe<HomePageCollection>;
  homePageCursorCollection: Maybe<HomePageCursorCollection>;
  mmufCollection: Maybe<MmufCollection>;
  mmufCursorCollection: Maybe<MmufCursorCollection>;
  newsPageCollection: Maybe<NewsPageCollection>;
  newsPageCursorCollection: Maybe<NewsPageCursorCollection>;
  personCollection: Maybe<PersonCollection>;
  personCursorCollection: Maybe<PersonCursorCollection>;
  pressRoomCollection: Maybe<PressRoomCollection>;
  pressRoomCursorCollection: Maybe<PressRoomCursorCollection>;
  resourcesCurrentGranteesCollection: Maybe<ResourcesCurrentGranteesCollection>;
  resourcesCurrentGranteesCursorCollection: Maybe<ResourcesCurrentGranteesCursorCollection>;
};


export type AnnualReportLinkingCollectionsAnnualReportCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<AnnualReportLinkingCollectionsAnnualReportCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnnualReportLinkingCollectionsAnnualReportCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<AnnualReportLinkingCollectionsAnnualReportCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnnualReportLinkingCollectionsConnectWithLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<AnnualReportLinkingCollectionsConnectWithLinkCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnnualReportLinkingCollectionsConnectWithLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<AnnualReportLinkingCollectionsConnectWithLinkCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnnualReportLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnnualReportLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnnualReportLinkingCollectionsHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<AnnualReportLinkingCollectionsHomePageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnnualReportLinkingCollectionsHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<AnnualReportLinkingCollectionsHomePageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnnualReportLinkingCollectionsMmufCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<AnnualReportLinkingCollectionsMmufCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnnualReportLinkingCollectionsMmufCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<AnnualReportLinkingCollectionsMmufCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnnualReportLinkingCollectionsNewsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<AnnualReportLinkingCollectionsNewsPageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnnualReportLinkingCollectionsNewsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<AnnualReportLinkingCollectionsNewsPageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnnualReportLinkingCollectionsPersonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<AnnualReportLinkingCollectionsPersonCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnnualReportLinkingCollectionsPersonCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<AnnualReportLinkingCollectionsPersonCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnnualReportLinkingCollectionsPressRoomCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<AnnualReportLinkingCollectionsPressRoomCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnnualReportLinkingCollectionsPressRoomCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<AnnualReportLinkingCollectionsPressRoomCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnnualReportLinkingCollectionsResourcesCurrentGranteesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<AnnualReportLinkingCollectionsResourcesCurrentGranteesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnnualReportLinkingCollectionsResourcesCurrentGranteesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<AnnualReportLinkingCollectionsResourcesCurrentGranteesCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AnnualReportLinkingCollectionsAnnualReportCollectionOrder {
  CallToActionCtaTextAsc = 'callToActionCtaText_ASC',
  CallToActionCtaTextDesc = 'callToActionCtaText_DESC',
  CallToActionTextAsc = 'callToActionText_ASC',
  CallToActionTextDesc = 'callToActionText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  IsLookingForAnnualReportsSectionVisibleAsc = 'isLookingForAnnualReportsSectionVisible_ASC',
  IsLookingForAnnualReportsSectionVisibleDesc = 'isLookingForAnnualReportsSectionVisible_DESC',
  MoreAnnualReportsTitleAsc = 'moreAnnualReportsTitle_ASC',
  MoreAnnualReportsTitleDesc = 'moreAnnualReportsTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  YearAsc = 'year_ASC',
  YearDesc = 'year_DESC'
}

export enum AnnualReportLinkingCollectionsAnnualReportCursorCollectionOrder {
  CallToActionCtaTextAsc = 'callToActionCtaText_ASC',
  CallToActionCtaTextDesc = 'callToActionCtaText_DESC',
  CallToActionTextAsc = 'callToActionText_ASC',
  CallToActionTextDesc = 'callToActionText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  IsLookingForAnnualReportsSectionVisibleAsc = 'isLookingForAnnualReportsSectionVisible_ASC',
  IsLookingForAnnualReportsSectionVisibleDesc = 'isLookingForAnnualReportsSectionVisible_DESC',
  MoreAnnualReportsTitleAsc = 'moreAnnualReportsTitle_ASC',
  MoreAnnualReportsTitleDesc = 'moreAnnualReportsTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  YearAsc = 'year_ASC',
  YearDesc = 'year_DESC'
}

export enum AnnualReportLinkingCollectionsConnectWithLinkCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum AnnualReportLinkingCollectionsConnectWithLinkCursorCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum AnnualReportLinkingCollectionsHomePageCollectionOrder {
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  MissionTextAsc = 'missionText_ASC',
  MissionTextDesc = 'missionText_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StoriesCtaAsc = 'storiesCta_ASC',
  StoriesCtaDesc = 'storiesCta_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum AnnualReportLinkingCollectionsHomePageCursorCollectionOrder {
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  MissionTextAsc = 'missionText_ASC',
  MissionTextDesc = 'missionText_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StoriesCtaAsc = 'storiesCta_ASC',
  StoriesCtaDesc = 'storiesCta_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum AnnualReportLinkingCollectionsMmufCollectionOrder {
  ArticleTitleAsc = 'articleTitle_ASC',
  ArticleTitleDesc = 'articleTitle_DESC',
  AtGlanceTitleAsc = 'atGlanceTitle_ASC',
  AtGlanceTitleDesc = 'atGlanceTitle_DESC',
  ContactEmailAsc = 'contactEmail_ASC',
  ContactEmailDesc = 'contactEmail_DESC',
  ContactMessageAsc = 'contactMessage_ASC',
  ContactMessageDesc = 'contactMessage_DESC',
  ContactTitleAsc = 'contactTitle_ASC',
  ContactTitleDesc = 'contactTitle_DESC',
  FellowStoriesCtaLabelAsc = 'fellowStoriesCtaLabel_ASC',
  FellowStoriesCtaLabelDesc = 'fellowStoriesCtaLabel_DESC',
  FellowStoriesMessageAsc = 'fellowStoriesMessage_ASC',
  FellowStoriesMessageDesc = 'fellowStoriesMessage_DESC',
  GraduateInitiativesTitleAsc = 'graduateInitiativesTitle_ASC',
  GraduateInitiativesTitleDesc = 'graduateInitiativesTitle_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum AnnualReportLinkingCollectionsMmufCursorCollectionOrder {
  ArticleTitleAsc = 'articleTitle_ASC',
  ArticleTitleDesc = 'articleTitle_DESC',
  AtGlanceTitleAsc = 'atGlanceTitle_ASC',
  AtGlanceTitleDesc = 'atGlanceTitle_DESC',
  ContactEmailAsc = 'contactEmail_ASC',
  ContactEmailDesc = 'contactEmail_DESC',
  ContactMessageAsc = 'contactMessage_ASC',
  ContactMessageDesc = 'contactMessage_DESC',
  ContactTitleAsc = 'contactTitle_ASC',
  ContactTitleDesc = 'contactTitle_DESC',
  FellowStoriesCtaLabelAsc = 'fellowStoriesCtaLabel_ASC',
  FellowStoriesCtaLabelDesc = 'fellowStoriesCtaLabel_DESC',
  FellowStoriesMessageAsc = 'fellowStoriesMessage_ASC',
  FellowStoriesMessageDesc = 'fellowStoriesMessage_DESC',
  GraduateInitiativesTitleAsc = 'graduateInitiativesTitle_ASC',
  GraduateInitiativesTitleDesc = 'graduateInitiativesTitle_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum AnnualReportLinkingCollectionsNewsPageCollectionOrder {
  PressRoomCopyAsc = 'pressRoomCopy_ASC',
  PressRoomCopyDesc = 'pressRoomCopy_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum AnnualReportLinkingCollectionsNewsPageCursorCollectionOrder {
  PressRoomCopyAsc = 'pressRoomCopy_ASC',
  PressRoomCopyDesc = 'pressRoomCopy_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum AnnualReportLinkingCollectionsPersonCollectionOrder {
  FirstNameAsc = 'firstName_ASC',
  FirstNameDesc = 'firstName_DESC',
  JobTitleAsc = 'jobTitle_ASC',
  JobTitleDesc = 'jobTitle_DESC',
  LastNameAsc = 'lastName_ASC',
  LastNameDesc = 'lastName_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  RelatedSectionTitleAsc = 'relatedSectionTitle_ASC',
  RelatedSectionTitleDesc = 'relatedSectionTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum AnnualReportLinkingCollectionsPersonCursorCollectionOrder {
  FirstNameAsc = 'firstName_ASC',
  FirstNameDesc = 'firstName_DESC',
  JobTitleAsc = 'jobTitle_ASC',
  JobTitleDesc = 'jobTitle_DESC',
  LastNameAsc = 'lastName_ASC',
  LastNameDesc = 'lastName_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  RelatedSectionTitleAsc = 'relatedSectionTitle_ASC',
  RelatedSectionTitleDesc = 'relatedSectionTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum AnnualReportLinkingCollectionsPressRoomCollectionOrder {
  ContactsTitleAsc = 'contactsTitle_ASC',
  ContactsTitleDesc = 'contactsTitle_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  EmailLabelAsc = 'emailLabel_ASC',
  EmailLabelDesc = 'emailLabel_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  GuidelinesAndMediasDescriptionAsc = 'guidelinesAndMediasDescription_ASC',
  GuidelinesAndMediasDescriptionDesc = 'guidelinesAndMediasDescription_DESC',
  GuidelinesAndMediasHeadingAsc = 'guidelinesAndMediasHeading_ASC',
  GuidelinesAndMediasHeadingDesc = 'guidelinesAndMediasHeading_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum AnnualReportLinkingCollectionsPressRoomCursorCollectionOrder {
  ContactsTitleAsc = 'contactsTitle_ASC',
  ContactsTitleDesc = 'contactsTitle_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  EmailLabelAsc = 'emailLabel_ASC',
  EmailLabelDesc = 'emailLabel_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  GuidelinesAndMediasDescriptionAsc = 'guidelinesAndMediasDescription_ASC',
  GuidelinesAndMediasDescriptionDesc = 'guidelinesAndMediasDescription_DESC',
  GuidelinesAndMediasHeadingAsc = 'guidelinesAndMediasHeading_ASC',
  GuidelinesAndMediasHeadingDesc = 'guidelinesAndMediasHeading_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum AnnualReportLinkingCollectionsResourcesCurrentGranteesCollectionOrder {
  GrantDatabaseCtaTextAsc = 'grantDatabaseCtaText_ASC',
  GrantDatabaseCtaTextDesc = 'grantDatabaseCtaText_DESC',
  ResourcesTitleAsc = 'resourcesTitle_ASC',
  ResourcesTitleDesc = 'resourcesTitle_DESC',
  SimilarGranteesTitleAsc = 'similarGranteesTitle_ASC',
  SimilarGranteesTitleDesc = 'similarGranteesTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum AnnualReportLinkingCollectionsResourcesCurrentGranteesCursorCollectionOrder {
  GrantDatabaseCtaTextAsc = 'grantDatabaseCtaText_ASC',
  GrantDatabaseCtaTextDesc = 'grantDatabaseCtaText_DESC',
  ResourcesTitleAsc = 'resourcesTitle_ASC',
  ResourcesTitleDesc = 'resourcesTitle_DESC',
  SimilarGranteesTitleAsc = 'similarGranteesTitle_ASC',
  SimilarGranteesTitleDesc = 'similarGranteesTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type AnnualReportMoreAnnualReportsCollection = {
  __typename: 'AnnualReportMoreAnnualReportsCollection';
  items: Array<Maybe<AnnualReportMoreAnnualReportsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AnnualReportMoreAnnualReportsCursorCollection = {
  __typename: 'AnnualReportMoreAnnualReportsCursorCollection';
  items: Array<Maybe<AnnualReportMoreAnnualReportsItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type AnnualReportMoreAnnualReportsFilter = {
  AND: InputMaybe<Array<InputMaybe<AnnualReportMoreAnnualReportsFilter>>>;
  OR: InputMaybe<Array<InputMaybe<AnnualReportMoreAnnualReportsFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
  year: InputMaybe<Scalars['String']['input']>;
  year_contains: InputMaybe<Scalars['String']['input']>;
  year_exists: InputMaybe<Scalars['Boolean']['input']>;
  year_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  year_not: InputMaybe<Scalars['String']['input']>;
  year_not_contains: InputMaybe<Scalars['String']['input']>;
  year_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AnnualReportMoreAnnualReportsItem = AnnualReport | OldAnnualReport;

export enum AnnualReportOrder {
  CallToActionCtaTextAsc = 'callToActionCtaText_ASC',
  CallToActionCtaTextDesc = 'callToActionCtaText_DESC',
  CallToActionTextAsc = 'callToActionText_ASC',
  CallToActionTextDesc = 'callToActionText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  IsLookingForAnnualReportsSectionVisibleAsc = 'isLookingForAnnualReportsSectionVisible_ASC',
  IsLookingForAnnualReportsSectionVisibleDesc = 'isLookingForAnnualReportsSectionVisible_DESC',
  MoreAnnualReportsTitleAsc = 'moreAnnualReportsTitle_ASC',
  MoreAnnualReportsTitleDesc = 'moreAnnualReportsTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  YearAsc = 'year_ASC',
  YearDesc = 'year_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/article) */
export type Article = Entry & _Node & {
  __typename: 'Article';
  _id: Scalars['ID']['output'];
  audio: Maybe<Asset>;
  author: Maybe<Scalars['String']['output']>;
  body: Maybe<ArticleBody>;
  contentfulMetadata: ContentfulMetadata;
  creditLabel: Maybe<Scalars['String']['output']>;
  creditText: Maybe<Scalars['String']['output']>;
  date: Maybe<Scalars['DateTime']['output']>;
  description: Maybe<Scalars['String']['output']>;
  externalNewsUrl: Maybe<Scalars['String']['output']>;
  externalPerson: Maybe<ExternalPerson>;
  eyebrow: Maybe<Scalars['String']['output']>;
  faqs: Maybe<FaqsModule>;
  formattingOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  grantMakingArea: Maybe<GrantmakingArea>;
  hero: Maybe<HeroAsset>;
  heroImage: Maybe<Asset>;
  hideDate: Maybe<Scalars['Boolean']['output']>;
  hideShareLink: Maybe<Scalars['Boolean']['output']>;
  linkedFrom: Maybe<ArticleLinkingCollections>;
  location: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Metadata>;
  password: Maybe<Scalars['String']['output']>;
  passwordProtectedPage: Maybe<PasswordProtectedPage>;
  person: Maybe<Person>;
  photographer: Maybe<Scalars['String']['output']>;
  publisherLogo: Maybe<Asset>;
  quickLinks: Maybe<ConnectWith>;
  relatedContentCollection: Maybe<ArticleRelatedContentCollection>;
  relatedContentCursorCollection: Maybe<ArticleRelatedContentCursorCollection>;
  slug: Maybe<Scalars['String']['output']>;
  sys: Sys;
  thumbnailImage: Maybe<Asset>;
  title: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/article) */
export type ArticleAudioArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/article) */
export type ArticleAuthorArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/article) */
export type ArticleBodyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/article) */
export type ArticleCreditLabelArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/article) */
export type ArticleCreditTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/article) */
export type ArticleDateArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/article) */
export type ArticleDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/article) */
export type ArticleExternalNewsUrlArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/article) */
export type ArticleExternalPersonArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ExternalPersonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/article) */
export type ArticleEyebrowArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/article) */
export type ArticleFaqsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<FaqsModuleFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/article) */
export type ArticleFormattingOptionsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/article) */
export type ArticleGrantMakingAreaArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantmakingAreaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/article) */
export type ArticleHeroArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<HeroAssetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/article) */
export type ArticleHeroImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/article) */
export type ArticleHideDateArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/article) */
export type ArticleHideShareLinkArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/article) */
export type ArticleLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/article) */
export type ArticleLocationArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/article) */
export type ArticleMetadataArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<MetadataFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/article) */
export type ArticlePasswordArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/article) */
export type ArticlePasswordProtectedPageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PasswordProtectedPageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/article) */
export type ArticlePersonArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PersonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/article) */
export type ArticlePhotographerArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/article) */
export type ArticlePublisherLogoArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/article) */
export type ArticleQuickLinksArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ConnectWithFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/article) */
export type ArticleRelatedContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ArticleRelatedContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/article) */
export type ArticleRelatedContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ArticleRelatedContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/article) */
export type ArticleSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/article) */
export type ArticleThumbnailImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/article) */
export type ArticleTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/article) */
export type ArticleTypeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ArticleBody = {
  __typename: 'ArticleBody';
  json: Scalars['JSON']['output'];
  links: ArticleBodyLinks;
};

export type ArticleBodyAssets = {
  __typename: 'ArticleBodyAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ArticleBodyEntries = {
  __typename: 'ArticleBodyEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ArticleBodyLinks = {
  __typename: 'ArticleBodyLinks';
  assets: ArticleBodyAssets;
  entries: ArticleBodyEntries;
  resources: ArticleBodyResources;
};

export type ArticleBodyResources = {
  __typename: 'ArticleBodyResources';
  block: Array<ArticleBodyResourcesBlock>;
  hyperlink: Array<ArticleBodyResourcesHyperlink>;
  inline: Array<ArticleBodyResourcesInline>;
};

export type ArticleBodyResourcesBlock = ResourceLink & {
  __typename: 'ArticleBodyResourcesBlock';
  sys: ResourceSys;
};

export type ArticleBodyResourcesHyperlink = ResourceLink & {
  __typename: 'ArticleBodyResourcesHyperlink';
  sys: ResourceSys;
};

export type ArticleBodyResourcesInline = ResourceLink & {
  __typename: 'ArticleBodyResourcesInline';
  sys: ResourceSys;
};

export type ArticleCollection = {
  __typename: 'ArticleCollection';
  items: Array<Maybe<Article>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ArticleCursorCollection = {
  __typename: 'ArticleCursorCollection';
  items: Array<Maybe<Article>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ArticleFilter = {
  AND: InputMaybe<Array<InputMaybe<ArticleFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ArticleFilter>>>;
  audio_exists: InputMaybe<Scalars['Boolean']['input']>;
  author: InputMaybe<Scalars['String']['input']>;
  author_contains: InputMaybe<Scalars['String']['input']>;
  author_exists: InputMaybe<Scalars['Boolean']['input']>;
  author_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  author_not: InputMaybe<Scalars['String']['input']>;
  author_not_contains: InputMaybe<Scalars['String']['input']>;
  author_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_contains: InputMaybe<Scalars['String']['input']>;
  body_exists: InputMaybe<Scalars['Boolean']['input']>;
  body_not_contains: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  creditLabel: InputMaybe<Scalars['String']['input']>;
  creditLabel_contains: InputMaybe<Scalars['String']['input']>;
  creditLabel_exists: InputMaybe<Scalars['Boolean']['input']>;
  creditLabel_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  creditLabel_not: InputMaybe<Scalars['String']['input']>;
  creditLabel_not_contains: InputMaybe<Scalars['String']['input']>;
  creditLabel_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  creditText: InputMaybe<Scalars['String']['input']>;
  creditText_contains: InputMaybe<Scalars['String']['input']>;
  creditText_exists: InputMaybe<Scalars['Boolean']['input']>;
  creditText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  creditText_not: InputMaybe<Scalars['String']['input']>;
  creditText_not_contains: InputMaybe<Scalars['String']['input']>;
  creditText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  date: InputMaybe<Scalars['DateTime']['input']>;
  date_exists: InputMaybe<Scalars['Boolean']['input']>;
  date_gt: InputMaybe<Scalars['DateTime']['input']>;
  date_gte: InputMaybe<Scalars['DateTime']['input']>;
  date_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_lt: InputMaybe<Scalars['DateTime']['input']>;
  date_lte: InputMaybe<Scalars['DateTime']['input']>;
  date_not: InputMaybe<Scalars['DateTime']['input']>;
  date_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalNewsUrl: InputMaybe<Scalars['String']['input']>;
  externalNewsUrl_contains: InputMaybe<Scalars['String']['input']>;
  externalNewsUrl_exists: InputMaybe<Scalars['Boolean']['input']>;
  externalNewsUrl_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalNewsUrl_not: InputMaybe<Scalars['String']['input']>;
  externalNewsUrl_not_contains: InputMaybe<Scalars['String']['input']>;
  externalNewsUrl_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalPerson: InputMaybe<CfExternalPersonNestedFilter>;
  externalPerson_exists: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow: InputMaybe<Scalars['String']['input']>;
  eyebrow_contains: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faqs: InputMaybe<CfFaqsModuleNestedFilter>;
  faqs_exists: InputMaybe<Scalars['Boolean']['input']>;
  formattingOptions_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattingOptions_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattingOptions_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattingOptions_exists: InputMaybe<Scalars['Boolean']['input']>;
  grantMakingArea: InputMaybe<CfGrantmakingAreaNestedFilter>;
  grantMakingArea_exists: InputMaybe<Scalars['Boolean']['input']>;
  hero: InputMaybe<CfHeroAssetNestedFilter>;
  heroImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  hero_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideDate: InputMaybe<Scalars['Boolean']['input']>;
  hideDate_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideDate_not: InputMaybe<Scalars['Boolean']['input']>;
  hideShareLink: InputMaybe<Scalars['Boolean']['input']>;
  hideShareLink_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideShareLink_not: InputMaybe<Scalars['Boolean']['input']>;
  location: InputMaybe<Scalars['String']['input']>;
  location_contains: InputMaybe<Scalars['String']['input']>;
  location_exists: InputMaybe<Scalars['Boolean']['input']>;
  location_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location_not: InputMaybe<Scalars['String']['input']>;
  location_not_contains: InputMaybe<Scalars['String']['input']>;
  location_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metadata: InputMaybe<CfMetadataNestedFilter>;
  metadata_exists: InputMaybe<Scalars['Boolean']['input']>;
  password: InputMaybe<Scalars['String']['input']>;
  passwordProtectedPage: InputMaybe<CfPasswordProtectedPageNestedFilter>;
  passwordProtectedPage_exists: InputMaybe<Scalars['Boolean']['input']>;
  password_contains: InputMaybe<Scalars['String']['input']>;
  password_exists: InputMaybe<Scalars['Boolean']['input']>;
  password_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  password_not: InputMaybe<Scalars['String']['input']>;
  password_not_contains: InputMaybe<Scalars['String']['input']>;
  password_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  person: InputMaybe<CfPersonNestedFilter>;
  person_exists: InputMaybe<Scalars['Boolean']['input']>;
  photographer: InputMaybe<Scalars['String']['input']>;
  photographer_contains: InputMaybe<Scalars['String']['input']>;
  photographer_exists: InputMaybe<Scalars['Boolean']['input']>;
  photographer_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  photographer_not: InputMaybe<Scalars['String']['input']>;
  photographer_not_contains: InputMaybe<Scalars['String']['input']>;
  photographer_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  publisherLogo_exists: InputMaybe<Scalars['Boolean']['input']>;
  quickLinks: InputMaybe<CfConnectWithNestedFilter>;
  quickLinks_exists: InputMaybe<Scalars['Boolean']['input']>;
  relatedContent: InputMaybe<CfrelatedContentMultiTypeNestedFilter>;
  relatedContentCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  thumbnailImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type: InputMaybe<Scalars['String']['input']>;
  type_contains: InputMaybe<Scalars['String']['input']>;
  type_exists: InputMaybe<Scalars['Boolean']['input']>;
  type_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not: InputMaybe<Scalars['String']['input']>;
  type_not_contains: InputMaybe<Scalars['String']['input']>;
  type_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ArticleLinkingCollections = {
  __typename: 'ArticleLinkingCollections';
  articleCollection: Maybe<ArticleCollection>;
  articleCursorCollection: Maybe<ArticleCursorCollection>;
  atGlanceCardCollection: Maybe<AtGlanceCardCollection>;
  atGlanceCardCursorCollection: Maybe<AtGlanceCardCursorCollection>;
  callForConceptCollection: Maybe<CallForConceptCollection>;
  callForConceptCursorCollection: Maybe<CallForConceptCursorCollection>;
  connectWithLinkCollection: Maybe<ConnectWithLinkCollection>;
  connectWithLinkCursorCollection: Maybe<ConnectWithLinkCursorCollection>;
  emphasizedArticleCollection: Maybe<EmphasizedArticleCollection>;
  emphasizedArticleCursorCollection: Maybe<EmphasizedArticleCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  experienceBlockCollection: Maybe<ExperienceBlockCollection>;
  experienceBlockCursorCollection: Maybe<ExperienceBlockCursorCollection>;
  featureCollection: Maybe<FeatureCollection>;
  featureCursorCollection: Maybe<FeatureCursorCollection>;
  grantActivityArticleCollection: Maybe<GrantActivityArticleCollection>;
  grantActivityArticleCursorCollection: Maybe<GrantActivityArticleCursorCollection>;
  grantDetailsPageCollection: Maybe<GrantDetailsPageCollection>;
  grantDetailsPageCursorCollection: Maybe<GrantDetailsPageCursorCollection>;
  grantmakingAreaDetailsPageCollection: Maybe<GrantmakingAreaDetailsPageCollection>;
  grantmakingAreaDetailsPageCursorCollection: Maybe<GrantmakingAreaDetailsPageCursorCollection>;
  historyPageCollection: Maybe<HistoryPageCollection>;
  historyPageCursorCollection: Maybe<HistoryPageCursorCollection>;
  homePageCollection: Maybe<HomePageCollection>;
  homePageCursorCollection: Maybe<HomePageCursorCollection>;
  ideaCollection: Maybe<IdeaCollection>;
  ideaCursorCollection: Maybe<IdeaCursorCollection>;
  inlineCardsCollection: Maybe<InlineCardsCollection>;
  inlineCardsCursorCollection: Maybe<InlineCardsCursorCollection>;
  mmufCollection: Maybe<MmufCollection>;
  mmufCursorCollection: Maybe<MmufCursorCollection>;
  navigationItemCollection: Maybe<NavigationItemCollection>;
  navigationItemCursorCollection: Maybe<NavigationItemCursorCollection>;
  newsPageCollection: Maybe<NewsPageCollection>;
  newsPageCursorCollection: Maybe<NewsPageCursorCollection>;
  personCollection: Maybe<PersonCollection>;
  personCursorCollection: Maybe<PersonCursorCollection>;
  pressRoomCollection: Maybe<PressRoomCollection>;
  pressRoomCursorCollection: Maybe<PressRoomCursorCollection>;
  resourcesCurrentGranteesCollection: Maybe<ResourcesCurrentGranteesCollection>;
  resourcesCurrentGranteesCursorCollection: Maybe<ResourcesCurrentGranteesCursorCollection>;
};


export type ArticleLinkingCollectionsArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsArticleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsArticleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsArticleCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsAtGlanceCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsAtGlanceCardCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsAtGlanceCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsAtGlanceCardCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsCallForConceptCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsCallForConceptCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsCallForConceptCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsCallForConceptCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsConnectWithLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsConnectWithLinkCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsConnectWithLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsConnectWithLinkCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsEmphasizedArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsEmphasizedArticleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsEmphasizedArticleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsEmphasizedArticleCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsExperienceBlockCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsExperienceBlockCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsExperienceBlockCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsExperienceBlockCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsFeatureCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsFeatureCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsFeatureCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsFeatureCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsGrantActivityArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsGrantActivityArticleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsGrantActivityArticleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsGrantActivityArticleCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsGrantDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsGrantDetailsPageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsGrantDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsGrantDetailsPageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsGrantmakingAreaDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsGrantmakingAreaDetailsPageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsGrantmakingAreaDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsGrantmakingAreaDetailsPageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsHistoryPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsHistoryPageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsHistoryPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsHistoryPageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsHomePageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsHomePageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsIdeaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsIdeaCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsIdeaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsIdeaCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsInlineCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsInlineCardsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsInlineCardsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsInlineCardsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsMmufCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsMmufCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsMmufCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsMmufCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsNavigationItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsNavigationItemCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsNavigationItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsNavigationItemCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsNewsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsNewsPageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsNewsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsNewsPageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsPersonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsPersonCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsPersonCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsPersonCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsPressRoomCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsPressRoomCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsPressRoomCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsPressRoomCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsResourcesCurrentGranteesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsResourcesCurrentGranteesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleLinkingCollectionsResourcesCurrentGranteesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleLinkingCollectionsResourcesCurrentGranteesCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ArticleLinkingCollectionsArticleCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  ExternalNewsUrlAsc = 'externalNewsUrl_ASC',
  ExternalNewsUrlDesc = 'externalNewsUrl_DESC',
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  PasswordAsc = 'password_ASC',
  PasswordDesc = 'password_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum ArticleLinkingCollectionsArticleCursorCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  ExternalNewsUrlAsc = 'externalNewsUrl_ASC',
  ExternalNewsUrlDesc = 'externalNewsUrl_DESC',
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  PasswordAsc = 'password_ASC',
  PasswordDesc = 'password_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum ArticleLinkingCollectionsAtGlanceCardCollectionOrder {
  BodyTextAsc = 'bodyText_ASC',
  BodyTextDesc = 'bodyText_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum ArticleLinkingCollectionsAtGlanceCardCursorCollectionOrder {
  BodyTextAsc = 'bodyText_ASC',
  BodyTextDesc = 'bodyText_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum ArticleLinkingCollectionsCallForConceptCollectionOrder {
  CallForConceptTitleAsc = 'callForConceptTitle_ASC',
  CallForConceptTitleDesc = 'callForConceptTitle_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  RegistrationDeadlineDateAsc = 'registrationDeadlineDate_ASC',
  RegistrationDeadlineDateDesc = 'registrationDeadlineDate_DESC',
  RegistrationDeadlineTitleAsc = 'registrationDeadlineTitle_ASC',
  RegistrationDeadlineTitleDesc = 'registrationDeadlineTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum ArticleLinkingCollectionsCallForConceptCursorCollectionOrder {
  CallForConceptTitleAsc = 'callForConceptTitle_ASC',
  CallForConceptTitleDesc = 'callForConceptTitle_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  RegistrationDeadlineDateAsc = 'registrationDeadlineDate_ASC',
  RegistrationDeadlineDateDesc = 'registrationDeadlineDate_DESC',
  RegistrationDeadlineTitleAsc = 'registrationDeadlineTitle_ASC',
  RegistrationDeadlineTitleDesc = 'registrationDeadlineTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum ArticleLinkingCollectionsConnectWithLinkCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ArticleLinkingCollectionsConnectWithLinkCursorCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ArticleLinkingCollectionsEmphasizedArticleCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ArticleLinkingCollectionsEmphasizedArticleCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ArticleLinkingCollectionsExperienceBlockCollectionOrder {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ArticleLinkingCollectionsExperienceBlockCursorCollectionOrder {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ArticleLinkingCollectionsFeatureCollectionOrder {
  DateTimeAsc = 'dateTime_ASC',
  DateTimeDesc = 'dateTime_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  ShowSocialCtasAsc = 'showSocialCtas_ASC',
  ShowSocialCtasDesc = 'showSocialCtas_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TaglineAsc = 'tagline_ASC',
  TaglineDesc = 'tagline_DESC'
}

export enum ArticleLinkingCollectionsFeatureCursorCollectionOrder {
  DateTimeAsc = 'dateTime_ASC',
  DateTimeDesc = 'dateTime_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  ShowSocialCtasAsc = 'showSocialCtas_ASC',
  ShowSocialCtasDesc = 'showSocialCtas_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TaglineAsc = 'tagline_ASC',
  TaglineDesc = 'tagline_DESC'
}

export enum ArticleLinkingCollectionsGrantActivityArticleCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  GranteeCityOverrideAsc = 'granteeCityOverride_ASC',
  GranteeCityOverrideDesc = 'granteeCityOverride_DESC',
  GranteeCountryOverrideAsc = 'granteeCountryOverride_ASC',
  GranteeCountryOverrideDesc = 'granteeCountryOverride_DESC',
  GranteeNameOverrideAsc = 'granteeNameOverride_ASC',
  GranteeNameOverrideDesc = 'granteeNameOverride_DESC',
  GranteeStateOverrideAsc = 'granteeStateOverride_ASC',
  GranteeStateOverrideDesc = 'granteeStateOverride_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ArticleLinkingCollectionsGrantActivityArticleCursorCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  GranteeCityOverrideAsc = 'granteeCityOverride_ASC',
  GranteeCityOverrideDesc = 'granteeCityOverride_DESC',
  GranteeCountryOverrideAsc = 'granteeCountryOverride_ASC',
  GranteeCountryOverrideDesc = 'granteeCountryOverride_DESC',
  GranteeNameOverrideAsc = 'granteeNameOverride_ASC',
  GranteeNameOverrideDesc = 'granteeNameOverride_DESC',
  GranteeStateOverrideAsc = 'granteeStateOverride_ASC',
  GranteeStateOverrideDesc = 'granteeStateOverride_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ArticleLinkingCollectionsGrantDetailsPageCollectionOrder {
  StrategyCopyAsc = 'strategyCopy_ASC',
  StrategyCopyDesc = 'strategyCopy_DESC',
  StrategyCtaLabelAsc = 'strategyCtaLabel_ASC',
  StrategyCtaLabelDesc = 'strategyCtaLabel_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ArticleLinkingCollectionsGrantDetailsPageCursorCollectionOrder {
  StrategyCopyAsc = 'strategyCopy_ASC',
  StrategyCopyDesc = 'strategyCopy_DESC',
  StrategyCtaLabelAsc = 'strategyCtaLabel_ASC',
  StrategyCtaLabelDesc = 'strategyCtaLabel_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ArticleLinkingCollectionsGrantmakingAreaDetailsPageCollectionOrder {
  GrantMakingProcessMessageAsc = 'grantMakingProcessMessage_ASC',
  GrantMakingProcessMessageDesc = 'grantMakingProcessMessage_DESC',
  GuidingStrategiesTitleAsc = 'guidingStrategiesTitle_ASC',
  GuidingStrategiesTitleDesc = 'guidingStrategiesTitle_DESC',
  IntroDescriptionAsc = 'introDescription_ASC',
  IntroDescriptionDesc = 'introDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ArticleLinkingCollectionsGrantmakingAreaDetailsPageCursorCollectionOrder {
  GrantMakingProcessMessageAsc = 'grantMakingProcessMessage_ASC',
  GrantMakingProcessMessageDesc = 'grantMakingProcessMessage_DESC',
  GuidingStrategiesTitleAsc = 'guidingStrategiesTitle_ASC',
  GuidingStrategiesTitleDesc = 'guidingStrategiesTitle_DESC',
  IntroDescriptionAsc = 'introDescription_ASC',
  IntroDescriptionDesc = 'introDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ArticleLinkingCollectionsHistoryPageCollectionOrder {
  CurrentPresidentStartYearAsc = 'currentPresidentStartYear_ASC',
  CurrentPresidentStartYearDesc = 'currentPresidentStartYear_DESC',
  GrantMakingProcessCtaTextAsc = 'grantMakingProcessCtaText_ASC',
  GrantMakingProcessCtaTextDesc = 'grantMakingProcessCtaText_DESC',
  ImpactTitleAsc = 'impactTitle_ASC',
  ImpactTitleDesc = 'impactTitle_DESC',
  PeopleSubtitleAsc = 'peopleSubtitle_ASC',
  PeopleSubtitleDesc = 'peopleSubtitle_DESC',
  PeopleTitleAsc = 'peopleTitle_ASC',
  PeopleTitleDesc = 'peopleTitle_DESC',
  PresidentsTitleAsc = 'presidentsTitle_ASC',
  PresidentsTitleDesc = 'presidentsTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SpaceTitleAsc = 'spaceTitle_ASC',
  SpaceTitleDesc = 'spaceTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ArticleLinkingCollectionsHistoryPageCursorCollectionOrder {
  CurrentPresidentStartYearAsc = 'currentPresidentStartYear_ASC',
  CurrentPresidentStartYearDesc = 'currentPresidentStartYear_DESC',
  GrantMakingProcessCtaTextAsc = 'grantMakingProcessCtaText_ASC',
  GrantMakingProcessCtaTextDesc = 'grantMakingProcessCtaText_DESC',
  ImpactTitleAsc = 'impactTitle_ASC',
  ImpactTitleDesc = 'impactTitle_DESC',
  PeopleSubtitleAsc = 'peopleSubtitle_ASC',
  PeopleSubtitleDesc = 'peopleSubtitle_DESC',
  PeopleTitleAsc = 'peopleTitle_ASC',
  PeopleTitleDesc = 'peopleTitle_DESC',
  PresidentsTitleAsc = 'presidentsTitle_ASC',
  PresidentsTitleDesc = 'presidentsTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SpaceTitleAsc = 'spaceTitle_ASC',
  SpaceTitleDesc = 'spaceTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ArticleLinkingCollectionsHomePageCollectionOrder {
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  MissionTextAsc = 'missionText_ASC',
  MissionTextDesc = 'missionText_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StoriesCtaAsc = 'storiesCta_ASC',
  StoriesCtaDesc = 'storiesCta_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ArticleLinkingCollectionsHomePageCursorCollectionOrder {
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  MissionTextAsc = 'missionText_ASC',
  MissionTextDesc = 'missionText_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StoriesCtaAsc = 'storiesCta_ASC',
  StoriesCtaDesc = 'storiesCta_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ArticleLinkingCollectionsIdeaCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ArticleLinkingCollectionsIdeaCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ArticleLinkingCollectionsInlineCardsCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ArticleLinkingCollectionsInlineCardsCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ArticleLinkingCollectionsMmufCollectionOrder {
  ArticleTitleAsc = 'articleTitle_ASC',
  ArticleTitleDesc = 'articleTitle_DESC',
  AtGlanceTitleAsc = 'atGlanceTitle_ASC',
  AtGlanceTitleDesc = 'atGlanceTitle_DESC',
  ContactEmailAsc = 'contactEmail_ASC',
  ContactEmailDesc = 'contactEmail_DESC',
  ContactMessageAsc = 'contactMessage_ASC',
  ContactMessageDesc = 'contactMessage_DESC',
  ContactTitleAsc = 'contactTitle_ASC',
  ContactTitleDesc = 'contactTitle_DESC',
  FellowStoriesCtaLabelAsc = 'fellowStoriesCtaLabel_ASC',
  FellowStoriesCtaLabelDesc = 'fellowStoriesCtaLabel_DESC',
  FellowStoriesMessageAsc = 'fellowStoriesMessage_ASC',
  FellowStoriesMessageDesc = 'fellowStoriesMessage_DESC',
  GraduateInitiativesTitleAsc = 'graduateInitiativesTitle_ASC',
  GraduateInitiativesTitleDesc = 'graduateInitiativesTitle_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ArticleLinkingCollectionsMmufCursorCollectionOrder {
  ArticleTitleAsc = 'articleTitle_ASC',
  ArticleTitleDesc = 'articleTitle_DESC',
  AtGlanceTitleAsc = 'atGlanceTitle_ASC',
  AtGlanceTitleDesc = 'atGlanceTitle_DESC',
  ContactEmailAsc = 'contactEmail_ASC',
  ContactEmailDesc = 'contactEmail_DESC',
  ContactMessageAsc = 'contactMessage_ASC',
  ContactMessageDesc = 'contactMessage_DESC',
  ContactTitleAsc = 'contactTitle_ASC',
  ContactTitleDesc = 'contactTitle_DESC',
  FellowStoriesCtaLabelAsc = 'fellowStoriesCtaLabel_ASC',
  FellowStoriesCtaLabelDesc = 'fellowStoriesCtaLabel_DESC',
  FellowStoriesMessageAsc = 'fellowStoriesMessage_ASC',
  FellowStoriesMessageDesc = 'fellowStoriesMessage_DESC',
  GraduateInitiativesTitleAsc = 'graduateInitiativesTitle_ASC',
  GraduateInitiativesTitleDesc = 'graduateInitiativesTitle_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ArticleLinkingCollectionsNavigationItemCollectionOrder {
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ArticleLinkingCollectionsNavigationItemCursorCollectionOrder {
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ArticleLinkingCollectionsNewsPageCollectionOrder {
  PressRoomCopyAsc = 'pressRoomCopy_ASC',
  PressRoomCopyDesc = 'pressRoomCopy_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ArticleLinkingCollectionsNewsPageCursorCollectionOrder {
  PressRoomCopyAsc = 'pressRoomCopy_ASC',
  PressRoomCopyDesc = 'pressRoomCopy_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ArticleLinkingCollectionsPersonCollectionOrder {
  FirstNameAsc = 'firstName_ASC',
  FirstNameDesc = 'firstName_DESC',
  JobTitleAsc = 'jobTitle_ASC',
  JobTitleDesc = 'jobTitle_DESC',
  LastNameAsc = 'lastName_ASC',
  LastNameDesc = 'lastName_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  RelatedSectionTitleAsc = 'relatedSectionTitle_ASC',
  RelatedSectionTitleDesc = 'relatedSectionTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ArticleLinkingCollectionsPersonCursorCollectionOrder {
  FirstNameAsc = 'firstName_ASC',
  FirstNameDesc = 'firstName_DESC',
  JobTitleAsc = 'jobTitle_ASC',
  JobTitleDesc = 'jobTitle_DESC',
  LastNameAsc = 'lastName_ASC',
  LastNameDesc = 'lastName_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  RelatedSectionTitleAsc = 'relatedSectionTitle_ASC',
  RelatedSectionTitleDesc = 'relatedSectionTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ArticleLinkingCollectionsPressRoomCollectionOrder {
  ContactsTitleAsc = 'contactsTitle_ASC',
  ContactsTitleDesc = 'contactsTitle_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  EmailLabelAsc = 'emailLabel_ASC',
  EmailLabelDesc = 'emailLabel_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  GuidelinesAndMediasDescriptionAsc = 'guidelinesAndMediasDescription_ASC',
  GuidelinesAndMediasDescriptionDesc = 'guidelinesAndMediasDescription_DESC',
  GuidelinesAndMediasHeadingAsc = 'guidelinesAndMediasHeading_ASC',
  GuidelinesAndMediasHeadingDesc = 'guidelinesAndMediasHeading_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ArticleLinkingCollectionsPressRoomCursorCollectionOrder {
  ContactsTitleAsc = 'contactsTitle_ASC',
  ContactsTitleDesc = 'contactsTitle_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  EmailLabelAsc = 'emailLabel_ASC',
  EmailLabelDesc = 'emailLabel_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  GuidelinesAndMediasDescriptionAsc = 'guidelinesAndMediasDescription_ASC',
  GuidelinesAndMediasDescriptionDesc = 'guidelinesAndMediasDescription_DESC',
  GuidelinesAndMediasHeadingAsc = 'guidelinesAndMediasHeading_ASC',
  GuidelinesAndMediasHeadingDesc = 'guidelinesAndMediasHeading_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ArticleLinkingCollectionsResourcesCurrentGranteesCollectionOrder {
  GrantDatabaseCtaTextAsc = 'grantDatabaseCtaText_ASC',
  GrantDatabaseCtaTextDesc = 'grantDatabaseCtaText_DESC',
  ResourcesTitleAsc = 'resourcesTitle_ASC',
  ResourcesTitleDesc = 'resourcesTitle_DESC',
  SimilarGranteesTitleAsc = 'similarGranteesTitle_ASC',
  SimilarGranteesTitleDesc = 'similarGranteesTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ArticleLinkingCollectionsResourcesCurrentGranteesCursorCollectionOrder {
  GrantDatabaseCtaTextAsc = 'grantDatabaseCtaText_ASC',
  GrantDatabaseCtaTextDesc = 'grantDatabaseCtaText_DESC',
  ResourcesTitleAsc = 'resourcesTitle_ASC',
  ResourcesTitleDesc = 'resourcesTitle_DESC',
  SimilarGranteesTitleAsc = 'similarGranteesTitle_ASC',
  SimilarGranteesTitleDesc = 'similarGranteesTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ArticleOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  ExternalNewsUrlAsc = 'externalNewsUrl_ASC',
  ExternalNewsUrlDesc = 'externalNewsUrl_DESC',
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  PasswordAsc = 'password_ASC',
  PasswordDesc = 'password_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export type ArticleRelatedContentCollection = {
  __typename: 'ArticleRelatedContentCollection';
  items: Array<Maybe<ArticleRelatedContentItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ArticleRelatedContentCursorCollection = {
  __typename: 'ArticleRelatedContentCursorCollection';
  items: Array<Maybe<ArticleRelatedContentItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ArticleRelatedContentFilter = {
  AND: InputMaybe<Array<InputMaybe<ArticleRelatedContentFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ArticleRelatedContentFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
};

export type ArticleRelatedContentItem = Article | ExternalEvent | Feature | GrantActivityArticle | Idea;

/** Represents a binary file in a space. An asset can be any file type. */
export type Asset = _Node & {
  __typename: 'Asset';
  _id: Scalars['ID']['output'];
  contentType: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  description: Maybe<Scalars['String']['output']>;
  fileName: Maybe<Scalars['String']['output']>;
  height: Maybe<Scalars['Int']['output']>;
  linkedFrom: Maybe<AssetLinkingCollections>;
  size: Maybe<Scalars['Int']['output']>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
  width: Maybe<Scalars['Int']['output']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetContentTypeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetFileNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetHeightArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetSizeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetUrlArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  transform: InputMaybe<ImageTransformOptions>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetWidthArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssetCollection = {
  __typename: 'AssetCollection';
  items: Array<Maybe<Asset>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AssetCursorCollection = {
  __typename: 'AssetCursorCollection';
  items: Array<Maybe<Asset>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type AssetFilter = {
  AND: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  OR: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  contentType: InputMaybe<Scalars['String']['input']>;
  contentType_contains: InputMaybe<Scalars['String']['input']>;
  contentType_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentType_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentType_not: InputMaybe<Scalars['String']['input']>;
  contentType_not_contains: InputMaybe<Scalars['String']['input']>;
  contentType_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fileName: InputMaybe<Scalars['String']['input']>;
  fileName_contains: InputMaybe<Scalars['String']['input']>;
  fileName_exists: InputMaybe<Scalars['Boolean']['input']>;
  fileName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fileName_not: InputMaybe<Scalars['String']['input']>;
  fileName_not_contains: InputMaybe<Scalars['String']['input']>;
  fileName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  height: InputMaybe<Scalars['Int']['input']>;
  height_exists: InputMaybe<Scalars['Boolean']['input']>;
  height_gt: InputMaybe<Scalars['Int']['input']>;
  height_gte: InputMaybe<Scalars['Int']['input']>;
  height_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  height_lt: InputMaybe<Scalars['Int']['input']>;
  height_lte: InputMaybe<Scalars['Int']['input']>;
  height_not: InputMaybe<Scalars['Int']['input']>;
  height_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  size: InputMaybe<Scalars['Int']['input']>;
  size_exists: InputMaybe<Scalars['Boolean']['input']>;
  size_gt: InputMaybe<Scalars['Int']['input']>;
  size_gte: InputMaybe<Scalars['Int']['input']>;
  size_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  size_lt: InputMaybe<Scalars['Int']['input']>;
  size_lte: InputMaybe<Scalars['Int']['input']>;
  size_not: InputMaybe<Scalars['Int']['input']>;
  size_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url: InputMaybe<Scalars['String']['input']>;
  url_contains: InputMaybe<Scalars['String']['input']>;
  url_exists: InputMaybe<Scalars['Boolean']['input']>;
  url_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not: InputMaybe<Scalars['String']['input']>;
  url_not_contains: InputMaybe<Scalars['String']['input']>;
  url_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  width: InputMaybe<Scalars['Int']['input']>;
  width_exists: InputMaybe<Scalars['Boolean']['input']>;
  width_gt: InputMaybe<Scalars['Int']['input']>;
  width_gte: InputMaybe<Scalars['Int']['input']>;
  width_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  width_lt: InputMaybe<Scalars['Int']['input']>;
  width_lte: InputMaybe<Scalars['Int']['input']>;
  width_not: InputMaybe<Scalars['Int']['input']>;
  width_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type AssetLinkingCollections = {
  __typename: 'AssetLinkingCollections';
  annualReportCollection: Maybe<AnnualReportCollection>;
  annualReportCursorCollection: Maybe<AnnualReportCursorCollection>;
  articleCollection: Maybe<ArticleCollection>;
  articleCursorCollection: Maybe<ArticleCursorCollection>;
  connectWithLinkCollection: Maybe<ConnectWithLinkCollection>;
  connectWithLinkCursorCollection: Maybe<ConnectWithLinkCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  eventsPageCollection: Maybe<EventsPageCollection>;
  eventsPageCursorCollection: Maybe<EventsPageCursorCollection>;
  experienceBlockCollection: Maybe<ExperienceBlockCollection>;
  experienceBlockCursorCollection: Maybe<ExperienceBlockCursorCollection>;
  externalEventCollection: Maybe<ExternalEventCollection>;
  externalEventCursorCollection: Maybe<ExternalEventCursorCollection>;
  externalPersonCollection: Maybe<ExternalPersonCollection>;
  externalPersonCursorCollection: Maybe<ExternalPersonCursorCollection>;
  featureCollection: Maybe<FeatureCollection>;
  featureCursorCollection: Maybe<FeatureCursorCollection>;
  financialsPageCollection: Maybe<FinancialsPageCollection>;
  financialsPageCursorCollection: Maybe<FinancialsPageCursorCollection>;
  grantActivityArticleCollection: Maybe<GrantActivityArticleCollection>;
  grantActivityArticleCursorCollection: Maybe<GrantActivityArticleCursorCollection>;
  grantmakingAreaCollection: Maybe<GrantmakingAreaCollection>;
  grantmakingAreaCursorCollection: Maybe<GrantmakingAreaCursorCollection>;
  grantmakingAreaDetailsPageCollection: Maybe<GrantmakingAreaDetailsPageCollection>;
  grantmakingAreaDetailsPageCursorCollection: Maybe<GrantmakingAreaDetailsPageCursorCollection>;
  grantmakingAreasPageCollection: Maybe<GrantmakingAreasPageCollection>;
  grantmakingAreasPageCursorCollection: Maybe<GrantmakingAreasPageCursorCollection>;
  heroAssetCollection: Maybe<HeroAssetCollection>;
  heroAssetCursorCollection: Maybe<HeroAssetCursorCollection>;
  historyPageCollection: Maybe<HistoryPageCollection>;
  historyPageCursorCollection: Maybe<HistoryPageCursorCollection>;
  historyPersonCollection: Maybe<HistoryPersonCollection>;
  historyPersonCursorCollection: Maybe<HistoryPersonCursorCollection>;
  homePageCollection: Maybe<HomePageCollection>;
  homePageCursorCollection: Maybe<HomePageCursorCollection>;
  ideaCollection: Maybe<IdeaCollection>;
  ideaCursorCollection: Maybe<IdeaCursorCollection>;
  inlineImagesCollection: Maybe<InlineImagesCollection>;
  inlineImagesCursorCollection: Maybe<InlineImagesCursorCollection>;
  metadataCollection: Maybe<MetadataCollection>;
  metadataCursorCollection: Maybe<MetadataCursorCollection>;
  missionPageCollection: Maybe<MissionPageCollection>;
  missionPageCursorCollection: Maybe<MissionPageCursorCollection>;
  mmufCollection: Maybe<MmufCollection>;
  mmufCursorCollection: Maybe<MmufCursorCollection>;
  navigationItemCollection: Maybe<NavigationItemCollection>;
  navigationItemCursorCollection: Maybe<NavigationItemCursorCollection>;
  newsPageCollection: Maybe<NewsPageCollection>;
  newsPageCursorCollection: Maybe<NewsPageCursorCollection>;
  newsletterPageCollection: Maybe<NewsletterPageCollection>;
  newsletterPageCursorCollection: Maybe<NewsletterPageCursorCollection>;
  oldAnnualReportCollection: Maybe<OldAnnualReportCollection>;
  oldAnnualReportCursorCollection: Maybe<OldAnnualReportCursorCollection>;
  parallaxImagesCollection: Maybe<ParallaxImagesCollection>;
  parallaxImagesCursorCollection: Maybe<ParallaxImagesCursorCollection>;
  peoplePageCollection: Maybe<PeoplePageCollection>;
  peoplePageCursorCollection: Maybe<PeoplePageCursorCollection>;
  personCollection: Maybe<PersonCollection>;
  personCursorCollection: Maybe<PersonCursorCollection>;
  pressRoomCollection: Maybe<PressRoomCollection>;
  pressRoomCursorCollection: Maybe<PressRoomCursorCollection>;
  quoteCollection: Maybe<QuoteCollection>;
  quoteCursorCollection: Maybe<QuoteCursorCollection>;
  spotlightSlideshowCollection: Maybe<SpotlightSlideshowCollection>;
  spotlightSlideshowCursorCollection: Maybe<SpotlightSlideshowCursorCollection>;
  spotlightVideoCollection: Maybe<SpotlightVideoCollection>;
  spotlightVideoCursorCollection: Maybe<SpotlightVideoCursorCollection>;
  trusteeCollection: Maybe<TrusteeCollection>;
  trusteeCursorCollection: Maybe<TrusteeCursorCollection>;
  videoNativeCollection: Maybe<VideoNativeCollection>;
  videoNativeCursorCollection: Maybe<VideoNativeCursorCollection>;
  videoYoutubeCollection: Maybe<VideoYoutubeCollection>;
  videoYoutubeCursorCollection: Maybe<VideoYoutubeCursorCollection>;
};


export type AssetLinkingCollectionsAnnualReportCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsAnnualReportCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsArticleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsConnectWithLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsConnectWithLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsEventsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsEventsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsExperienceBlockCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsExperienceBlockCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsExternalEventCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsExternalEventCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsExternalPersonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsExternalPersonCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsFeatureCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsFeatureCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsFinancialsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsFinancialsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsGrantActivityArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsGrantActivityArticleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsGrantmakingAreaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsGrantmakingAreaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsGrantmakingAreaDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsGrantmakingAreaDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsGrantmakingAreasPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsGrantmakingAreasPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsHeroAssetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsHeroAssetCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsHistoryPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsHistoryPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsHistoryPersonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsHistoryPersonCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsIdeaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsIdeaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsInlineImagesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsInlineImagesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsMetadataCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsMetadataCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsMissionPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsMissionPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsMmufCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsMmufCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsNavigationItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsNavigationItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsNewsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsNewsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsNewsletterPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsNewsletterPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsOldAnnualReportCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsOldAnnualReportCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsParallaxImagesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsParallaxImagesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsPeoplePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsPeoplePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsPersonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsPersonCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsPressRoomCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsPressRoomCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsQuoteCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsQuoteCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsSpotlightSlideshowCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsSpotlightSlideshowCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsSpotlightVideoCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsSpotlightVideoCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsTrusteeCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsTrusteeCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsVideoNativeCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsVideoNativeCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsVideoYoutubeCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsVideoYoutubeCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AssetOrder {
  ContentTypeAsc = 'contentType_ASC',
  ContentTypeDesc = 'contentType_DESC',
  FileNameAsc = 'fileName_ASC',
  FileNameDesc = 'fileName_DESC',
  HeightAsc = 'height_ASC',
  HeightDesc = 'height_DESC',
  SizeAsc = 'size_ASC',
  SizeDesc = 'size_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC',
  WidthAsc = 'width_ASC',
  WidthDesc = 'width_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/atGlanceCard) */
export type AtGlanceCard = Entry & _Node & {
  __typename: 'AtGlanceCard';
  _id: Scalars['ID']['output'];
  bodyText: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  ctaText: Maybe<Scalars['String']['output']>;
  heading: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<AtGlanceCardLinkingCollections>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  typeReference: Maybe<Article>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/atGlanceCard) */
export type AtGlanceCardBodyTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/atGlanceCard) */
export type AtGlanceCardCtaTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/atGlanceCard) */
export type AtGlanceCardHeadingArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/atGlanceCard) */
export type AtGlanceCardLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/atGlanceCard) */
export type AtGlanceCardTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/atGlanceCard) */
export type AtGlanceCardTypeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/atGlanceCard) */
export type AtGlanceCardTypeReferenceArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ArticleFilter>;
};

export type AtGlanceCardCollection = {
  __typename: 'AtGlanceCardCollection';
  items: Array<Maybe<AtGlanceCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AtGlanceCardCursorCollection = {
  __typename: 'AtGlanceCardCursorCollection';
  items: Array<Maybe<AtGlanceCard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type AtGlanceCardFilter = {
  AND: InputMaybe<Array<InputMaybe<AtGlanceCardFilter>>>;
  OR: InputMaybe<Array<InputMaybe<AtGlanceCardFilter>>>;
  bodyText: InputMaybe<Scalars['String']['input']>;
  bodyText_contains: InputMaybe<Scalars['String']['input']>;
  bodyText_exists: InputMaybe<Scalars['Boolean']['input']>;
  bodyText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyText_not: InputMaybe<Scalars['String']['input']>;
  bodyText_not_contains: InputMaybe<Scalars['String']['input']>;
  bodyText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  ctaText: InputMaybe<Scalars['String']['input']>;
  ctaText_contains: InputMaybe<Scalars['String']['input']>;
  ctaText_exists: InputMaybe<Scalars['Boolean']['input']>;
  ctaText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaText_not: InputMaybe<Scalars['String']['input']>;
  ctaText_not_contains: InputMaybe<Scalars['String']['input']>;
  ctaText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading: InputMaybe<Scalars['String']['input']>;
  heading_contains: InputMaybe<Scalars['String']['input']>;
  heading_exists: InputMaybe<Scalars['Boolean']['input']>;
  heading_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading_not: InputMaybe<Scalars['String']['input']>;
  heading_not_contains: InputMaybe<Scalars['String']['input']>;
  heading_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type: InputMaybe<Scalars['String']['input']>;
  typeReference: InputMaybe<CfArticleNestedFilter>;
  typeReference_exists: InputMaybe<Scalars['Boolean']['input']>;
  type_contains: InputMaybe<Scalars['String']['input']>;
  type_exists: InputMaybe<Scalars['Boolean']['input']>;
  type_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not: InputMaybe<Scalars['String']['input']>;
  type_not_contains: InputMaybe<Scalars['String']['input']>;
  type_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AtGlanceCardLinkingCollections = {
  __typename: 'AtGlanceCardLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  grantResourcesCollection: Maybe<GrantResourcesCollection>;
  grantResourcesCursorCollection: Maybe<GrantResourcesCursorCollection>;
  missionPageCollection: Maybe<MissionPageCollection>;
  missionPageCursorCollection: Maybe<MissionPageCursorCollection>;
  mmufCollection: Maybe<MmufCollection>;
  mmufCursorCollection: Maybe<MmufCursorCollection>;
  pressRoomCollection: Maybe<PressRoomCollection>;
  pressRoomCursorCollection: Maybe<PressRoomCursorCollection>;
  resourcesProspectiveGranteesCollection: Maybe<ResourcesProspectiveGranteesCollection>;
  resourcesProspectiveGranteesCursorCollection: Maybe<ResourcesProspectiveGranteesCursorCollection>;
};


export type AtGlanceCardLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AtGlanceCardLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AtGlanceCardLinkingCollectionsGrantResourcesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<AtGlanceCardLinkingCollectionsGrantResourcesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AtGlanceCardLinkingCollectionsGrantResourcesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<AtGlanceCardLinkingCollectionsGrantResourcesCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AtGlanceCardLinkingCollectionsMissionPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<AtGlanceCardLinkingCollectionsMissionPageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AtGlanceCardLinkingCollectionsMissionPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<AtGlanceCardLinkingCollectionsMissionPageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AtGlanceCardLinkingCollectionsMmufCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<AtGlanceCardLinkingCollectionsMmufCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AtGlanceCardLinkingCollectionsMmufCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<AtGlanceCardLinkingCollectionsMmufCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AtGlanceCardLinkingCollectionsPressRoomCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<AtGlanceCardLinkingCollectionsPressRoomCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AtGlanceCardLinkingCollectionsPressRoomCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<AtGlanceCardLinkingCollectionsPressRoomCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AtGlanceCardLinkingCollectionsResourcesProspectiveGranteesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<AtGlanceCardLinkingCollectionsResourcesProspectiveGranteesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AtGlanceCardLinkingCollectionsResourcesProspectiveGranteesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<AtGlanceCardLinkingCollectionsResourcesProspectiveGranteesCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AtGlanceCardLinkingCollectionsGrantResourcesCollectionOrder {
  ExplanatoryTitleAsc = 'explanatoryTitle_ASC',
  ExplanatoryTitleDesc = 'explanatoryTitle_DESC',
  GrantMakingAreasTitleAsc = 'grantMakingAreasTitle_ASC',
  GrantMakingAreasTitleDesc = 'grantMakingAreasTitle_DESC',
  SearchContextualMessageAsc = 'searchContextualMessage_ASC',
  SearchContextualMessageDesc = 'searchContextualMessage_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum AtGlanceCardLinkingCollectionsGrantResourcesCursorCollectionOrder {
  ExplanatoryTitleAsc = 'explanatoryTitle_ASC',
  ExplanatoryTitleDesc = 'explanatoryTitle_DESC',
  GrantMakingAreasTitleAsc = 'grantMakingAreasTitle_ASC',
  GrantMakingAreasTitleDesc = 'grantMakingAreasTitle_DESC',
  SearchContextualMessageAsc = 'searchContextualMessage_ASC',
  SearchContextualMessageDesc = 'searchContextualMessage_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum AtGlanceCardLinkingCollectionsMissionPageCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum AtGlanceCardLinkingCollectionsMissionPageCursorCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum AtGlanceCardLinkingCollectionsMmufCollectionOrder {
  ArticleTitleAsc = 'articleTitle_ASC',
  ArticleTitleDesc = 'articleTitle_DESC',
  AtGlanceTitleAsc = 'atGlanceTitle_ASC',
  AtGlanceTitleDesc = 'atGlanceTitle_DESC',
  ContactEmailAsc = 'contactEmail_ASC',
  ContactEmailDesc = 'contactEmail_DESC',
  ContactMessageAsc = 'contactMessage_ASC',
  ContactMessageDesc = 'contactMessage_DESC',
  ContactTitleAsc = 'contactTitle_ASC',
  ContactTitleDesc = 'contactTitle_DESC',
  FellowStoriesCtaLabelAsc = 'fellowStoriesCtaLabel_ASC',
  FellowStoriesCtaLabelDesc = 'fellowStoriesCtaLabel_DESC',
  FellowStoriesMessageAsc = 'fellowStoriesMessage_ASC',
  FellowStoriesMessageDesc = 'fellowStoriesMessage_DESC',
  GraduateInitiativesTitleAsc = 'graduateInitiativesTitle_ASC',
  GraduateInitiativesTitleDesc = 'graduateInitiativesTitle_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum AtGlanceCardLinkingCollectionsMmufCursorCollectionOrder {
  ArticleTitleAsc = 'articleTitle_ASC',
  ArticleTitleDesc = 'articleTitle_DESC',
  AtGlanceTitleAsc = 'atGlanceTitle_ASC',
  AtGlanceTitleDesc = 'atGlanceTitle_DESC',
  ContactEmailAsc = 'contactEmail_ASC',
  ContactEmailDesc = 'contactEmail_DESC',
  ContactMessageAsc = 'contactMessage_ASC',
  ContactMessageDesc = 'contactMessage_DESC',
  ContactTitleAsc = 'contactTitle_ASC',
  ContactTitleDesc = 'contactTitle_DESC',
  FellowStoriesCtaLabelAsc = 'fellowStoriesCtaLabel_ASC',
  FellowStoriesCtaLabelDesc = 'fellowStoriesCtaLabel_DESC',
  FellowStoriesMessageAsc = 'fellowStoriesMessage_ASC',
  FellowStoriesMessageDesc = 'fellowStoriesMessage_DESC',
  GraduateInitiativesTitleAsc = 'graduateInitiativesTitle_ASC',
  GraduateInitiativesTitleDesc = 'graduateInitiativesTitle_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum AtGlanceCardLinkingCollectionsPressRoomCollectionOrder {
  ContactsTitleAsc = 'contactsTitle_ASC',
  ContactsTitleDesc = 'contactsTitle_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  EmailLabelAsc = 'emailLabel_ASC',
  EmailLabelDesc = 'emailLabel_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  GuidelinesAndMediasDescriptionAsc = 'guidelinesAndMediasDescription_ASC',
  GuidelinesAndMediasDescriptionDesc = 'guidelinesAndMediasDescription_DESC',
  GuidelinesAndMediasHeadingAsc = 'guidelinesAndMediasHeading_ASC',
  GuidelinesAndMediasHeadingDesc = 'guidelinesAndMediasHeading_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum AtGlanceCardLinkingCollectionsPressRoomCursorCollectionOrder {
  ContactsTitleAsc = 'contactsTitle_ASC',
  ContactsTitleDesc = 'contactsTitle_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  EmailLabelAsc = 'emailLabel_ASC',
  EmailLabelDesc = 'emailLabel_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  GuidelinesAndMediasDescriptionAsc = 'guidelinesAndMediasDescription_ASC',
  GuidelinesAndMediasDescriptionDesc = 'guidelinesAndMediasDescription_DESC',
  GuidelinesAndMediasHeadingAsc = 'guidelinesAndMediasHeading_ASC',
  GuidelinesAndMediasHeadingDesc = 'guidelinesAndMediasHeading_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum AtGlanceCardLinkingCollectionsResourcesProspectiveGranteesCollectionOrder {
  CallsForConceptsTitleAsc = 'callsForConceptsTitle_ASC',
  CallsForConceptsTitleDesc = 'callsForConceptsTitle_DESC',
  GrantDatabaseCtaTextAsc = 'grantDatabaseCtaText_ASC',
  GrantDatabaseCtaTextDesc = 'grantDatabaseCtaText_DESC',
  GrantmakingAtGlanceTitleAsc = 'grantmakingAtGlanceTitle_ASC',
  GrantmakingAtGlanceTitleDesc = 'grantmakingAtGlanceTitle_DESC',
  NewsletterCtaTextAsc = 'newsletterCtaText_ASC',
  NewsletterCtaTextDesc = 'newsletterCtaText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum AtGlanceCardLinkingCollectionsResourcesProspectiveGranteesCursorCollectionOrder {
  CallsForConceptsTitleAsc = 'callsForConceptsTitle_ASC',
  CallsForConceptsTitleDesc = 'callsForConceptsTitle_DESC',
  GrantDatabaseCtaTextAsc = 'grantDatabaseCtaText_ASC',
  GrantDatabaseCtaTextDesc = 'grantDatabaseCtaText_DESC',
  GrantmakingAtGlanceTitleAsc = 'grantmakingAtGlanceTitle_ASC',
  GrantmakingAtGlanceTitleDesc = 'grantmakingAtGlanceTitle_DESC',
  NewsletterCtaTextAsc = 'newsletterCtaText_ASC',
  NewsletterCtaTextDesc = 'newsletterCtaText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum AtGlanceCardOrder {
  BodyTextAsc = 'bodyText_ASC',
  BodyTextDesc = 'bodyText_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/callForConcept) */
export type CallForConcept = Entry & _Node & {
  __typename: 'CallForConcept';
  _id: Scalars['ID']['output'];
  article: Maybe<Article>;
  callForConceptTitle: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  ctaText: Maybe<Scalars['String']['output']>;
  descriptionItems: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  grantMakingArea: Maybe<GrantmakingArea>;
  linkedFrom: Maybe<CallForConceptLinkingCollections>;
  registrationDeadlineDate: Maybe<Scalars['DateTime']['output']>;
  registrationDeadlineTitle: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/callForConcept) */
export type CallForConceptArticleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ArticleFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/callForConcept) */
export type CallForConceptCallForConceptTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/callForConcept) */
export type CallForConceptCtaTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/callForConcept) */
export type CallForConceptDescriptionItemsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/callForConcept) */
export type CallForConceptGrantMakingAreaArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantmakingAreaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/callForConcept) */
export type CallForConceptLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/callForConcept) */
export type CallForConceptRegistrationDeadlineDateArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/callForConcept) */
export type CallForConceptRegistrationDeadlineTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/callForConcept) */
export type CallForConceptTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/callForConcept) */
export type CallForConceptTypeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type CallForConceptCollection = {
  __typename: 'CallForConceptCollection';
  items: Array<Maybe<CallForConcept>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CallForConceptCursorCollection = {
  __typename: 'CallForConceptCursorCollection';
  items: Array<Maybe<CallForConcept>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type CallForConceptFilter = {
  AND: InputMaybe<Array<InputMaybe<CallForConceptFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CallForConceptFilter>>>;
  article: InputMaybe<CfArticleNestedFilter>;
  article_exists: InputMaybe<Scalars['Boolean']['input']>;
  callForConceptTitle: InputMaybe<Scalars['String']['input']>;
  callForConceptTitle_contains: InputMaybe<Scalars['String']['input']>;
  callForConceptTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  callForConceptTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callForConceptTitle_not: InputMaybe<Scalars['String']['input']>;
  callForConceptTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  callForConceptTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  ctaText: InputMaybe<Scalars['String']['input']>;
  ctaText_contains: InputMaybe<Scalars['String']['input']>;
  ctaText_exists: InputMaybe<Scalars['Boolean']['input']>;
  ctaText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaText_not: InputMaybe<Scalars['String']['input']>;
  ctaText_not_contains: InputMaybe<Scalars['String']['input']>;
  ctaText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descriptionItems_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descriptionItems_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descriptionItems_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descriptionItems_exists: InputMaybe<Scalars['Boolean']['input']>;
  grantMakingArea: InputMaybe<CfGrantmakingAreaNestedFilter>;
  grantMakingArea_exists: InputMaybe<Scalars['Boolean']['input']>;
  registrationDeadlineDate: InputMaybe<Scalars['DateTime']['input']>;
  registrationDeadlineDate_exists: InputMaybe<Scalars['Boolean']['input']>;
  registrationDeadlineDate_gt: InputMaybe<Scalars['DateTime']['input']>;
  registrationDeadlineDate_gte: InputMaybe<Scalars['DateTime']['input']>;
  registrationDeadlineDate_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  registrationDeadlineDate_lt: InputMaybe<Scalars['DateTime']['input']>;
  registrationDeadlineDate_lte: InputMaybe<Scalars['DateTime']['input']>;
  registrationDeadlineDate_not: InputMaybe<Scalars['DateTime']['input']>;
  registrationDeadlineDate_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  registrationDeadlineTitle: InputMaybe<Scalars['String']['input']>;
  registrationDeadlineTitle_contains: InputMaybe<Scalars['String']['input']>;
  registrationDeadlineTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  registrationDeadlineTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  registrationDeadlineTitle_not: InputMaybe<Scalars['String']['input']>;
  registrationDeadlineTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  registrationDeadlineTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type: InputMaybe<Scalars['String']['input']>;
  type_contains: InputMaybe<Scalars['String']['input']>;
  type_exists: InputMaybe<Scalars['Boolean']['input']>;
  type_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not: InputMaybe<Scalars['String']['input']>;
  type_not_contains: InputMaybe<Scalars['String']['input']>;
  type_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CallForConceptLinkingCollections = {
  __typename: 'CallForConceptLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  grantResourcesCollection: Maybe<GrantResourcesCollection>;
  grantResourcesCursorCollection: Maybe<GrantResourcesCursorCollection>;
  grantmakingAreaDetailsPageCollection: Maybe<GrantmakingAreaDetailsPageCollection>;
  grantmakingAreaDetailsPageCursorCollection: Maybe<GrantmakingAreaDetailsPageCursorCollection>;
  ideaCollection: Maybe<IdeaCollection>;
  ideaCursorCollection: Maybe<IdeaCursorCollection>;
  resourcesProspectiveGranteesCollection: Maybe<ResourcesProspectiveGranteesCollection>;
  resourcesProspectiveGranteesCursorCollection: Maybe<ResourcesProspectiveGranteesCursorCollection>;
};


export type CallForConceptLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type CallForConceptLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type CallForConceptLinkingCollectionsGrantResourcesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CallForConceptLinkingCollectionsGrantResourcesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type CallForConceptLinkingCollectionsGrantResourcesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CallForConceptLinkingCollectionsGrantResourcesCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type CallForConceptLinkingCollectionsGrantmakingAreaDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CallForConceptLinkingCollectionsGrantmakingAreaDetailsPageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type CallForConceptLinkingCollectionsGrantmakingAreaDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CallForConceptLinkingCollectionsGrantmakingAreaDetailsPageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type CallForConceptLinkingCollectionsIdeaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CallForConceptLinkingCollectionsIdeaCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type CallForConceptLinkingCollectionsIdeaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CallForConceptLinkingCollectionsIdeaCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type CallForConceptLinkingCollectionsResourcesProspectiveGranteesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CallForConceptLinkingCollectionsResourcesProspectiveGranteesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type CallForConceptLinkingCollectionsResourcesProspectiveGranteesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CallForConceptLinkingCollectionsResourcesProspectiveGranteesCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CallForConceptLinkingCollectionsGrantResourcesCollectionOrder {
  ExplanatoryTitleAsc = 'explanatoryTitle_ASC',
  ExplanatoryTitleDesc = 'explanatoryTitle_DESC',
  GrantMakingAreasTitleAsc = 'grantMakingAreasTitle_ASC',
  GrantMakingAreasTitleDesc = 'grantMakingAreasTitle_DESC',
  SearchContextualMessageAsc = 'searchContextualMessage_ASC',
  SearchContextualMessageDesc = 'searchContextualMessage_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CallForConceptLinkingCollectionsGrantResourcesCursorCollectionOrder {
  ExplanatoryTitleAsc = 'explanatoryTitle_ASC',
  ExplanatoryTitleDesc = 'explanatoryTitle_DESC',
  GrantMakingAreasTitleAsc = 'grantMakingAreasTitle_ASC',
  GrantMakingAreasTitleDesc = 'grantMakingAreasTitle_DESC',
  SearchContextualMessageAsc = 'searchContextualMessage_ASC',
  SearchContextualMessageDesc = 'searchContextualMessage_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CallForConceptLinkingCollectionsGrantmakingAreaDetailsPageCollectionOrder {
  GrantMakingProcessMessageAsc = 'grantMakingProcessMessage_ASC',
  GrantMakingProcessMessageDesc = 'grantMakingProcessMessage_DESC',
  GuidingStrategiesTitleAsc = 'guidingStrategiesTitle_ASC',
  GuidingStrategiesTitleDesc = 'guidingStrategiesTitle_DESC',
  IntroDescriptionAsc = 'introDescription_ASC',
  IntroDescriptionDesc = 'introDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CallForConceptLinkingCollectionsGrantmakingAreaDetailsPageCursorCollectionOrder {
  GrantMakingProcessMessageAsc = 'grantMakingProcessMessage_ASC',
  GrantMakingProcessMessageDesc = 'grantMakingProcessMessage_DESC',
  GuidingStrategiesTitleAsc = 'guidingStrategiesTitle_ASC',
  GuidingStrategiesTitleDesc = 'guidingStrategiesTitle_DESC',
  IntroDescriptionAsc = 'introDescription_ASC',
  IntroDescriptionDesc = 'introDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CallForConceptLinkingCollectionsIdeaCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CallForConceptLinkingCollectionsIdeaCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CallForConceptLinkingCollectionsResourcesProspectiveGranteesCollectionOrder {
  CallsForConceptsTitleAsc = 'callsForConceptsTitle_ASC',
  CallsForConceptsTitleDesc = 'callsForConceptsTitle_DESC',
  GrantDatabaseCtaTextAsc = 'grantDatabaseCtaText_ASC',
  GrantDatabaseCtaTextDesc = 'grantDatabaseCtaText_DESC',
  GrantmakingAtGlanceTitleAsc = 'grantmakingAtGlanceTitle_ASC',
  GrantmakingAtGlanceTitleDesc = 'grantmakingAtGlanceTitle_DESC',
  NewsletterCtaTextAsc = 'newsletterCtaText_ASC',
  NewsletterCtaTextDesc = 'newsletterCtaText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CallForConceptLinkingCollectionsResourcesProspectiveGranteesCursorCollectionOrder {
  CallsForConceptsTitleAsc = 'callsForConceptsTitle_ASC',
  CallsForConceptsTitleDesc = 'callsForConceptsTitle_DESC',
  GrantDatabaseCtaTextAsc = 'grantDatabaseCtaText_ASC',
  GrantDatabaseCtaTextDesc = 'grantDatabaseCtaText_DESC',
  GrantmakingAtGlanceTitleAsc = 'grantmakingAtGlanceTitle_ASC',
  GrantmakingAtGlanceTitleDesc = 'grantmakingAtGlanceTitle_DESC',
  NewsletterCtaTextAsc = 'newsletterCtaText_ASC',
  NewsletterCtaTextDesc = 'newsletterCtaText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CallForConceptOrder {
  CallForConceptTitleAsc = 'callForConceptTitle_ASC',
  CallForConceptTitleDesc = 'callForConceptTitle_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  RegistrationDeadlineDateAsc = 'registrationDeadlineDate_ASC',
  RegistrationDeadlineDateDesc = 'registrationDeadlineDate_DESC',
  RegistrationDeadlineTitleAsc = 'registrationDeadlineTitle_ASC',
  RegistrationDeadlineTitleDesc = 'registrationDeadlineTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/connectWith) */
export type ConnectWith = Entry & _Node & {
  __typename: 'ConnectWith';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  eyebrow: Maybe<Scalars['String']['output']>;
  heading: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<ConnectWithLinkingCollections>;
  linksCollection: Maybe<ConnectWithLinksCollection>;
  linksCursorCollection: Maybe<ConnectWithLinksCursorCollection>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/connectWith) */
export type ConnectWithEyebrowArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/connectWith) */
export type ConnectWithHeadingArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/connectWith) */
export type ConnectWithLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/connectWith) */
export type ConnectWithLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinksCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ConnectWithLinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/connectWith) */
export type ConnectWithLinksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinksCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ConnectWithLinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/connectWith) */
export type ConnectWithTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectWithCollection = {
  __typename: 'ConnectWithCollection';
  items: Array<Maybe<ConnectWith>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ConnectWithCursorCollection = {
  __typename: 'ConnectWithCursorCollection';
  items: Array<Maybe<ConnectWith>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ConnectWithFilter = {
  AND: InputMaybe<Array<InputMaybe<ConnectWithFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ConnectWithFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  eyebrow: InputMaybe<Scalars['String']['input']>;
  eyebrow_contains: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading: InputMaybe<Scalars['String']['input']>;
  heading_contains: InputMaybe<Scalars['String']['input']>;
  heading_exists: InputMaybe<Scalars['Boolean']['input']>;
  heading_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading_not: InputMaybe<Scalars['String']['input']>;
  heading_not_contains: InputMaybe<Scalars['String']['input']>;
  heading_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  links: InputMaybe<CfConnectWithLinkNestedFilter>;
  linksCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/connectWithLink) */
export type ConnectWithLink = Entry & _Node & {
  __typename: 'ConnectWithLink';
  _id: Scalars['ID']['output'];
  asset: Maybe<Asset>;
  contentfulMetadata: ContentfulMetadata;
  externalLink: Maybe<Scalars['String']['output']>;
  internalLink: Maybe<ConnectWithLinkInternalLink>;
  label: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<ConnectWithLinkLinkingCollections>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/connectWithLink) */
export type ConnectWithLinkAssetArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/connectWithLink) */
export type ConnectWithLinkExternalLinkArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/connectWithLink) */
export type ConnectWithLinkInternalLinkArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/connectWithLink) */
export type ConnectWithLinkLabelArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/connectWithLink) */
export type ConnectWithLinkLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/connectWithLink) */
export type ConnectWithLinkTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectWithLinkCollection = {
  __typename: 'ConnectWithLinkCollection';
  items: Array<Maybe<ConnectWithLink>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ConnectWithLinkCursorCollection = {
  __typename: 'ConnectWithLinkCursorCollection';
  items: Array<Maybe<ConnectWithLink>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ConnectWithLinkFilter = {
  AND: InputMaybe<Array<InputMaybe<ConnectWithLinkFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ConnectWithLinkFilter>>>;
  asset_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  externalLink: InputMaybe<Scalars['String']['input']>;
  externalLink_contains: InputMaybe<Scalars['String']['input']>;
  externalLink_exists: InputMaybe<Scalars['Boolean']['input']>;
  externalLink_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalLink_not: InputMaybe<Scalars['String']['input']>;
  externalLink_not_contains: InputMaybe<Scalars['String']['input']>;
  externalLink_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalLink_exists: InputMaybe<Scalars['Boolean']['input']>;
  label: InputMaybe<Scalars['String']['input']>;
  label_contains: InputMaybe<Scalars['String']['input']>;
  label_exists: InputMaybe<Scalars['Boolean']['input']>;
  label_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not: InputMaybe<Scalars['String']['input']>;
  label_not_contains: InputMaybe<Scalars['String']['input']>;
  label_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ConnectWithLinkInternalLink = AnnualReport | Article | Contact | Department | EventsPage | Feature | FinancialsPage | GrantActivityArticle | GrantResources | GrantSearchFilters | GrantmakingArea | GrantmakingAreaDetailsPage | GrantmakingAreasPage | HistoryPage | Idea | MissionPage | Mmuf | NewsPage | PeoplePage | Person | PressRoom | PrivacyPolicy | TermsOfUse;

export type ConnectWithLinkLinkingCollections = {
  __typename: 'ConnectWithLinkLinkingCollections';
  connectWithCollection: Maybe<ConnectWithCollection>;
  connectWithCursorCollection: Maybe<ConnectWithCursorCollection>;
  contactCollection: Maybe<ContactCollection>;
  contactCursorCollection: Maybe<ContactCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  financialsPageCollection: Maybe<FinancialsPageCollection>;
  financialsPageCursorCollection: Maybe<FinancialsPageCursorCollection>;
  footerCollection: Maybe<FooterCollection>;
  footerCursorCollection: Maybe<FooterCursorCollection>;
  grantActivityArticleCollection: Maybe<GrantActivityArticleCollection>;
  grantActivityArticleCursorCollection: Maybe<GrantActivityArticleCursorCollection>;
  mmufCollection: Maybe<MmufCollection>;
  mmufCursorCollection: Maybe<MmufCursorCollection>;
  passwordProtectedPageCollection: Maybe<PasswordProtectedPageCollection>;
  passwordProtectedPageCursorCollection: Maybe<PasswordProtectedPageCursorCollection>;
  personCollection: Maybe<PersonCollection>;
  personCursorCollection: Maybe<PersonCursorCollection>;
  pressRoomCollection: Maybe<PressRoomCollection>;
  pressRoomCursorCollection: Maybe<PressRoomCursorCollection>;
};


export type ConnectWithLinkLinkingCollectionsConnectWithCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkLinkingCollectionsConnectWithCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkLinkingCollectionsConnectWithCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkLinkingCollectionsConnectWithCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkLinkingCollectionsContactCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkLinkingCollectionsContactCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkLinkingCollectionsContactCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkLinkingCollectionsContactCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkLinkingCollectionsFinancialsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkLinkingCollectionsFinancialsPageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkLinkingCollectionsFinancialsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkLinkingCollectionsFinancialsPageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkLinkingCollectionsFooterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkLinkingCollectionsFooterCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkLinkingCollectionsFooterCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkLinkingCollectionsFooterCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkLinkingCollectionsGrantActivityArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkLinkingCollectionsGrantActivityArticleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkLinkingCollectionsGrantActivityArticleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkLinkingCollectionsGrantActivityArticleCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkLinkingCollectionsMmufCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkLinkingCollectionsMmufCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkLinkingCollectionsMmufCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkLinkingCollectionsMmufCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkLinkingCollectionsPasswordProtectedPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkLinkingCollectionsPasswordProtectedPageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkLinkingCollectionsPasswordProtectedPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkLinkingCollectionsPasswordProtectedPageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkLinkingCollectionsPersonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkLinkingCollectionsPersonCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkLinkingCollectionsPersonCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkLinkingCollectionsPersonCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkLinkingCollectionsPressRoomCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkLinkingCollectionsPressRoomCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkLinkingCollectionsPressRoomCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkLinkingCollectionsPressRoomCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ConnectWithLinkLinkingCollectionsConnectWithCollectionOrder {
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ConnectWithLinkLinkingCollectionsConnectWithCursorCollectionOrder {
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ConnectWithLinkLinkingCollectionsContactCollectionOrder {
  ContactEmailsHeadlineAsc = 'contactEmailsHeadline_ASC',
  ContactEmailsHeadlineDesc = 'contactEmailsHeadline_DESC',
  FacebookLinkAsc = 'facebookLink_ASC',
  FacebookLinkDesc = 'facebookLink_DESC',
  GrantInquiriesHeadlineAsc = 'grantInquiriesHeadline_ASC',
  GrantInquiriesHeadlineDesc = 'grantInquiriesHeadline_DESC',
  InstagramLinkAsc = 'instagramLink_ASC',
  InstagramLinkDesc = 'instagramLink_DESC',
  LinkedInLinkAsc = 'linkedInLink_ASC',
  LinkedInLinkDesc = 'linkedInLink_DESC',
  OfficeAddressGoogleMapsLabelAsc = 'officeAddressGoogleMapsLabel_ASC',
  OfficeAddressGoogleMapsLabelDesc = 'officeAddressGoogleMapsLabel_DESC',
  OfficeAddressGoogleMapsLinkAsc = 'officeAddressGoogleMapsLink_ASC',
  OfficeAddressGoogleMapsLinkDesc = 'officeAddressGoogleMapsLink_DESC',
  OfficeContactInformationHeadlineAsc = 'officeContactInformationHeadline_ASC',
  OfficeContactInformationHeadlineDesc = 'officeContactInformationHeadline_DESC',
  OfficeFaxNumberAsc = 'officeFaxNumber_ASC',
  OfficeFaxNumberDesc = 'officeFaxNumber_DESC',
  OfficeTelephoneNumberAsc = 'officeTelephoneNumber_ASC',
  OfficeTelephoneNumberDesc = 'officeTelephoneNumber_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SocialMediaHeadlineAsc = 'socialMediaHeadline_ASC',
  SocialMediaHeadlineDesc = 'socialMediaHeadline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThreadsLinkAsc = 'threadsLink_ASC',
  ThreadsLinkDesc = 'threadsLink_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterLinkAsc = 'twitterLink_ASC',
  TwitterLinkDesc = 'twitterLink_DESC',
  YoutubeLinkAsc = 'youtubeLink_ASC',
  YoutubeLinkDesc = 'youtubeLink_DESC'
}

export enum ConnectWithLinkLinkingCollectionsContactCursorCollectionOrder {
  ContactEmailsHeadlineAsc = 'contactEmailsHeadline_ASC',
  ContactEmailsHeadlineDesc = 'contactEmailsHeadline_DESC',
  FacebookLinkAsc = 'facebookLink_ASC',
  FacebookLinkDesc = 'facebookLink_DESC',
  GrantInquiriesHeadlineAsc = 'grantInquiriesHeadline_ASC',
  GrantInquiriesHeadlineDesc = 'grantInquiriesHeadline_DESC',
  InstagramLinkAsc = 'instagramLink_ASC',
  InstagramLinkDesc = 'instagramLink_DESC',
  LinkedInLinkAsc = 'linkedInLink_ASC',
  LinkedInLinkDesc = 'linkedInLink_DESC',
  OfficeAddressGoogleMapsLabelAsc = 'officeAddressGoogleMapsLabel_ASC',
  OfficeAddressGoogleMapsLabelDesc = 'officeAddressGoogleMapsLabel_DESC',
  OfficeAddressGoogleMapsLinkAsc = 'officeAddressGoogleMapsLink_ASC',
  OfficeAddressGoogleMapsLinkDesc = 'officeAddressGoogleMapsLink_DESC',
  OfficeContactInformationHeadlineAsc = 'officeContactInformationHeadline_ASC',
  OfficeContactInformationHeadlineDesc = 'officeContactInformationHeadline_DESC',
  OfficeFaxNumberAsc = 'officeFaxNumber_ASC',
  OfficeFaxNumberDesc = 'officeFaxNumber_DESC',
  OfficeTelephoneNumberAsc = 'officeTelephoneNumber_ASC',
  OfficeTelephoneNumberDesc = 'officeTelephoneNumber_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SocialMediaHeadlineAsc = 'socialMediaHeadline_ASC',
  SocialMediaHeadlineDesc = 'socialMediaHeadline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThreadsLinkAsc = 'threadsLink_ASC',
  ThreadsLinkDesc = 'threadsLink_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterLinkAsc = 'twitterLink_ASC',
  TwitterLinkDesc = 'twitterLink_DESC',
  YoutubeLinkAsc = 'youtubeLink_ASC',
  YoutubeLinkDesc = 'youtubeLink_DESC'
}

export enum ConnectWithLinkLinkingCollectionsFinancialsPageCollectionOrder {
  AuditedFinancialStatementsHeaderAsc = 'auditedFinancialStatementsHeader_ASC',
  AuditedFinancialStatementsHeaderDesc = 'auditedFinancialStatementsHeader_DESC',
  FinancialReportsHeaderAsc = 'financialReportsHeader_ASC',
  FinancialReportsHeaderDesc = 'financialReportsHeader_DESC',
  PrivateFoundationReportsHeaderAsc = 'privateFoundationReportsHeader_ASC',
  PrivateFoundationReportsHeaderDesc = 'privateFoundationReportsHeader_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SocialBondFrameworkAsc = 'socialBondFramework_ASC',
  SocialBondFrameworkDesc = 'socialBondFramework_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ConnectWithLinkLinkingCollectionsFinancialsPageCursorCollectionOrder {
  AuditedFinancialStatementsHeaderAsc = 'auditedFinancialStatementsHeader_ASC',
  AuditedFinancialStatementsHeaderDesc = 'auditedFinancialStatementsHeader_DESC',
  FinancialReportsHeaderAsc = 'financialReportsHeader_ASC',
  FinancialReportsHeaderDesc = 'financialReportsHeader_DESC',
  PrivateFoundationReportsHeaderAsc = 'privateFoundationReportsHeader_ASC',
  PrivateFoundationReportsHeaderDesc = 'privateFoundationReportsHeader_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SocialBondFrameworkAsc = 'socialBondFramework_ASC',
  SocialBondFrameworkDesc = 'socialBondFramework_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ConnectWithLinkLinkingCollectionsFooterCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ConnectWithLinkLinkingCollectionsFooterCursorCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ConnectWithLinkLinkingCollectionsGrantActivityArticleCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  GranteeCityOverrideAsc = 'granteeCityOverride_ASC',
  GranteeCityOverrideDesc = 'granteeCityOverride_DESC',
  GranteeCountryOverrideAsc = 'granteeCountryOverride_ASC',
  GranteeCountryOverrideDesc = 'granteeCountryOverride_DESC',
  GranteeNameOverrideAsc = 'granteeNameOverride_ASC',
  GranteeNameOverrideDesc = 'granteeNameOverride_DESC',
  GranteeStateOverrideAsc = 'granteeStateOverride_ASC',
  GranteeStateOverrideDesc = 'granteeStateOverride_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ConnectWithLinkLinkingCollectionsGrantActivityArticleCursorCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  GranteeCityOverrideAsc = 'granteeCityOverride_ASC',
  GranteeCityOverrideDesc = 'granteeCityOverride_DESC',
  GranteeCountryOverrideAsc = 'granteeCountryOverride_ASC',
  GranteeCountryOverrideDesc = 'granteeCountryOverride_DESC',
  GranteeNameOverrideAsc = 'granteeNameOverride_ASC',
  GranteeNameOverrideDesc = 'granteeNameOverride_DESC',
  GranteeStateOverrideAsc = 'granteeStateOverride_ASC',
  GranteeStateOverrideDesc = 'granteeStateOverride_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ConnectWithLinkLinkingCollectionsMmufCollectionOrder {
  ArticleTitleAsc = 'articleTitle_ASC',
  ArticleTitleDesc = 'articleTitle_DESC',
  AtGlanceTitleAsc = 'atGlanceTitle_ASC',
  AtGlanceTitleDesc = 'atGlanceTitle_DESC',
  ContactEmailAsc = 'contactEmail_ASC',
  ContactEmailDesc = 'contactEmail_DESC',
  ContactMessageAsc = 'contactMessage_ASC',
  ContactMessageDesc = 'contactMessage_DESC',
  ContactTitleAsc = 'contactTitle_ASC',
  ContactTitleDesc = 'contactTitle_DESC',
  FellowStoriesCtaLabelAsc = 'fellowStoriesCtaLabel_ASC',
  FellowStoriesCtaLabelDesc = 'fellowStoriesCtaLabel_DESC',
  FellowStoriesMessageAsc = 'fellowStoriesMessage_ASC',
  FellowStoriesMessageDesc = 'fellowStoriesMessage_DESC',
  GraduateInitiativesTitleAsc = 'graduateInitiativesTitle_ASC',
  GraduateInitiativesTitleDesc = 'graduateInitiativesTitle_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ConnectWithLinkLinkingCollectionsMmufCursorCollectionOrder {
  ArticleTitleAsc = 'articleTitle_ASC',
  ArticleTitleDesc = 'articleTitle_DESC',
  AtGlanceTitleAsc = 'atGlanceTitle_ASC',
  AtGlanceTitleDesc = 'atGlanceTitle_DESC',
  ContactEmailAsc = 'contactEmail_ASC',
  ContactEmailDesc = 'contactEmail_DESC',
  ContactMessageAsc = 'contactMessage_ASC',
  ContactMessageDesc = 'contactMessage_DESC',
  ContactTitleAsc = 'contactTitle_ASC',
  ContactTitleDesc = 'contactTitle_DESC',
  FellowStoriesCtaLabelAsc = 'fellowStoriesCtaLabel_ASC',
  FellowStoriesCtaLabelDesc = 'fellowStoriesCtaLabel_DESC',
  FellowStoriesMessageAsc = 'fellowStoriesMessage_ASC',
  FellowStoriesMessageDesc = 'fellowStoriesMessage_DESC',
  GraduateInitiativesTitleAsc = 'graduateInitiativesTitle_ASC',
  GraduateInitiativesTitleDesc = 'graduateInitiativesTitle_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ConnectWithLinkLinkingCollectionsPasswordProtectedPageCollectionOrder {
  EmailHeadlineAsc = 'emailHeadline_ASC',
  EmailHeadlineDesc = 'emailHeadline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ConnectWithLinkLinkingCollectionsPasswordProtectedPageCursorCollectionOrder {
  EmailHeadlineAsc = 'emailHeadline_ASC',
  EmailHeadlineDesc = 'emailHeadline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ConnectWithLinkLinkingCollectionsPersonCollectionOrder {
  FirstNameAsc = 'firstName_ASC',
  FirstNameDesc = 'firstName_DESC',
  JobTitleAsc = 'jobTitle_ASC',
  JobTitleDesc = 'jobTitle_DESC',
  LastNameAsc = 'lastName_ASC',
  LastNameDesc = 'lastName_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  RelatedSectionTitleAsc = 'relatedSectionTitle_ASC',
  RelatedSectionTitleDesc = 'relatedSectionTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ConnectWithLinkLinkingCollectionsPersonCursorCollectionOrder {
  FirstNameAsc = 'firstName_ASC',
  FirstNameDesc = 'firstName_DESC',
  JobTitleAsc = 'jobTitle_ASC',
  JobTitleDesc = 'jobTitle_DESC',
  LastNameAsc = 'lastName_ASC',
  LastNameDesc = 'lastName_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  RelatedSectionTitleAsc = 'relatedSectionTitle_ASC',
  RelatedSectionTitleDesc = 'relatedSectionTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ConnectWithLinkLinkingCollectionsPressRoomCollectionOrder {
  ContactsTitleAsc = 'contactsTitle_ASC',
  ContactsTitleDesc = 'contactsTitle_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  EmailLabelAsc = 'emailLabel_ASC',
  EmailLabelDesc = 'emailLabel_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  GuidelinesAndMediasDescriptionAsc = 'guidelinesAndMediasDescription_ASC',
  GuidelinesAndMediasDescriptionDesc = 'guidelinesAndMediasDescription_DESC',
  GuidelinesAndMediasHeadingAsc = 'guidelinesAndMediasHeading_ASC',
  GuidelinesAndMediasHeadingDesc = 'guidelinesAndMediasHeading_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ConnectWithLinkLinkingCollectionsPressRoomCursorCollectionOrder {
  ContactsTitleAsc = 'contactsTitle_ASC',
  ContactsTitleDesc = 'contactsTitle_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  EmailLabelAsc = 'emailLabel_ASC',
  EmailLabelDesc = 'emailLabel_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  GuidelinesAndMediasDescriptionAsc = 'guidelinesAndMediasDescription_ASC',
  GuidelinesAndMediasDescriptionDesc = 'guidelinesAndMediasDescription_DESC',
  GuidelinesAndMediasHeadingAsc = 'guidelinesAndMediasHeading_ASC',
  GuidelinesAndMediasHeadingDesc = 'guidelinesAndMediasHeading_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ConnectWithLinkOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ConnectWithLinkingCollections = {
  __typename: 'ConnectWithLinkingCollections';
  annualReportCollection: Maybe<AnnualReportCollection>;
  annualReportCursorCollection: Maybe<AnnualReportCursorCollection>;
  articleCollection: Maybe<ArticleCollection>;
  articleCursorCollection: Maybe<ArticleCursorCollection>;
  contactCollection: Maybe<ContactCollection>;
  contactCursorCollection: Maybe<ContactCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  featureCollection: Maybe<FeatureCollection>;
  featureCursorCollection: Maybe<FeatureCursorCollection>;
  financialsPageCollection: Maybe<FinancialsPageCollection>;
  financialsPageCursorCollection: Maybe<FinancialsPageCursorCollection>;
  grantDetailsPageCollection: Maybe<GrantDetailsPageCollection>;
  grantDetailsPageCursorCollection: Maybe<GrantDetailsPageCursorCollection>;
  grantResourcesCollection: Maybe<GrantResourcesCollection>;
  grantResourcesCursorCollection: Maybe<GrantResourcesCursorCollection>;
  grantmakingAreaDetailsPageCollection: Maybe<GrantmakingAreaDetailsPageCollection>;
  grantmakingAreaDetailsPageCursorCollection: Maybe<GrantmakingAreaDetailsPageCursorCollection>;
  mmufCollection: Maybe<MmufCollection>;
  mmufCursorCollection: Maybe<MmufCursorCollection>;
  newsletterPageCollection: Maybe<NewsletterPageCollection>;
  newsletterPageCursorCollection: Maybe<NewsletterPageCursorCollection>;
  pressRoomCollection: Maybe<PressRoomCollection>;
  pressRoomCursorCollection: Maybe<PressRoomCursorCollection>;
  resourcesCurrentGranteesCollection: Maybe<ResourcesCurrentGranteesCollection>;
  resourcesCurrentGranteesCursorCollection: Maybe<ResourcesCurrentGranteesCursorCollection>;
  resourcesProspectiveGranteesCollection: Maybe<ResourcesProspectiveGranteesCollection>;
  resourcesProspectiveGranteesCursorCollection: Maybe<ResourcesProspectiveGranteesCursorCollection>;
};


export type ConnectWithLinkingCollectionsAnnualReportCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkingCollectionsAnnualReportCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkingCollectionsAnnualReportCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkingCollectionsAnnualReportCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkingCollectionsArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkingCollectionsArticleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkingCollectionsArticleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkingCollectionsArticleCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkingCollectionsContactCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkingCollectionsContactCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkingCollectionsContactCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkingCollectionsContactCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkingCollectionsFeatureCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkingCollectionsFeatureCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkingCollectionsFeatureCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkingCollectionsFeatureCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkingCollectionsFinancialsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkingCollectionsFinancialsPageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkingCollectionsFinancialsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkingCollectionsFinancialsPageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkingCollectionsGrantDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkingCollectionsGrantDetailsPageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkingCollectionsGrantDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkingCollectionsGrantDetailsPageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkingCollectionsGrantResourcesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkingCollectionsGrantResourcesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkingCollectionsGrantResourcesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkingCollectionsGrantResourcesCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkingCollectionsGrantmakingAreaDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkingCollectionsGrantmakingAreaDetailsPageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkingCollectionsGrantmakingAreaDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkingCollectionsGrantmakingAreaDetailsPageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkingCollectionsMmufCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkingCollectionsMmufCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkingCollectionsMmufCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkingCollectionsMmufCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkingCollectionsNewsletterPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkingCollectionsNewsletterPageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkingCollectionsNewsletterPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkingCollectionsNewsletterPageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkingCollectionsPressRoomCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkingCollectionsPressRoomCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkingCollectionsPressRoomCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkingCollectionsPressRoomCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkingCollectionsResourcesCurrentGranteesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkingCollectionsResourcesCurrentGranteesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkingCollectionsResourcesCurrentGranteesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkingCollectionsResourcesCurrentGranteesCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkingCollectionsResourcesProspectiveGranteesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkingCollectionsResourcesProspectiveGranteesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConnectWithLinkingCollectionsResourcesProspectiveGranteesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkingCollectionsResourcesProspectiveGranteesCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ConnectWithLinkingCollectionsAnnualReportCollectionOrder {
  CallToActionCtaTextAsc = 'callToActionCtaText_ASC',
  CallToActionCtaTextDesc = 'callToActionCtaText_DESC',
  CallToActionTextAsc = 'callToActionText_ASC',
  CallToActionTextDesc = 'callToActionText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  IsLookingForAnnualReportsSectionVisibleAsc = 'isLookingForAnnualReportsSectionVisible_ASC',
  IsLookingForAnnualReportsSectionVisibleDesc = 'isLookingForAnnualReportsSectionVisible_DESC',
  MoreAnnualReportsTitleAsc = 'moreAnnualReportsTitle_ASC',
  MoreAnnualReportsTitleDesc = 'moreAnnualReportsTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  YearAsc = 'year_ASC',
  YearDesc = 'year_DESC'
}

export enum ConnectWithLinkingCollectionsAnnualReportCursorCollectionOrder {
  CallToActionCtaTextAsc = 'callToActionCtaText_ASC',
  CallToActionCtaTextDesc = 'callToActionCtaText_DESC',
  CallToActionTextAsc = 'callToActionText_ASC',
  CallToActionTextDesc = 'callToActionText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  IsLookingForAnnualReportsSectionVisibleAsc = 'isLookingForAnnualReportsSectionVisible_ASC',
  IsLookingForAnnualReportsSectionVisibleDesc = 'isLookingForAnnualReportsSectionVisible_DESC',
  MoreAnnualReportsTitleAsc = 'moreAnnualReportsTitle_ASC',
  MoreAnnualReportsTitleDesc = 'moreAnnualReportsTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  YearAsc = 'year_ASC',
  YearDesc = 'year_DESC'
}

export enum ConnectWithLinkingCollectionsArticleCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  ExternalNewsUrlAsc = 'externalNewsUrl_ASC',
  ExternalNewsUrlDesc = 'externalNewsUrl_DESC',
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  PasswordAsc = 'password_ASC',
  PasswordDesc = 'password_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum ConnectWithLinkingCollectionsArticleCursorCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  ExternalNewsUrlAsc = 'externalNewsUrl_ASC',
  ExternalNewsUrlDesc = 'externalNewsUrl_DESC',
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  PasswordAsc = 'password_ASC',
  PasswordDesc = 'password_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum ConnectWithLinkingCollectionsContactCollectionOrder {
  ContactEmailsHeadlineAsc = 'contactEmailsHeadline_ASC',
  ContactEmailsHeadlineDesc = 'contactEmailsHeadline_DESC',
  FacebookLinkAsc = 'facebookLink_ASC',
  FacebookLinkDesc = 'facebookLink_DESC',
  GrantInquiriesHeadlineAsc = 'grantInquiriesHeadline_ASC',
  GrantInquiriesHeadlineDesc = 'grantInquiriesHeadline_DESC',
  InstagramLinkAsc = 'instagramLink_ASC',
  InstagramLinkDesc = 'instagramLink_DESC',
  LinkedInLinkAsc = 'linkedInLink_ASC',
  LinkedInLinkDesc = 'linkedInLink_DESC',
  OfficeAddressGoogleMapsLabelAsc = 'officeAddressGoogleMapsLabel_ASC',
  OfficeAddressGoogleMapsLabelDesc = 'officeAddressGoogleMapsLabel_DESC',
  OfficeAddressGoogleMapsLinkAsc = 'officeAddressGoogleMapsLink_ASC',
  OfficeAddressGoogleMapsLinkDesc = 'officeAddressGoogleMapsLink_DESC',
  OfficeContactInformationHeadlineAsc = 'officeContactInformationHeadline_ASC',
  OfficeContactInformationHeadlineDesc = 'officeContactInformationHeadline_DESC',
  OfficeFaxNumberAsc = 'officeFaxNumber_ASC',
  OfficeFaxNumberDesc = 'officeFaxNumber_DESC',
  OfficeTelephoneNumberAsc = 'officeTelephoneNumber_ASC',
  OfficeTelephoneNumberDesc = 'officeTelephoneNumber_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SocialMediaHeadlineAsc = 'socialMediaHeadline_ASC',
  SocialMediaHeadlineDesc = 'socialMediaHeadline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThreadsLinkAsc = 'threadsLink_ASC',
  ThreadsLinkDesc = 'threadsLink_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterLinkAsc = 'twitterLink_ASC',
  TwitterLinkDesc = 'twitterLink_DESC',
  YoutubeLinkAsc = 'youtubeLink_ASC',
  YoutubeLinkDesc = 'youtubeLink_DESC'
}

export enum ConnectWithLinkingCollectionsContactCursorCollectionOrder {
  ContactEmailsHeadlineAsc = 'contactEmailsHeadline_ASC',
  ContactEmailsHeadlineDesc = 'contactEmailsHeadline_DESC',
  FacebookLinkAsc = 'facebookLink_ASC',
  FacebookLinkDesc = 'facebookLink_DESC',
  GrantInquiriesHeadlineAsc = 'grantInquiriesHeadline_ASC',
  GrantInquiriesHeadlineDesc = 'grantInquiriesHeadline_DESC',
  InstagramLinkAsc = 'instagramLink_ASC',
  InstagramLinkDesc = 'instagramLink_DESC',
  LinkedInLinkAsc = 'linkedInLink_ASC',
  LinkedInLinkDesc = 'linkedInLink_DESC',
  OfficeAddressGoogleMapsLabelAsc = 'officeAddressGoogleMapsLabel_ASC',
  OfficeAddressGoogleMapsLabelDesc = 'officeAddressGoogleMapsLabel_DESC',
  OfficeAddressGoogleMapsLinkAsc = 'officeAddressGoogleMapsLink_ASC',
  OfficeAddressGoogleMapsLinkDesc = 'officeAddressGoogleMapsLink_DESC',
  OfficeContactInformationHeadlineAsc = 'officeContactInformationHeadline_ASC',
  OfficeContactInformationHeadlineDesc = 'officeContactInformationHeadline_DESC',
  OfficeFaxNumberAsc = 'officeFaxNumber_ASC',
  OfficeFaxNumberDesc = 'officeFaxNumber_DESC',
  OfficeTelephoneNumberAsc = 'officeTelephoneNumber_ASC',
  OfficeTelephoneNumberDesc = 'officeTelephoneNumber_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SocialMediaHeadlineAsc = 'socialMediaHeadline_ASC',
  SocialMediaHeadlineDesc = 'socialMediaHeadline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThreadsLinkAsc = 'threadsLink_ASC',
  ThreadsLinkDesc = 'threadsLink_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterLinkAsc = 'twitterLink_ASC',
  TwitterLinkDesc = 'twitterLink_DESC',
  YoutubeLinkAsc = 'youtubeLink_ASC',
  YoutubeLinkDesc = 'youtubeLink_DESC'
}

export enum ConnectWithLinkingCollectionsFeatureCollectionOrder {
  DateTimeAsc = 'dateTime_ASC',
  DateTimeDesc = 'dateTime_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  ShowSocialCtasAsc = 'showSocialCtas_ASC',
  ShowSocialCtasDesc = 'showSocialCtas_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TaglineAsc = 'tagline_ASC',
  TaglineDesc = 'tagline_DESC'
}

export enum ConnectWithLinkingCollectionsFeatureCursorCollectionOrder {
  DateTimeAsc = 'dateTime_ASC',
  DateTimeDesc = 'dateTime_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  ShowSocialCtasAsc = 'showSocialCtas_ASC',
  ShowSocialCtasDesc = 'showSocialCtas_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TaglineAsc = 'tagline_ASC',
  TaglineDesc = 'tagline_DESC'
}

export enum ConnectWithLinkingCollectionsFinancialsPageCollectionOrder {
  AuditedFinancialStatementsHeaderAsc = 'auditedFinancialStatementsHeader_ASC',
  AuditedFinancialStatementsHeaderDesc = 'auditedFinancialStatementsHeader_DESC',
  FinancialReportsHeaderAsc = 'financialReportsHeader_ASC',
  FinancialReportsHeaderDesc = 'financialReportsHeader_DESC',
  PrivateFoundationReportsHeaderAsc = 'privateFoundationReportsHeader_ASC',
  PrivateFoundationReportsHeaderDesc = 'privateFoundationReportsHeader_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SocialBondFrameworkAsc = 'socialBondFramework_ASC',
  SocialBondFrameworkDesc = 'socialBondFramework_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ConnectWithLinkingCollectionsFinancialsPageCursorCollectionOrder {
  AuditedFinancialStatementsHeaderAsc = 'auditedFinancialStatementsHeader_ASC',
  AuditedFinancialStatementsHeaderDesc = 'auditedFinancialStatementsHeader_DESC',
  FinancialReportsHeaderAsc = 'financialReportsHeader_ASC',
  FinancialReportsHeaderDesc = 'financialReportsHeader_DESC',
  PrivateFoundationReportsHeaderAsc = 'privateFoundationReportsHeader_ASC',
  PrivateFoundationReportsHeaderDesc = 'privateFoundationReportsHeader_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SocialBondFrameworkAsc = 'socialBondFramework_ASC',
  SocialBondFrameworkDesc = 'socialBondFramework_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ConnectWithLinkingCollectionsGrantDetailsPageCollectionOrder {
  StrategyCopyAsc = 'strategyCopy_ASC',
  StrategyCopyDesc = 'strategyCopy_DESC',
  StrategyCtaLabelAsc = 'strategyCtaLabel_ASC',
  StrategyCtaLabelDesc = 'strategyCtaLabel_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ConnectWithLinkingCollectionsGrantDetailsPageCursorCollectionOrder {
  StrategyCopyAsc = 'strategyCopy_ASC',
  StrategyCopyDesc = 'strategyCopy_DESC',
  StrategyCtaLabelAsc = 'strategyCtaLabel_ASC',
  StrategyCtaLabelDesc = 'strategyCtaLabel_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ConnectWithLinkingCollectionsGrantResourcesCollectionOrder {
  ExplanatoryTitleAsc = 'explanatoryTitle_ASC',
  ExplanatoryTitleDesc = 'explanatoryTitle_DESC',
  GrantMakingAreasTitleAsc = 'grantMakingAreasTitle_ASC',
  GrantMakingAreasTitleDesc = 'grantMakingAreasTitle_DESC',
  SearchContextualMessageAsc = 'searchContextualMessage_ASC',
  SearchContextualMessageDesc = 'searchContextualMessage_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ConnectWithLinkingCollectionsGrantResourcesCursorCollectionOrder {
  ExplanatoryTitleAsc = 'explanatoryTitle_ASC',
  ExplanatoryTitleDesc = 'explanatoryTitle_DESC',
  GrantMakingAreasTitleAsc = 'grantMakingAreasTitle_ASC',
  GrantMakingAreasTitleDesc = 'grantMakingAreasTitle_DESC',
  SearchContextualMessageAsc = 'searchContextualMessage_ASC',
  SearchContextualMessageDesc = 'searchContextualMessage_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ConnectWithLinkingCollectionsGrantmakingAreaDetailsPageCollectionOrder {
  GrantMakingProcessMessageAsc = 'grantMakingProcessMessage_ASC',
  GrantMakingProcessMessageDesc = 'grantMakingProcessMessage_DESC',
  GuidingStrategiesTitleAsc = 'guidingStrategiesTitle_ASC',
  GuidingStrategiesTitleDesc = 'guidingStrategiesTitle_DESC',
  IntroDescriptionAsc = 'introDescription_ASC',
  IntroDescriptionDesc = 'introDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ConnectWithLinkingCollectionsGrantmakingAreaDetailsPageCursorCollectionOrder {
  GrantMakingProcessMessageAsc = 'grantMakingProcessMessage_ASC',
  GrantMakingProcessMessageDesc = 'grantMakingProcessMessage_DESC',
  GuidingStrategiesTitleAsc = 'guidingStrategiesTitle_ASC',
  GuidingStrategiesTitleDesc = 'guidingStrategiesTitle_DESC',
  IntroDescriptionAsc = 'introDescription_ASC',
  IntroDescriptionDesc = 'introDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ConnectWithLinkingCollectionsMmufCollectionOrder {
  ArticleTitleAsc = 'articleTitle_ASC',
  ArticleTitleDesc = 'articleTitle_DESC',
  AtGlanceTitleAsc = 'atGlanceTitle_ASC',
  AtGlanceTitleDesc = 'atGlanceTitle_DESC',
  ContactEmailAsc = 'contactEmail_ASC',
  ContactEmailDesc = 'contactEmail_DESC',
  ContactMessageAsc = 'contactMessage_ASC',
  ContactMessageDesc = 'contactMessage_DESC',
  ContactTitleAsc = 'contactTitle_ASC',
  ContactTitleDesc = 'contactTitle_DESC',
  FellowStoriesCtaLabelAsc = 'fellowStoriesCtaLabel_ASC',
  FellowStoriesCtaLabelDesc = 'fellowStoriesCtaLabel_DESC',
  FellowStoriesMessageAsc = 'fellowStoriesMessage_ASC',
  FellowStoriesMessageDesc = 'fellowStoriesMessage_DESC',
  GraduateInitiativesTitleAsc = 'graduateInitiativesTitle_ASC',
  GraduateInitiativesTitleDesc = 'graduateInitiativesTitle_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ConnectWithLinkingCollectionsMmufCursorCollectionOrder {
  ArticleTitleAsc = 'articleTitle_ASC',
  ArticleTitleDesc = 'articleTitle_DESC',
  AtGlanceTitleAsc = 'atGlanceTitle_ASC',
  AtGlanceTitleDesc = 'atGlanceTitle_DESC',
  ContactEmailAsc = 'contactEmail_ASC',
  ContactEmailDesc = 'contactEmail_DESC',
  ContactMessageAsc = 'contactMessage_ASC',
  ContactMessageDesc = 'contactMessage_DESC',
  ContactTitleAsc = 'contactTitle_ASC',
  ContactTitleDesc = 'contactTitle_DESC',
  FellowStoriesCtaLabelAsc = 'fellowStoriesCtaLabel_ASC',
  FellowStoriesCtaLabelDesc = 'fellowStoriesCtaLabel_DESC',
  FellowStoriesMessageAsc = 'fellowStoriesMessage_ASC',
  FellowStoriesMessageDesc = 'fellowStoriesMessage_DESC',
  GraduateInitiativesTitleAsc = 'graduateInitiativesTitle_ASC',
  GraduateInitiativesTitleDesc = 'graduateInitiativesTitle_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ConnectWithLinkingCollectionsNewsletterPageCollectionOrder {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  SignupDescriptionAsc = 'signupDescription_ASC',
  SignupDescriptionDesc = 'signupDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ConnectWithLinkingCollectionsNewsletterPageCursorCollectionOrder {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  SignupDescriptionAsc = 'signupDescription_ASC',
  SignupDescriptionDesc = 'signupDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ConnectWithLinkingCollectionsPressRoomCollectionOrder {
  ContactsTitleAsc = 'contactsTitle_ASC',
  ContactsTitleDesc = 'contactsTitle_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  EmailLabelAsc = 'emailLabel_ASC',
  EmailLabelDesc = 'emailLabel_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  GuidelinesAndMediasDescriptionAsc = 'guidelinesAndMediasDescription_ASC',
  GuidelinesAndMediasDescriptionDesc = 'guidelinesAndMediasDescription_DESC',
  GuidelinesAndMediasHeadingAsc = 'guidelinesAndMediasHeading_ASC',
  GuidelinesAndMediasHeadingDesc = 'guidelinesAndMediasHeading_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ConnectWithLinkingCollectionsPressRoomCursorCollectionOrder {
  ContactsTitleAsc = 'contactsTitle_ASC',
  ContactsTitleDesc = 'contactsTitle_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  EmailLabelAsc = 'emailLabel_ASC',
  EmailLabelDesc = 'emailLabel_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  GuidelinesAndMediasDescriptionAsc = 'guidelinesAndMediasDescription_ASC',
  GuidelinesAndMediasDescriptionDesc = 'guidelinesAndMediasDescription_DESC',
  GuidelinesAndMediasHeadingAsc = 'guidelinesAndMediasHeading_ASC',
  GuidelinesAndMediasHeadingDesc = 'guidelinesAndMediasHeading_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ConnectWithLinkingCollectionsResourcesCurrentGranteesCollectionOrder {
  GrantDatabaseCtaTextAsc = 'grantDatabaseCtaText_ASC',
  GrantDatabaseCtaTextDesc = 'grantDatabaseCtaText_DESC',
  ResourcesTitleAsc = 'resourcesTitle_ASC',
  ResourcesTitleDesc = 'resourcesTitle_DESC',
  SimilarGranteesTitleAsc = 'similarGranteesTitle_ASC',
  SimilarGranteesTitleDesc = 'similarGranteesTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ConnectWithLinkingCollectionsResourcesCurrentGranteesCursorCollectionOrder {
  GrantDatabaseCtaTextAsc = 'grantDatabaseCtaText_ASC',
  GrantDatabaseCtaTextDesc = 'grantDatabaseCtaText_DESC',
  ResourcesTitleAsc = 'resourcesTitle_ASC',
  ResourcesTitleDesc = 'resourcesTitle_DESC',
  SimilarGranteesTitleAsc = 'similarGranteesTitle_ASC',
  SimilarGranteesTitleDesc = 'similarGranteesTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ConnectWithLinkingCollectionsResourcesProspectiveGranteesCollectionOrder {
  CallsForConceptsTitleAsc = 'callsForConceptsTitle_ASC',
  CallsForConceptsTitleDesc = 'callsForConceptsTitle_DESC',
  GrantDatabaseCtaTextAsc = 'grantDatabaseCtaText_ASC',
  GrantDatabaseCtaTextDesc = 'grantDatabaseCtaText_DESC',
  GrantmakingAtGlanceTitleAsc = 'grantmakingAtGlanceTitle_ASC',
  GrantmakingAtGlanceTitleDesc = 'grantmakingAtGlanceTitle_DESC',
  NewsletterCtaTextAsc = 'newsletterCtaText_ASC',
  NewsletterCtaTextDesc = 'newsletterCtaText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ConnectWithLinkingCollectionsResourcesProspectiveGranteesCursorCollectionOrder {
  CallsForConceptsTitleAsc = 'callsForConceptsTitle_ASC',
  CallsForConceptsTitleDesc = 'callsForConceptsTitle_DESC',
  GrantDatabaseCtaTextAsc = 'grantDatabaseCtaText_ASC',
  GrantDatabaseCtaTextDesc = 'grantDatabaseCtaText_DESC',
  GrantmakingAtGlanceTitleAsc = 'grantmakingAtGlanceTitle_ASC',
  GrantmakingAtGlanceTitleDesc = 'grantmakingAtGlanceTitle_DESC',
  NewsletterCtaTextAsc = 'newsletterCtaText_ASC',
  NewsletterCtaTextDesc = 'newsletterCtaText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ConnectWithLinksCollection = {
  __typename: 'ConnectWithLinksCollection';
  items: Array<Maybe<ConnectWithLink>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ConnectWithLinksCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ConnectWithLinksCursorCollection = {
  __typename: 'ConnectWithLinksCursorCollection';
  items: Array<Maybe<ConnectWithLink>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ConnectWithLinksCursorCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ConnectWithOrder {
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/contact) */
export type Contact = Entry & _Node & {
  __typename: 'Contact';
  _id: Scalars['ID']['output'];
  contactEmailsHeadline: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  description: Maybe<Scalars['String']['output']>;
  emailsCollection: Maybe<ContactEmailsCollection>;
  emailsCursorCollection: Maybe<ContactEmailsCursorCollection>;
  facebookLink: Maybe<Scalars['String']['output']>;
  grantInquiriesHeadline: Maybe<Scalars['String']['output']>;
  grantInquiriesLink: Maybe<ConnectWithLink>;
  grantInquiriesText: Maybe<Scalars['String']['output']>;
  instagramLink: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<ContactLinkingCollections>;
  linkedInLink: Maybe<Scalars['String']['output']>;
  newsletter: Maybe<NewsletterCard>;
  officeAddress: Maybe<Scalars['String']['output']>;
  officeAddressGoogleMapsLabel: Maybe<Scalars['String']['output']>;
  officeAddressGoogleMapsLink: Maybe<Scalars['String']['output']>;
  officeContactInformationHeadline: Maybe<Scalars['String']['output']>;
  officeFaxNumber: Maybe<Scalars['String']['output']>;
  officeTelephoneNumber: Maybe<Scalars['String']['output']>;
  quickLinks: Maybe<ConnectWith>;
  slug: Maybe<Scalars['String']['output']>;
  socialMediaHeadline: Maybe<Scalars['String']['output']>;
  socialMediaText: Maybe<Scalars['String']['output']>;
  sys: Sys;
  textBlock: Maybe<ContactTextBlock>;
  threadsLink: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  twitterLink: Maybe<Scalars['String']['output']>;
  youtubeLink: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/contact) */
export type ContactContactEmailsHeadlineArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/contact) */
export type ContactDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/contact) */
export type ContactEmailsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ContactEmailsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ConnectWithLinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/contact) */
export type ContactEmailsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ContactEmailsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ConnectWithLinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/contact) */
export type ContactFacebookLinkArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/contact) */
export type ContactGrantInquiriesHeadlineArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/contact) */
export type ContactGrantInquiriesLinkArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ConnectWithLinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/contact) */
export type ContactGrantInquiriesTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/contact) */
export type ContactInstagramLinkArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/contact) */
export type ContactLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/contact) */
export type ContactLinkedInLinkArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/contact) */
export type ContactNewsletterArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<NewsletterCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/contact) */
export type ContactOfficeAddressArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/contact) */
export type ContactOfficeAddressGoogleMapsLabelArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/contact) */
export type ContactOfficeAddressGoogleMapsLinkArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/contact) */
export type ContactOfficeContactInformationHeadlineArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/contact) */
export type ContactOfficeFaxNumberArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/contact) */
export type ContactOfficeTelephoneNumberArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/contact) */
export type ContactQuickLinksArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ConnectWithFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/contact) */
export type ContactSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/contact) */
export type ContactSocialMediaHeadlineArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/contact) */
export type ContactSocialMediaTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/contact) */
export type ContactTextBlockArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/contact) */
export type ContactThreadsLinkArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/contact) */
export type ContactTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/contact) */
export type ContactTwitterLinkArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/contact) */
export type ContactYoutubeLinkArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContactCollection = {
  __typename: 'ContactCollection';
  items: Array<Maybe<Contact>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContactCursorCollection = {
  __typename: 'ContactCursorCollection';
  items: Array<Maybe<Contact>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ContactEmailsCollection = {
  __typename: 'ContactEmailsCollection';
  items: Array<Maybe<ConnectWithLink>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ContactEmailsCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ContactEmailsCursorCollection = {
  __typename: 'ContactEmailsCursorCollection';
  items: Array<Maybe<ConnectWithLink>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ContactEmailsCursorCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ContactFilter = {
  AND: InputMaybe<Array<InputMaybe<ContactFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ContactFilter>>>;
  contactEmailsHeadline: InputMaybe<Scalars['String']['input']>;
  contactEmailsHeadline_contains: InputMaybe<Scalars['String']['input']>;
  contactEmailsHeadline_exists: InputMaybe<Scalars['Boolean']['input']>;
  contactEmailsHeadline_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactEmailsHeadline_not: InputMaybe<Scalars['String']['input']>;
  contactEmailsHeadline_not_contains: InputMaybe<Scalars['String']['input']>;
  contactEmailsHeadline_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  emails: InputMaybe<CfConnectWithLinkNestedFilter>;
  emailsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  facebookLink: InputMaybe<Scalars['String']['input']>;
  facebookLink_contains: InputMaybe<Scalars['String']['input']>;
  facebookLink_exists: InputMaybe<Scalars['Boolean']['input']>;
  facebookLink_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facebookLink_not: InputMaybe<Scalars['String']['input']>;
  facebookLink_not_contains: InputMaybe<Scalars['String']['input']>;
  facebookLink_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  grantInquiriesHeadline: InputMaybe<Scalars['String']['input']>;
  grantInquiriesHeadline_contains: InputMaybe<Scalars['String']['input']>;
  grantInquiriesHeadline_exists: InputMaybe<Scalars['Boolean']['input']>;
  grantInquiriesHeadline_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  grantInquiriesHeadline_not: InputMaybe<Scalars['String']['input']>;
  grantInquiriesHeadline_not_contains: InputMaybe<Scalars['String']['input']>;
  grantInquiriesHeadline_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  grantInquiriesLink: InputMaybe<CfConnectWithLinkNestedFilter>;
  grantInquiriesLink_exists: InputMaybe<Scalars['Boolean']['input']>;
  grantInquiriesText: InputMaybe<Scalars['String']['input']>;
  grantInquiriesText_contains: InputMaybe<Scalars['String']['input']>;
  grantInquiriesText_exists: InputMaybe<Scalars['Boolean']['input']>;
  grantInquiriesText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  grantInquiriesText_not: InputMaybe<Scalars['String']['input']>;
  grantInquiriesText_not_contains: InputMaybe<Scalars['String']['input']>;
  grantInquiriesText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  instagramLink: InputMaybe<Scalars['String']['input']>;
  instagramLink_contains: InputMaybe<Scalars['String']['input']>;
  instagramLink_exists: InputMaybe<Scalars['Boolean']['input']>;
  instagramLink_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  instagramLink_not: InputMaybe<Scalars['String']['input']>;
  instagramLink_not_contains: InputMaybe<Scalars['String']['input']>;
  instagramLink_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkedInLink: InputMaybe<Scalars['String']['input']>;
  linkedInLink_contains: InputMaybe<Scalars['String']['input']>;
  linkedInLink_exists: InputMaybe<Scalars['Boolean']['input']>;
  linkedInLink_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkedInLink_not: InputMaybe<Scalars['String']['input']>;
  linkedInLink_not_contains: InputMaybe<Scalars['String']['input']>;
  linkedInLink_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  newsletter: InputMaybe<CfNewsletterCardNestedFilter>;
  newsletter_exists: InputMaybe<Scalars['Boolean']['input']>;
  officeAddress: InputMaybe<Scalars['String']['input']>;
  officeAddressGoogleMapsLabel: InputMaybe<Scalars['String']['input']>;
  officeAddressGoogleMapsLabel_contains: InputMaybe<Scalars['String']['input']>;
  officeAddressGoogleMapsLabel_exists: InputMaybe<Scalars['Boolean']['input']>;
  officeAddressGoogleMapsLabel_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  officeAddressGoogleMapsLabel_not: InputMaybe<Scalars['String']['input']>;
  officeAddressGoogleMapsLabel_not_contains: InputMaybe<Scalars['String']['input']>;
  officeAddressGoogleMapsLabel_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  officeAddressGoogleMapsLink: InputMaybe<Scalars['String']['input']>;
  officeAddressGoogleMapsLink_contains: InputMaybe<Scalars['String']['input']>;
  officeAddressGoogleMapsLink_exists: InputMaybe<Scalars['Boolean']['input']>;
  officeAddressGoogleMapsLink_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  officeAddressGoogleMapsLink_not: InputMaybe<Scalars['String']['input']>;
  officeAddressGoogleMapsLink_not_contains: InputMaybe<Scalars['String']['input']>;
  officeAddressGoogleMapsLink_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  officeAddress_contains: InputMaybe<Scalars['String']['input']>;
  officeAddress_exists: InputMaybe<Scalars['Boolean']['input']>;
  officeAddress_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  officeAddress_not: InputMaybe<Scalars['String']['input']>;
  officeAddress_not_contains: InputMaybe<Scalars['String']['input']>;
  officeAddress_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  officeContactInformationHeadline: InputMaybe<Scalars['String']['input']>;
  officeContactInformationHeadline_contains: InputMaybe<Scalars['String']['input']>;
  officeContactInformationHeadline_exists: InputMaybe<Scalars['Boolean']['input']>;
  officeContactInformationHeadline_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  officeContactInformationHeadline_not: InputMaybe<Scalars['String']['input']>;
  officeContactInformationHeadline_not_contains: InputMaybe<Scalars['String']['input']>;
  officeContactInformationHeadline_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  officeFaxNumber: InputMaybe<Scalars['String']['input']>;
  officeFaxNumber_contains: InputMaybe<Scalars['String']['input']>;
  officeFaxNumber_exists: InputMaybe<Scalars['Boolean']['input']>;
  officeFaxNumber_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  officeFaxNumber_not: InputMaybe<Scalars['String']['input']>;
  officeFaxNumber_not_contains: InputMaybe<Scalars['String']['input']>;
  officeFaxNumber_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  officeTelephoneNumber: InputMaybe<Scalars['String']['input']>;
  officeTelephoneNumber_contains: InputMaybe<Scalars['String']['input']>;
  officeTelephoneNumber_exists: InputMaybe<Scalars['Boolean']['input']>;
  officeTelephoneNumber_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  officeTelephoneNumber_not: InputMaybe<Scalars['String']['input']>;
  officeTelephoneNumber_not_contains: InputMaybe<Scalars['String']['input']>;
  officeTelephoneNumber_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quickLinks: InputMaybe<CfConnectWithNestedFilter>;
  quickLinks_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialMediaHeadline: InputMaybe<Scalars['String']['input']>;
  socialMediaHeadline_contains: InputMaybe<Scalars['String']['input']>;
  socialMediaHeadline_exists: InputMaybe<Scalars['Boolean']['input']>;
  socialMediaHeadline_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialMediaHeadline_not: InputMaybe<Scalars['String']['input']>;
  socialMediaHeadline_not_contains: InputMaybe<Scalars['String']['input']>;
  socialMediaHeadline_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialMediaText: InputMaybe<Scalars['String']['input']>;
  socialMediaText_contains: InputMaybe<Scalars['String']['input']>;
  socialMediaText_exists: InputMaybe<Scalars['Boolean']['input']>;
  socialMediaText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialMediaText_not: InputMaybe<Scalars['String']['input']>;
  socialMediaText_not_contains: InputMaybe<Scalars['String']['input']>;
  socialMediaText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  textBlock_contains: InputMaybe<Scalars['String']['input']>;
  textBlock_exists: InputMaybe<Scalars['Boolean']['input']>;
  textBlock_not_contains: InputMaybe<Scalars['String']['input']>;
  threadsLink: InputMaybe<Scalars['String']['input']>;
  threadsLink_contains: InputMaybe<Scalars['String']['input']>;
  threadsLink_exists: InputMaybe<Scalars['Boolean']['input']>;
  threadsLink_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  threadsLink_not: InputMaybe<Scalars['String']['input']>;
  threadsLink_not_contains: InputMaybe<Scalars['String']['input']>;
  threadsLink_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  twitterLink: InputMaybe<Scalars['String']['input']>;
  twitterLink_contains: InputMaybe<Scalars['String']['input']>;
  twitterLink_exists: InputMaybe<Scalars['Boolean']['input']>;
  twitterLink_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  twitterLink_not: InputMaybe<Scalars['String']['input']>;
  twitterLink_not_contains: InputMaybe<Scalars['String']['input']>;
  twitterLink_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  youtubeLink: InputMaybe<Scalars['String']['input']>;
  youtubeLink_contains: InputMaybe<Scalars['String']['input']>;
  youtubeLink_exists: InputMaybe<Scalars['Boolean']['input']>;
  youtubeLink_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  youtubeLink_not: InputMaybe<Scalars['String']['input']>;
  youtubeLink_not_contains: InputMaybe<Scalars['String']['input']>;
  youtubeLink_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContactLinkingCollections = {
  __typename: 'ContactLinkingCollections';
  connectWithLinkCollection: Maybe<ConnectWithLinkCollection>;
  connectWithLinkCursorCollection: Maybe<ConnectWithLinkCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type ContactLinkingCollectionsConnectWithLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ContactLinkingCollectionsConnectWithLinkCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContactLinkingCollectionsConnectWithLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ContactLinkingCollectionsConnectWithLinkCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContactLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContactLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ContactLinkingCollectionsConnectWithLinkCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ContactLinkingCollectionsConnectWithLinkCursorCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ContactOrder {
  ContactEmailsHeadlineAsc = 'contactEmailsHeadline_ASC',
  ContactEmailsHeadlineDesc = 'contactEmailsHeadline_DESC',
  FacebookLinkAsc = 'facebookLink_ASC',
  FacebookLinkDesc = 'facebookLink_DESC',
  GrantInquiriesHeadlineAsc = 'grantInquiriesHeadline_ASC',
  GrantInquiriesHeadlineDesc = 'grantInquiriesHeadline_DESC',
  InstagramLinkAsc = 'instagramLink_ASC',
  InstagramLinkDesc = 'instagramLink_DESC',
  LinkedInLinkAsc = 'linkedInLink_ASC',
  LinkedInLinkDesc = 'linkedInLink_DESC',
  OfficeAddressGoogleMapsLabelAsc = 'officeAddressGoogleMapsLabel_ASC',
  OfficeAddressGoogleMapsLabelDesc = 'officeAddressGoogleMapsLabel_DESC',
  OfficeAddressGoogleMapsLinkAsc = 'officeAddressGoogleMapsLink_ASC',
  OfficeAddressGoogleMapsLinkDesc = 'officeAddressGoogleMapsLink_DESC',
  OfficeContactInformationHeadlineAsc = 'officeContactInformationHeadline_ASC',
  OfficeContactInformationHeadlineDesc = 'officeContactInformationHeadline_DESC',
  OfficeFaxNumberAsc = 'officeFaxNumber_ASC',
  OfficeFaxNumberDesc = 'officeFaxNumber_DESC',
  OfficeTelephoneNumberAsc = 'officeTelephoneNumber_ASC',
  OfficeTelephoneNumberDesc = 'officeTelephoneNumber_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SocialMediaHeadlineAsc = 'socialMediaHeadline_ASC',
  SocialMediaHeadlineDesc = 'socialMediaHeadline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThreadsLinkAsc = 'threadsLink_ASC',
  ThreadsLinkDesc = 'threadsLink_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterLinkAsc = 'twitterLink_ASC',
  TwitterLinkDesc = 'twitterLink_DESC',
  YoutubeLinkAsc = 'youtubeLink_ASC',
  YoutubeLinkDesc = 'youtubeLink_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/contactPerson) */
export type ContactPerson = Entry & _Node & {
  __typename: 'ContactPerson';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  email: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<ContactPersonLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  role: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/contactPerson) */
export type ContactPersonEmailArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/contactPerson) */
export type ContactPersonLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/contactPerson) */
export type ContactPersonNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/contactPerson) */
export type ContactPersonPhoneArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/contactPerson) */
export type ContactPersonRoleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContactPersonCollection = {
  __typename: 'ContactPersonCollection';
  items: Array<Maybe<ContactPerson>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContactPersonCursorCollection = {
  __typename: 'ContactPersonCursorCollection';
  items: Array<Maybe<ContactPerson>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ContactPersonFilter = {
  AND: InputMaybe<Array<InputMaybe<ContactPersonFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ContactPersonFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  email: InputMaybe<Scalars['String']['input']>;
  email_contains: InputMaybe<Scalars['String']['input']>;
  email_exists: InputMaybe<Scalars['Boolean']['input']>;
  email_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email_not: InputMaybe<Scalars['String']['input']>;
  email_not_contains: InputMaybe<Scalars['String']['input']>;
  email_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phone: InputMaybe<Scalars['String']['input']>;
  phone_contains: InputMaybe<Scalars['String']['input']>;
  phone_exists: InputMaybe<Scalars['Boolean']['input']>;
  phone_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phone_not: InputMaybe<Scalars['String']['input']>;
  phone_not_contains: InputMaybe<Scalars['String']['input']>;
  phone_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  role: InputMaybe<Scalars['String']['input']>;
  role_contains: InputMaybe<Scalars['String']['input']>;
  role_exists: InputMaybe<Scalars['Boolean']['input']>;
  role_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  role_not: InputMaybe<Scalars['String']['input']>;
  role_not_contains: InputMaybe<Scalars['String']['input']>;
  role_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type ContactPersonLinkingCollections = {
  __typename: 'ContactPersonLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  pressRoomCollection: Maybe<PressRoomCollection>;
  pressRoomCursorCollection: Maybe<PressRoomCursorCollection>;
};


export type ContactPersonLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContactPersonLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContactPersonLinkingCollectionsPressRoomCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ContactPersonLinkingCollectionsPressRoomCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContactPersonLinkingCollectionsPressRoomCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ContactPersonLinkingCollectionsPressRoomCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ContactPersonLinkingCollectionsPressRoomCollectionOrder {
  ContactsTitleAsc = 'contactsTitle_ASC',
  ContactsTitleDesc = 'contactsTitle_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  EmailLabelAsc = 'emailLabel_ASC',
  EmailLabelDesc = 'emailLabel_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  GuidelinesAndMediasDescriptionAsc = 'guidelinesAndMediasDescription_ASC',
  GuidelinesAndMediasDescriptionDesc = 'guidelinesAndMediasDescription_DESC',
  GuidelinesAndMediasHeadingAsc = 'guidelinesAndMediasHeading_ASC',
  GuidelinesAndMediasHeadingDesc = 'guidelinesAndMediasHeading_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ContactPersonLinkingCollectionsPressRoomCursorCollectionOrder {
  ContactsTitleAsc = 'contactsTitle_ASC',
  ContactsTitleDesc = 'contactsTitle_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  EmailLabelAsc = 'emailLabel_ASC',
  EmailLabelDesc = 'emailLabel_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  GuidelinesAndMediasDescriptionAsc = 'guidelinesAndMediasDescription_ASC',
  GuidelinesAndMediasDescriptionDesc = 'guidelinesAndMediasDescription_DESC',
  GuidelinesAndMediasHeadingAsc = 'guidelinesAndMediasHeading_ASC',
  GuidelinesAndMediasHeadingDesc = 'guidelinesAndMediasHeading_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ContactPersonOrder {
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PhoneAsc = 'phone_ASC',
  PhoneDesc = 'phone_DESC',
  RoleAsc = 'role_ASC',
  RoleDesc = 'role_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ContactTextBlock = {
  __typename: 'ContactTextBlock';
  json: Scalars['JSON']['output'];
  links: ContactTextBlockLinks;
};

export type ContactTextBlockAssets = {
  __typename: 'ContactTextBlockAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ContactTextBlockEntries = {
  __typename: 'ContactTextBlockEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ContactTextBlockLinks = {
  __typename: 'ContactTextBlockLinks';
  assets: ContactTextBlockAssets;
  entries: ContactTextBlockEntries;
  resources: ContactTextBlockResources;
};

export type ContactTextBlockResources = {
  __typename: 'ContactTextBlockResources';
  block: Array<ContactTextBlockResourcesBlock>;
  hyperlink: Array<ContactTextBlockResourcesHyperlink>;
  inline: Array<ContactTextBlockResourcesInline>;
};

export type ContactTextBlockResourcesBlock = ResourceLink & {
  __typename: 'ContactTextBlockResourcesBlock';
  sys: ResourceSys;
};

export type ContactTextBlockResourcesHyperlink = ResourceLink & {
  __typename: 'ContactTextBlockResourcesHyperlink';
  sys: ResourceSys;
};

export type ContactTextBlockResourcesInline = ResourceLink & {
  __typename: 'ContactTextBlockResourcesInline';
  sys: ResourceSys;
};

export type ContentfulMetadata = {
  __typename: 'ContentfulMetadata';
  concepts: Array<Maybe<TaxonomyConcept>>;
  tags: Array<Maybe<ContentfulTag>>;
};

export type ContentfulMetadataConceptsDescendantsFilter = {
  id_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulMetadataConceptsFilter = {
  descendants: InputMaybe<ContentfulMetadataConceptsDescendantsFilter>;
  id_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulMetadataFilter = {
  concepts: InputMaybe<ContentfulMetadataConceptsFilter>;
  concepts_exists: InputMaybe<Scalars['Boolean']['input']>;
  tags: InputMaybe<ContentfulMetadataTagsFilter>;
  tags_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulMetadataTagsFilter = {
  id_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/**
 * Represents a tag entity for finding and organizing content easily.
 *       Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-tags
 */
export type ContentfulTag = {
  __typename: 'ContentfulTag';
  id: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type CursorPages = {
  __typename: 'CursorPages';
  next: Maybe<Scalars['String']['output']>;
  prev: Maybe<Scalars['String']['output']>;
};

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/department) */
export type Department = Entry & _Node & {
  __typename: 'Department';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<DepartmentLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/department) */
export type DepartmentLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/department) */
export type DepartmentNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type DepartmentCollection = {
  __typename: 'DepartmentCollection';
  items: Array<Maybe<Department>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type DepartmentCursorCollection = {
  __typename: 'DepartmentCursorCollection';
  items: Array<Maybe<Department>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type DepartmentFilter = {
  AND: InputMaybe<Array<InputMaybe<DepartmentFilter>>>;
  OR: InputMaybe<Array<InputMaybe<DepartmentFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type DepartmentLinkingCollections = {
  __typename: 'DepartmentLinkingCollections';
  connectWithLinkCollection: Maybe<ConnectWithLinkCollection>;
  connectWithLinkCursorCollection: Maybe<ConnectWithLinkCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  peoplePageCollection: Maybe<PeoplePageCollection>;
  peoplePageCursorCollection: Maybe<PeoplePageCursorCollection>;
  personCollection: Maybe<PersonCollection>;
  personCursorCollection: Maybe<PersonCursorCollection>;
};


export type DepartmentLinkingCollectionsConnectWithLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<DepartmentLinkingCollectionsConnectWithLinkCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type DepartmentLinkingCollectionsConnectWithLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<DepartmentLinkingCollectionsConnectWithLinkCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type DepartmentLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type DepartmentLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type DepartmentLinkingCollectionsPeoplePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<DepartmentLinkingCollectionsPeoplePageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type DepartmentLinkingCollectionsPeoplePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<DepartmentLinkingCollectionsPeoplePageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type DepartmentLinkingCollectionsPersonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<DepartmentLinkingCollectionsPersonCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type DepartmentLinkingCollectionsPersonCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<DepartmentLinkingCollectionsPersonCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum DepartmentLinkingCollectionsConnectWithLinkCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum DepartmentLinkingCollectionsConnectWithLinkCursorCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum DepartmentLinkingCollectionsPeoplePageCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TrusteesCtaLabelAsc = 'trusteesCtaLabel_ASC',
  TrusteesCtaLabelDesc = 'trusteesCtaLabel_DESC',
  TrusteesCtaTextAsc = 'trusteesCtaText_ASC',
  TrusteesCtaTextDesc = 'trusteesCtaText_DESC'
}

export enum DepartmentLinkingCollectionsPeoplePageCursorCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TrusteesCtaLabelAsc = 'trusteesCtaLabel_ASC',
  TrusteesCtaLabelDesc = 'trusteesCtaLabel_DESC',
  TrusteesCtaTextAsc = 'trusteesCtaText_ASC',
  TrusteesCtaTextDesc = 'trusteesCtaText_DESC'
}

export enum DepartmentLinkingCollectionsPersonCollectionOrder {
  FirstNameAsc = 'firstName_ASC',
  FirstNameDesc = 'firstName_DESC',
  JobTitleAsc = 'jobTitle_ASC',
  JobTitleDesc = 'jobTitle_DESC',
  LastNameAsc = 'lastName_ASC',
  LastNameDesc = 'lastName_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  RelatedSectionTitleAsc = 'relatedSectionTitle_ASC',
  RelatedSectionTitleDesc = 'relatedSectionTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum DepartmentLinkingCollectionsPersonCursorCollectionOrder {
  FirstNameAsc = 'firstName_ASC',
  FirstNameDesc = 'firstName_DESC',
  JobTitleAsc = 'jobTitle_ASC',
  JobTitleDesc = 'jobTitle_DESC',
  LastNameAsc = 'lastName_ASC',
  LastNameDesc = 'lastName_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  RelatedSectionTitleAsc = 'relatedSectionTitle_ASC',
  RelatedSectionTitleDesc = 'relatedSectionTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum DepartmentOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/dropCap) */
export type DropCap = Entry & _Node & {
  __typename: 'DropCap';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<DropCapLinkingCollections>;
  sys: Sys;
  text: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/dropCap) */
export type DropCapLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/dropCap) */
export type DropCapTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type DropCapCollection = {
  __typename: 'DropCapCollection';
  items: Array<Maybe<DropCap>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type DropCapCursorCollection = {
  __typename: 'DropCapCursorCollection';
  items: Array<Maybe<DropCap>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type DropCapFilter = {
  AND: InputMaybe<Array<InputMaybe<DropCapFilter>>>;
  OR: InputMaybe<Array<InputMaybe<DropCapFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
  text: InputMaybe<Scalars['String']['input']>;
  text_contains: InputMaybe<Scalars['String']['input']>;
  text_exists: InputMaybe<Scalars['Boolean']['input']>;
  text_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text_not: InputMaybe<Scalars['String']['input']>;
  text_not_contains: InputMaybe<Scalars['String']['input']>;
  text_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DropCapLinkingCollections = {
  __typename: 'DropCapLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type DropCapLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type DropCapLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum DropCapOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/emphasizedArticle) */
export type EmphasizedArticle = Entry & _Node & {
  __typename: 'EmphasizedArticle';
  _id: Scalars['ID']['output'];
  article: Maybe<EmphasizedArticleArticle>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<EmphasizedArticleLinkingCollections>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/emphasizedArticle) */
export type EmphasizedArticleArticleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<EmphasizedArticleArticleFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/emphasizedArticle) */
export type EmphasizedArticleLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/emphasizedArticle) */
export type EmphasizedArticleTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmphasizedArticleArticle = Article | GrantActivityArticle;

export type EmphasizedArticleArticleFilter = {
  AND: InputMaybe<Array<InputMaybe<EmphasizedArticleArticleFilter>>>;
  OR: InputMaybe<Array<InputMaybe<EmphasizedArticleArticleFilter>>>;
  audio_exists: InputMaybe<Scalars['Boolean']['input']>;
  author: InputMaybe<Scalars['String']['input']>;
  author_contains: InputMaybe<Scalars['String']['input']>;
  author_exists: InputMaybe<Scalars['Boolean']['input']>;
  author_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  author_not: InputMaybe<Scalars['String']['input']>;
  author_not_contains: InputMaybe<Scalars['String']['input']>;
  author_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_contains: InputMaybe<Scalars['String']['input']>;
  body_exists: InputMaybe<Scalars['Boolean']['input']>;
  body_not_contains: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  creditLabel: InputMaybe<Scalars['String']['input']>;
  creditLabel_contains: InputMaybe<Scalars['String']['input']>;
  creditLabel_exists: InputMaybe<Scalars['Boolean']['input']>;
  creditLabel_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  creditLabel_not: InputMaybe<Scalars['String']['input']>;
  creditLabel_not_contains: InputMaybe<Scalars['String']['input']>;
  creditLabel_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  creditText: InputMaybe<Scalars['String']['input']>;
  creditText_contains: InputMaybe<Scalars['String']['input']>;
  creditText_exists: InputMaybe<Scalars['Boolean']['input']>;
  creditText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  creditText_not: InputMaybe<Scalars['String']['input']>;
  creditText_not_contains: InputMaybe<Scalars['String']['input']>;
  creditText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  date: InputMaybe<Scalars['DateTime']['input']>;
  date_exists: InputMaybe<Scalars['Boolean']['input']>;
  date_gt: InputMaybe<Scalars['DateTime']['input']>;
  date_gte: InputMaybe<Scalars['DateTime']['input']>;
  date_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_lt: InputMaybe<Scalars['DateTime']['input']>;
  date_lte: InputMaybe<Scalars['DateTime']['input']>;
  date_not: InputMaybe<Scalars['DateTime']['input']>;
  date_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattingOptions_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattingOptions_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattingOptions_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattingOptions_exists: InputMaybe<Scalars['Boolean']['input']>;
  hero_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideDate: InputMaybe<Scalars['Boolean']['input']>;
  hideDate_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideDate_not: InputMaybe<Scalars['Boolean']['input']>;
  hideShareLink: InputMaybe<Scalars['Boolean']['input']>;
  hideShareLink_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideShareLink_not: InputMaybe<Scalars['Boolean']['input']>;
  metadata_exists: InputMaybe<Scalars['Boolean']['input']>;
  photographer: InputMaybe<Scalars['String']['input']>;
  photographer_contains: InputMaybe<Scalars['String']['input']>;
  photographer_exists: InputMaybe<Scalars['Boolean']['input']>;
  photographer_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  photographer_not: InputMaybe<Scalars['String']['input']>;
  photographer_not_contains: InputMaybe<Scalars['String']['input']>;
  photographer_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  thumbnailImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type EmphasizedArticleCollection = {
  __typename: 'EmphasizedArticleCollection';
  items: Array<Maybe<EmphasizedArticle>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type EmphasizedArticleCursorCollection = {
  __typename: 'EmphasizedArticleCursorCollection';
  items: Array<Maybe<EmphasizedArticle>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type EmphasizedArticleFilter = {
  AND: InputMaybe<Array<InputMaybe<EmphasizedArticleFilter>>>;
  OR: InputMaybe<Array<InputMaybe<EmphasizedArticleFilter>>>;
  article: InputMaybe<CfarticleMultiTypeNestedFilter>;
  article_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type EmphasizedArticleLinkingCollections = {
  __typename: 'EmphasizedArticleLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  homePageCollection: Maybe<HomePageCollection>;
  homePageCursorCollection: Maybe<HomePageCursorCollection>;
  ideaCollection: Maybe<IdeaCollection>;
  ideaCursorCollection: Maybe<IdeaCursorCollection>;
  inlineCardsCollection: Maybe<InlineCardsCollection>;
  inlineCardsCursorCollection: Maybe<InlineCardsCursorCollection>;
};


export type EmphasizedArticleLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type EmphasizedArticleLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type EmphasizedArticleLinkingCollectionsHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<EmphasizedArticleLinkingCollectionsHomePageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type EmphasizedArticleLinkingCollectionsHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<EmphasizedArticleLinkingCollectionsHomePageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type EmphasizedArticleLinkingCollectionsIdeaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<EmphasizedArticleLinkingCollectionsIdeaCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type EmphasizedArticleLinkingCollectionsIdeaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<EmphasizedArticleLinkingCollectionsIdeaCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type EmphasizedArticleLinkingCollectionsInlineCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<EmphasizedArticleLinkingCollectionsInlineCardsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type EmphasizedArticleLinkingCollectionsInlineCardsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<EmphasizedArticleLinkingCollectionsInlineCardsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum EmphasizedArticleLinkingCollectionsHomePageCollectionOrder {
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  MissionTextAsc = 'missionText_ASC',
  MissionTextDesc = 'missionText_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StoriesCtaAsc = 'storiesCta_ASC',
  StoriesCtaDesc = 'storiesCta_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum EmphasizedArticleLinkingCollectionsHomePageCursorCollectionOrder {
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  MissionTextAsc = 'missionText_ASC',
  MissionTextDesc = 'missionText_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StoriesCtaAsc = 'storiesCta_ASC',
  StoriesCtaDesc = 'storiesCta_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum EmphasizedArticleLinkingCollectionsIdeaCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum EmphasizedArticleLinkingCollectionsIdeaCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum EmphasizedArticleLinkingCollectionsInlineCardsCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum EmphasizedArticleLinkingCollectionsInlineCardsCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum EmphasizedArticleOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type Entry = {
  contentfulMetadata: ContentfulMetadata;
  sys: Sys;
};

export type EntryCollection = {
  __typename: 'EntryCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type EntryCursorCollection = {
  __typename: 'EntryCursorCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type EntryFilter = {
  AND: InputMaybe<Array<InputMaybe<EntryFilter>>>;
  OR: InputMaybe<Array<InputMaybe<EntryFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
};

export enum EntryOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/eventsPage) */
export type EventsPage = Entry & _Node & {
  __typename: 'EventsPage';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  description: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<EventsPageLinkingCollections>;
  navigationImagePortrait: Maybe<Asset>;
  newsletter: Maybe<NewsletterCard>;
  slug: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
  upcomingEventsCollection: Maybe<EventsPageUpcomingEventsCollection>;
  upcomingEventsCursorCollection: Maybe<EventsPageUpcomingEventsCursorCollection>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/eventsPage) */
export type EventsPageDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/eventsPage) */
export type EventsPageLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/eventsPage) */
export type EventsPageNavigationImagePortraitArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/eventsPage) */
export type EventsPageNewsletterArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<NewsletterCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/eventsPage) */
export type EventsPageSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/eventsPage) */
export type EventsPageTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/eventsPage) */
export type EventsPageUpcomingEventsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<EventsPageUpcomingEventsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ExternalEventFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/eventsPage) */
export type EventsPageUpcomingEventsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<EventsPageUpcomingEventsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ExternalEventFilter>;
};

export type EventsPageCollection = {
  __typename: 'EventsPageCollection';
  items: Array<Maybe<EventsPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type EventsPageCursorCollection = {
  __typename: 'EventsPageCursorCollection';
  items: Array<Maybe<EventsPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type EventsPageFilter = {
  AND: InputMaybe<Array<InputMaybe<EventsPageFilter>>>;
  OR: InputMaybe<Array<InputMaybe<EventsPageFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navigationImagePortrait_exists: InputMaybe<Scalars['Boolean']['input']>;
  newsletter: InputMaybe<CfNewsletterCardNestedFilter>;
  newsletter_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  upcomingEvents: InputMaybe<CfExternalEventNestedFilter>;
  upcomingEventsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventsPageLinkingCollections = {
  __typename: 'EventsPageLinkingCollections';
  connectWithLinkCollection: Maybe<ConnectWithLinkCollection>;
  connectWithLinkCursorCollection: Maybe<ConnectWithLinkCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  mainNavigationCollection: Maybe<MainNavigationCollection>;
  mainNavigationCursorCollection: Maybe<MainNavigationCursorCollection>;
};


export type EventsPageLinkingCollectionsConnectWithLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<EventsPageLinkingCollectionsConnectWithLinkCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type EventsPageLinkingCollectionsConnectWithLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<EventsPageLinkingCollectionsConnectWithLinkCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type EventsPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type EventsPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type EventsPageLinkingCollectionsMainNavigationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<EventsPageLinkingCollectionsMainNavigationCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type EventsPageLinkingCollectionsMainNavigationCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<EventsPageLinkingCollectionsMainNavigationCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum EventsPageLinkingCollectionsConnectWithLinkCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum EventsPageLinkingCollectionsConnectWithLinkCursorCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum EventsPageLinkingCollectionsMainNavigationCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum EventsPageLinkingCollectionsMainNavigationCursorCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum EventsPageOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type EventsPageUpcomingEventsCollection = {
  __typename: 'EventsPageUpcomingEventsCollection';
  items: Array<Maybe<ExternalEvent>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum EventsPageUpcomingEventsCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  EndTimeAsc = 'endTime_ASC',
  EndTimeDesc = 'endTime_DESC',
  EventTypeAsc = 'eventType_ASC',
  EventTypeDesc = 'eventType_DESC',
  LinkAsc = 'link_ASC',
  LinkDesc = 'link_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  StartTimeAsc = 'startTime_ASC',
  StartTimeDesc = 'startTime_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TimeZoneAsc = 'timeZone_ASC',
  TimeZoneDesc = 'timeZone_DESC'
}

export type EventsPageUpcomingEventsCursorCollection = {
  __typename: 'EventsPageUpcomingEventsCursorCollection';
  items: Array<Maybe<ExternalEvent>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum EventsPageUpcomingEventsCursorCollectionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  EndTimeAsc = 'endTime_ASC',
  EndTimeDesc = 'endTime_DESC',
  EventTypeAsc = 'eventType_ASC',
  EventTypeDesc = 'eventType_DESC',
  LinkAsc = 'link_ASC',
  LinkDesc = 'link_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  StartTimeAsc = 'startTime_ASC',
  StartTimeDesc = 'startTime_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TimeZoneAsc = 'timeZone_ASC',
  TimeZoneDesc = 'timeZone_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/experienceBlock) */
export type ExperienceBlock = Entry & _Node & {
  __typename: 'ExperienceBlock';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  devNotesAboutThisBlock: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  json: Maybe<Scalars['JSON']['output']>;
  linkedFrom: Maybe<ExperienceBlockLinkingCollections>;
  mediaCollection: Maybe<AssetCollection>;
  mediaCursorCollection: Maybe<AssetCursorCollection>;
  referencesCollection: Maybe<ExperienceBlockReferencesCollection>;
  referencesCursorCollection: Maybe<ExperienceBlockReferencesCursorCollection>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/experienceBlock) */
export type ExperienceBlockDevNotesAboutThisBlockArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/experienceBlock) */
export type ExperienceBlockIdArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/experienceBlock) */
export type ExperienceBlockJsonArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/experienceBlock) */
export type ExperienceBlockLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/experienceBlock) */
export type ExperienceBlockMediaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/experienceBlock) */
export type ExperienceBlockMediaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/experienceBlock) */
export type ExperienceBlockReferencesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ExperienceBlockReferencesFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/experienceBlock) */
export type ExperienceBlockReferencesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ExperienceBlockReferencesFilter>;
};

export type ExperienceBlockCollection = {
  __typename: 'ExperienceBlockCollection';
  items: Array<Maybe<ExperienceBlock>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ExperienceBlockCursorCollection = {
  __typename: 'ExperienceBlockCursorCollection';
  items: Array<Maybe<ExperienceBlock>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ExperienceBlockFilter = {
  AND: InputMaybe<Array<InputMaybe<ExperienceBlockFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ExperienceBlockFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  devNotesAboutThisBlock: InputMaybe<Scalars['String']['input']>;
  devNotesAboutThisBlock_contains: InputMaybe<Scalars['String']['input']>;
  devNotesAboutThisBlock_exists: InputMaybe<Scalars['Boolean']['input']>;
  devNotesAboutThisBlock_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  devNotesAboutThisBlock_not: InputMaybe<Scalars['String']['input']>;
  devNotesAboutThisBlock_not_contains: InputMaybe<Scalars['String']['input']>;
  devNotesAboutThisBlock_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id: InputMaybe<Scalars['String']['input']>;
  id_contains: InputMaybe<Scalars['String']['input']>;
  id_exists: InputMaybe<Scalars['Boolean']['input']>;
  id_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not: InputMaybe<Scalars['String']['input']>;
  id_not_contains: InputMaybe<Scalars['String']['input']>;
  id_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  json_exists: InputMaybe<Scalars['Boolean']['input']>;
  mediaCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  references: InputMaybe<CfreferencesMultiTypeNestedFilter>;
  referencesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
};

export type ExperienceBlockLinkingCollections = {
  __typename: 'ExperienceBlockLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  featureCollection: Maybe<FeatureCollection>;
  featureCursorCollection: Maybe<FeatureCursorCollection>;
  grantActivityArticleCollection: Maybe<GrantActivityArticleCollection>;
  grantActivityArticleCursorCollection: Maybe<GrantActivityArticleCursorCollection>;
};


export type ExperienceBlockLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExperienceBlockLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExperienceBlockLinkingCollectionsFeatureCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ExperienceBlockLinkingCollectionsFeatureCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExperienceBlockLinkingCollectionsFeatureCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ExperienceBlockLinkingCollectionsFeatureCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExperienceBlockLinkingCollectionsGrantActivityArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ExperienceBlockLinkingCollectionsGrantActivityArticleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExperienceBlockLinkingCollectionsGrantActivityArticleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ExperienceBlockLinkingCollectionsGrantActivityArticleCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ExperienceBlockLinkingCollectionsFeatureCollectionOrder {
  DateTimeAsc = 'dateTime_ASC',
  DateTimeDesc = 'dateTime_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  ShowSocialCtasAsc = 'showSocialCtas_ASC',
  ShowSocialCtasDesc = 'showSocialCtas_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TaglineAsc = 'tagline_ASC',
  TaglineDesc = 'tagline_DESC'
}

export enum ExperienceBlockLinkingCollectionsFeatureCursorCollectionOrder {
  DateTimeAsc = 'dateTime_ASC',
  DateTimeDesc = 'dateTime_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  ShowSocialCtasAsc = 'showSocialCtas_ASC',
  ShowSocialCtasDesc = 'showSocialCtas_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TaglineAsc = 'tagline_ASC',
  TaglineDesc = 'tagline_DESC'
}

export enum ExperienceBlockLinkingCollectionsGrantActivityArticleCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  GranteeCityOverrideAsc = 'granteeCityOverride_ASC',
  GranteeCityOverrideDesc = 'granteeCityOverride_DESC',
  GranteeCountryOverrideAsc = 'granteeCountryOverride_ASC',
  GranteeCountryOverrideDesc = 'granteeCountryOverride_DESC',
  GranteeNameOverrideAsc = 'granteeNameOverride_ASC',
  GranteeNameOverrideDesc = 'granteeNameOverride_DESC',
  GranteeStateOverrideAsc = 'granteeStateOverride_ASC',
  GranteeStateOverrideDesc = 'granteeStateOverride_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ExperienceBlockLinkingCollectionsGrantActivityArticleCursorCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  GranteeCityOverrideAsc = 'granteeCityOverride_ASC',
  GranteeCityOverrideDesc = 'granteeCityOverride_DESC',
  GranteeCountryOverrideAsc = 'granteeCountryOverride_ASC',
  GranteeCountryOverrideDesc = 'granteeCountryOverride_DESC',
  GranteeNameOverrideAsc = 'granteeNameOverride_ASC',
  GranteeNameOverrideDesc = 'granteeNameOverride_DESC',
  GranteeStateOverrideAsc = 'granteeStateOverride_ASC',
  GranteeStateOverrideDesc = 'granteeStateOverride_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ExperienceBlockOrder {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ExperienceBlockReferencesCollection = {
  __typename: 'ExperienceBlockReferencesCollection';
  items: Array<Maybe<ExperienceBlockReferencesItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ExperienceBlockReferencesCursorCollection = {
  __typename: 'ExperienceBlockReferencesCursorCollection';
  items: Array<Maybe<ExperienceBlockReferencesItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ExperienceBlockReferencesFilter = {
  AND: InputMaybe<Array<InputMaybe<ExperienceBlockReferencesFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ExperienceBlockReferencesFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ExperienceBlockReferencesItem = Article | VideoNative;

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/explicitValueFilter) */
export type ExplicitValueFilter = Entry & _Node & {
  __typename: 'ExplicitValueFilter';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<ExplicitValueFilterLinkingCollections>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/explicitValueFilter) */
export type ExplicitValueFilterLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/explicitValueFilter) */
export type ExplicitValueFilterTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/explicitValueFilter) */
export type ExplicitValueFilterTypeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/explicitValueFilter) */
export type ExplicitValueFilterValueArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExplicitValueFilterCollection = {
  __typename: 'ExplicitValueFilterCollection';
  items: Array<Maybe<ExplicitValueFilter>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ExplicitValueFilterCursorCollection = {
  __typename: 'ExplicitValueFilterCursorCollection';
  items: Array<Maybe<ExplicitValueFilter>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ExplicitValueFilterFilter = {
  AND: InputMaybe<Array<InputMaybe<ExplicitValueFilterFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ExplicitValueFilterFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type: InputMaybe<Scalars['String']['input']>;
  type_contains: InputMaybe<Scalars['String']['input']>;
  type_exists: InputMaybe<Scalars['Boolean']['input']>;
  type_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not: InputMaybe<Scalars['String']['input']>;
  type_not_contains: InputMaybe<Scalars['String']['input']>;
  type_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value: InputMaybe<Scalars['String']['input']>;
  value_contains: InputMaybe<Scalars['String']['input']>;
  value_exists: InputMaybe<Scalars['Boolean']['input']>;
  value_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not: InputMaybe<Scalars['String']['input']>;
  value_not_contains: InputMaybe<Scalars['String']['input']>;
  value_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ExplicitValueFilterLinkingCollections = {
  __typename: 'ExplicitValueFilterLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  grantSearchFiltersCollection: Maybe<GrantSearchFiltersCollection>;
  grantSearchFiltersCursorCollection: Maybe<GrantSearchFiltersCursorCollection>;
};


export type ExplicitValueFilterLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExplicitValueFilterLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExplicitValueFilterLinkingCollectionsGrantSearchFiltersCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ExplicitValueFilterLinkingCollectionsGrantSearchFiltersCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExplicitValueFilterLinkingCollectionsGrantSearchFiltersCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ExplicitValueFilterLinkingCollectionsGrantSearchFiltersCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ExplicitValueFilterLinkingCollectionsGrantSearchFiltersCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ExplicitValueFilterLinkingCollectionsGrantSearchFiltersCursorCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ExplicitValueFilterOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  ValueAsc = 'value_ASC',
  ValueDesc = 'value_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/externalEvent) */
export type ExternalEvent = Entry & _Node & {
  __typename: 'ExternalEvent';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  date: Maybe<Scalars['DateTime']['output']>;
  endTime: Maybe<Scalars['String']['output']>;
  eventType: Maybe<Scalars['String']['output']>;
  link: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<ExternalEventLinkingCollections>;
  logo: Maybe<Asset>;
  name: Maybe<Scalars['String']['output']>;
  startTime: Maybe<Scalars['String']['output']>;
  sys: Sys;
  timeZone: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/externalEvent) */
export type ExternalEventDateArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/externalEvent) */
export type ExternalEventEndTimeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/externalEvent) */
export type ExternalEventEventTypeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/externalEvent) */
export type ExternalEventLinkArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/externalEvent) */
export type ExternalEventLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/externalEvent) */
export type ExternalEventLogoArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/externalEvent) */
export type ExternalEventNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/externalEvent) */
export type ExternalEventStartTimeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/externalEvent) */
export type ExternalEventTimeZoneArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExternalEventCollection = {
  __typename: 'ExternalEventCollection';
  items: Array<Maybe<ExternalEvent>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ExternalEventCursorCollection = {
  __typename: 'ExternalEventCursorCollection';
  items: Array<Maybe<ExternalEvent>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ExternalEventFilter = {
  AND: InputMaybe<Array<InputMaybe<ExternalEventFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ExternalEventFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  date: InputMaybe<Scalars['DateTime']['input']>;
  date_exists: InputMaybe<Scalars['Boolean']['input']>;
  date_gt: InputMaybe<Scalars['DateTime']['input']>;
  date_gte: InputMaybe<Scalars['DateTime']['input']>;
  date_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_lt: InputMaybe<Scalars['DateTime']['input']>;
  date_lte: InputMaybe<Scalars['DateTime']['input']>;
  date_not: InputMaybe<Scalars['DateTime']['input']>;
  date_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  endTime: InputMaybe<Scalars['String']['input']>;
  endTime_contains: InputMaybe<Scalars['String']['input']>;
  endTime_exists: InputMaybe<Scalars['Boolean']['input']>;
  endTime_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endTime_not: InputMaybe<Scalars['String']['input']>;
  endTime_not_contains: InputMaybe<Scalars['String']['input']>;
  endTime_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eventType: InputMaybe<Scalars['String']['input']>;
  eventType_contains: InputMaybe<Scalars['String']['input']>;
  eventType_exists: InputMaybe<Scalars['Boolean']['input']>;
  eventType_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eventType_not: InputMaybe<Scalars['String']['input']>;
  eventType_not_contains: InputMaybe<Scalars['String']['input']>;
  eventType_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  link: InputMaybe<Scalars['String']['input']>;
  link_contains: InputMaybe<Scalars['String']['input']>;
  link_exists: InputMaybe<Scalars['Boolean']['input']>;
  link_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  link_not: InputMaybe<Scalars['String']['input']>;
  link_not_contains: InputMaybe<Scalars['String']['input']>;
  link_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logo_exists: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startTime: InputMaybe<Scalars['String']['input']>;
  startTime_contains: InputMaybe<Scalars['String']['input']>;
  startTime_exists: InputMaybe<Scalars['Boolean']['input']>;
  startTime_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startTime_not: InputMaybe<Scalars['String']['input']>;
  startTime_not_contains: InputMaybe<Scalars['String']['input']>;
  startTime_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  timeZone: InputMaybe<Scalars['String']['input']>;
  timeZone_contains: InputMaybe<Scalars['String']['input']>;
  timeZone_exists: InputMaybe<Scalars['Boolean']['input']>;
  timeZone_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timeZone_not: InputMaybe<Scalars['String']['input']>;
  timeZone_not_contains: InputMaybe<Scalars['String']['input']>;
  timeZone_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ExternalEventLinkingCollections = {
  __typename: 'ExternalEventLinkingCollections';
  articleCollection: Maybe<ArticleCollection>;
  articleCursorCollection: Maybe<ArticleCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  eventsPageCollection: Maybe<EventsPageCollection>;
  eventsPageCursorCollection: Maybe<EventsPageCursorCollection>;
  featureCollection: Maybe<FeatureCollection>;
  featureCursorCollection: Maybe<FeatureCursorCollection>;
  grantActivityArticleCollection: Maybe<GrantActivityArticleCollection>;
  grantActivityArticleCursorCollection: Maybe<GrantActivityArticleCursorCollection>;
  homePageCollection: Maybe<HomePageCollection>;
  homePageCursorCollection: Maybe<HomePageCursorCollection>;
  ideaCollection: Maybe<IdeaCollection>;
  ideaCursorCollection: Maybe<IdeaCursorCollection>;
  inlineCardsCollection: Maybe<InlineCardsCollection>;
  inlineCardsCursorCollection: Maybe<InlineCardsCursorCollection>;
  mmufCollection: Maybe<MmufCollection>;
  mmufCursorCollection: Maybe<MmufCursorCollection>;
};


export type ExternalEventLinkingCollectionsArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ExternalEventLinkingCollectionsArticleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExternalEventLinkingCollectionsArticleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ExternalEventLinkingCollectionsArticleCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExternalEventLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExternalEventLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExternalEventLinkingCollectionsEventsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ExternalEventLinkingCollectionsEventsPageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExternalEventLinkingCollectionsEventsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ExternalEventLinkingCollectionsEventsPageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExternalEventLinkingCollectionsFeatureCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ExternalEventLinkingCollectionsFeatureCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExternalEventLinkingCollectionsFeatureCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ExternalEventLinkingCollectionsFeatureCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExternalEventLinkingCollectionsGrantActivityArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ExternalEventLinkingCollectionsGrantActivityArticleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExternalEventLinkingCollectionsGrantActivityArticleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ExternalEventLinkingCollectionsGrantActivityArticleCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExternalEventLinkingCollectionsHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ExternalEventLinkingCollectionsHomePageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExternalEventLinkingCollectionsHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ExternalEventLinkingCollectionsHomePageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExternalEventLinkingCollectionsIdeaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ExternalEventLinkingCollectionsIdeaCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExternalEventLinkingCollectionsIdeaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ExternalEventLinkingCollectionsIdeaCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExternalEventLinkingCollectionsInlineCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ExternalEventLinkingCollectionsInlineCardsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExternalEventLinkingCollectionsInlineCardsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ExternalEventLinkingCollectionsInlineCardsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExternalEventLinkingCollectionsMmufCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ExternalEventLinkingCollectionsMmufCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExternalEventLinkingCollectionsMmufCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ExternalEventLinkingCollectionsMmufCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ExternalEventLinkingCollectionsArticleCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  ExternalNewsUrlAsc = 'externalNewsUrl_ASC',
  ExternalNewsUrlDesc = 'externalNewsUrl_DESC',
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  PasswordAsc = 'password_ASC',
  PasswordDesc = 'password_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum ExternalEventLinkingCollectionsArticleCursorCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  ExternalNewsUrlAsc = 'externalNewsUrl_ASC',
  ExternalNewsUrlDesc = 'externalNewsUrl_DESC',
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  PasswordAsc = 'password_ASC',
  PasswordDesc = 'password_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum ExternalEventLinkingCollectionsEventsPageCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ExternalEventLinkingCollectionsEventsPageCursorCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ExternalEventLinkingCollectionsFeatureCollectionOrder {
  DateTimeAsc = 'dateTime_ASC',
  DateTimeDesc = 'dateTime_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  ShowSocialCtasAsc = 'showSocialCtas_ASC',
  ShowSocialCtasDesc = 'showSocialCtas_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TaglineAsc = 'tagline_ASC',
  TaglineDesc = 'tagline_DESC'
}

export enum ExternalEventLinkingCollectionsFeatureCursorCollectionOrder {
  DateTimeAsc = 'dateTime_ASC',
  DateTimeDesc = 'dateTime_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  ShowSocialCtasAsc = 'showSocialCtas_ASC',
  ShowSocialCtasDesc = 'showSocialCtas_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TaglineAsc = 'tagline_ASC',
  TaglineDesc = 'tagline_DESC'
}

export enum ExternalEventLinkingCollectionsGrantActivityArticleCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  GranteeCityOverrideAsc = 'granteeCityOverride_ASC',
  GranteeCityOverrideDesc = 'granteeCityOverride_DESC',
  GranteeCountryOverrideAsc = 'granteeCountryOverride_ASC',
  GranteeCountryOverrideDesc = 'granteeCountryOverride_DESC',
  GranteeNameOverrideAsc = 'granteeNameOverride_ASC',
  GranteeNameOverrideDesc = 'granteeNameOverride_DESC',
  GranteeStateOverrideAsc = 'granteeStateOverride_ASC',
  GranteeStateOverrideDesc = 'granteeStateOverride_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ExternalEventLinkingCollectionsGrantActivityArticleCursorCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  GranteeCityOverrideAsc = 'granteeCityOverride_ASC',
  GranteeCityOverrideDesc = 'granteeCityOverride_DESC',
  GranteeCountryOverrideAsc = 'granteeCountryOverride_ASC',
  GranteeCountryOverrideDesc = 'granteeCountryOverride_DESC',
  GranteeNameOverrideAsc = 'granteeNameOverride_ASC',
  GranteeNameOverrideDesc = 'granteeNameOverride_DESC',
  GranteeStateOverrideAsc = 'granteeStateOverride_ASC',
  GranteeStateOverrideDesc = 'granteeStateOverride_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ExternalEventLinkingCollectionsHomePageCollectionOrder {
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  MissionTextAsc = 'missionText_ASC',
  MissionTextDesc = 'missionText_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StoriesCtaAsc = 'storiesCta_ASC',
  StoriesCtaDesc = 'storiesCta_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ExternalEventLinkingCollectionsHomePageCursorCollectionOrder {
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  MissionTextAsc = 'missionText_ASC',
  MissionTextDesc = 'missionText_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StoriesCtaAsc = 'storiesCta_ASC',
  StoriesCtaDesc = 'storiesCta_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ExternalEventLinkingCollectionsIdeaCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ExternalEventLinkingCollectionsIdeaCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ExternalEventLinkingCollectionsInlineCardsCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ExternalEventLinkingCollectionsInlineCardsCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ExternalEventLinkingCollectionsMmufCollectionOrder {
  ArticleTitleAsc = 'articleTitle_ASC',
  ArticleTitleDesc = 'articleTitle_DESC',
  AtGlanceTitleAsc = 'atGlanceTitle_ASC',
  AtGlanceTitleDesc = 'atGlanceTitle_DESC',
  ContactEmailAsc = 'contactEmail_ASC',
  ContactEmailDesc = 'contactEmail_DESC',
  ContactMessageAsc = 'contactMessage_ASC',
  ContactMessageDesc = 'contactMessage_DESC',
  ContactTitleAsc = 'contactTitle_ASC',
  ContactTitleDesc = 'contactTitle_DESC',
  FellowStoriesCtaLabelAsc = 'fellowStoriesCtaLabel_ASC',
  FellowStoriesCtaLabelDesc = 'fellowStoriesCtaLabel_DESC',
  FellowStoriesMessageAsc = 'fellowStoriesMessage_ASC',
  FellowStoriesMessageDesc = 'fellowStoriesMessage_DESC',
  GraduateInitiativesTitleAsc = 'graduateInitiativesTitle_ASC',
  GraduateInitiativesTitleDesc = 'graduateInitiativesTitle_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ExternalEventLinkingCollectionsMmufCursorCollectionOrder {
  ArticleTitleAsc = 'articleTitle_ASC',
  ArticleTitleDesc = 'articleTitle_DESC',
  AtGlanceTitleAsc = 'atGlanceTitle_ASC',
  AtGlanceTitleDesc = 'atGlanceTitle_DESC',
  ContactEmailAsc = 'contactEmail_ASC',
  ContactEmailDesc = 'contactEmail_DESC',
  ContactMessageAsc = 'contactMessage_ASC',
  ContactMessageDesc = 'contactMessage_DESC',
  ContactTitleAsc = 'contactTitle_ASC',
  ContactTitleDesc = 'contactTitle_DESC',
  FellowStoriesCtaLabelAsc = 'fellowStoriesCtaLabel_ASC',
  FellowStoriesCtaLabelDesc = 'fellowStoriesCtaLabel_DESC',
  FellowStoriesMessageAsc = 'fellowStoriesMessage_ASC',
  FellowStoriesMessageDesc = 'fellowStoriesMessage_DESC',
  GraduateInitiativesTitleAsc = 'graduateInitiativesTitle_ASC',
  GraduateInitiativesTitleDesc = 'graduateInitiativesTitle_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ExternalEventOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  EndTimeAsc = 'endTime_ASC',
  EndTimeDesc = 'endTime_DESC',
  EventTypeAsc = 'eventType_ASC',
  EventTypeDesc = 'eventType_DESC',
  LinkAsc = 'link_ASC',
  LinkDesc = 'link_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  StartTimeAsc = 'startTime_ASC',
  StartTimeDesc = 'startTime_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TimeZoneAsc = 'timeZone_ASC',
  TimeZoneDesc = 'timeZone_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/externalPerson) */
export type ExternalPerson = Entry & _Node & {
  __typename: 'ExternalPerson';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  image: Maybe<Asset>;
  jobTitle: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<ExternalPersonLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  organization: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/externalPerson) */
export type ExternalPersonImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/externalPerson) */
export type ExternalPersonJobTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/externalPerson) */
export type ExternalPersonLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/externalPerson) */
export type ExternalPersonNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/externalPerson) */
export type ExternalPersonOrganizationArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExternalPersonCollection = {
  __typename: 'ExternalPersonCollection';
  items: Array<Maybe<ExternalPerson>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ExternalPersonCursorCollection = {
  __typename: 'ExternalPersonCursorCollection';
  items: Array<Maybe<ExternalPerson>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ExternalPersonFilter = {
  AND: InputMaybe<Array<InputMaybe<ExternalPersonFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ExternalPersonFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  image_exists: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle: InputMaybe<Scalars['String']['input']>;
  jobTitle_contains: InputMaybe<Scalars['String']['input']>;
  jobTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  jobTitle_not: InputMaybe<Scalars['String']['input']>;
  jobTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  jobTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organization: InputMaybe<Scalars['String']['input']>;
  organization_contains: InputMaybe<Scalars['String']['input']>;
  organization_exists: InputMaybe<Scalars['Boolean']['input']>;
  organization_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organization_not: InputMaybe<Scalars['String']['input']>;
  organization_not_contains: InputMaybe<Scalars['String']['input']>;
  organization_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type ExternalPersonLinkingCollections = {
  __typename: 'ExternalPersonLinkingCollections';
  articleCollection: Maybe<ArticleCollection>;
  articleCursorCollection: Maybe<ArticleCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type ExternalPersonLinkingCollectionsArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ExternalPersonLinkingCollectionsArticleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExternalPersonLinkingCollectionsArticleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ExternalPersonLinkingCollectionsArticleCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExternalPersonLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExternalPersonLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ExternalPersonLinkingCollectionsArticleCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  ExternalNewsUrlAsc = 'externalNewsUrl_ASC',
  ExternalNewsUrlDesc = 'externalNewsUrl_DESC',
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  PasswordAsc = 'password_ASC',
  PasswordDesc = 'password_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum ExternalPersonLinkingCollectionsArticleCursorCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  ExternalNewsUrlAsc = 'externalNewsUrl_ASC',
  ExternalNewsUrlDesc = 'externalNewsUrl_DESC',
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  PasswordAsc = 'password_ASC',
  PasswordDesc = 'password_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum ExternalPersonOrder {
  JobTitleAsc = 'jobTitle_ASC',
  JobTitleDesc = 'jobTitle_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  OrganizationAsc = 'organization_ASC',
  OrganizationDesc = 'organization_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/faq) */
export type Faq = Entry & _Node & {
  __typename: 'Faq';
  _id: Scalars['ID']['output'];
  answer: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<FaqLinkingCollections>;
  question: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/faq) */
export type FaqAnswerArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/faq) */
export type FaqLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/faq) */
export type FaqQuestionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type FaqCollection = {
  __typename: 'FaqCollection';
  items: Array<Maybe<Faq>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type FaqCursorCollection = {
  __typename: 'FaqCursorCollection';
  items: Array<Maybe<Faq>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type FaqFilter = {
  AND: InputMaybe<Array<InputMaybe<FaqFilter>>>;
  OR: InputMaybe<Array<InputMaybe<FaqFilter>>>;
  answer: InputMaybe<Scalars['String']['input']>;
  answer_contains: InputMaybe<Scalars['String']['input']>;
  answer_exists: InputMaybe<Scalars['Boolean']['input']>;
  answer_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  answer_not: InputMaybe<Scalars['String']['input']>;
  answer_not_contains: InputMaybe<Scalars['String']['input']>;
  answer_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  question: InputMaybe<Scalars['String']['input']>;
  question_contains: InputMaybe<Scalars['String']['input']>;
  question_exists: InputMaybe<Scalars['Boolean']['input']>;
  question_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  question_not: InputMaybe<Scalars['String']['input']>;
  question_not_contains: InputMaybe<Scalars['String']['input']>;
  question_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type FaqLinkingCollections = {
  __typename: 'FaqLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  faqsModuleCollection: Maybe<FaqsModuleCollection>;
  faqsModuleCursorCollection: Maybe<FaqsModuleCursorCollection>;
};


export type FaqLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type FaqLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type FaqLinkingCollectionsFaqsModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FaqLinkingCollectionsFaqsModuleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type FaqLinkingCollectionsFaqsModuleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FaqLinkingCollectionsFaqsModuleCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum FaqLinkingCollectionsFaqsModuleCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum FaqLinkingCollectionsFaqsModuleCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum FaqOrder {
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/faqsModule) */
export type FaqsModule = Entry & _Node & {
  __typename: 'FaqsModule';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  faqsCollection: Maybe<FaqsModuleFaqsCollection>;
  faqsCursorCollection: Maybe<FaqsModuleFaqsCursorCollection>;
  linkedFrom: Maybe<FaqsModuleLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/faqsModule) */
export type FaqsModuleFaqsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FaqsModuleFaqsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<FaqFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/faqsModule) */
export type FaqsModuleFaqsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FaqsModuleFaqsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<FaqFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/faqsModule) */
export type FaqsModuleLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/faqsModule) */
export type FaqsModuleNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/faqsModule) */
export type FaqsModuleTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type FaqsModuleCollection = {
  __typename: 'FaqsModuleCollection';
  items: Array<Maybe<FaqsModule>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type FaqsModuleCursorCollection = {
  __typename: 'FaqsModuleCursorCollection';
  items: Array<Maybe<FaqsModule>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type FaqsModuleFaqsCollection = {
  __typename: 'FaqsModuleFaqsCollection';
  items: Array<Maybe<Faq>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum FaqsModuleFaqsCollectionOrder {
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type FaqsModuleFaqsCursorCollection = {
  __typename: 'FaqsModuleFaqsCursorCollection';
  items: Array<Maybe<Faq>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum FaqsModuleFaqsCursorCollectionOrder {
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type FaqsModuleFilter = {
  AND: InputMaybe<Array<InputMaybe<FaqsModuleFilter>>>;
  OR: InputMaybe<Array<InputMaybe<FaqsModuleFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  faqs: InputMaybe<CfFaqNestedFilter>;
  faqsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FaqsModuleLinkingCollections = {
  __typename: 'FaqsModuleLinkingCollections';
  articleCollection: Maybe<ArticleCollection>;
  articleCursorCollection: Maybe<ArticleCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  grantResourcesCollection: Maybe<GrantResourcesCollection>;
  grantResourcesCursorCollection: Maybe<GrantResourcesCursorCollection>;
  mmufCollection: Maybe<MmufCollection>;
  mmufCursorCollection: Maybe<MmufCursorCollection>;
  resourcesCurrentGranteesCollection: Maybe<ResourcesCurrentGranteesCollection>;
  resourcesCurrentGranteesCursorCollection: Maybe<ResourcesCurrentGranteesCursorCollection>;
  resourcesProspectiveGranteesCollection: Maybe<ResourcesProspectiveGranteesCollection>;
  resourcesProspectiveGranteesCursorCollection: Maybe<ResourcesProspectiveGranteesCursorCollection>;
};


export type FaqsModuleLinkingCollectionsArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FaqsModuleLinkingCollectionsArticleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type FaqsModuleLinkingCollectionsArticleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FaqsModuleLinkingCollectionsArticleCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type FaqsModuleLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type FaqsModuleLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type FaqsModuleLinkingCollectionsGrantResourcesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FaqsModuleLinkingCollectionsGrantResourcesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type FaqsModuleLinkingCollectionsGrantResourcesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FaqsModuleLinkingCollectionsGrantResourcesCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type FaqsModuleLinkingCollectionsMmufCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FaqsModuleLinkingCollectionsMmufCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type FaqsModuleLinkingCollectionsMmufCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FaqsModuleLinkingCollectionsMmufCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type FaqsModuleLinkingCollectionsResourcesCurrentGranteesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FaqsModuleLinkingCollectionsResourcesCurrentGranteesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type FaqsModuleLinkingCollectionsResourcesCurrentGranteesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FaqsModuleLinkingCollectionsResourcesCurrentGranteesCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type FaqsModuleLinkingCollectionsResourcesProspectiveGranteesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FaqsModuleLinkingCollectionsResourcesProspectiveGranteesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type FaqsModuleLinkingCollectionsResourcesProspectiveGranteesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FaqsModuleLinkingCollectionsResourcesProspectiveGranteesCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum FaqsModuleLinkingCollectionsArticleCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  ExternalNewsUrlAsc = 'externalNewsUrl_ASC',
  ExternalNewsUrlDesc = 'externalNewsUrl_DESC',
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  PasswordAsc = 'password_ASC',
  PasswordDesc = 'password_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum FaqsModuleLinkingCollectionsArticleCursorCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  ExternalNewsUrlAsc = 'externalNewsUrl_ASC',
  ExternalNewsUrlDesc = 'externalNewsUrl_DESC',
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  PasswordAsc = 'password_ASC',
  PasswordDesc = 'password_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum FaqsModuleLinkingCollectionsGrantResourcesCollectionOrder {
  ExplanatoryTitleAsc = 'explanatoryTitle_ASC',
  ExplanatoryTitleDesc = 'explanatoryTitle_DESC',
  GrantMakingAreasTitleAsc = 'grantMakingAreasTitle_ASC',
  GrantMakingAreasTitleDesc = 'grantMakingAreasTitle_DESC',
  SearchContextualMessageAsc = 'searchContextualMessage_ASC',
  SearchContextualMessageDesc = 'searchContextualMessage_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum FaqsModuleLinkingCollectionsGrantResourcesCursorCollectionOrder {
  ExplanatoryTitleAsc = 'explanatoryTitle_ASC',
  ExplanatoryTitleDesc = 'explanatoryTitle_DESC',
  GrantMakingAreasTitleAsc = 'grantMakingAreasTitle_ASC',
  GrantMakingAreasTitleDesc = 'grantMakingAreasTitle_DESC',
  SearchContextualMessageAsc = 'searchContextualMessage_ASC',
  SearchContextualMessageDesc = 'searchContextualMessage_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum FaqsModuleLinkingCollectionsMmufCollectionOrder {
  ArticleTitleAsc = 'articleTitle_ASC',
  ArticleTitleDesc = 'articleTitle_DESC',
  AtGlanceTitleAsc = 'atGlanceTitle_ASC',
  AtGlanceTitleDesc = 'atGlanceTitle_DESC',
  ContactEmailAsc = 'contactEmail_ASC',
  ContactEmailDesc = 'contactEmail_DESC',
  ContactMessageAsc = 'contactMessage_ASC',
  ContactMessageDesc = 'contactMessage_DESC',
  ContactTitleAsc = 'contactTitle_ASC',
  ContactTitleDesc = 'contactTitle_DESC',
  FellowStoriesCtaLabelAsc = 'fellowStoriesCtaLabel_ASC',
  FellowStoriesCtaLabelDesc = 'fellowStoriesCtaLabel_DESC',
  FellowStoriesMessageAsc = 'fellowStoriesMessage_ASC',
  FellowStoriesMessageDesc = 'fellowStoriesMessage_DESC',
  GraduateInitiativesTitleAsc = 'graduateInitiativesTitle_ASC',
  GraduateInitiativesTitleDesc = 'graduateInitiativesTitle_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum FaqsModuleLinkingCollectionsMmufCursorCollectionOrder {
  ArticleTitleAsc = 'articleTitle_ASC',
  ArticleTitleDesc = 'articleTitle_DESC',
  AtGlanceTitleAsc = 'atGlanceTitle_ASC',
  AtGlanceTitleDesc = 'atGlanceTitle_DESC',
  ContactEmailAsc = 'contactEmail_ASC',
  ContactEmailDesc = 'contactEmail_DESC',
  ContactMessageAsc = 'contactMessage_ASC',
  ContactMessageDesc = 'contactMessage_DESC',
  ContactTitleAsc = 'contactTitle_ASC',
  ContactTitleDesc = 'contactTitle_DESC',
  FellowStoriesCtaLabelAsc = 'fellowStoriesCtaLabel_ASC',
  FellowStoriesCtaLabelDesc = 'fellowStoriesCtaLabel_DESC',
  FellowStoriesMessageAsc = 'fellowStoriesMessage_ASC',
  FellowStoriesMessageDesc = 'fellowStoriesMessage_DESC',
  GraduateInitiativesTitleAsc = 'graduateInitiativesTitle_ASC',
  GraduateInitiativesTitleDesc = 'graduateInitiativesTitle_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum FaqsModuleLinkingCollectionsResourcesCurrentGranteesCollectionOrder {
  GrantDatabaseCtaTextAsc = 'grantDatabaseCtaText_ASC',
  GrantDatabaseCtaTextDesc = 'grantDatabaseCtaText_DESC',
  ResourcesTitleAsc = 'resourcesTitle_ASC',
  ResourcesTitleDesc = 'resourcesTitle_DESC',
  SimilarGranteesTitleAsc = 'similarGranteesTitle_ASC',
  SimilarGranteesTitleDesc = 'similarGranteesTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum FaqsModuleLinkingCollectionsResourcesCurrentGranteesCursorCollectionOrder {
  GrantDatabaseCtaTextAsc = 'grantDatabaseCtaText_ASC',
  GrantDatabaseCtaTextDesc = 'grantDatabaseCtaText_DESC',
  ResourcesTitleAsc = 'resourcesTitle_ASC',
  ResourcesTitleDesc = 'resourcesTitle_DESC',
  SimilarGranteesTitleAsc = 'similarGranteesTitle_ASC',
  SimilarGranteesTitleDesc = 'similarGranteesTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum FaqsModuleLinkingCollectionsResourcesProspectiveGranteesCollectionOrder {
  CallsForConceptsTitleAsc = 'callsForConceptsTitle_ASC',
  CallsForConceptsTitleDesc = 'callsForConceptsTitle_DESC',
  GrantDatabaseCtaTextAsc = 'grantDatabaseCtaText_ASC',
  GrantDatabaseCtaTextDesc = 'grantDatabaseCtaText_DESC',
  GrantmakingAtGlanceTitleAsc = 'grantmakingAtGlanceTitle_ASC',
  GrantmakingAtGlanceTitleDesc = 'grantmakingAtGlanceTitle_DESC',
  NewsletterCtaTextAsc = 'newsletterCtaText_ASC',
  NewsletterCtaTextDesc = 'newsletterCtaText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum FaqsModuleLinkingCollectionsResourcesProspectiveGranteesCursorCollectionOrder {
  CallsForConceptsTitleAsc = 'callsForConceptsTitle_ASC',
  CallsForConceptsTitleDesc = 'callsForConceptsTitle_DESC',
  GrantDatabaseCtaTextAsc = 'grantDatabaseCtaText_ASC',
  GrantDatabaseCtaTextDesc = 'grantDatabaseCtaText_DESC',
  GrantmakingAtGlanceTitleAsc = 'grantmakingAtGlanceTitle_ASC',
  GrantmakingAtGlanceTitleDesc = 'grantmakingAtGlanceTitle_DESC',
  NewsletterCtaTextAsc = 'newsletterCtaText_ASC',
  NewsletterCtaTextDesc = 'newsletterCtaText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum FaqsModuleOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/feature) */
export type Feature = Entry & _Node & {
  __typename: 'Feature';
  _id: Scalars['ID']['output'];
  callout: Maybe<FeatureCallout>;
  content: Maybe<FeatureContent>;
  contentfulMetadata: ContentfulMetadata;
  ctaContextualMessage: Maybe<Scalars['String']['output']>;
  date: Maybe<Scalars['String']['output']>;
  dateTime: Maybe<Scalars['DateTime']['output']>;
  experienceBlock: Maybe<ExperienceBlock>;
  grantStoriesSetCollection: Maybe<FeatureGrantStoriesSetCollection>;
  grantStoriesSetCursorCollection: Maybe<FeatureGrantStoriesSetCursorCollection>;
  hero: Maybe<HeroAsset>;
  heroImage: Maybe<Asset>;
  includedGrantsCollection: Maybe<FeatureIncludedGrantsCollection>;
  includedGrantsCursorCollection: Maybe<FeatureIncludedGrantsCursorCollection>;
  intro: Maybe<FeatureIntro>;
  linkedFrom: Maybe<FeatureLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  newsletter: Maybe<NewsletterCard>;
  pinnedGrantStoriesCollection: Maybe<FeaturePinnedGrantStoriesCollection>;
  pinnedGrantStoriesCursorCollection: Maybe<FeaturePinnedGrantStoriesCursorCollection>;
  previewVideo: Maybe<Asset>;
  quickLinks: Maybe<ConnectWith>;
  relatedContentCollection: Maybe<FeatureRelatedContentCollection>;
  relatedContentCursorCollection: Maybe<FeatureRelatedContentCursorCollection>;
  showSocialCtas: Maybe<Scalars['Boolean']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  sys: Sys;
  tagline: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/feature) */
export type FeatureCalloutArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/feature) */
export type FeatureContentArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/feature) */
export type FeatureCtaContextualMessageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/feature) */
export type FeatureDateArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/feature) */
export type FeatureDateTimeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/feature) */
export type FeatureExperienceBlockArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ExperienceBlockFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/feature) */
export type FeatureGrantStoriesSetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FeatureGrantStoriesSetCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantActivityArticleFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/feature) */
export type FeatureGrantStoriesSetCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FeatureGrantStoriesSetCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantActivityArticleFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/feature) */
export type FeatureHeroArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<HeroAssetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/feature) */
export type FeatureHeroImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/feature) */
export type FeatureIncludedGrantsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FeatureIncludedGrantsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/feature) */
export type FeatureIncludedGrantsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FeatureIncludedGrantsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/feature) */
export type FeatureIntroArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/feature) */
export type FeatureLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/feature) */
export type FeatureNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/feature) */
export type FeatureNewsletterArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<NewsletterCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/feature) */
export type FeaturePinnedGrantStoriesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<FeaturePinnedGrantStoriesFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/feature) */
export type FeaturePinnedGrantStoriesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<FeaturePinnedGrantStoriesFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/feature) */
export type FeaturePreviewVideoArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/feature) */
export type FeatureQuickLinksArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ConnectWithFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/feature) */
export type FeatureRelatedContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<FeatureRelatedContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/feature) */
export type FeatureRelatedContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<FeatureRelatedContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/feature) */
export type FeatureShowSocialCtasArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/feature) */
export type FeatureSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/feature) */
export type FeatureTaglineArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type FeatureCallout = Article | ExternalEvent | GrantActivityArticle;

export type FeatureCollection = {
  __typename: 'FeatureCollection';
  items: Array<Maybe<Feature>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type FeatureContent = {
  __typename: 'FeatureContent';
  json: Scalars['JSON']['output'];
  links: FeatureContentLinks;
};

export type FeatureContentAssets = {
  __typename: 'FeatureContentAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type FeatureContentEntries = {
  __typename: 'FeatureContentEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type FeatureContentLinks = {
  __typename: 'FeatureContentLinks';
  assets: FeatureContentAssets;
  entries: FeatureContentEntries;
  resources: FeatureContentResources;
};

export type FeatureContentResources = {
  __typename: 'FeatureContentResources';
  block: Array<FeatureContentResourcesBlock>;
  hyperlink: Array<FeatureContentResourcesHyperlink>;
  inline: Array<FeatureContentResourcesInline>;
};

export type FeatureContentResourcesBlock = ResourceLink & {
  __typename: 'FeatureContentResourcesBlock';
  sys: ResourceSys;
};

export type FeatureContentResourcesHyperlink = ResourceLink & {
  __typename: 'FeatureContentResourcesHyperlink';
  sys: ResourceSys;
};

export type FeatureContentResourcesInline = ResourceLink & {
  __typename: 'FeatureContentResourcesInline';
  sys: ResourceSys;
};

export type FeatureCursorCollection = {
  __typename: 'FeatureCursorCollection';
  items: Array<Maybe<Feature>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type FeatureFilter = {
  AND: InputMaybe<Array<InputMaybe<FeatureFilter>>>;
  OR: InputMaybe<Array<InputMaybe<FeatureFilter>>>;
  callout_exists: InputMaybe<Scalars['Boolean']['input']>;
  content_contains: InputMaybe<Scalars['String']['input']>;
  content_exists: InputMaybe<Scalars['Boolean']['input']>;
  content_not_contains: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  ctaContextualMessage: InputMaybe<Scalars['String']['input']>;
  ctaContextualMessage_contains: InputMaybe<Scalars['String']['input']>;
  ctaContextualMessage_exists: InputMaybe<Scalars['Boolean']['input']>;
  ctaContextualMessage_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaContextualMessage_not: InputMaybe<Scalars['String']['input']>;
  ctaContextualMessage_not_contains: InputMaybe<Scalars['String']['input']>;
  ctaContextualMessage_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  date: InputMaybe<Scalars['String']['input']>;
  dateTime: InputMaybe<Scalars['DateTime']['input']>;
  dateTime_exists: InputMaybe<Scalars['Boolean']['input']>;
  dateTime_gt: InputMaybe<Scalars['DateTime']['input']>;
  dateTime_gte: InputMaybe<Scalars['DateTime']['input']>;
  dateTime_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  dateTime_lt: InputMaybe<Scalars['DateTime']['input']>;
  dateTime_lte: InputMaybe<Scalars['DateTime']['input']>;
  dateTime_not: InputMaybe<Scalars['DateTime']['input']>;
  dateTime_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_contains: InputMaybe<Scalars['String']['input']>;
  date_exists: InputMaybe<Scalars['Boolean']['input']>;
  date_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  date_not: InputMaybe<Scalars['String']['input']>;
  date_not_contains: InputMaybe<Scalars['String']['input']>;
  date_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  experienceBlock: InputMaybe<CfExperienceBlockNestedFilter>;
  experienceBlock_exists: InputMaybe<Scalars['Boolean']['input']>;
  grantStoriesSet: InputMaybe<CfGrantActivityArticleNestedFilter>;
  grantStoriesSetCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  hero: InputMaybe<CfHeroAssetNestedFilter>;
  heroImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  hero_exists: InputMaybe<Scalars['Boolean']['input']>;
  includedGrants: InputMaybe<CfGrantNestedFilter>;
  includedGrantsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  intro_contains: InputMaybe<Scalars['String']['input']>;
  intro_exists: InputMaybe<Scalars['Boolean']['input']>;
  intro_not_contains: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  newsletter: InputMaybe<CfNewsletterCardNestedFilter>;
  newsletter_exists: InputMaybe<Scalars['Boolean']['input']>;
  pinnedGrantStories: InputMaybe<CfpinnedGrantStoriesMultiTypeNestedFilter>;
  pinnedGrantStoriesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  previewVideo_exists: InputMaybe<Scalars['Boolean']['input']>;
  quickLinks: InputMaybe<CfConnectWithNestedFilter>;
  quickLinks_exists: InputMaybe<Scalars['Boolean']['input']>;
  relatedContent: InputMaybe<CfrelatedContentMultiTypeNestedFilter>;
  relatedContentCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  showSocialCtas: InputMaybe<Scalars['Boolean']['input']>;
  showSocialCtas_exists: InputMaybe<Scalars['Boolean']['input']>;
  showSocialCtas_not: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  tagline: InputMaybe<Scalars['String']['input']>;
  tagline_contains: InputMaybe<Scalars['String']['input']>;
  tagline_exists: InputMaybe<Scalars['Boolean']['input']>;
  tagline_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagline_not: InputMaybe<Scalars['String']['input']>;
  tagline_not_contains: InputMaybe<Scalars['String']['input']>;
  tagline_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FeatureGrantStoriesSetCollection = {
  __typename: 'FeatureGrantStoriesSetCollection';
  items: Array<Maybe<GrantActivityArticle>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum FeatureGrantStoriesSetCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  GranteeCityOverrideAsc = 'granteeCityOverride_ASC',
  GranteeCityOverrideDesc = 'granteeCityOverride_DESC',
  GranteeCountryOverrideAsc = 'granteeCountryOverride_ASC',
  GranteeCountryOverrideDesc = 'granteeCountryOverride_DESC',
  GranteeNameOverrideAsc = 'granteeNameOverride_ASC',
  GranteeNameOverrideDesc = 'granteeNameOverride_DESC',
  GranteeStateOverrideAsc = 'granteeStateOverride_ASC',
  GranteeStateOverrideDesc = 'granteeStateOverride_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type FeatureGrantStoriesSetCursorCollection = {
  __typename: 'FeatureGrantStoriesSetCursorCollection';
  items: Array<Maybe<GrantActivityArticle>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum FeatureGrantStoriesSetCursorCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  GranteeCityOverrideAsc = 'granteeCityOverride_ASC',
  GranteeCityOverrideDesc = 'granteeCityOverride_DESC',
  GranteeCountryOverrideAsc = 'granteeCountryOverride_ASC',
  GranteeCountryOverrideDesc = 'granteeCountryOverride_DESC',
  GranteeNameOverrideAsc = 'granteeNameOverride_ASC',
  GranteeNameOverrideDesc = 'granteeNameOverride_DESC',
  GranteeStateOverrideAsc = 'granteeStateOverride_ASC',
  GranteeStateOverrideDesc = 'granteeStateOverride_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type FeatureIncludedGrantsCollection = {
  __typename: 'FeatureIncludedGrantsCollection';
  items: Array<Maybe<Grant>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum FeatureIncludedGrantsCollectionOrder {
  AmountAsc = 'amount_ASC',
  AmountDesc = 'amount_DESC',
  AreaOfFocusAsc = 'areaOfFocus_ASC',
  AreaOfFocusDesc = 'areaOfFocus_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  DurationInMonthsAsc = 'durationInMonths_ASC',
  DurationInMonthsDesc = 'durationInMonths_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ProjectTitleAsc = 'projectTitle_ASC',
  ProjectTitleDesc = 'projectTitle_DESC',
  ReferenceIdAsc = 'referenceId_ASC',
  ReferenceIdDesc = 'referenceId_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type FeatureIncludedGrantsCursorCollection = {
  __typename: 'FeatureIncludedGrantsCursorCollection';
  items: Array<Maybe<Grant>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum FeatureIncludedGrantsCursorCollectionOrder {
  AmountAsc = 'amount_ASC',
  AmountDesc = 'amount_DESC',
  AreaOfFocusAsc = 'areaOfFocus_ASC',
  AreaOfFocusDesc = 'areaOfFocus_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  DurationInMonthsAsc = 'durationInMonths_ASC',
  DurationInMonthsDesc = 'durationInMonths_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ProjectTitleAsc = 'projectTitle_ASC',
  ProjectTitleDesc = 'projectTitle_DESC',
  ReferenceIdAsc = 'referenceId_ASC',
  ReferenceIdDesc = 'referenceId_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type FeatureIntro = {
  __typename: 'FeatureIntro';
  json: Scalars['JSON']['output'];
  links: FeatureIntroLinks;
};

export type FeatureIntroAssets = {
  __typename: 'FeatureIntroAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type FeatureIntroEntries = {
  __typename: 'FeatureIntroEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type FeatureIntroLinks = {
  __typename: 'FeatureIntroLinks';
  assets: FeatureIntroAssets;
  entries: FeatureIntroEntries;
  resources: FeatureIntroResources;
};

export type FeatureIntroResources = {
  __typename: 'FeatureIntroResources';
  block: Array<FeatureIntroResourcesBlock>;
  hyperlink: Array<FeatureIntroResourcesHyperlink>;
  inline: Array<FeatureIntroResourcesInline>;
};

export type FeatureIntroResourcesBlock = ResourceLink & {
  __typename: 'FeatureIntroResourcesBlock';
  sys: ResourceSys;
};

export type FeatureIntroResourcesHyperlink = ResourceLink & {
  __typename: 'FeatureIntroResourcesHyperlink';
  sys: ResourceSys;
};

export type FeatureIntroResourcesInline = ResourceLink & {
  __typename: 'FeatureIntroResourcesInline';
  sys: ResourceSys;
};

export type FeatureLinkingCollections = {
  __typename: 'FeatureLinkingCollections';
  articleCollection: Maybe<ArticleCollection>;
  articleCursorCollection: Maybe<ArticleCursorCollection>;
  connectWithLinkCollection: Maybe<ConnectWithLinkCollection>;
  connectWithLinkCursorCollection: Maybe<ConnectWithLinkCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  featureCollection: Maybe<FeatureCollection>;
  featureCursorCollection: Maybe<FeatureCursorCollection>;
  grantActivityArticleCollection: Maybe<GrantActivityArticleCollection>;
  grantActivityArticleCursorCollection: Maybe<GrantActivityArticleCursorCollection>;
  homePageCollection: Maybe<HomePageCollection>;
  homePageCursorCollection: Maybe<HomePageCursorCollection>;
  ideaCollection: Maybe<IdeaCollection>;
  ideaCursorCollection: Maybe<IdeaCursorCollection>;
  inlineCardsCollection: Maybe<InlineCardsCollection>;
  inlineCardsCursorCollection: Maybe<InlineCardsCursorCollection>;
  storiesPageCollection: Maybe<StoriesPageCollection>;
  storiesPageCursorCollection: Maybe<StoriesPageCursorCollection>;
};


export type FeatureLinkingCollectionsArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FeatureLinkingCollectionsArticleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type FeatureLinkingCollectionsArticleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FeatureLinkingCollectionsArticleCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type FeatureLinkingCollectionsConnectWithLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FeatureLinkingCollectionsConnectWithLinkCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type FeatureLinkingCollectionsConnectWithLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FeatureLinkingCollectionsConnectWithLinkCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type FeatureLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type FeatureLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type FeatureLinkingCollectionsFeatureCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FeatureLinkingCollectionsFeatureCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type FeatureLinkingCollectionsFeatureCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FeatureLinkingCollectionsFeatureCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type FeatureLinkingCollectionsGrantActivityArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FeatureLinkingCollectionsGrantActivityArticleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type FeatureLinkingCollectionsGrantActivityArticleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FeatureLinkingCollectionsGrantActivityArticleCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type FeatureLinkingCollectionsHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FeatureLinkingCollectionsHomePageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type FeatureLinkingCollectionsHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FeatureLinkingCollectionsHomePageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type FeatureLinkingCollectionsIdeaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FeatureLinkingCollectionsIdeaCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type FeatureLinkingCollectionsIdeaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FeatureLinkingCollectionsIdeaCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type FeatureLinkingCollectionsInlineCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FeatureLinkingCollectionsInlineCardsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type FeatureLinkingCollectionsInlineCardsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FeatureLinkingCollectionsInlineCardsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type FeatureLinkingCollectionsStoriesPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FeatureLinkingCollectionsStoriesPageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type FeatureLinkingCollectionsStoriesPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FeatureLinkingCollectionsStoriesPageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum FeatureLinkingCollectionsArticleCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  ExternalNewsUrlAsc = 'externalNewsUrl_ASC',
  ExternalNewsUrlDesc = 'externalNewsUrl_DESC',
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  PasswordAsc = 'password_ASC',
  PasswordDesc = 'password_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum FeatureLinkingCollectionsArticleCursorCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  ExternalNewsUrlAsc = 'externalNewsUrl_ASC',
  ExternalNewsUrlDesc = 'externalNewsUrl_DESC',
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  PasswordAsc = 'password_ASC',
  PasswordDesc = 'password_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum FeatureLinkingCollectionsConnectWithLinkCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum FeatureLinkingCollectionsConnectWithLinkCursorCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum FeatureLinkingCollectionsFeatureCollectionOrder {
  DateTimeAsc = 'dateTime_ASC',
  DateTimeDesc = 'dateTime_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  ShowSocialCtasAsc = 'showSocialCtas_ASC',
  ShowSocialCtasDesc = 'showSocialCtas_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TaglineAsc = 'tagline_ASC',
  TaglineDesc = 'tagline_DESC'
}

export enum FeatureLinkingCollectionsFeatureCursorCollectionOrder {
  DateTimeAsc = 'dateTime_ASC',
  DateTimeDesc = 'dateTime_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  ShowSocialCtasAsc = 'showSocialCtas_ASC',
  ShowSocialCtasDesc = 'showSocialCtas_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TaglineAsc = 'tagline_ASC',
  TaglineDesc = 'tagline_DESC'
}

export enum FeatureLinkingCollectionsGrantActivityArticleCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  GranteeCityOverrideAsc = 'granteeCityOverride_ASC',
  GranteeCityOverrideDesc = 'granteeCityOverride_DESC',
  GranteeCountryOverrideAsc = 'granteeCountryOverride_ASC',
  GranteeCountryOverrideDesc = 'granteeCountryOverride_DESC',
  GranteeNameOverrideAsc = 'granteeNameOverride_ASC',
  GranteeNameOverrideDesc = 'granteeNameOverride_DESC',
  GranteeStateOverrideAsc = 'granteeStateOverride_ASC',
  GranteeStateOverrideDesc = 'granteeStateOverride_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum FeatureLinkingCollectionsGrantActivityArticleCursorCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  GranteeCityOverrideAsc = 'granteeCityOverride_ASC',
  GranteeCityOverrideDesc = 'granteeCityOverride_DESC',
  GranteeCountryOverrideAsc = 'granteeCountryOverride_ASC',
  GranteeCountryOverrideDesc = 'granteeCountryOverride_DESC',
  GranteeNameOverrideAsc = 'granteeNameOverride_ASC',
  GranteeNameOverrideDesc = 'granteeNameOverride_DESC',
  GranteeStateOverrideAsc = 'granteeStateOverride_ASC',
  GranteeStateOverrideDesc = 'granteeStateOverride_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum FeatureLinkingCollectionsHomePageCollectionOrder {
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  MissionTextAsc = 'missionText_ASC',
  MissionTextDesc = 'missionText_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StoriesCtaAsc = 'storiesCta_ASC',
  StoriesCtaDesc = 'storiesCta_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum FeatureLinkingCollectionsHomePageCursorCollectionOrder {
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  MissionTextAsc = 'missionText_ASC',
  MissionTextDesc = 'missionText_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StoriesCtaAsc = 'storiesCta_ASC',
  StoriesCtaDesc = 'storiesCta_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum FeatureLinkingCollectionsIdeaCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum FeatureLinkingCollectionsIdeaCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum FeatureLinkingCollectionsInlineCardsCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum FeatureLinkingCollectionsInlineCardsCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum FeatureLinkingCollectionsStoriesPageCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum FeatureLinkingCollectionsStoriesPageCursorCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum FeatureOrder {
  DateTimeAsc = 'dateTime_ASC',
  DateTimeDesc = 'dateTime_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  ShowSocialCtasAsc = 'showSocialCtas_ASC',
  ShowSocialCtasDesc = 'showSocialCtas_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TaglineAsc = 'tagline_ASC',
  TaglineDesc = 'tagline_DESC'
}

export type FeaturePinnedGrantStoriesCollection = {
  __typename: 'FeaturePinnedGrantStoriesCollection';
  items: Array<Maybe<FeaturePinnedGrantStoriesItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type FeaturePinnedGrantStoriesCursorCollection = {
  __typename: 'FeaturePinnedGrantStoriesCursorCollection';
  items: Array<Maybe<FeaturePinnedGrantStoriesItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type FeaturePinnedGrantStoriesFilter = {
  AND: InputMaybe<Array<InputMaybe<FeaturePinnedGrantStoriesFilter>>>;
  OR: InputMaybe<Array<InputMaybe<FeaturePinnedGrantStoriesFilter>>>;
  audio_exists: InputMaybe<Scalars['Boolean']['input']>;
  author: InputMaybe<Scalars['String']['input']>;
  author_contains: InputMaybe<Scalars['String']['input']>;
  author_exists: InputMaybe<Scalars['Boolean']['input']>;
  author_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  author_not: InputMaybe<Scalars['String']['input']>;
  author_not_contains: InputMaybe<Scalars['String']['input']>;
  author_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_contains: InputMaybe<Scalars['String']['input']>;
  body_exists: InputMaybe<Scalars['Boolean']['input']>;
  body_not_contains: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  creditLabel: InputMaybe<Scalars['String']['input']>;
  creditLabel_contains: InputMaybe<Scalars['String']['input']>;
  creditLabel_exists: InputMaybe<Scalars['Boolean']['input']>;
  creditLabel_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  creditLabel_not: InputMaybe<Scalars['String']['input']>;
  creditLabel_not_contains: InputMaybe<Scalars['String']['input']>;
  creditLabel_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  creditText: InputMaybe<Scalars['String']['input']>;
  creditText_contains: InputMaybe<Scalars['String']['input']>;
  creditText_exists: InputMaybe<Scalars['Boolean']['input']>;
  creditText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  creditText_not: InputMaybe<Scalars['String']['input']>;
  creditText_not_contains: InputMaybe<Scalars['String']['input']>;
  creditText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  date: InputMaybe<Scalars['DateTime']['input']>;
  date_exists: InputMaybe<Scalars['Boolean']['input']>;
  date_gt: InputMaybe<Scalars['DateTime']['input']>;
  date_gte: InputMaybe<Scalars['DateTime']['input']>;
  date_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_lt: InputMaybe<Scalars['DateTime']['input']>;
  date_lte: InputMaybe<Scalars['DateTime']['input']>;
  date_not: InputMaybe<Scalars['DateTime']['input']>;
  date_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattingOptions_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattingOptions_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattingOptions_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattingOptions_exists: InputMaybe<Scalars['Boolean']['input']>;
  hero_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideDate: InputMaybe<Scalars['Boolean']['input']>;
  hideDate_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideDate_not: InputMaybe<Scalars['Boolean']['input']>;
  hideShareLink: InputMaybe<Scalars['Boolean']['input']>;
  hideShareLink_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideShareLink_not: InputMaybe<Scalars['Boolean']['input']>;
  metadata_exists: InputMaybe<Scalars['Boolean']['input']>;
  photographer: InputMaybe<Scalars['String']['input']>;
  photographer_contains: InputMaybe<Scalars['String']['input']>;
  photographer_exists: InputMaybe<Scalars['Boolean']['input']>;
  photographer_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  photographer_not: InputMaybe<Scalars['String']['input']>;
  photographer_not_contains: InputMaybe<Scalars['String']['input']>;
  photographer_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  thumbnailImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FeaturePinnedGrantStoriesItem = Article | GrantActivityArticle;

export type FeatureRelatedContentCollection = {
  __typename: 'FeatureRelatedContentCollection';
  items: Array<Maybe<FeatureRelatedContentItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type FeatureRelatedContentCursorCollection = {
  __typename: 'FeatureRelatedContentCursorCollection';
  items: Array<Maybe<FeatureRelatedContentItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type FeatureRelatedContentFilter = {
  AND: InputMaybe<Array<InputMaybe<FeatureRelatedContentFilter>>>;
  OR: InputMaybe<Array<InputMaybe<FeatureRelatedContentFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
};

export type FeatureRelatedContentItem = Article | ExternalEvent | Feature | GrantActivityArticle | Idea;

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/financialsPage) */
export type FinancialsPage = Entry & _Node & {
  __typename: 'FinancialsPage';
  _id: Scalars['ID']['output'];
  auditedFinancialStatementsCollection: Maybe<AssetCollection>;
  auditedFinancialStatementsCursorCollection: Maybe<AssetCursorCollection>;
  auditedFinancialStatementsHeader: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  financialReportsCollection: Maybe<AssetCollection>;
  financialReportsCursorCollection: Maybe<AssetCursorCollection>;
  financialReportsHeader: Maybe<Scalars['String']['output']>;
  graphsSection: Maybe<FinancialsPageGraphsSection>;
  introDescription: Maybe<Scalars['String']['output']>;
  introParagraph: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<FinancialsPageLinkingCollections>;
  navigationImagePortrait: Maybe<Asset>;
  privateFoundationReportsCollection: Maybe<AssetCollection>;
  privateFoundationReportsCursorCollection: Maybe<AssetCursorCollection>;
  privateFoundationReportsHeader: Maybe<Scalars['String']['output']>;
  quickLinks: Maybe<ConnectWith>;
  slug: Maybe<Scalars['String']['output']>;
  socialBondFramework: Maybe<Scalars['String']['output']>;
  socialBondFrameworkLink: Maybe<ConnectWithLink>;
  socialBondFrameworkText: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/financialsPage) */
export type FinancialsPageAuditedFinancialStatementsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/financialsPage) */
export type FinancialsPageAuditedFinancialStatementsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/financialsPage) */
export type FinancialsPageAuditedFinancialStatementsHeaderArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/financialsPage) */
export type FinancialsPageFinancialReportsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/financialsPage) */
export type FinancialsPageFinancialReportsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/financialsPage) */
export type FinancialsPageFinancialReportsHeaderArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/financialsPage) */
export type FinancialsPageGraphsSectionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/financialsPage) */
export type FinancialsPageIntroDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/financialsPage) */
export type FinancialsPageIntroParagraphArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/financialsPage) */
export type FinancialsPageLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/financialsPage) */
export type FinancialsPageNavigationImagePortraitArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/financialsPage) */
export type FinancialsPagePrivateFoundationReportsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/financialsPage) */
export type FinancialsPagePrivateFoundationReportsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/financialsPage) */
export type FinancialsPagePrivateFoundationReportsHeaderArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/financialsPage) */
export type FinancialsPageQuickLinksArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ConnectWithFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/financialsPage) */
export type FinancialsPageSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/financialsPage) */
export type FinancialsPageSocialBondFrameworkArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/financialsPage) */
export type FinancialsPageSocialBondFrameworkLinkArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ConnectWithLinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/financialsPage) */
export type FinancialsPageSocialBondFrameworkTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/financialsPage) */
export type FinancialsPageTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type FinancialsPageCollection = {
  __typename: 'FinancialsPageCollection';
  items: Array<Maybe<FinancialsPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type FinancialsPageCursorCollection = {
  __typename: 'FinancialsPageCursorCollection';
  items: Array<Maybe<FinancialsPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type FinancialsPageFilter = {
  AND: InputMaybe<Array<InputMaybe<FinancialsPageFilter>>>;
  OR: InputMaybe<Array<InputMaybe<FinancialsPageFilter>>>;
  auditedFinancialStatementsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  auditedFinancialStatementsHeader: InputMaybe<Scalars['String']['input']>;
  auditedFinancialStatementsHeader_contains: InputMaybe<Scalars['String']['input']>;
  auditedFinancialStatementsHeader_exists: InputMaybe<Scalars['Boolean']['input']>;
  auditedFinancialStatementsHeader_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  auditedFinancialStatementsHeader_not: InputMaybe<Scalars['String']['input']>;
  auditedFinancialStatementsHeader_not_contains: InputMaybe<Scalars['String']['input']>;
  auditedFinancialStatementsHeader_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  financialReportsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  financialReportsHeader: InputMaybe<Scalars['String']['input']>;
  financialReportsHeader_contains: InputMaybe<Scalars['String']['input']>;
  financialReportsHeader_exists: InputMaybe<Scalars['Boolean']['input']>;
  financialReportsHeader_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  financialReportsHeader_not: InputMaybe<Scalars['String']['input']>;
  financialReportsHeader_not_contains: InputMaybe<Scalars['String']['input']>;
  financialReportsHeader_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  graphsSection_contains: InputMaybe<Scalars['String']['input']>;
  graphsSection_exists: InputMaybe<Scalars['Boolean']['input']>;
  graphsSection_not_contains: InputMaybe<Scalars['String']['input']>;
  introDescription: InputMaybe<Scalars['String']['input']>;
  introDescription_contains: InputMaybe<Scalars['String']['input']>;
  introDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  introDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  introDescription_not: InputMaybe<Scalars['String']['input']>;
  introDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  introDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  introParagraph: InputMaybe<Scalars['String']['input']>;
  introParagraph_contains: InputMaybe<Scalars['String']['input']>;
  introParagraph_exists: InputMaybe<Scalars['Boolean']['input']>;
  introParagraph_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  introParagraph_not: InputMaybe<Scalars['String']['input']>;
  introParagraph_not_contains: InputMaybe<Scalars['String']['input']>;
  introParagraph_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navigationImagePortrait_exists: InputMaybe<Scalars['Boolean']['input']>;
  privateFoundationReportsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  privateFoundationReportsHeader: InputMaybe<Scalars['String']['input']>;
  privateFoundationReportsHeader_contains: InputMaybe<Scalars['String']['input']>;
  privateFoundationReportsHeader_exists: InputMaybe<Scalars['Boolean']['input']>;
  privateFoundationReportsHeader_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  privateFoundationReportsHeader_not: InputMaybe<Scalars['String']['input']>;
  privateFoundationReportsHeader_not_contains: InputMaybe<Scalars['String']['input']>;
  privateFoundationReportsHeader_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quickLinks: InputMaybe<CfConnectWithNestedFilter>;
  quickLinks_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialBondFramework: InputMaybe<Scalars['String']['input']>;
  socialBondFrameworkLink: InputMaybe<CfConnectWithLinkNestedFilter>;
  socialBondFrameworkLink_exists: InputMaybe<Scalars['Boolean']['input']>;
  socialBondFrameworkText: InputMaybe<Scalars['String']['input']>;
  socialBondFrameworkText_contains: InputMaybe<Scalars['String']['input']>;
  socialBondFrameworkText_exists: InputMaybe<Scalars['Boolean']['input']>;
  socialBondFrameworkText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialBondFrameworkText_not: InputMaybe<Scalars['String']['input']>;
  socialBondFrameworkText_not_contains: InputMaybe<Scalars['String']['input']>;
  socialBondFrameworkText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialBondFramework_contains: InputMaybe<Scalars['String']['input']>;
  socialBondFramework_exists: InputMaybe<Scalars['Boolean']['input']>;
  socialBondFramework_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialBondFramework_not: InputMaybe<Scalars['String']['input']>;
  socialBondFramework_not_contains: InputMaybe<Scalars['String']['input']>;
  socialBondFramework_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FinancialsPageGraphsSection = {
  __typename: 'FinancialsPageGraphsSection';
  json: Scalars['JSON']['output'];
  links: FinancialsPageGraphsSectionLinks;
};

export type FinancialsPageGraphsSectionAssets = {
  __typename: 'FinancialsPageGraphsSectionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type FinancialsPageGraphsSectionEntries = {
  __typename: 'FinancialsPageGraphsSectionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type FinancialsPageGraphsSectionLinks = {
  __typename: 'FinancialsPageGraphsSectionLinks';
  assets: FinancialsPageGraphsSectionAssets;
  entries: FinancialsPageGraphsSectionEntries;
  resources: FinancialsPageGraphsSectionResources;
};

export type FinancialsPageGraphsSectionResources = {
  __typename: 'FinancialsPageGraphsSectionResources';
  block: Array<FinancialsPageGraphsSectionResourcesBlock>;
  hyperlink: Array<FinancialsPageGraphsSectionResourcesHyperlink>;
  inline: Array<FinancialsPageGraphsSectionResourcesInline>;
};

export type FinancialsPageGraphsSectionResourcesBlock = ResourceLink & {
  __typename: 'FinancialsPageGraphsSectionResourcesBlock';
  sys: ResourceSys;
};

export type FinancialsPageGraphsSectionResourcesHyperlink = ResourceLink & {
  __typename: 'FinancialsPageGraphsSectionResourcesHyperlink';
  sys: ResourceSys;
};

export type FinancialsPageGraphsSectionResourcesInline = ResourceLink & {
  __typename: 'FinancialsPageGraphsSectionResourcesInline';
  sys: ResourceSys;
};

export type FinancialsPageLinkingCollections = {
  __typename: 'FinancialsPageLinkingCollections';
  connectWithLinkCollection: Maybe<ConnectWithLinkCollection>;
  connectWithLinkCursorCollection: Maybe<ConnectWithLinkCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  mainNavigationCollection: Maybe<MainNavigationCollection>;
  mainNavigationCursorCollection: Maybe<MainNavigationCursorCollection>;
};


export type FinancialsPageLinkingCollectionsConnectWithLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FinancialsPageLinkingCollectionsConnectWithLinkCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type FinancialsPageLinkingCollectionsConnectWithLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FinancialsPageLinkingCollectionsConnectWithLinkCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type FinancialsPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type FinancialsPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type FinancialsPageLinkingCollectionsMainNavigationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FinancialsPageLinkingCollectionsMainNavigationCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type FinancialsPageLinkingCollectionsMainNavigationCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FinancialsPageLinkingCollectionsMainNavigationCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum FinancialsPageLinkingCollectionsConnectWithLinkCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum FinancialsPageLinkingCollectionsConnectWithLinkCursorCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum FinancialsPageLinkingCollectionsMainNavigationCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum FinancialsPageLinkingCollectionsMainNavigationCursorCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum FinancialsPageOrder {
  AuditedFinancialStatementsHeaderAsc = 'auditedFinancialStatementsHeader_ASC',
  AuditedFinancialStatementsHeaderDesc = 'auditedFinancialStatementsHeader_DESC',
  FinancialReportsHeaderAsc = 'financialReportsHeader_ASC',
  FinancialReportsHeaderDesc = 'financialReportsHeader_DESC',
  PrivateFoundationReportsHeaderAsc = 'privateFoundationReportsHeader_ASC',
  PrivateFoundationReportsHeaderDesc = 'privateFoundationReportsHeader_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SocialBondFrameworkAsc = 'socialBondFramework_ASC',
  SocialBondFrameworkDesc = 'socialBondFramework_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/footer) */
export type Footer = Entry & _Node & {
  __typename: 'Footer';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  footerLinksCollection: Maybe<FooterFooterLinksCollection>;
  footerLinksCursorCollection: Maybe<FooterFooterLinksCursorCollection>;
  linkedFrom: Maybe<FooterLinkingCollections>;
  newsletter: Maybe<NewsletterCard>;
  slug: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/footer) */
export type FooterFooterLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FooterFooterLinksCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ConnectWithLinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/footer) */
export type FooterFooterLinksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FooterFooterLinksCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ConnectWithLinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/footer) */
export type FooterLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/footer) */
export type FooterNewsletterArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<NewsletterCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/footer) */
export type FooterSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/footer) */
export type FooterTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type FooterCollection = {
  __typename: 'FooterCollection';
  items: Array<Maybe<Footer>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type FooterCursorCollection = {
  __typename: 'FooterCursorCollection';
  items: Array<Maybe<Footer>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type FooterFilter = {
  AND: InputMaybe<Array<InputMaybe<FooterFilter>>>;
  OR: InputMaybe<Array<InputMaybe<FooterFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  footerLinks: InputMaybe<CfConnectWithLinkNestedFilter>;
  footerLinksCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  newsletter: InputMaybe<CfNewsletterCardNestedFilter>;
  newsletter_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FooterFooterLinksCollection = {
  __typename: 'FooterFooterLinksCollection';
  items: Array<Maybe<ConnectWithLink>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum FooterFooterLinksCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type FooterFooterLinksCursorCollection = {
  __typename: 'FooterFooterLinksCursorCollection';
  items: Array<Maybe<ConnectWithLink>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum FooterFooterLinksCursorCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type FooterLinkingCollections = {
  __typename: 'FooterLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type FooterLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type FooterLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum FooterOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grant) */
export type Grant = Entry & _Node & {
  __typename: 'Grant';
  _id: Scalars['ID']['output'];
  amount: Maybe<Scalars['Float']['output']>;
  areaOfFocus: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  date: Maybe<Scalars['DateTime']['output']>;
  description: Maybe<Scalars['String']['output']>;
  durationInMonths: Maybe<Scalars['Int']['output']>;
  grantmakingArea: Maybe<GrantmakingArea>;
  id: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<GrantLinkingCollections>;
  organization: Maybe<Organisation>;
  projectTitle: Maybe<Scalars['String']['output']>;
  referenceId: Maybe<Scalars['String']['output']>;
  sys: Sys;
  taxonomies: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grant) */
export type GrantAmountArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grant) */
export type GrantAreaOfFocusArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grant) */
export type GrantDateArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grant) */
export type GrantDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grant) */
export type GrantDurationInMonthsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grant) */
export type GrantGrantmakingAreaArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantmakingAreaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grant) */
export type GrantIdArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grant) */
export type GrantLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grant) */
export type GrantOrganizationArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<OrganisationFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grant) */
export type GrantProjectTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grant) */
export type GrantReferenceIdArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grant) */
export type GrantTaxonomiesArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantActivityArticle) */
export type GrantActivityArticle = Entry & _Node & {
  __typename: 'GrantActivityArticle';
  _id: Scalars['ID']['output'];
  audio: Maybe<Asset>;
  author: Maybe<Scalars['String']['output']>;
  body: Maybe<GrantActivityArticleBody>;
  connectLinksCollection: Maybe<GrantActivityArticleConnectLinksCollection>;
  connectLinksCursorCollection: Maybe<GrantActivityArticleConnectLinksCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  creditLabel: Maybe<Scalars['String']['output']>;
  creditText: Maybe<Scalars['String']['output']>;
  date: Maybe<Scalars['DateTime']['output']>;
  description: Maybe<Scalars['String']['output']>;
  experienceBlock: Maybe<ExperienceBlock>;
  formattingOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  grant: Maybe<Grant>;
  grantInsight: Maybe<Scalars['String']['output']>;
  granteeCityOverride: Maybe<Scalars['String']['output']>;
  granteeCountryOverride: Maybe<Scalars['String']['output']>;
  granteeNameOverride: Maybe<Scalars['String']['output']>;
  granteeStateOverride: Maybe<Scalars['String']['output']>;
  hero: Maybe<HeroAsset>;
  hideDate: Maybe<Scalars['Boolean']['output']>;
  hideShareLink: Maybe<Scalars['Boolean']['output']>;
  leadImage: Maybe<Asset>;
  linkedFrom: Maybe<GrantActivityArticleLinkingCollections>;
  metadata: Maybe<Metadata>;
  photographer: Maybe<Scalars['String']['output']>;
  relatedArticlesCollection: Maybe<GrantActivityArticleRelatedArticlesCollection>;
  relatedArticlesCursorCollection: Maybe<GrantActivityArticleRelatedArticlesCursorCollection>;
  slug: Maybe<Scalars['String']['output']>;
  sys: Sys;
  thumbnailImage: Maybe<Asset>;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantActivityArticle) */
export type GrantActivityArticleAudioArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantActivityArticle) */
export type GrantActivityArticleAuthorArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantActivityArticle) */
export type GrantActivityArticleBodyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantActivityArticle) */
export type GrantActivityArticleConnectLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantActivityArticleConnectLinksCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ConnectWithLinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantActivityArticle) */
export type GrantActivityArticleConnectLinksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantActivityArticleConnectLinksCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ConnectWithLinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantActivityArticle) */
export type GrantActivityArticleCreditLabelArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantActivityArticle) */
export type GrantActivityArticleCreditTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantActivityArticle) */
export type GrantActivityArticleDateArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantActivityArticle) */
export type GrantActivityArticleDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantActivityArticle) */
export type GrantActivityArticleExperienceBlockArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ExperienceBlockFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantActivityArticle) */
export type GrantActivityArticleFormattingOptionsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantActivityArticle) */
export type GrantActivityArticleGrantArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantActivityArticle) */
export type GrantActivityArticleGrantInsightArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantActivityArticle) */
export type GrantActivityArticleGranteeCityOverrideArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantActivityArticle) */
export type GrantActivityArticleGranteeCountryOverrideArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantActivityArticle) */
export type GrantActivityArticleGranteeNameOverrideArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantActivityArticle) */
export type GrantActivityArticleGranteeStateOverrideArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantActivityArticle) */
export type GrantActivityArticleHeroArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<HeroAssetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantActivityArticle) */
export type GrantActivityArticleHideDateArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantActivityArticle) */
export type GrantActivityArticleHideShareLinkArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantActivityArticle) */
export type GrantActivityArticleLeadImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantActivityArticle) */
export type GrantActivityArticleLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantActivityArticle) */
export type GrantActivityArticleMetadataArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<MetadataFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantActivityArticle) */
export type GrantActivityArticlePhotographerArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantActivityArticle) */
export type GrantActivityArticleRelatedArticlesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantActivityArticleRelatedArticlesFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantActivityArticle) */
export type GrantActivityArticleRelatedArticlesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantActivityArticleRelatedArticlesFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantActivityArticle) */
export type GrantActivityArticleSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantActivityArticle) */
export type GrantActivityArticleThumbnailImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantActivityArticle) */
export type GrantActivityArticleTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type GrantActivityArticleBody = {
  __typename: 'GrantActivityArticleBody';
  json: Scalars['JSON']['output'];
  links: GrantActivityArticleBodyLinks;
};

export type GrantActivityArticleBodyAssets = {
  __typename: 'GrantActivityArticleBodyAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type GrantActivityArticleBodyEntries = {
  __typename: 'GrantActivityArticleBodyEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type GrantActivityArticleBodyLinks = {
  __typename: 'GrantActivityArticleBodyLinks';
  assets: GrantActivityArticleBodyAssets;
  entries: GrantActivityArticleBodyEntries;
  resources: GrantActivityArticleBodyResources;
};

export type GrantActivityArticleBodyResources = {
  __typename: 'GrantActivityArticleBodyResources';
  block: Array<GrantActivityArticleBodyResourcesBlock>;
  hyperlink: Array<GrantActivityArticleBodyResourcesHyperlink>;
  inline: Array<GrantActivityArticleBodyResourcesInline>;
};

export type GrantActivityArticleBodyResourcesBlock = ResourceLink & {
  __typename: 'GrantActivityArticleBodyResourcesBlock';
  sys: ResourceSys;
};

export type GrantActivityArticleBodyResourcesHyperlink = ResourceLink & {
  __typename: 'GrantActivityArticleBodyResourcesHyperlink';
  sys: ResourceSys;
};

export type GrantActivityArticleBodyResourcesInline = ResourceLink & {
  __typename: 'GrantActivityArticleBodyResourcesInline';
  sys: ResourceSys;
};

export type GrantActivityArticleCollection = {
  __typename: 'GrantActivityArticleCollection';
  items: Array<Maybe<GrantActivityArticle>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type GrantActivityArticleConnectLinksCollection = {
  __typename: 'GrantActivityArticleConnectLinksCollection';
  items: Array<Maybe<ConnectWithLink>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum GrantActivityArticleConnectLinksCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type GrantActivityArticleConnectLinksCursorCollection = {
  __typename: 'GrantActivityArticleConnectLinksCursorCollection';
  items: Array<Maybe<ConnectWithLink>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum GrantActivityArticleConnectLinksCursorCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type GrantActivityArticleCursorCollection = {
  __typename: 'GrantActivityArticleCursorCollection';
  items: Array<Maybe<GrantActivityArticle>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type GrantActivityArticleFilter = {
  AND: InputMaybe<Array<InputMaybe<GrantActivityArticleFilter>>>;
  OR: InputMaybe<Array<InputMaybe<GrantActivityArticleFilter>>>;
  audio_exists: InputMaybe<Scalars['Boolean']['input']>;
  author: InputMaybe<Scalars['String']['input']>;
  author_contains: InputMaybe<Scalars['String']['input']>;
  author_exists: InputMaybe<Scalars['Boolean']['input']>;
  author_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  author_not: InputMaybe<Scalars['String']['input']>;
  author_not_contains: InputMaybe<Scalars['String']['input']>;
  author_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_contains: InputMaybe<Scalars['String']['input']>;
  body_exists: InputMaybe<Scalars['Boolean']['input']>;
  body_not_contains: InputMaybe<Scalars['String']['input']>;
  connectLinks: InputMaybe<CfConnectWithLinkNestedFilter>;
  connectLinksCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  creditLabel: InputMaybe<Scalars['String']['input']>;
  creditLabel_contains: InputMaybe<Scalars['String']['input']>;
  creditLabel_exists: InputMaybe<Scalars['Boolean']['input']>;
  creditLabel_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  creditLabel_not: InputMaybe<Scalars['String']['input']>;
  creditLabel_not_contains: InputMaybe<Scalars['String']['input']>;
  creditLabel_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  creditText: InputMaybe<Scalars['String']['input']>;
  creditText_contains: InputMaybe<Scalars['String']['input']>;
  creditText_exists: InputMaybe<Scalars['Boolean']['input']>;
  creditText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  creditText_not: InputMaybe<Scalars['String']['input']>;
  creditText_not_contains: InputMaybe<Scalars['String']['input']>;
  creditText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  date: InputMaybe<Scalars['DateTime']['input']>;
  date_exists: InputMaybe<Scalars['Boolean']['input']>;
  date_gt: InputMaybe<Scalars['DateTime']['input']>;
  date_gte: InputMaybe<Scalars['DateTime']['input']>;
  date_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_lt: InputMaybe<Scalars['DateTime']['input']>;
  date_lte: InputMaybe<Scalars['DateTime']['input']>;
  date_not: InputMaybe<Scalars['DateTime']['input']>;
  date_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  experienceBlock: InputMaybe<CfExperienceBlockNestedFilter>;
  experienceBlock_exists: InputMaybe<Scalars['Boolean']['input']>;
  formattingOptions_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattingOptions_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattingOptions_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattingOptions_exists: InputMaybe<Scalars['Boolean']['input']>;
  grant: InputMaybe<CfGrantNestedFilter>;
  grantInsight: InputMaybe<Scalars['String']['input']>;
  grantInsight_contains: InputMaybe<Scalars['String']['input']>;
  grantInsight_exists: InputMaybe<Scalars['Boolean']['input']>;
  grantInsight_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  grantInsight_not: InputMaybe<Scalars['String']['input']>;
  grantInsight_not_contains: InputMaybe<Scalars['String']['input']>;
  grantInsight_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  grant_exists: InputMaybe<Scalars['Boolean']['input']>;
  granteeCityOverride: InputMaybe<Scalars['String']['input']>;
  granteeCityOverride_contains: InputMaybe<Scalars['String']['input']>;
  granteeCityOverride_exists: InputMaybe<Scalars['Boolean']['input']>;
  granteeCityOverride_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  granteeCityOverride_not: InputMaybe<Scalars['String']['input']>;
  granteeCityOverride_not_contains: InputMaybe<Scalars['String']['input']>;
  granteeCityOverride_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  granteeCountryOverride: InputMaybe<Scalars['String']['input']>;
  granteeCountryOverride_contains: InputMaybe<Scalars['String']['input']>;
  granteeCountryOverride_exists: InputMaybe<Scalars['Boolean']['input']>;
  granteeCountryOverride_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  granteeCountryOverride_not: InputMaybe<Scalars['String']['input']>;
  granteeCountryOverride_not_contains: InputMaybe<Scalars['String']['input']>;
  granteeCountryOverride_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  granteeNameOverride: InputMaybe<Scalars['String']['input']>;
  granteeNameOverride_contains: InputMaybe<Scalars['String']['input']>;
  granteeNameOverride_exists: InputMaybe<Scalars['Boolean']['input']>;
  granteeNameOverride_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  granteeNameOverride_not: InputMaybe<Scalars['String']['input']>;
  granteeNameOverride_not_contains: InputMaybe<Scalars['String']['input']>;
  granteeNameOverride_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  granteeStateOverride: InputMaybe<Scalars['String']['input']>;
  granteeStateOverride_contains: InputMaybe<Scalars['String']['input']>;
  granteeStateOverride_exists: InputMaybe<Scalars['Boolean']['input']>;
  granteeStateOverride_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  granteeStateOverride_not: InputMaybe<Scalars['String']['input']>;
  granteeStateOverride_not_contains: InputMaybe<Scalars['String']['input']>;
  granteeStateOverride_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hero: InputMaybe<CfHeroAssetNestedFilter>;
  hero_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideDate: InputMaybe<Scalars['Boolean']['input']>;
  hideDate_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideDate_not: InputMaybe<Scalars['Boolean']['input']>;
  hideShareLink: InputMaybe<Scalars['Boolean']['input']>;
  hideShareLink_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideShareLink_not: InputMaybe<Scalars['Boolean']['input']>;
  leadImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  metadata: InputMaybe<CfMetadataNestedFilter>;
  metadata_exists: InputMaybe<Scalars['Boolean']['input']>;
  photographer: InputMaybe<Scalars['String']['input']>;
  photographer_contains: InputMaybe<Scalars['String']['input']>;
  photographer_exists: InputMaybe<Scalars['Boolean']['input']>;
  photographer_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  photographer_not: InputMaybe<Scalars['String']['input']>;
  photographer_not_contains: InputMaybe<Scalars['String']['input']>;
  photographer_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedArticles: InputMaybe<CfrelatedArticlesMultiTypeNestedFilter>;
  relatedArticlesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  thumbnailImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GrantActivityArticleLinkingCollections = {
  __typename: 'GrantActivityArticleLinkingCollections';
  articleCollection: Maybe<ArticleCollection>;
  articleCursorCollection: Maybe<ArticleCursorCollection>;
  connectWithLinkCollection: Maybe<ConnectWithLinkCollection>;
  connectWithLinkCursorCollection: Maybe<ConnectWithLinkCursorCollection>;
  emphasizedArticleCollection: Maybe<EmphasizedArticleCollection>;
  emphasizedArticleCursorCollection: Maybe<EmphasizedArticleCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  featureCollection: Maybe<FeatureCollection>;
  featureCursorCollection: Maybe<FeatureCursorCollection>;
  grantActivityArticleCollection: Maybe<GrantActivityArticleCollection>;
  grantActivityArticleCursorCollection: Maybe<GrantActivityArticleCursorCollection>;
  grantDetailsPageCollection: Maybe<GrantDetailsPageCollection>;
  grantDetailsPageCursorCollection: Maybe<GrantDetailsPageCursorCollection>;
  grantResourcesCollection: Maybe<GrantResourcesCollection>;
  grantResourcesCursorCollection: Maybe<GrantResourcesCursorCollection>;
  grantmakingAreaDetailsPageCollection: Maybe<GrantmakingAreaDetailsPageCollection>;
  grantmakingAreaDetailsPageCursorCollection: Maybe<GrantmakingAreaDetailsPageCursorCollection>;
  homePageCollection: Maybe<HomePageCollection>;
  homePageCursorCollection: Maybe<HomePageCursorCollection>;
  ideaCollection: Maybe<IdeaCollection>;
  ideaCursorCollection: Maybe<IdeaCursorCollection>;
  inlineCardsCollection: Maybe<InlineCardsCollection>;
  inlineCardsCursorCollection: Maybe<InlineCardsCursorCollection>;
  navigationItemCollection: Maybe<NavigationItemCollection>;
  navigationItemCursorCollection: Maybe<NavigationItemCursorCollection>;
};


export type GrantActivityArticleLinkingCollectionsArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantActivityArticleLinkingCollectionsArticleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantActivityArticleLinkingCollectionsArticleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantActivityArticleLinkingCollectionsArticleCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantActivityArticleLinkingCollectionsConnectWithLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantActivityArticleLinkingCollectionsConnectWithLinkCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantActivityArticleLinkingCollectionsConnectWithLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantActivityArticleLinkingCollectionsConnectWithLinkCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantActivityArticleLinkingCollectionsEmphasizedArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantActivityArticleLinkingCollectionsEmphasizedArticleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantActivityArticleLinkingCollectionsEmphasizedArticleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantActivityArticleLinkingCollectionsEmphasizedArticleCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantActivityArticleLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantActivityArticleLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantActivityArticleLinkingCollectionsFeatureCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantActivityArticleLinkingCollectionsFeatureCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantActivityArticleLinkingCollectionsFeatureCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantActivityArticleLinkingCollectionsFeatureCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantActivityArticleLinkingCollectionsGrantActivityArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantActivityArticleLinkingCollectionsGrantActivityArticleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantActivityArticleLinkingCollectionsGrantActivityArticleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantActivityArticleLinkingCollectionsGrantActivityArticleCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantActivityArticleLinkingCollectionsGrantDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantActivityArticleLinkingCollectionsGrantDetailsPageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantActivityArticleLinkingCollectionsGrantDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantActivityArticleLinkingCollectionsGrantDetailsPageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantActivityArticleLinkingCollectionsGrantResourcesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantActivityArticleLinkingCollectionsGrantResourcesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantActivityArticleLinkingCollectionsGrantResourcesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantActivityArticleLinkingCollectionsGrantResourcesCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantActivityArticleLinkingCollectionsGrantmakingAreaDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantActivityArticleLinkingCollectionsGrantmakingAreaDetailsPageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantActivityArticleLinkingCollectionsGrantmakingAreaDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantActivityArticleLinkingCollectionsGrantmakingAreaDetailsPageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantActivityArticleLinkingCollectionsHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantActivityArticleLinkingCollectionsHomePageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantActivityArticleLinkingCollectionsHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantActivityArticleLinkingCollectionsHomePageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantActivityArticleLinkingCollectionsIdeaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantActivityArticleLinkingCollectionsIdeaCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantActivityArticleLinkingCollectionsIdeaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantActivityArticleLinkingCollectionsIdeaCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantActivityArticleLinkingCollectionsInlineCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantActivityArticleLinkingCollectionsInlineCardsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantActivityArticleLinkingCollectionsInlineCardsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantActivityArticleLinkingCollectionsInlineCardsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantActivityArticleLinkingCollectionsNavigationItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantActivityArticleLinkingCollectionsNavigationItemCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantActivityArticleLinkingCollectionsNavigationItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantActivityArticleLinkingCollectionsNavigationItemCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum GrantActivityArticleLinkingCollectionsArticleCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  ExternalNewsUrlAsc = 'externalNewsUrl_ASC',
  ExternalNewsUrlDesc = 'externalNewsUrl_DESC',
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  PasswordAsc = 'password_ASC',
  PasswordDesc = 'password_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum GrantActivityArticleLinkingCollectionsArticleCursorCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  ExternalNewsUrlAsc = 'externalNewsUrl_ASC',
  ExternalNewsUrlDesc = 'externalNewsUrl_DESC',
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  PasswordAsc = 'password_ASC',
  PasswordDesc = 'password_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum GrantActivityArticleLinkingCollectionsConnectWithLinkCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantActivityArticleLinkingCollectionsConnectWithLinkCursorCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantActivityArticleLinkingCollectionsEmphasizedArticleCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantActivityArticleLinkingCollectionsEmphasizedArticleCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantActivityArticleLinkingCollectionsFeatureCollectionOrder {
  DateTimeAsc = 'dateTime_ASC',
  DateTimeDesc = 'dateTime_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  ShowSocialCtasAsc = 'showSocialCtas_ASC',
  ShowSocialCtasDesc = 'showSocialCtas_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TaglineAsc = 'tagline_ASC',
  TaglineDesc = 'tagline_DESC'
}

export enum GrantActivityArticleLinkingCollectionsFeatureCursorCollectionOrder {
  DateTimeAsc = 'dateTime_ASC',
  DateTimeDesc = 'dateTime_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  ShowSocialCtasAsc = 'showSocialCtas_ASC',
  ShowSocialCtasDesc = 'showSocialCtas_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TaglineAsc = 'tagline_ASC',
  TaglineDesc = 'tagline_DESC'
}

export enum GrantActivityArticleLinkingCollectionsGrantActivityArticleCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  GranteeCityOverrideAsc = 'granteeCityOverride_ASC',
  GranteeCityOverrideDesc = 'granteeCityOverride_DESC',
  GranteeCountryOverrideAsc = 'granteeCountryOverride_ASC',
  GranteeCountryOverrideDesc = 'granteeCountryOverride_DESC',
  GranteeNameOverrideAsc = 'granteeNameOverride_ASC',
  GranteeNameOverrideDesc = 'granteeNameOverride_DESC',
  GranteeStateOverrideAsc = 'granteeStateOverride_ASC',
  GranteeStateOverrideDesc = 'granteeStateOverride_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantActivityArticleLinkingCollectionsGrantActivityArticleCursorCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  GranteeCityOverrideAsc = 'granteeCityOverride_ASC',
  GranteeCityOverrideDesc = 'granteeCityOverride_DESC',
  GranteeCountryOverrideAsc = 'granteeCountryOverride_ASC',
  GranteeCountryOverrideDesc = 'granteeCountryOverride_DESC',
  GranteeNameOverrideAsc = 'granteeNameOverride_ASC',
  GranteeNameOverrideDesc = 'granteeNameOverride_DESC',
  GranteeStateOverrideAsc = 'granteeStateOverride_ASC',
  GranteeStateOverrideDesc = 'granteeStateOverride_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantActivityArticleLinkingCollectionsGrantDetailsPageCollectionOrder {
  StrategyCopyAsc = 'strategyCopy_ASC',
  StrategyCopyDesc = 'strategyCopy_DESC',
  StrategyCtaLabelAsc = 'strategyCtaLabel_ASC',
  StrategyCtaLabelDesc = 'strategyCtaLabel_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantActivityArticleLinkingCollectionsGrantDetailsPageCursorCollectionOrder {
  StrategyCopyAsc = 'strategyCopy_ASC',
  StrategyCopyDesc = 'strategyCopy_DESC',
  StrategyCtaLabelAsc = 'strategyCtaLabel_ASC',
  StrategyCtaLabelDesc = 'strategyCtaLabel_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantActivityArticleLinkingCollectionsGrantResourcesCollectionOrder {
  ExplanatoryTitleAsc = 'explanatoryTitle_ASC',
  ExplanatoryTitleDesc = 'explanatoryTitle_DESC',
  GrantMakingAreasTitleAsc = 'grantMakingAreasTitle_ASC',
  GrantMakingAreasTitleDesc = 'grantMakingAreasTitle_DESC',
  SearchContextualMessageAsc = 'searchContextualMessage_ASC',
  SearchContextualMessageDesc = 'searchContextualMessage_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantActivityArticleLinkingCollectionsGrantResourcesCursorCollectionOrder {
  ExplanatoryTitleAsc = 'explanatoryTitle_ASC',
  ExplanatoryTitleDesc = 'explanatoryTitle_DESC',
  GrantMakingAreasTitleAsc = 'grantMakingAreasTitle_ASC',
  GrantMakingAreasTitleDesc = 'grantMakingAreasTitle_DESC',
  SearchContextualMessageAsc = 'searchContextualMessage_ASC',
  SearchContextualMessageDesc = 'searchContextualMessage_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantActivityArticleLinkingCollectionsGrantmakingAreaDetailsPageCollectionOrder {
  GrantMakingProcessMessageAsc = 'grantMakingProcessMessage_ASC',
  GrantMakingProcessMessageDesc = 'grantMakingProcessMessage_DESC',
  GuidingStrategiesTitleAsc = 'guidingStrategiesTitle_ASC',
  GuidingStrategiesTitleDesc = 'guidingStrategiesTitle_DESC',
  IntroDescriptionAsc = 'introDescription_ASC',
  IntroDescriptionDesc = 'introDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantActivityArticleLinkingCollectionsGrantmakingAreaDetailsPageCursorCollectionOrder {
  GrantMakingProcessMessageAsc = 'grantMakingProcessMessage_ASC',
  GrantMakingProcessMessageDesc = 'grantMakingProcessMessage_DESC',
  GuidingStrategiesTitleAsc = 'guidingStrategiesTitle_ASC',
  GuidingStrategiesTitleDesc = 'guidingStrategiesTitle_DESC',
  IntroDescriptionAsc = 'introDescription_ASC',
  IntroDescriptionDesc = 'introDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantActivityArticleLinkingCollectionsHomePageCollectionOrder {
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  MissionTextAsc = 'missionText_ASC',
  MissionTextDesc = 'missionText_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StoriesCtaAsc = 'storiesCta_ASC',
  StoriesCtaDesc = 'storiesCta_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum GrantActivityArticleLinkingCollectionsHomePageCursorCollectionOrder {
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  MissionTextAsc = 'missionText_ASC',
  MissionTextDesc = 'missionText_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StoriesCtaAsc = 'storiesCta_ASC',
  StoriesCtaDesc = 'storiesCta_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum GrantActivityArticleLinkingCollectionsIdeaCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum GrantActivityArticleLinkingCollectionsIdeaCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum GrantActivityArticleLinkingCollectionsInlineCardsCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantActivityArticleLinkingCollectionsInlineCardsCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantActivityArticleLinkingCollectionsNavigationItemCollectionOrder {
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum GrantActivityArticleLinkingCollectionsNavigationItemCursorCollectionOrder {
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum GrantActivityArticleOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  GranteeCityOverrideAsc = 'granteeCityOverride_ASC',
  GranteeCityOverrideDesc = 'granteeCityOverride_DESC',
  GranteeCountryOverrideAsc = 'granteeCountryOverride_ASC',
  GranteeCountryOverrideDesc = 'granteeCountryOverride_DESC',
  GranteeNameOverrideAsc = 'granteeNameOverride_ASC',
  GranteeNameOverrideDesc = 'granteeNameOverride_DESC',
  GranteeStateOverrideAsc = 'granteeStateOverride_ASC',
  GranteeStateOverrideDesc = 'granteeStateOverride_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type GrantActivityArticleRelatedArticlesCollection = {
  __typename: 'GrantActivityArticleRelatedArticlesCollection';
  items: Array<Maybe<GrantActivityArticleRelatedArticlesItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type GrantActivityArticleRelatedArticlesCursorCollection = {
  __typename: 'GrantActivityArticleRelatedArticlesCursorCollection';
  items: Array<Maybe<GrantActivityArticleRelatedArticlesItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type GrantActivityArticleRelatedArticlesFilter = {
  AND: InputMaybe<Array<InputMaybe<GrantActivityArticleRelatedArticlesFilter>>>;
  OR: InputMaybe<Array<InputMaybe<GrantActivityArticleRelatedArticlesFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
};

export type GrantActivityArticleRelatedArticlesItem = Article | ExternalEvent | Feature | GrantActivityArticle | Idea;

export type GrantCollection = {
  __typename: 'GrantCollection';
  items: Array<Maybe<Grant>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type GrantCursorCollection = {
  __typename: 'GrantCursorCollection';
  items: Array<Maybe<Grant>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantDetailsPage) */
export type GrantDetailsPage = Entry & _Node & {
  __typename: 'GrantDetailsPage';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  grant: Maybe<Grant>;
  granteeInformation: Maybe<ConnectWith>;
  linkedFrom: Maybe<GrantDetailsPageLinkingCollections>;
  relatedActivitiesCollection: Maybe<GrantDetailsPageRelatedActivitiesCollection>;
  relatedActivitiesCursorCollection: Maybe<GrantDetailsPageRelatedActivitiesCursorCollection>;
  strategyCopy: Maybe<Scalars['String']['output']>;
  strategyCtaLabel: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantDetailsPage) */
export type GrantDetailsPageGrantArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantDetailsPage) */
export type GrantDetailsPageGranteeInformationArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ConnectWithFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantDetailsPage) */
export type GrantDetailsPageLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantDetailsPage) */
export type GrantDetailsPageRelatedActivitiesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantDetailsPageRelatedActivitiesFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantDetailsPage) */
export type GrantDetailsPageRelatedActivitiesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantDetailsPageRelatedActivitiesFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantDetailsPage) */
export type GrantDetailsPageStrategyCopyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantDetailsPage) */
export type GrantDetailsPageStrategyCtaLabelArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantDetailsPage) */
export type GrantDetailsPageTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type GrantDetailsPageCollection = {
  __typename: 'GrantDetailsPageCollection';
  items: Array<Maybe<GrantDetailsPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type GrantDetailsPageCursorCollection = {
  __typename: 'GrantDetailsPageCursorCollection';
  items: Array<Maybe<GrantDetailsPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type GrantDetailsPageFilter = {
  AND: InputMaybe<Array<InputMaybe<GrantDetailsPageFilter>>>;
  OR: InputMaybe<Array<InputMaybe<GrantDetailsPageFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  grant: InputMaybe<CfGrantNestedFilter>;
  grant_exists: InputMaybe<Scalars['Boolean']['input']>;
  granteeInformation: InputMaybe<CfConnectWithNestedFilter>;
  granteeInformation_exists: InputMaybe<Scalars['Boolean']['input']>;
  relatedActivities: InputMaybe<CfrelatedActivitiesMultiTypeNestedFilter>;
  relatedActivitiesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  strategyCopy: InputMaybe<Scalars['String']['input']>;
  strategyCopy_contains: InputMaybe<Scalars['String']['input']>;
  strategyCopy_exists: InputMaybe<Scalars['Boolean']['input']>;
  strategyCopy_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  strategyCopy_not: InputMaybe<Scalars['String']['input']>;
  strategyCopy_not_contains: InputMaybe<Scalars['String']['input']>;
  strategyCopy_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  strategyCtaLabel: InputMaybe<Scalars['String']['input']>;
  strategyCtaLabel_contains: InputMaybe<Scalars['String']['input']>;
  strategyCtaLabel_exists: InputMaybe<Scalars['Boolean']['input']>;
  strategyCtaLabel_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  strategyCtaLabel_not: InputMaybe<Scalars['String']['input']>;
  strategyCtaLabel_not_contains: InputMaybe<Scalars['String']['input']>;
  strategyCtaLabel_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GrantDetailsPageLinkingCollections = {
  __typename: 'GrantDetailsPageLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  navigationItemCollection: Maybe<NavigationItemCollection>;
  navigationItemCursorCollection: Maybe<NavigationItemCursorCollection>;
};


export type GrantDetailsPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantDetailsPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantDetailsPageLinkingCollectionsNavigationItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantDetailsPageLinkingCollectionsNavigationItemCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantDetailsPageLinkingCollectionsNavigationItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantDetailsPageLinkingCollectionsNavigationItemCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum GrantDetailsPageLinkingCollectionsNavigationItemCollectionOrder {
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum GrantDetailsPageLinkingCollectionsNavigationItemCursorCollectionOrder {
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum GrantDetailsPageOrder {
  StrategyCopyAsc = 'strategyCopy_ASC',
  StrategyCopyDesc = 'strategyCopy_DESC',
  StrategyCtaLabelAsc = 'strategyCtaLabel_ASC',
  StrategyCtaLabelDesc = 'strategyCtaLabel_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type GrantDetailsPageRelatedActivitiesCollection = {
  __typename: 'GrantDetailsPageRelatedActivitiesCollection';
  items: Array<Maybe<GrantDetailsPageRelatedActivitiesItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type GrantDetailsPageRelatedActivitiesCursorCollection = {
  __typename: 'GrantDetailsPageRelatedActivitiesCursorCollection';
  items: Array<Maybe<GrantDetailsPageRelatedActivitiesItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type GrantDetailsPageRelatedActivitiesFilter = {
  AND: InputMaybe<Array<InputMaybe<GrantDetailsPageRelatedActivitiesFilter>>>;
  OR: InputMaybe<Array<InputMaybe<GrantDetailsPageRelatedActivitiesFilter>>>;
  audio_exists: InputMaybe<Scalars['Boolean']['input']>;
  author: InputMaybe<Scalars['String']['input']>;
  author_contains: InputMaybe<Scalars['String']['input']>;
  author_exists: InputMaybe<Scalars['Boolean']['input']>;
  author_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  author_not: InputMaybe<Scalars['String']['input']>;
  author_not_contains: InputMaybe<Scalars['String']['input']>;
  author_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_contains: InputMaybe<Scalars['String']['input']>;
  body_exists: InputMaybe<Scalars['Boolean']['input']>;
  body_not_contains: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  creditLabel: InputMaybe<Scalars['String']['input']>;
  creditLabel_contains: InputMaybe<Scalars['String']['input']>;
  creditLabel_exists: InputMaybe<Scalars['Boolean']['input']>;
  creditLabel_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  creditLabel_not: InputMaybe<Scalars['String']['input']>;
  creditLabel_not_contains: InputMaybe<Scalars['String']['input']>;
  creditLabel_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  creditText: InputMaybe<Scalars['String']['input']>;
  creditText_contains: InputMaybe<Scalars['String']['input']>;
  creditText_exists: InputMaybe<Scalars['Boolean']['input']>;
  creditText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  creditText_not: InputMaybe<Scalars['String']['input']>;
  creditText_not_contains: InputMaybe<Scalars['String']['input']>;
  creditText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  date: InputMaybe<Scalars['DateTime']['input']>;
  date_exists: InputMaybe<Scalars['Boolean']['input']>;
  date_gt: InputMaybe<Scalars['DateTime']['input']>;
  date_gte: InputMaybe<Scalars['DateTime']['input']>;
  date_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_lt: InputMaybe<Scalars['DateTime']['input']>;
  date_lte: InputMaybe<Scalars['DateTime']['input']>;
  date_not: InputMaybe<Scalars['DateTime']['input']>;
  date_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattingOptions_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattingOptions_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattingOptions_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattingOptions_exists: InputMaybe<Scalars['Boolean']['input']>;
  hero_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideDate: InputMaybe<Scalars['Boolean']['input']>;
  hideDate_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideDate_not: InputMaybe<Scalars['Boolean']['input']>;
  hideShareLink: InputMaybe<Scalars['Boolean']['input']>;
  hideShareLink_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideShareLink_not: InputMaybe<Scalars['Boolean']['input']>;
  metadata_exists: InputMaybe<Scalars['Boolean']['input']>;
  photographer: InputMaybe<Scalars['String']['input']>;
  photographer_contains: InputMaybe<Scalars['String']['input']>;
  photographer_exists: InputMaybe<Scalars['Boolean']['input']>;
  photographer_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  photographer_not: InputMaybe<Scalars['String']['input']>;
  photographer_not_contains: InputMaybe<Scalars['String']['input']>;
  photographer_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  thumbnailImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GrantDetailsPageRelatedActivitiesItem = Article | GrantActivityArticle;

export type GrantFilter = {
  AND: InputMaybe<Array<InputMaybe<GrantFilter>>>;
  OR: InputMaybe<Array<InputMaybe<GrantFilter>>>;
  amount: InputMaybe<Scalars['Float']['input']>;
  amount_exists: InputMaybe<Scalars['Boolean']['input']>;
  amount_gt: InputMaybe<Scalars['Float']['input']>;
  amount_gte: InputMaybe<Scalars['Float']['input']>;
  amount_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  amount_lt: InputMaybe<Scalars['Float']['input']>;
  amount_lte: InputMaybe<Scalars['Float']['input']>;
  amount_not: InputMaybe<Scalars['Float']['input']>;
  amount_not_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  areaOfFocus: InputMaybe<Scalars['String']['input']>;
  areaOfFocus_contains: InputMaybe<Scalars['String']['input']>;
  areaOfFocus_exists: InputMaybe<Scalars['Boolean']['input']>;
  areaOfFocus_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  areaOfFocus_not: InputMaybe<Scalars['String']['input']>;
  areaOfFocus_not_contains: InputMaybe<Scalars['String']['input']>;
  areaOfFocus_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  date: InputMaybe<Scalars['DateTime']['input']>;
  date_exists: InputMaybe<Scalars['Boolean']['input']>;
  date_gt: InputMaybe<Scalars['DateTime']['input']>;
  date_gte: InputMaybe<Scalars['DateTime']['input']>;
  date_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_lt: InputMaybe<Scalars['DateTime']['input']>;
  date_lte: InputMaybe<Scalars['DateTime']['input']>;
  date_not: InputMaybe<Scalars['DateTime']['input']>;
  date_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  durationInMonths: InputMaybe<Scalars['Int']['input']>;
  durationInMonths_exists: InputMaybe<Scalars['Boolean']['input']>;
  durationInMonths_gt: InputMaybe<Scalars['Int']['input']>;
  durationInMonths_gte: InputMaybe<Scalars['Int']['input']>;
  durationInMonths_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  durationInMonths_lt: InputMaybe<Scalars['Int']['input']>;
  durationInMonths_lte: InputMaybe<Scalars['Int']['input']>;
  durationInMonths_not: InputMaybe<Scalars['Int']['input']>;
  durationInMonths_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  grantmakingArea: InputMaybe<CfGrantmakingAreaNestedFilter>;
  grantmakingArea_exists: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['String']['input']>;
  id_contains: InputMaybe<Scalars['String']['input']>;
  id_exists: InputMaybe<Scalars['Boolean']['input']>;
  id_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not: InputMaybe<Scalars['String']['input']>;
  id_not_contains: InputMaybe<Scalars['String']['input']>;
  id_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organization: InputMaybe<CfOrganisationNestedFilter>;
  organization_exists: InputMaybe<Scalars['Boolean']['input']>;
  projectTitle: InputMaybe<Scalars['String']['input']>;
  projectTitle_contains: InputMaybe<Scalars['String']['input']>;
  projectTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  projectTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  projectTitle_not: InputMaybe<Scalars['String']['input']>;
  projectTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  projectTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  referenceId: InputMaybe<Scalars['String']['input']>;
  referenceId_contains: InputMaybe<Scalars['String']['input']>;
  referenceId_exists: InputMaybe<Scalars['Boolean']['input']>;
  referenceId_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  referenceId_not: InputMaybe<Scalars['String']['input']>;
  referenceId_not_contains: InputMaybe<Scalars['String']['input']>;
  referenceId_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  taxonomies_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taxonomies_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taxonomies_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taxonomies_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type GrantLinkingCollections = {
  __typename: 'GrantLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  featureCollection: Maybe<FeatureCollection>;
  featureCursorCollection: Maybe<FeatureCursorCollection>;
  grantActivityArticleCollection: Maybe<GrantActivityArticleCollection>;
  grantActivityArticleCursorCollection: Maybe<GrantActivityArticleCursorCollection>;
  grantDetailsPageCollection: Maybe<GrantDetailsPageCollection>;
  grantDetailsPageCursorCollection: Maybe<GrantDetailsPageCursorCollection>;
  ideaCollection: Maybe<IdeaCollection>;
  ideaCursorCollection: Maybe<IdeaCursorCollection>;
  initiativeQuoteCallOutCollection: Maybe<InitiativeQuoteCallOutCollection>;
  initiativeQuoteCallOutCursorCollection: Maybe<InitiativeQuoteCallOutCursorCollection>;
};


export type GrantLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantLinkingCollectionsFeatureCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantLinkingCollectionsFeatureCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantLinkingCollectionsFeatureCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantLinkingCollectionsFeatureCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantLinkingCollectionsGrantActivityArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantLinkingCollectionsGrantActivityArticleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantLinkingCollectionsGrantActivityArticleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantLinkingCollectionsGrantActivityArticleCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantLinkingCollectionsGrantDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantLinkingCollectionsGrantDetailsPageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantLinkingCollectionsGrantDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantLinkingCollectionsGrantDetailsPageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantLinkingCollectionsIdeaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantLinkingCollectionsIdeaCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantLinkingCollectionsIdeaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantLinkingCollectionsIdeaCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantLinkingCollectionsInitiativeQuoteCallOutCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantLinkingCollectionsInitiativeQuoteCallOutCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantLinkingCollectionsInitiativeQuoteCallOutCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantLinkingCollectionsInitiativeQuoteCallOutCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum GrantLinkingCollectionsFeatureCollectionOrder {
  DateTimeAsc = 'dateTime_ASC',
  DateTimeDesc = 'dateTime_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  ShowSocialCtasAsc = 'showSocialCtas_ASC',
  ShowSocialCtasDesc = 'showSocialCtas_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TaglineAsc = 'tagline_ASC',
  TaglineDesc = 'tagline_DESC'
}

export enum GrantLinkingCollectionsFeatureCursorCollectionOrder {
  DateTimeAsc = 'dateTime_ASC',
  DateTimeDesc = 'dateTime_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  ShowSocialCtasAsc = 'showSocialCtas_ASC',
  ShowSocialCtasDesc = 'showSocialCtas_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TaglineAsc = 'tagline_ASC',
  TaglineDesc = 'tagline_DESC'
}

export enum GrantLinkingCollectionsGrantActivityArticleCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  GranteeCityOverrideAsc = 'granteeCityOverride_ASC',
  GranteeCityOverrideDesc = 'granteeCityOverride_DESC',
  GranteeCountryOverrideAsc = 'granteeCountryOverride_ASC',
  GranteeCountryOverrideDesc = 'granteeCountryOverride_DESC',
  GranteeNameOverrideAsc = 'granteeNameOverride_ASC',
  GranteeNameOverrideDesc = 'granteeNameOverride_DESC',
  GranteeStateOverrideAsc = 'granteeStateOverride_ASC',
  GranteeStateOverrideDesc = 'granteeStateOverride_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantLinkingCollectionsGrantActivityArticleCursorCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  GranteeCityOverrideAsc = 'granteeCityOverride_ASC',
  GranteeCityOverrideDesc = 'granteeCityOverride_DESC',
  GranteeCountryOverrideAsc = 'granteeCountryOverride_ASC',
  GranteeCountryOverrideDesc = 'granteeCountryOverride_DESC',
  GranteeNameOverrideAsc = 'granteeNameOverride_ASC',
  GranteeNameOverrideDesc = 'granteeNameOverride_DESC',
  GranteeStateOverrideAsc = 'granteeStateOverride_ASC',
  GranteeStateOverrideDesc = 'granteeStateOverride_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantLinkingCollectionsGrantDetailsPageCollectionOrder {
  StrategyCopyAsc = 'strategyCopy_ASC',
  StrategyCopyDesc = 'strategyCopy_DESC',
  StrategyCtaLabelAsc = 'strategyCtaLabel_ASC',
  StrategyCtaLabelDesc = 'strategyCtaLabel_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantLinkingCollectionsGrantDetailsPageCursorCollectionOrder {
  StrategyCopyAsc = 'strategyCopy_ASC',
  StrategyCopyDesc = 'strategyCopy_DESC',
  StrategyCtaLabelAsc = 'strategyCtaLabel_ASC',
  StrategyCtaLabelDesc = 'strategyCtaLabel_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantLinkingCollectionsIdeaCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum GrantLinkingCollectionsIdeaCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum GrantLinkingCollectionsInitiativeQuoteCallOutCollectionOrder {
  InitiativeCtaTextAsc = 'initiativeCtaText_ASC',
  InitiativeCtaTextDesc = 'initiativeCtaText_DESC',
  InitiativeHeadingAsc = 'initiativeHeading_ASC',
  InitiativeHeadingDesc = 'initiativeHeading_DESC',
  InitiativeTextAsc = 'initiativeText_ASC',
  InitiativeTextDesc = 'initiativeText_DESC',
  InitiativeTitleAsc = 'initiativeTitle_ASC',
  InitiativeTitleDesc = 'initiativeTitle_DESC',
  SearchQueryAsc = 'searchQuery_ASC',
  SearchQueryDesc = 'searchQuery_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantLinkingCollectionsInitiativeQuoteCallOutCursorCollectionOrder {
  InitiativeCtaTextAsc = 'initiativeCtaText_ASC',
  InitiativeCtaTextDesc = 'initiativeCtaText_DESC',
  InitiativeHeadingAsc = 'initiativeHeading_ASC',
  InitiativeHeadingDesc = 'initiativeHeading_DESC',
  InitiativeTextAsc = 'initiativeText_ASC',
  InitiativeTextDesc = 'initiativeText_DESC',
  InitiativeTitleAsc = 'initiativeTitle_ASC',
  InitiativeTitleDesc = 'initiativeTitle_DESC',
  SearchQueryAsc = 'searchQuery_ASC',
  SearchQueryDesc = 'searchQuery_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantOrder {
  AmountAsc = 'amount_ASC',
  AmountDesc = 'amount_DESC',
  AreaOfFocusAsc = 'areaOfFocus_ASC',
  AreaOfFocusDesc = 'areaOfFocus_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  DurationInMonthsAsc = 'durationInMonths_ASC',
  DurationInMonthsDesc = 'durationInMonths_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ProjectTitleAsc = 'projectTitle_ASC',
  ProjectTitleDesc = 'projectTitle_DESC',
  ReferenceIdAsc = 'referenceId_ASC',
  ReferenceIdDesc = 'referenceId_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantResources) */
export type GrantResources = Entry & _Node & {
  __typename: 'GrantResources';
  _id: Scalars['ID']['output'];
  callForConceptsCollection: Maybe<GrantResourcesCallForConceptsCollection>;
  callForConceptsCursorCollection: Maybe<GrantResourcesCallForConceptsCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  explanatoryParagraph: Maybe<Scalars['String']['output']>;
  explanatoryTitle: Maybe<Scalars['String']['output']>;
  faqs: Maybe<FaqsModule>;
  grantActivityArticlesCollection: Maybe<GrantResourcesGrantActivityArticlesCollection>;
  grantActivityArticlesCursorCollection: Maybe<GrantResourcesGrantActivityArticlesCursorCollection>;
  grantMakingAreasCollection: Maybe<GrantResourcesGrantMakingAreasCollection>;
  grantMakingAreasCursorCollection: Maybe<GrantResourcesGrantMakingAreasCursorCollection>;
  grantMakingAreasTitle: Maybe<Scalars['String']['output']>;
  grantsAtGlanceCollection: Maybe<GrantResourcesGrantsAtGlanceCollection>;
  grantsAtGlanceCursorCollection: Maybe<GrantResourcesGrantsAtGlanceCursorCollection>;
  introDescription: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<GrantResourcesLinkingCollections>;
  newsletter: Maybe<NewsletterCard>;
  pullQuote: Maybe<Quote>;
  quickLinks: Maybe<ConnectWith>;
  searchContextualMessage: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  spotlight: Maybe<GrantResourcesSpotlight>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantResources) */
export type GrantResourcesCallForConceptsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantResourcesCallForConceptsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CallForConceptFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantResources) */
export type GrantResourcesCallForConceptsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantResourcesCallForConceptsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CallForConceptFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantResources) */
export type GrantResourcesExplanatoryParagraphArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantResources) */
export type GrantResourcesExplanatoryTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantResources) */
export type GrantResourcesFaqsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<FaqsModuleFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantResources) */
export type GrantResourcesGrantActivityArticlesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantResourcesGrantActivityArticlesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantActivityArticleFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantResources) */
export type GrantResourcesGrantActivityArticlesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantResourcesGrantActivityArticlesCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantActivityArticleFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantResources) */
export type GrantResourcesGrantMakingAreasCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantResourcesGrantMakingAreasCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantmakingAreaDetailsPageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantResources) */
export type GrantResourcesGrantMakingAreasCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantResourcesGrantMakingAreasCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantmakingAreaDetailsPageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantResources) */
export type GrantResourcesGrantMakingAreasTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantResources) */
export type GrantResourcesGrantsAtGlanceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantResourcesGrantsAtGlanceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<AtGlanceCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantResources) */
export type GrantResourcesGrantsAtGlanceCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantResourcesGrantsAtGlanceCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<AtGlanceCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantResources) */
export type GrantResourcesIntroDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantResources) */
export type GrantResourcesLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantResources) */
export type GrantResourcesNewsletterArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<NewsletterCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantResources) */
export type GrantResourcesPullQuoteArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<QuoteFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantResources) */
export type GrantResourcesQuickLinksArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ConnectWithFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantResources) */
export type GrantResourcesSearchContextualMessageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantResources) */
export type GrantResourcesSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantResources) */
export type GrantResourcesSpotlightArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantResources) */
export type GrantResourcesTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type GrantResourcesCallForConceptsCollection = {
  __typename: 'GrantResourcesCallForConceptsCollection';
  items: Array<Maybe<CallForConcept>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum GrantResourcesCallForConceptsCollectionOrder {
  CallForConceptTitleAsc = 'callForConceptTitle_ASC',
  CallForConceptTitleDesc = 'callForConceptTitle_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  RegistrationDeadlineDateAsc = 'registrationDeadlineDate_ASC',
  RegistrationDeadlineDateDesc = 'registrationDeadlineDate_DESC',
  RegistrationDeadlineTitleAsc = 'registrationDeadlineTitle_ASC',
  RegistrationDeadlineTitleDesc = 'registrationDeadlineTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export type GrantResourcesCallForConceptsCursorCollection = {
  __typename: 'GrantResourcesCallForConceptsCursorCollection';
  items: Array<Maybe<CallForConcept>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum GrantResourcesCallForConceptsCursorCollectionOrder {
  CallForConceptTitleAsc = 'callForConceptTitle_ASC',
  CallForConceptTitleDesc = 'callForConceptTitle_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  RegistrationDeadlineDateAsc = 'registrationDeadlineDate_ASC',
  RegistrationDeadlineDateDesc = 'registrationDeadlineDate_DESC',
  RegistrationDeadlineTitleAsc = 'registrationDeadlineTitle_ASC',
  RegistrationDeadlineTitleDesc = 'registrationDeadlineTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export type GrantResourcesCollection = {
  __typename: 'GrantResourcesCollection';
  items: Array<Maybe<GrantResources>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type GrantResourcesCursorCollection = {
  __typename: 'GrantResourcesCursorCollection';
  items: Array<Maybe<GrantResources>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type GrantResourcesFilter = {
  AND: InputMaybe<Array<InputMaybe<GrantResourcesFilter>>>;
  OR: InputMaybe<Array<InputMaybe<GrantResourcesFilter>>>;
  callForConcepts: InputMaybe<CfCallForConceptNestedFilter>;
  callForConceptsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  explanatoryParagraph: InputMaybe<Scalars['String']['input']>;
  explanatoryParagraph_contains: InputMaybe<Scalars['String']['input']>;
  explanatoryParagraph_exists: InputMaybe<Scalars['Boolean']['input']>;
  explanatoryParagraph_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  explanatoryParagraph_not: InputMaybe<Scalars['String']['input']>;
  explanatoryParagraph_not_contains: InputMaybe<Scalars['String']['input']>;
  explanatoryParagraph_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  explanatoryTitle: InputMaybe<Scalars['String']['input']>;
  explanatoryTitle_contains: InputMaybe<Scalars['String']['input']>;
  explanatoryTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  explanatoryTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  explanatoryTitle_not: InputMaybe<Scalars['String']['input']>;
  explanatoryTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  explanatoryTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faqs: InputMaybe<CfFaqsModuleNestedFilter>;
  faqs_exists: InputMaybe<Scalars['Boolean']['input']>;
  grantActivityArticles: InputMaybe<CfGrantActivityArticleNestedFilter>;
  grantActivityArticlesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  grantMakingAreas: InputMaybe<CfGrantmakingAreaDetailsPageNestedFilter>;
  grantMakingAreasCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  grantMakingAreasTitle: InputMaybe<Scalars['String']['input']>;
  grantMakingAreasTitle_contains: InputMaybe<Scalars['String']['input']>;
  grantMakingAreasTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  grantMakingAreasTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  grantMakingAreasTitle_not: InputMaybe<Scalars['String']['input']>;
  grantMakingAreasTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  grantMakingAreasTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  grantsAtGlance: InputMaybe<CfAtGlanceCardNestedFilter>;
  grantsAtGlanceCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  introDescription: InputMaybe<Scalars['String']['input']>;
  introDescription_contains: InputMaybe<Scalars['String']['input']>;
  introDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  introDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  introDescription_not: InputMaybe<Scalars['String']['input']>;
  introDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  introDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  newsletter: InputMaybe<CfNewsletterCardNestedFilter>;
  newsletter_exists: InputMaybe<Scalars['Boolean']['input']>;
  pullQuote: InputMaybe<CfQuoteNestedFilter>;
  pullQuote_exists: InputMaybe<Scalars['Boolean']['input']>;
  quickLinks: InputMaybe<CfConnectWithNestedFilter>;
  quickLinks_exists: InputMaybe<Scalars['Boolean']['input']>;
  searchContextualMessage: InputMaybe<Scalars['String']['input']>;
  searchContextualMessage_contains: InputMaybe<Scalars['String']['input']>;
  searchContextualMessage_exists: InputMaybe<Scalars['Boolean']['input']>;
  searchContextualMessage_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchContextualMessage_not: InputMaybe<Scalars['String']['input']>;
  searchContextualMessage_not_contains: InputMaybe<Scalars['String']['input']>;
  searchContextualMessage_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  spotlight_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GrantResourcesGrantActivityArticlesCollection = {
  __typename: 'GrantResourcesGrantActivityArticlesCollection';
  items: Array<Maybe<GrantActivityArticle>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum GrantResourcesGrantActivityArticlesCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  GranteeCityOverrideAsc = 'granteeCityOverride_ASC',
  GranteeCityOverrideDesc = 'granteeCityOverride_DESC',
  GranteeCountryOverrideAsc = 'granteeCountryOverride_ASC',
  GranteeCountryOverrideDesc = 'granteeCountryOverride_DESC',
  GranteeNameOverrideAsc = 'granteeNameOverride_ASC',
  GranteeNameOverrideDesc = 'granteeNameOverride_DESC',
  GranteeStateOverrideAsc = 'granteeStateOverride_ASC',
  GranteeStateOverrideDesc = 'granteeStateOverride_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type GrantResourcesGrantActivityArticlesCursorCollection = {
  __typename: 'GrantResourcesGrantActivityArticlesCursorCollection';
  items: Array<Maybe<GrantActivityArticle>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum GrantResourcesGrantActivityArticlesCursorCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  GranteeCityOverrideAsc = 'granteeCityOverride_ASC',
  GranteeCityOverrideDesc = 'granteeCityOverride_DESC',
  GranteeCountryOverrideAsc = 'granteeCountryOverride_ASC',
  GranteeCountryOverrideDesc = 'granteeCountryOverride_DESC',
  GranteeNameOverrideAsc = 'granteeNameOverride_ASC',
  GranteeNameOverrideDesc = 'granteeNameOverride_DESC',
  GranteeStateOverrideAsc = 'granteeStateOverride_ASC',
  GranteeStateOverrideDesc = 'granteeStateOverride_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type GrantResourcesGrantMakingAreasCollection = {
  __typename: 'GrantResourcesGrantMakingAreasCollection';
  items: Array<Maybe<GrantmakingAreaDetailsPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum GrantResourcesGrantMakingAreasCollectionOrder {
  GrantMakingProcessMessageAsc = 'grantMakingProcessMessage_ASC',
  GrantMakingProcessMessageDesc = 'grantMakingProcessMessage_DESC',
  GuidingStrategiesTitleAsc = 'guidingStrategiesTitle_ASC',
  GuidingStrategiesTitleDesc = 'guidingStrategiesTitle_DESC',
  IntroDescriptionAsc = 'introDescription_ASC',
  IntroDescriptionDesc = 'introDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type GrantResourcesGrantMakingAreasCursorCollection = {
  __typename: 'GrantResourcesGrantMakingAreasCursorCollection';
  items: Array<Maybe<GrantmakingAreaDetailsPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum GrantResourcesGrantMakingAreasCursorCollectionOrder {
  GrantMakingProcessMessageAsc = 'grantMakingProcessMessage_ASC',
  GrantMakingProcessMessageDesc = 'grantMakingProcessMessage_DESC',
  GuidingStrategiesTitleAsc = 'guidingStrategiesTitle_ASC',
  GuidingStrategiesTitleDesc = 'guidingStrategiesTitle_DESC',
  IntroDescriptionAsc = 'introDescription_ASC',
  IntroDescriptionDesc = 'introDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type GrantResourcesGrantsAtGlanceCollection = {
  __typename: 'GrantResourcesGrantsAtGlanceCollection';
  items: Array<Maybe<AtGlanceCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum GrantResourcesGrantsAtGlanceCollectionOrder {
  BodyTextAsc = 'bodyText_ASC',
  BodyTextDesc = 'bodyText_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export type GrantResourcesGrantsAtGlanceCursorCollection = {
  __typename: 'GrantResourcesGrantsAtGlanceCursorCollection';
  items: Array<Maybe<AtGlanceCard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum GrantResourcesGrantsAtGlanceCursorCollectionOrder {
  BodyTextAsc = 'bodyText_ASC',
  BodyTextDesc = 'bodyText_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export type GrantResourcesLinkingCollections = {
  __typename: 'GrantResourcesLinkingCollections';
  connectWithLinkCollection: Maybe<ConnectWithLinkCollection>;
  connectWithLinkCursorCollection: Maybe<ConnectWithLinkCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type GrantResourcesLinkingCollectionsConnectWithLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantResourcesLinkingCollectionsConnectWithLinkCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantResourcesLinkingCollectionsConnectWithLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantResourcesLinkingCollectionsConnectWithLinkCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantResourcesLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantResourcesLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum GrantResourcesLinkingCollectionsConnectWithLinkCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantResourcesLinkingCollectionsConnectWithLinkCursorCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantResourcesOrder {
  ExplanatoryTitleAsc = 'explanatoryTitle_ASC',
  ExplanatoryTitleDesc = 'explanatoryTitle_DESC',
  GrantMakingAreasTitleAsc = 'grantMakingAreasTitle_ASC',
  GrantMakingAreasTitleDesc = 'grantMakingAreasTitle_DESC',
  SearchContextualMessageAsc = 'searchContextualMessage_ASC',
  SearchContextualMessageDesc = 'searchContextualMessage_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type GrantResourcesSpotlight = SpotlightSlideshow | SpotlightVideo;

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantSearchFilters) */
export type GrantSearchFilters = Entry & _Node & {
  __typename: 'GrantSearchFilters';
  _id: Scalars['ID']['output'];
  amountCollection: Maybe<GrantSearchFiltersAmountCollection>;
  amountCursorCollection: Maybe<GrantSearchFiltersAmountCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<GrantSearchFiltersLinkingCollections>;
  slug: Maybe<Scalars['String']['output']>;
  sys: Sys;
  termsOfUse: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  yearCollection: Maybe<GrantSearchFiltersYearCollection>;
  yearCursorCollection: Maybe<GrantSearchFiltersYearCursorCollection>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantSearchFilters) */
export type GrantSearchFiltersAmountCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantSearchFiltersAmountFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantSearchFilters) */
export type GrantSearchFiltersAmountCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantSearchFiltersAmountFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantSearchFilters) */
export type GrantSearchFiltersLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantSearchFilters) */
export type GrantSearchFiltersSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantSearchFilters) */
export type GrantSearchFiltersTermsOfUseArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantSearchFilters) */
export type GrantSearchFiltersTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantSearchFilters) */
export type GrantSearchFiltersYearCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantSearchFiltersYearFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantSearchFilters) */
export type GrantSearchFiltersYearCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantSearchFiltersYearFilter>;
};

export type GrantSearchFiltersAmountCollection = {
  __typename: 'GrantSearchFiltersAmountCollection';
  items: Array<Maybe<GrantSearchFiltersAmountItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type GrantSearchFiltersAmountCursorCollection = {
  __typename: 'GrantSearchFiltersAmountCursorCollection';
  items: Array<Maybe<GrantSearchFiltersAmountItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type GrantSearchFiltersAmountFilter = {
  AND: InputMaybe<Array<InputMaybe<GrantSearchFiltersAmountFilter>>>;
  OR: InputMaybe<Array<InputMaybe<GrantSearchFiltersAmountFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type: InputMaybe<Scalars['String']['input']>;
  type_contains: InputMaybe<Scalars['String']['input']>;
  type_exists: InputMaybe<Scalars['Boolean']['input']>;
  type_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not: InputMaybe<Scalars['String']['input']>;
  type_not_contains: InputMaybe<Scalars['String']['input']>;
  type_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GrantSearchFiltersAmountItem = ExplicitValueFilter | RangeValueFilter;

export type GrantSearchFiltersCollection = {
  __typename: 'GrantSearchFiltersCollection';
  items: Array<Maybe<GrantSearchFilters>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type GrantSearchFiltersCursorCollection = {
  __typename: 'GrantSearchFiltersCursorCollection';
  items: Array<Maybe<GrantSearchFilters>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type GrantSearchFiltersFilter = {
  AND: InputMaybe<Array<InputMaybe<GrantSearchFiltersFilter>>>;
  OR: InputMaybe<Array<InputMaybe<GrantSearchFiltersFilter>>>;
  amount: InputMaybe<CfamountMultiTypeNestedFilter>;
  amountCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  termsOfUse: InputMaybe<Scalars['String']['input']>;
  termsOfUse_contains: InputMaybe<Scalars['String']['input']>;
  termsOfUse_exists: InputMaybe<Scalars['Boolean']['input']>;
  termsOfUse_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  termsOfUse_not: InputMaybe<Scalars['String']['input']>;
  termsOfUse_not_contains: InputMaybe<Scalars['String']['input']>;
  termsOfUse_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  year: InputMaybe<CfyearMultiTypeNestedFilter>;
  yearCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type GrantSearchFiltersLinkingCollections = {
  __typename: 'GrantSearchFiltersLinkingCollections';
  connectWithLinkCollection: Maybe<ConnectWithLinkCollection>;
  connectWithLinkCursorCollection: Maybe<ConnectWithLinkCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  navigationItemCollection: Maybe<NavigationItemCollection>;
  navigationItemCursorCollection: Maybe<NavigationItemCursorCollection>;
};


export type GrantSearchFiltersLinkingCollectionsConnectWithLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantSearchFiltersLinkingCollectionsConnectWithLinkCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantSearchFiltersLinkingCollectionsConnectWithLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantSearchFiltersLinkingCollectionsConnectWithLinkCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantSearchFiltersLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantSearchFiltersLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantSearchFiltersLinkingCollectionsNavigationItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantSearchFiltersLinkingCollectionsNavigationItemCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantSearchFiltersLinkingCollectionsNavigationItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantSearchFiltersLinkingCollectionsNavigationItemCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum GrantSearchFiltersLinkingCollectionsConnectWithLinkCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantSearchFiltersLinkingCollectionsConnectWithLinkCursorCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantSearchFiltersLinkingCollectionsNavigationItemCollectionOrder {
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum GrantSearchFiltersLinkingCollectionsNavigationItemCursorCollectionOrder {
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum GrantSearchFiltersOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type GrantSearchFiltersYearCollection = {
  __typename: 'GrantSearchFiltersYearCollection';
  items: Array<Maybe<GrantSearchFiltersYearItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type GrantSearchFiltersYearCursorCollection = {
  __typename: 'GrantSearchFiltersYearCursorCollection';
  items: Array<Maybe<GrantSearchFiltersYearItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type GrantSearchFiltersYearFilter = {
  AND: InputMaybe<Array<InputMaybe<GrantSearchFiltersYearFilter>>>;
  OR: InputMaybe<Array<InputMaybe<GrantSearchFiltersYearFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type: InputMaybe<Scalars['String']['input']>;
  type_contains: InputMaybe<Scalars['String']['input']>;
  type_exists: InputMaybe<Scalars['Boolean']['input']>;
  type_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not: InputMaybe<Scalars['String']['input']>;
  type_not_contains: InputMaybe<Scalars['String']['input']>;
  type_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GrantSearchFiltersYearItem = ExplicitValueFilter | RangeValueFilter;

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantmakingArea) */
export type GrantmakingArea = Entry & _Node & {
  __typename: 'GrantmakingArea';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  id: Maybe<Scalars['String']['output']>;
  image: Maybe<Asset>;
  linkedFrom: Maybe<GrantmakingAreaLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  sys: Sys;
  tagline: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantmakingArea) */
export type GrantmakingAreaIdArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantmakingArea) */
export type GrantmakingAreaImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantmakingArea) */
export type GrantmakingAreaLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantmakingArea) */
export type GrantmakingAreaNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantmakingArea) */
export type GrantmakingAreaTaglineArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type GrantmakingAreaCollection = {
  __typename: 'GrantmakingAreaCollection';
  items: Array<Maybe<GrantmakingArea>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type GrantmakingAreaCursorCollection = {
  __typename: 'GrantmakingAreaCursorCollection';
  items: Array<Maybe<GrantmakingArea>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantmakingAreaDetailsPage) */
export type GrantmakingAreaDetailsPage = Entry & _Node & {
  __typename: 'GrantmakingAreaDetailsPage';
  _id: Scalars['ID']['output'];
  body: Maybe<GrantmakingAreaDetailsPageBody>;
  callForConceptsCollection: Maybe<GrantmakingAreaDetailsPageCallForConceptsCollection>;
  callForConceptsCursorCollection: Maybe<GrantmakingAreaDetailsPageCallForConceptsCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  grantMakingArea: Maybe<GrantmakingArea>;
  grantMakingProcessMessage: Maybe<Scalars['String']['output']>;
  guidingStrategiesContent: Maybe<Scalars['String']['output']>;
  guidingStrategiesTitle: Maybe<Scalars['String']['output']>;
  heroImage: Maybe<Asset>;
  inFocusContentCollection: Maybe<GrantmakingAreaDetailsPageInFocusContentCollection>;
  inFocusContentCursorCollection: Maybe<GrantmakingAreaDetailsPageInFocusContentCursorCollection>;
  introDescription: Maybe<Scalars['String']['output']>;
  introductionText: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<GrantmakingAreaDetailsPageLinkingCollections>;
  quickLinks: Maybe<ConnectWith>;
  slug: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantmakingAreaDetailsPage) */
export type GrantmakingAreaDetailsPageBodyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantmakingAreaDetailsPage) */
export type GrantmakingAreaDetailsPageCallForConceptsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreaDetailsPageCallForConceptsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CallForConceptFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantmakingAreaDetailsPage) */
export type GrantmakingAreaDetailsPageCallForConceptsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreaDetailsPageCallForConceptsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CallForConceptFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantmakingAreaDetailsPage) */
export type GrantmakingAreaDetailsPageGrantMakingAreaArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantmakingAreaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantmakingAreaDetailsPage) */
export type GrantmakingAreaDetailsPageGrantMakingProcessMessageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantmakingAreaDetailsPage) */
export type GrantmakingAreaDetailsPageGuidingStrategiesContentArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantmakingAreaDetailsPage) */
export type GrantmakingAreaDetailsPageGuidingStrategiesTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantmakingAreaDetailsPage) */
export type GrantmakingAreaDetailsPageHeroImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantmakingAreaDetailsPage) */
export type GrantmakingAreaDetailsPageInFocusContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantmakingAreaDetailsPageInFocusContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantmakingAreaDetailsPage) */
export type GrantmakingAreaDetailsPageInFocusContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantmakingAreaDetailsPageInFocusContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantmakingAreaDetailsPage) */
export type GrantmakingAreaDetailsPageIntroDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantmakingAreaDetailsPage) */
export type GrantmakingAreaDetailsPageIntroductionTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantmakingAreaDetailsPage) */
export type GrantmakingAreaDetailsPageLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantmakingAreaDetailsPage) */
export type GrantmakingAreaDetailsPageQuickLinksArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ConnectWithFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantmakingAreaDetailsPage) */
export type GrantmakingAreaDetailsPageSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantmakingAreaDetailsPage) */
export type GrantmakingAreaDetailsPageTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type GrantmakingAreaDetailsPageBody = {
  __typename: 'GrantmakingAreaDetailsPageBody';
  json: Scalars['JSON']['output'];
  links: GrantmakingAreaDetailsPageBodyLinks;
};

export type GrantmakingAreaDetailsPageBodyAssets = {
  __typename: 'GrantmakingAreaDetailsPageBodyAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type GrantmakingAreaDetailsPageBodyEntries = {
  __typename: 'GrantmakingAreaDetailsPageBodyEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type GrantmakingAreaDetailsPageBodyLinks = {
  __typename: 'GrantmakingAreaDetailsPageBodyLinks';
  assets: GrantmakingAreaDetailsPageBodyAssets;
  entries: GrantmakingAreaDetailsPageBodyEntries;
  resources: GrantmakingAreaDetailsPageBodyResources;
};

export type GrantmakingAreaDetailsPageBodyResources = {
  __typename: 'GrantmakingAreaDetailsPageBodyResources';
  block: Array<GrantmakingAreaDetailsPageBodyResourcesBlock>;
  hyperlink: Array<GrantmakingAreaDetailsPageBodyResourcesHyperlink>;
  inline: Array<GrantmakingAreaDetailsPageBodyResourcesInline>;
};

export type GrantmakingAreaDetailsPageBodyResourcesBlock = ResourceLink & {
  __typename: 'GrantmakingAreaDetailsPageBodyResourcesBlock';
  sys: ResourceSys;
};

export type GrantmakingAreaDetailsPageBodyResourcesHyperlink = ResourceLink & {
  __typename: 'GrantmakingAreaDetailsPageBodyResourcesHyperlink';
  sys: ResourceSys;
};

export type GrantmakingAreaDetailsPageBodyResourcesInline = ResourceLink & {
  __typename: 'GrantmakingAreaDetailsPageBodyResourcesInline';
  sys: ResourceSys;
};

export type GrantmakingAreaDetailsPageCallForConceptsCollection = {
  __typename: 'GrantmakingAreaDetailsPageCallForConceptsCollection';
  items: Array<Maybe<CallForConcept>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum GrantmakingAreaDetailsPageCallForConceptsCollectionOrder {
  CallForConceptTitleAsc = 'callForConceptTitle_ASC',
  CallForConceptTitleDesc = 'callForConceptTitle_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  RegistrationDeadlineDateAsc = 'registrationDeadlineDate_ASC',
  RegistrationDeadlineDateDesc = 'registrationDeadlineDate_DESC',
  RegistrationDeadlineTitleAsc = 'registrationDeadlineTitle_ASC',
  RegistrationDeadlineTitleDesc = 'registrationDeadlineTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export type GrantmakingAreaDetailsPageCallForConceptsCursorCollection = {
  __typename: 'GrantmakingAreaDetailsPageCallForConceptsCursorCollection';
  items: Array<Maybe<CallForConcept>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum GrantmakingAreaDetailsPageCallForConceptsCursorCollectionOrder {
  CallForConceptTitleAsc = 'callForConceptTitle_ASC',
  CallForConceptTitleDesc = 'callForConceptTitle_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  RegistrationDeadlineDateAsc = 'registrationDeadlineDate_ASC',
  RegistrationDeadlineDateDesc = 'registrationDeadlineDate_DESC',
  RegistrationDeadlineTitleAsc = 'registrationDeadlineTitle_ASC',
  RegistrationDeadlineTitleDesc = 'registrationDeadlineTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export type GrantmakingAreaDetailsPageCollection = {
  __typename: 'GrantmakingAreaDetailsPageCollection';
  items: Array<Maybe<GrantmakingAreaDetailsPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type GrantmakingAreaDetailsPageCursorCollection = {
  __typename: 'GrantmakingAreaDetailsPageCursorCollection';
  items: Array<Maybe<GrantmakingAreaDetailsPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type GrantmakingAreaDetailsPageFilter = {
  AND: InputMaybe<Array<InputMaybe<GrantmakingAreaDetailsPageFilter>>>;
  OR: InputMaybe<Array<InputMaybe<GrantmakingAreaDetailsPageFilter>>>;
  body_contains: InputMaybe<Scalars['String']['input']>;
  body_exists: InputMaybe<Scalars['Boolean']['input']>;
  body_not_contains: InputMaybe<Scalars['String']['input']>;
  callForConcepts: InputMaybe<CfCallForConceptNestedFilter>;
  callForConceptsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  grantMakingArea: InputMaybe<CfGrantmakingAreaNestedFilter>;
  grantMakingArea_exists: InputMaybe<Scalars['Boolean']['input']>;
  grantMakingProcessMessage: InputMaybe<Scalars['String']['input']>;
  grantMakingProcessMessage_contains: InputMaybe<Scalars['String']['input']>;
  grantMakingProcessMessage_exists: InputMaybe<Scalars['Boolean']['input']>;
  grantMakingProcessMessage_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  grantMakingProcessMessage_not: InputMaybe<Scalars['String']['input']>;
  grantMakingProcessMessage_not_contains: InputMaybe<Scalars['String']['input']>;
  grantMakingProcessMessage_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  guidingStrategiesContent: InputMaybe<Scalars['String']['input']>;
  guidingStrategiesContent_contains: InputMaybe<Scalars['String']['input']>;
  guidingStrategiesContent_exists: InputMaybe<Scalars['Boolean']['input']>;
  guidingStrategiesContent_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  guidingStrategiesContent_not: InputMaybe<Scalars['String']['input']>;
  guidingStrategiesContent_not_contains: InputMaybe<Scalars['String']['input']>;
  guidingStrategiesContent_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  guidingStrategiesTitle: InputMaybe<Scalars['String']['input']>;
  guidingStrategiesTitle_contains: InputMaybe<Scalars['String']['input']>;
  guidingStrategiesTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  guidingStrategiesTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  guidingStrategiesTitle_not: InputMaybe<Scalars['String']['input']>;
  guidingStrategiesTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  guidingStrategiesTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heroImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  inFocusContent: InputMaybe<CfinFocusContentMultiTypeNestedFilter>;
  inFocusContentCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  introDescription: InputMaybe<Scalars['String']['input']>;
  introDescription_contains: InputMaybe<Scalars['String']['input']>;
  introDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  introDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  introDescription_not: InputMaybe<Scalars['String']['input']>;
  introDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  introDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  introductionText: InputMaybe<Scalars['String']['input']>;
  introductionText_contains: InputMaybe<Scalars['String']['input']>;
  introductionText_exists: InputMaybe<Scalars['Boolean']['input']>;
  introductionText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  introductionText_not: InputMaybe<Scalars['String']['input']>;
  introductionText_not_contains: InputMaybe<Scalars['String']['input']>;
  introductionText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quickLinks: InputMaybe<CfConnectWithNestedFilter>;
  quickLinks_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GrantmakingAreaDetailsPageInFocusContentCollection = {
  __typename: 'GrantmakingAreaDetailsPageInFocusContentCollection';
  items: Array<Maybe<GrantmakingAreaDetailsPageInFocusContentItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type GrantmakingAreaDetailsPageInFocusContentCursorCollection = {
  __typename: 'GrantmakingAreaDetailsPageInFocusContentCursorCollection';
  items: Array<Maybe<GrantmakingAreaDetailsPageInFocusContentItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type GrantmakingAreaDetailsPageInFocusContentFilter = {
  AND: InputMaybe<Array<InputMaybe<GrantmakingAreaDetailsPageInFocusContentFilter>>>;
  OR: InputMaybe<Array<InputMaybe<GrantmakingAreaDetailsPageInFocusContentFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
};

export type GrantmakingAreaDetailsPageInFocusContentItem = Article | GrantActivityArticle | Mmuf | Quote;

export type GrantmakingAreaDetailsPageLinkingCollections = {
  __typename: 'GrantmakingAreaDetailsPageLinkingCollections';
  connectWithLinkCollection: Maybe<ConnectWithLinkCollection>;
  connectWithLinkCursorCollection: Maybe<ConnectWithLinkCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  grantResourcesCollection: Maybe<GrantResourcesCollection>;
  grantResourcesCursorCollection: Maybe<GrantResourcesCursorCollection>;
  grantmakingAreasPageCollection: Maybe<GrantmakingAreasPageCollection>;
  grantmakingAreasPageCursorCollection: Maybe<GrantmakingAreasPageCursorCollection>;
  inlineCardsCollection: Maybe<InlineCardsCollection>;
  inlineCardsCursorCollection: Maybe<InlineCardsCursorCollection>;
  navigationItemCollection: Maybe<NavigationItemCollection>;
  navigationItemCursorCollection: Maybe<NavigationItemCursorCollection>;
  resourcesProspectiveGranteesCollection: Maybe<ResourcesProspectiveGranteesCollection>;
  resourcesProspectiveGranteesCursorCollection: Maybe<ResourcesProspectiveGranteesCursorCollection>;
};


export type GrantmakingAreaDetailsPageLinkingCollectionsConnectWithLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreaDetailsPageLinkingCollectionsConnectWithLinkCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreaDetailsPageLinkingCollectionsConnectWithLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreaDetailsPageLinkingCollectionsConnectWithLinkCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreaDetailsPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreaDetailsPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreaDetailsPageLinkingCollectionsGrantResourcesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreaDetailsPageLinkingCollectionsGrantResourcesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreaDetailsPageLinkingCollectionsGrantResourcesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreaDetailsPageLinkingCollectionsGrantResourcesCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreaDetailsPageLinkingCollectionsGrantmakingAreasPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreaDetailsPageLinkingCollectionsGrantmakingAreasPageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreaDetailsPageLinkingCollectionsGrantmakingAreasPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreaDetailsPageLinkingCollectionsGrantmakingAreasPageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreaDetailsPageLinkingCollectionsInlineCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreaDetailsPageLinkingCollectionsInlineCardsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreaDetailsPageLinkingCollectionsInlineCardsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreaDetailsPageLinkingCollectionsInlineCardsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreaDetailsPageLinkingCollectionsNavigationItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreaDetailsPageLinkingCollectionsNavigationItemCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreaDetailsPageLinkingCollectionsNavigationItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreaDetailsPageLinkingCollectionsNavigationItemCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreaDetailsPageLinkingCollectionsResourcesProspectiveGranteesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreaDetailsPageLinkingCollectionsResourcesProspectiveGranteesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreaDetailsPageLinkingCollectionsResourcesProspectiveGranteesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreaDetailsPageLinkingCollectionsResourcesProspectiveGranteesCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum GrantmakingAreaDetailsPageLinkingCollectionsConnectWithLinkCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantmakingAreaDetailsPageLinkingCollectionsConnectWithLinkCursorCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantmakingAreaDetailsPageLinkingCollectionsGrantResourcesCollectionOrder {
  ExplanatoryTitleAsc = 'explanatoryTitle_ASC',
  ExplanatoryTitleDesc = 'explanatoryTitle_DESC',
  GrantMakingAreasTitleAsc = 'grantMakingAreasTitle_ASC',
  GrantMakingAreasTitleDesc = 'grantMakingAreasTitle_DESC',
  SearchContextualMessageAsc = 'searchContextualMessage_ASC',
  SearchContextualMessageDesc = 'searchContextualMessage_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantmakingAreaDetailsPageLinkingCollectionsGrantResourcesCursorCollectionOrder {
  ExplanatoryTitleAsc = 'explanatoryTitle_ASC',
  ExplanatoryTitleDesc = 'explanatoryTitle_DESC',
  GrantMakingAreasTitleAsc = 'grantMakingAreasTitle_ASC',
  GrantMakingAreasTitleDesc = 'grantMakingAreasTitle_DESC',
  SearchContextualMessageAsc = 'searchContextualMessage_ASC',
  SearchContextualMessageDesc = 'searchContextualMessage_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantmakingAreaDetailsPageLinkingCollectionsGrantmakingAreasPageCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantmakingAreaDetailsPageLinkingCollectionsGrantmakingAreasPageCursorCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantmakingAreaDetailsPageLinkingCollectionsInlineCardsCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantmakingAreaDetailsPageLinkingCollectionsInlineCardsCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantmakingAreaDetailsPageLinkingCollectionsNavigationItemCollectionOrder {
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum GrantmakingAreaDetailsPageLinkingCollectionsNavigationItemCursorCollectionOrder {
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum GrantmakingAreaDetailsPageLinkingCollectionsResourcesProspectiveGranteesCollectionOrder {
  CallsForConceptsTitleAsc = 'callsForConceptsTitle_ASC',
  CallsForConceptsTitleDesc = 'callsForConceptsTitle_DESC',
  GrantDatabaseCtaTextAsc = 'grantDatabaseCtaText_ASC',
  GrantDatabaseCtaTextDesc = 'grantDatabaseCtaText_DESC',
  GrantmakingAtGlanceTitleAsc = 'grantmakingAtGlanceTitle_ASC',
  GrantmakingAtGlanceTitleDesc = 'grantmakingAtGlanceTitle_DESC',
  NewsletterCtaTextAsc = 'newsletterCtaText_ASC',
  NewsletterCtaTextDesc = 'newsletterCtaText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantmakingAreaDetailsPageLinkingCollectionsResourcesProspectiveGranteesCursorCollectionOrder {
  CallsForConceptsTitleAsc = 'callsForConceptsTitle_ASC',
  CallsForConceptsTitleDesc = 'callsForConceptsTitle_DESC',
  GrantDatabaseCtaTextAsc = 'grantDatabaseCtaText_ASC',
  GrantDatabaseCtaTextDesc = 'grantDatabaseCtaText_DESC',
  GrantmakingAtGlanceTitleAsc = 'grantmakingAtGlanceTitle_ASC',
  GrantmakingAtGlanceTitleDesc = 'grantmakingAtGlanceTitle_DESC',
  NewsletterCtaTextAsc = 'newsletterCtaText_ASC',
  NewsletterCtaTextDesc = 'newsletterCtaText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantmakingAreaDetailsPageOrder {
  GrantMakingProcessMessageAsc = 'grantMakingProcessMessage_ASC',
  GrantMakingProcessMessageDesc = 'grantMakingProcessMessage_DESC',
  GuidingStrategiesTitleAsc = 'guidingStrategiesTitle_ASC',
  GuidingStrategiesTitleDesc = 'guidingStrategiesTitle_DESC',
  IntroDescriptionAsc = 'introDescription_ASC',
  IntroDescriptionDesc = 'introDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type GrantmakingAreaFilter = {
  AND: InputMaybe<Array<InputMaybe<GrantmakingAreaFilter>>>;
  OR: InputMaybe<Array<InputMaybe<GrantmakingAreaFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  id: InputMaybe<Scalars['String']['input']>;
  id_contains: InputMaybe<Scalars['String']['input']>;
  id_exists: InputMaybe<Scalars['Boolean']['input']>;
  id_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not: InputMaybe<Scalars['String']['input']>;
  id_not_contains: InputMaybe<Scalars['String']['input']>;
  id_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  tagline: InputMaybe<Scalars['String']['input']>;
  tagline_contains: InputMaybe<Scalars['String']['input']>;
  tagline_exists: InputMaybe<Scalars['Boolean']['input']>;
  tagline_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagline_not: InputMaybe<Scalars['String']['input']>;
  tagline_not_contains: InputMaybe<Scalars['String']['input']>;
  tagline_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GrantmakingAreaLinkingCollections = {
  __typename: 'GrantmakingAreaLinkingCollections';
  articleCollection: Maybe<ArticleCollection>;
  articleCursorCollection: Maybe<ArticleCursorCollection>;
  callForConceptCollection: Maybe<CallForConceptCollection>;
  callForConceptCursorCollection: Maybe<CallForConceptCursorCollection>;
  connectWithLinkCollection: Maybe<ConnectWithLinkCollection>;
  connectWithLinkCursorCollection: Maybe<ConnectWithLinkCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  grantCollection: Maybe<GrantCollection>;
  grantCursorCollection: Maybe<GrantCursorCollection>;
  grantmakingAreaDetailsPageCollection: Maybe<GrantmakingAreaDetailsPageCollection>;
  grantmakingAreaDetailsPageCursorCollection: Maybe<GrantmakingAreaDetailsPageCursorCollection>;
  peoplePageCollection: Maybe<PeoplePageCollection>;
  peoplePageCursorCollection: Maybe<PeoplePageCursorCollection>;
  personCollection: Maybe<PersonCollection>;
  personCursorCollection: Maybe<PersonCursorCollection>;
  presidentialQuoteCallOutCollection: Maybe<PresidentialQuoteCallOutCollection>;
  presidentialQuoteCallOutCursorCollection: Maybe<PresidentialQuoteCallOutCursorCollection>;
  resourcesCurrentGranteesCollection: Maybe<ResourcesCurrentGranteesCollection>;
  resourcesCurrentGranteesCursorCollection: Maybe<ResourcesCurrentGranteesCursorCollection>;
};


export type GrantmakingAreaLinkingCollectionsArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreaLinkingCollectionsArticleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreaLinkingCollectionsArticleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreaLinkingCollectionsArticleCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreaLinkingCollectionsCallForConceptCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreaLinkingCollectionsCallForConceptCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreaLinkingCollectionsCallForConceptCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreaLinkingCollectionsCallForConceptCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreaLinkingCollectionsConnectWithLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreaLinkingCollectionsConnectWithLinkCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreaLinkingCollectionsConnectWithLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreaLinkingCollectionsConnectWithLinkCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreaLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreaLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreaLinkingCollectionsGrantCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreaLinkingCollectionsGrantCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreaLinkingCollectionsGrantCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreaLinkingCollectionsGrantCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreaLinkingCollectionsGrantmakingAreaDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreaLinkingCollectionsGrantmakingAreaDetailsPageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreaLinkingCollectionsGrantmakingAreaDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreaLinkingCollectionsGrantmakingAreaDetailsPageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreaLinkingCollectionsPeoplePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreaLinkingCollectionsPeoplePageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreaLinkingCollectionsPeoplePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreaLinkingCollectionsPeoplePageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreaLinkingCollectionsPersonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreaLinkingCollectionsPersonCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreaLinkingCollectionsPersonCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreaLinkingCollectionsPersonCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreaLinkingCollectionsPresidentialQuoteCallOutCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreaLinkingCollectionsPresidentialQuoteCallOutCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreaLinkingCollectionsPresidentialQuoteCallOutCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreaLinkingCollectionsPresidentialQuoteCallOutCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreaLinkingCollectionsResourcesCurrentGranteesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreaLinkingCollectionsResourcesCurrentGranteesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreaLinkingCollectionsResourcesCurrentGranteesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreaLinkingCollectionsResourcesCurrentGranteesCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum GrantmakingAreaLinkingCollectionsArticleCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  ExternalNewsUrlAsc = 'externalNewsUrl_ASC',
  ExternalNewsUrlDesc = 'externalNewsUrl_DESC',
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  PasswordAsc = 'password_ASC',
  PasswordDesc = 'password_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum GrantmakingAreaLinkingCollectionsArticleCursorCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  ExternalNewsUrlAsc = 'externalNewsUrl_ASC',
  ExternalNewsUrlDesc = 'externalNewsUrl_DESC',
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  PasswordAsc = 'password_ASC',
  PasswordDesc = 'password_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum GrantmakingAreaLinkingCollectionsCallForConceptCollectionOrder {
  CallForConceptTitleAsc = 'callForConceptTitle_ASC',
  CallForConceptTitleDesc = 'callForConceptTitle_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  RegistrationDeadlineDateAsc = 'registrationDeadlineDate_ASC',
  RegistrationDeadlineDateDesc = 'registrationDeadlineDate_DESC',
  RegistrationDeadlineTitleAsc = 'registrationDeadlineTitle_ASC',
  RegistrationDeadlineTitleDesc = 'registrationDeadlineTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum GrantmakingAreaLinkingCollectionsCallForConceptCursorCollectionOrder {
  CallForConceptTitleAsc = 'callForConceptTitle_ASC',
  CallForConceptTitleDesc = 'callForConceptTitle_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  RegistrationDeadlineDateAsc = 'registrationDeadlineDate_ASC',
  RegistrationDeadlineDateDesc = 'registrationDeadlineDate_DESC',
  RegistrationDeadlineTitleAsc = 'registrationDeadlineTitle_ASC',
  RegistrationDeadlineTitleDesc = 'registrationDeadlineTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum GrantmakingAreaLinkingCollectionsConnectWithLinkCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantmakingAreaLinkingCollectionsConnectWithLinkCursorCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantmakingAreaLinkingCollectionsGrantCollectionOrder {
  AmountAsc = 'amount_ASC',
  AmountDesc = 'amount_DESC',
  AreaOfFocusAsc = 'areaOfFocus_ASC',
  AreaOfFocusDesc = 'areaOfFocus_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  DurationInMonthsAsc = 'durationInMonths_ASC',
  DurationInMonthsDesc = 'durationInMonths_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ProjectTitleAsc = 'projectTitle_ASC',
  ProjectTitleDesc = 'projectTitle_DESC',
  ReferenceIdAsc = 'referenceId_ASC',
  ReferenceIdDesc = 'referenceId_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum GrantmakingAreaLinkingCollectionsGrantCursorCollectionOrder {
  AmountAsc = 'amount_ASC',
  AmountDesc = 'amount_DESC',
  AreaOfFocusAsc = 'areaOfFocus_ASC',
  AreaOfFocusDesc = 'areaOfFocus_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  DurationInMonthsAsc = 'durationInMonths_ASC',
  DurationInMonthsDesc = 'durationInMonths_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ProjectTitleAsc = 'projectTitle_ASC',
  ProjectTitleDesc = 'projectTitle_DESC',
  ReferenceIdAsc = 'referenceId_ASC',
  ReferenceIdDesc = 'referenceId_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum GrantmakingAreaLinkingCollectionsGrantmakingAreaDetailsPageCollectionOrder {
  GrantMakingProcessMessageAsc = 'grantMakingProcessMessage_ASC',
  GrantMakingProcessMessageDesc = 'grantMakingProcessMessage_DESC',
  GuidingStrategiesTitleAsc = 'guidingStrategiesTitle_ASC',
  GuidingStrategiesTitleDesc = 'guidingStrategiesTitle_DESC',
  IntroDescriptionAsc = 'introDescription_ASC',
  IntroDescriptionDesc = 'introDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantmakingAreaLinkingCollectionsGrantmakingAreaDetailsPageCursorCollectionOrder {
  GrantMakingProcessMessageAsc = 'grantMakingProcessMessage_ASC',
  GrantMakingProcessMessageDesc = 'grantMakingProcessMessage_DESC',
  GuidingStrategiesTitleAsc = 'guidingStrategiesTitle_ASC',
  GuidingStrategiesTitleDesc = 'guidingStrategiesTitle_DESC',
  IntroDescriptionAsc = 'introDescription_ASC',
  IntroDescriptionDesc = 'introDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantmakingAreaLinkingCollectionsPeoplePageCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TrusteesCtaLabelAsc = 'trusteesCtaLabel_ASC',
  TrusteesCtaLabelDesc = 'trusteesCtaLabel_DESC',
  TrusteesCtaTextAsc = 'trusteesCtaText_ASC',
  TrusteesCtaTextDesc = 'trusteesCtaText_DESC'
}

export enum GrantmakingAreaLinkingCollectionsPeoplePageCursorCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TrusteesCtaLabelAsc = 'trusteesCtaLabel_ASC',
  TrusteesCtaLabelDesc = 'trusteesCtaLabel_DESC',
  TrusteesCtaTextAsc = 'trusteesCtaText_ASC',
  TrusteesCtaTextDesc = 'trusteesCtaText_DESC'
}

export enum GrantmakingAreaLinkingCollectionsPersonCollectionOrder {
  FirstNameAsc = 'firstName_ASC',
  FirstNameDesc = 'firstName_DESC',
  JobTitleAsc = 'jobTitle_ASC',
  JobTitleDesc = 'jobTitle_DESC',
  LastNameAsc = 'lastName_ASC',
  LastNameDesc = 'lastName_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  RelatedSectionTitleAsc = 'relatedSectionTitle_ASC',
  RelatedSectionTitleDesc = 'relatedSectionTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum GrantmakingAreaLinkingCollectionsPersonCursorCollectionOrder {
  FirstNameAsc = 'firstName_ASC',
  FirstNameDesc = 'firstName_DESC',
  JobTitleAsc = 'jobTitle_ASC',
  JobTitleDesc = 'jobTitle_DESC',
  LastNameAsc = 'lastName_ASC',
  LastNameDesc = 'lastName_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  RelatedSectionTitleAsc = 'relatedSectionTitle_ASC',
  RelatedSectionTitleDesc = 'relatedSectionTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum GrantmakingAreaLinkingCollectionsPresidentialQuoteCallOutCollectionOrder {
  PresidentialCtaTextAsc = 'presidentialCtaText_ASC',
  PresidentialCtaTextDesc = 'presidentialCtaText_DESC',
  PresidentialHeadingAsc = 'presidentialHeading_ASC',
  PresidentialHeadingDesc = 'presidentialHeading_DESC',
  PresidentialTextAsc = 'presidentialText_ASC',
  PresidentialTextDesc = 'presidentialText_DESC',
  PresidentialTitleAsc = 'presidentialTitle_ASC',
  PresidentialTitleDesc = 'presidentialTitle_DESC',
  SearchQueryAsc = 'searchQuery_ASC',
  SearchQueryDesc = 'searchQuery_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantmakingAreaLinkingCollectionsPresidentialQuoteCallOutCursorCollectionOrder {
  PresidentialCtaTextAsc = 'presidentialCtaText_ASC',
  PresidentialCtaTextDesc = 'presidentialCtaText_DESC',
  PresidentialHeadingAsc = 'presidentialHeading_ASC',
  PresidentialHeadingDesc = 'presidentialHeading_DESC',
  PresidentialTextAsc = 'presidentialText_ASC',
  PresidentialTextDesc = 'presidentialText_DESC',
  PresidentialTitleAsc = 'presidentialTitle_ASC',
  PresidentialTitleDesc = 'presidentialTitle_DESC',
  SearchQueryAsc = 'searchQuery_ASC',
  SearchQueryDesc = 'searchQuery_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantmakingAreaLinkingCollectionsResourcesCurrentGranteesCollectionOrder {
  GrantDatabaseCtaTextAsc = 'grantDatabaseCtaText_ASC',
  GrantDatabaseCtaTextDesc = 'grantDatabaseCtaText_DESC',
  ResourcesTitleAsc = 'resourcesTitle_ASC',
  ResourcesTitleDesc = 'resourcesTitle_DESC',
  SimilarGranteesTitleAsc = 'similarGranteesTitle_ASC',
  SimilarGranteesTitleDesc = 'similarGranteesTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantmakingAreaLinkingCollectionsResourcesCurrentGranteesCursorCollectionOrder {
  GrantDatabaseCtaTextAsc = 'grantDatabaseCtaText_ASC',
  GrantDatabaseCtaTextDesc = 'grantDatabaseCtaText_DESC',
  ResourcesTitleAsc = 'resourcesTitle_ASC',
  ResourcesTitleDesc = 'resourcesTitle_DESC',
  SimilarGranteesTitleAsc = 'similarGranteesTitle_ASC',
  SimilarGranteesTitleDesc = 'similarGranteesTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantmakingAreaOrder {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TaglineAsc = 'tagline_ASC',
  TaglineDesc = 'tagline_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantmakingAreasPage) */
export type GrantmakingAreasPage = Entry & _Node & {
  __typename: 'GrantmakingAreasPage';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  contextualMessage: Maybe<Scalars['String']['output']>;
  grantmakingAreasCollection: Maybe<GrantmakingAreasPageGrantmakingAreasCollection>;
  grantmakingAreasCursorCollection: Maybe<GrantmakingAreasPageGrantmakingAreasCursorCollection>;
  introDescription: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<GrantmakingAreasPageLinkingCollections>;
  navigationImagePortrait: Maybe<Asset>;
  slug: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantmakingAreasPage) */
export type GrantmakingAreasPageContextualMessageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantmakingAreasPage) */
export type GrantmakingAreasPageGrantmakingAreasCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreasPageGrantmakingAreasCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantmakingAreaDetailsPageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantmakingAreasPage) */
export type GrantmakingAreasPageGrantmakingAreasCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreasPageGrantmakingAreasCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantmakingAreaDetailsPageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantmakingAreasPage) */
export type GrantmakingAreasPageIntroDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantmakingAreasPage) */
export type GrantmakingAreasPageLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantmakingAreasPage) */
export type GrantmakingAreasPageNavigationImagePortraitArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantmakingAreasPage) */
export type GrantmakingAreasPageSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/grantmakingAreasPage) */
export type GrantmakingAreasPageTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type GrantmakingAreasPageCollection = {
  __typename: 'GrantmakingAreasPageCollection';
  items: Array<Maybe<GrantmakingAreasPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type GrantmakingAreasPageCursorCollection = {
  __typename: 'GrantmakingAreasPageCursorCollection';
  items: Array<Maybe<GrantmakingAreasPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type GrantmakingAreasPageFilter = {
  AND: InputMaybe<Array<InputMaybe<GrantmakingAreasPageFilter>>>;
  OR: InputMaybe<Array<InputMaybe<GrantmakingAreasPageFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  contextualMessage: InputMaybe<Scalars['String']['input']>;
  contextualMessage_contains: InputMaybe<Scalars['String']['input']>;
  contextualMessage_exists: InputMaybe<Scalars['Boolean']['input']>;
  contextualMessage_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contextualMessage_not: InputMaybe<Scalars['String']['input']>;
  contextualMessage_not_contains: InputMaybe<Scalars['String']['input']>;
  contextualMessage_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  grantmakingAreas: InputMaybe<CfGrantmakingAreaDetailsPageNestedFilter>;
  grantmakingAreasCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  introDescription: InputMaybe<Scalars['String']['input']>;
  introDescription_contains: InputMaybe<Scalars['String']['input']>;
  introDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  introDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  introDescription_not: InputMaybe<Scalars['String']['input']>;
  introDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  introDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navigationImagePortrait_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GrantmakingAreasPageGrantmakingAreasCollection = {
  __typename: 'GrantmakingAreasPageGrantmakingAreasCollection';
  items: Array<Maybe<GrantmakingAreaDetailsPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum GrantmakingAreasPageGrantmakingAreasCollectionOrder {
  GrantMakingProcessMessageAsc = 'grantMakingProcessMessage_ASC',
  GrantMakingProcessMessageDesc = 'grantMakingProcessMessage_DESC',
  GuidingStrategiesTitleAsc = 'guidingStrategiesTitle_ASC',
  GuidingStrategiesTitleDesc = 'guidingStrategiesTitle_DESC',
  IntroDescriptionAsc = 'introDescription_ASC',
  IntroDescriptionDesc = 'introDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type GrantmakingAreasPageGrantmakingAreasCursorCollection = {
  __typename: 'GrantmakingAreasPageGrantmakingAreasCursorCollection';
  items: Array<Maybe<GrantmakingAreaDetailsPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum GrantmakingAreasPageGrantmakingAreasCursorCollectionOrder {
  GrantMakingProcessMessageAsc = 'grantMakingProcessMessage_ASC',
  GrantMakingProcessMessageDesc = 'grantMakingProcessMessage_DESC',
  GuidingStrategiesTitleAsc = 'guidingStrategiesTitle_ASC',
  GuidingStrategiesTitleDesc = 'guidingStrategiesTitle_DESC',
  IntroDescriptionAsc = 'introDescription_ASC',
  IntroDescriptionDesc = 'introDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type GrantmakingAreasPageLinkingCollections = {
  __typename: 'GrantmakingAreasPageLinkingCollections';
  connectWithLinkCollection: Maybe<ConnectWithLinkCollection>;
  connectWithLinkCursorCollection: Maybe<ConnectWithLinkCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  mainNavigationCollection: Maybe<MainNavigationCollection>;
  mainNavigationCursorCollection: Maybe<MainNavigationCursorCollection>;
  navigationItemCollection: Maybe<NavigationItemCollection>;
  navigationItemCursorCollection: Maybe<NavigationItemCursorCollection>;
};


export type GrantmakingAreasPageLinkingCollectionsConnectWithLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreasPageLinkingCollectionsConnectWithLinkCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreasPageLinkingCollectionsConnectWithLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreasPageLinkingCollectionsConnectWithLinkCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreasPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreasPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreasPageLinkingCollectionsMainNavigationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreasPageLinkingCollectionsMainNavigationCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreasPageLinkingCollectionsMainNavigationCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreasPageLinkingCollectionsMainNavigationCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreasPageLinkingCollectionsNavigationItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreasPageLinkingCollectionsNavigationItemCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GrantmakingAreasPageLinkingCollectionsNavigationItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreasPageLinkingCollectionsNavigationItemCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum GrantmakingAreasPageLinkingCollectionsConnectWithLinkCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantmakingAreasPageLinkingCollectionsConnectWithLinkCursorCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantmakingAreasPageLinkingCollectionsMainNavigationCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantmakingAreasPageLinkingCollectionsMainNavigationCursorCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum GrantmakingAreasPageLinkingCollectionsNavigationItemCollectionOrder {
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum GrantmakingAreasPageLinkingCollectionsNavigationItemCursorCollectionOrder {
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum GrantmakingAreasPageOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/heroAsset) */
export type HeroAsset = Entry & _Node & {
  __typename: 'HeroAsset';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  image: Maybe<Asset>;
  linkedFrom: Maybe<HeroAssetLinkingCollections>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
  video: Maybe<Asset>;
  videoHasAudio: Maybe<Scalars['Boolean']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/heroAsset) */
export type HeroAssetImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/heroAsset) */
export type HeroAssetLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/heroAsset) */
export type HeroAssetTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/heroAsset) */
export type HeroAssetVideoArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/heroAsset) */
export type HeroAssetVideoHasAudioArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type HeroAssetCollection = {
  __typename: 'HeroAssetCollection';
  items: Array<Maybe<HeroAsset>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HeroAssetCursorCollection = {
  __typename: 'HeroAssetCursorCollection';
  items: Array<Maybe<HeroAsset>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type HeroAssetFilter = {
  AND: InputMaybe<Array<InputMaybe<HeroAssetFilter>>>;
  OR: InputMaybe<Array<InputMaybe<HeroAssetFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  image_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoHasAudio: InputMaybe<Scalars['Boolean']['input']>;
  videoHasAudio_exists: InputMaybe<Scalars['Boolean']['input']>;
  videoHasAudio_not: InputMaybe<Scalars['Boolean']['input']>;
  video_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type HeroAssetLinkingCollections = {
  __typename: 'HeroAssetLinkingCollections';
  articleCollection: Maybe<ArticleCollection>;
  articleCursorCollection: Maybe<ArticleCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  featureCollection: Maybe<FeatureCollection>;
  featureCursorCollection: Maybe<FeatureCursorCollection>;
  grantActivityArticleCollection: Maybe<GrantActivityArticleCollection>;
  grantActivityArticleCursorCollection: Maybe<GrantActivityArticleCursorCollection>;
  resourcesCurrentGranteesCollection: Maybe<ResourcesCurrentGranteesCollection>;
  resourcesCurrentGranteesCursorCollection: Maybe<ResourcesCurrentGranteesCursorCollection>;
  resourcesProspectiveGranteesCollection: Maybe<ResourcesProspectiveGranteesCollection>;
  resourcesProspectiveGranteesCursorCollection: Maybe<ResourcesProspectiveGranteesCursorCollection>;
};


export type HeroAssetLinkingCollectionsArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HeroAssetLinkingCollectionsArticleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeroAssetLinkingCollectionsArticleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HeroAssetLinkingCollectionsArticleCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeroAssetLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeroAssetLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeroAssetLinkingCollectionsFeatureCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HeroAssetLinkingCollectionsFeatureCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeroAssetLinkingCollectionsFeatureCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HeroAssetLinkingCollectionsFeatureCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeroAssetLinkingCollectionsGrantActivityArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HeroAssetLinkingCollectionsGrantActivityArticleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeroAssetLinkingCollectionsGrantActivityArticleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HeroAssetLinkingCollectionsGrantActivityArticleCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeroAssetLinkingCollectionsResourcesCurrentGranteesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HeroAssetLinkingCollectionsResourcesCurrentGranteesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeroAssetLinkingCollectionsResourcesCurrentGranteesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HeroAssetLinkingCollectionsResourcesCurrentGranteesCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeroAssetLinkingCollectionsResourcesProspectiveGranteesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HeroAssetLinkingCollectionsResourcesProspectiveGranteesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeroAssetLinkingCollectionsResourcesProspectiveGranteesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HeroAssetLinkingCollectionsResourcesProspectiveGranteesCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum HeroAssetLinkingCollectionsArticleCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  ExternalNewsUrlAsc = 'externalNewsUrl_ASC',
  ExternalNewsUrlDesc = 'externalNewsUrl_DESC',
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  PasswordAsc = 'password_ASC',
  PasswordDesc = 'password_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum HeroAssetLinkingCollectionsArticleCursorCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  ExternalNewsUrlAsc = 'externalNewsUrl_ASC',
  ExternalNewsUrlDesc = 'externalNewsUrl_DESC',
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  PasswordAsc = 'password_ASC',
  PasswordDesc = 'password_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum HeroAssetLinkingCollectionsFeatureCollectionOrder {
  DateTimeAsc = 'dateTime_ASC',
  DateTimeDesc = 'dateTime_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  ShowSocialCtasAsc = 'showSocialCtas_ASC',
  ShowSocialCtasDesc = 'showSocialCtas_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TaglineAsc = 'tagline_ASC',
  TaglineDesc = 'tagline_DESC'
}

export enum HeroAssetLinkingCollectionsFeatureCursorCollectionOrder {
  DateTimeAsc = 'dateTime_ASC',
  DateTimeDesc = 'dateTime_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  ShowSocialCtasAsc = 'showSocialCtas_ASC',
  ShowSocialCtasDesc = 'showSocialCtas_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TaglineAsc = 'tagline_ASC',
  TaglineDesc = 'tagline_DESC'
}

export enum HeroAssetLinkingCollectionsGrantActivityArticleCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  GranteeCityOverrideAsc = 'granteeCityOverride_ASC',
  GranteeCityOverrideDesc = 'granteeCityOverride_DESC',
  GranteeCountryOverrideAsc = 'granteeCountryOverride_ASC',
  GranteeCountryOverrideDesc = 'granteeCountryOverride_DESC',
  GranteeNameOverrideAsc = 'granteeNameOverride_ASC',
  GranteeNameOverrideDesc = 'granteeNameOverride_DESC',
  GranteeStateOverrideAsc = 'granteeStateOverride_ASC',
  GranteeStateOverrideDesc = 'granteeStateOverride_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum HeroAssetLinkingCollectionsGrantActivityArticleCursorCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  GranteeCityOverrideAsc = 'granteeCityOverride_ASC',
  GranteeCityOverrideDesc = 'granteeCityOverride_DESC',
  GranteeCountryOverrideAsc = 'granteeCountryOverride_ASC',
  GranteeCountryOverrideDesc = 'granteeCountryOverride_DESC',
  GranteeNameOverrideAsc = 'granteeNameOverride_ASC',
  GranteeNameOverrideDesc = 'granteeNameOverride_DESC',
  GranteeStateOverrideAsc = 'granteeStateOverride_ASC',
  GranteeStateOverrideDesc = 'granteeStateOverride_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum HeroAssetLinkingCollectionsResourcesCurrentGranteesCollectionOrder {
  GrantDatabaseCtaTextAsc = 'grantDatabaseCtaText_ASC',
  GrantDatabaseCtaTextDesc = 'grantDatabaseCtaText_DESC',
  ResourcesTitleAsc = 'resourcesTitle_ASC',
  ResourcesTitleDesc = 'resourcesTitle_DESC',
  SimilarGranteesTitleAsc = 'similarGranteesTitle_ASC',
  SimilarGranteesTitleDesc = 'similarGranteesTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum HeroAssetLinkingCollectionsResourcesCurrentGranteesCursorCollectionOrder {
  GrantDatabaseCtaTextAsc = 'grantDatabaseCtaText_ASC',
  GrantDatabaseCtaTextDesc = 'grantDatabaseCtaText_DESC',
  ResourcesTitleAsc = 'resourcesTitle_ASC',
  ResourcesTitleDesc = 'resourcesTitle_DESC',
  SimilarGranteesTitleAsc = 'similarGranteesTitle_ASC',
  SimilarGranteesTitleDesc = 'similarGranteesTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum HeroAssetLinkingCollectionsResourcesProspectiveGranteesCollectionOrder {
  CallsForConceptsTitleAsc = 'callsForConceptsTitle_ASC',
  CallsForConceptsTitleDesc = 'callsForConceptsTitle_DESC',
  GrantDatabaseCtaTextAsc = 'grantDatabaseCtaText_ASC',
  GrantDatabaseCtaTextDesc = 'grantDatabaseCtaText_DESC',
  GrantmakingAtGlanceTitleAsc = 'grantmakingAtGlanceTitle_ASC',
  GrantmakingAtGlanceTitleDesc = 'grantmakingAtGlanceTitle_DESC',
  NewsletterCtaTextAsc = 'newsletterCtaText_ASC',
  NewsletterCtaTextDesc = 'newsletterCtaText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum HeroAssetLinkingCollectionsResourcesProspectiveGranteesCursorCollectionOrder {
  CallsForConceptsTitleAsc = 'callsForConceptsTitle_ASC',
  CallsForConceptsTitleDesc = 'callsForConceptsTitle_DESC',
  GrantDatabaseCtaTextAsc = 'grantDatabaseCtaText_ASC',
  GrantDatabaseCtaTextDesc = 'grantDatabaseCtaText_DESC',
  GrantmakingAtGlanceTitleAsc = 'grantmakingAtGlanceTitle_ASC',
  GrantmakingAtGlanceTitleDesc = 'grantmakingAtGlanceTitle_DESC',
  NewsletterCtaTextAsc = 'newsletterCtaText_ASC',
  NewsletterCtaTextDesc = 'newsletterCtaText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum HeroAssetOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VideoHasAudioAsc = 'videoHasAudio_ASC',
  VideoHasAudioDesc = 'videoHasAudio_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/historyPage) */
export type HistoryPage = Entry & _Node & {
  __typename: 'HistoryPage';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  currentPresident: Maybe<Person>;
  currentPresidentStartYear: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  explanatoryParagraph: Maybe<Scalars['String']['output']>;
  foundersCollection: Maybe<HistoryPageFoundersCollection>;
  foundersCursorCollection: Maybe<HistoryPageFoundersCursorCollection>;
  grantMakingProcessCtaText: Maybe<Scalars['String']['output']>;
  grantMakingProcessDescription: Maybe<Scalars['String']['output']>;
  heroImage: Maybe<Asset>;
  impactArticlesCollection: Maybe<HistoryPageImpactArticlesCollection>;
  impactArticlesCursorCollection: Maybe<HistoryPageImpactArticlesCursorCollection>;
  impactTitle: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<HistoryPageLinkingCollections>;
  navigationImagePortrait: Maybe<Asset>;
  peopleDescription: Maybe<Scalars['String']['output']>;
  peopleSubtitle: Maybe<Scalars['String']['output']>;
  peopleTitle: Maybe<Scalars['String']['output']>;
  presidentsTitle: Maybe<Scalars['String']['output']>;
  previousPresidentsCollection: Maybe<HistoryPagePreviousPresidentsCollection>;
  previousPresidentsCursorCollection: Maybe<HistoryPagePreviousPresidentsCursorCollection>;
  slug: Maybe<Scalars['String']['output']>;
  spaceDescription: Maybe<Scalars['String']['output']>;
  spaceImagesCollection: Maybe<AssetCollection>;
  spaceImagesCursorCollection: Maybe<AssetCursorCollection>;
  spaceTitle: Maybe<Scalars['String']['output']>;
  sys: Sys;
  text: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/historyPage) */
export type HistoryPageCurrentPresidentArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PersonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/historyPage) */
export type HistoryPageCurrentPresidentStartYearArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/historyPage) */
export type HistoryPageDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/historyPage) */
export type HistoryPageExplanatoryParagraphArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/historyPage) */
export type HistoryPageFoundersCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HistoryPageFoundersCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<HistoryPersonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/historyPage) */
export type HistoryPageFoundersCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HistoryPageFoundersCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<HistoryPersonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/historyPage) */
export type HistoryPageGrantMakingProcessCtaTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/historyPage) */
export type HistoryPageGrantMakingProcessDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/historyPage) */
export type HistoryPageHeroImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/historyPage) */
export type HistoryPageImpactArticlesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HistoryPageImpactArticlesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ArticleFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/historyPage) */
export type HistoryPageImpactArticlesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HistoryPageImpactArticlesCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ArticleFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/historyPage) */
export type HistoryPageImpactTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/historyPage) */
export type HistoryPageLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/historyPage) */
export type HistoryPageNavigationImagePortraitArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/historyPage) */
export type HistoryPagePeopleDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/historyPage) */
export type HistoryPagePeopleSubtitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/historyPage) */
export type HistoryPagePeopleTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/historyPage) */
export type HistoryPagePresidentsTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/historyPage) */
export type HistoryPagePreviousPresidentsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HistoryPagePreviousPresidentsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<HistoryPersonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/historyPage) */
export type HistoryPagePreviousPresidentsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HistoryPagePreviousPresidentsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<HistoryPersonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/historyPage) */
export type HistoryPageSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/historyPage) */
export type HistoryPageSpaceDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/historyPage) */
export type HistoryPageSpaceImagesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/historyPage) */
export type HistoryPageSpaceImagesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/historyPage) */
export type HistoryPageSpaceTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/historyPage) */
export type HistoryPageTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/historyPage) */
export type HistoryPageTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type HistoryPageCollection = {
  __typename: 'HistoryPageCollection';
  items: Array<Maybe<HistoryPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HistoryPageCursorCollection = {
  __typename: 'HistoryPageCursorCollection';
  items: Array<Maybe<HistoryPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type HistoryPageFilter = {
  AND: InputMaybe<Array<InputMaybe<HistoryPageFilter>>>;
  OR: InputMaybe<Array<InputMaybe<HistoryPageFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  currentPresident: InputMaybe<CfPersonNestedFilter>;
  currentPresidentStartYear: InputMaybe<Scalars['String']['input']>;
  currentPresidentStartYear_contains: InputMaybe<Scalars['String']['input']>;
  currentPresidentStartYear_exists: InputMaybe<Scalars['Boolean']['input']>;
  currentPresidentStartYear_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currentPresidentStartYear_not: InputMaybe<Scalars['String']['input']>;
  currentPresidentStartYear_not_contains: InputMaybe<Scalars['String']['input']>;
  currentPresidentStartYear_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currentPresident_exists: InputMaybe<Scalars['Boolean']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  explanatoryParagraph: InputMaybe<Scalars['String']['input']>;
  explanatoryParagraph_contains: InputMaybe<Scalars['String']['input']>;
  explanatoryParagraph_exists: InputMaybe<Scalars['Boolean']['input']>;
  explanatoryParagraph_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  explanatoryParagraph_not: InputMaybe<Scalars['String']['input']>;
  explanatoryParagraph_not_contains: InputMaybe<Scalars['String']['input']>;
  explanatoryParagraph_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  founders: InputMaybe<CfHistoryPersonNestedFilter>;
  foundersCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  grantMakingProcessCtaText: InputMaybe<Scalars['String']['input']>;
  grantMakingProcessCtaText_contains: InputMaybe<Scalars['String']['input']>;
  grantMakingProcessCtaText_exists: InputMaybe<Scalars['Boolean']['input']>;
  grantMakingProcessCtaText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  grantMakingProcessCtaText_not: InputMaybe<Scalars['String']['input']>;
  grantMakingProcessCtaText_not_contains: InputMaybe<Scalars['String']['input']>;
  grantMakingProcessCtaText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  grantMakingProcessDescription: InputMaybe<Scalars['String']['input']>;
  grantMakingProcessDescription_contains: InputMaybe<Scalars['String']['input']>;
  grantMakingProcessDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  grantMakingProcessDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  grantMakingProcessDescription_not: InputMaybe<Scalars['String']['input']>;
  grantMakingProcessDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  grantMakingProcessDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heroImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  impactArticles: InputMaybe<CfArticleNestedFilter>;
  impactArticlesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  impactTitle: InputMaybe<Scalars['String']['input']>;
  impactTitle_contains: InputMaybe<Scalars['String']['input']>;
  impactTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  impactTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  impactTitle_not: InputMaybe<Scalars['String']['input']>;
  impactTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  impactTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navigationImagePortrait_exists: InputMaybe<Scalars['Boolean']['input']>;
  peopleDescription: InputMaybe<Scalars['String']['input']>;
  peopleDescription_contains: InputMaybe<Scalars['String']['input']>;
  peopleDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  peopleDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  peopleDescription_not: InputMaybe<Scalars['String']['input']>;
  peopleDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  peopleDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  peopleSubtitle: InputMaybe<Scalars['String']['input']>;
  peopleSubtitle_contains: InputMaybe<Scalars['String']['input']>;
  peopleSubtitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  peopleSubtitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  peopleSubtitle_not: InputMaybe<Scalars['String']['input']>;
  peopleSubtitle_not_contains: InputMaybe<Scalars['String']['input']>;
  peopleSubtitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  peopleTitle: InputMaybe<Scalars['String']['input']>;
  peopleTitle_contains: InputMaybe<Scalars['String']['input']>;
  peopleTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  peopleTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  peopleTitle_not: InputMaybe<Scalars['String']['input']>;
  peopleTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  peopleTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  presidentsTitle: InputMaybe<Scalars['String']['input']>;
  presidentsTitle_contains: InputMaybe<Scalars['String']['input']>;
  presidentsTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  presidentsTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  presidentsTitle_not: InputMaybe<Scalars['String']['input']>;
  presidentsTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  presidentsTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  previousPresidents: InputMaybe<CfHistoryPersonNestedFilter>;
  previousPresidentsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  spaceDescription: InputMaybe<Scalars['String']['input']>;
  spaceDescription_contains: InputMaybe<Scalars['String']['input']>;
  spaceDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  spaceDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  spaceDescription_not: InputMaybe<Scalars['String']['input']>;
  spaceDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  spaceDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  spaceImagesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  spaceTitle: InputMaybe<Scalars['String']['input']>;
  spaceTitle_contains: InputMaybe<Scalars['String']['input']>;
  spaceTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  spaceTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  spaceTitle_not: InputMaybe<Scalars['String']['input']>;
  spaceTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  spaceTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  text: InputMaybe<Scalars['String']['input']>;
  text_contains: InputMaybe<Scalars['String']['input']>;
  text_exists: InputMaybe<Scalars['Boolean']['input']>;
  text_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text_not: InputMaybe<Scalars['String']['input']>;
  text_not_contains: InputMaybe<Scalars['String']['input']>;
  text_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type HistoryPageFoundersCollection = {
  __typename: 'HistoryPageFoundersCollection';
  items: Array<Maybe<HistoryPerson>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum HistoryPageFoundersCollectionOrder {
  EndYearAsc = 'endYear_ASC',
  EndYearDesc = 'endYear_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StartYearAsc = 'startYear_ASC',
  StartYearDesc = 'startYear_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  YearsOfPresidencyAsc = 'yearsOfPresidency_ASC',
  YearsOfPresidencyDesc = 'yearsOfPresidency_DESC'
}

export type HistoryPageFoundersCursorCollection = {
  __typename: 'HistoryPageFoundersCursorCollection';
  items: Array<Maybe<HistoryPerson>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum HistoryPageFoundersCursorCollectionOrder {
  EndYearAsc = 'endYear_ASC',
  EndYearDesc = 'endYear_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StartYearAsc = 'startYear_ASC',
  StartYearDesc = 'startYear_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  YearsOfPresidencyAsc = 'yearsOfPresidency_ASC',
  YearsOfPresidencyDesc = 'yearsOfPresidency_DESC'
}

export type HistoryPageImpactArticlesCollection = {
  __typename: 'HistoryPageImpactArticlesCollection';
  items: Array<Maybe<Article>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum HistoryPageImpactArticlesCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  ExternalNewsUrlAsc = 'externalNewsUrl_ASC',
  ExternalNewsUrlDesc = 'externalNewsUrl_DESC',
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  PasswordAsc = 'password_ASC',
  PasswordDesc = 'password_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export type HistoryPageImpactArticlesCursorCollection = {
  __typename: 'HistoryPageImpactArticlesCursorCollection';
  items: Array<Maybe<Article>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum HistoryPageImpactArticlesCursorCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  ExternalNewsUrlAsc = 'externalNewsUrl_ASC',
  ExternalNewsUrlDesc = 'externalNewsUrl_DESC',
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  PasswordAsc = 'password_ASC',
  PasswordDesc = 'password_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export type HistoryPageLinkingCollections = {
  __typename: 'HistoryPageLinkingCollections';
  connectWithLinkCollection: Maybe<ConnectWithLinkCollection>;
  connectWithLinkCursorCollection: Maybe<ConnectWithLinkCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  mainNavigationCollection: Maybe<MainNavigationCollection>;
  mainNavigationCursorCollection: Maybe<MainNavigationCursorCollection>;
};


export type HistoryPageLinkingCollectionsConnectWithLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HistoryPageLinkingCollectionsConnectWithLinkCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type HistoryPageLinkingCollectionsConnectWithLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HistoryPageLinkingCollectionsConnectWithLinkCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type HistoryPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type HistoryPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type HistoryPageLinkingCollectionsMainNavigationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HistoryPageLinkingCollectionsMainNavigationCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type HistoryPageLinkingCollectionsMainNavigationCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HistoryPageLinkingCollectionsMainNavigationCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum HistoryPageLinkingCollectionsConnectWithLinkCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum HistoryPageLinkingCollectionsConnectWithLinkCursorCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum HistoryPageLinkingCollectionsMainNavigationCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum HistoryPageLinkingCollectionsMainNavigationCursorCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum HistoryPageOrder {
  CurrentPresidentStartYearAsc = 'currentPresidentStartYear_ASC',
  CurrentPresidentStartYearDesc = 'currentPresidentStartYear_DESC',
  GrantMakingProcessCtaTextAsc = 'grantMakingProcessCtaText_ASC',
  GrantMakingProcessCtaTextDesc = 'grantMakingProcessCtaText_DESC',
  ImpactTitleAsc = 'impactTitle_ASC',
  ImpactTitleDesc = 'impactTitle_DESC',
  PeopleSubtitleAsc = 'peopleSubtitle_ASC',
  PeopleSubtitleDesc = 'peopleSubtitle_DESC',
  PeopleTitleAsc = 'peopleTitle_ASC',
  PeopleTitleDesc = 'peopleTitle_DESC',
  PresidentsTitleAsc = 'presidentsTitle_ASC',
  PresidentsTitleDesc = 'presidentsTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SpaceTitleAsc = 'spaceTitle_ASC',
  SpaceTitleDesc = 'spaceTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type HistoryPagePreviousPresidentsCollection = {
  __typename: 'HistoryPagePreviousPresidentsCollection';
  items: Array<Maybe<HistoryPerson>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum HistoryPagePreviousPresidentsCollectionOrder {
  EndYearAsc = 'endYear_ASC',
  EndYearDesc = 'endYear_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StartYearAsc = 'startYear_ASC',
  StartYearDesc = 'startYear_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  YearsOfPresidencyAsc = 'yearsOfPresidency_ASC',
  YearsOfPresidencyDesc = 'yearsOfPresidency_DESC'
}

export type HistoryPagePreviousPresidentsCursorCollection = {
  __typename: 'HistoryPagePreviousPresidentsCursorCollection';
  items: Array<Maybe<HistoryPerson>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum HistoryPagePreviousPresidentsCursorCollectionOrder {
  EndYearAsc = 'endYear_ASC',
  EndYearDesc = 'endYear_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StartYearAsc = 'startYear_ASC',
  StartYearDesc = 'startYear_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  YearsOfPresidencyAsc = 'yearsOfPresidency_ASC',
  YearsOfPresidencyDesc = 'yearsOfPresidency_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/historyPerson) */
export type HistoryPerson = Entry & _Node & {
  __typename: 'HistoryPerson';
  _id: Scalars['ID']['output'];
  biography: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  endYear: Maybe<Scalars['String']['output']>;
  image: Maybe<Asset>;
  linkedFrom: Maybe<HistoryPersonLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  startYear: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
  yearsOfPresidency: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/historyPerson) */
export type HistoryPersonBiographyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/historyPerson) */
export type HistoryPersonEndYearArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/historyPerson) */
export type HistoryPersonImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/historyPerson) */
export type HistoryPersonLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/historyPerson) */
export type HistoryPersonNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/historyPerson) */
export type HistoryPersonSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/historyPerson) */
export type HistoryPersonStartYearArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/historyPerson) */
export type HistoryPersonTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/historyPerson) */
export type HistoryPersonYearsOfPresidencyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type HistoryPersonCollection = {
  __typename: 'HistoryPersonCollection';
  items: Array<Maybe<HistoryPerson>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HistoryPersonCursorCollection = {
  __typename: 'HistoryPersonCursorCollection';
  items: Array<Maybe<HistoryPerson>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type HistoryPersonFilter = {
  AND: InputMaybe<Array<InputMaybe<HistoryPersonFilter>>>;
  OR: InputMaybe<Array<InputMaybe<HistoryPersonFilter>>>;
  biography: InputMaybe<Scalars['String']['input']>;
  biography_contains: InputMaybe<Scalars['String']['input']>;
  biography_exists: InputMaybe<Scalars['Boolean']['input']>;
  biography_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  biography_not: InputMaybe<Scalars['String']['input']>;
  biography_not_contains: InputMaybe<Scalars['String']['input']>;
  biography_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  endYear: InputMaybe<Scalars['String']['input']>;
  endYear_contains: InputMaybe<Scalars['String']['input']>;
  endYear_exists: InputMaybe<Scalars['Boolean']['input']>;
  endYear_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endYear_not: InputMaybe<Scalars['String']['input']>;
  endYear_not_contains: InputMaybe<Scalars['String']['input']>;
  endYear_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startYear: InputMaybe<Scalars['String']['input']>;
  startYear_contains: InputMaybe<Scalars['String']['input']>;
  startYear_exists: InputMaybe<Scalars['Boolean']['input']>;
  startYear_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startYear_not: InputMaybe<Scalars['String']['input']>;
  startYear_not_contains: InputMaybe<Scalars['String']['input']>;
  startYear_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  yearsOfPresidency: InputMaybe<Scalars['String']['input']>;
  yearsOfPresidency_contains: InputMaybe<Scalars['String']['input']>;
  yearsOfPresidency_exists: InputMaybe<Scalars['Boolean']['input']>;
  yearsOfPresidency_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  yearsOfPresidency_not: InputMaybe<Scalars['String']['input']>;
  yearsOfPresidency_not_contains: InputMaybe<Scalars['String']['input']>;
  yearsOfPresidency_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type HistoryPersonLinkingCollections = {
  __typename: 'HistoryPersonLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  historyPageCollection: Maybe<HistoryPageCollection>;
  historyPageCursorCollection: Maybe<HistoryPageCursorCollection>;
};


export type HistoryPersonLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type HistoryPersonLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type HistoryPersonLinkingCollectionsHistoryPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HistoryPersonLinkingCollectionsHistoryPageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type HistoryPersonLinkingCollectionsHistoryPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HistoryPersonLinkingCollectionsHistoryPageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum HistoryPersonLinkingCollectionsHistoryPageCollectionOrder {
  CurrentPresidentStartYearAsc = 'currentPresidentStartYear_ASC',
  CurrentPresidentStartYearDesc = 'currentPresidentStartYear_DESC',
  GrantMakingProcessCtaTextAsc = 'grantMakingProcessCtaText_ASC',
  GrantMakingProcessCtaTextDesc = 'grantMakingProcessCtaText_DESC',
  ImpactTitleAsc = 'impactTitle_ASC',
  ImpactTitleDesc = 'impactTitle_DESC',
  PeopleSubtitleAsc = 'peopleSubtitle_ASC',
  PeopleSubtitleDesc = 'peopleSubtitle_DESC',
  PeopleTitleAsc = 'peopleTitle_ASC',
  PeopleTitleDesc = 'peopleTitle_DESC',
  PresidentsTitleAsc = 'presidentsTitle_ASC',
  PresidentsTitleDesc = 'presidentsTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SpaceTitleAsc = 'spaceTitle_ASC',
  SpaceTitleDesc = 'spaceTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum HistoryPersonLinkingCollectionsHistoryPageCursorCollectionOrder {
  CurrentPresidentStartYearAsc = 'currentPresidentStartYear_ASC',
  CurrentPresidentStartYearDesc = 'currentPresidentStartYear_DESC',
  GrantMakingProcessCtaTextAsc = 'grantMakingProcessCtaText_ASC',
  GrantMakingProcessCtaTextDesc = 'grantMakingProcessCtaText_DESC',
  ImpactTitleAsc = 'impactTitle_ASC',
  ImpactTitleDesc = 'impactTitle_DESC',
  PeopleSubtitleAsc = 'peopleSubtitle_ASC',
  PeopleSubtitleDesc = 'peopleSubtitle_DESC',
  PeopleTitleAsc = 'peopleTitle_ASC',
  PeopleTitleDesc = 'peopleTitle_DESC',
  PresidentsTitleAsc = 'presidentsTitle_ASC',
  PresidentsTitleDesc = 'presidentsTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SpaceTitleAsc = 'spaceTitle_ASC',
  SpaceTitleDesc = 'spaceTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum HistoryPersonOrder {
  EndYearAsc = 'endYear_ASC',
  EndYearDesc = 'endYear_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StartYearAsc = 'startYear_ASC',
  StartYearDesc = 'startYear_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  YearsOfPresidencyAsc = 'yearsOfPresidency_ASC',
  YearsOfPresidencyDesc = 'yearsOfPresidency_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/homePage) */
export type HomePage = Entry & _Node & {
  __typename: 'HomePage';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  ctaText: Maybe<Scalars['String']['output']>;
  grantActivityArticlesCollection: Maybe<HomePageGrantActivityArticlesCollection>;
  grantActivityArticlesCursorCollection: Maybe<HomePageGrantActivityArticlesCursorCollection>;
  inFocusContentCollection: Maybe<HomePageInFocusContentCollection>;
  inFocusContentCursorCollection: Maybe<HomePageInFocusContentCursorCollection>;
  inFocusHeadline: Maybe<Scalars['String']['output']>;
  inTheNewsCollection: Maybe<HomePageInTheNewsCollection>;
  inTheNewsCursorCollection: Maybe<HomePageInTheNewsCursorCollection>;
  layout: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<HomePageLinkingCollections>;
  missionText: Maybe<Scalars['String']['output']>;
  newsletter: Maybe<NewsletterCard>;
  slug: Maybe<Scalars['String']['output']>;
  spotlightCtaLink: Maybe<HomePageSpotlightCtaLink>;
  spotlightFeature: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  spotlightImage: Maybe<Asset>;
  spotlightVideo: Maybe<VideoNative>;
  storiesCta: Maybe<Scalars['String']['output']>;
  sys: Sys;
  thematicSpotlight: Maybe<HomePageThematicSpotlight>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/homePage) */
export type HomePageCtaTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/homePage) */
export type HomePageGrantActivityArticlesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HomePageGrantActivityArticlesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantActivityArticleFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/homePage) */
export type HomePageGrantActivityArticlesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HomePageGrantActivityArticlesCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantActivityArticleFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/homePage) */
export type HomePageInFocusContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<HomePageInFocusContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/homePage) */
export type HomePageInFocusContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<HomePageInFocusContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/homePage) */
export type HomePageInFocusHeadlineArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/homePage) */
export type HomePageInTheNewsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<HomePageInTheNewsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/homePage) */
export type HomePageInTheNewsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<HomePageInTheNewsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/homePage) */
export type HomePageLayoutArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/homePage) */
export type HomePageLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/homePage) */
export type HomePageMissionTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/homePage) */
export type HomePageNewsletterArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<NewsletterCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/homePage) */
export type HomePageSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/homePage) */
export type HomePageSpotlightCtaLinkArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<HomePageSpotlightCtaLinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/homePage) */
export type HomePageSpotlightFeatureArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/homePage) */
export type HomePageSpotlightImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/homePage) */
export type HomePageSpotlightVideoArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<VideoNativeFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/homePage) */
export type HomePageStoriesCtaArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/homePage) */
export type HomePageThematicSpotlightArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomePageCollection = {
  __typename: 'HomePageCollection';
  items: Array<Maybe<HomePage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HomePageCursorCollection = {
  __typename: 'HomePageCursorCollection';
  items: Array<Maybe<HomePage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type HomePageFilter = {
  AND: InputMaybe<Array<InputMaybe<HomePageFilter>>>;
  OR: InputMaybe<Array<InputMaybe<HomePageFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  ctaText: InputMaybe<Scalars['String']['input']>;
  ctaText_contains: InputMaybe<Scalars['String']['input']>;
  ctaText_exists: InputMaybe<Scalars['Boolean']['input']>;
  ctaText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaText_not: InputMaybe<Scalars['String']['input']>;
  ctaText_not_contains: InputMaybe<Scalars['String']['input']>;
  ctaText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  grantActivityArticles: InputMaybe<CfGrantActivityArticleNestedFilter>;
  grantActivityArticlesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  inFocusContent: InputMaybe<CfinFocusContentMultiTypeNestedFilter>;
  inFocusContentCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  inFocusHeadline: InputMaybe<Scalars['String']['input']>;
  inFocusHeadline_contains: InputMaybe<Scalars['String']['input']>;
  inFocusHeadline_exists: InputMaybe<Scalars['Boolean']['input']>;
  inFocusHeadline_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inFocusHeadline_not: InputMaybe<Scalars['String']['input']>;
  inFocusHeadline_not_contains: InputMaybe<Scalars['String']['input']>;
  inFocusHeadline_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inTheNews: InputMaybe<CfinTheNewsMultiTypeNestedFilter>;
  inTheNewsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  layout: InputMaybe<Scalars['String']['input']>;
  layout_contains: InputMaybe<Scalars['String']['input']>;
  layout_exists: InputMaybe<Scalars['Boolean']['input']>;
  layout_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  layout_not: InputMaybe<Scalars['String']['input']>;
  layout_not_contains: InputMaybe<Scalars['String']['input']>;
  layout_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  missionText: InputMaybe<Scalars['String']['input']>;
  missionText_contains: InputMaybe<Scalars['String']['input']>;
  missionText_exists: InputMaybe<Scalars['Boolean']['input']>;
  missionText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  missionText_not: InputMaybe<Scalars['String']['input']>;
  missionText_not_contains: InputMaybe<Scalars['String']['input']>;
  missionText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  newsletter: InputMaybe<CfNewsletterCardNestedFilter>;
  newsletter_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  spotlightCTALink: InputMaybe<CfspotlightCtaLinkMultiTypeNestedFilter>;
  spotlightCTALink_exists: InputMaybe<Scalars['Boolean']['input']>;
  spotlightFeature_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  spotlightFeature_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  spotlightFeature_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  spotlightFeature_exists: InputMaybe<Scalars['Boolean']['input']>;
  spotlightImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  spotlightVideo: InputMaybe<CfVideoNativeNestedFilter>;
  spotlightVideo_exists: InputMaybe<Scalars['Boolean']['input']>;
  storiesCta: InputMaybe<Scalars['String']['input']>;
  storiesCta_contains: InputMaybe<Scalars['String']['input']>;
  storiesCta_exists: InputMaybe<Scalars['Boolean']['input']>;
  storiesCta_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  storiesCta_not: InputMaybe<Scalars['String']['input']>;
  storiesCta_not_contains: InputMaybe<Scalars['String']['input']>;
  storiesCta_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  thematicSpotlight_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomePageGrantActivityArticlesCollection = {
  __typename: 'HomePageGrantActivityArticlesCollection';
  items: Array<Maybe<GrantActivityArticle>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum HomePageGrantActivityArticlesCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  GranteeCityOverrideAsc = 'granteeCityOverride_ASC',
  GranteeCityOverrideDesc = 'granteeCityOverride_DESC',
  GranteeCountryOverrideAsc = 'granteeCountryOverride_ASC',
  GranteeCountryOverrideDesc = 'granteeCountryOverride_DESC',
  GranteeNameOverrideAsc = 'granteeNameOverride_ASC',
  GranteeNameOverrideDesc = 'granteeNameOverride_DESC',
  GranteeStateOverrideAsc = 'granteeStateOverride_ASC',
  GranteeStateOverrideDesc = 'granteeStateOverride_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type HomePageGrantActivityArticlesCursorCollection = {
  __typename: 'HomePageGrantActivityArticlesCursorCollection';
  items: Array<Maybe<GrantActivityArticle>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum HomePageGrantActivityArticlesCursorCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  GranteeCityOverrideAsc = 'granteeCityOverride_ASC',
  GranteeCityOverrideDesc = 'granteeCityOverride_DESC',
  GranteeCountryOverrideAsc = 'granteeCountryOverride_ASC',
  GranteeCountryOverrideDesc = 'granteeCountryOverride_DESC',
  GranteeNameOverrideAsc = 'granteeNameOverride_ASC',
  GranteeNameOverrideDesc = 'granteeNameOverride_DESC',
  GranteeStateOverrideAsc = 'granteeStateOverride_ASC',
  GranteeStateOverrideDesc = 'granteeStateOverride_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type HomePageInFocusContentCollection = {
  __typename: 'HomePageInFocusContentCollection';
  items: Array<Maybe<HomePageInFocusContentItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HomePageInFocusContentCursorCollection = {
  __typename: 'HomePageInFocusContentCursorCollection';
  items: Array<Maybe<HomePageInFocusContentItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type HomePageInFocusContentFilter = {
  AND: InputMaybe<Array<InputMaybe<HomePageInFocusContentFilter>>>;
  OR: InputMaybe<Array<InputMaybe<HomePageInFocusContentFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
};

export type HomePageInFocusContentItem = AnnualReport | Article | EmphasizedArticle | ExternalEvent | Feature | GrantActivityArticle | Idea | Quote;

export type HomePageInTheNewsCollection = {
  __typename: 'HomePageInTheNewsCollection';
  items: Array<Maybe<HomePageInTheNewsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HomePageInTheNewsCursorCollection = {
  __typename: 'HomePageInTheNewsCursorCollection';
  items: Array<Maybe<HomePageInTheNewsItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type HomePageInTheNewsFilter = {
  AND: InputMaybe<Array<InputMaybe<HomePageInTheNewsFilter>>>;
  OR: InputMaybe<Array<InputMaybe<HomePageInTheNewsFilter>>>;
  audio_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  date: InputMaybe<Scalars['DateTime']['input']>;
  date_exists: InputMaybe<Scalars['Boolean']['input']>;
  date_gt: InputMaybe<Scalars['DateTime']['input']>;
  date_gte: InputMaybe<Scalars['DateTime']['input']>;
  date_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_lt: InputMaybe<Scalars['DateTime']['input']>;
  date_lte: InputMaybe<Scalars['DateTime']['input']>;
  date_not: InputMaybe<Scalars['DateTime']['input']>;
  date_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  person_exists: InputMaybe<Scalars['Boolean']['input']>;
  quickLinks_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type HomePageInTheNewsItem = AnnualReport | Article;

export type HomePageLinkingCollections = {
  __typename: 'HomePageLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type HomePageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type HomePageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum HomePageOrder {
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  MissionTextAsc = 'missionText_ASC',
  MissionTextDesc = 'missionText_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StoriesCtaAsc = 'storiesCta_ASC',
  StoriesCtaDesc = 'storiesCta_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type HomePageSpotlightCtaLink = Article | ExternalEvent | Feature | GrantActivityArticle | Idea;

export type HomePageSpotlightCtaLinkFilter = {
  AND: InputMaybe<Array<InputMaybe<HomePageSpotlightCtaLinkFilter>>>;
  OR: InputMaybe<Array<InputMaybe<HomePageSpotlightCtaLinkFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
};

export type HomePageThematicSpotlight = SpotlightSlideshow | SpotlightVideo;

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/idea) */
export type Idea = Entry & _Node & {
  __typename: 'Idea';
  _id: Scalars['ID']['output'];
  callForConceptsCollection: Maybe<IdeaCallForConceptsCollection>;
  callForConceptsCursorCollection: Maybe<IdeaCallForConceptsCursorCollection>;
  contentCollection: Maybe<IdeaContentCollection>;
  contentCursorCollection: Maybe<IdeaContentCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  ctaContextualMessage: Maybe<Scalars['String']['output']>;
  excludedGrantsCollection: Maybe<IdeaExcludedGrantsCollection>;
  excludedGrantsCursorCollection: Maybe<IdeaExcludedGrantsCursorCollection>;
  heroImage: Maybe<Asset>;
  ideaSetupStatement: Maybe<Scalars['String']['output']>;
  includedGrantsCollection: Maybe<IdeaIncludedGrantsCollection>;
  includedGrantsCursorCollection: Maybe<IdeaIncludedGrantsCursorCollection>;
  linkedFrom: Maybe<IdeaLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  navigationImagePortrait: Maybe<Asset>;
  newsletter: Maybe<NewsletterCard>;
  question: Maybe<Scalars['String']['output']>;
  recommendedGrantsCollection: Maybe<IdeaRecommendedGrantsCollection>;
  recommendedGrantsCursorCollection: Maybe<IdeaRecommendedGrantsCursorCollection>;
  slug: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/idea) */
export type IdeaCallForConceptsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<IdeaCallForConceptsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CallForConceptFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/idea) */
export type IdeaCallForConceptsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<IdeaCallForConceptsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CallForConceptFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/idea) */
export type IdeaContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<IdeaContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/idea) */
export type IdeaContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<IdeaContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/idea) */
export type IdeaCtaContextualMessageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/idea) */
export type IdeaExcludedGrantsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<IdeaExcludedGrantsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/idea) */
export type IdeaExcludedGrantsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<IdeaExcludedGrantsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/idea) */
export type IdeaHeroImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/idea) */
export type IdeaIdeaSetupStatementArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/idea) */
export type IdeaIncludedGrantsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<IdeaIncludedGrantsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/idea) */
export type IdeaIncludedGrantsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<IdeaIncludedGrantsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/idea) */
export type IdeaLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/idea) */
export type IdeaNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/idea) */
export type IdeaNavigationImagePortraitArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/idea) */
export type IdeaNewsletterArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<NewsletterCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/idea) */
export type IdeaQuestionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/idea) */
export type IdeaRecommendedGrantsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<IdeaRecommendedGrantsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/idea) */
export type IdeaRecommendedGrantsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<IdeaRecommendedGrantsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/idea) */
export type IdeaSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type IdeaCallForConceptsCollection = {
  __typename: 'IdeaCallForConceptsCollection';
  items: Array<Maybe<CallForConcept>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum IdeaCallForConceptsCollectionOrder {
  CallForConceptTitleAsc = 'callForConceptTitle_ASC',
  CallForConceptTitleDesc = 'callForConceptTitle_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  RegistrationDeadlineDateAsc = 'registrationDeadlineDate_ASC',
  RegistrationDeadlineDateDesc = 'registrationDeadlineDate_DESC',
  RegistrationDeadlineTitleAsc = 'registrationDeadlineTitle_ASC',
  RegistrationDeadlineTitleDesc = 'registrationDeadlineTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export type IdeaCallForConceptsCursorCollection = {
  __typename: 'IdeaCallForConceptsCursorCollection';
  items: Array<Maybe<CallForConcept>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum IdeaCallForConceptsCursorCollectionOrder {
  CallForConceptTitleAsc = 'callForConceptTitle_ASC',
  CallForConceptTitleDesc = 'callForConceptTitle_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  RegistrationDeadlineDateAsc = 'registrationDeadlineDate_ASC',
  RegistrationDeadlineDateDesc = 'registrationDeadlineDate_DESC',
  RegistrationDeadlineTitleAsc = 'registrationDeadlineTitle_ASC',
  RegistrationDeadlineTitleDesc = 'registrationDeadlineTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export type IdeaCollection = {
  __typename: 'IdeaCollection';
  items: Array<Maybe<Idea>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type IdeaContentCollection = {
  __typename: 'IdeaContentCollection';
  items: Array<Maybe<IdeaContentItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type IdeaContentCursorCollection = {
  __typename: 'IdeaContentCursorCollection';
  items: Array<Maybe<IdeaContentItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type IdeaContentFilter = {
  AND: InputMaybe<Array<InputMaybe<IdeaContentFilter>>>;
  OR: InputMaybe<Array<InputMaybe<IdeaContentFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
};

export type IdeaContentItem = Article | EmphasizedArticle | ExternalEvent | Feature | GrantActivityArticle | Idea | InitiativeQuoteCallOut | Quote | SpotlightSlideshow | SpotlightVideo;

export type IdeaCursorCollection = {
  __typename: 'IdeaCursorCollection';
  items: Array<Maybe<Idea>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type IdeaExcludedGrantsCollection = {
  __typename: 'IdeaExcludedGrantsCollection';
  items: Array<Maybe<Grant>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum IdeaExcludedGrantsCollectionOrder {
  AmountAsc = 'amount_ASC',
  AmountDesc = 'amount_DESC',
  AreaOfFocusAsc = 'areaOfFocus_ASC',
  AreaOfFocusDesc = 'areaOfFocus_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  DurationInMonthsAsc = 'durationInMonths_ASC',
  DurationInMonthsDesc = 'durationInMonths_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ProjectTitleAsc = 'projectTitle_ASC',
  ProjectTitleDesc = 'projectTitle_DESC',
  ReferenceIdAsc = 'referenceId_ASC',
  ReferenceIdDesc = 'referenceId_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type IdeaExcludedGrantsCursorCollection = {
  __typename: 'IdeaExcludedGrantsCursorCollection';
  items: Array<Maybe<Grant>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum IdeaExcludedGrantsCursorCollectionOrder {
  AmountAsc = 'amount_ASC',
  AmountDesc = 'amount_DESC',
  AreaOfFocusAsc = 'areaOfFocus_ASC',
  AreaOfFocusDesc = 'areaOfFocus_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  DurationInMonthsAsc = 'durationInMonths_ASC',
  DurationInMonthsDesc = 'durationInMonths_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ProjectTitleAsc = 'projectTitle_ASC',
  ProjectTitleDesc = 'projectTitle_DESC',
  ReferenceIdAsc = 'referenceId_ASC',
  ReferenceIdDesc = 'referenceId_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type IdeaFilter = {
  AND: InputMaybe<Array<InputMaybe<IdeaFilter>>>;
  OR: InputMaybe<Array<InputMaybe<IdeaFilter>>>;
  callForConcepts: InputMaybe<CfCallForConceptNestedFilter>;
  callForConceptsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  content: InputMaybe<CfcontentMultiTypeNestedFilter>;
  contentCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  ctaContextualMessage: InputMaybe<Scalars['String']['input']>;
  ctaContextualMessage_contains: InputMaybe<Scalars['String']['input']>;
  ctaContextualMessage_exists: InputMaybe<Scalars['Boolean']['input']>;
  ctaContextualMessage_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaContextualMessage_not: InputMaybe<Scalars['String']['input']>;
  ctaContextualMessage_not_contains: InputMaybe<Scalars['String']['input']>;
  ctaContextualMessage_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludedGrants: InputMaybe<CfGrantNestedFilter>;
  excludedGrantsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  heroImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  ideaSetupStatement: InputMaybe<Scalars['String']['input']>;
  ideaSetupStatement_contains: InputMaybe<Scalars['String']['input']>;
  ideaSetupStatement_exists: InputMaybe<Scalars['Boolean']['input']>;
  ideaSetupStatement_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ideaSetupStatement_not: InputMaybe<Scalars['String']['input']>;
  ideaSetupStatement_not_contains: InputMaybe<Scalars['String']['input']>;
  ideaSetupStatement_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  includedGrants: InputMaybe<CfGrantNestedFilter>;
  includedGrantsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navigationImagePortrait_exists: InputMaybe<Scalars['Boolean']['input']>;
  newsletter: InputMaybe<CfNewsletterCardNestedFilter>;
  newsletter_exists: InputMaybe<Scalars['Boolean']['input']>;
  question: InputMaybe<Scalars['String']['input']>;
  question_contains: InputMaybe<Scalars['String']['input']>;
  question_exists: InputMaybe<Scalars['Boolean']['input']>;
  question_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  question_not: InputMaybe<Scalars['String']['input']>;
  question_not_contains: InputMaybe<Scalars['String']['input']>;
  question_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  recommendedGrants: InputMaybe<CfGrantNestedFilter>;
  recommendedGrantsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type IdeaIncludedGrantsCollection = {
  __typename: 'IdeaIncludedGrantsCollection';
  items: Array<Maybe<Grant>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum IdeaIncludedGrantsCollectionOrder {
  AmountAsc = 'amount_ASC',
  AmountDesc = 'amount_DESC',
  AreaOfFocusAsc = 'areaOfFocus_ASC',
  AreaOfFocusDesc = 'areaOfFocus_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  DurationInMonthsAsc = 'durationInMonths_ASC',
  DurationInMonthsDesc = 'durationInMonths_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ProjectTitleAsc = 'projectTitle_ASC',
  ProjectTitleDesc = 'projectTitle_DESC',
  ReferenceIdAsc = 'referenceId_ASC',
  ReferenceIdDesc = 'referenceId_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type IdeaIncludedGrantsCursorCollection = {
  __typename: 'IdeaIncludedGrantsCursorCollection';
  items: Array<Maybe<Grant>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum IdeaIncludedGrantsCursorCollectionOrder {
  AmountAsc = 'amount_ASC',
  AmountDesc = 'amount_DESC',
  AreaOfFocusAsc = 'areaOfFocus_ASC',
  AreaOfFocusDesc = 'areaOfFocus_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  DurationInMonthsAsc = 'durationInMonths_ASC',
  DurationInMonthsDesc = 'durationInMonths_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ProjectTitleAsc = 'projectTitle_ASC',
  ProjectTitleDesc = 'projectTitle_DESC',
  ReferenceIdAsc = 'referenceId_ASC',
  ReferenceIdDesc = 'referenceId_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type IdeaLinkingCollections = {
  __typename: 'IdeaLinkingCollections';
  articleCollection: Maybe<ArticleCollection>;
  articleCursorCollection: Maybe<ArticleCursorCollection>;
  connectWithLinkCollection: Maybe<ConnectWithLinkCollection>;
  connectWithLinkCursorCollection: Maybe<ConnectWithLinkCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  featureCollection: Maybe<FeatureCollection>;
  featureCursorCollection: Maybe<FeatureCursorCollection>;
  grantActivityArticleCollection: Maybe<GrantActivityArticleCollection>;
  grantActivityArticleCursorCollection: Maybe<GrantActivityArticleCursorCollection>;
  homePageCollection: Maybe<HomePageCollection>;
  homePageCursorCollection: Maybe<HomePageCursorCollection>;
  ideaCollection: Maybe<IdeaCollection>;
  ideaCursorCollection: Maybe<IdeaCursorCollection>;
  inlineCardsCollection: Maybe<InlineCardsCollection>;
  inlineCardsCursorCollection: Maybe<InlineCardsCursorCollection>;
  mainNavigationCollection: Maybe<MainNavigationCollection>;
  mainNavigationCursorCollection: Maybe<MainNavigationCursorCollection>;
  navigationItemCollection: Maybe<NavigationItemCollection>;
  navigationItemCursorCollection: Maybe<NavigationItemCursorCollection>;
};


export type IdeaLinkingCollectionsArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<IdeaLinkingCollectionsArticleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type IdeaLinkingCollectionsArticleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<IdeaLinkingCollectionsArticleCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type IdeaLinkingCollectionsConnectWithLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<IdeaLinkingCollectionsConnectWithLinkCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type IdeaLinkingCollectionsConnectWithLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<IdeaLinkingCollectionsConnectWithLinkCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type IdeaLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type IdeaLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type IdeaLinkingCollectionsFeatureCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<IdeaLinkingCollectionsFeatureCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type IdeaLinkingCollectionsFeatureCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<IdeaLinkingCollectionsFeatureCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type IdeaLinkingCollectionsGrantActivityArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<IdeaLinkingCollectionsGrantActivityArticleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type IdeaLinkingCollectionsGrantActivityArticleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<IdeaLinkingCollectionsGrantActivityArticleCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type IdeaLinkingCollectionsHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<IdeaLinkingCollectionsHomePageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type IdeaLinkingCollectionsHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<IdeaLinkingCollectionsHomePageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type IdeaLinkingCollectionsIdeaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<IdeaLinkingCollectionsIdeaCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type IdeaLinkingCollectionsIdeaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<IdeaLinkingCollectionsIdeaCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type IdeaLinkingCollectionsInlineCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<IdeaLinkingCollectionsInlineCardsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type IdeaLinkingCollectionsInlineCardsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<IdeaLinkingCollectionsInlineCardsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type IdeaLinkingCollectionsMainNavigationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<IdeaLinkingCollectionsMainNavigationCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type IdeaLinkingCollectionsMainNavigationCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<IdeaLinkingCollectionsMainNavigationCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type IdeaLinkingCollectionsNavigationItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<IdeaLinkingCollectionsNavigationItemCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type IdeaLinkingCollectionsNavigationItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<IdeaLinkingCollectionsNavigationItemCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum IdeaLinkingCollectionsArticleCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  ExternalNewsUrlAsc = 'externalNewsUrl_ASC',
  ExternalNewsUrlDesc = 'externalNewsUrl_DESC',
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  PasswordAsc = 'password_ASC',
  PasswordDesc = 'password_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum IdeaLinkingCollectionsArticleCursorCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  ExternalNewsUrlAsc = 'externalNewsUrl_ASC',
  ExternalNewsUrlDesc = 'externalNewsUrl_DESC',
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  PasswordAsc = 'password_ASC',
  PasswordDesc = 'password_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum IdeaLinkingCollectionsConnectWithLinkCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum IdeaLinkingCollectionsConnectWithLinkCursorCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum IdeaLinkingCollectionsFeatureCollectionOrder {
  DateTimeAsc = 'dateTime_ASC',
  DateTimeDesc = 'dateTime_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  ShowSocialCtasAsc = 'showSocialCtas_ASC',
  ShowSocialCtasDesc = 'showSocialCtas_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TaglineAsc = 'tagline_ASC',
  TaglineDesc = 'tagline_DESC'
}

export enum IdeaLinkingCollectionsFeatureCursorCollectionOrder {
  DateTimeAsc = 'dateTime_ASC',
  DateTimeDesc = 'dateTime_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  ShowSocialCtasAsc = 'showSocialCtas_ASC',
  ShowSocialCtasDesc = 'showSocialCtas_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TaglineAsc = 'tagline_ASC',
  TaglineDesc = 'tagline_DESC'
}

export enum IdeaLinkingCollectionsGrantActivityArticleCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  GranteeCityOverrideAsc = 'granteeCityOverride_ASC',
  GranteeCityOverrideDesc = 'granteeCityOverride_DESC',
  GranteeCountryOverrideAsc = 'granteeCountryOverride_ASC',
  GranteeCountryOverrideDesc = 'granteeCountryOverride_DESC',
  GranteeNameOverrideAsc = 'granteeNameOverride_ASC',
  GranteeNameOverrideDesc = 'granteeNameOverride_DESC',
  GranteeStateOverrideAsc = 'granteeStateOverride_ASC',
  GranteeStateOverrideDesc = 'granteeStateOverride_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum IdeaLinkingCollectionsGrantActivityArticleCursorCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  GranteeCityOverrideAsc = 'granteeCityOverride_ASC',
  GranteeCityOverrideDesc = 'granteeCityOverride_DESC',
  GranteeCountryOverrideAsc = 'granteeCountryOverride_ASC',
  GranteeCountryOverrideDesc = 'granteeCountryOverride_DESC',
  GranteeNameOverrideAsc = 'granteeNameOverride_ASC',
  GranteeNameOverrideDesc = 'granteeNameOverride_DESC',
  GranteeStateOverrideAsc = 'granteeStateOverride_ASC',
  GranteeStateOverrideDesc = 'granteeStateOverride_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum IdeaLinkingCollectionsHomePageCollectionOrder {
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  MissionTextAsc = 'missionText_ASC',
  MissionTextDesc = 'missionText_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StoriesCtaAsc = 'storiesCta_ASC',
  StoriesCtaDesc = 'storiesCta_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum IdeaLinkingCollectionsHomePageCursorCollectionOrder {
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  MissionTextAsc = 'missionText_ASC',
  MissionTextDesc = 'missionText_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StoriesCtaAsc = 'storiesCta_ASC',
  StoriesCtaDesc = 'storiesCta_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum IdeaLinkingCollectionsIdeaCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum IdeaLinkingCollectionsIdeaCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum IdeaLinkingCollectionsInlineCardsCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum IdeaLinkingCollectionsInlineCardsCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum IdeaLinkingCollectionsMainNavigationCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum IdeaLinkingCollectionsMainNavigationCursorCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum IdeaLinkingCollectionsNavigationItemCollectionOrder {
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum IdeaLinkingCollectionsNavigationItemCursorCollectionOrder {
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum IdeaOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type IdeaRecommendedGrantsCollection = {
  __typename: 'IdeaRecommendedGrantsCollection';
  items: Array<Maybe<Grant>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum IdeaRecommendedGrantsCollectionOrder {
  AmountAsc = 'amount_ASC',
  AmountDesc = 'amount_DESC',
  AreaOfFocusAsc = 'areaOfFocus_ASC',
  AreaOfFocusDesc = 'areaOfFocus_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  DurationInMonthsAsc = 'durationInMonths_ASC',
  DurationInMonthsDesc = 'durationInMonths_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ProjectTitleAsc = 'projectTitle_ASC',
  ProjectTitleDesc = 'projectTitle_DESC',
  ReferenceIdAsc = 'referenceId_ASC',
  ReferenceIdDesc = 'referenceId_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type IdeaRecommendedGrantsCursorCollection = {
  __typename: 'IdeaRecommendedGrantsCursorCollection';
  items: Array<Maybe<Grant>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum IdeaRecommendedGrantsCursorCollectionOrder {
  AmountAsc = 'amount_ASC',
  AmountDesc = 'amount_DESC',
  AreaOfFocusAsc = 'areaOfFocus_ASC',
  AreaOfFocusDesc = 'areaOfFocus_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  DurationInMonthsAsc = 'durationInMonths_ASC',
  DurationInMonthsDesc = 'durationInMonths_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ProjectTitleAsc = 'projectTitle_ASC',
  ProjectTitleDesc = 'projectTitle_DESC',
  ReferenceIdAsc = 'referenceId_ASC',
  ReferenceIdDesc = 'referenceId_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ImageFormat {
  /** AVIF image format. */
  Avif = 'AVIF',
  /** JPG image format. */
  Jpg = 'JPG',
  /**
   * Progressive JPG format stores multiple passes of an image in progressively higher detail.
   *         When a progressive image is loading, the viewer will first see a lower quality pixelated version which
   *         will gradually improve in detail, until the image is fully downloaded. This is to display an image as
   *         early as possible to make the layout look as designed.
   */
  JpgProgressive = 'JPG_PROGRESSIVE',
  /** PNG image format */
  Png = 'PNG',
  /**
   * 8-bit PNG images support up to 256 colors and weigh less than the standard 24-bit PNG equivalent.
   *         The 8-bit PNG format is mostly used for simple images, such as icons or logos.
   */
  Png8 = 'PNG8',
  /** WebP image format. */
  Webp = 'WEBP'
}

export enum ImageResizeFocus {
  /** Focus the resizing on the bottom. */
  Bottom = 'BOTTOM',
  /** Focus the resizing on the bottom left. */
  BottomLeft = 'BOTTOM_LEFT',
  /** Focus the resizing on the bottom right. */
  BottomRight = 'BOTTOM_RIGHT',
  /** Focus the resizing on the center. */
  Center = 'CENTER',
  /** Focus the resizing on the largest face. */
  Face = 'FACE',
  /** Focus the resizing on the area containing all the faces. */
  Faces = 'FACES',
  /** Focus the resizing on the left. */
  Left = 'LEFT',
  /** Focus the resizing on the right. */
  Right = 'RIGHT',
  /** Focus the resizing on the top. */
  Top = 'TOP',
  /** Focus the resizing on the top left. */
  TopLeft = 'TOP_LEFT',
  /** Focus the resizing on the top right. */
  TopRight = 'TOP_RIGHT'
}

export enum ImageResizeStrategy {
  /** Crops a part of the original image to fit into the specified dimensions. */
  Crop = 'CROP',
  /** Resizes the image to the specified dimensions, cropping the image if needed. */
  Fill = 'FILL',
  /** Resizes the image to fit into the specified dimensions. */
  Fit = 'FIT',
  /**
   * Resizes the image to the specified dimensions, padding the image if needed.
   *         Uses desired background color as padding color.
   */
  Pad = 'PAD',
  /** Resizes the image to the specified dimensions, changing the original aspect ratio if needed. */
  Scale = 'SCALE',
  /** Creates a thumbnail from the image. */
  Thumb = 'THUMB'
}

export type ImageTransformOptions = {
  /**
   * Desired background color, used with corner radius or `PAD` resize strategy.
   *         Defaults to transparent (for `PNG`, `PNG8` and `WEBP`) or white (for `JPG` and `JPG_PROGRESSIVE`).
   */
  backgroundColor: InputMaybe<Scalars['HexColor']['input']>;
  /**
   * Desired corner radius in pixels.
   *         Results in an image with rounded corners (pass `-1` for a full circle/ellipse).
   *         Defaults to `0`. Uses desired background color as padding color,
   *         unless the format is `JPG` or `JPG_PROGRESSIVE` and resize strategy is `PAD`, then defaults to white.
   */
  cornerRadius: InputMaybe<Scalars['Int']['input']>;
  /** Desired image format. Defaults to the original image format. */
  format: InputMaybe<ImageFormat>;
  /** Desired height in pixels. Defaults to the original image height. */
  height: InputMaybe<Scalars['Dimension']['input']>;
  /**
   * Desired quality of the image in percents.
   *         Used for `PNG8`, `JPG`, `JPG_PROGRESSIVE` and `WEBP` formats.
   */
  quality: InputMaybe<Scalars['Quality']['input']>;
  /** Desired resize focus area. Defaults to `CENTER`. */
  resizeFocus: InputMaybe<ImageResizeFocus>;
  /** Desired resize strategy. Defaults to `FIT`. */
  resizeStrategy: InputMaybe<ImageResizeStrategy>;
  /** Desired width in pixels. Defaults to the original image width. */
  width: InputMaybe<Scalars['Dimension']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/initiativeQuoteCallOut) */
export type InitiativeQuoteCallOut = Entry & _Node & {
  __typename: 'InitiativeQuoteCallOut';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  initiativeCtaText: Maybe<Scalars['String']['output']>;
  initiativeHeading: Maybe<Scalars['String']['output']>;
  initiativeText: Maybe<Scalars['String']['output']>;
  initiativeTitle: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<InitiativeQuoteCallOutLinkingCollections>;
  quote: Maybe<Quote>;
  relatedGrantsCollection: Maybe<InitiativeQuoteCallOutRelatedGrantsCollection>;
  relatedGrantsCursorCollection: Maybe<InitiativeQuoteCallOutRelatedGrantsCursorCollection>;
  searchQuery: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/initiativeQuoteCallOut) */
export type InitiativeQuoteCallOutInitiativeCtaTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/initiativeQuoteCallOut) */
export type InitiativeQuoteCallOutInitiativeHeadingArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/initiativeQuoteCallOut) */
export type InitiativeQuoteCallOutInitiativeTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/initiativeQuoteCallOut) */
export type InitiativeQuoteCallOutInitiativeTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/initiativeQuoteCallOut) */
export type InitiativeQuoteCallOutLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/initiativeQuoteCallOut) */
export type InitiativeQuoteCallOutQuoteArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<QuoteFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/initiativeQuoteCallOut) */
export type InitiativeQuoteCallOutRelatedGrantsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<InitiativeQuoteCallOutRelatedGrantsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/initiativeQuoteCallOut) */
export type InitiativeQuoteCallOutRelatedGrantsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<InitiativeQuoteCallOutRelatedGrantsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/initiativeQuoteCallOut) */
export type InitiativeQuoteCallOutSearchQueryArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/initiativeQuoteCallOut) */
export type InitiativeQuoteCallOutTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type InitiativeQuoteCallOutCollection = {
  __typename: 'InitiativeQuoteCallOutCollection';
  items: Array<Maybe<InitiativeQuoteCallOut>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type InitiativeQuoteCallOutCursorCollection = {
  __typename: 'InitiativeQuoteCallOutCursorCollection';
  items: Array<Maybe<InitiativeQuoteCallOut>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type InitiativeQuoteCallOutFilter = {
  AND: InputMaybe<Array<InputMaybe<InitiativeQuoteCallOutFilter>>>;
  OR: InputMaybe<Array<InputMaybe<InitiativeQuoteCallOutFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  initiativeCtaText: InputMaybe<Scalars['String']['input']>;
  initiativeCtaText_contains: InputMaybe<Scalars['String']['input']>;
  initiativeCtaText_exists: InputMaybe<Scalars['Boolean']['input']>;
  initiativeCtaText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  initiativeCtaText_not: InputMaybe<Scalars['String']['input']>;
  initiativeCtaText_not_contains: InputMaybe<Scalars['String']['input']>;
  initiativeCtaText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  initiativeHeading: InputMaybe<Scalars['String']['input']>;
  initiativeHeading_contains: InputMaybe<Scalars['String']['input']>;
  initiativeHeading_exists: InputMaybe<Scalars['Boolean']['input']>;
  initiativeHeading_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  initiativeHeading_not: InputMaybe<Scalars['String']['input']>;
  initiativeHeading_not_contains: InputMaybe<Scalars['String']['input']>;
  initiativeHeading_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  initiativeText: InputMaybe<Scalars['String']['input']>;
  initiativeText_contains: InputMaybe<Scalars['String']['input']>;
  initiativeText_exists: InputMaybe<Scalars['Boolean']['input']>;
  initiativeText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  initiativeText_not: InputMaybe<Scalars['String']['input']>;
  initiativeText_not_contains: InputMaybe<Scalars['String']['input']>;
  initiativeText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  initiativeTitle: InputMaybe<Scalars['String']['input']>;
  initiativeTitle_contains: InputMaybe<Scalars['String']['input']>;
  initiativeTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  initiativeTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  initiativeTitle_not: InputMaybe<Scalars['String']['input']>;
  initiativeTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  initiativeTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quote: InputMaybe<CfQuoteNestedFilter>;
  quote_exists: InputMaybe<Scalars['Boolean']['input']>;
  relatedGrants: InputMaybe<CfGrantNestedFilter>;
  relatedGrantsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  searchQuery: InputMaybe<Scalars['String']['input']>;
  searchQuery_contains: InputMaybe<Scalars['String']['input']>;
  searchQuery_exists: InputMaybe<Scalars['Boolean']['input']>;
  searchQuery_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchQuery_not: InputMaybe<Scalars['String']['input']>;
  searchQuery_not_contains: InputMaybe<Scalars['String']['input']>;
  searchQuery_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type InitiativeQuoteCallOutLinkingCollections = {
  __typename: 'InitiativeQuoteCallOutLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  ideaCollection: Maybe<IdeaCollection>;
  ideaCursorCollection: Maybe<IdeaCursorCollection>;
};


export type InitiativeQuoteCallOutLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type InitiativeQuoteCallOutLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type InitiativeQuoteCallOutLinkingCollectionsIdeaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<InitiativeQuoteCallOutLinkingCollectionsIdeaCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type InitiativeQuoteCallOutLinkingCollectionsIdeaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<InitiativeQuoteCallOutLinkingCollectionsIdeaCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum InitiativeQuoteCallOutLinkingCollectionsIdeaCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum InitiativeQuoteCallOutLinkingCollectionsIdeaCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum InitiativeQuoteCallOutOrder {
  InitiativeCtaTextAsc = 'initiativeCtaText_ASC',
  InitiativeCtaTextDesc = 'initiativeCtaText_DESC',
  InitiativeHeadingAsc = 'initiativeHeading_ASC',
  InitiativeHeadingDesc = 'initiativeHeading_DESC',
  InitiativeTextAsc = 'initiativeText_ASC',
  InitiativeTextDesc = 'initiativeText_DESC',
  InitiativeTitleAsc = 'initiativeTitle_ASC',
  InitiativeTitleDesc = 'initiativeTitle_DESC',
  SearchQueryAsc = 'searchQuery_ASC',
  SearchQueryDesc = 'searchQuery_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type InitiativeQuoteCallOutRelatedGrantsCollection = {
  __typename: 'InitiativeQuoteCallOutRelatedGrantsCollection';
  items: Array<Maybe<Grant>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum InitiativeQuoteCallOutRelatedGrantsCollectionOrder {
  AmountAsc = 'amount_ASC',
  AmountDesc = 'amount_DESC',
  AreaOfFocusAsc = 'areaOfFocus_ASC',
  AreaOfFocusDesc = 'areaOfFocus_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  DurationInMonthsAsc = 'durationInMonths_ASC',
  DurationInMonthsDesc = 'durationInMonths_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ProjectTitleAsc = 'projectTitle_ASC',
  ProjectTitleDesc = 'projectTitle_DESC',
  ReferenceIdAsc = 'referenceId_ASC',
  ReferenceIdDesc = 'referenceId_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type InitiativeQuoteCallOutRelatedGrantsCursorCollection = {
  __typename: 'InitiativeQuoteCallOutRelatedGrantsCursorCollection';
  items: Array<Maybe<Grant>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum InitiativeQuoteCallOutRelatedGrantsCursorCollectionOrder {
  AmountAsc = 'amount_ASC',
  AmountDesc = 'amount_DESC',
  AreaOfFocusAsc = 'areaOfFocus_ASC',
  AreaOfFocusDesc = 'areaOfFocus_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  DurationInMonthsAsc = 'durationInMonths_ASC',
  DurationInMonthsDesc = 'durationInMonths_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ProjectTitleAsc = 'projectTitle_ASC',
  ProjectTitleDesc = 'projectTitle_DESC',
  ReferenceIdAsc = 'referenceId_ASC',
  ReferenceIdDesc = 'referenceId_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/inlineCards) */
export type InlineCards = Entry & _Node & {
  __typename: 'InlineCards';
  _id: Scalars['ID']['output'];
  cardsCollection: Maybe<InlineCardsCardsCollection>;
  cardsCursorCollection: Maybe<InlineCardsCardsCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<InlineCardsLinkingCollections>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/inlineCards) */
export type InlineCardsCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<InlineCardsCardsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/inlineCards) */
export type InlineCardsCardsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<InlineCardsCardsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/inlineCards) */
export type InlineCardsLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/inlineCards) */
export type InlineCardsTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type InlineCardsCardsCollection = {
  __typename: 'InlineCardsCardsCollection';
  items: Array<Maybe<InlineCardsCardsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type InlineCardsCardsCursorCollection = {
  __typename: 'InlineCardsCardsCursorCollection';
  items: Array<Maybe<InlineCardsCardsItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type InlineCardsCardsFilter = {
  AND: InputMaybe<Array<InputMaybe<InlineCardsCardsFilter>>>;
  OR: InputMaybe<Array<InputMaybe<InlineCardsCardsFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
};

export type InlineCardsCardsItem = Article | EmphasizedArticle | ExternalEvent | Feature | GrantActivityArticle | GrantmakingAreaDetailsPage | Idea;

export type InlineCardsCollection = {
  __typename: 'InlineCardsCollection';
  items: Array<Maybe<InlineCards>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type InlineCardsCursorCollection = {
  __typename: 'InlineCardsCursorCollection';
  items: Array<Maybe<InlineCards>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type InlineCardsFilter = {
  AND: InputMaybe<Array<InputMaybe<InlineCardsFilter>>>;
  OR: InputMaybe<Array<InputMaybe<InlineCardsFilter>>>;
  cards: InputMaybe<CfcardsMultiTypeNestedFilter>;
  cardsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type InlineCardsLinkingCollections = {
  __typename: 'InlineCardsLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type InlineCardsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type InlineCardsLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum InlineCardsOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/inlineImages) */
export type InlineImages = Entry & _Node & {
  __typename: 'InlineImages';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  imagesCollection: Maybe<AssetCollection>;
  imagesCursorCollection: Maybe<AssetCursorCollection>;
  invert: Maybe<Scalars['Boolean']['output']>;
  linkedFrom: Maybe<InlineImagesLinkingCollections>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/inlineImages) */
export type InlineImagesImagesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/inlineImages) */
export type InlineImagesImagesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/inlineImages) */
export type InlineImagesInvertArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/inlineImages) */
export type InlineImagesLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/inlineImages) */
export type InlineImagesTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type InlineImagesCollection = {
  __typename: 'InlineImagesCollection';
  items: Array<Maybe<InlineImages>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type InlineImagesCursorCollection = {
  __typename: 'InlineImagesCursorCollection';
  items: Array<Maybe<InlineImages>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type InlineImagesFilter = {
  AND: InputMaybe<Array<InputMaybe<InlineImagesFilter>>>;
  OR: InputMaybe<Array<InputMaybe<InlineImagesFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  imagesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  invert: InputMaybe<Scalars['Boolean']['input']>;
  invert_exists: InputMaybe<Scalars['Boolean']['input']>;
  invert_not: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type InlineImagesLinkingCollections = {
  __typename: 'InlineImagesLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type InlineImagesLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type InlineImagesLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum InlineImagesOrder {
  InvertAsc = 'invert_ASC',
  InvertDesc = 'invert_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mainNavigation) */
export type MainNavigation = Entry & _Node & {
  __typename: 'MainNavigation';
  _id: Scalars['ID']['output'];
  babyMissionStatement: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  ideasCollection: Maybe<MainNavigationIdeasCollection>;
  ideasCursorCollection: Maybe<MainNavigationIdeasCursorCollection>;
  linkedFrom: Maybe<MainNavigationLinkingCollections>;
  pagesCollection: Maybe<MainNavigationPagesCollection>;
  pagesCursorCollection: Maybe<MainNavigationPagesCursorCollection>;
  resourcesCollection: Maybe<MainNavigationResourcesCollection>;
  resourcesCursorCollection: Maybe<MainNavigationResourcesCursorCollection>;
  slug: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mainNavigation) */
export type MainNavigationBabyMissionStatementArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mainNavigation) */
export type MainNavigationIdeasCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<MainNavigationIdeasCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<IdeaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mainNavigation) */
export type MainNavigationIdeasCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<MainNavigationIdeasCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<IdeaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mainNavigation) */
export type MainNavigationLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mainNavigation) */
export type MainNavigationPagesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<MainNavigationPagesFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mainNavigation) */
export type MainNavigationPagesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<MainNavigationPagesFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mainNavigation) */
export type MainNavigationResourcesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<MainNavigationResourcesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<NavigationItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mainNavigation) */
export type MainNavigationResourcesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<MainNavigationResourcesCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<NavigationItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mainNavigation) */
export type MainNavigationSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mainNavigation) */
export type MainNavigationTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type MainNavigationCollection = {
  __typename: 'MainNavigationCollection';
  items: Array<Maybe<MainNavigation>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MainNavigationCursorCollection = {
  __typename: 'MainNavigationCursorCollection';
  items: Array<Maybe<MainNavigation>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type MainNavigationFilter = {
  AND: InputMaybe<Array<InputMaybe<MainNavigationFilter>>>;
  OR: InputMaybe<Array<InputMaybe<MainNavigationFilter>>>;
  babyMissionStatement: InputMaybe<Scalars['String']['input']>;
  babyMissionStatement_contains: InputMaybe<Scalars['String']['input']>;
  babyMissionStatement_exists: InputMaybe<Scalars['Boolean']['input']>;
  babyMissionStatement_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  babyMissionStatement_not: InputMaybe<Scalars['String']['input']>;
  babyMissionStatement_not_contains: InputMaybe<Scalars['String']['input']>;
  babyMissionStatement_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  ideas: InputMaybe<CfIdeaNestedFilter>;
  ideasCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  pages: InputMaybe<CfpagesMultiTypeNestedFilter>;
  pagesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  resources: InputMaybe<CfNavigationItemNestedFilter>;
  resourcesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MainNavigationIdeasCollection = {
  __typename: 'MainNavigationIdeasCollection';
  items: Array<Maybe<Idea>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum MainNavigationIdeasCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type MainNavigationIdeasCursorCollection = {
  __typename: 'MainNavigationIdeasCursorCollection';
  items: Array<Maybe<Idea>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum MainNavigationIdeasCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type MainNavigationLinkingCollections = {
  __typename: 'MainNavigationLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type MainNavigationLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type MainNavigationLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum MainNavigationOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type MainNavigationPagesCollection = {
  __typename: 'MainNavigationPagesCollection';
  items: Array<Maybe<MainNavigationPagesItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MainNavigationPagesCursorCollection = {
  __typename: 'MainNavigationPagesCursorCollection';
  items: Array<Maybe<MainNavigationPagesItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type MainNavigationPagesFilter = {
  AND: InputMaybe<Array<InputMaybe<MainNavigationPagesFilter>>>;
  OR: InputMaybe<Array<InputMaybe<MainNavigationPagesFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  navigationImagePortrait_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MainNavigationPagesItem = EventsPage | FinancialsPage | GrantmakingAreasPage | HistoryPage | MissionPage | NewsPage | PeoplePage;

export type MainNavigationResourcesCollection = {
  __typename: 'MainNavigationResourcesCollection';
  items: Array<Maybe<NavigationItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum MainNavigationResourcesCollectionOrder {
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type MainNavigationResourcesCursorCollection = {
  __typename: 'MainNavigationResourcesCursorCollection';
  items: Array<Maybe<NavigationItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum MainNavigationResourcesCursorCollectionOrder {
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/metadata) */
export type Metadata = Entry & _Node & {
  __typename: 'Metadata';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  description: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<MetadataLinkingCollections>;
  ogDescription: Maybe<Scalars['String']['output']>;
  ogImage: Maybe<Asset>;
  ogTitle: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/metadata) */
export type MetadataDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/metadata) */
export type MetadataLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/metadata) */
export type MetadataOgDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/metadata) */
export type MetadataOgImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/metadata) */
export type MetadataOgTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/metadata) */
export type MetadataTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetadataCollection = {
  __typename: 'MetadataCollection';
  items: Array<Maybe<Metadata>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MetadataCursorCollection = {
  __typename: 'MetadataCursorCollection';
  items: Array<Maybe<Metadata>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type MetadataFilter = {
  AND: InputMaybe<Array<InputMaybe<MetadataFilter>>>;
  OR: InputMaybe<Array<InputMaybe<MetadataFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogDescription: InputMaybe<Scalars['String']['input']>;
  ogDescription_contains: InputMaybe<Scalars['String']['input']>;
  ogDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  ogDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogDescription_not: InputMaybe<Scalars['String']['input']>;
  ogDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  ogDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  ogTitle: InputMaybe<Scalars['String']['input']>;
  ogTitle_contains: InputMaybe<Scalars['String']['input']>;
  ogTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  ogTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogTitle_not: InputMaybe<Scalars['String']['input']>;
  ogTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  ogTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MetadataLinkingCollections = {
  __typename: 'MetadataLinkingCollections';
  articleCollection: Maybe<ArticleCollection>;
  articleCursorCollection: Maybe<ArticleCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  grantActivityArticleCollection: Maybe<GrantActivityArticleCollection>;
  grantActivityArticleCursorCollection: Maybe<GrantActivityArticleCursorCollection>;
};


export type MetadataLinkingCollectionsArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<MetadataLinkingCollectionsArticleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type MetadataLinkingCollectionsArticleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<MetadataLinkingCollectionsArticleCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type MetadataLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type MetadataLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type MetadataLinkingCollectionsGrantActivityArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<MetadataLinkingCollectionsGrantActivityArticleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type MetadataLinkingCollectionsGrantActivityArticleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<MetadataLinkingCollectionsGrantActivityArticleCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum MetadataLinkingCollectionsArticleCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  ExternalNewsUrlAsc = 'externalNewsUrl_ASC',
  ExternalNewsUrlDesc = 'externalNewsUrl_DESC',
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  PasswordAsc = 'password_ASC',
  PasswordDesc = 'password_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum MetadataLinkingCollectionsArticleCursorCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  ExternalNewsUrlAsc = 'externalNewsUrl_ASC',
  ExternalNewsUrlDesc = 'externalNewsUrl_DESC',
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  PasswordAsc = 'password_ASC',
  PasswordDesc = 'password_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum MetadataLinkingCollectionsGrantActivityArticleCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  GranteeCityOverrideAsc = 'granteeCityOverride_ASC',
  GranteeCityOverrideDesc = 'granteeCityOverride_DESC',
  GranteeCountryOverrideAsc = 'granteeCountryOverride_ASC',
  GranteeCountryOverrideDesc = 'granteeCountryOverride_DESC',
  GranteeNameOverrideAsc = 'granteeNameOverride_ASC',
  GranteeNameOverrideDesc = 'granteeNameOverride_DESC',
  GranteeStateOverrideAsc = 'granteeStateOverride_ASC',
  GranteeStateOverrideDesc = 'granteeStateOverride_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum MetadataLinkingCollectionsGrantActivityArticleCursorCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  GranteeCityOverrideAsc = 'granteeCityOverride_ASC',
  GranteeCityOverrideDesc = 'granteeCityOverride_DESC',
  GranteeCountryOverrideAsc = 'granteeCountryOverride_ASC',
  GranteeCountryOverrideDesc = 'granteeCountryOverride_DESC',
  GranteeNameOverrideAsc = 'granteeNameOverride_ASC',
  GranteeNameOverrideDesc = 'granteeNameOverride_DESC',
  GranteeStateOverrideAsc = 'granteeStateOverride_ASC',
  GranteeStateOverrideDesc = 'granteeStateOverride_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum MetadataOrder {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  OgDescriptionAsc = 'ogDescription_ASC',
  OgDescriptionDesc = 'ogDescription_DESC',
  OgTitleAsc = 'ogTitle_ASC',
  OgTitleDesc = 'ogTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/missionPage) */
export type MissionPage = Entry & _Node & {
  __typename: 'MissionPage';
  _id: Scalars['ID']['output'];
  atGlanceCardsCollection: Maybe<MissionPageAtGlanceCardsCollection>;
  atGlanceCardsCursorCollection: Maybe<MissionPageAtGlanceCardsCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  description: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<MissionPageLinkingCollections>;
  navigationImagePortrait: Maybe<Asset>;
  quote: Maybe<Quote>;
  slug: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/missionPage) */
export type MissionPageAtGlanceCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<MissionPageAtGlanceCardsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<AtGlanceCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/missionPage) */
export type MissionPageAtGlanceCardsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<MissionPageAtGlanceCardsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<AtGlanceCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/missionPage) */
export type MissionPageDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/missionPage) */
export type MissionPageLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/missionPage) */
export type MissionPageNavigationImagePortraitArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/missionPage) */
export type MissionPageQuoteArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<QuoteFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/missionPage) */
export type MissionPageSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/missionPage) */
export type MissionPageTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type MissionPageAtGlanceCardsCollection = {
  __typename: 'MissionPageAtGlanceCardsCollection';
  items: Array<Maybe<AtGlanceCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum MissionPageAtGlanceCardsCollectionOrder {
  BodyTextAsc = 'bodyText_ASC',
  BodyTextDesc = 'bodyText_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export type MissionPageAtGlanceCardsCursorCollection = {
  __typename: 'MissionPageAtGlanceCardsCursorCollection';
  items: Array<Maybe<AtGlanceCard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum MissionPageAtGlanceCardsCursorCollectionOrder {
  BodyTextAsc = 'bodyText_ASC',
  BodyTextDesc = 'bodyText_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export type MissionPageCollection = {
  __typename: 'MissionPageCollection';
  items: Array<Maybe<MissionPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MissionPageCursorCollection = {
  __typename: 'MissionPageCursorCollection';
  items: Array<Maybe<MissionPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type MissionPageFilter = {
  AND: InputMaybe<Array<InputMaybe<MissionPageFilter>>>;
  OR: InputMaybe<Array<InputMaybe<MissionPageFilter>>>;
  atGlanceCards: InputMaybe<CfAtGlanceCardNestedFilter>;
  atGlanceCardsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navigationImagePortrait_exists: InputMaybe<Scalars['Boolean']['input']>;
  quote: InputMaybe<CfQuoteNestedFilter>;
  quote_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MissionPageLinkingCollections = {
  __typename: 'MissionPageLinkingCollections';
  connectWithLinkCollection: Maybe<ConnectWithLinkCollection>;
  connectWithLinkCursorCollection: Maybe<ConnectWithLinkCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  mainNavigationCollection: Maybe<MainNavigationCollection>;
  mainNavigationCursorCollection: Maybe<MainNavigationCursorCollection>;
};


export type MissionPageLinkingCollectionsConnectWithLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<MissionPageLinkingCollectionsConnectWithLinkCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type MissionPageLinkingCollectionsConnectWithLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<MissionPageLinkingCollectionsConnectWithLinkCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type MissionPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type MissionPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type MissionPageLinkingCollectionsMainNavigationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<MissionPageLinkingCollectionsMainNavigationCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type MissionPageLinkingCollectionsMainNavigationCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<MissionPageLinkingCollectionsMainNavigationCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum MissionPageLinkingCollectionsConnectWithLinkCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum MissionPageLinkingCollectionsConnectWithLinkCursorCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum MissionPageLinkingCollectionsMainNavigationCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum MissionPageLinkingCollectionsMainNavigationCursorCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum MissionPageOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mmuf) */
export type Mmuf = Entry & _Node & {
  __typename: 'Mmuf';
  _id: Scalars['ID']['output'];
  articleText: Maybe<Scalars['String']['output']>;
  articleTitle: Maybe<Scalars['String']['output']>;
  atGlanceCardsCollection: Maybe<MmufAtGlanceCardsCollection>;
  atGlanceCardsCursorCollection: Maybe<MmufAtGlanceCardsCursorCollection>;
  atGlanceTitle: Maybe<Scalars['String']['output']>;
  contactEmail: Maybe<Scalars['String']['output']>;
  contactMessage: Maybe<Scalars['String']['output']>;
  contactTitle: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  faqs: Maybe<FaqsModule>;
  fellowStoriesCtaLabel: Maybe<Scalars['String']['output']>;
  fellowStoriesMessage: Maybe<Scalars['String']['output']>;
  graduateInitiativesLink: Maybe<ConnectWithLink>;
  graduateInitiativesText: Maybe<Scalars['String']['output']>;
  graduateInitiativesTitle: Maybe<Scalars['String']['output']>;
  heroImage: Maybe<Asset>;
  historyLink: Maybe<ConnectWithLink>;
  inFocusContentCollection: Maybe<MmufInFocusContentCollection>;
  inFocusContentCursorCollection: Maybe<MmufInFocusContentCursorCollection>;
  inFocusHeadline: Maybe<Scalars['String']['output']>;
  inTheNewsCollection: Maybe<MmufInTheNewsCollection>;
  inTheNewsCursorCollection: Maybe<MmufInTheNewsCursorCollection>;
  introDescription: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<MmufLinkingCollections>;
  newsletter: Maybe<NewsletterCard>;
  pullQuote: Maybe<Quote>;
  quickLinks: Maybe<ConnectWith>;
  slug: Maybe<Scalars['String']['output']>;
  spotlight: Maybe<MmufSpotlight>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mmuf) */
export type MmufArticleTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mmuf) */
export type MmufArticleTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mmuf) */
export type MmufAtGlanceCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<MmufAtGlanceCardsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<AtGlanceCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mmuf) */
export type MmufAtGlanceCardsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<MmufAtGlanceCardsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<AtGlanceCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mmuf) */
export type MmufAtGlanceTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mmuf) */
export type MmufContactEmailArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mmuf) */
export type MmufContactMessageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mmuf) */
export type MmufContactTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mmuf) */
export type MmufFaqsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<FaqsModuleFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mmuf) */
export type MmufFellowStoriesCtaLabelArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mmuf) */
export type MmufFellowStoriesMessageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mmuf) */
export type MmufGraduateInitiativesLinkArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ConnectWithLinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mmuf) */
export type MmufGraduateInitiativesTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mmuf) */
export type MmufGraduateInitiativesTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mmuf) */
export type MmufHeroImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mmuf) */
export type MmufHistoryLinkArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ConnectWithLinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mmuf) */
export type MmufInFocusContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<MmufInFocusContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mmuf) */
export type MmufInFocusContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<MmufInFocusContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mmuf) */
export type MmufInFocusHeadlineArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mmuf) */
export type MmufInTheNewsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<MmufInTheNewsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mmuf) */
export type MmufInTheNewsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<MmufInTheNewsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mmuf) */
export type MmufIntroDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mmuf) */
export type MmufLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mmuf) */
export type MmufNewsletterArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<NewsletterCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mmuf) */
export type MmufPullQuoteArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<QuoteFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mmuf) */
export type MmufQuickLinksArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ConnectWithFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mmuf) */
export type MmufSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mmuf) */
export type MmufSpotlightArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/mmuf) */
export type MmufTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type MmufAtGlanceCardsCollection = {
  __typename: 'MmufAtGlanceCardsCollection';
  items: Array<Maybe<AtGlanceCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum MmufAtGlanceCardsCollectionOrder {
  BodyTextAsc = 'bodyText_ASC',
  BodyTextDesc = 'bodyText_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export type MmufAtGlanceCardsCursorCollection = {
  __typename: 'MmufAtGlanceCardsCursorCollection';
  items: Array<Maybe<AtGlanceCard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum MmufAtGlanceCardsCursorCollectionOrder {
  BodyTextAsc = 'bodyText_ASC',
  BodyTextDesc = 'bodyText_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export type MmufCollection = {
  __typename: 'MmufCollection';
  items: Array<Maybe<Mmuf>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MmufCursorCollection = {
  __typename: 'MmufCursorCollection';
  items: Array<Maybe<Mmuf>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type MmufFilter = {
  AND: InputMaybe<Array<InputMaybe<MmufFilter>>>;
  OR: InputMaybe<Array<InputMaybe<MmufFilter>>>;
  articleText: InputMaybe<Scalars['String']['input']>;
  articleText_contains: InputMaybe<Scalars['String']['input']>;
  articleText_exists: InputMaybe<Scalars['Boolean']['input']>;
  articleText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  articleText_not: InputMaybe<Scalars['String']['input']>;
  articleText_not_contains: InputMaybe<Scalars['String']['input']>;
  articleText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  articleTitle: InputMaybe<Scalars['String']['input']>;
  articleTitle_contains: InputMaybe<Scalars['String']['input']>;
  articleTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  articleTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  articleTitle_not: InputMaybe<Scalars['String']['input']>;
  articleTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  articleTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  atGlanceCards: InputMaybe<CfAtGlanceCardNestedFilter>;
  atGlanceCardsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  atGlanceTitle: InputMaybe<Scalars['String']['input']>;
  atGlanceTitle_contains: InputMaybe<Scalars['String']['input']>;
  atGlanceTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  atGlanceTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  atGlanceTitle_not: InputMaybe<Scalars['String']['input']>;
  atGlanceTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  atGlanceTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactEmail: InputMaybe<Scalars['String']['input']>;
  contactEmail_contains: InputMaybe<Scalars['String']['input']>;
  contactEmail_exists: InputMaybe<Scalars['Boolean']['input']>;
  contactEmail_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactEmail_not: InputMaybe<Scalars['String']['input']>;
  contactEmail_not_contains: InputMaybe<Scalars['String']['input']>;
  contactEmail_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactMessage: InputMaybe<Scalars['String']['input']>;
  contactMessage_contains: InputMaybe<Scalars['String']['input']>;
  contactMessage_exists: InputMaybe<Scalars['Boolean']['input']>;
  contactMessage_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactMessage_not: InputMaybe<Scalars['String']['input']>;
  contactMessage_not_contains: InputMaybe<Scalars['String']['input']>;
  contactMessage_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactTitle: InputMaybe<Scalars['String']['input']>;
  contactTitle_contains: InputMaybe<Scalars['String']['input']>;
  contactTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  contactTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactTitle_not: InputMaybe<Scalars['String']['input']>;
  contactTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  contactTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  faqs: InputMaybe<CfFaqsModuleNestedFilter>;
  faqs_exists: InputMaybe<Scalars['Boolean']['input']>;
  fellowStoriesCtaLabel: InputMaybe<Scalars['String']['input']>;
  fellowStoriesCtaLabel_contains: InputMaybe<Scalars['String']['input']>;
  fellowStoriesCtaLabel_exists: InputMaybe<Scalars['Boolean']['input']>;
  fellowStoriesCtaLabel_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fellowStoriesCtaLabel_not: InputMaybe<Scalars['String']['input']>;
  fellowStoriesCtaLabel_not_contains: InputMaybe<Scalars['String']['input']>;
  fellowStoriesCtaLabel_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fellowStoriesMessage: InputMaybe<Scalars['String']['input']>;
  fellowStoriesMessage_contains: InputMaybe<Scalars['String']['input']>;
  fellowStoriesMessage_exists: InputMaybe<Scalars['Boolean']['input']>;
  fellowStoriesMessage_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fellowStoriesMessage_not: InputMaybe<Scalars['String']['input']>;
  fellowStoriesMessage_not_contains: InputMaybe<Scalars['String']['input']>;
  fellowStoriesMessage_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  graduateInitiativesLink: InputMaybe<CfConnectWithLinkNestedFilter>;
  graduateInitiativesLink_exists: InputMaybe<Scalars['Boolean']['input']>;
  graduateInitiativesText: InputMaybe<Scalars['String']['input']>;
  graduateInitiativesText_contains: InputMaybe<Scalars['String']['input']>;
  graduateInitiativesText_exists: InputMaybe<Scalars['Boolean']['input']>;
  graduateInitiativesText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  graduateInitiativesText_not: InputMaybe<Scalars['String']['input']>;
  graduateInitiativesText_not_contains: InputMaybe<Scalars['String']['input']>;
  graduateInitiativesText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  graduateInitiativesTitle: InputMaybe<Scalars['String']['input']>;
  graduateInitiativesTitle_contains: InputMaybe<Scalars['String']['input']>;
  graduateInitiativesTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  graduateInitiativesTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  graduateInitiativesTitle_not: InputMaybe<Scalars['String']['input']>;
  graduateInitiativesTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  graduateInitiativesTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heroImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  historyLink: InputMaybe<CfConnectWithLinkNestedFilter>;
  historyLink_exists: InputMaybe<Scalars['Boolean']['input']>;
  inFocusContent: InputMaybe<CfinFocusContentMultiTypeNestedFilter>;
  inFocusContentCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  inFocusHeadline: InputMaybe<Scalars['String']['input']>;
  inFocusHeadline_contains: InputMaybe<Scalars['String']['input']>;
  inFocusHeadline_exists: InputMaybe<Scalars['Boolean']['input']>;
  inFocusHeadline_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inFocusHeadline_not: InputMaybe<Scalars['String']['input']>;
  inFocusHeadline_not_contains: InputMaybe<Scalars['String']['input']>;
  inFocusHeadline_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inTheNews: InputMaybe<CfinTheNewsMultiTypeNestedFilter>;
  inTheNewsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  introDescription: InputMaybe<Scalars['String']['input']>;
  introDescription_contains: InputMaybe<Scalars['String']['input']>;
  introDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  introDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  introDescription_not: InputMaybe<Scalars['String']['input']>;
  introDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  introDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  newsletter: InputMaybe<CfNewsletterCardNestedFilter>;
  newsletter_exists: InputMaybe<Scalars['Boolean']['input']>;
  pullQuote: InputMaybe<CfQuoteNestedFilter>;
  pullQuote_exists: InputMaybe<Scalars['Boolean']['input']>;
  quickLinks: InputMaybe<CfConnectWithNestedFilter>;
  quickLinks_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  spotlight_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MmufInFocusContentCollection = {
  __typename: 'MmufInFocusContentCollection';
  items: Array<Maybe<MmufInFocusContentItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MmufInFocusContentCursorCollection = {
  __typename: 'MmufInFocusContentCursorCollection';
  items: Array<Maybe<MmufInFocusContentItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type MmufInFocusContentFilter = {
  AND: InputMaybe<Array<InputMaybe<MmufInFocusContentFilter>>>;
  OR: InputMaybe<Array<InputMaybe<MmufInFocusContentFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  date: InputMaybe<Scalars['DateTime']['input']>;
  date_exists: InputMaybe<Scalars['Boolean']['input']>;
  date_gt: InputMaybe<Scalars['DateTime']['input']>;
  date_gte: InputMaybe<Scalars['DateTime']['input']>;
  date_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_lt: InputMaybe<Scalars['DateTime']['input']>;
  date_lte: InputMaybe<Scalars['DateTime']['input']>;
  date_not: InputMaybe<Scalars['DateTime']['input']>;
  date_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type MmufInFocusContentItem = Article | ExternalEvent;

export type MmufInTheNewsCollection = {
  __typename: 'MmufInTheNewsCollection';
  items: Array<Maybe<MmufInTheNewsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MmufInTheNewsCursorCollection = {
  __typename: 'MmufInTheNewsCursorCollection';
  items: Array<Maybe<MmufInTheNewsItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type MmufInTheNewsFilter = {
  AND: InputMaybe<Array<InputMaybe<MmufInTheNewsFilter>>>;
  OR: InputMaybe<Array<InputMaybe<MmufInTheNewsFilter>>>;
  audio_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  date: InputMaybe<Scalars['DateTime']['input']>;
  date_exists: InputMaybe<Scalars['Boolean']['input']>;
  date_gt: InputMaybe<Scalars['DateTime']['input']>;
  date_gte: InputMaybe<Scalars['DateTime']['input']>;
  date_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_lt: InputMaybe<Scalars['DateTime']['input']>;
  date_lte: InputMaybe<Scalars['DateTime']['input']>;
  date_not: InputMaybe<Scalars['DateTime']['input']>;
  date_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  person_exists: InputMaybe<Scalars['Boolean']['input']>;
  quickLinks_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type MmufInTheNewsItem = AnnualReport | Article;

export type MmufLinkingCollections = {
  __typename: 'MmufLinkingCollections';
  connectWithLinkCollection: Maybe<ConnectWithLinkCollection>;
  connectWithLinkCursorCollection: Maybe<ConnectWithLinkCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  grantmakingAreaDetailsPageCollection: Maybe<GrantmakingAreaDetailsPageCollection>;
  grantmakingAreaDetailsPageCursorCollection: Maybe<GrantmakingAreaDetailsPageCursorCollection>;
};


export type MmufLinkingCollectionsConnectWithLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<MmufLinkingCollectionsConnectWithLinkCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type MmufLinkingCollectionsConnectWithLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<MmufLinkingCollectionsConnectWithLinkCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type MmufLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type MmufLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type MmufLinkingCollectionsGrantmakingAreaDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<MmufLinkingCollectionsGrantmakingAreaDetailsPageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type MmufLinkingCollectionsGrantmakingAreaDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<MmufLinkingCollectionsGrantmakingAreaDetailsPageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum MmufLinkingCollectionsConnectWithLinkCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum MmufLinkingCollectionsConnectWithLinkCursorCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum MmufLinkingCollectionsGrantmakingAreaDetailsPageCollectionOrder {
  GrantMakingProcessMessageAsc = 'grantMakingProcessMessage_ASC',
  GrantMakingProcessMessageDesc = 'grantMakingProcessMessage_DESC',
  GuidingStrategiesTitleAsc = 'guidingStrategiesTitle_ASC',
  GuidingStrategiesTitleDesc = 'guidingStrategiesTitle_DESC',
  IntroDescriptionAsc = 'introDescription_ASC',
  IntroDescriptionDesc = 'introDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum MmufLinkingCollectionsGrantmakingAreaDetailsPageCursorCollectionOrder {
  GrantMakingProcessMessageAsc = 'grantMakingProcessMessage_ASC',
  GrantMakingProcessMessageDesc = 'grantMakingProcessMessage_DESC',
  GuidingStrategiesTitleAsc = 'guidingStrategiesTitle_ASC',
  GuidingStrategiesTitleDesc = 'guidingStrategiesTitle_DESC',
  IntroDescriptionAsc = 'introDescription_ASC',
  IntroDescriptionDesc = 'introDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum MmufOrder {
  ArticleTitleAsc = 'articleTitle_ASC',
  ArticleTitleDesc = 'articleTitle_DESC',
  AtGlanceTitleAsc = 'atGlanceTitle_ASC',
  AtGlanceTitleDesc = 'atGlanceTitle_DESC',
  ContactEmailAsc = 'contactEmail_ASC',
  ContactEmailDesc = 'contactEmail_DESC',
  ContactMessageAsc = 'contactMessage_ASC',
  ContactMessageDesc = 'contactMessage_DESC',
  ContactTitleAsc = 'contactTitle_ASC',
  ContactTitleDesc = 'contactTitle_DESC',
  FellowStoriesCtaLabelAsc = 'fellowStoriesCtaLabel_ASC',
  FellowStoriesCtaLabelDesc = 'fellowStoriesCtaLabel_DESC',
  FellowStoriesMessageAsc = 'fellowStoriesMessage_ASC',
  FellowStoriesMessageDesc = 'fellowStoriesMessage_DESC',
  GraduateInitiativesTitleAsc = 'graduateInitiativesTitle_ASC',
  GraduateInitiativesTitleDesc = 'graduateInitiativesTitle_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type MmufSpotlight = SpotlightSlideshow | SpotlightVideo;

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/navigationItem) */
export type NavigationItem = Entry & _Node & {
  __typename: 'NavigationItem';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  image: Maybe<Asset>;
  label: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<NavigationItemLinkingCollections>;
  reference: Maybe<NavigationItemReference>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/navigationItem) */
export type NavigationItemImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/navigationItem) */
export type NavigationItemLabelArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/navigationItem) */
export type NavigationItemLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/navigationItem) */
export type NavigationItemReferenceArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type NavigationItemCollection = {
  __typename: 'NavigationItemCollection';
  items: Array<Maybe<NavigationItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type NavigationItemCursorCollection = {
  __typename: 'NavigationItemCursorCollection';
  items: Array<Maybe<NavigationItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type NavigationItemFilter = {
  AND: InputMaybe<Array<InputMaybe<NavigationItemFilter>>>;
  OR: InputMaybe<Array<InputMaybe<NavigationItemFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  image_exists: InputMaybe<Scalars['Boolean']['input']>;
  label: InputMaybe<Scalars['String']['input']>;
  label_contains: InputMaybe<Scalars['String']['input']>;
  label_exists: InputMaybe<Scalars['Boolean']['input']>;
  label_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not: InputMaybe<Scalars['String']['input']>;
  label_not_contains: InputMaybe<Scalars['String']['input']>;
  label_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reference_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
};

export type NavigationItemLinkingCollections = {
  __typename: 'NavigationItemLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  mainNavigationCollection: Maybe<MainNavigationCollection>;
  mainNavigationCursorCollection: Maybe<MainNavigationCursorCollection>;
};


export type NavigationItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type NavigationItemLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type NavigationItemLinkingCollectionsMainNavigationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<NavigationItemLinkingCollectionsMainNavigationCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type NavigationItemLinkingCollectionsMainNavigationCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<NavigationItemLinkingCollectionsMainNavigationCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum NavigationItemLinkingCollectionsMainNavigationCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum NavigationItemLinkingCollectionsMainNavigationCursorCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum NavigationItemOrder {
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type NavigationItemReference = Article | GrantActivityArticle | GrantDetailsPage | GrantSearchFilters | GrantmakingAreaDetailsPage | GrantmakingAreasPage | Idea | ResourcesCurrentGrantees | ResourcesProspectiveGrantees | StoriesPage;

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/newsPage) */
export type NewsPage = Entry & _Node & {
  __typename: 'NewsPage';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  description: Maybe<Scalars['String']['output']>;
  featuredNews: Maybe<NewsPageFeaturedNews>;
  linkedFrom: Maybe<NewsPageLinkingCollections>;
  navigationImagePortrait: Maybe<Asset>;
  pressRoomCopy: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/newsPage) */
export type NewsPageDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/newsPage) */
export type NewsPageFeaturedNewsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<NewsPageFeaturedNewsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/newsPage) */
export type NewsPageLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/newsPage) */
export type NewsPageNavigationImagePortraitArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/newsPage) */
export type NewsPagePressRoomCopyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/newsPage) */
export type NewsPageSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/newsPage) */
export type NewsPageTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type NewsPageCollection = {
  __typename: 'NewsPageCollection';
  items: Array<Maybe<NewsPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type NewsPageCursorCollection = {
  __typename: 'NewsPageCursorCollection';
  items: Array<Maybe<NewsPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type NewsPageFeaturedNews = AnnualReport | Article;

export type NewsPageFeaturedNewsFilter = {
  AND: InputMaybe<Array<InputMaybe<NewsPageFeaturedNewsFilter>>>;
  OR: InputMaybe<Array<InputMaybe<NewsPageFeaturedNewsFilter>>>;
  audio_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  date: InputMaybe<Scalars['DateTime']['input']>;
  date_exists: InputMaybe<Scalars['Boolean']['input']>;
  date_gt: InputMaybe<Scalars['DateTime']['input']>;
  date_gte: InputMaybe<Scalars['DateTime']['input']>;
  date_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_lt: InputMaybe<Scalars['DateTime']['input']>;
  date_lte: InputMaybe<Scalars['DateTime']['input']>;
  date_not: InputMaybe<Scalars['DateTime']['input']>;
  date_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  person_exists: InputMaybe<Scalars['Boolean']['input']>;
  quickLinks_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type NewsPageFilter = {
  AND: InputMaybe<Array<InputMaybe<NewsPageFilter>>>;
  OR: InputMaybe<Array<InputMaybe<NewsPageFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featuredNews: InputMaybe<CffeaturedNewsMultiTypeNestedFilter>;
  featuredNews_exists: InputMaybe<Scalars['Boolean']['input']>;
  navigationImagePortrait_exists: InputMaybe<Scalars['Boolean']['input']>;
  pressRoomCopy: InputMaybe<Scalars['String']['input']>;
  pressRoomCopy_contains: InputMaybe<Scalars['String']['input']>;
  pressRoomCopy_exists: InputMaybe<Scalars['Boolean']['input']>;
  pressRoomCopy_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pressRoomCopy_not: InputMaybe<Scalars['String']['input']>;
  pressRoomCopy_not_contains: InputMaybe<Scalars['String']['input']>;
  pressRoomCopy_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NewsPageLinkingCollections = {
  __typename: 'NewsPageLinkingCollections';
  connectWithLinkCollection: Maybe<ConnectWithLinkCollection>;
  connectWithLinkCursorCollection: Maybe<ConnectWithLinkCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  mainNavigationCollection: Maybe<MainNavigationCollection>;
  mainNavigationCursorCollection: Maybe<MainNavigationCursorCollection>;
};


export type NewsPageLinkingCollectionsConnectWithLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<NewsPageLinkingCollectionsConnectWithLinkCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type NewsPageLinkingCollectionsConnectWithLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<NewsPageLinkingCollectionsConnectWithLinkCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type NewsPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type NewsPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type NewsPageLinkingCollectionsMainNavigationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<NewsPageLinkingCollectionsMainNavigationCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type NewsPageLinkingCollectionsMainNavigationCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<NewsPageLinkingCollectionsMainNavigationCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum NewsPageLinkingCollectionsConnectWithLinkCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum NewsPageLinkingCollectionsConnectWithLinkCursorCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum NewsPageLinkingCollectionsMainNavigationCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum NewsPageLinkingCollectionsMainNavigationCursorCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum NewsPageOrder {
  PressRoomCopyAsc = 'pressRoomCopy_ASC',
  PressRoomCopyDesc = 'pressRoomCopy_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/newsletterCard) */
export type NewsletterCard = Entry & _Node & {
  __typename: 'NewsletterCard';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  description: Maybe<Scalars['String']['output']>;
  disclaimer: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<NewsletterCardLinkingCollections>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/newsletterCard) */
export type NewsletterCardDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/newsletterCard) */
export type NewsletterCardDisclaimerArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/newsletterCard) */
export type NewsletterCardLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/newsletterCard) */
export type NewsletterCardTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type NewsletterCardCollection = {
  __typename: 'NewsletterCardCollection';
  items: Array<Maybe<NewsletterCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type NewsletterCardCursorCollection = {
  __typename: 'NewsletterCardCursorCollection';
  items: Array<Maybe<NewsletterCard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type NewsletterCardFilter = {
  AND: InputMaybe<Array<InputMaybe<NewsletterCardFilter>>>;
  OR: InputMaybe<Array<InputMaybe<NewsletterCardFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disclaimer: InputMaybe<Scalars['String']['input']>;
  disclaimer_contains: InputMaybe<Scalars['String']['input']>;
  disclaimer_exists: InputMaybe<Scalars['Boolean']['input']>;
  disclaimer_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disclaimer_not: InputMaybe<Scalars['String']['input']>;
  disclaimer_not_contains: InputMaybe<Scalars['String']['input']>;
  disclaimer_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NewsletterCardLinkingCollections = {
  __typename: 'NewsletterCardLinkingCollections';
  contactCollection: Maybe<ContactCollection>;
  contactCursorCollection: Maybe<ContactCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  eventsPageCollection: Maybe<EventsPageCollection>;
  eventsPageCursorCollection: Maybe<EventsPageCursorCollection>;
  featureCollection: Maybe<FeatureCollection>;
  featureCursorCollection: Maybe<FeatureCursorCollection>;
  footerCollection: Maybe<FooterCollection>;
  footerCursorCollection: Maybe<FooterCursorCollection>;
  grantResourcesCollection: Maybe<GrantResourcesCollection>;
  grantResourcesCursorCollection: Maybe<GrantResourcesCursorCollection>;
  homePageCollection: Maybe<HomePageCollection>;
  homePageCursorCollection: Maybe<HomePageCursorCollection>;
  ideaCollection: Maybe<IdeaCollection>;
  ideaCursorCollection: Maybe<IdeaCursorCollection>;
  mmufCollection: Maybe<MmufCollection>;
  mmufCursorCollection: Maybe<MmufCursorCollection>;
};


export type NewsletterCardLinkingCollectionsContactCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<NewsletterCardLinkingCollectionsContactCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type NewsletterCardLinkingCollectionsContactCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<NewsletterCardLinkingCollectionsContactCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type NewsletterCardLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type NewsletterCardLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type NewsletterCardLinkingCollectionsEventsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<NewsletterCardLinkingCollectionsEventsPageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type NewsletterCardLinkingCollectionsEventsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<NewsletterCardLinkingCollectionsEventsPageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type NewsletterCardLinkingCollectionsFeatureCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<NewsletterCardLinkingCollectionsFeatureCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type NewsletterCardLinkingCollectionsFeatureCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<NewsletterCardLinkingCollectionsFeatureCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type NewsletterCardLinkingCollectionsFooterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<NewsletterCardLinkingCollectionsFooterCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type NewsletterCardLinkingCollectionsFooterCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<NewsletterCardLinkingCollectionsFooterCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type NewsletterCardLinkingCollectionsGrantResourcesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<NewsletterCardLinkingCollectionsGrantResourcesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type NewsletterCardLinkingCollectionsGrantResourcesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<NewsletterCardLinkingCollectionsGrantResourcesCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type NewsletterCardLinkingCollectionsHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<NewsletterCardLinkingCollectionsHomePageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type NewsletterCardLinkingCollectionsHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<NewsletterCardLinkingCollectionsHomePageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type NewsletterCardLinkingCollectionsIdeaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<NewsletterCardLinkingCollectionsIdeaCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type NewsletterCardLinkingCollectionsIdeaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<NewsletterCardLinkingCollectionsIdeaCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type NewsletterCardLinkingCollectionsMmufCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<NewsletterCardLinkingCollectionsMmufCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type NewsletterCardLinkingCollectionsMmufCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<NewsletterCardLinkingCollectionsMmufCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum NewsletterCardLinkingCollectionsContactCollectionOrder {
  ContactEmailsHeadlineAsc = 'contactEmailsHeadline_ASC',
  ContactEmailsHeadlineDesc = 'contactEmailsHeadline_DESC',
  FacebookLinkAsc = 'facebookLink_ASC',
  FacebookLinkDesc = 'facebookLink_DESC',
  GrantInquiriesHeadlineAsc = 'grantInquiriesHeadline_ASC',
  GrantInquiriesHeadlineDesc = 'grantInquiriesHeadline_DESC',
  InstagramLinkAsc = 'instagramLink_ASC',
  InstagramLinkDesc = 'instagramLink_DESC',
  LinkedInLinkAsc = 'linkedInLink_ASC',
  LinkedInLinkDesc = 'linkedInLink_DESC',
  OfficeAddressGoogleMapsLabelAsc = 'officeAddressGoogleMapsLabel_ASC',
  OfficeAddressGoogleMapsLabelDesc = 'officeAddressGoogleMapsLabel_DESC',
  OfficeAddressGoogleMapsLinkAsc = 'officeAddressGoogleMapsLink_ASC',
  OfficeAddressGoogleMapsLinkDesc = 'officeAddressGoogleMapsLink_DESC',
  OfficeContactInformationHeadlineAsc = 'officeContactInformationHeadline_ASC',
  OfficeContactInformationHeadlineDesc = 'officeContactInformationHeadline_DESC',
  OfficeFaxNumberAsc = 'officeFaxNumber_ASC',
  OfficeFaxNumberDesc = 'officeFaxNumber_DESC',
  OfficeTelephoneNumberAsc = 'officeTelephoneNumber_ASC',
  OfficeTelephoneNumberDesc = 'officeTelephoneNumber_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SocialMediaHeadlineAsc = 'socialMediaHeadline_ASC',
  SocialMediaHeadlineDesc = 'socialMediaHeadline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThreadsLinkAsc = 'threadsLink_ASC',
  ThreadsLinkDesc = 'threadsLink_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterLinkAsc = 'twitterLink_ASC',
  TwitterLinkDesc = 'twitterLink_DESC',
  YoutubeLinkAsc = 'youtubeLink_ASC',
  YoutubeLinkDesc = 'youtubeLink_DESC'
}

export enum NewsletterCardLinkingCollectionsContactCursorCollectionOrder {
  ContactEmailsHeadlineAsc = 'contactEmailsHeadline_ASC',
  ContactEmailsHeadlineDesc = 'contactEmailsHeadline_DESC',
  FacebookLinkAsc = 'facebookLink_ASC',
  FacebookLinkDesc = 'facebookLink_DESC',
  GrantInquiriesHeadlineAsc = 'grantInquiriesHeadline_ASC',
  GrantInquiriesHeadlineDesc = 'grantInquiriesHeadline_DESC',
  InstagramLinkAsc = 'instagramLink_ASC',
  InstagramLinkDesc = 'instagramLink_DESC',
  LinkedInLinkAsc = 'linkedInLink_ASC',
  LinkedInLinkDesc = 'linkedInLink_DESC',
  OfficeAddressGoogleMapsLabelAsc = 'officeAddressGoogleMapsLabel_ASC',
  OfficeAddressGoogleMapsLabelDesc = 'officeAddressGoogleMapsLabel_DESC',
  OfficeAddressGoogleMapsLinkAsc = 'officeAddressGoogleMapsLink_ASC',
  OfficeAddressGoogleMapsLinkDesc = 'officeAddressGoogleMapsLink_DESC',
  OfficeContactInformationHeadlineAsc = 'officeContactInformationHeadline_ASC',
  OfficeContactInformationHeadlineDesc = 'officeContactInformationHeadline_DESC',
  OfficeFaxNumberAsc = 'officeFaxNumber_ASC',
  OfficeFaxNumberDesc = 'officeFaxNumber_DESC',
  OfficeTelephoneNumberAsc = 'officeTelephoneNumber_ASC',
  OfficeTelephoneNumberDesc = 'officeTelephoneNumber_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SocialMediaHeadlineAsc = 'socialMediaHeadline_ASC',
  SocialMediaHeadlineDesc = 'socialMediaHeadline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThreadsLinkAsc = 'threadsLink_ASC',
  ThreadsLinkDesc = 'threadsLink_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterLinkAsc = 'twitterLink_ASC',
  TwitterLinkDesc = 'twitterLink_DESC',
  YoutubeLinkAsc = 'youtubeLink_ASC',
  YoutubeLinkDesc = 'youtubeLink_DESC'
}

export enum NewsletterCardLinkingCollectionsEventsPageCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum NewsletterCardLinkingCollectionsEventsPageCursorCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum NewsletterCardLinkingCollectionsFeatureCollectionOrder {
  DateTimeAsc = 'dateTime_ASC',
  DateTimeDesc = 'dateTime_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  ShowSocialCtasAsc = 'showSocialCtas_ASC',
  ShowSocialCtasDesc = 'showSocialCtas_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TaglineAsc = 'tagline_ASC',
  TaglineDesc = 'tagline_DESC'
}

export enum NewsletterCardLinkingCollectionsFeatureCursorCollectionOrder {
  DateTimeAsc = 'dateTime_ASC',
  DateTimeDesc = 'dateTime_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  ShowSocialCtasAsc = 'showSocialCtas_ASC',
  ShowSocialCtasDesc = 'showSocialCtas_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TaglineAsc = 'tagline_ASC',
  TaglineDesc = 'tagline_DESC'
}

export enum NewsletterCardLinkingCollectionsFooterCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum NewsletterCardLinkingCollectionsFooterCursorCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum NewsletterCardLinkingCollectionsGrantResourcesCollectionOrder {
  ExplanatoryTitleAsc = 'explanatoryTitle_ASC',
  ExplanatoryTitleDesc = 'explanatoryTitle_DESC',
  GrantMakingAreasTitleAsc = 'grantMakingAreasTitle_ASC',
  GrantMakingAreasTitleDesc = 'grantMakingAreasTitle_DESC',
  SearchContextualMessageAsc = 'searchContextualMessage_ASC',
  SearchContextualMessageDesc = 'searchContextualMessage_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum NewsletterCardLinkingCollectionsGrantResourcesCursorCollectionOrder {
  ExplanatoryTitleAsc = 'explanatoryTitle_ASC',
  ExplanatoryTitleDesc = 'explanatoryTitle_DESC',
  GrantMakingAreasTitleAsc = 'grantMakingAreasTitle_ASC',
  GrantMakingAreasTitleDesc = 'grantMakingAreasTitle_DESC',
  SearchContextualMessageAsc = 'searchContextualMessage_ASC',
  SearchContextualMessageDesc = 'searchContextualMessage_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum NewsletterCardLinkingCollectionsHomePageCollectionOrder {
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  MissionTextAsc = 'missionText_ASC',
  MissionTextDesc = 'missionText_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StoriesCtaAsc = 'storiesCta_ASC',
  StoriesCtaDesc = 'storiesCta_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum NewsletterCardLinkingCollectionsHomePageCursorCollectionOrder {
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  MissionTextAsc = 'missionText_ASC',
  MissionTextDesc = 'missionText_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StoriesCtaAsc = 'storiesCta_ASC',
  StoriesCtaDesc = 'storiesCta_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum NewsletterCardLinkingCollectionsIdeaCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum NewsletterCardLinkingCollectionsIdeaCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum NewsletterCardLinkingCollectionsMmufCollectionOrder {
  ArticleTitleAsc = 'articleTitle_ASC',
  ArticleTitleDesc = 'articleTitle_DESC',
  AtGlanceTitleAsc = 'atGlanceTitle_ASC',
  AtGlanceTitleDesc = 'atGlanceTitle_DESC',
  ContactEmailAsc = 'contactEmail_ASC',
  ContactEmailDesc = 'contactEmail_DESC',
  ContactMessageAsc = 'contactMessage_ASC',
  ContactMessageDesc = 'contactMessage_DESC',
  ContactTitleAsc = 'contactTitle_ASC',
  ContactTitleDesc = 'contactTitle_DESC',
  FellowStoriesCtaLabelAsc = 'fellowStoriesCtaLabel_ASC',
  FellowStoriesCtaLabelDesc = 'fellowStoriesCtaLabel_DESC',
  FellowStoriesMessageAsc = 'fellowStoriesMessage_ASC',
  FellowStoriesMessageDesc = 'fellowStoriesMessage_DESC',
  GraduateInitiativesTitleAsc = 'graduateInitiativesTitle_ASC',
  GraduateInitiativesTitleDesc = 'graduateInitiativesTitle_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum NewsletterCardLinkingCollectionsMmufCursorCollectionOrder {
  ArticleTitleAsc = 'articleTitle_ASC',
  ArticleTitleDesc = 'articleTitle_DESC',
  AtGlanceTitleAsc = 'atGlanceTitle_ASC',
  AtGlanceTitleDesc = 'atGlanceTitle_DESC',
  ContactEmailAsc = 'contactEmail_ASC',
  ContactEmailDesc = 'contactEmail_DESC',
  ContactMessageAsc = 'contactMessage_ASC',
  ContactMessageDesc = 'contactMessage_DESC',
  ContactTitleAsc = 'contactTitle_ASC',
  ContactTitleDesc = 'contactTitle_DESC',
  FellowStoriesCtaLabelAsc = 'fellowStoriesCtaLabel_ASC',
  FellowStoriesCtaLabelDesc = 'fellowStoriesCtaLabel_DESC',
  FellowStoriesMessageAsc = 'fellowStoriesMessage_ASC',
  FellowStoriesMessageDesc = 'fellowStoriesMessage_DESC',
  GraduateInitiativesTitleAsc = 'graduateInitiativesTitle_ASC',
  GraduateInitiativesTitleDesc = 'graduateInitiativesTitle_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum NewsletterCardOrder {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  DisclaimerAsc = 'disclaimer_ASC',
  DisclaimerDesc = 'disclaimer_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/newsletterConfirmPage) */
export type NewsletterConfirmPage = Entry & _Node & {
  __typename: 'NewsletterConfirmPage';
  _id: Scalars['ID']['output'];
  body: Maybe<NewsletterConfirmPageBody>;
  contentfulMetadata: ContentfulMetadata;
  description: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<NewsletterConfirmPageLinkingCollections>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/newsletterConfirmPage) */
export type NewsletterConfirmPageBodyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/newsletterConfirmPage) */
export type NewsletterConfirmPageDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/newsletterConfirmPage) */
export type NewsletterConfirmPageLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/newsletterConfirmPage) */
export type NewsletterConfirmPageTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type NewsletterConfirmPageBody = {
  __typename: 'NewsletterConfirmPageBody';
  json: Scalars['JSON']['output'];
  links: NewsletterConfirmPageBodyLinks;
};

export type NewsletterConfirmPageBodyAssets = {
  __typename: 'NewsletterConfirmPageBodyAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type NewsletterConfirmPageBodyEntries = {
  __typename: 'NewsletterConfirmPageBodyEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type NewsletterConfirmPageBodyLinks = {
  __typename: 'NewsletterConfirmPageBodyLinks';
  assets: NewsletterConfirmPageBodyAssets;
  entries: NewsletterConfirmPageBodyEntries;
  resources: NewsletterConfirmPageBodyResources;
};

export type NewsletterConfirmPageBodyResources = {
  __typename: 'NewsletterConfirmPageBodyResources';
  block: Array<NewsletterConfirmPageBodyResourcesBlock>;
  hyperlink: Array<NewsletterConfirmPageBodyResourcesHyperlink>;
  inline: Array<NewsletterConfirmPageBodyResourcesInline>;
};

export type NewsletterConfirmPageBodyResourcesBlock = ResourceLink & {
  __typename: 'NewsletterConfirmPageBodyResourcesBlock';
  sys: ResourceSys;
};

export type NewsletterConfirmPageBodyResourcesHyperlink = ResourceLink & {
  __typename: 'NewsletterConfirmPageBodyResourcesHyperlink';
  sys: ResourceSys;
};

export type NewsletterConfirmPageBodyResourcesInline = ResourceLink & {
  __typename: 'NewsletterConfirmPageBodyResourcesInline';
  sys: ResourceSys;
};

export type NewsletterConfirmPageCollection = {
  __typename: 'NewsletterConfirmPageCollection';
  items: Array<Maybe<NewsletterConfirmPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type NewsletterConfirmPageCursorCollection = {
  __typename: 'NewsletterConfirmPageCursorCollection';
  items: Array<Maybe<NewsletterConfirmPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type NewsletterConfirmPageFilter = {
  AND: InputMaybe<Array<InputMaybe<NewsletterConfirmPageFilter>>>;
  OR: InputMaybe<Array<InputMaybe<NewsletterConfirmPageFilter>>>;
  body_contains: InputMaybe<Scalars['String']['input']>;
  body_exists: InputMaybe<Scalars['Boolean']['input']>;
  body_not_contains: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NewsletterConfirmPageLinkingCollections = {
  __typename: 'NewsletterConfirmPageLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type NewsletterConfirmPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type NewsletterConfirmPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum NewsletterConfirmPageOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/newsletterPage) */
export type NewsletterPage = Entry & _Node & {
  __typename: 'NewsletterPage';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  description: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<NewsletterPageLinkingCollections>;
  quickLinks: Maybe<ConnectWith>;
  signupDescription: Maybe<Scalars['String']['output']>;
  signupImage: Maybe<Asset>;
  slug: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/newsletterPage) */
export type NewsletterPageDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/newsletterPage) */
export type NewsletterPageLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/newsletterPage) */
export type NewsletterPageQuickLinksArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ConnectWithFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/newsletterPage) */
export type NewsletterPageSignupDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/newsletterPage) */
export type NewsletterPageSignupImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/newsletterPage) */
export type NewsletterPageSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/newsletterPage) */
export type NewsletterPageTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type NewsletterPageCollection = {
  __typename: 'NewsletterPageCollection';
  items: Array<Maybe<NewsletterPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type NewsletterPageCursorCollection = {
  __typename: 'NewsletterPageCursorCollection';
  items: Array<Maybe<NewsletterPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type NewsletterPageFilter = {
  AND: InputMaybe<Array<InputMaybe<NewsletterPageFilter>>>;
  OR: InputMaybe<Array<InputMaybe<NewsletterPageFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quickLinks: InputMaybe<CfConnectWithNestedFilter>;
  quickLinks_exists: InputMaybe<Scalars['Boolean']['input']>;
  signupDescription: InputMaybe<Scalars['String']['input']>;
  signupDescription_contains: InputMaybe<Scalars['String']['input']>;
  signupDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  signupDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  signupDescription_not: InputMaybe<Scalars['String']['input']>;
  signupDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  signupDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  signupImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NewsletterPageLinkingCollections = {
  __typename: 'NewsletterPageLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type NewsletterPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type NewsletterPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum NewsletterPageOrder {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  SignupDescriptionAsc = 'signupDescription_ASC',
  SignupDescriptionDesc = 'signupDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/oldAnnualReport) */
export type OldAnnualReport = Entry & _Node & {
  __typename: 'OldAnnualReport';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<OldAnnualReportLinkingCollections>;
  report: Maybe<Asset>;
  sys: Sys;
  year: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/oldAnnualReport) */
export type OldAnnualReportLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/oldAnnualReport) */
export type OldAnnualReportReportArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/oldAnnualReport) */
export type OldAnnualReportYearArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type OldAnnualReportCollection = {
  __typename: 'OldAnnualReportCollection';
  items: Array<Maybe<OldAnnualReport>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type OldAnnualReportCursorCollection = {
  __typename: 'OldAnnualReportCursorCollection';
  items: Array<Maybe<OldAnnualReport>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type OldAnnualReportFilter = {
  AND: InputMaybe<Array<InputMaybe<OldAnnualReportFilter>>>;
  OR: InputMaybe<Array<InputMaybe<OldAnnualReportFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  report_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  year: InputMaybe<Scalars['String']['input']>;
  year_contains: InputMaybe<Scalars['String']['input']>;
  year_exists: InputMaybe<Scalars['Boolean']['input']>;
  year_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  year_not: InputMaybe<Scalars['String']['input']>;
  year_not_contains: InputMaybe<Scalars['String']['input']>;
  year_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OldAnnualReportLinkingCollections = {
  __typename: 'OldAnnualReportLinkingCollections';
  annualReportCollection: Maybe<AnnualReportCollection>;
  annualReportCursorCollection: Maybe<AnnualReportCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type OldAnnualReportLinkingCollectionsAnnualReportCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<OldAnnualReportLinkingCollectionsAnnualReportCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type OldAnnualReportLinkingCollectionsAnnualReportCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<OldAnnualReportLinkingCollectionsAnnualReportCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type OldAnnualReportLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type OldAnnualReportLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OldAnnualReportLinkingCollectionsAnnualReportCollectionOrder {
  CallToActionCtaTextAsc = 'callToActionCtaText_ASC',
  CallToActionCtaTextDesc = 'callToActionCtaText_DESC',
  CallToActionTextAsc = 'callToActionText_ASC',
  CallToActionTextDesc = 'callToActionText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  IsLookingForAnnualReportsSectionVisibleAsc = 'isLookingForAnnualReportsSectionVisible_ASC',
  IsLookingForAnnualReportsSectionVisibleDesc = 'isLookingForAnnualReportsSectionVisible_DESC',
  MoreAnnualReportsTitleAsc = 'moreAnnualReportsTitle_ASC',
  MoreAnnualReportsTitleDesc = 'moreAnnualReportsTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  YearAsc = 'year_ASC',
  YearDesc = 'year_DESC'
}

export enum OldAnnualReportLinkingCollectionsAnnualReportCursorCollectionOrder {
  CallToActionCtaTextAsc = 'callToActionCtaText_ASC',
  CallToActionCtaTextDesc = 'callToActionCtaText_DESC',
  CallToActionTextAsc = 'callToActionText_ASC',
  CallToActionTextDesc = 'callToActionText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  IsLookingForAnnualReportsSectionVisibleAsc = 'isLookingForAnnualReportsSectionVisible_ASC',
  IsLookingForAnnualReportsSectionVisibleDesc = 'isLookingForAnnualReportsSectionVisible_DESC',
  MoreAnnualReportsTitleAsc = 'moreAnnualReportsTitle_ASC',
  MoreAnnualReportsTitleDesc = 'moreAnnualReportsTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  YearAsc = 'year_ASC',
  YearDesc = 'year_DESC'
}

export enum OldAnnualReportOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  YearAsc = 'year_ASC',
  YearDesc = 'year_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/organisation) */
export type Organisation = Entry & _Node & {
  __typename: 'Organisation';
  _id: Scalars['ID']['output'];
  city: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  country: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<OrganisationLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/organisation) */
export type OrganisationCityArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/organisation) */
export type OrganisationCountryArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/organisation) */
export type OrganisationIdArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/organisation) */
export type OrganisationLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/organisation) */
export type OrganisationNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/organisation) */
export type OrganisationStateArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrganisationCollection = {
  __typename: 'OrganisationCollection';
  items: Array<Maybe<Organisation>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type OrganisationCursorCollection = {
  __typename: 'OrganisationCursorCollection';
  items: Array<Maybe<Organisation>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type OrganisationFilter = {
  AND: InputMaybe<Array<InputMaybe<OrganisationFilter>>>;
  OR: InputMaybe<Array<InputMaybe<OrganisationFilter>>>;
  city: InputMaybe<Scalars['String']['input']>;
  city_contains: InputMaybe<Scalars['String']['input']>;
  city_exists: InputMaybe<Scalars['Boolean']['input']>;
  city_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  city_not: InputMaybe<Scalars['String']['input']>;
  city_not_contains: InputMaybe<Scalars['String']['input']>;
  city_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  country: InputMaybe<Scalars['String']['input']>;
  country_contains: InputMaybe<Scalars['String']['input']>;
  country_exists: InputMaybe<Scalars['Boolean']['input']>;
  country_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  country_not: InputMaybe<Scalars['String']['input']>;
  country_not_contains: InputMaybe<Scalars['String']['input']>;
  country_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id: InputMaybe<Scalars['String']['input']>;
  id_contains: InputMaybe<Scalars['String']['input']>;
  id_exists: InputMaybe<Scalars['Boolean']['input']>;
  id_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not: InputMaybe<Scalars['String']['input']>;
  id_not_contains: InputMaybe<Scalars['String']['input']>;
  id_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  state: InputMaybe<Scalars['String']['input']>;
  state_contains: InputMaybe<Scalars['String']['input']>;
  state_exists: InputMaybe<Scalars['Boolean']['input']>;
  state_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  state_not: InputMaybe<Scalars['String']['input']>;
  state_not_contains: InputMaybe<Scalars['String']['input']>;
  state_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type OrganisationLinkingCollections = {
  __typename: 'OrganisationLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  grantCollection: Maybe<GrantCollection>;
  grantCursorCollection: Maybe<GrantCursorCollection>;
};


export type OrganisationLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type OrganisationLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type OrganisationLinkingCollectionsGrantCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<OrganisationLinkingCollectionsGrantCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type OrganisationLinkingCollectionsGrantCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<OrganisationLinkingCollectionsGrantCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OrganisationLinkingCollectionsGrantCollectionOrder {
  AmountAsc = 'amount_ASC',
  AmountDesc = 'amount_DESC',
  AreaOfFocusAsc = 'areaOfFocus_ASC',
  AreaOfFocusDesc = 'areaOfFocus_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  DurationInMonthsAsc = 'durationInMonths_ASC',
  DurationInMonthsDesc = 'durationInMonths_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ProjectTitleAsc = 'projectTitle_ASC',
  ProjectTitleDesc = 'projectTitle_DESC',
  ReferenceIdAsc = 'referenceId_ASC',
  ReferenceIdDesc = 'referenceId_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum OrganisationLinkingCollectionsGrantCursorCollectionOrder {
  AmountAsc = 'amount_ASC',
  AmountDesc = 'amount_DESC',
  AreaOfFocusAsc = 'areaOfFocus_ASC',
  AreaOfFocusDesc = 'areaOfFocus_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  DurationInMonthsAsc = 'durationInMonths_ASC',
  DurationInMonthsDesc = 'durationInMonths_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ProjectTitleAsc = 'projectTitle_ASC',
  ProjectTitleDesc = 'projectTitle_DESC',
  ReferenceIdAsc = 'referenceId_ASC',
  ReferenceIdDesc = 'referenceId_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum OrganisationOrder {
  CityAsc = 'city_ASC',
  CityDesc = 'city_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  StateAsc = 'state_ASC',
  StateDesc = 'state_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/parallaxImages) */
export type ParallaxImages = Entry & _Node & {
  __typename: 'ParallaxImages';
  _id: Scalars['ID']['output'];
  body: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  imagesCollection: Maybe<AssetCollection>;
  imagesCursorCollection: Maybe<AssetCursorCollection>;
  linkedFrom: Maybe<ParallaxImagesLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/parallaxImages) */
export type ParallaxImagesBodyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/parallaxImages) */
export type ParallaxImagesImagesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/parallaxImages) */
export type ParallaxImagesImagesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/parallaxImages) */
export type ParallaxImagesLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ParallaxImagesCollection = {
  __typename: 'ParallaxImagesCollection';
  items: Array<Maybe<ParallaxImages>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ParallaxImagesCursorCollection = {
  __typename: 'ParallaxImagesCursorCollection';
  items: Array<Maybe<ParallaxImages>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ParallaxImagesFilter = {
  AND: InputMaybe<Array<InputMaybe<ParallaxImagesFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ParallaxImagesFilter>>>;
  body: InputMaybe<Scalars['String']['input']>;
  body_contains: InputMaybe<Scalars['String']['input']>;
  body_exists: InputMaybe<Scalars['Boolean']['input']>;
  body_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_not: InputMaybe<Scalars['String']['input']>;
  body_not_contains: InputMaybe<Scalars['String']['input']>;
  body_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  imagesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
};

export type ParallaxImagesLinkingCollections = {
  __typename: 'ParallaxImagesLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type ParallaxImagesLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ParallaxImagesLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ParallaxImagesOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/passwordProtectedPage) */
export type PasswordProtectedPage = Entry & _Node & {
  __typename: 'PasswordProtectedPage';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  email: Maybe<ConnectWithLink>;
  emailHeadline: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<PasswordProtectedPageLinkingCollections>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/passwordProtectedPage) */
export type PasswordProtectedPageEmailArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ConnectWithLinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/passwordProtectedPage) */
export type PasswordProtectedPageEmailHeadlineArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/passwordProtectedPage) */
export type PasswordProtectedPageLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/passwordProtectedPage) */
export type PasswordProtectedPageTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type PasswordProtectedPageCollection = {
  __typename: 'PasswordProtectedPageCollection';
  items: Array<Maybe<PasswordProtectedPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PasswordProtectedPageCursorCollection = {
  __typename: 'PasswordProtectedPageCursorCollection';
  items: Array<Maybe<PasswordProtectedPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PasswordProtectedPageFilter = {
  AND: InputMaybe<Array<InputMaybe<PasswordProtectedPageFilter>>>;
  OR: InputMaybe<Array<InputMaybe<PasswordProtectedPageFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  email: InputMaybe<CfConnectWithLinkNestedFilter>;
  emailHeadline: InputMaybe<Scalars['String']['input']>;
  emailHeadline_contains: InputMaybe<Scalars['String']['input']>;
  emailHeadline_exists: InputMaybe<Scalars['Boolean']['input']>;
  emailHeadline_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  emailHeadline_not: InputMaybe<Scalars['String']['input']>;
  emailHeadline_not_contains: InputMaybe<Scalars['String']['input']>;
  emailHeadline_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PasswordProtectedPageLinkingCollections = {
  __typename: 'PasswordProtectedPageLinkingCollections';
  articleCollection: Maybe<ArticleCollection>;
  articleCursorCollection: Maybe<ArticleCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type PasswordProtectedPageLinkingCollectionsArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PasswordProtectedPageLinkingCollectionsArticleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type PasswordProtectedPageLinkingCollectionsArticleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PasswordProtectedPageLinkingCollectionsArticleCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type PasswordProtectedPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type PasswordProtectedPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PasswordProtectedPageLinkingCollectionsArticleCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  ExternalNewsUrlAsc = 'externalNewsUrl_ASC',
  ExternalNewsUrlDesc = 'externalNewsUrl_DESC',
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  PasswordAsc = 'password_ASC',
  PasswordDesc = 'password_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum PasswordProtectedPageLinkingCollectionsArticleCursorCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  ExternalNewsUrlAsc = 'externalNewsUrl_ASC',
  ExternalNewsUrlDesc = 'externalNewsUrl_DESC',
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  PasswordAsc = 'password_ASC',
  PasswordDesc = 'password_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum PasswordProtectedPageOrder {
  EmailHeadlineAsc = 'emailHeadline_ASC',
  EmailHeadlineDesc = 'emailHeadline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/peoplePage) */
export type PeoplePage = Entry & _Node & {
  __typename: 'PeoplePage';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  contextualMessage: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  image: Maybe<Asset>;
  leadershipCollection: Maybe<PeoplePageLeadershipCollection>;
  leadershipCursorCollection: Maybe<PeoplePageLeadershipCursorCollection>;
  linkedFrom: Maybe<PeoplePageLinkingCollections>;
  navigationImagePortrait: Maybe<Asset>;
  president: Maybe<Person>;
  slug: Maybe<Scalars['String']['output']>;
  sys: Sys;
  teamsCollection: Maybe<PeoplePageTeamsCollection>;
  teamsCursorCollection: Maybe<PeoplePageTeamsCursorCollection>;
  title: Maybe<Scalars['String']['output']>;
  trusteesCtaLabel: Maybe<Scalars['String']['output']>;
  trusteesCtaText: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/peoplePage) */
export type PeoplePageContextualMessageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/peoplePage) */
export type PeoplePageDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/peoplePage) */
export type PeoplePageImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/peoplePage) */
export type PeoplePageLeadershipCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PeoplePageLeadershipCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PersonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/peoplePage) */
export type PeoplePageLeadershipCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PeoplePageLeadershipCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PersonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/peoplePage) */
export type PeoplePageLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/peoplePage) */
export type PeoplePageNavigationImagePortraitArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/peoplePage) */
export type PeoplePagePresidentArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PersonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/peoplePage) */
export type PeoplePageSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/peoplePage) */
export type PeoplePageTeamsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PeoplePageTeamsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/peoplePage) */
export type PeoplePageTeamsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PeoplePageTeamsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/peoplePage) */
export type PeoplePageTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/peoplePage) */
export type PeoplePageTrusteesCtaLabelArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/peoplePage) */
export type PeoplePageTrusteesCtaTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type PeoplePageCollection = {
  __typename: 'PeoplePageCollection';
  items: Array<Maybe<PeoplePage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PeoplePageCursorCollection = {
  __typename: 'PeoplePageCursorCollection';
  items: Array<Maybe<PeoplePage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PeoplePageFilter = {
  AND: InputMaybe<Array<InputMaybe<PeoplePageFilter>>>;
  OR: InputMaybe<Array<InputMaybe<PeoplePageFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  contextualMessage: InputMaybe<Scalars['String']['input']>;
  contextualMessage_contains: InputMaybe<Scalars['String']['input']>;
  contextualMessage_exists: InputMaybe<Scalars['Boolean']['input']>;
  contextualMessage_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contextualMessage_not: InputMaybe<Scalars['String']['input']>;
  contextualMessage_not_contains: InputMaybe<Scalars['String']['input']>;
  contextualMessage_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists: InputMaybe<Scalars['Boolean']['input']>;
  leadership: InputMaybe<CfPersonNestedFilter>;
  leadershipCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  navigationImagePortrait_exists: InputMaybe<Scalars['Boolean']['input']>;
  president: InputMaybe<CfPersonNestedFilter>;
  president_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  teams: InputMaybe<CfteamsMultiTypeNestedFilter>;
  teamsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  trusteesCtaLabel: InputMaybe<Scalars['String']['input']>;
  trusteesCtaLabel_contains: InputMaybe<Scalars['String']['input']>;
  trusteesCtaLabel_exists: InputMaybe<Scalars['Boolean']['input']>;
  trusteesCtaLabel_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  trusteesCtaLabel_not: InputMaybe<Scalars['String']['input']>;
  trusteesCtaLabel_not_contains: InputMaybe<Scalars['String']['input']>;
  trusteesCtaLabel_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  trusteesCtaText: InputMaybe<Scalars['String']['input']>;
  trusteesCtaText_contains: InputMaybe<Scalars['String']['input']>;
  trusteesCtaText_exists: InputMaybe<Scalars['Boolean']['input']>;
  trusteesCtaText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  trusteesCtaText_not: InputMaybe<Scalars['String']['input']>;
  trusteesCtaText_not_contains: InputMaybe<Scalars['String']['input']>;
  trusteesCtaText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PeoplePageLeadershipCollection = {
  __typename: 'PeoplePageLeadershipCollection';
  items: Array<Maybe<Person>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum PeoplePageLeadershipCollectionOrder {
  FirstNameAsc = 'firstName_ASC',
  FirstNameDesc = 'firstName_DESC',
  JobTitleAsc = 'jobTitle_ASC',
  JobTitleDesc = 'jobTitle_DESC',
  LastNameAsc = 'lastName_ASC',
  LastNameDesc = 'lastName_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  RelatedSectionTitleAsc = 'relatedSectionTitle_ASC',
  RelatedSectionTitleDesc = 'relatedSectionTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type PeoplePageLeadershipCursorCollection = {
  __typename: 'PeoplePageLeadershipCursorCollection';
  items: Array<Maybe<Person>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum PeoplePageLeadershipCursorCollectionOrder {
  FirstNameAsc = 'firstName_ASC',
  FirstNameDesc = 'firstName_DESC',
  JobTitleAsc = 'jobTitle_ASC',
  JobTitleDesc = 'jobTitle_DESC',
  LastNameAsc = 'lastName_ASC',
  LastNameDesc = 'lastName_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  RelatedSectionTitleAsc = 'relatedSectionTitle_ASC',
  RelatedSectionTitleDesc = 'relatedSectionTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type PeoplePageLinkingCollections = {
  __typename: 'PeoplePageLinkingCollections';
  connectWithLinkCollection: Maybe<ConnectWithLinkCollection>;
  connectWithLinkCursorCollection: Maybe<ConnectWithLinkCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  mainNavigationCollection: Maybe<MainNavigationCollection>;
  mainNavigationCursorCollection: Maybe<MainNavigationCursorCollection>;
};


export type PeoplePageLinkingCollectionsConnectWithLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PeoplePageLinkingCollectionsConnectWithLinkCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type PeoplePageLinkingCollectionsConnectWithLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PeoplePageLinkingCollectionsConnectWithLinkCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type PeoplePageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type PeoplePageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type PeoplePageLinkingCollectionsMainNavigationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PeoplePageLinkingCollectionsMainNavigationCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type PeoplePageLinkingCollectionsMainNavigationCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PeoplePageLinkingCollectionsMainNavigationCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PeoplePageLinkingCollectionsConnectWithLinkCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PeoplePageLinkingCollectionsConnectWithLinkCursorCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PeoplePageLinkingCollectionsMainNavigationCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PeoplePageLinkingCollectionsMainNavigationCursorCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PeoplePageOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TrusteesCtaLabelAsc = 'trusteesCtaLabel_ASC',
  TrusteesCtaLabelDesc = 'trusteesCtaLabel_DESC',
  TrusteesCtaTextAsc = 'trusteesCtaText_ASC',
  TrusteesCtaTextDesc = 'trusteesCtaText_DESC'
}

export type PeoplePageTeamsCollection = {
  __typename: 'PeoplePageTeamsCollection';
  items: Array<Maybe<PeoplePageTeamsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PeoplePageTeamsCursorCollection = {
  __typename: 'PeoplePageTeamsCursorCollection';
  items: Array<Maybe<PeoplePageTeamsItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PeoplePageTeamsFilter = {
  AND: InputMaybe<Array<InputMaybe<PeoplePageTeamsFilter>>>;
  OR: InputMaybe<Array<InputMaybe<PeoplePageTeamsFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type PeoplePageTeamsItem = Department | GrantmakingArea;

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/person) */
export type Person = Entry & _Node & {
  __typename: 'Person';
  _id: Scalars['ID']['output'];
  biography: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  contextualMessage: Maybe<Scalars['String']['output']>;
  departmentOrGrantMakingArea: Maybe<PersonDepartmentOrGrantMakingArea>;
  description: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  image: Maybe<Asset>;
  jobTitle: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<PersonLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  quickLinksCollection: Maybe<PersonQuickLinksCollection>;
  quickLinksCursorCollection: Maybe<PersonQuickLinksCursorCollection>;
  quote: Maybe<Quote>;
  relatedNewsCollection: Maybe<PersonRelatedNewsCollection>;
  relatedNewsCursorCollection: Maybe<PersonRelatedNewsCursorCollection>;
  relatedSectionTitle: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  spotlight: Maybe<PersonSpotlight>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/person) */
export type PersonBiographyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/person) */
export type PersonContextualMessageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/person) */
export type PersonDepartmentOrGrantMakingAreaArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PersonDepartmentOrGrantMakingAreaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/person) */
export type PersonDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/person) */
export type PersonFirstNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/person) */
export type PersonImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/person) */
export type PersonJobTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/person) */
export type PersonLastNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/person) */
export type PersonLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/person) */
export type PersonNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/person) */
export type PersonQuickLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PersonQuickLinksCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ConnectWithLinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/person) */
export type PersonQuickLinksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PersonQuickLinksCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ConnectWithLinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/person) */
export type PersonQuoteArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<QuoteFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/person) */
export type PersonRelatedNewsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PersonRelatedNewsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/person) */
export type PersonRelatedNewsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PersonRelatedNewsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/person) */
export type PersonRelatedSectionTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/person) */
export type PersonSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/person) */
export type PersonSpotlightArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type PersonCollection = {
  __typename: 'PersonCollection';
  items: Array<Maybe<Person>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PersonCursorCollection = {
  __typename: 'PersonCursorCollection';
  items: Array<Maybe<Person>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PersonDepartmentOrGrantMakingArea = Department | GrantmakingArea;

export type PersonDepartmentOrGrantMakingAreaFilter = {
  AND: InputMaybe<Array<InputMaybe<PersonDepartmentOrGrantMakingAreaFilter>>>;
  OR: InputMaybe<Array<InputMaybe<PersonDepartmentOrGrantMakingAreaFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type PersonFilter = {
  AND: InputMaybe<Array<InputMaybe<PersonFilter>>>;
  OR: InputMaybe<Array<InputMaybe<PersonFilter>>>;
  biography: InputMaybe<Scalars['String']['input']>;
  biography_contains: InputMaybe<Scalars['String']['input']>;
  biography_exists: InputMaybe<Scalars['Boolean']['input']>;
  biography_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  biography_not: InputMaybe<Scalars['String']['input']>;
  biography_not_contains: InputMaybe<Scalars['String']['input']>;
  biography_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  contextualMessage: InputMaybe<Scalars['String']['input']>;
  contextualMessage_contains: InputMaybe<Scalars['String']['input']>;
  contextualMessage_exists: InputMaybe<Scalars['Boolean']['input']>;
  contextualMessage_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contextualMessage_not: InputMaybe<Scalars['String']['input']>;
  contextualMessage_not_contains: InputMaybe<Scalars['String']['input']>;
  contextualMessage_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  departmentOrGrantMakingArea: InputMaybe<CfdepartmentOrGrantMakingAreaMultiTypeNestedFilter>;
  departmentOrGrantMakingArea_exists: InputMaybe<Scalars['Boolean']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstName: InputMaybe<Scalars['String']['input']>;
  firstName_contains: InputMaybe<Scalars['String']['input']>;
  firstName_exists: InputMaybe<Scalars['Boolean']['input']>;
  firstName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstName_not: InputMaybe<Scalars['String']['input']>;
  firstName_not_contains: InputMaybe<Scalars['String']['input']>;
  firstName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle: InputMaybe<Scalars['String']['input']>;
  jobTitle_contains: InputMaybe<Scalars['String']['input']>;
  jobTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  jobTitle_not: InputMaybe<Scalars['String']['input']>;
  jobTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  jobTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName: InputMaybe<Scalars['String']['input']>;
  lastName_contains: InputMaybe<Scalars['String']['input']>;
  lastName_exists: InputMaybe<Scalars['Boolean']['input']>;
  lastName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName_not: InputMaybe<Scalars['String']['input']>;
  lastName_not_contains: InputMaybe<Scalars['String']['input']>;
  lastName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quickLinks: InputMaybe<CfConnectWithLinkNestedFilter>;
  quickLinksCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  quote: InputMaybe<CfQuoteNestedFilter>;
  quote_exists: InputMaybe<Scalars['Boolean']['input']>;
  relatedNews: InputMaybe<CfrelatedNewsMultiTypeNestedFilter>;
  relatedNewsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  relatedSectionTitle: InputMaybe<Scalars['String']['input']>;
  relatedSectionTitle_contains: InputMaybe<Scalars['String']['input']>;
  relatedSectionTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  relatedSectionTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedSectionTitle_not: InputMaybe<Scalars['String']['input']>;
  relatedSectionTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  relatedSectionTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  spotlight_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
};

export type PersonLinkingCollections = {
  __typename: 'PersonLinkingCollections';
  annualReportCollection: Maybe<AnnualReportCollection>;
  annualReportCursorCollection: Maybe<AnnualReportCursorCollection>;
  articleCollection: Maybe<ArticleCollection>;
  articleCursorCollection: Maybe<ArticleCursorCollection>;
  connectWithLinkCollection: Maybe<ConnectWithLinkCollection>;
  connectWithLinkCursorCollection: Maybe<ConnectWithLinkCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  historyPageCollection: Maybe<HistoryPageCollection>;
  historyPageCursorCollection: Maybe<HistoryPageCursorCollection>;
  peoplePageCollection: Maybe<PeoplePageCollection>;
  peoplePageCursorCollection: Maybe<PeoplePageCursorCollection>;
};


export type PersonLinkingCollectionsAnnualReportCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PersonLinkingCollectionsAnnualReportCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type PersonLinkingCollectionsAnnualReportCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PersonLinkingCollectionsAnnualReportCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type PersonLinkingCollectionsArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PersonLinkingCollectionsArticleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type PersonLinkingCollectionsArticleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PersonLinkingCollectionsArticleCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type PersonLinkingCollectionsConnectWithLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PersonLinkingCollectionsConnectWithLinkCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type PersonLinkingCollectionsConnectWithLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PersonLinkingCollectionsConnectWithLinkCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type PersonLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type PersonLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type PersonLinkingCollectionsHistoryPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PersonLinkingCollectionsHistoryPageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type PersonLinkingCollectionsHistoryPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PersonLinkingCollectionsHistoryPageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type PersonLinkingCollectionsPeoplePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PersonLinkingCollectionsPeoplePageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type PersonLinkingCollectionsPeoplePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PersonLinkingCollectionsPeoplePageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PersonLinkingCollectionsAnnualReportCollectionOrder {
  CallToActionCtaTextAsc = 'callToActionCtaText_ASC',
  CallToActionCtaTextDesc = 'callToActionCtaText_DESC',
  CallToActionTextAsc = 'callToActionText_ASC',
  CallToActionTextDesc = 'callToActionText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  IsLookingForAnnualReportsSectionVisibleAsc = 'isLookingForAnnualReportsSectionVisible_ASC',
  IsLookingForAnnualReportsSectionVisibleDesc = 'isLookingForAnnualReportsSectionVisible_DESC',
  MoreAnnualReportsTitleAsc = 'moreAnnualReportsTitle_ASC',
  MoreAnnualReportsTitleDesc = 'moreAnnualReportsTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  YearAsc = 'year_ASC',
  YearDesc = 'year_DESC'
}

export enum PersonLinkingCollectionsAnnualReportCursorCollectionOrder {
  CallToActionCtaTextAsc = 'callToActionCtaText_ASC',
  CallToActionCtaTextDesc = 'callToActionCtaText_DESC',
  CallToActionTextAsc = 'callToActionText_ASC',
  CallToActionTextDesc = 'callToActionText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  IsLookingForAnnualReportsSectionVisibleAsc = 'isLookingForAnnualReportsSectionVisible_ASC',
  IsLookingForAnnualReportsSectionVisibleDesc = 'isLookingForAnnualReportsSectionVisible_DESC',
  MoreAnnualReportsTitleAsc = 'moreAnnualReportsTitle_ASC',
  MoreAnnualReportsTitleDesc = 'moreAnnualReportsTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  YearAsc = 'year_ASC',
  YearDesc = 'year_DESC'
}

export enum PersonLinkingCollectionsArticleCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  ExternalNewsUrlAsc = 'externalNewsUrl_ASC',
  ExternalNewsUrlDesc = 'externalNewsUrl_DESC',
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  PasswordAsc = 'password_ASC',
  PasswordDesc = 'password_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum PersonLinkingCollectionsArticleCursorCollectionOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  CreditLabelAsc = 'creditLabel_ASC',
  CreditLabelDesc = 'creditLabel_DESC',
  CreditTextAsc = 'creditText_ASC',
  CreditTextDesc = 'creditText_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  ExternalNewsUrlAsc = 'externalNewsUrl_ASC',
  ExternalNewsUrlDesc = 'externalNewsUrl_DESC',
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  HideShareLinkAsc = 'hideShareLink_ASC',
  HideShareLinkDesc = 'hideShareLink_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  PasswordAsc = 'password_ASC',
  PasswordDesc = 'password_DESC',
  PhotographerAsc = 'photographer_ASC',
  PhotographerDesc = 'photographer_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum PersonLinkingCollectionsConnectWithLinkCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PersonLinkingCollectionsConnectWithLinkCursorCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PersonLinkingCollectionsHistoryPageCollectionOrder {
  CurrentPresidentStartYearAsc = 'currentPresidentStartYear_ASC',
  CurrentPresidentStartYearDesc = 'currentPresidentStartYear_DESC',
  GrantMakingProcessCtaTextAsc = 'grantMakingProcessCtaText_ASC',
  GrantMakingProcessCtaTextDesc = 'grantMakingProcessCtaText_DESC',
  ImpactTitleAsc = 'impactTitle_ASC',
  ImpactTitleDesc = 'impactTitle_DESC',
  PeopleSubtitleAsc = 'peopleSubtitle_ASC',
  PeopleSubtitleDesc = 'peopleSubtitle_DESC',
  PeopleTitleAsc = 'peopleTitle_ASC',
  PeopleTitleDesc = 'peopleTitle_DESC',
  PresidentsTitleAsc = 'presidentsTitle_ASC',
  PresidentsTitleDesc = 'presidentsTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SpaceTitleAsc = 'spaceTitle_ASC',
  SpaceTitleDesc = 'spaceTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PersonLinkingCollectionsHistoryPageCursorCollectionOrder {
  CurrentPresidentStartYearAsc = 'currentPresidentStartYear_ASC',
  CurrentPresidentStartYearDesc = 'currentPresidentStartYear_DESC',
  GrantMakingProcessCtaTextAsc = 'grantMakingProcessCtaText_ASC',
  GrantMakingProcessCtaTextDesc = 'grantMakingProcessCtaText_DESC',
  ImpactTitleAsc = 'impactTitle_ASC',
  ImpactTitleDesc = 'impactTitle_DESC',
  PeopleSubtitleAsc = 'peopleSubtitle_ASC',
  PeopleSubtitleDesc = 'peopleSubtitle_DESC',
  PeopleTitleAsc = 'peopleTitle_ASC',
  PeopleTitleDesc = 'peopleTitle_DESC',
  PresidentsTitleAsc = 'presidentsTitle_ASC',
  PresidentsTitleDesc = 'presidentsTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SpaceTitleAsc = 'spaceTitle_ASC',
  SpaceTitleDesc = 'spaceTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PersonLinkingCollectionsPeoplePageCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TrusteesCtaLabelAsc = 'trusteesCtaLabel_ASC',
  TrusteesCtaLabelDesc = 'trusteesCtaLabel_DESC',
  TrusteesCtaTextAsc = 'trusteesCtaText_ASC',
  TrusteesCtaTextDesc = 'trusteesCtaText_DESC'
}

export enum PersonLinkingCollectionsPeoplePageCursorCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TrusteesCtaLabelAsc = 'trusteesCtaLabel_ASC',
  TrusteesCtaLabelDesc = 'trusteesCtaLabel_DESC',
  TrusteesCtaTextAsc = 'trusteesCtaText_ASC',
  TrusteesCtaTextDesc = 'trusteesCtaText_DESC'
}

export enum PersonOrder {
  FirstNameAsc = 'firstName_ASC',
  FirstNameDesc = 'firstName_DESC',
  JobTitleAsc = 'jobTitle_ASC',
  JobTitleDesc = 'jobTitle_DESC',
  LastNameAsc = 'lastName_ASC',
  LastNameDesc = 'lastName_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  RelatedSectionTitleAsc = 'relatedSectionTitle_ASC',
  RelatedSectionTitleDesc = 'relatedSectionTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type PersonQuickLinksCollection = {
  __typename: 'PersonQuickLinksCollection';
  items: Array<Maybe<ConnectWithLink>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum PersonQuickLinksCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type PersonQuickLinksCursorCollection = {
  __typename: 'PersonQuickLinksCursorCollection';
  items: Array<Maybe<ConnectWithLink>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum PersonQuickLinksCursorCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type PersonRelatedNewsCollection = {
  __typename: 'PersonRelatedNewsCollection';
  items: Array<Maybe<PersonRelatedNewsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PersonRelatedNewsCursorCollection = {
  __typename: 'PersonRelatedNewsCursorCollection';
  items: Array<Maybe<PersonRelatedNewsItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PersonRelatedNewsFilter = {
  AND: InputMaybe<Array<InputMaybe<PersonRelatedNewsFilter>>>;
  OR: InputMaybe<Array<InputMaybe<PersonRelatedNewsFilter>>>;
  audio_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  date: InputMaybe<Scalars['DateTime']['input']>;
  date_exists: InputMaybe<Scalars['Boolean']['input']>;
  date_gt: InputMaybe<Scalars['DateTime']['input']>;
  date_gte: InputMaybe<Scalars['DateTime']['input']>;
  date_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_lt: InputMaybe<Scalars['DateTime']['input']>;
  date_lte: InputMaybe<Scalars['DateTime']['input']>;
  date_not: InputMaybe<Scalars['DateTime']['input']>;
  date_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  person_exists: InputMaybe<Scalars['Boolean']['input']>;
  quickLinks_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type PersonRelatedNewsItem = AnnualReport | Article;

export type PersonSpotlight = SpotlightSlideshow | SpotlightVideo;

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/presidentialQuoteCallOut) */
export type PresidentialQuoteCallOut = Entry & _Node & {
  __typename: 'PresidentialQuoteCallOut';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  grantmakingAreasCollection: Maybe<PresidentialQuoteCallOutGrantmakingAreasCollection>;
  grantmakingAreasCursorCollection: Maybe<PresidentialQuoteCallOutGrantmakingAreasCursorCollection>;
  linkedFrom: Maybe<PresidentialQuoteCallOutLinkingCollections>;
  presidentialCtaText: Maybe<Scalars['String']['output']>;
  presidentialHeading: Maybe<Scalars['String']['output']>;
  presidentialText: Maybe<Scalars['String']['output']>;
  presidentialTitle: Maybe<Scalars['String']['output']>;
  quote: Maybe<Quote>;
  searchQuery: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/presidentialQuoteCallOut) */
export type PresidentialQuoteCallOutGrantmakingAreasCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PresidentialQuoteCallOutGrantmakingAreasCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantmakingAreaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/presidentialQuoteCallOut) */
export type PresidentialQuoteCallOutGrantmakingAreasCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PresidentialQuoteCallOutGrantmakingAreasCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantmakingAreaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/presidentialQuoteCallOut) */
export type PresidentialQuoteCallOutLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/presidentialQuoteCallOut) */
export type PresidentialQuoteCallOutPresidentialCtaTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/presidentialQuoteCallOut) */
export type PresidentialQuoteCallOutPresidentialHeadingArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/presidentialQuoteCallOut) */
export type PresidentialQuoteCallOutPresidentialTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/presidentialQuoteCallOut) */
export type PresidentialQuoteCallOutPresidentialTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/presidentialQuoteCallOut) */
export type PresidentialQuoteCallOutQuoteArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<QuoteFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/presidentialQuoteCallOut) */
export type PresidentialQuoteCallOutSearchQueryArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/presidentialQuoteCallOut) */
export type PresidentialQuoteCallOutTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type PresidentialQuoteCallOutCollection = {
  __typename: 'PresidentialQuoteCallOutCollection';
  items: Array<Maybe<PresidentialQuoteCallOut>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PresidentialQuoteCallOutCursorCollection = {
  __typename: 'PresidentialQuoteCallOutCursorCollection';
  items: Array<Maybe<PresidentialQuoteCallOut>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PresidentialQuoteCallOutFilter = {
  AND: InputMaybe<Array<InputMaybe<PresidentialQuoteCallOutFilter>>>;
  OR: InputMaybe<Array<InputMaybe<PresidentialQuoteCallOutFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  grantmakingAreas: InputMaybe<CfGrantmakingAreaNestedFilter>;
  grantmakingAreasCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  presidentialCtaText: InputMaybe<Scalars['String']['input']>;
  presidentialCtaText_contains: InputMaybe<Scalars['String']['input']>;
  presidentialCtaText_exists: InputMaybe<Scalars['Boolean']['input']>;
  presidentialCtaText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  presidentialCtaText_not: InputMaybe<Scalars['String']['input']>;
  presidentialCtaText_not_contains: InputMaybe<Scalars['String']['input']>;
  presidentialCtaText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  presidentialHeading: InputMaybe<Scalars['String']['input']>;
  presidentialHeading_contains: InputMaybe<Scalars['String']['input']>;
  presidentialHeading_exists: InputMaybe<Scalars['Boolean']['input']>;
  presidentialHeading_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  presidentialHeading_not: InputMaybe<Scalars['String']['input']>;
  presidentialHeading_not_contains: InputMaybe<Scalars['String']['input']>;
  presidentialHeading_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  presidentialText: InputMaybe<Scalars['String']['input']>;
  presidentialText_contains: InputMaybe<Scalars['String']['input']>;
  presidentialText_exists: InputMaybe<Scalars['Boolean']['input']>;
  presidentialText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  presidentialText_not: InputMaybe<Scalars['String']['input']>;
  presidentialText_not_contains: InputMaybe<Scalars['String']['input']>;
  presidentialText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  presidentialTitle: InputMaybe<Scalars['String']['input']>;
  presidentialTitle_contains: InputMaybe<Scalars['String']['input']>;
  presidentialTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  presidentialTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  presidentialTitle_not: InputMaybe<Scalars['String']['input']>;
  presidentialTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  presidentialTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quote: InputMaybe<CfQuoteNestedFilter>;
  quote_exists: InputMaybe<Scalars['Boolean']['input']>;
  searchQuery: InputMaybe<Scalars['String']['input']>;
  searchQuery_contains: InputMaybe<Scalars['String']['input']>;
  searchQuery_exists: InputMaybe<Scalars['Boolean']['input']>;
  searchQuery_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchQuery_not: InputMaybe<Scalars['String']['input']>;
  searchQuery_not_contains: InputMaybe<Scalars['String']['input']>;
  searchQuery_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PresidentialQuoteCallOutGrantmakingAreasCollection = {
  __typename: 'PresidentialQuoteCallOutGrantmakingAreasCollection';
  items: Array<Maybe<GrantmakingArea>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum PresidentialQuoteCallOutGrantmakingAreasCollectionOrder {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TaglineAsc = 'tagline_ASC',
  TaglineDesc = 'tagline_DESC'
}

export type PresidentialQuoteCallOutGrantmakingAreasCursorCollection = {
  __typename: 'PresidentialQuoteCallOutGrantmakingAreasCursorCollection';
  items: Array<Maybe<GrantmakingArea>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum PresidentialQuoteCallOutGrantmakingAreasCursorCollectionOrder {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TaglineAsc = 'tagline_ASC',
  TaglineDesc = 'tagline_DESC'
}

export type PresidentialQuoteCallOutLinkingCollections = {
  __typename: 'PresidentialQuoteCallOutLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type PresidentialQuoteCallOutLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type PresidentialQuoteCallOutLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PresidentialQuoteCallOutOrder {
  PresidentialCtaTextAsc = 'presidentialCtaText_ASC',
  PresidentialCtaTextDesc = 'presidentialCtaText_DESC',
  PresidentialHeadingAsc = 'presidentialHeading_ASC',
  PresidentialHeadingDesc = 'presidentialHeading_DESC',
  PresidentialTextAsc = 'presidentialText_ASC',
  PresidentialTextDesc = 'presidentialText_DESC',
  PresidentialTitleAsc = 'presidentialTitle_ASC',
  PresidentialTitleDesc = 'presidentialTitle_DESC',
  SearchQueryAsc = 'searchQuery_ASC',
  SearchQueryDesc = 'searchQuery_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/pressRoom) */
export type PressRoom = Entry & _Node & {
  __typename: 'PressRoom';
  _id: Scalars['ID']['output'];
  atGlanceCardsCollection: Maybe<PressRoomAtGlanceCardsCollection>;
  atGlanceCardsCursorCollection: Maybe<PressRoomAtGlanceCardsCursorCollection>;
  brandGuidelinesAndMediaAssetsLinksCollection: Maybe<PressRoomBrandGuidelinesAndMediaAssetsLinksCollection>;
  brandGuidelinesAndMediaAssetsLinksCursorCollection: Maybe<PressRoomBrandGuidelinesAndMediaAssetsLinksCursorCollection>;
  contactPersonsCollection: Maybe<PressRoomContactPersonsCollection>;
  contactPersonsCursorCollection: Maybe<PressRoomContactPersonsCursorCollection>;
  contactsTitle: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  description: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  emailLabel: Maybe<Scalars['String']['output']>;
  factSheetLink: Maybe<Asset>;
  guidelinesAndMediasDescription: Maybe<Scalars['String']['output']>;
  guidelinesAndMediasHeading: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<PressRoomLinkingCollections>;
  newsContentCollection: Maybe<PressRoomNewsContentCollection>;
  newsContentCursorCollection: Maybe<PressRoomNewsContentCursorCollection>;
  quickLinks: Maybe<ConnectWith>;
  slug: Maybe<Scalars['String']['output']>;
  spotlight: Maybe<PressRoomSpotlight>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/pressRoom) */
export type PressRoomAtGlanceCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PressRoomAtGlanceCardsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<AtGlanceCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/pressRoom) */
export type PressRoomAtGlanceCardsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PressRoomAtGlanceCardsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<AtGlanceCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/pressRoom) */
export type PressRoomBrandGuidelinesAndMediaAssetsLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PressRoomBrandGuidelinesAndMediaAssetsLinksCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ConnectWithLinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/pressRoom) */
export type PressRoomBrandGuidelinesAndMediaAssetsLinksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PressRoomBrandGuidelinesAndMediaAssetsLinksCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ConnectWithLinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/pressRoom) */
export type PressRoomContactPersonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PressRoomContactPersonsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ContactPersonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/pressRoom) */
export type PressRoomContactPersonsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PressRoomContactPersonsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ContactPersonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/pressRoom) */
export type PressRoomContactsTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/pressRoom) */
export type PressRoomDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/pressRoom) */
export type PressRoomEmailArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/pressRoom) */
export type PressRoomEmailLabelArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/pressRoom) */
export type PressRoomFactSheetLinkArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/pressRoom) */
export type PressRoomGuidelinesAndMediasDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/pressRoom) */
export type PressRoomGuidelinesAndMediasHeadingArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/pressRoom) */
export type PressRoomLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/pressRoom) */
export type PressRoomNewsContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PressRoomNewsContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/pressRoom) */
export type PressRoomNewsContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PressRoomNewsContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/pressRoom) */
export type PressRoomQuickLinksArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ConnectWithFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/pressRoom) */
export type PressRoomSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/pressRoom) */
export type PressRoomSpotlightArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/pressRoom) */
export type PressRoomTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type PressRoomAtGlanceCardsCollection = {
  __typename: 'PressRoomAtGlanceCardsCollection';
  items: Array<Maybe<AtGlanceCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum PressRoomAtGlanceCardsCollectionOrder {
  BodyTextAsc = 'bodyText_ASC',
  BodyTextDesc = 'bodyText_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export type PressRoomAtGlanceCardsCursorCollection = {
  __typename: 'PressRoomAtGlanceCardsCursorCollection';
  items: Array<Maybe<AtGlanceCard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum PressRoomAtGlanceCardsCursorCollectionOrder {
  BodyTextAsc = 'bodyText_ASC',
  BodyTextDesc = 'bodyText_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export type PressRoomBrandGuidelinesAndMediaAssetsLinksCollection = {
  __typename: 'PressRoomBrandGuidelinesAndMediaAssetsLinksCollection';
  items: Array<Maybe<ConnectWithLink>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum PressRoomBrandGuidelinesAndMediaAssetsLinksCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type PressRoomBrandGuidelinesAndMediaAssetsLinksCursorCollection = {
  __typename: 'PressRoomBrandGuidelinesAndMediaAssetsLinksCursorCollection';
  items: Array<Maybe<ConnectWithLink>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum PressRoomBrandGuidelinesAndMediaAssetsLinksCursorCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type PressRoomCollection = {
  __typename: 'PressRoomCollection';
  items: Array<Maybe<PressRoom>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PressRoomContactPersonsCollection = {
  __typename: 'PressRoomContactPersonsCollection';
  items: Array<Maybe<ContactPerson>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum PressRoomContactPersonsCollectionOrder {
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PhoneAsc = 'phone_ASC',
  PhoneDesc = 'phone_DESC',
  RoleAsc = 'role_ASC',
  RoleDesc = 'role_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type PressRoomContactPersonsCursorCollection = {
  __typename: 'PressRoomContactPersonsCursorCollection';
  items: Array<Maybe<ContactPerson>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum PressRoomContactPersonsCursorCollectionOrder {
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PhoneAsc = 'phone_ASC',
  PhoneDesc = 'phone_DESC',
  RoleAsc = 'role_ASC',
  RoleDesc = 'role_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type PressRoomCursorCollection = {
  __typename: 'PressRoomCursorCollection';
  items: Array<Maybe<PressRoom>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PressRoomFilter = {
  AND: InputMaybe<Array<InputMaybe<PressRoomFilter>>>;
  OR: InputMaybe<Array<InputMaybe<PressRoomFilter>>>;
  atGlanceCards: InputMaybe<CfAtGlanceCardNestedFilter>;
  atGlanceCardsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  brandGuidelinesAndMediaAssetsLinks: InputMaybe<CfConnectWithLinkNestedFilter>;
  brandGuidelinesAndMediaAssetsLinksCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contactPersons: InputMaybe<CfContactPersonNestedFilter>;
  contactPersonsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contactsTitle: InputMaybe<Scalars['String']['input']>;
  contactsTitle_contains: InputMaybe<Scalars['String']['input']>;
  contactsTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  contactsTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactsTitle_not: InputMaybe<Scalars['String']['input']>;
  contactsTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  contactsTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email: InputMaybe<Scalars['String']['input']>;
  emailLabel: InputMaybe<Scalars['String']['input']>;
  emailLabel_contains: InputMaybe<Scalars['String']['input']>;
  emailLabel_exists: InputMaybe<Scalars['Boolean']['input']>;
  emailLabel_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  emailLabel_not: InputMaybe<Scalars['String']['input']>;
  emailLabel_not_contains: InputMaybe<Scalars['String']['input']>;
  emailLabel_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email_contains: InputMaybe<Scalars['String']['input']>;
  email_exists: InputMaybe<Scalars['Boolean']['input']>;
  email_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email_not: InputMaybe<Scalars['String']['input']>;
  email_not_contains: InputMaybe<Scalars['String']['input']>;
  email_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  factSheetLink_exists: InputMaybe<Scalars['Boolean']['input']>;
  guidelinesAndMediasDescription: InputMaybe<Scalars['String']['input']>;
  guidelinesAndMediasDescription_contains: InputMaybe<Scalars['String']['input']>;
  guidelinesAndMediasDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  guidelinesAndMediasDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  guidelinesAndMediasDescription_not: InputMaybe<Scalars['String']['input']>;
  guidelinesAndMediasDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  guidelinesAndMediasDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  guidelinesAndMediasHeading: InputMaybe<Scalars['String']['input']>;
  guidelinesAndMediasHeading_contains: InputMaybe<Scalars['String']['input']>;
  guidelinesAndMediasHeading_exists: InputMaybe<Scalars['Boolean']['input']>;
  guidelinesAndMediasHeading_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  guidelinesAndMediasHeading_not: InputMaybe<Scalars['String']['input']>;
  guidelinesAndMediasHeading_not_contains: InputMaybe<Scalars['String']['input']>;
  guidelinesAndMediasHeading_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  newsContent: InputMaybe<CfnewsContentMultiTypeNestedFilter>;
  newsContentCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  quickLinks: InputMaybe<CfConnectWithNestedFilter>;
  quickLinks_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  spotlight_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PressRoomLinkingCollections = {
  __typename: 'PressRoomLinkingCollections';
  connectWithLinkCollection: Maybe<ConnectWithLinkCollection>;
  connectWithLinkCursorCollection: Maybe<ConnectWithLinkCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type PressRoomLinkingCollectionsConnectWithLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PressRoomLinkingCollectionsConnectWithLinkCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type PressRoomLinkingCollectionsConnectWithLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PressRoomLinkingCollectionsConnectWithLinkCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type PressRoomLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type PressRoomLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PressRoomLinkingCollectionsConnectWithLinkCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PressRoomLinkingCollectionsConnectWithLinkCursorCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type PressRoomNewsContentCollection = {
  __typename: 'PressRoomNewsContentCollection';
  items: Array<Maybe<PressRoomNewsContentItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PressRoomNewsContentCursorCollection = {
  __typename: 'PressRoomNewsContentCursorCollection';
  items: Array<Maybe<PressRoomNewsContentItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PressRoomNewsContentFilter = {
  AND: InputMaybe<Array<InputMaybe<PressRoomNewsContentFilter>>>;
  OR: InputMaybe<Array<InputMaybe<PressRoomNewsContentFilter>>>;
  audio_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  date: InputMaybe<Scalars['DateTime']['input']>;
  date_exists: InputMaybe<Scalars['Boolean']['input']>;
  date_gt: InputMaybe<Scalars['DateTime']['input']>;
  date_gte: InputMaybe<Scalars['DateTime']['input']>;
  date_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_lt: InputMaybe<Scalars['DateTime']['input']>;
  date_lte: InputMaybe<Scalars['DateTime']['input']>;
  date_not: InputMaybe<Scalars['DateTime']['input']>;
  date_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  person_exists: InputMaybe<Scalars['Boolean']['input']>;
  quickLinks_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type PressRoomNewsContentItem = AnnualReport | Article;

export enum PressRoomOrder {
  ContactsTitleAsc = 'contactsTitle_ASC',
  ContactsTitleDesc = 'contactsTitle_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  EmailLabelAsc = 'emailLabel_ASC',
  EmailLabelDesc = 'emailLabel_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  GuidelinesAndMediasDescriptionAsc = 'guidelinesAndMediasDescription_ASC',
  GuidelinesAndMediasDescriptionDesc = 'guidelinesAndMediasDescription_DESC',
  GuidelinesAndMediasHeadingAsc = 'guidelinesAndMediasHeading_ASC',
  GuidelinesAndMediasHeadingDesc = 'guidelinesAndMediasHeading_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type PressRoomSpotlight = SpotlightSlideshow | SpotlightVideo;

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/privacyPolicy) */
export type PrivacyPolicy = Entry & _Node & {
  __typename: 'PrivacyPolicy';
  _id: Scalars['ID']['output'];
  addressDetails: Maybe<Scalars['String']['output']>;
  body: Maybe<Scalars['String']['output']>;
  contactDetails: Maybe<Scalars['String']['output']>;
  contactDetailsEmail: Maybe<Scalars['String']['output']>;
  contactDetailsParagraph: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  description: Maybe<Scalars['String']['output']>;
  lastRevisedDate: Maybe<Scalars['DateTime']['output']>;
  linkedFrom: Maybe<PrivacyPolicyLinkingCollections>;
  slug: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/privacyPolicy) */
export type PrivacyPolicyAddressDetailsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/privacyPolicy) */
export type PrivacyPolicyBodyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/privacyPolicy) */
export type PrivacyPolicyContactDetailsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/privacyPolicy) */
export type PrivacyPolicyContactDetailsEmailArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/privacyPolicy) */
export type PrivacyPolicyContactDetailsParagraphArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/privacyPolicy) */
export type PrivacyPolicyDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/privacyPolicy) */
export type PrivacyPolicyLastRevisedDateArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/privacyPolicy) */
export type PrivacyPolicyLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/privacyPolicy) */
export type PrivacyPolicySlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/privacyPolicy) */
export type PrivacyPolicyTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type PrivacyPolicyCollection = {
  __typename: 'PrivacyPolicyCollection';
  items: Array<Maybe<PrivacyPolicy>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PrivacyPolicyCursorCollection = {
  __typename: 'PrivacyPolicyCursorCollection';
  items: Array<Maybe<PrivacyPolicy>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PrivacyPolicyFilter = {
  AND: InputMaybe<Array<InputMaybe<PrivacyPolicyFilter>>>;
  OR: InputMaybe<Array<InputMaybe<PrivacyPolicyFilter>>>;
  addressDetails: InputMaybe<Scalars['String']['input']>;
  addressDetails_contains: InputMaybe<Scalars['String']['input']>;
  addressDetails_exists: InputMaybe<Scalars['Boolean']['input']>;
  addressDetails_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  addressDetails_not: InputMaybe<Scalars['String']['input']>;
  addressDetails_not_contains: InputMaybe<Scalars['String']['input']>;
  addressDetails_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body: InputMaybe<Scalars['String']['input']>;
  body_contains: InputMaybe<Scalars['String']['input']>;
  body_exists: InputMaybe<Scalars['Boolean']['input']>;
  body_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_not: InputMaybe<Scalars['String']['input']>;
  body_not_contains: InputMaybe<Scalars['String']['input']>;
  body_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactDetails: InputMaybe<Scalars['String']['input']>;
  contactDetailsEmail: InputMaybe<Scalars['String']['input']>;
  contactDetailsEmail_contains: InputMaybe<Scalars['String']['input']>;
  contactDetailsEmail_exists: InputMaybe<Scalars['Boolean']['input']>;
  contactDetailsEmail_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactDetailsEmail_not: InputMaybe<Scalars['String']['input']>;
  contactDetailsEmail_not_contains: InputMaybe<Scalars['String']['input']>;
  contactDetailsEmail_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactDetailsParagraph: InputMaybe<Scalars['String']['input']>;
  contactDetailsParagraph_contains: InputMaybe<Scalars['String']['input']>;
  contactDetailsParagraph_exists: InputMaybe<Scalars['Boolean']['input']>;
  contactDetailsParagraph_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactDetailsParagraph_not: InputMaybe<Scalars['String']['input']>;
  contactDetailsParagraph_not_contains: InputMaybe<Scalars['String']['input']>;
  contactDetailsParagraph_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactDetails_contains: InputMaybe<Scalars['String']['input']>;
  contactDetails_exists: InputMaybe<Scalars['Boolean']['input']>;
  contactDetails_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactDetails_not: InputMaybe<Scalars['String']['input']>;
  contactDetails_not_contains: InputMaybe<Scalars['String']['input']>;
  contactDetails_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastRevisedDate: InputMaybe<Scalars['DateTime']['input']>;
  lastRevisedDate_exists: InputMaybe<Scalars['Boolean']['input']>;
  lastRevisedDate_gt: InputMaybe<Scalars['DateTime']['input']>;
  lastRevisedDate_gte: InputMaybe<Scalars['DateTime']['input']>;
  lastRevisedDate_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastRevisedDate_lt: InputMaybe<Scalars['DateTime']['input']>;
  lastRevisedDate_lte: InputMaybe<Scalars['DateTime']['input']>;
  lastRevisedDate_not: InputMaybe<Scalars['DateTime']['input']>;
  lastRevisedDate_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PrivacyPolicyLinkingCollections = {
  __typename: 'PrivacyPolicyLinkingCollections';
  connectWithLinkCollection: Maybe<ConnectWithLinkCollection>;
  connectWithLinkCursorCollection: Maybe<ConnectWithLinkCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type PrivacyPolicyLinkingCollectionsConnectWithLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PrivacyPolicyLinkingCollectionsConnectWithLinkCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type PrivacyPolicyLinkingCollectionsConnectWithLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PrivacyPolicyLinkingCollectionsConnectWithLinkCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type PrivacyPolicyLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type PrivacyPolicyLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PrivacyPolicyLinkingCollectionsConnectWithLinkCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PrivacyPolicyLinkingCollectionsConnectWithLinkCursorCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PrivacyPolicyOrder {
  ContactDetailsEmailAsc = 'contactDetailsEmail_ASC',
  ContactDetailsEmailDesc = 'contactDetailsEmail_DESC',
  ContactDetailsAsc = 'contactDetails_ASC',
  ContactDetailsDesc = 'contactDetails_DESC',
  LastRevisedDateAsc = 'lastRevisedDate_ASC',
  LastRevisedDateDesc = 'lastRevisedDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type Query = {
  __typename: 'Query';
  _node: Maybe<_Node>;
  _nodes: Array<Maybe<_Node>>;
  annualReport: Maybe<AnnualReport>;
  annualReportCollection: Maybe<AnnualReportCollection>;
  annualReportCursorCollection: Maybe<AnnualReportCursorCollection>;
  article: Maybe<Article>;
  articleCollection: Maybe<ArticleCollection>;
  articleCursorCollection: Maybe<ArticleCursorCollection>;
  asset: Maybe<Asset>;
  assetCollection: Maybe<AssetCollection>;
  assetCursorCollection: Maybe<AssetCursorCollection>;
  atGlanceCard: Maybe<AtGlanceCard>;
  atGlanceCardCollection: Maybe<AtGlanceCardCollection>;
  atGlanceCardCursorCollection: Maybe<AtGlanceCardCursorCollection>;
  callForConcept: Maybe<CallForConcept>;
  callForConceptCollection: Maybe<CallForConceptCollection>;
  callForConceptCursorCollection: Maybe<CallForConceptCursorCollection>;
  connectWith: Maybe<ConnectWith>;
  connectWithCollection: Maybe<ConnectWithCollection>;
  connectWithCursorCollection: Maybe<ConnectWithCursorCollection>;
  connectWithLink: Maybe<ConnectWithLink>;
  connectWithLinkCollection: Maybe<ConnectWithLinkCollection>;
  connectWithLinkCursorCollection: Maybe<ConnectWithLinkCursorCollection>;
  contact: Maybe<Contact>;
  contactCollection: Maybe<ContactCollection>;
  contactCursorCollection: Maybe<ContactCursorCollection>;
  contactPerson: Maybe<ContactPerson>;
  contactPersonCollection: Maybe<ContactPersonCollection>;
  contactPersonCursorCollection: Maybe<ContactPersonCursorCollection>;
  department: Maybe<Department>;
  departmentCollection: Maybe<DepartmentCollection>;
  departmentCursorCollection: Maybe<DepartmentCursorCollection>;
  dropCap: Maybe<DropCap>;
  dropCapCollection: Maybe<DropCapCollection>;
  dropCapCursorCollection: Maybe<DropCapCursorCollection>;
  emphasizedArticle: Maybe<EmphasizedArticle>;
  emphasizedArticleCollection: Maybe<EmphasizedArticleCollection>;
  emphasizedArticleCursorCollection: Maybe<EmphasizedArticleCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  eventsPage: Maybe<EventsPage>;
  eventsPageCollection: Maybe<EventsPageCollection>;
  eventsPageCursorCollection: Maybe<EventsPageCursorCollection>;
  experienceBlock: Maybe<ExperienceBlock>;
  experienceBlockCollection: Maybe<ExperienceBlockCollection>;
  experienceBlockCursorCollection: Maybe<ExperienceBlockCursorCollection>;
  explicitValueFilter: Maybe<ExplicitValueFilter>;
  explicitValueFilterCollection: Maybe<ExplicitValueFilterCollection>;
  explicitValueFilterCursorCollection: Maybe<ExplicitValueFilterCursorCollection>;
  externalEvent: Maybe<ExternalEvent>;
  externalEventCollection: Maybe<ExternalEventCollection>;
  externalEventCursorCollection: Maybe<ExternalEventCursorCollection>;
  externalPerson: Maybe<ExternalPerson>;
  externalPersonCollection: Maybe<ExternalPersonCollection>;
  externalPersonCursorCollection: Maybe<ExternalPersonCursorCollection>;
  faq: Maybe<Faq>;
  faqCollection: Maybe<FaqCollection>;
  faqCursorCollection: Maybe<FaqCursorCollection>;
  faqsModule: Maybe<FaqsModule>;
  faqsModuleCollection: Maybe<FaqsModuleCollection>;
  faqsModuleCursorCollection: Maybe<FaqsModuleCursorCollection>;
  feature: Maybe<Feature>;
  featureCollection: Maybe<FeatureCollection>;
  featureCursorCollection: Maybe<FeatureCursorCollection>;
  financialsPage: Maybe<FinancialsPage>;
  financialsPageCollection: Maybe<FinancialsPageCollection>;
  financialsPageCursorCollection: Maybe<FinancialsPageCursorCollection>;
  footer: Maybe<Footer>;
  footerCollection: Maybe<FooterCollection>;
  footerCursorCollection: Maybe<FooterCursorCollection>;
  grant: Maybe<Grant>;
  grantActivityArticle: Maybe<GrantActivityArticle>;
  grantActivityArticleCollection: Maybe<GrantActivityArticleCollection>;
  grantActivityArticleCursorCollection: Maybe<GrantActivityArticleCursorCollection>;
  grantCollection: Maybe<GrantCollection>;
  grantCursorCollection: Maybe<GrantCursorCollection>;
  grantDetailsPage: Maybe<GrantDetailsPage>;
  grantDetailsPageCollection: Maybe<GrantDetailsPageCollection>;
  grantDetailsPageCursorCollection: Maybe<GrantDetailsPageCursorCollection>;
  grantResources: Maybe<GrantResources>;
  grantResourcesCollection: Maybe<GrantResourcesCollection>;
  grantResourcesCursorCollection: Maybe<GrantResourcesCursorCollection>;
  grantSearchFilters: Maybe<GrantSearchFilters>;
  grantSearchFiltersCollection: Maybe<GrantSearchFiltersCollection>;
  grantSearchFiltersCursorCollection: Maybe<GrantSearchFiltersCursorCollection>;
  grantmakingArea: Maybe<GrantmakingArea>;
  grantmakingAreaCollection: Maybe<GrantmakingAreaCollection>;
  grantmakingAreaCursorCollection: Maybe<GrantmakingAreaCursorCollection>;
  grantmakingAreaDetailsPage: Maybe<GrantmakingAreaDetailsPage>;
  grantmakingAreaDetailsPageCollection: Maybe<GrantmakingAreaDetailsPageCollection>;
  grantmakingAreaDetailsPageCursorCollection: Maybe<GrantmakingAreaDetailsPageCursorCollection>;
  grantmakingAreasPage: Maybe<GrantmakingAreasPage>;
  grantmakingAreasPageCollection: Maybe<GrantmakingAreasPageCollection>;
  grantmakingAreasPageCursorCollection: Maybe<GrantmakingAreasPageCursorCollection>;
  heroAsset: Maybe<HeroAsset>;
  heroAssetCollection: Maybe<HeroAssetCollection>;
  heroAssetCursorCollection: Maybe<HeroAssetCursorCollection>;
  historyPage: Maybe<HistoryPage>;
  historyPageCollection: Maybe<HistoryPageCollection>;
  historyPageCursorCollection: Maybe<HistoryPageCursorCollection>;
  historyPerson: Maybe<HistoryPerson>;
  historyPersonCollection: Maybe<HistoryPersonCollection>;
  historyPersonCursorCollection: Maybe<HistoryPersonCursorCollection>;
  homePage: Maybe<HomePage>;
  homePageCollection: Maybe<HomePageCollection>;
  homePageCursorCollection: Maybe<HomePageCursorCollection>;
  idea: Maybe<Idea>;
  ideaCollection: Maybe<IdeaCollection>;
  ideaCursorCollection: Maybe<IdeaCursorCollection>;
  initiativeQuoteCallOut: Maybe<InitiativeQuoteCallOut>;
  initiativeQuoteCallOutCollection: Maybe<InitiativeQuoteCallOutCollection>;
  initiativeQuoteCallOutCursorCollection: Maybe<InitiativeQuoteCallOutCursorCollection>;
  inlineCards: Maybe<InlineCards>;
  inlineCardsCollection: Maybe<InlineCardsCollection>;
  inlineCardsCursorCollection: Maybe<InlineCardsCursorCollection>;
  inlineImages: Maybe<InlineImages>;
  inlineImagesCollection: Maybe<InlineImagesCollection>;
  inlineImagesCursorCollection: Maybe<InlineImagesCursorCollection>;
  mainNavigation: Maybe<MainNavigation>;
  mainNavigationCollection: Maybe<MainNavigationCollection>;
  mainNavigationCursorCollection: Maybe<MainNavigationCursorCollection>;
  metadata: Maybe<Metadata>;
  metadataCollection: Maybe<MetadataCollection>;
  metadataCursorCollection: Maybe<MetadataCursorCollection>;
  missionPage: Maybe<MissionPage>;
  missionPageCollection: Maybe<MissionPageCollection>;
  missionPageCursorCollection: Maybe<MissionPageCursorCollection>;
  mmuf: Maybe<Mmuf>;
  mmufCollection: Maybe<MmufCollection>;
  mmufCursorCollection: Maybe<MmufCursorCollection>;
  navigationItem: Maybe<NavigationItem>;
  navigationItemCollection: Maybe<NavigationItemCollection>;
  navigationItemCursorCollection: Maybe<NavigationItemCursorCollection>;
  newsPage: Maybe<NewsPage>;
  newsPageCollection: Maybe<NewsPageCollection>;
  newsPageCursorCollection: Maybe<NewsPageCursorCollection>;
  newsletterCard: Maybe<NewsletterCard>;
  newsletterCardCollection: Maybe<NewsletterCardCollection>;
  newsletterCardCursorCollection: Maybe<NewsletterCardCursorCollection>;
  newsletterConfirmPage: Maybe<NewsletterConfirmPage>;
  newsletterConfirmPageCollection: Maybe<NewsletterConfirmPageCollection>;
  newsletterConfirmPageCursorCollection: Maybe<NewsletterConfirmPageCursorCollection>;
  newsletterPage: Maybe<NewsletterPage>;
  newsletterPageCollection: Maybe<NewsletterPageCollection>;
  newsletterPageCursorCollection: Maybe<NewsletterPageCursorCollection>;
  oldAnnualReport: Maybe<OldAnnualReport>;
  oldAnnualReportCollection: Maybe<OldAnnualReportCollection>;
  oldAnnualReportCursorCollection: Maybe<OldAnnualReportCursorCollection>;
  organisation: Maybe<Organisation>;
  organisationCollection: Maybe<OrganisationCollection>;
  organisationCursorCollection: Maybe<OrganisationCursorCollection>;
  parallaxImages: Maybe<ParallaxImages>;
  parallaxImagesCollection: Maybe<ParallaxImagesCollection>;
  parallaxImagesCursorCollection: Maybe<ParallaxImagesCursorCollection>;
  passwordProtectedPage: Maybe<PasswordProtectedPage>;
  passwordProtectedPageCollection: Maybe<PasswordProtectedPageCollection>;
  passwordProtectedPageCursorCollection: Maybe<PasswordProtectedPageCursorCollection>;
  peoplePage: Maybe<PeoplePage>;
  peoplePageCollection: Maybe<PeoplePageCollection>;
  peoplePageCursorCollection: Maybe<PeoplePageCursorCollection>;
  person: Maybe<Person>;
  personCollection: Maybe<PersonCollection>;
  personCursorCollection: Maybe<PersonCursorCollection>;
  presidentialQuoteCallOut: Maybe<PresidentialQuoteCallOut>;
  presidentialQuoteCallOutCollection: Maybe<PresidentialQuoteCallOutCollection>;
  presidentialQuoteCallOutCursorCollection: Maybe<PresidentialQuoteCallOutCursorCollection>;
  pressRoom: Maybe<PressRoom>;
  pressRoomCollection: Maybe<PressRoomCollection>;
  pressRoomCursorCollection: Maybe<PressRoomCursorCollection>;
  privacyPolicy: Maybe<PrivacyPolicy>;
  privacyPolicyCollection: Maybe<PrivacyPolicyCollection>;
  privacyPolicyCursorCollection: Maybe<PrivacyPolicyCursorCollection>;
  quickLink: Maybe<QuickLink>;
  quickLinkCollection: Maybe<QuickLinkCollection>;
  quickLinkCursorCollection: Maybe<QuickLinkCursorCollection>;
  quote: Maybe<Quote>;
  quoteCollection: Maybe<QuoteCollection>;
  quoteCursorCollection: Maybe<QuoteCursorCollection>;
  rangeValueFilter: Maybe<RangeValueFilter>;
  rangeValueFilterCollection: Maybe<RangeValueFilterCollection>;
  rangeValueFilterCursorCollection: Maybe<RangeValueFilterCursorCollection>;
  resourcesCurrentGrantees: Maybe<ResourcesCurrentGrantees>;
  resourcesCurrentGranteesCollection: Maybe<ResourcesCurrentGranteesCollection>;
  resourcesCurrentGranteesCursorCollection: Maybe<ResourcesCurrentGranteesCursorCollection>;
  resourcesProspectiveGrantees: Maybe<ResourcesProspectiveGrantees>;
  resourcesProspectiveGranteesCollection: Maybe<ResourcesProspectiveGranteesCollection>;
  resourcesProspectiveGranteesCursorCollection: Maybe<ResourcesProspectiveGranteesCursorCollection>;
  rootPage: Maybe<RootPage>;
  rootPageCollection: Maybe<RootPageCollection>;
  rootPageCursorCollection: Maybe<RootPageCursorCollection>;
  searchPage: Maybe<SearchPage>;
  searchPageCollection: Maybe<SearchPageCollection>;
  searchPageCursorCollection: Maybe<SearchPageCursorCollection>;
  spotlightSlideshow: Maybe<SpotlightSlideshow>;
  spotlightSlideshowCollection: Maybe<SpotlightSlideshowCollection>;
  spotlightSlideshowCursorCollection: Maybe<SpotlightSlideshowCursorCollection>;
  spotlightVideo: Maybe<SpotlightVideo>;
  spotlightVideoCollection: Maybe<SpotlightVideoCollection>;
  spotlightVideoCursorCollection: Maybe<SpotlightVideoCursorCollection>;
  storiesPage: Maybe<StoriesPage>;
  storiesPageCollection: Maybe<StoriesPageCollection>;
  storiesPageCursorCollection: Maybe<StoriesPageCursorCollection>;
  taxonomy: Maybe<Taxonomy>;
  taxonomyCollection: Maybe<TaxonomyCollection>;
  taxonomyCursorCollection: Maybe<TaxonomyCursorCollection>;
  termsOfUse: Maybe<TermsOfUse>;
  termsOfUseCollection: Maybe<TermsOfUseCollection>;
  termsOfUseCursorCollection: Maybe<TermsOfUseCursorCollection>;
  theme: Maybe<Theme>;
  themeCollection: Maybe<ThemeCollection>;
  themeCursorCollection: Maybe<ThemeCursorCollection>;
  trustee: Maybe<Trustee>;
  trusteeCollection: Maybe<TrusteeCollection>;
  trusteeCursorCollection: Maybe<TrusteeCursorCollection>;
  trusteesPage: Maybe<TrusteesPage>;
  trusteesPageCollection: Maybe<TrusteesPageCollection>;
  trusteesPageCursorCollection: Maybe<TrusteesPageCursorCollection>;
  videoNative: Maybe<VideoNative>;
  videoNativeCollection: Maybe<VideoNativeCollection>;
  videoNativeCursorCollection: Maybe<VideoNativeCursorCollection>;
  videoYoutube: Maybe<VideoYoutube>;
  videoYoutubeCollection: Maybe<VideoYoutubeCollection>;
  videoYoutubeCursorCollection: Maybe<VideoYoutubeCursorCollection>;
};


export type Query_NodeArgs = {
  id: Scalars['ID']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type Query_NodesArgs = {
  ids: Array<Scalars['ID']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAnnualReportArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAnnualReportCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<AnnualReportOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<AnnualReportFilter>;
};


export type QueryAnnualReportCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<AnnualReportOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<AnnualReportFilter>;
};


export type QueryArticleArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ArticleFilter>;
};


export type QueryArticleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ArticleOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ArticleFilter>;
};


export type QueryAssetArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAssetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<AssetOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<AssetFilter>;
};


export type QueryAssetCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<AssetOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<AssetFilter>;
};


export type QueryAtGlanceCardArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAtGlanceCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<AtGlanceCardOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<AtGlanceCardFilter>;
};


export type QueryAtGlanceCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<AtGlanceCardOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<AtGlanceCardFilter>;
};


export type QueryCallForConceptArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCallForConceptCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CallForConceptOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CallForConceptFilter>;
};


export type QueryCallForConceptCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CallForConceptOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CallForConceptFilter>;
};


export type QueryConnectWithArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryConnectWithCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ConnectWithFilter>;
};


export type QueryConnectWithCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ConnectWithFilter>;
};


export type QueryConnectWithLinkArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryConnectWithLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ConnectWithLinkFilter>;
};


export type QueryConnectWithLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ConnectWithLinkOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ConnectWithLinkFilter>;
};


export type QueryContactArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryContactCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ContactOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ContactFilter>;
};


export type QueryContactCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ContactOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ContactFilter>;
};


export type QueryContactPersonArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryContactPersonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ContactPersonOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ContactPersonFilter>;
};


export type QueryContactPersonCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ContactPersonOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ContactPersonFilter>;
};


export type QueryDepartmentArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDepartmentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<DepartmentOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<DepartmentFilter>;
};


export type QueryDepartmentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<DepartmentOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<DepartmentFilter>;
};


export type QueryDropCapArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDropCapCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<DropCapOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<DropCapFilter>;
};


export type QueryDropCapCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<DropCapOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<DropCapFilter>;
};


export type QueryEmphasizedArticleArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryEmphasizedArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<EmphasizedArticleOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<EmphasizedArticleFilter>;
};


export type QueryEmphasizedArticleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<EmphasizedArticleOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<EmphasizedArticleFilter>;
};


export type QueryEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<EntryOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<EntryFilter>;
};


export type QueryEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<EntryOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<EntryFilter>;
};


export type QueryEventsPageArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryEventsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<EventsPageOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<EventsPageFilter>;
};


export type QueryEventsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<EventsPageOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<EventsPageFilter>;
};


export type QueryExperienceBlockArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryExperienceBlockCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ExperienceBlockOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ExperienceBlockFilter>;
};


export type QueryExperienceBlockCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ExperienceBlockOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ExperienceBlockFilter>;
};


export type QueryExplicitValueFilterArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryExplicitValueFilterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ExplicitValueFilterOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ExplicitValueFilterFilter>;
};


export type QueryExplicitValueFilterCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ExplicitValueFilterOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ExplicitValueFilterFilter>;
};


export type QueryExternalEventArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryExternalEventCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ExternalEventOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ExternalEventFilter>;
};


export type QueryExternalEventCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ExternalEventOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ExternalEventFilter>;
};


export type QueryExternalPersonArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryExternalPersonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ExternalPersonOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ExternalPersonFilter>;
};


export type QueryExternalPersonCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ExternalPersonOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ExternalPersonFilter>;
};


export type QueryFaqArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFaqCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FaqOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<FaqFilter>;
};


export type QueryFaqCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FaqOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<FaqFilter>;
};


export type QueryFaqsModuleArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFaqsModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FaqsModuleOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<FaqsModuleFilter>;
};


export type QueryFaqsModuleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FaqsModuleOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<FaqsModuleFilter>;
};


export type QueryFeatureArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFeatureCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FeatureOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<FeatureFilter>;
};


export type QueryFeatureCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FeatureOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<FeatureFilter>;
};


export type QueryFinancialsPageArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFinancialsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FinancialsPageOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<FinancialsPageFilter>;
};


export type QueryFinancialsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FinancialsPageOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<FinancialsPageFilter>;
};


export type QueryFooterArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFooterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FooterOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<FooterFilter>;
};


export type QueryFooterCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<FooterOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<FooterFilter>;
};


export type QueryGrantArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGrantActivityArticleArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGrantActivityArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantActivityArticleOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantActivityArticleFilter>;
};


export type QueryGrantActivityArticleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantActivityArticleOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantActivityArticleFilter>;
};


export type QueryGrantCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantFilter>;
};


export type QueryGrantCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantFilter>;
};


export type QueryGrantDetailsPageArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGrantDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantDetailsPageOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantDetailsPageFilter>;
};


export type QueryGrantDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantDetailsPageOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantDetailsPageFilter>;
};


export type QueryGrantResourcesArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGrantResourcesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantResourcesOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantResourcesFilter>;
};


export type QueryGrantResourcesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantResourcesOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantResourcesFilter>;
};


export type QueryGrantSearchFiltersArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGrantSearchFiltersCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantSearchFiltersOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantSearchFiltersFilter>;
};


export type QueryGrantSearchFiltersCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantSearchFiltersOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantSearchFiltersFilter>;
};


export type QueryGrantmakingAreaArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGrantmakingAreaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreaOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantmakingAreaFilter>;
};


export type QueryGrantmakingAreaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreaOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantmakingAreaFilter>;
};


export type QueryGrantmakingAreaDetailsPageArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGrantmakingAreaDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreaDetailsPageOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantmakingAreaDetailsPageFilter>;
};


export type QueryGrantmakingAreaDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreaDetailsPageOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantmakingAreaDetailsPageFilter>;
};


export type QueryGrantmakingAreasPageArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGrantmakingAreasPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreasPageOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantmakingAreasPageFilter>;
};


export type QueryGrantmakingAreasPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GrantmakingAreasPageOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantmakingAreasPageFilter>;
};


export type QueryHeroAssetArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryHeroAssetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HeroAssetOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<HeroAssetFilter>;
};


export type QueryHeroAssetCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HeroAssetOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<HeroAssetFilter>;
};


export type QueryHistoryPageArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryHistoryPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HistoryPageOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<HistoryPageFilter>;
};


export type QueryHistoryPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HistoryPageOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<HistoryPageFilter>;
};


export type QueryHistoryPersonArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryHistoryPersonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HistoryPersonOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<HistoryPersonFilter>;
};


export type QueryHistoryPersonCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HistoryPersonOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<HistoryPersonFilter>;
};


export type QueryHomePageArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HomePageOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<HomePageFilter>;
};


export type QueryHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HomePageOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<HomePageFilter>;
};


export type QueryIdeaArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryIdeaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<IdeaOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<IdeaFilter>;
};


export type QueryIdeaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<IdeaOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<IdeaFilter>;
};


export type QueryInitiativeQuoteCallOutArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryInitiativeQuoteCallOutCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<InitiativeQuoteCallOutOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<InitiativeQuoteCallOutFilter>;
};


export type QueryInitiativeQuoteCallOutCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<InitiativeQuoteCallOutOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<InitiativeQuoteCallOutFilter>;
};


export type QueryInlineCardsArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryInlineCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<InlineCardsOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<InlineCardsFilter>;
};


export type QueryInlineCardsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<InlineCardsOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<InlineCardsFilter>;
};


export type QueryInlineImagesArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryInlineImagesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<InlineImagesOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<InlineImagesFilter>;
};


export type QueryInlineImagesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<InlineImagesOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<InlineImagesFilter>;
};


export type QueryMainNavigationArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMainNavigationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<MainNavigationOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<MainNavigationFilter>;
};


export type QueryMainNavigationCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<MainNavigationOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<MainNavigationFilter>;
};


export type QueryMetadataArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMetadataCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<MetadataOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<MetadataFilter>;
};


export type QueryMetadataCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<MetadataOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<MetadataFilter>;
};


export type QueryMissionPageArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMissionPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<MissionPageOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<MissionPageFilter>;
};


export type QueryMissionPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<MissionPageOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<MissionPageFilter>;
};


export type QueryMmufArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMmufCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<MmufOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<MmufFilter>;
};


export type QueryMmufCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<MmufOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<MmufFilter>;
};


export type QueryNavigationItemArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryNavigationItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<NavigationItemOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<NavigationItemFilter>;
};


export type QueryNavigationItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<NavigationItemOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<NavigationItemFilter>;
};


export type QueryNewsPageArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryNewsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<NewsPageOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<NewsPageFilter>;
};


export type QueryNewsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<NewsPageOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<NewsPageFilter>;
};


export type QueryNewsletterCardArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryNewsletterCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<NewsletterCardOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<NewsletterCardFilter>;
};


export type QueryNewsletterCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<NewsletterCardOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<NewsletterCardFilter>;
};


export type QueryNewsletterConfirmPageArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryNewsletterConfirmPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<NewsletterConfirmPageOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<NewsletterConfirmPageFilter>;
};


export type QueryNewsletterConfirmPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<NewsletterConfirmPageOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<NewsletterConfirmPageFilter>;
};


export type QueryNewsletterPageArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryNewsletterPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<NewsletterPageOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<NewsletterPageFilter>;
};


export type QueryNewsletterPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<NewsletterPageOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<NewsletterPageFilter>;
};


export type QueryOldAnnualReportArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryOldAnnualReportCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<OldAnnualReportOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<OldAnnualReportFilter>;
};


export type QueryOldAnnualReportCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<OldAnnualReportOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<OldAnnualReportFilter>;
};


export type QueryOrganisationArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryOrganisationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<OrganisationOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<OrganisationFilter>;
};


export type QueryOrganisationCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<OrganisationOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<OrganisationFilter>;
};


export type QueryParallaxImagesArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryParallaxImagesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ParallaxImagesOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ParallaxImagesFilter>;
};


export type QueryParallaxImagesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ParallaxImagesOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ParallaxImagesFilter>;
};


export type QueryPasswordProtectedPageArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPasswordProtectedPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PasswordProtectedPageOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PasswordProtectedPageFilter>;
};


export type QueryPasswordProtectedPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PasswordProtectedPageOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PasswordProtectedPageFilter>;
};


export type QueryPeoplePageArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPeoplePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PeoplePageOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PeoplePageFilter>;
};


export type QueryPeoplePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PeoplePageOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PeoplePageFilter>;
};


export type QueryPersonArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPersonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PersonOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PersonFilter>;
};


export type QueryPersonCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PersonOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PersonFilter>;
};


export type QueryPresidentialQuoteCallOutArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPresidentialQuoteCallOutCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PresidentialQuoteCallOutOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PresidentialQuoteCallOutFilter>;
};


export type QueryPresidentialQuoteCallOutCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PresidentialQuoteCallOutOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PresidentialQuoteCallOutFilter>;
};


export type QueryPressRoomArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPressRoomCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PressRoomOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PressRoomFilter>;
};


export type QueryPressRoomCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PressRoomOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PressRoomFilter>;
};


export type QueryPrivacyPolicyArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPrivacyPolicyCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PrivacyPolicyOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PrivacyPolicyFilter>;
};


export type QueryPrivacyPolicyCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PrivacyPolicyOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PrivacyPolicyFilter>;
};


export type QueryQuickLinkArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryQuickLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<QuickLinkOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<QuickLinkFilter>;
};


export type QueryQuickLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<QuickLinkOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<QuickLinkFilter>;
};


export type QueryQuoteArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryQuoteCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<QuoteOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<QuoteFilter>;
};


export type QueryQuoteCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<QuoteOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<QuoteFilter>;
};


export type QueryRangeValueFilterArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryRangeValueFilterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<RangeValueFilterOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<RangeValueFilterFilter>;
};


export type QueryRangeValueFilterCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<RangeValueFilterOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<RangeValueFilterFilter>;
};


export type QueryResourcesCurrentGranteesArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryResourcesCurrentGranteesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ResourcesCurrentGranteesOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ResourcesCurrentGranteesFilter>;
};


export type QueryResourcesCurrentGranteesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ResourcesCurrentGranteesOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ResourcesCurrentGranteesFilter>;
};


export type QueryResourcesProspectiveGranteesArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryResourcesProspectiveGranteesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ResourcesProspectiveGranteesOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ResourcesProspectiveGranteesFilter>;
};


export type QueryResourcesProspectiveGranteesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ResourcesProspectiveGranteesOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ResourcesProspectiveGranteesFilter>;
};


export type QueryRootPageArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryRootPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<RootPageOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<RootPageFilter>;
};


export type QueryRootPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<RootPageOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<RootPageFilter>;
};


export type QuerySearchPageArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySearchPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SearchPageOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SearchPageFilter>;
};


export type QuerySearchPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SearchPageOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SearchPageFilter>;
};


export type QuerySpotlightSlideshowArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySpotlightSlideshowCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpotlightSlideshowOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SpotlightSlideshowFilter>;
};


export type QuerySpotlightSlideshowCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpotlightSlideshowOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SpotlightSlideshowFilter>;
};


export type QuerySpotlightVideoArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySpotlightVideoCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpotlightVideoOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SpotlightVideoFilter>;
};


export type QuerySpotlightVideoCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpotlightVideoOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SpotlightVideoFilter>;
};


export type QueryStoriesPageArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryStoriesPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<StoriesPageOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<StoriesPageFilter>;
};


export type QueryStoriesPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<StoriesPageOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<StoriesPageFilter>;
};


export type QueryTaxonomyArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTaxonomyCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<TaxonomyOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<TaxonomyFilter>;
};


export type QueryTaxonomyCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<TaxonomyOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<TaxonomyFilter>;
};


export type QueryTermsOfUseArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTermsOfUseCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<TermsOfUseOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<TermsOfUseFilter>;
};


export type QueryTermsOfUseCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<TermsOfUseOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<TermsOfUseFilter>;
};


export type QueryThemeArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryThemeCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ThemeOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ThemeFilter>;
};


export type QueryThemeCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ThemeOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ThemeFilter>;
};


export type QueryTrusteeArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTrusteeCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<TrusteeOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<TrusteeFilter>;
};


export type QueryTrusteeCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<TrusteeOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<TrusteeFilter>;
};


export type QueryTrusteesPageArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTrusteesPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<TrusteesPageOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<TrusteesPageFilter>;
};


export type QueryTrusteesPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<TrusteesPageOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<TrusteesPageFilter>;
};


export type QueryVideoNativeArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryVideoNativeCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<VideoNativeOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<VideoNativeFilter>;
};


export type QueryVideoNativeCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<VideoNativeOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<VideoNativeFilter>;
};


export type QueryVideoYoutubeArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryVideoYoutubeCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<VideoYoutubeOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<VideoYoutubeFilter>;
};


export type QueryVideoYoutubeCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<VideoYoutubeOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<VideoYoutubeFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/quickLink) */
export type QuickLink = Entry & _Node & {
  __typename: 'QuickLink';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  label: Maybe<Scalars['String']['output']>;
  link: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<QuickLinkLinkingCollections>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/quickLink) */
export type QuickLinkLabelArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/quickLink) */
export type QuickLinkLinkArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/quickLink) */
export type QuickLinkLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/quickLink) */
export type QuickLinkTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuickLinkCollection = {
  __typename: 'QuickLinkCollection';
  items: Array<Maybe<QuickLink>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type QuickLinkCursorCollection = {
  __typename: 'QuickLinkCursorCollection';
  items: Array<Maybe<QuickLink>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type QuickLinkFilter = {
  AND: InputMaybe<Array<InputMaybe<QuickLinkFilter>>>;
  OR: InputMaybe<Array<InputMaybe<QuickLinkFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  label: InputMaybe<Scalars['String']['input']>;
  label_contains: InputMaybe<Scalars['String']['input']>;
  label_exists: InputMaybe<Scalars['Boolean']['input']>;
  label_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not: InputMaybe<Scalars['String']['input']>;
  label_not_contains: InputMaybe<Scalars['String']['input']>;
  label_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  link: InputMaybe<Scalars['String']['input']>;
  link_contains: InputMaybe<Scalars['String']['input']>;
  link_exists: InputMaybe<Scalars['Boolean']['input']>;
  link_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  link_not: InputMaybe<Scalars['String']['input']>;
  link_not_contains: InputMaybe<Scalars['String']['input']>;
  link_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QuickLinkLinkingCollections = {
  __typename: 'QuickLinkLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type QuickLinkLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuickLinkLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum QuickLinkOrder {
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  LinkAsc = 'link_ASC',
  LinkDesc = 'link_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/quote) */
export type Quote = Entry & _Node & {
  __typename: 'Quote';
  _id: Scalars['ID']['output'];
  attribution: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  isTwitterImage: Maybe<Scalars['Boolean']['output']>;
  link: Maybe<Scalars['String']['output']>;
  linkText: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<QuoteLinkingCollections>;
  quoteAudio: Maybe<Asset>;
  quoteImage: Maybe<Asset>;
  quoteText: Maybe<Scalars['String']['output']>;
  sys: Sys;
  twitterUsername: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/quote) */
export type QuoteAttributionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/quote) */
export type QuoteIsTwitterImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/quote) */
export type QuoteLinkArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/quote) */
export type QuoteLinkTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/quote) */
export type QuoteLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/quote) */
export type QuoteQuoteAudioArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/quote) */
export type QuoteQuoteImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/quote) */
export type QuoteQuoteTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/quote) */
export type QuoteTwitterUsernameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuoteCollection = {
  __typename: 'QuoteCollection';
  items: Array<Maybe<Quote>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type QuoteCursorCollection = {
  __typename: 'QuoteCursorCollection';
  items: Array<Maybe<Quote>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type QuoteFilter = {
  AND: InputMaybe<Array<InputMaybe<QuoteFilter>>>;
  OR: InputMaybe<Array<InputMaybe<QuoteFilter>>>;
  attribution: InputMaybe<Scalars['String']['input']>;
  attribution_contains: InputMaybe<Scalars['String']['input']>;
  attribution_exists: InputMaybe<Scalars['Boolean']['input']>;
  attribution_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attribution_not: InputMaybe<Scalars['String']['input']>;
  attribution_not_contains: InputMaybe<Scalars['String']['input']>;
  attribution_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  isTwitterImage: InputMaybe<Scalars['Boolean']['input']>;
  isTwitterImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  isTwitterImage_not: InputMaybe<Scalars['Boolean']['input']>;
  link: InputMaybe<Scalars['String']['input']>;
  linkText: InputMaybe<Scalars['String']['input']>;
  linkText_contains: InputMaybe<Scalars['String']['input']>;
  linkText_exists: InputMaybe<Scalars['Boolean']['input']>;
  linkText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkText_not: InputMaybe<Scalars['String']['input']>;
  linkText_not_contains: InputMaybe<Scalars['String']['input']>;
  linkText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  link_contains: InputMaybe<Scalars['String']['input']>;
  link_exists: InputMaybe<Scalars['Boolean']['input']>;
  link_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  link_not: InputMaybe<Scalars['String']['input']>;
  link_not_contains: InputMaybe<Scalars['String']['input']>;
  link_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quoteAudio_exists: InputMaybe<Scalars['Boolean']['input']>;
  quoteImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  quoteText: InputMaybe<Scalars['String']['input']>;
  quoteText_contains: InputMaybe<Scalars['String']['input']>;
  quoteText_exists: InputMaybe<Scalars['Boolean']['input']>;
  quoteText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quoteText_not: InputMaybe<Scalars['String']['input']>;
  quoteText_not_contains: InputMaybe<Scalars['String']['input']>;
  quoteText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  twitterUsername: InputMaybe<Scalars['String']['input']>;
  twitterUsername_contains: InputMaybe<Scalars['String']['input']>;
  twitterUsername_exists: InputMaybe<Scalars['Boolean']['input']>;
  twitterUsername_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  twitterUsername_not: InputMaybe<Scalars['String']['input']>;
  twitterUsername_not_contains: InputMaybe<Scalars['String']['input']>;
  twitterUsername_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QuoteLinkingCollections = {
  __typename: 'QuoteLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  grantResourcesCollection: Maybe<GrantResourcesCollection>;
  grantResourcesCursorCollection: Maybe<GrantResourcesCursorCollection>;
  grantmakingAreaDetailsPageCollection: Maybe<GrantmakingAreaDetailsPageCollection>;
  grantmakingAreaDetailsPageCursorCollection: Maybe<GrantmakingAreaDetailsPageCursorCollection>;
  homePageCollection: Maybe<HomePageCollection>;
  homePageCursorCollection: Maybe<HomePageCursorCollection>;
  ideaCollection: Maybe<IdeaCollection>;
  ideaCursorCollection: Maybe<IdeaCursorCollection>;
  initiativeQuoteCallOutCollection: Maybe<InitiativeQuoteCallOutCollection>;
  initiativeQuoteCallOutCursorCollection: Maybe<InitiativeQuoteCallOutCursorCollection>;
  missionPageCollection: Maybe<MissionPageCollection>;
  missionPageCursorCollection: Maybe<MissionPageCursorCollection>;
  mmufCollection: Maybe<MmufCollection>;
  mmufCursorCollection: Maybe<MmufCursorCollection>;
  personCollection: Maybe<PersonCollection>;
  personCursorCollection: Maybe<PersonCursorCollection>;
  presidentialQuoteCallOutCollection: Maybe<PresidentialQuoteCallOutCollection>;
  presidentialQuoteCallOutCursorCollection: Maybe<PresidentialQuoteCallOutCursorCollection>;
};


export type QuoteLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuoteLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuoteLinkingCollectionsGrantResourcesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<QuoteLinkingCollectionsGrantResourcesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuoteLinkingCollectionsGrantResourcesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<QuoteLinkingCollectionsGrantResourcesCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuoteLinkingCollectionsGrantmakingAreaDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<QuoteLinkingCollectionsGrantmakingAreaDetailsPageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuoteLinkingCollectionsGrantmakingAreaDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<QuoteLinkingCollectionsGrantmakingAreaDetailsPageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuoteLinkingCollectionsHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<QuoteLinkingCollectionsHomePageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuoteLinkingCollectionsHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<QuoteLinkingCollectionsHomePageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuoteLinkingCollectionsIdeaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<QuoteLinkingCollectionsIdeaCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuoteLinkingCollectionsIdeaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<QuoteLinkingCollectionsIdeaCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuoteLinkingCollectionsInitiativeQuoteCallOutCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<QuoteLinkingCollectionsInitiativeQuoteCallOutCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuoteLinkingCollectionsInitiativeQuoteCallOutCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<QuoteLinkingCollectionsInitiativeQuoteCallOutCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuoteLinkingCollectionsMissionPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<QuoteLinkingCollectionsMissionPageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuoteLinkingCollectionsMissionPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<QuoteLinkingCollectionsMissionPageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuoteLinkingCollectionsMmufCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<QuoteLinkingCollectionsMmufCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuoteLinkingCollectionsMmufCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<QuoteLinkingCollectionsMmufCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuoteLinkingCollectionsPersonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<QuoteLinkingCollectionsPersonCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuoteLinkingCollectionsPersonCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<QuoteLinkingCollectionsPersonCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuoteLinkingCollectionsPresidentialQuoteCallOutCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<QuoteLinkingCollectionsPresidentialQuoteCallOutCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuoteLinkingCollectionsPresidentialQuoteCallOutCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<QuoteLinkingCollectionsPresidentialQuoteCallOutCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum QuoteLinkingCollectionsGrantResourcesCollectionOrder {
  ExplanatoryTitleAsc = 'explanatoryTitle_ASC',
  ExplanatoryTitleDesc = 'explanatoryTitle_DESC',
  GrantMakingAreasTitleAsc = 'grantMakingAreasTitle_ASC',
  GrantMakingAreasTitleDesc = 'grantMakingAreasTitle_DESC',
  SearchContextualMessageAsc = 'searchContextualMessage_ASC',
  SearchContextualMessageDesc = 'searchContextualMessage_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum QuoteLinkingCollectionsGrantResourcesCursorCollectionOrder {
  ExplanatoryTitleAsc = 'explanatoryTitle_ASC',
  ExplanatoryTitleDesc = 'explanatoryTitle_DESC',
  GrantMakingAreasTitleAsc = 'grantMakingAreasTitle_ASC',
  GrantMakingAreasTitleDesc = 'grantMakingAreasTitle_DESC',
  SearchContextualMessageAsc = 'searchContextualMessage_ASC',
  SearchContextualMessageDesc = 'searchContextualMessage_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum QuoteLinkingCollectionsGrantmakingAreaDetailsPageCollectionOrder {
  GrantMakingProcessMessageAsc = 'grantMakingProcessMessage_ASC',
  GrantMakingProcessMessageDesc = 'grantMakingProcessMessage_DESC',
  GuidingStrategiesTitleAsc = 'guidingStrategiesTitle_ASC',
  GuidingStrategiesTitleDesc = 'guidingStrategiesTitle_DESC',
  IntroDescriptionAsc = 'introDescription_ASC',
  IntroDescriptionDesc = 'introDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum QuoteLinkingCollectionsGrantmakingAreaDetailsPageCursorCollectionOrder {
  GrantMakingProcessMessageAsc = 'grantMakingProcessMessage_ASC',
  GrantMakingProcessMessageDesc = 'grantMakingProcessMessage_DESC',
  GuidingStrategiesTitleAsc = 'guidingStrategiesTitle_ASC',
  GuidingStrategiesTitleDesc = 'guidingStrategiesTitle_DESC',
  IntroDescriptionAsc = 'introDescription_ASC',
  IntroDescriptionDesc = 'introDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum QuoteLinkingCollectionsHomePageCollectionOrder {
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  MissionTextAsc = 'missionText_ASC',
  MissionTextDesc = 'missionText_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StoriesCtaAsc = 'storiesCta_ASC',
  StoriesCtaDesc = 'storiesCta_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum QuoteLinkingCollectionsHomePageCursorCollectionOrder {
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  MissionTextAsc = 'missionText_ASC',
  MissionTextDesc = 'missionText_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StoriesCtaAsc = 'storiesCta_ASC',
  StoriesCtaDesc = 'storiesCta_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum QuoteLinkingCollectionsIdeaCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum QuoteLinkingCollectionsIdeaCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum QuoteLinkingCollectionsInitiativeQuoteCallOutCollectionOrder {
  InitiativeCtaTextAsc = 'initiativeCtaText_ASC',
  InitiativeCtaTextDesc = 'initiativeCtaText_DESC',
  InitiativeHeadingAsc = 'initiativeHeading_ASC',
  InitiativeHeadingDesc = 'initiativeHeading_DESC',
  InitiativeTextAsc = 'initiativeText_ASC',
  InitiativeTextDesc = 'initiativeText_DESC',
  InitiativeTitleAsc = 'initiativeTitle_ASC',
  InitiativeTitleDesc = 'initiativeTitle_DESC',
  SearchQueryAsc = 'searchQuery_ASC',
  SearchQueryDesc = 'searchQuery_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum QuoteLinkingCollectionsInitiativeQuoteCallOutCursorCollectionOrder {
  InitiativeCtaTextAsc = 'initiativeCtaText_ASC',
  InitiativeCtaTextDesc = 'initiativeCtaText_DESC',
  InitiativeHeadingAsc = 'initiativeHeading_ASC',
  InitiativeHeadingDesc = 'initiativeHeading_DESC',
  InitiativeTextAsc = 'initiativeText_ASC',
  InitiativeTextDesc = 'initiativeText_DESC',
  InitiativeTitleAsc = 'initiativeTitle_ASC',
  InitiativeTitleDesc = 'initiativeTitle_DESC',
  SearchQueryAsc = 'searchQuery_ASC',
  SearchQueryDesc = 'searchQuery_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum QuoteLinkingCollectionsMissionPageCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum QuoteLinkingCollectionsMissionPageCursorCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum QuoteLinkingCollectionsMmufCollectionOrder {
  ArticleTitleAsc = 'articleTitle_ASC',
  ArticleTitleDesc = 'articleTitle_DESC',
  AtGlanceTitleAsc = 'atGlanceTitle_ASC',
  AtGlanceTitleDesc = 'atGlanceTitle_DESC',
  ContactEmailAsc = 'contactEmail_ASC',
  ContactEmailDesc = 'contactEmail_DESC',
  ContactMessageAsc = 'contactMessage_ASC',
  ContactMessageDesc = 'contactMessage_DESC',
  ContactTitleAsc = 'contactTitle_ASC',
  ContactTitleDesc = 'contactTitle_DESC',
  FellowStoriesCtaLabelAsc = 'fellowStoriesCtaLabel_ASC',
  FellowStoriesCtaLabelDesc = 'fellowStoriesCtaLabel_DESC',
  FellowStoriesMessageAsc = 'fellowStoriesMessage_ASC',
  FellowStoriesMessageDesc = 'fellowStoriesMessage_DESC',
  GraduateInitiativesTitleAsc = 'graduateInitiativesTitle_ASC',
  GraduateInitiativesTitleDesc = 'graduateInitiativesTitle_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum QuoteLinkingCollectionsMmufCursorCollectionOrder {
  ArticleTitleAsc = 'articleTitle_ASC',
  ArticleTitleDesc = 'articleTitle_DESC',
  AtGlanceTitleAsc = 'atGlanceTitle_ASC',
  AtGlanceTitleDesc = 'atGlanceTitle_DESC',
  ContactEmailAsc = 'contactEmail_ASC',
  ContactEmailDesc = 'contactEmail_DESC',
  ContactMessageAsc = 'contactMessage_ASC',
  ContactMessageDesc = 'contactMessage_DESC',
  ContactTitleAsc = 'contactTitle_ASC',
  ContactTitleDesc = 'contactTitle_DESC',
  FellowStoriesCtaLabelAsc = 'fellowStoriesCtaLabel_ASC',
  FellowStoriesCtaLabelDesc = 'fellowStoriesCtaLabel_DESC',
  FellowStoriesMessageAsc = 'fellowStoriesMessage_ASC',
  FellowStoriesMessageDesc = 'fellowStoriesMessage_DESC',
  GraduateInitiativesTitleAsc = 'graduateInitiativesTitle_ASC',
  GraduateInitiativesTitleDesc = 'graduateInitiativesTitle_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum QuoteLinkingCollectionsPersonCollectionOrder {
  FirstNameAsc = 'firstName_ASC',
  FirstNameDesc = 'firstName_DESC',
  JobTitleAsc = 'jobTitle_ASC',
  JobTitleDesc = 'jobTitle_DESC',
  LastNameAsc = 'lastName_ASC',
  LastNameDesc = 'lastName_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  RelatedSectionTitleAsc = 'relatedSectionTitle_ASC',
  RelatedSectionTitleDesc = 'relatedSectionTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum QuoteLinkingCollectionsPersonCursorCollectionOrder {
  FirstNameAsc = 'firstName_ASC',
  FirstNameDesc = 'firstName_DESC',
  JobTitleAsc = 'jobTitle_ASC',
  JobTitleDesc = 'jobTitle_DESC',
  LastNameAsc = 'lastName_ASC',
  LastNameDesc = 'lastName_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  RelatedSectionTitleAsc = 'relatedSectionTitle_ASC',
  RelatedSectionTitleDesc = 'relatedSectionTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum QuoteLinkingCollectionsPresidentialQuoteCallOutCollectionOrder {
  PresidentialCtaTextAsc = 'presidentialCtaText_ASC',
  PresidentialCtaTextDesc = 'presidentialCtaText_DESC',
  PresidentialHeadingAsc = 'presidentialHeading_ASC',
  PresidentialHeadingDesc = 'presidentialHeading_DESC',
  PresidentialTextAsc = 'presidentialText_ASC',
  PresidentialTextDesc = 'presidentialText_DESC',
  PresidentialTitleAsc = 'presidentialTitle_ASC',
  PresidentialTitleDesc = 'presidentialTitle_DESC',
  SearchQueryAsc = 'searchQuery_ASC',
  SearchQueryDesc = 'searchQuery_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum QuoteLinkingCollectionsPresidentialQuoteCallOutCursorCollectionOrder {
  PresidentialCtaTextAsc = 'presidentialCtaText_ASC',
  PresidentialCtaTextDesc = 'presidentialCtaText_DESC',
  PresidentialHeadingAsc = 'presidentialHeading_ASC',
  PresidentialHeadingDesc = 'presidentialHeading_DESC',
  PresidentialTextAsc = 'presidentialText_ASC',
  PresidentialTextDesc = 'presidentialText_DESC',
  PresidentialTitleAsc = 'presidentialTitle_ASC',
  PresidentialTitleDesc = 'presidentialTitle_DESC',
  SearchQueryAsc = 'searchQuery_ASC',
  SearchQueryDesc = 'searchQuery_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum QuoteOrder {
  IsTwitterImageAsc = 'isTwitterImage_ASC',
  IsTwitterImageDesc = 'isTwitterImage_DESC',
  LinkTextAsc = 'linkText_ASC',
  LinkTextDesc = 'linkText_DESC',
  LinkAsc = 'link_ASC',
  LinkDesc = 'link_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TwitterUsernameAsc = 'twitterUsername_ASC',
  TwitterUsernameDesc = 'twitterUsername_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/rangeValueFilter) */
export type RangeValueFilter = Entry & _Node & {
  __typename: 'RangeValueFilter';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  gte: Maybe<Scalars['Float']['output']>;
  linkedFrom: Maybe<RangeValueFilterLinkingCollections>;
  lte: Maybe<Scalars['Float']['output']>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/rangeValueFilter) */
export type RangeValueFilterGteArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/rangeValueFilter) */
export type RangeValueFilterLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/rangeValueFilter) */
export type RangeValueFilterLteArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/rangeValueFilter) */
export type RangeValueFilterTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/rangeValueFilter) */
export type RangeValueFilterTypeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type RangeValueFilterCollection = {
  __typename: 'RangeValueFilterCollection';
  items: Array<Maybe<RangeValueFilter>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RangeValueFilterCursorCollection = {
  __typename: 'RangeValueFilterCursorCollection';
  items: Array<Maybe<RangeValueFilter>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type RangeValueFilterFilter = {
  AND: InputMaybe<Array<InputMaybe<RangeValueFilterFilter>>>;
  OR: InputMaybe<Array<InputMaybe<RangeValueFilterFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  gte: InputMaybe<Scalars['Float']['input']>;
  gte_exists: InputMaybe<Scalars['Boolean']['input']>;
  gte_gt: InputMaybe<Scalars['Float']['input']>;
  gte_gte: InputMaybe<Scalars['Float']['input']>;
  gte_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  gte_lt: InputMaybe<Scalars['Float']['input']>;
  gte_lte: InputMaybe<Scalars['Float']['input']>;
  gte_not: InputMaybe<Scalars['Float']['input']>;
  gte_not_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lte: InputMaybe<Scalars['Float']['input']>;
  lte_exists: InputMaybe<Scalars['Boolean']['input']>;
  lte_gt: InputMaybe<Scalars['Float']['input']>;
  lte_gte: InputMaybe<Scalars['Float']['input']>;
  lte_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lte_lt: InputMaybe<Scalars['Float']['input']>;
  lte_lte: InputMaybe<Scalars['Float']['input']>;
  lte_not: InputMaybe<Scalars['Float']['input']>;
  lte_not_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type: InputMaybe<Scalars['String']['input']>;
  type_contains: InputMaybe<Scalars['String']['input']>;
  type_exists: InputMaybe<Scalars['Boolean']['input']>;
  type_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not: InputMaybe<Scalars['String']['input']>;
  type_not_contains: InputMaybe<Scalars['String']['input']>;
  type_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type RangeValueFilterLinkingCollections = {
  __typename: 'RangeValueFilterLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  grantSearchFiltersCollection: Maybe<GrantSearchFiltersCollection>;
  grantSearchFiltersCursorCollection: Maybe<GrantSearchFiltersCursorCollection>;
};


export type RangeValueFilterLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type RangeValueFilterLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type RangeValueFilterLinkingCollectionsGrantSearchFiltersCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<RangeValueFilterLinkingCollectionsGrantSearchFiltersCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type RangeValueFilterLinkingCollectionsGrantSearchFiltersCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<RangeValueFilterLinkingCollectionsGrantSearchFiltersCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum RangeValueFilterLinkingCollectionsGrantSearchFiltersCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum RangeValueFilterLinkingCollectionsGrantSearchFiltersCursorCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum RangeValueFilterOrder {
  GteAsc = 'gte_ASC',
  GteDesc = 'gte_DESC',
  LteAsc = 'lte_ASC',
  LteDesc = 'lte_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export type ResourceLink = {
  sys: ResourceSys;
};

export type ResourceSys = {
  __typename: 'ResourceSys';
  linkType: Scalars['String']['output'];
  urn: Scalars['String']['output'];
};

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/resourcesCurrentGrantees) */
export type ResourcesCurrentGrantees = Entry & _Node & {
  __typename: 'ResourcesCurrentGrantees';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  description: Maybe<Scalars['String']['output']>;
  faqs: Maybe<FaqsModule>;
  grantDatabaseCtaText: Maybe<Scalars['String']['output']>;
  hero: Maybe<HeroAsset>;
  linkedFrom: Maybe<ResourcesCurrentGranteesLinkingCollections>;
  quickLinks: Maybe<ConnectWith>;
  resourcesCollection: Maybe<ResourcesCurrentGranteesResourcesCollection>;
  resourcesCursorCollection: Maybe<ResourcesCurrentGranteesResourcesCursorCollection>;
  resourcesTitle: Maybe<Scalars['String']['output']>;
  similarGranteesGrantmakingAreasCollection: Maybe<ResourcesCurrentGranteesSimilarGranteesGrantmakingAreasCollection>;
  similarGranteesGrantmakingAreasCursorCollection: Maybe<ResourcesCurrentGranteesSimilarGranteesGrantmakingAreasCursorCollection>;
  similarGranteesTitle: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/resourcesCurrentGrantees) */
export type ResourcesCurrentGranteesDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/resourcesCurrentGrantees) */
export type ResourcesCurrentGranteesFaqsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<FaqsModuleFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/resourcesCurrentGrantees) */
export type ResourcesCurrentGranteesGrantDatabaseCtaTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/resourcesCurrentGrantees) */
export type ResourcesCurrentGranteesHeroArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<HeroAssetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/resourcesCurrentGrantees) */
export type ResourcesCurrentGranteesLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/resourcesCurrentGrantees) */
export type ResourcesCurrentGranteesQuickLinksArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ConnectWithFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/resourcesCurrentGrantees) */
export type ResourcesCurrentGranteesResourcesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ResourcesCurrentGranteesResourcesFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/resourcesCurrentGrantees) */
export type ResourcesCurrentGranteesResourcesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ResourcesCurrentGranteesResourcesFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/resourcesCurrentGrantees) */
export type ResourcesCurrentGranteesResourcesTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/resourcesCurrentGrantees) */
export type ResourcesCurrentGranteesSimilarGranteesGrantmakingAreasCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ResourcesCurrentGranteesSimilarGranteesGrantmakingAreasCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantmakingAreaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/resourcesCurrentGrantees) */
export type ResourcesCurrentGranteesSimilarGranteesGrantmakingAreasCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ResourcesCurrentGranteesSimilarGranteesGrantmakingAreasCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantmakingAreaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/resourcesCurrentGrantees) */
export type ResourcesCurrentGranteesSimilarGranteesTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/resourcesCurrentGrantees) */
export type ResourcesCurrentGranteesTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ResourcesCurrentGranteesCollection = {
  __typename: 'ResourcesCurrentGranteesCollection';
  items: Array<Maybe<ResourcesCurrentGrantees>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ResourcesCurrentGranteesCursorCollection = {
  __typename: 'ResourcesCurrentGranteesCursorCollection';
  items: Array<Maybe<ResourcesCurrentGrantees>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ResourcesCurrentGranteesFilter = {
  AND: InputMaybe<Array<InputMaybe<ResourcesCurrentGranteesFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ResourcesCurrentGranteesFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faqs: InputMaybe<CfFaqsModuleNestedFilter>;
  faqs_exists: InputMaybe<Scalars['Boolean']['input']>;
  grantDatabaseCtaText: InputMaybe<Scalars['String']['input']>;
  grantDatabaseCtaText_contains: InputMaybe<Scalars['String']['input']>;
  grantDatabaseCtaText_exists: InputMaybe<Scalars['Boolean']['input']>;
  grantDatabaseCtaText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  grantDatabaseCtaText_not: InputMaybe<Scalars['String']['input']>;
  grantDatabaseCtaText_not_contains: InputMaybe<Scalars['String']['input']>;
  grantDatabaseCtaText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hero: InputMaybe<CfHeroAssetNestedFilter>;
  hero_exists: InputMaybe<Scalars['Boolean']['input']>;
  quickLinks: InputMaybe<CfConnectWithNestedFilter>;
  quickLinks_exists: InputMaybe<Scalars['Boolean']['input']>;
  resources: InputMaybe<CfresourcesMultiTypeNestedFilter>;
  resourcesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  resourcesTitle: InputMaybe<Scalars['String']['input']>;
  resourcesTitle_contains: InputMaybe<Scalars['String']['input']>;
  resourcesTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  resourcesTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  resourcesTitle_not: InputMaybe<Scalars['String']['input']>;
  resourcesTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  resourcesTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  similarGranteesGrantmakingAreas: InputMaybe<CfGrantmakingAreaNestedFilter>;
  similarGranteesGrantmakingAreasCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  similarGranteesTitle: InputMaybe<Scalars['String']['input']>;
  similarGranteesTitle_contains: InputMaybe<Scalars['String']['input']>;
  similarGranteesTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  similarGranteesTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  similarGranteesTitle_not: InputMaybe<Scalars['String']['input']>;
  similarGranteesTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  similarGranteesTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ResourcesCurrentGranteesLinkingCollections = {
  __typename: 'ResourcesCurrentGranteesLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  navigationItemCollection: Maybe<NavigationItemCollection>;
  navigationItemCursorCollection: Maybe<NavigationItemCursorCollection>;
};


export type ResourcesCurrentGranteesLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ResourcesCurrentGranteesLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ResourcesCurrentGranteesLinkingCollectionsNavigationItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ResourcesCurrentGranteesLinkingCollectionsNavigationItemCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ResourcesCurrentGranteesLinkingCollectionsNavigationItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ResourcesCurrentGranteesLinkingCollectionsNavigationItemCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ResourcesCurrentGranteesLinkingCollectionsNavigationItemCollectionOrder {
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ResourcesCurrentGranteesLinkingCollectionsNavigationItemCursorCollectionOrder {
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ResourcesCurrentGranteesOrder {
  GrantDatabaseCtaTextAsc = 'grantDatabaseCtaText_ASC',
  GrantDatabaseCtaTextDesc = 'grantDatabaseCtaText_DESC',
  ResourcesTitleAsc = 'resourcesTitle_ASC',
  ResourcesTitleDesc = 'resourcesTitle_DESC',
  SimilarGranteesTitleAsc = 'similarGranteesTitle_ASC',
  SimilarGranteesTitleDesc = 'similarGranteesTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ResourcesCurrentGranteesResourcesCollection = {
  __typename: 'ResourcesCurrentGranteesResourcesCollection';
  items: Array<Maybe<ResourcesCurrentGranteesResourcesItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ResourcesCurrentGranteesResourcesCursorCollection = {
  __typename: 'ResourcesCurrentGranteesResourcesCursorCollection';
  items: Array<Maybe<ResourcesCurrentGranteesResourcesItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ResourcesCurrentGranteesResourcesFilter = {
  AND: InputMaybe<Array<InputMaybe<ResourcesCurrentGranteesResourcesFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ResourcesCurrentGranteesResourcesFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type ResourcesCurrentGranteesResourcesItem = AnnualReport | Article | StoriesPage;

export type ResourcesCurrentGranteesSimilarGranteesGrantmakingAreasCollection = {
  __typename: 'ResourcesCurrentGranteesSimilarGranteesGrantmakingAreasCollection';
  items: Array<Maybe<GrantmakingArea>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ResourcesCurrentGranteesSimilarGranteesGrantmakingAreasCollectionOrder {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TaglineAsc = 'tagline_ASC',
  TaglineDesc = 'tagline_DESC'
}

export type ResourcesCurrentGranteesSimilarGranteesGrantmakingAreasCursorCollection = {
  __typename: 'ResourcesCurrentGranteesSimilarGranteesGrantmakingAreasCursorCollection';
  items: Array<Maybe<GrantmakingArea>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ResourcesCurrentGranteesSimilarGranteesGrantmakingAreasCursorCollectionOrder {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TaglineAsc = 'tagline_ASC',
  TaglineDesc = 'tagline_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/resourcesProspectiveGrantees) */
export type ResourcesProspectiveGrantees = Entry & _Node & {
  __typename: 'ResourcesProspectiveGrantees';
  _id: Scalars['ID']['output'];
  callsForConceptsCollection: Maybe<ResourcesProspectiveGranteesCallsForConceptsCollection>;
  callsForConceptsCursorCollection: Maybe<ResourcesProspectiveGranteesCallsForConceptsCursorCollection>;
  callsForConceptsTitle: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  description: Maybe<Scalars['String']['output']>;
  explanatoryParagraph: Maybe<ResourcesProspectiveGranteesExplanatoryParagraph>;
  faqs: Maybe<FaqsModule>;
  grantDatabaseCtaText: Maybe<Scalars['String']['output']>;
  grantmakingAreasCollection: Maybe<ResourcesProspectiveGranteesGrantmakingAreasCollection>;
  grantmakingAreasCursorCollection: Maybe<ResourcesProspectiveGranteesGrantmakingAreasCursorCollection>;
  grantmakingAtGlanceCardsCollection: Maybe<ResourcesProspectiveGranteesGrantmakingAtGlanceCardsCollection>;
  grantmakingAtGlanceCardsCursorCollection: Maybe<ResourcesProspectiveGranteesGrantmakingAtGlanceCardsCursorCollection>;
  grantmakingAtGlanceTitle: Maybe<Scalars['String']['output']>;
  hero: Maybe<HeroAsset>;
  linkedFrom: Maybe<ResourcesProspectiveGranteesLinkingCollections>;
  newsletterCtaText: Maybe<Scalars['String']['output']>;
  quickLinks: Maybe<ConnectWith>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/resourcesProspectiveGrantees) */
export type ResourcesProspectiveGranteesCallsForConceptsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ResourcesProspectiveGranteesCallsForConceptsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CallForConceptFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/resourcesProspectiveGrantees) */
export type ResourcesProspectiveGranteesCallsForConceptsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ResourcesProspectiveGranteesCallsForConceptsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CallForConceptFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/resourcesProspectiveGrantees) */
export type ResourcesProspectiveGranteesCallsForConceptsTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/resourcesProspectiveGrantees) */
export type ResourcesProspectiveGranteesDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/resourcesProspectiveGrantees) */
export type ResourcesProspectiveGranteesExplanatoryParagraphArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/resourcesProspectiveGrantees) */
export type ResourcesProspectiveGranteesFaqsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<FaqsModuleFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/resourcesProspectiveGrantees) */
export type ResourcesProspectiveGranteesGrantDatabaseCtaTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/resourcesProspectiveGrantees) */
export type ResourcesProspectiveGranteesGrantmakingAreasCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ResourcesProspectiveGranteesGrantmakingAreasCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantmakingAreaDetailsPageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/resourcesProspectiveGrantees) */
export type ResourcesProspectiveGranteesGrantmakingAreasCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ResourcesProspectiveGranteesGrantmakingAreasCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GrantmakingAreaDetailsPageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/resourcesProspectiveGrantees) */
export type ResourcesProspectiveGranteesGrantmakingAtGlanceCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ResourcesProspectiveGranteesGrantmakingAtGlanceCardsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<AtGlanceCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/resourcesProspectiveGrantees) */
export type ResourcesProspectiveGranteesGrantmakingAtGlanceCardsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ResourcesProspectiveGranteesGrantmakingAtGlanceCardsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<AtGlanceCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/resourcesProspectiveGrantees) */
export type ResourcesProspectiveGranteesGrantmakingAtGlanceTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/resourcesProspectiveGrantees) */
export type ResourcesProspectiveGranteesHeroArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<HeroAssetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/resourcesProspectiveGrantees) */
export type ResourcesProspectiveGranteesLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/resourcesProspectiveGrantees) */
export type ResourcesProspectiveGranteesNewsletterCtaTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/resourcesProspectiveGrantees) */
export type ResourcesProspectiveGranteesQuickLinksArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ConnectWithFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/resourcesProspectiveGrantees) */
export type ResourcesProspectiveGranteesTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ResourcesProspectiveGranteesCallsForConceptsCollection = {
  __typename: 'ResourcesProspectiveGranteesCallsForConceptsCollection';
  items: Array<Maybe<CallForConcept>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ResourcesProspectiveGranteesCallsForConceptsCollectionOrder {
  CallForConceptTitleAsc = 'callForConceptTitle_ASC',
  CallForConceptTitleDesc = 'callForConceptTitle_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  RegistrationDeadlineDateAsc = 'registrationDeadlineDate_ASC',
  RegistrationDeadlineDateDesc = 'registrationDeadlineDate_DESC',
  RegistrationDeadlineTitleAsc = 'registrationDeadlineTitle_ASC',
  RegistrationDeadlineTitleDesc = 'registrationDeadlineTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export type ResourcesProspectiveGranteesCallsForConceptsCursorCollection = {
  __typename: 'ResourcesProspectiveGranteesCallsForConceptsCursorCollection';
  items: Array<Maybe<CallForConcept>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ResourcesProspectiveGranteesCallsForConceptsCursorCollectionOrder {
  CallForConceptTitleAsc = 'callForConceptTitle_ASC',
  CallForConceptTitleDesc = 'callForConceptTitle_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  RegistrationDeadlineDateAsc = 'registrationDeadlineDate_ASC',
  RegistrationDeadlineDateDesc = 'registrationDeadlineDate_DESC',
  RegistrationDeadlineTitleAsc = 'registrationDeadlineTitle_ASC',
  RegistrationDeadlineTitleDesc = 'registrationDeadlineTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export type ResourcesProspectiveGranteesCollection = {
  __typename: 'ResourcesProspectiveGranteesCollection';
  items: Array<Maybe<ResourcesProspectiveGrantees>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ResourcesProspectiveGranteesCursorCollection = {
  __typename: 'ResourcesProspectiveGranteesCursorCollection';
  items: Array<Maybe<ResourcesProspectiveGrantees>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ResourcesProspectiveGranteesExplanatoryParagraph = {
  __typename: 'ResourcesProspectiveGranteesExplanatoryParagraph';
  json: Scalars['JSON']['output'];
  links: ResourcesProspectiveGranteesExplanatoryParagraphLinks;
};

export type ResourcesProspectiveGranteesExplanatoryParagraphAssets = {
  __typename: 'ResourcesProspectiveGranteesExplanatoryParagraphAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ResourcesProspectiveGranteesExplanatoryParagraphEntries = {
  __typename: 'ResourcesProspectiveGranteesExplanatoryParagraphEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ResourcesProspectiveGranteesExplanatoryParagraphLinks = {
  __typename: 'ResourcesProspectiveGranteesExplanatoryParagraphLinks';
  assets: ResourcesProspectiveGranteesExplanatoryParagraphAssets;
  entries: ResourcesProspectiveGranteesExplanatoryParagraphEntries;
  resources: ResourcesProspectiveGranteesExplanatoryParagraphResources;
};

export type ResourcesProspectiveGranteesExplanatoryParagraphResources = {
  __typename: 'ResourcesProspectiveGranteesExplanatoryParagraphResources';
  block: Array<ResourcesProspectiveGranteesExplanatoryParagraphResourcesBlock>;
  hyperlink: Array<ResourcesProspectiveGranteesExplanatoryParagraphResourcesHyperlink>;
  inline: Array<ResourcesProspectiveGranteesExplanatoryParagraphResourcesInline>;
};

export type ResourcesProspectiveGranteesExplanatoryParagraphResourcesBlock = ResourceLink & {
  __typename: 'ResourcesProspectiveGranteesExplanatoryParagraphResourcesBlock';
  sys: ResourceSys;
};

export type ResourcesProspectiveGranteesExplanatoryParagraphResourcesHyperlink = ResourceLink & {
  __typename: 'ResourcesProspectiveGranteesExplanatoryParagraphResourcesHyperlink';
  sys: ResourceSys;
};

export type ResourcesProspectiveGranteesExplanatoryParagraphResourcesInline = ResourceLink & {
  __typename: 'ResourcesProspectiveGranteesExplanatoryParagraphResourcesInline';
  sys: ResourceSys;
};

export type ResourcesProspectiveGranteesFilter = {
  AND: InputMaybe<Array<InputMaybe<ResourcesProspectiveGranteesFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ResourcesProspectiveGranteesFilter>>>;
  callsForConcepts: InputMaybe<CfCallForConceptNestedFilter>;
  callsForConceptsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  callsForConceptsTitle: InputMaybe<Scalars['String']['input']>;
  callsForConceptsTitle_contains: InputMaybe<Scalars['String']['input']>;
  callsForConceptsTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  callsForConceptsTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callsForConceptsTitle_not: InputMaybe<Scalars['String']['input']>;
  callsForConceptsTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  callsForConceptsTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  explanatoryParagraph_contains: InputMaybe<Scalars['String']['input']>;
  explanatoryParagraph_exists: InputMaybe<Scalars['Boolean']['input']>;
  explanatoryParagraph_not_contains: InputMaybe<Scalars['String']['input']>;
  faqs: InputMaybe<CfFaqsModuleNestedFilter>;
  faqs_exists: InputMaybe<Scalars['Boolean']['input']>;
  grantDatabaseCtaText: InputMaybe<Scalars['String']['input']>;
  grantDatabaseCtaText_contains: InputMaybe<Scalars['String']['input']>;
  grantDatabaseCtaText_exists: InputMaybe<Scalars['Boolean']['input']>;
  grantDatabaseCtaText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  grantDatabaseCtaText_not: InputMaybe<Scalars['String']['input']>;
  grantDatabaseCtaText_not_contains: InputMaybe<Scalars['String']['input']>;
  grantDatabaseCtaText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  grantmakingAreas: InputMaybe<CfGrantmakingAreaDetailsPageNestedFilter>;
  grantmakingAreasCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  grantmakingAtGlanceCards: InputMaybe<CfAtGlanceCardNestedFilter>;
  grantmakingAtGlanceCardsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  grantmakingAtGlanceTitle: InputMaybe<Scalars['String']['input']>;
  grantmakingAtGlanceTitle_contains: InputMaybe<Scalars['String']['input']>;
  grantmakingAtGlanceTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  grantmakingAtGlanceTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  grantmakingAtGlanceTitle_not: InputMaybe<Scalars['String']['input']>;
  grantmakingAtGlanceTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  grantmakingAtGlanceTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hero: InputMaybe<CfHeroAssetNestedFilter>;
  hero_exists: InputMaybe<Scalars['Boolean']['input']>;
  newsletterCtaText: InputMaybe<Scalars['String']['input']>;
  newsletterCtaText_contains: InputMaybe<Scalars['String']['input']>;
  newsletterCtaText_exists: InputMaybe<Scalars['Boolean']['input']>;
  newsletterCtaText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  newsletterCtaText_not: InputMaybe<Scalars['String']['input']>;
  newsletterCtaText_not_contains: InputMaybe<Scalars['String']['input']>;
  newsletterCtaText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quickLinks: InputMaybe<CfConnectWithNestedFilter>;
  quickLinks_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ResourcesProspectiveGranteesGrantmakingAreasCollection = {
  __typename: 'ResourcesProspectiveGranteesGrantmakingAreasCollection';
  items: Array<Maybe<GrantmakingAreaDetailsPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ResourcesProspectiveGranteesGrantmakingAreasCollectionOrder {
  GrantMakingProcessMessageAsc = 'grantMakingProcessMessage_ASC',
  GrantMakingProcessMessageDesc = 'grantMakingProcessMessage_DESC',
  GuidingStrategiesTitleAsc = 'guidingStrategiesTitle_ASC',
  GuidingStrategiesTitleDesc = 'guidingStrategiesTitle_DESC',
  IntroDescriptionAsc = 'introDescription_ASC',
  IntroDescriptionDesc = 'introDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ResourcesProspectiveGranteesGrantmakingAreasCursorCollection = {
  __typename: 'ResourcesProspectiveGranteesGrantmakingAreasCursorCollection';
  items: Array<Maybe<GrantmakingAreaDetailsPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ResourcesProspectiveGranteesGrantmakingAreasCursorCollectionOrder {
  GrantMakingProcessMessageAsc = 'grantMakingProcessMessage_ASC',
  GrantMakingProcessMessageDesc = 'grantMakingProcessMessage_DESC',
  GuidingStrategiesTitleAsc = 'guidingStrategiesTitle_ASC',
  GuidingStrategiesTitleDesc = 'guidingStrategiesTitle_DESC',
  IntroDescriptionAsc = 'introDescription_ASC',
  IntroDescriptionDesc = 'introDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ResourcesProspectiveGranteesGrantmakingAtGlanceCardsCollection = {
  __typename: 'ResourcesProspectiveGranteesGrantmakingAtGlanceCardsCollection';
  items: Array<Maybe<AtGlanceCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ResourcesProspectiveGranteesGrantmakingAtGlanceCardsCollectionOrder {
  BodyTextAsc = 'bodyText_ASC',
  BodyTextDesc = 'bodyText_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export type ResourcesProspectiveGranteesGrantmakingAtGlanceCardsCursorCollection = {
  __typename: 'ResourcesProspectiveGranteesGrantmakingAtGlanceCardsCursorCollection';
  items: Array<Maybe<AtGlanceCard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ResourcesProspectiveGranteesGrantmakingAtGlanceCardsCursorCollectionOrder {
  BodyTextAsc = 'bodyText_ASC',
  BodyTextDesc = 'bodyText_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export type ResourcesProspectiveGranteesLinkingCollections = {
  __typename: 'ResourcesProspectiveGranteesLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  navigationItemCollection: Maybe<NavigationItemCollection>;
  navigationItemCursorCollection: Maybe<NavigationItemCursorCollection>;
};


export type ResourcesProspectiveGranteesLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ResourcesProspectiveGranteesLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ResourcesProspectiveGranteesLinkingCollectionsNavigationItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ResourcesProspectiveGranteesLinkingCollectionsNavigationItemCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ResourcesProspectiveGranteesLinkingCollectionsNavigationItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ResourcesProspectiveGranteesLinkingCollectionsNavigationItemCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ResourcesProspectiveGranteesLinkingCollectionsNavigationItemCollectionOrder {
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ResourcesProspectiveGranteesLinkingCollectionsNavigationItemCursorCollectionOrder {
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ResourcesProspectiveGranteesOrder {
  CallsForConceptsTitleAsc = 'callsForConceptsTitle_ASC',
  CallsForConceptsTitleDesc = 'callsForConceptsTitle_DESC',
  GrantDatabaseCtaTextAsc = 'grantDatabaseCtaText_ASC',
  GrantDatabaseCtaTextDesc = 'grantDatabaseCtaText_DESC',
  GrantmakingAtGlanceTitleAsc = 'grantmakingAtGlanceTitle_ASC',
  GrantmakingAtGlanceTitleDesc = 'grantmakingAtGlanceTitle_DESC',
  NewsletterCtaTextAsc = 'newsletterCtaText_ASC',
  NewsletterCtaTextDesc = 'newsletterCtaText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/rootPage) */
export type RootPage = Entry & _Node & {
  __typename: 'RootPage';
  _id: Scalars['ID']['output'];
  body: Maybe<RootPageBody>;
  contentfulMetadata: ContentfulMetadata;
  includeLegalLogo: Maybe<Scalars['Boolean']['output']>;
  lastUpdated: Maybe<Scalars['DateTime']['output']>;
  linkedFrom: Maybe<RootPageLinkingCollections>;
  metaDescription: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/rootPage) */
export type RootPageBodyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/rootPage) */
export type RootPageIncludeLegalLogoArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/rootPage) */
export type RootPageLastUpdatedArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/rootPage) */
export type RootPageLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/rootPage) */
export type RootPageMetaDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/rootPage) */
export type RootPageSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/rootPage) */
export type RootPageTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type RootPageBody = {
  __typename: 'RootPageBody';
  json: Scalars['JSON']['output'];
  links: RootPageBodyLinks;
};

export type RootPageBodyAssets = {
  __typename: 'RootPageBodyAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type RootPageBodyEntries = {
  __typename: 'RootPageBodyEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type RootPageBodyLinks = {
  __typename: 'RootPageBodyLinks';
  assets: RootPageBodyAssets;
  entries: RootPageBodyEntries;
  resources: RootPageBodyResources;
};

export type RootPageBodyResources = {
  __typename: 'RootPageBodyResources';
  block: Array<RootPageBodyResourcesBlock>;
  hyperlink: Array<RootPageBodyResourcesHyperlink>;
  inline: Array<RootPageBodyResourcesInline>;
};

export type RootPageBodyResourcesBlock = ResourceLink & {
  __typename: 'RootPageBodyResourcesBlock';
  sys: ResourceSys;
};

export type RootPageBodyResourcesHyperlink = ResourceLink & {
  __typename: 'RootPageBodyResourcesHyperlink';
  sys: ResourceSys;
};

export type RootPageBodyResourcesInline = ResourceLink & {
  __typename: 'RootPageBodyResourcesInline';
  sys: ResourceSys;
};

export type RootPageCollection = {
  __typename: 'RootPageCollection';
  items: Array<Maybe<RootPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RootPageCursorCollection = {
  __typename: 'RootPageCursorCollection';
  items: Array<Maybe<RootPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type RootPageFilter = {
  AND: InputMaybe<Array<InputMaybe<RootPageFilter>>>;
  OR: InputMaybe<Array<InputMaybe<RootPageFilter>>>;
  body_contains: InputMaybe<Scalars['String']['input']>;
  body_exists: InputMaybe<Scalars['Boolean']['input']>;
  body_not_contains: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  includeLegalLogo: InputMaybe<Scalars['Boolean']['input']>;
  includeLegalLogo_exists: InputMaybe<Scalars['Boolean']['input']>;
  includeLegalLogo_not: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdated: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdated_exists: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdated_gt: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdated_gte: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdated_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastUpdated_lt: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdated_lte: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdated_not: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdated_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  metaDescription: InputMaybe<Scalars['String']['input']>;
  metaDescription_contains: InputMaybe<Scalars['String']['input']>;
  metaDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaDescription_not: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type RootPageLinkingCollections = {
  __typename: 'RootPageLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type RootPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum RootPageOrder {
  IncludeLegalLogoAsc = 'includeLegalLogo_ASC',
  IncludeLegalLogoDesc = 'includeLegalLogo_DESC',
  LastUpdatedAsc = 'lastUpdated_ASC',
  LastUpdatedDesc = 'lastUpdated_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/searchPage) */
export type SearchPage = Entry & _Node & {
  __typename: 'SearchPage';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  featuredSearches: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  linkedFrom: Maybe<SearchPageLinkingCollections>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/searchPage) */
export type SearchPageFeaturedSearchesArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/searchPage) */
export type SearchPageLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/searchPage) */
export type SearchPageTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type SearchPageCollection = {
  __typename: 'SearchPageCollection';
  items: Array<Maybe<SearchPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SearchPageCursorCollection = {
  __typename: 'SearchPageCursorCollection';
  items: Array<Maybe<SearchPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type SearchPageFilter = {
  AND: InputMaybe<Array<InputMaybe<SearchPageFilter>>>;
  OR: InputMaybe<Array<InputMaybe<SearchPageFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  featuredSearches_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featuredSearches_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featuredSearches_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featuredSearches_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SearchPageLinkingCollections = {
  __typename: 'SearchPageLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type SearchPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SearchPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SearchPageOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/spotlightSlideshow) */
export type SpotlightSlideshow = Entry & _Node & {
  __typename: 'SpotlightSlideshow';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  headline: Maybe<Scalars['String']['output']>;
  imagesCollection: Maybe<AssetCollection>;
  imagesCursorCollection: Maybe<AssetCursorCollection>;
  linkedFrom: Maybe<SpotlightSlideshowLinkingCollections>;
  subheadline: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/spotlightSlideshow) */
export type SpotlightSlideshowHeadlineArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/spotlightSlideshow) */
export type SpotlightSlideshowImagesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/spotlightSlideshow) */
export type SpotlightSlideshowImagesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/spotlightSlideshow) */
export type SpotlightSlideshowLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/spotlightSlideshow) */
export type SpotlightSlideshowSubheadlineArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type SpotlightSlideshowCollection = {
  __typename: 'SpotlightSlideshowCollection';
  items: Array<Maybe<SpotlightSlideshow>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SpotlightSlideshowCursorCollection = {
  __typename: 'SpotlightSlideshowCursorCollection';
  items: Array<Maybe<SpotlightSlideshow>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type SpotlightSlideshowFilter = {
  AND: InputMaybe<Array<InputMaybe<SpotlightSlideshowFilter>>>;
  OR: InputMaybe<Array<InputMaybe<SpotlightSlideshowFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  headline: InputMaybe<Scalars['String']['input']>;
  headline_contains: InputMaybe<Scalars['String']['input']>;
  headline_exists: InputMaybe<Scalars['Boolean']['input']>;
  headline_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline_not: InputMaybe<Scalars['String']['input']>;
  headline_not_contains: InputMaybe<Scalars['String']['input']>;
  headline_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imagesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  subheadline: InputMaybe<Scalars['String']['input']>;
  subheadline_contains: InputMaybe<Scalars['String']['input']>;
  subheadline_exists: InputMaybe<Scalars['Boolean']['input']>;
  subheadline_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subheadline_not: InputMaybe<Scalars['String']['input']>;
  subheadline_not_contains: InputMaybe<Scalars['String']['input']>;
  subheadline_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type SpotlightSlideshowLinkingCollections = {
  __typename: 'SpotlightSlideshowLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  grantResourcesCollection: Maybe<GrantResourcesCollection>;
  grantResourcesCursorCollection: Maybe<GrantResourcesCursorCollection>;
  homePageCollection: Maybe<HomePageCollection>;
  homePageCursorCollection: Maybe<HomePageCursorCollection>;
  ideaCollection: Maybe<IdeaCollection>;
  ideaCursorCollection: Maybe<IdeaCursorCollection>;
  mmufCollection: Maybe<MmufCollection>;
  mmufCursorCollection: Maybe<MmufCursorCollection>;
  personCollection: Maybe<PersonCollection>;
  personCursorCollection: Maybe<PersonCursorCollection>;
  pressRoomCollection: Maybe<PressRoomCollection>;
  pressRoomCursorCollection: Maybe<PressRoomCursorCollection>;
};


export type SpotlightSlideshowLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpotlightSlideshowLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpotlightSlideshowLinkingCollectionsGrantResourcesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpotlightSlideshowLinkingCollectionsGrantResourcesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpotlightSlideshowLinkingCollectionsGrantResourcesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpotlightSlideshowLinkingCollectionsGrantResourcesCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpotlightSlideshowLinkingCollectionsHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpotlightSlideshowLinkingCollectionsHomePageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpotlightSlideshowLinkingCollectionsHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpotlightSlideshowLinkingCollectionsHomePageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpotlightSlideshowLinkingCollectionsIdeaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpotlightSlideshowLinkingCollectionsIdeaCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpotlightSlideshowLinkingCollectionsIdeaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpotlightSlideshowLinkingCollectionsIdeaCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpotlightSlideshowLinkingCollectionsMmufCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpotlightSlideshowLinkingCollectionsMmufCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpotlightSlideshowLinkingCollectionsMmufCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpotlightSlideshowLinkingCollectionsMmufCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpotlightSlideshowLinkingCollectionsPersonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpotlightSlideshowLinkingCollectionsPersonCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpotlightSlideshowLinkingCollectionsPersonCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpotlightSlideshowLinkingCollectionsPersonCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpotlightSlideshowLinkingCollectionsPressRoomCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpotlightSlideshowLinkingCollectionsPressRoomCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpotlightSlideshowLinkingCollectionsPressRoomCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpotlightSlideshowLinkingCollectionsPressRoomCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SpotlightSlideshowLinkingCollectionsGrantResourcesCollectionOrder {
  ExplanatoryTitleAsc = 'explanatoryTitle_ASC',
  ExplanatoryTitleDesc = 'explanatoryTitle_DESC',
  GrantMakingAreasTitleAsc = 'grantMakingAreasTitle_ASC',
  GrantMakingAreasTitleDesc = 'grantMakingAreasTitle_DESC',
  SearchContextualMessageAsc = 'searchContextualMessage_ASC',
  SearchContextualMessageDesc = 'searchContextualMessage_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SpotlightSlideshowLinkingCollectionsGrantResourcesCursorCollectionOrder {
  ExplanatoryTitleAsc = 'explanatoryTitle_ASC',
  ExplanatoryTitleDesc = 'explanatoryTitle_DESC',
  GrantMakingAreasTitleAsc = 'grantMakingAreasTitle_ASC',
  GrantMakingAreasTitleDesc = 'grantMakingAreasTitle_DESC',
  SearchContextualMessageAsc = 'searchContextualMessage_ASC',
  SearchContextualMessageDesc = 'searchContextualMessage_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SpotlightSlideshowLinkingCollectionsHomePageCollectionOrder {
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  MissionTextAsc = 'missionText_ASC',
  MissionTextDesc = 'missionText_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StoriesCtaAsc = 'storiesCta_ASC',
  StoriesCtaDesc = 'storiesCta_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum SpotlightSlideshowLinkingCollectionsHomePageCursorCollectionOrder {
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  MissionTextAsc = 'missionText_ASC',
  MissionTextDesc = 'missionText_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StoriesCtaAsc = 'storiesCta_ASC',
  StoriesCtaDesc = 'storiesCta_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum SpotlightSlideshowLinkingCollectionsIdeaCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum SpotlightSlideshowLinkingCollectionsIdeaCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum SpotlightSlideshowLinkingCollectionsMmufCollectionOrder {
  ArticleTitleAsc = 'articleTitle_ASC',
  ArticleTitleDesc = 'articleTitle_DESC',
  AtGlanceTitleAsc = 'atGlanceTitle_ASC',
  AtGlanceTitleDesc = 'atGlanceTitle_DESC',
  ContactEmailAsc = 'contactEmail_ASC',
  ContactEmailDesc = 'contactEmail_DESC',
  ContactMessageAsc = 'contactMessage_ASC',
  ContactMessageDesc = 'contactMessage_DESC',
  ContactTitleAsc = 'contactTitle_ASC',
  ContactTitleDesc = 'contactTitle_DESC',
  FellowStoriesCtaLabelAsc = 'fellowStoriesCtaLabel_ASC',
  FellowStoriesCtaLabelDesc = 'fellowStoriesCtaLabel_DESC',
  FellowStoriesMessageAsc = 'fellowStoriesMessage_ASC',
  FellowStoriesMessageDesc = 'fellowStoriesMessage_DESC',
  GraduateInitiativesTitleAsc = 'graduateInitiativesTitle_ASC',
  GraduateInitiativesTitleDesc = 'graduateInitiativesTitle_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SpotlightSlideshowLinkingCollectionsMmufCursorCollectionOrder {
  ArticleTitleAsc = 'articleTitle_ASC',
  ArticleTitleDesc = 'articleTitle_DESC',
  AtGlanceTitleAsc = 'atGlanceTitle_ASC',
  AtGlanceTitleDesc = 'atGlanceTitle_DESC',
  ContactEmailAsc = 'contactEmail_ASC',
  ContactEmailDesc = 'contactEmail_DESC',
  ContactMessageAsc = 'contactMessage_ASC',
  ContactMessageDesc = 'contactMessage_DESC',
  ContactTitleAsc = 'contactTitle_ASC',
  ContactTitleDesc = 'contactTitle_DESC',
  FellowStoriesCtaLabelAsc = 'fellowStoriesCtaLabel_ASC',
  FellowStoriesCtaLabelDesc = 'fellowStoriesCtaLabel_DESC',
  FellowStoriesMessageAsc = 'fellowStoriesMessage_ASC',
  FellowStoriesMessageDesc = 'fellowStoriesMessage_DESC',
  GraduateInitiativesTitleAsc = 'graduateInitiativesTitle_ASC',
  GraduateInitiativesTitleDesc = 'graduateInitiativesTitle_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SpotlightSlideshowLinkingCollectionsPersonCollectionOrder {
  FirstNameAsc = 'firstName_ASC',
  FirstNameDesc = 'firstName_DESC',
  JobTitleAsc = 'jobTitle_ASC',
  JobTitleDesc = 'jobTitle_DESC',
  LastNameAsc = 'lastName_ASC',
  LastNameDesc = 'lastName_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  RelatedSectionTitleAsc = 'relatedSectionTitle_ASC',
  RelatedSectionTitleDesc = 'relatedSectionTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum SpotlightSlideshowLinkingCollectionsPersonCursorCollectionOrder {
  FirstNameAsc = 'firstName_ASC',
  FirstNameDesc = 'firstName_DESC',
  JobTitleAsc = 'jobTitle_ASC',
  JobTitleDesc = 'jobTitle_DESC',
  LastNameAsc = 'lastName_ASC',
  LastNameDesc = 'lastName_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  RelatedSectionTitleAsc = 'relatedSectionTitle_ASC',
  RelatedSectionTitleDesc = 'relatedSectionTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum SpotlightSlideshowLinkingCollectionsPressRoomCollectionOrder {
  ContactsTitleAsc = 'contactsTitle_ASC',
  ContactsTitleDesc = 'contactsTitle_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  EmailLabelAsc = 'emailLabel_ASC',
  EmailLabelDesc = 'emailLabel_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  GuidelinesAndMediasDescriptionAsc = 'guidelinesAndMediasDescription_ASC',
  GuidelinesAndMediasDescriptionDesc = 'guidelinesAndMediasDescription_DESC',
  GuidelinesAndMediasHeadingAsc = 'guidelinesAndMediasHeading_ASC',
  GuidelinesAndMediasHeadingDesc = 'guidelinesAndMediasHeading_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SpotlightSlideshowLinkingCollectionsPressRoomCursorCollectionOrder {
  ContactsTitleAsc = 'contactsTitle_ASC',
  ContactsTitleDesc = 'contactsTitle_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  EmailLabelAsc = 'emailLabel_ASC',
  EmailLabelDesc = 'emailLabel_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  GuidelinesAndMediasDescriptionAsc = 'guidelinesAndMediasDescription_ASC',
  GuidelinesAndMediasDescriptionDesc = 'guidelinesAndMediasDescription_DESC',
  GuidelinesAndMediasHeadingAsc = 'guidelinesAndMediasHeading_ASC',
  GuidelinesAndMediasHeadingDesc = 'guidelinesAndMediasHeading_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SpotlightSlideshowOrder {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SubheadlineAsc = 'subheadline_ASC',
  SubheadlineDesc = 'subheadline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/spotlightVideo) */
export type SpotlightVideo = Entry & _Node & {
  __typename: 'SpotlightVideo';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  ctaLabel: Maybe<Scalars['String']['output']>;
  headline: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<SpotlightVideoLinkingCollections>;
  previewStaticImage: Maybe<Asset>;
  previewVideo: Maybe<Asset>;
  previewVideoUrl: Maybe<Scalars['String']['output']>;
  subheadline: Maybe<Scalars['String']['output']>;
  sys: Sys;
  video: Maybe<Asset>;
  videoCaptions: Maybe<Asset>;
  videoUrl: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/spotlightVideo) */
export type SpotlightVideoCtaLabelArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/spotlightVideo) */
export type SpotlightVideoHeadlineArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/spotlightVideo) */
export type SpotlightVideoLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/spotlightVideo) */
export type SpotlightVideoPreviewStaticImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/spotlightVideo) */
export type SpotlightVideoPreviewVideoArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/spotlightVideo) */
export type SpotlightVideoPreviewVideoUrlArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/spotlightVideo) */
export type SpotlightVideoSubheadlineArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/spotlightVideo) */
export type SpotlightVideoVideoArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/spotlightVideo) */
export type SpotlightVideoVideoCaptionsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/spotlightVideo) */
export type SpotlightVideoVideoUrlArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type SpotlightVideoCollection = {
  __typename: 'SpotlightVideoCollection';
  items: Array<Maybe<SpotlightVideo>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SpotlightVideoCursorCollection = {
  __typename: 'SpotlightVideoCursorCollection';
  items: Array<Maybe<SpotlightVideo>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type SpotlightVideoFilter = {
  AND: InputMaybe<Array<InputMaybe<SpotlightVideoFilter>>>;
  OR: InputMaybe<Array<InputMaybe<SpotlightVideoFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  ctaLabel: InputMaybe<Scalars['String']['input']>;
  ctaLabel_contains: InputMaybe<Scalars['String']['input']>;
  ctaLabel_exists: InputMaybe<Scalars['Boolean']['input']>;
  ctaLabel_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaLabel_not: InputMaybe<Scalars['String']['input']>;
  ctaLabel_not_contains: InputMaybe<Scalars['String']['input']>;
  ctaLabel_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline: InputMaybe<Scalars['String']['input']>;
  headline_contains: InputMaybe<Scalars['String']['input']>;
  headline_exists: InputMaybe<Scalars['Boolean']['input']>;
  headline_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline_not: InputMaybe<Scalars['String']['input']>;
  headline_not_contains: InputMaybe<Scalars['String']['input']>;
  headline_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  previewStaticImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  previewVideoUrl: InputMaybe<Scalars['String']['input']>;
  previewVideoUrl_contains: InputMaybe<Scalars['String']['input']>;
  previewVideoUrl_exists: InputMaybe<Scalars['Boolean']['input']>;
  previewVideoUrl_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  previewVideoUrl_not: InputMaybe<Scalars['String']['input']>;
  previewVideoUrl_not_contains: InputMaybe<Scalars['String']['input']>;
  previewVideoUrl_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  previewVideo_exists: InputMaybe<Scalars['Boolean']['input']>;
  subheadline: InputMaybe<Scalars['String']['input']>;
  subheadline_contains: InputMaybe<Scalars['String']['input']>;
  subheadline_exists: InputMaybe<Scalars['Boolean']['input']>;
  subheadline_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subheadline_not: InputMaybe<Scalars['String']['input']>;
  subheadline_not_contains: InputMaybe<Scalars['String']['input']>;
  subheadline_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  videoCaptions_exists: InputMaybe<Scalars['Boolean']['input']>;
  videoUrl: InputMaybe<Scalars['String']['input']>;
  videoUrl_contains: InputMaybe<Scalars['String']['input']>;
  videoUrl_exists: InputMaybe<Scalars['Boolean']['input']>;
  videoUrl_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoUrl_not: InputMaybe<Scalars['String']['input']>;
  videoUrl_not_contains: InputMaybe<Scalars['String']['input']>;
  videoUrl_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  video_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type SpotlightVideoLinkingCollections = {
  __typename: 'SpotlightVideoLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  grantResourcesCollection: Maybe<GrantResourcesCollection>;
  grantResourcesCursorCollection: Maybe<GrantResourcesCursorCollection>;
  homePageCollection: Maybe<HomePageCollection>;
  homePageCursorCollection: Maybe<HomePageCursorCollection>;
  ideaCollection: Maybe<IdeaCollection>;
  ideaCursorCollection: Maybe<IdeaCursorCollection>;
  mmufCollection: Maybe<MmufCollection>;
  mmufCursorCollection: Maybe<MmufCursorCollection>;
  personCollection: Maybe<PersonCollection>;
  personCursorCollection: Maybe<PersonCursorCollection>;
  pressRoomCollection: Maybe<PressRoomCollection>;
  pressRoomCursorCollection: Maybe<PressRoomCursorCollection>;
};


export type SpotlightVideoLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpotlightVideoLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpotlightVideoLinkingCollectionsGrantResourcesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpotlightVideoLinkingCollectionsGrantResourcesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpotlightVideoLinkingCollectionsGrantResourcesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpotlightVideoLinkingCollectionsGrantResourcesCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpotlightVideoLinkingCollectionsHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpotlightVideoLinkingCollectionsHomePageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpotlightVideoLinkingCollectionsHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpotlightVideoLinkingCollectionsHomePageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpotlightVideoLinkingCollectionsIdeaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpotlightVideoLinkingCollectionsIdeaCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpotlightVideoLinkingCollectionsIdeaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpotlightVideoLinkingCollectionsIdeaCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpotlightVideoLinkingCollectionsMmufCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpotlightVideoLinkingCollectionsMmufCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpotlightVideoLinkingCollectionsMmufCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpotlightVideoLinkingCollectionsMmufCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpotlightVideoLinkingCollectionsPersonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpotlightVideoLinkingCollectionsPersonCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpotlightVideoLinkingCollectionsPersonCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpotlightVideoLinkingCollectionsPersonCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpotlightVideoLinkingCollectionsPressRoomCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpotlightVideoLinkingCollectionsPressRoomCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpotlightVideoLinkingCollectionsPressRoomCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpotlightVideoLinkingCollectionsPressRoomCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SpotlightVideoLinkingCollectionsGrantResourcesCollectionOrder {
  ExplanatoryTitleAsc = 'explanatoryTitle_ASC',
  ExplanatoryTitleDesc = 'explanatoryTitle_DESC',
  GrantMakingAreasTitleAsc = 'grantMakingAreasTitle_ASC',
  GrantMakingAreasTitleDesc = 'grantMakingAreasTitle_DESC',
  SearchContextualMessageAsc = 'searchContextualMessage_ASC',
  SearchContextualMessageDesc = 'searchContextualMessage_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SpotlightVideoLinkingCollectionsGrantResourcesCursorCollectionOrder {
  ExplanatoryTitleAsc = 'explanatoryTitle_ASC',
  ExplanatoryTitleDesc = 'explanatoryTitle_DESC',
  GrantMakingAreasTitleAsc = 'grantMakingAreasTitle_ASC',
  GrantMakingAreasTitleDesc = 'grantMakingAreasTitle_DESC',
  SearchContextualMessageAsc = 'searchContextualMessage_ASC',
  SearchContextualMessageDesc = 'searchContextualMessage_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SpotlightVideoLinkingCollectionsHomePageCollectionOrder {
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  MissionTextAsc = 'missionText_ASC',
  MissionTextDesc = 'missionText_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StoriesCtaAsc = 'storiesCta_ASC',
  StoriesCtaDesc = 'storiesCta_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum SpotlightVideoLinkingCollectionsHomePageCursorCollectionOrder {
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  MissionTextAsc = 'missionText_ASC',
  MissionTextDesc = 'missionText_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StoriesCtaAsc = 'storiesCta_ASC',
  StoriesCtaDesc = 'storiesCta_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum SpotlightVideoLinkingCollectionsIdeaCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum SpotlightVideoLinkingCollectionsIdeaCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum SpotlightVideoLinkingCollectionsMmufCollectionOrder {
  ArticleTitleAsc = 'articleTitle_ASC',
  ArticleTitleDesc = 'articleTitle_DESC',
  AtGlanceTitleAsc = 'atGlanceTitle_ASC',
  AtGlanceTitleDesc = 'atGlanceTitle_DESC',
  ContactEmailAsc = 'contactEmail_ASC',
  ContactEmailDesc = 'contactEmail_DESC',
  ContactMessageAsc = 'contactMessage_ASC',
  ContactMessageDesc = 'contactMessage_DESC',
  ContactTitleAsc = 'contactTitle_ASC',
  ContactTitleDesc = 'contactTitle_DESC',
  FellowStoriesCtaLabelAsc = 'fellowStoriesCtaLabel_ASC',
  FellowStoriesCtaLabelDesc = 'fellowStoriesCtaLabel_DESC',
  FellowStoriesMessageAsc = 'fellowStoriesMessage_ASC',
  FellowStoriesMessageDesc = 'fellowStoriesMessage_DESC',
  GraduateInitiativesTitleAsc = 'graduateInitiativesTitle_ASC',
  GraduateInitiativesTitleDesc = 'graduateInitiativesTitle_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SpotlightVideoLinkingCollectionsMmufCursorCollectionOrder {
  ArticleTitleAsc = 'articleTitle_ASC',
  ArticleTitleDesc = 'articleTitle_DESC',
  AtGlanceTitleAsc = 'atGlanceTitle_ASC',
  AtGlanceTitleDesc = 'atGlanceTitle_DESC',
  ContactEmailAsc = 'contactEmail_ASC',
  ContactEmailDesc = 'contactEmail_DESC',
  ContactMessageAsc = 'contactMessage_ASC',
  ContactMessageDesc = 'contactMessage_DESC',
  ContactTitleAsc = 'contactTitle_ASC',
  ContactTitleDesc = 'contactTitle_DESC',
  FellowStoriesCtaLabelAsc = 'fellowStoriesCtaLabel_ASC',
  FellowStoriesCtaLabelDesc = 'fellowStoriesCtaLabel_DESC',
  FellowStoriesMessageAsc = 'fellowStoriesMessage_ASC',
  FellowStoriesMessageDesc = 'fellowStoriesMessage_DESC',
  GraduateInitiativesTitleAsc = 'graduateInitiativesTitle_ASC',
  GraduateInitiativesTitleDesc = 'graduateInitiativesTitle_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SpotlightVideoLinkingCollectionsPersonCollectionOrder {
  FirstNameAsc = 'firstName_ASC',
  FirstNameDesc = 'firstName_DESC',
  JobTitleAsc = 'jobTitle_ASC',
  JobTitleDesc = 'jobTitle_DESC',
  LastNameAsc = 'lastName_ASC',
  LastNameDesc = 'lastName_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  RelatedSectionTitleAsc = 'relatedSectionTitle_ASC',
  RelatedSectionTitleDesc = 'relatedSectionTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum SpotlightVideoLinkingCollectionsPersonCursorCollectionOrder {
  FirstNameAsc = 'firstName_ASC',
  FirstNameDesc = 'firstName_DESC',
  JobTitleAsc = 'jobTitle_ASC',
  JobTitleDesc = 'jobTitle_DESC',
  LastNameAsc = 'lastName_ASC',
  LastNameDesc = 'lastName_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  RelatedSectionTitleAsc = 'relatedSectionTitle_ASC',
  RelatedSectionTitleDesc = 'relatedSectionTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum SpotlightVideoLinkingCollectionsPressRoomCollectionOrder {
  ContactsTitleAsc = 'contactsTitle_ASC',
  ContactsTitleDesc = 'contactsTitle_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  EmailLabelAsc = 'emailLabel_ASC',
  EmailLabelDesc = 'emailLabel_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  GuidelinesAndMediasDescriptionAsc = 'guidelinesAndMediasDescription_ASC',
  GuidelinesAndMediasDescriptionDesc = 'guidelinesAndMediasDescription_DESC',
  GuidelinesAndMediasHeadingAsc = 'guidelinesAndMediasHeading_ASC',
  GuidelinesAndMediasHeadingDesc = 'guidelinesAndMediasHeading_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SpotlightVideoLinkingCollectionsPressRoomCursorCollectionOrder {
  ContactsTitleAsc = 'contactsTitle_ASC',
  ContactsTitleDesc = 'contactsTitle_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  EmailLabelAsc = 'emailLabel_ASC',
  EmailLabelDesc = 'emailLabel_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  GuidelinesAndMediasDescriptionAsc = 'guidelinesAndMediasDescription_ASC',
  GuidelinesAndMediasDescriptionDesc = 'guidelinesAndMediasDescription_DESC',
  GuidelinesAndMediasHeadingAsc = 'guidelinesAndMediasHeading_ASC',
  GuidelinesAndMediasHeadingDesc = 'guidelinesAndMediasHeading_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SpotlightVideoOrder {
  CtaLabelAsc = 'ctaLabel_ASC',
  CtaLabelDesc = 'ctaLabel_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  PreviewVideoUrlAsc = 'previewVideoUrl_ASC',
  PreviewVideoUrlDesc = 'previewVideoUrl_DESC',
  SubheadlineAsc = 'subheadline_ASC',
  SubheadlineDesc = 'subheadline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VideoUrlAsc = 'videoUrl_ASC',
  VideoUrlDesc = 'videoUrl_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/storiesPage) */
export type StoriesPage = Entry & _Node & {
  __typename: 'StoriesPage';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  description: Maybe<Scalars['String']['output']>;
  highlightedFeature: Maybe<Feature>;
  linkedFrom: Maybe<StoriesPageLinkingCollections>;
  slug: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/storiesPage) */
export type StoriesPageDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/storiesPage) */
export type StoriesPageHighlightedFeatureArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<FeatureFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/storiesPage) */
export type StoriesPageLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/storiesPage) */
export type StoriesPageSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/storiesPage) */
export type StoriesPageTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type StoriesPageCollection = {
  __typename: 'StoriesPageCollection';
  items: Array<Maybe<StoriesPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type StoriesPageCursorCollection = {
  __typename: 'StoriesPageCursorCollection';
  items: Array<Maybe<StoriesPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type StoriesPageFilter = {
  AND: InputMaybe<Array<InputMaybe<StoriesPageFilter>>>;
  OR: InputMaybe<Array<InputMaybe<StoriesPageFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  highlightedFeature: InputMaybe<CfFeatureNestedFilter>;
  highlightedFeature_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StoriesPageLinkingCollections = {
  __typename: 'StoriesPageLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  navigationItemCollection: Maybe<NavigationItemCollection>;
  navigationItemCursorCollection: Maybe<NavigationItemCursorCollection>;
  resourcesCurrentGranteesCollection: Maybe<ResourcesCurrentGranteesCollection>;
  resourcesCurrentGranteesCursorCollection: Maybe<ResourcesCurrentGranteesCursorCollection>;
};


export type StoriesPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type StoriesPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type StoriesPageLinkingCollectionsNavigationItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<StoriesPageLinkingCollectionsNavigationItemCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type StoriesPageLinkingCollectionsNavigationItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<StoriesPageLinkingCollectionsNavigationItemCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type StoriesPageLinkingCollectionsResourcesCurrentGranteesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<StoriesPageLinkingCollectionsResourcesCurrentGranteesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type StoriesPageLinkingCollectionsResourcesCurrentGranteesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<StoriesPageLinkingCollectionsResourcesCurrentGranteesCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum StoriesPageLinkingCollectionsNavigationItemCollectionOrder {
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum StoriesPageLinkingCollectionsNavigationItemCursorCollectionOrder {
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum StoriesPageLinkingCollectionsResourcesCurrentGranteesCollectionOrder {
  GrantDatabaseCtaTextAsc = 'grantDatabaseCtaText_ASC',
  GrantDatabaseCtaTextDesc = 'grantDatabaseCtaText_DESC',
  ResourcesTitleAsc = 'resourcesTitle_ASC',
  ResourcesTitleDesc = 'resourcesTitle_DESC',
  SimilarGranteesTitleAsc = 'similarGranteesTitle_ASC',
  SimilarGranteesTitleDesc = 'similarGranteesTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum StoriesPageLinkingCollectionsResourcesCurrentGranteesCursorCollectionOrder {
  GrantDatabaseCtaTextAsc = 'grantDatabaseCtaText_ASC',
  GrantDatabaseCtaTextDesc = 'grantDatabaseCtaText_DESC',
  ResourcesTitleAsc = 'resourcesTitle_ASC',
  ResourcesTitleDesc = 'resourcesTitle_DESC',
  SimilarGranteesTitleAsc = 'similarGranteesTitle_ASC',
  SimilarGranteesTitleDesc = 'similarGranteesTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum StoriesPageOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type Sys = {
  __typename: 'Sys';
  environmentId: Scalars['String']['output'];
  firstPublishedAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  /** The locale that was requested. */
  locale: Maybe<Scalars['String']['output']>;
  publishedAt: Maybe<Scalars['DateTime']['output']>;
  publishedVersion: Maybe<Scalars['Int']['output']>;
  spaceId: Scalars['String']['output'];
};

export type SysFilter = {
  firstPublishedAt: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  firstPublishedAt_gt: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_gte: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  firstPublishedAt_lt: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_lte: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_not: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  id: InputMaybe<Scalars['String']['input']>;
  id_contains: InputMaybe<Scalars['String']['input']>;
  id_exists: InputMaybe<Scalars['Boolean']['input']>;
  id_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not: InputMaybe<Scalars['String']['input']>;
  id_not_contains: InputMaybe<Scalars['String']['input']>;
  id_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  publishedAt: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt_gt: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_gte: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedAt_lt: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_lte: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedVersion: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_exists: InputMaybe<Scalars['Boolean']['input']>;
  publishedVersion_gt: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_gte: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  publishedVersion_lt: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_lte: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_not: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_not_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/taxonomy) */
export type Taxonomy = Entry & _Node & {
  __typename: 'Taxonomy';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  facet: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<TaxonomyLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/taxonomy) */
export type TaxonomyFacetArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/taxonomy) */
export type TaxonomyLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TaxonomyCollection = {
  __typename: 'TaxonomyCollection';
  items: Array<Maybe<Taxonomy>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

/**
 * Represents a taxonomy concept entity for finding and organizing content easily.
 *         Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-concepts
 */
export type TaxonomyConcept = {
  __typename: 'TaxonomyConcept';
  id: Maybe<Scalars['String']['output']>;
};

export type TaxonomyCursorCollection = {
  __typename: 'TaxonomyCursorCollection';
  items: Array<Maybe<Taxonomy>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type TaxonomyFilter = {
  AND: InputMaybe<Array<InputMaybe<TaxonomyFilter>>>;
  OR: InputMaybe<Array<InputMaybe<TaxonomyFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  facet: InputMaybe<Scalars['String']['input']>;
  facet_contains: InputMaybe<Scalars['String']['input']>;
  facet_exists: InputMaybe<Scalars['Boolean']['input']>;
  facet_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facet_not: InputMaybe<Scalars['String']['input']>;
  facet_not_contains: InputMaybe<Scalars['String']['input']>;
  facet_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type TaxonomyLinkingCollections = {
  __typename: 'TaxonomyLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type TaxonomyLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type TaxonomyLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum TaxonomyOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/termsOfUse) */
export type TermsOfUse = Entry & _Node & {
  __typename: 'TermsOfUse';
  _id: Scalars['ID']['output'];
  addressDetails: Maybe<Scalars['String']['output']>;
  body: Maybe<Scalars['String']['output']>;
  contactDetails: Maybe<Scalars['String']['output']>;
  contactDetailsEmail: Maybe<Scalars['String']['output']>;
  contactDetailsParagraph: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  description: Maybe<Scalars['String']['output']>;
  lastRevisedDate: Maybe<Scalars['DateTime']['output']>;
  linkedFrom: Maybe<TermsOfUseLinkingCollections>;
  slug: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/termsOfUse) */
export type TermsOfUseAddressDetailsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/termsOfUse) */
export type TermsOfUseBodyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/termsOfUse) */
export type TermsOfUseContactDetailsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/termsOfUse) */
export type TermsOfUseContactDetailsEmailArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/termsOfUse) */
export type TermsOfUseContactDetailsParagraphArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/termsOfUse) */
export type TermsOfUseDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/termsOfUse) */
export type TermsOfUseLastRevisedDateArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/termsOfUse) */
export type TermsOfUseLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/termsOfUse) */
export type TermsOfUseSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/termsOfUse) */
export type TermsOfUseTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type TermsOfUseCollection = {
  __typename: 'TermsOfUseCollection';
  items: Array<Maybe<TermsOfUse>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TermsOfUseCursorCollection = {
  __typename: 'TermsOfUseCursorCollection';
  items: Array<Maybe<TermsOfUse>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type TermsOfUseFilter = {
  AND: InputMaybe<Array<InputMaybe<TermsOfUseFilter>>>;
  OR: InputMaybe<Array<InputMaybe<TermsOfUseFilter>>>;
  addressDetails: InputMaybe<Scalars['String']['input']>;
  addressDetails_contains: InputMaybe<Scalars['String']['input']>;
  addressDetails_exists: InputMaybe<Scalars['Boolean']['input']>;
  addressDetails_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  addressDetails_not: InputMaybe<Scalars['String']['input']>;
  addressDetails_not_contains: InputMaybe<Scalars['String']['input']>;
  addressDetails_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body: InputMaybe<Scalars['String']['input']>;
  body_contains: InputMaybe<Scalars['String']['input']>;
  body_exists: InputMaybe<Scalars['Boolean']['input']>;
  body_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_not: InputMaybe<Scalars['String']['input']>;
  body_not_contains: InputMaybe<Scalars['String']['input']>;
  body_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactDetails: InputMaybe<Scalars['String']['input']>;
  contactDetailsEmail: InputMaybe<Scalars['String']['input']>;
  contactDetailsEmail_contains: InputMaybe<Scalars['String']['input']>;
  contactDetailsEmail_exists: InputMaybe<Scalars['Boolean']['input']>;
  contactDetailsEmail_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactDetailsEmail_not: InputMaybe<Scalars['String']['input']>;
  contactDetailsEmail_not_contains: InputMaybe<Scalars['String']['input']>;
  contactDetailsEmail_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactDetailsParagraph: InputMaybe<Scalars['String']['input']>;
  contactDetailsParagraph_contains: InputMaybe<Scalars['String']['input']>;
  contactDetailsParagraph_exists: InputMaybe<Scalars['Boolean']['input']>;
  contactDetailsParagraph_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactDetailsParagraph_not: InputMaybe<Scalars['String']['input']>;
  contactDetailsParagraph_not_contains: InputMaybe<Scalars['String']['input']>;
  contactDetailsParagraph_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactDetails_contains: InputMaybe<Scalars['String']['input']>;
  contactDetails_exists: InputMaybe<Scalars['Boolean']['input']>;
  contactDetails_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactDetails_not: InputMaybe<Scalars['String']['input']>;
  contactDetails_not_contains: InputMaybe<Scalars['String']['input']>;
  contactDetails_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastRevisedDate: InputMaybe<Scalars['DateTime']['input']>;
  lastRevisedDate_exists: InputMaybe<Scalars['Boolean']['input']>;
  lastRevisedDate_gt: InputMaybe<Scalars['DateTime']['input']>;
  lastRevisedDate_gte: InputMaybe<Scalars['DateTime']['input']>;
  lastRevisedDate_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastRevisedDate_lt: InputMaybe<Scalars['DateTime']['input']>;
  lastRevisedDate_lte: InputMaybe<Scalars['DateTime']['input']>;
  lastRevisedDate_not: InputMaybe<Scalars['DateTime']['input']>;
  lastRevisedDate_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TermsOfUseLinkingCollections = {
  __typename: 'TermsOfUseLinkingCollections';
  connectWithLinkCollection: Maybe<ConnectWithLinkCollection>;
  connectWithLinkCursorCollection: Maybe<ConnectWithLinkCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type TermsOfUseLinkingCollectionsConnectWithLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<TermsOfUseLinkingCollectionsConnectWithLinkCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type TermsOfUseLinkingCollectionsConnectWithLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<TermsOfUseLinkingCollectionsConnectWithLinkCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type TermsOfUseLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type TermsOfUseLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum TermsOfUseLinkingCollectionsConnectWithLinkCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum TermsOfUseLinkingCollectionsConnectWithLinkCursorCollectionOrder {
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum TermsOfUseOrder {
  ContactDetailsEmailAsc = 'contactDetailsEmail_ASC',
  ContactDetailsEmailDesc = 'contactDetailsEmail_DESC',
  ContactDetailsAsc = 'contactDetails_ASC',
  ContactDetailsDesc = 'contactDetails_DESC',
  LastRevisedDateAsc = 'lastRevisedDate_ASC',
  LastRevisedDateDesc = 'lastRevisedDate_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/theme) */
export type Theme = Entry & _Node & {
  __typename: 'Theme';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  copy: Maybe<Scalars['String']['output']>;
  fullScreenAnimation: Maybe<Scalars['Boolean']['output']>;
  linkedFrom: Maybe<ThemeLinkingCollections>;
  primary: Maybe<Scalars['String']['output']>;
  secondary: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/theme) */
export type ThemeCopyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/theme) */
export type ThemeFullScreenAnimationArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/theme) */
export type ThemeLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/theme) */
export type ThemePrimaryArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/theme) */
export type ThemeSecondaryArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/theme) */
export type ThemeSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ThemeCollection = {
  __typename: 'ThemeCollection';
  items: Array<Maybe<Theme>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ThemeCursorCollection = {
  __typename: 'ThemeCursorCollection';
  items: Array<Maybe<Theme>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ThemeFilter = {
  AND: InputMaybe<Array<InputMaybe<ThemeFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ThemeFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  copy: InputMaybe<Scalars['String']['input']>;
  copy_contains: InputMaybe<Scalars['String']['input']>;
  copy_exists: InputMaybe<Scalars['Boolean']['input']>;
  copy_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  copy_not: InputMaybe<Scalars['String']['input']>;
  copy_not_contains: InputMaybe<Scalars['String']['input']>;
  copy_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fullScreenAnimation: InputMaybe<Scalars['Boolean']['input']>;
  fullScreenAnimation_exists: InputMaybe<Scalars['Boolean']['input']>;
  fullScreenAnimation_not: InputMaybe<Scalars['Boolean']['input']>;
  primary: InputMaybe<Scalars['String']['input']>;
  primary_contains: InputMaybe<Scalars['String']['input']>;
  primary_exists: InputMaybe<Scalars['Boolean']['input']>;
  primary_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  primary_not: InputMaybe<Scalars['String']['input']>;
  primary_not_contains: InputMaybe<Scalars['String']['input']>;
  primary_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  secondary: InputMaybe<Scalars['String']['input']>;
  secondary_contains: InputMaybe<Scalars['String']['input']>;
  secondary_exists: InputMaybe<Scalars['Boolean']['input']>;
  secondary_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  secondary_not: InputMaybe<Scalars['String']['input']>;
  secondary_not_contains: InputMaybe<Scalars['String']['input']>;
  secondary_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type ThemeLinkingCollections = {
  __typename: 'ThemeLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type ThemeLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ThemeLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ThemeOrder {
  CopyAsc = 'copy_ASC',
  CopyDesc = 'copy_DESC',
  FullScreenAnimationAsc = 'fullScreenAnimation_ASC',
  FullScreenAnimationDesc = 'fullScreenAnimation_DESC',
  PrimaryAsc = 'primary_ASC',
  PrimaryDesc = 'primary_DESC',
  SecondaryAsc = 'secondary_ASC',
  SecondaryDesc = 'secondary_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type TimelineFilterInput = {
  /** Preview content starting from a given release date */
  release_lte: InputMaybe<Scalars['String']['input']>;
  /** Preview content starting from a given timestamp */
  timestamp_lte: InputMaybe<Scalars['DateTime']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/trustee) */
export type Trustee = Entry & _Node & {
  __typename: 'Trustee';
  _id: Scalars['ID']['output'];
  company: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  image: Maybe<Asset>;
  jobTitle: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<TrusteeLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/trustee) */
export type TrusteeCompanyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/trustee) */
export type TrusteeImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/trustee) */
export type TrusteeJobTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/trustee) */
export type TrusteeLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/trustee) */
export type TrusteeNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type TrusteeCollection = {
  __typename: 'TrusteeCollection';
  items: Array<Maybe<Trustee>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TrusteeCursorCollection = {
  __typename: 'TrusteeCursorCollection';
  items: Array<Maybe<Trustee>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type TrusteeFilter = {
  AND: InputMaybe<Array<InputMaybe<TrusteeFilter>>>;
  OR: InputMaybe<Array<InputMaybe<TrusteeFilter>>>;
  company: InputMaybe<Scalars['String']['input']>;
  company_contains: InputMaybe<Scalars['String']['input']>;
  company_exists: InputMaybe<Scalars['Boolean']['input']>;
  company_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  company_not: InputMaybe<Scalars['String']['input']>;
  company_not_contains: InputMaybe<Scalars['String']['input']>;
  company_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  image_exists: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle: InputMaybe<Scalars['String']['input']>;
  jobTitle_contains: InputMaybe<Scalars['String']['input']>;
  jobTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  jobTitle_not: InputMaybe<Scalars['String']['input']>;
  jobTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  jobTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type TrusteeLinkingCollections = {
  __typename: 'TrusteeLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  trusteesPageCollection: Maybe<TrusteesPageCollection>;
  trusteesPageCursorCollection: Maybe<TrusteesPageCursorCollection>;
};


export type TrusteeLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type TrusteeLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type TrusteeLinkingCollectionsTrusteesPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<TrusteeLinkingCollectionsTrusteesPageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type TrusteeLinkingCollectionsTrusteesPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<TrusteeLinkingCollectionsTrusteesPageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum TrusteeLinkingCollectionsTrusteesPageCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum TrusteeLinkingCollectionsTrusteesPageCursorCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum TrusteeOrder {
  CompanyAsc = 'company_ASC',
  CompanyDesc = 'company_DESC',
  JobTitleAsc = 'jobTitle_ASC',
  JobTitleDesc = 'jobTitle_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/trusteesPage) */
export type TrusteesPage = Entry & _Node & {
  __typename: 'TrusteesPage';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<TrusteesPageLinkingCollections>;
  slug: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
  trusteesCollection: Maybe<TrusteesPageTrusteesCollection>;
  trusteesCursorCollection: Maybe<TrusteesPageTrusteesCursorCollection>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/trusteesPage) */
export type TrusteesPageLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/trusteesPage) */
export type TrusteesPageSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/trusteesPage) */
export type TrusteesPageTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/trusteesPage) */
export type TrusteesPageTrusteesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<TrusteesPageTrusteesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<TrusteeFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/trusteesPage) */
export type TrusteesPageTrusteesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<TrusteesPageTrusteesCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<TrusteeFilter>;
};

export type TrusteesPageCollection = {
  __typename: 'TrusteesPageCollection';
  items: Array<Maybe<TrusteesPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TrusteesPageCursorCollection = {
  __typename: 'TrusteesPageCursorCollection';
  items: Array<Maybe<TrusteesPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type TrusteesPageFilter = {
  AND: InputMaybe<Array<InputMaybe<TrusteesPageFilter>>>;
  OR: InputMaybe<Array<InputMaybe<TrusteesPageFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  trustees: InputMaybe<CfTrusteeNestedFilter>;
  trusteesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type TrusteesPageLinkingCollections = {
  __typename: 'TrusteesPageLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type TrusteesPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type TrusteesPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum TrusteesPageOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type TrusteesPageTrusteesCollection = {
  __typename: 'TrusteesPageTrusteesCollection';
  items: Array<Maybe<Trustee>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum TrusteesPageTrusteesCollectionOrder {
  CompanyAsc = 'company_ASC',
  CompanyDesc = 'company_DESC',
  JobTitleAsc = 'jobTitle_ASC',
  JobTitleDesc = 'jobTitle_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type TrusteesPageTrusteesCursorCollection = {
  __typename: 'TrusteesPageTrusteesCursorCollection';
  items: Array<Maybe<Trustee>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum TrusteesPageTrusteesCursorCollectionOrder {
  CompanyAsc = 'company_ASC',
  CompanyDesc = 'company_DESC',
  JobTitleAsc = 'jobTitle_ASC',
  JobTitleDesc = 'jobTitle_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/videoNative) */
export type VideoNative = Entry & _Node & {
  __typename: 'VideoNative';
  _id: Scalars['ID']['output'];
  caption: Maybe<Scalars['String']['output']>;
  closedCaptions: Maybe<Asset>;
  contentfulMetadata: ContentfulMetadata;
  isAmbient: Maybe<Scalars['Boolean']['output']>;
  isVertical: Maybe<Scalars['Boolean']['output']>;
  linkedFrom: Maybe<VideoNativeLinkingCollections>;
  preview: Maybe<Asset>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
  video: Maybe<Asset>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/videoNative) */
export type VideoNativeCaptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/videoNative) */
export type VideoNativeClosedCaptionsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/videoNative) */
export type VideoNativeIsAmbientArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/videoNative) */
export type VideoNativeIsVerticalArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/videoNative) */
export type VideoNativeLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/videoNative) */
export type VideoNativePreviewArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/videoNative) */
export type VideoNativeTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/videoNative) */
export type VideoNativeVideoArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type VideoNativeCollection = {
  __typename: 'VideoNativeCollection';
  items: Array<Maybe<VideoNative>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type VideoNativeCursorCollection = {
  __typename: 'VideoNativeCursorCollection';
  items: Array<Maybe<VideoNative>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type VideoNativeFilter = {
  AND: InputMaybe<Array<InputMaybe<VideoNativeFilter>>>;
  OR: InputMaybe<Array<InputMaybe<VideoNativeFilter>>>;
  caption: InputMaybe<Scalars['String']['input']>;
  caption_contains: InputMaybe<Scalars['String']['input']>;
  caption_exists: InputMaybe<Scalars['Boolean']['input']>;
  caption_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  caption_not: InputMaybe<Scalars['String']['input']>;
  caption_not_contains: InputMaybe<Scalars['String']['input']>;
  caption_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  closedCaptions_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  isAmbient: InputMaybe<Scalars['Boolean']['input']>;
  isAmbient_exists: InputMaybe<Scalars['Boolean']['input']>;
  isAmbient_not: InputMaybe<Scalars['Boolean']['input']>;
  isVertical: InputMaybe<Scalars['Boolean']['input']>;
  isVertical_exists: InputMaybe<Scalars['Boolean']['input']>;
  isVertical_not: InputMaybe<Scalars['Boolean']['input']>;
  preview_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  video_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type VideoNativeLinkingCollections = {
  __typename: 'VideoNativeLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  experienceBlockCollection: Maybe<ExperienceBlockCollection>;
  experienceBlockCursorCollection: Maybe<ExperienceBlockCursorCollection>;
  homePageCollection: Maybe<HomePageCollection>;
  homePageCursorCollection: Maybe<HomePageCursorCollection>;
};


export type VideoNativeLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type VideoNativeLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type VideoNativeLinkingCollectionsExperienceBlockCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<VideoNativeLinkingCollectionsExperienceBlockCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type VideoNativeLinkingCollectionsExperienceBlockCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<VideoNativeLinkingCollectionsExperienceBlockCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type VideoNativeLinkingCollectionsHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<VideoNativeLinkingCollectionsHomePageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type VideoNativeLinkingCollectionsHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<VideoNativeLinkingCollectionsHomePageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum VideoNativeLinkingCollectionsExperienceBlockCollectionOrder {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum VideoNativeLinkingCollectionsExperienceBlockCursorCollectionOrder {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum VideoNativeLinkingCollectionsHomePageCollectionOrder {
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  MissionTextAsc = 'missionText_ASC',
  MissionTextDesc = 'missionText_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StoriesCtaAsc = 'storiesCta_ASC',
  StoriesCtaDesc = 'storiesCta_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum VideoNativeLinkingCollectionsHomePageCursorCollectionOrder {
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  InFocusHeadlineAsc = 'inFocusHeadline_ASC',
  InFocusHeadlineDesc = 'inFocusHeadline_DESC',
  LayoutAsc = 'layout_ASC',
  LayoutDesc = 'layout_DESC',
  MissionTextAsc = 'missionText_ASC',
  MissionTextDesc = 'missionText_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StoriesCtaAsc = 'storiesCta_ASC',
  StoriesCtaDesc = 'storiesCta_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum VideoNativeOrder {
  IsAmbientAsc = 'isAmbient_ASC',
  IsAmbientDesc = 'isAmbient_DESC',
  IsVerticalAsc = 'isVertical_ASC',
  IsVerticalDesc = 'isVertical_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/videoYoutube) */
export type VideoYoutube = Entry & _Node & {
  __typename: 'VideoYoutube';
  _id: Scalars['ID']['output'];
  caption: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<VideoYoutubeLinkingCollections>;
  preview: Maybe<Asset>;
  sys: Sys;
  url: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/videoYoutube) */
export type VideoYoutubeCaptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/videoYoutube) */
export type VideoYoutubeLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/videoYoutube) */
export type VideoYoutubePreviewArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/nslp74meuw3d/content_types/videoYoutube) */
export type VideoYoutubeUrlArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type VideoYoutubeCollection = {
  __typename: 'VideoYoutubeCollection';
  items: Array<Maybe<VideoYoutube>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type VideoYoutubeCursorCollection = {
  __typename: 'VideoYoutubeCursorCollection';
  items: Array<Maybe<VideoYoutube>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type VideoYoutubeFilter = {
  AND: InputMaybe<Array<InputMaybe<VideoYoutubeFilter>>>;
  OR: InputMaybe<Array<InputMaybe<VideoYoutubeFilter>>>;
  caption: InputMaybe<Scalars['String']['input']>;
  caption_contains: InputMaybe<Scalars['String']['input']>;
  caption_exists: InputMaybe<Scalars['Boolean']['input']>;
  caption_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  caption_not: InputMaybe<Scalars['String']['input']>;
  caption_not_contains: InputMaybe<Scalars['String']['input']>;
  caption_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  preview_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  url: InputMaybe<Scalars['String']['input']>;
  url_contains: InputMaybe<Scalars['String']['input']>;
  url_exists: InputMaybe<Scalars['Boolean']['input']>;
  url_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not: InputMaybe<Scalars['String']['input']>;
  url_not_contains: InputMaybe<Scalars['String']['input']>;
  url_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type VideoYoutubeLinkingCollections = {
  __typename: 'VideoYoutubeLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type VideoYoutubeLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type VideoYoutubeLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum VideoYoutubeOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

export type _Node = {
  _id: Scalars['ID']['output'];
};

export type CfArticleNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfArticleNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfArticleNestedFilter>>>;
  audio_exists: InputMaybe<Scalars['Boolean']['input']>;
  author: InputMaybe<Scalars['String']['input']>;
  author_contains: InputMaybe<Scalars['String']['input']>;
  author_exists: InputMaybe<Scalars['Boolean']['input']>;
  author_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  author_not: InputMaybe<Scalars['String']['input']>;
  author_not_contains: InputMaybe<Scalars['String']['input']>;
  author_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_contains: InputMaybe<Scalars['String']['input']>;
  body_exists: InputMaybe<Scalars['Boolean']['input']>;
  body_not_contains: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  creditLabel: InputMaybe<Scalars['String']['input']>;
  creditLabel_contains: InputMaybe<Scalars['String']['input']>;
  creditLabel_exists: InputMaybe<Scalars['Boolean']['input']>;
  creditLabel_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  creditLabel_not: InputMaybe<Scalars['String']['input']>;
  creditLabel_not_contains: InputMaybe<Scalars['String']['input']>;
  creditLabel_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  creditText: InputMaybe<Scalars['String']['input']>;
  creditText_contains: InputMaybe<Scalars['String']['input']>;
  creditText_exists: InputMaybe<Scalars['Boolean']['input']>;
  creditText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  creditText_not: InputMaybe<Scalars['String']['input']>;
  creditText_not_contains: InputMaybe<Scalars['String']['input']>;
  creditText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  date: InputMaybe<Scalars['DateTime']['input']>;
  date_exists: InputMaybe<Scalars['Boolean']['input']>;
  date_gt: InputMaybe<Scalars['DateTime']['input']>;
  date_gte: InputMaybe<Scalars['DateTime']['input']>;
  date_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_lt: InputMaybe<Scalars['DateTime']['input']>;
  date_lte: InputMaybe<Scalars['DateTime']['input']>;
  date_not: InputMaybe<Scalars['DateTime']['input']>;
  date_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalNewsUrl: InputMaybe<Scalars['String']['input']>;
  externalNewsUrl_contains: InputMaybe<Scalars['String']['input']>;
  externalNewsUrl_exists: InputMaybe<Scalars['Boolean']['input']>;
  externalNewsUrl_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalNewsUrl_not: InputMaybe<Scalars['String']['input']>;
  externalNewsUrl_not_contains: InputMaybe<Scalars['String']['input']>;
  externalNewsUrl_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalPerson_exists: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow: InputMaybe<Scalars['String']['input']>;
  eyebrow_contains: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faqs_exists: InputMaybe<Scalars['Boolean']['input']>;
  formattingOptions_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattingOptions_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattingOptions_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattingOptions_exists: InputMaybe<Scalars['Boolean']['input']>;
  grantMakingArea_exists: InputMaybe<Scalars['Boolean']['input']>;
  heroImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  hero_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideDate: InputMaybe<Scalars['Boolean']['input']>;
  hideDate_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideDate_not: InputMaybe<Scalars['Boolean']['input']>;
  hideShareLink: InputMaybe<Scalars['Boolean']['input']>;
  hideShareLink_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideShareLink_not: InputMaybe<Scalars['Boolean']['input']>;
  location: InputMaybe<Scalars['String']['input']>;
  location_contains: InputMaybe<Scalars['String']['input']>;
  location_exists: InputMaybe<Scalars['Boolean']['input']>;
  location_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location_not: InputMaybe<Scalars['String']['input']>;
  location_not_contains: InputMaybe<Scalars['String']['input']>;
  location_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metadata_exists: InputMaybe<Scalars['Boolean']['input']>;
  password: InputMaybe<Scalars['String']['input']>;
  passwordProtectedPage_exists: InputMaybe<Scalars['Boolean']['input']>;
  password_contains: InputMaybe<Scalars['String']['input']>;
  password_exists: InputMaybe<Scalars['Boolean']['input']>;
  password_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  password_not: InputMaybe<Scalars['String']['input']>;
  password_not_contains: InputMaybe<Scalars['String']['input']>;
  password_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  person_exists: InputMaybe<Scalars['Boolean']['input']>;
  photographer: InputMaybe<Scalars['String']['input']>;
  photographer_contains: InputMaybe<Scalars['String']['input']>;
  photographer_exists: InputMaybe<Scalars['Boolean']['input']>;
  photographer_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  photographer_not: InputMaybe<Scalars['String']['input']>;
  photographer_not_contains: InputMaybe<Scalars['String']['input']>;
  photographer_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  publisherLogo_exists: InputMaybe<Scalars['Boolean']['input']>;
  quickLinks_exists: InputMaybe<Scalars['Boolean']['input']>;
  relatedContentCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  thumbnailImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type: InputMaybe<Scalars['String']['input']>;
  type_contains: InputMaybe<Scalars['String']['input']>;
  type_exists: InputMaybe<Scalars['Boolean']['input']>;
  type_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not: InputMaybe<Scalars['String']['input']>;
  type_not_contains: InputMaybe<Scalars['String']['input']>;
  type_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfAtGlanceCardNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfAtGlanceCardNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfAtGlanceCardNestedFilter>>>;
  bodyText: InputMaybe<Scalars['String']['input']>;
  bodyText_contains: InputMaybe<Scalars['String']['input']>;
  bodyText_exists: InputMaybe<Scalars['Boolean']['input']>;
  bodyText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyText_not: InputMaybe<Scalars['String']['input']>;
  bodyText_not_contains: InputMaybe<Scalars['String']['input']>;
  bodyText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  ctaText: InputMaybe<Scalars['String']['input']>;
  ctaText_contains: InputMaybe<Scalars['String']['input']>;
  ctaText_exists: InputMaybe<Scalars['Boolean']['input']>;
  ctaText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaText_not: InputMaybe<Scalars['String']['input']>;
  ctaText_not_contains: InputMaybe<Scalars['String']['input']>;
  ctaText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading: InputMaybe<Scalars['String']['input']>;
  heading_contains: InputMaybe<Scalars['String']['input']>;
  heading_exists: InputMaybe<Scalars['Boolean']['input']>;
  heading_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading_not: InputMaybe<Scalars['String']['input']>;
  heading_not_contains: InputMaybe<Scalars['String']['input']>;
  heading_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type: InputMaybe<Scalars['String']['input']>;
  typeReference_exists: InputMaybe<Scalars['Boolean']['input']>;
  type_contains: InputMaybe<Scalars['String']['input']>;
  type_exists: InputMaybe<Scalars['Boolean']['input']>;
  type_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not: InputMaybe<Scalars['String']['input']>;
  type_not_contains: InputMaybe<Scalars['String']['input']>;
  type_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfCallForConceptNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCallForConceptNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCallForConceptNestedFilter>>>;
  article_exists: InputMaybe<Scalars['Boolean']['input']>;
  callForConceptTitle: InputMaybe<Scalars['String']['input']>;
  callForConceptTitle_contains: InputMaybe<Scalars['String']['input']>;
  callForConceptTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  callForConceptTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callForConceptTitle_not: InputMaybe<Scalars['String']['input']>;
  callForConceptTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  callForConceptTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  ctaText: InputMaybe<Scalars['String']['input']>;
  ctaText_contains: InputMaybe<Scalars['String']['input']>;
  ctaText_exists: InputMaybe<Scalars['Boolean']['input']>;
  ctaText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaText_not: InputMaybe<Scalars['String']['input']>;
  ctaText_not_contains: InputMaybe<Scalars['String']['input']>;
  ctaText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descriptionItems_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descriptionItems_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descriptionItems_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descriptionItems_exists: InputMaybe<Scalars['Boolean']['input']>;
  grantMakingArea_exists: InputMaybe<Scalars['Boolean']['input']>;
  registrationDeadlineDate: InputMaybe<Scalars['DateTime']['input']>;
  registrationDeadlineDate_exists: InputMaybe<Scalars['Boolean']['input']>;
  registrationDeadlineDate_gt: InputMaybe<Scalars['DateTime']['input']>;
  registrationDeadlineDate_gte: InputMaybe<Scalars['DateTime']['input']>;
  registrationDeadlineDate_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  registrationDeadlineDate_lt: InputMaybe<Scalars['DateTime']['input']>;
  registrationDeadlineDate_lte: InputMaybe<Scalars['DateTime']['input']>;
  registrationDeadlineDate_not: InputMaybe<Scalars['DateTime']['input']>;
  registrationDeadlineDate_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  registrationDeadlineTitle: InputMaybe<Scalars['String']['input']>;
  registrationDeadlineTitle_contains: InputMaybe<Scalars['String']['input']>;
  registrationDeadlineTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  registrationDeadlineTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  registrationDeadlineTitle_not: InputMaybe<Scalars['String']['input']>;
  registrationDeadlineTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  registrationDeadlineTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type: InputMaybe<Scalars['String']['input']>;
  type_contains: InputMaybe<Scalars['String']['input']>;
  type_exists: InputMaybe<Scalars['Boolean']['input']>;
  type_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not: InputMaybe<Scalars['String']['input']>;
  type_not_contains: InputMaybe<Scalars['String']['input']>;
  type_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfConnectWithLinkNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfConnectWithLinkNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfConnectWithLinkNestedFilter>>>;
  asset_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  externalLink: InputMaybe<Scalars['String']['input']>;
  externalLink_contains: InputMaybe<Scalars['String']['input']>;
  externalLink_exists: InputMaybe<Scalars['Boolean']['input']>;
  externalLink_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalLink_not: InputMaybe<Scalars['String']['input']>;
  externalLink_not_contains: InputMaybe<Scalars['String']['input']>;
  externalLink_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalLink_exists: InputMaybe<Scalars['Boolean']['input']>;
  label: InputMaybe<Scalars['String']['input']>;
  label_contains: InputMaybe<Scalars['String']['input']>;
  label_exists: InputMaybe<Scalars['Boolean']['input']>;
  label_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not: InputMaybe<Scalars['String']['input']>;
  label_not_contains: InputMaybe<Scalars['String']['input']>;
  label_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfConnectWithNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfConnectWithNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfConnectWithNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  eyebrow: InputMaybe<Scalars['String']['input']>;
  eyebrow_contains: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading: InputMaybe<Scalars['String']['input']>;
  heading_contains: InputMaybe<Scalars['String']['input']>;
  heading_exists: InputMaybe<Scalars['Boolean']['input']>;
  heading_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading_not: InputMaybe<Scalars['String']['input']>;
  heading_not_contains: InputMaybe<Scalars['String']['input']>;
  heading_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linksCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfContactPersonNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfContactPersonNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfContactPersonNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  email: InputMaybe<Scalars['String']['input']>;
  email_contains: InputMaybe<Scalars['String']['input']>;
  email_exists: InputMaybe<Scalars['Boolean']['input']>;
  email_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email_not: InputMaybe<Scalars['String']['input']>;
  email_not_contains: InputMaybe<Scalars['String']['input']>;
  email_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phone: InputMaybe<Scalars['String']['input']>;
  phone_contains: InputMaybe<Scalars['String']['input']>;
  phone_exists: InputMaybe<Scalars['Boolean']['input']>;
  phone_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phone_not: InputMaybe<Scalars['String']['input']>;
  phone_not_contains: InputMaybe<Scalars['String']['input']>;
  phone_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  role: InputMaybe<Scalars['String']['input']>;
  role_contains: InputMaybe<Scalars['String']['input']>;
  role_exists: InputMaybe<Scalars['Boolean']['input']>;
  role_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  role_not: InputMaybe<Scalars['String']['input']>;
  role_not_contains: InputMaybe<Scalars['String']['input']>;
  role_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type CfExperienceBlockNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfExperienceBlockNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfExperienceBlockNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  devNotesAboutThisBlock: InputMaybe<Scalars['String']['input']>;
  devNotesAboutThisBlock_contains: InputMaybe<Scalars['String']['input']>;
  devNotesAboutThisBlock_exists: InputMaybe<Scalars['Boolean']['input']>;
  devNotesAboutThisBlock_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  devNotesAboutThisBlock_not: InputMaybe<Scalars['String']['input']>;
  devNotesAboutThisBlock_not_contains: InputMaybe<Scalars['String']['input']>;
  devNotesAboutThisBlock_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id: InputMaybe<Scalars['String']['input']>;
  id_contains: InputMaybe<Scalars['String']['input']>;
  id_exists: InputMaybe<Scalars['Boolean']['input']>;
  id_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not: InputMaybe<Scalars['String']['input']>;
  id_not_contains: InputMaybe<Scalars['String']['input']>;
  id_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  json_exists: InputMaybe<Scalars['Boolean']['input']>;
  mediaCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  referencesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
};

export type CfExternalEventNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfExternalEventNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfExternalEventNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  date: InputMaybe<Scalars['DateTime']['input']>;
  date_exists: InputMaybe<Scalars['Boolean']['input']>;
  date_gt: InputMaybe<Scalars['DateTime']['input']>;
  date_gte: InputMaybe<Scalars['DateTime']['input']>;
  date_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_lt: InputMaybe<Scalars['DateTime']['input']>;
  date_lte: InputMaybe<Scalars['DateTime']['input']>;
  date_not: InputMaybe<Scalars['DateTime']['input']>;
  date_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  endTime: InputMaybe<Scalars['String']['input']>;
  endTime_contains: InputMaybe<Scalars['String']['input']>;
  endTime_exists: InputMaybe<Scalars['Boolean']['input']>;
  endTime_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endTime_not: InputMaybe<Scalars['String']['input']>;
  endTime_not_contains: InputMaybe<Scalars['String']['input']>;
  endTime_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eventType: InputMaybe<Scalars['String']['input']>;
  eventType_contains: InputMaybe<Scalars['String']['input']>;
  eventType_exists: InputMaybe<Scalars['Boolean']['input']>;
  eventType_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eventType_not: InputMaybe<Scalars['String']['input']>;
  eventType_not_contains: InputMaybe<Scalars['String']['input']>;
  eventType_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  link: InputMaybe<Scalars['String']['input']>;
  link_contains: InputMaybe<Scalars['String']['input']>;
  link_exists: InputMaybe<Scalars['Boolean']['input']>;
  link_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  link_not: InputMaybe<Scalars['String']['input']>;
  link_not_contains: InputMaybe<Scalars['String']['input']>;
  link_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logo_exists: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startTime: InputMaybe<Scalars['String']['input']>;
  startTime_contains: InputMaybe<Scalars['String']['input']>;
  startTime_exists: InputMaybe<Scalars['Boolean']['input']>;
  startTime_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startTime_not: InputMaybe<Scalars['String']['input']>;
  startTime_not_contains: InputMaybe<Scalars['String']['input']>;
  startTime_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  timeZone: InputMaybe<Scalars['String']['input']>;
  timeZone_contains: InputMaybe<Scalars['String']['input']>;
  timeZone_exists: InputMaybe<Scalars['Boolean']['input']>;
  timeZone_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timeZone_not: InputMaybe<Scalars['String']['input']>;
  timeZone_not_contains: InputMaybe<Scalars['String']['input']>;
  timeZone_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfExternalPersonNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfExternalPersonNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfExternalPersonNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  image_exists: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle: InputMaybe<Scalars['String']['input']>;
  jobTitle_contains: InputMaybe<Scalars['String']['input']>;
  jobTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  jobTitle_not: InputMaybe<Scalars['String']['input']>;
  jobTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  jobTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organization: InputMaybe<Scalars['String']['input']>;
  organization_contains: InputMaybe<Scalars['String']['input']>;
  organization_exists: InputMaybe<Scalars['Boolean']['input']>;
  organization_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organization_not: InputMaybe<Scalars['String']['input']>;
  organization_not_contains: InputMaybe<Scalars['String']['input']>;
  organization_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type CfFaqNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfFaqNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfFaqNestedFilter>>>;
  answer: InputMaybe<Scalars['String']['input']>;
  answer_contains: InputMaybe<Scalars['String']['input']>;
  answer_exists: InputMaybe<Scalars['Boolean']['input']>;
  answer_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  answer_not: InputMaybe<Scalars['String']['input']>;
  answer_not_contains: InputMaybe<Scalars['String']['input']>;
  answer_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  question: InputMaybe<Scalars['String']['input']>;
  question_contains: InputMaybe<Scalars['String']['input']>;
  question_exists: InputMaybe<Scalars['Boolean']['input']>;
  question_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  question_not: InputMaybe<Scalars['String']['input']>;
  question_not_contains: InputMaybe<Scalars['String']['input']>;
  question_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type CfFaqsModuleNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfFaqsModuleNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfFaqsModuleNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  faqsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfFeatureNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfFeatureNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfFeatureNestedFilter>>>;
  callout_exists: InputMaybe<Scalars['Boolean']['input']>;
  content_contains: InputMaybe<Scalars['String']['input']>;
  content_exists: InputMaybe<Scalars['Boolean']['input']>;
  content_not_contains: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  ctaContextualMessage: InputMaybe<Scalars['String']['input']>;
  ctaContextualMessage_contains: InputMaybe<Scalars['String']['input']>;
  ctaContextualMessage_exists: InputMaybe<Scalars['Boolean']['input']>;
  ctaContextualMessage_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaContextualMessage_not: InputMaybe<Scalars['String']['input']>;
  ctaContextualMessage_not_contains: InputMaybe<Scalars['String']['input']>;
  ctaContextualMessage_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  date: InputMaybe<Scalars['String']['input']>;
  dateTime: InputMaybe<Scalars['DateTime']['input']>;
  dateTime_exists: InputMaybe<Scalars['Boolean']['input']>;
  dateTime_gt: InputMaybe<Scalars['DateTime']['input']>;
  dateTime_gte: InputMaybe<Scalars['DateTime']['input']>;
  dateTime_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  dateTime_lt: InputMaybe<Scalars['DateTime']['input']>;
  dateTime_lte: InputMaybe<Scalars['DateTime']['input']>;
  dateTime_not: InputMaybe<Scalars['DateTime']['input']>;
  dateTime_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_contains: InputMaybe<Scalars['String']['input']>;
  date_exists: InputMaybe<Scalars['Boolean']['input']>;
  date_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  date_not: InputMaybe<Scalars['String']['input']>;
  date_not_contains: InputMaybe<Scalars['String']['input']>;
  date_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  experienceBlock_exists: InputMaybe<Scalars['Boolean']['input']>;
  grantStoriesSetCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  heroImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  hero_exists: InputMaybe<Scalars['Boolean']['input']>;
  includedGrantsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  intro_contains: InputMaybe<Scalars['String']['input']>;
  intro_exists: InputMaybe<Scalars['Boolean']['input']>;
  intro_not_contains: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  newsletter_exists: InputMaybe<Scalars['Boolean']['input']>;
  pinnedGrantStoriesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  previewVideo_exists: InputMaybe<Scalars['Boolean']['input']>;
  quickLinks_exists: InputMaybe<Scalars['Boolean']['input']>;
  relatedContentCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  showSocialCtas: InputMaybe<Scalars['Boolean']['input']>;
  showSocialCtas_exists: InputMaybe<Scalars['Boolean']['input']>;
  showSocialCtas_not: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  tagline: InputMaybe<Scalars['String']['input']>;
  tagline_contains: InputMaybe<Scalars['String']['input']>;
  tagline_exists: InputMaybe<Scalars['Boolean']['input']>;
  tagline_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagline_not: InputMaybe<Scalars['String']['input']>;
  tagline_not_contains: InputMaybe<Scalars['String']['input']>;
  tagline_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfGrantActivityArticleNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfGrantActivityArticleNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfGrantActivityArticleNestedFilter>>>;
  audio_exists: InputMaybe<Scalars['Boolean']['input']>;
  author: InputMaybe<Scalars['String']['input']>;
  author_contains: InputMaybe<Scalars['String']['input']>;
  author_exists: InputMaybe<Scalars['Boolean']['input']>;
  author_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  author_not: InputMaybe<Scalars['String']['input']>;
  author_not_contains: InputMaybe<Scalars['String']['input']>;
  author_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_contains: InputMaybe<Scalars['String']['input']>;
  body_exists: InputMaybe<Scalars['Boolean']['input']>;
  body_not_contains: InputMaybe<Scalars['String']['input']>;
  connectLinksCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  creditLabel: InputMaybe<Scalars['String']['input']>;
  creditLabel_contains: InputMaybe<Scalars['String']['input']>;
  creditLabel_exists: InputMaybe<Scalars['Boolean']['input']>;
  creditLabel_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  creditLabel_not: InputMaybe<Scalars['String']['input']>;
  creditLabel_not_contains: InputMaybe<Scalars['String']['input']>;
  creditLabel_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  creditText: InputMaybe<Scalars['String']['input']>;
  creditText_contains: InputMaybe<Scalars['String']['input']>;
  creditText_exists: InputMaybe<Scalars['Boolean']['input']>;
  creditText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  creditText_not: InputMaybe<Scalars['String']['input']>;
  creditText_not_contains: InputMaybe<Scalars['String']['input']>;
  creditText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  date: InputMaybe<Scalars['DateTime']['input']>;
  date_exists: InputMaybe<Scalars['Boolean']['input']>;
  date_gt: InputMaybe<Scalars['DateTime']['input']>;
  date_gte: InputMaybe<Scalars['DateTime']['input']>;
  date_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_lt: InputMaybe<Scalars['DateTime']['input']>;
  date_lte: InputMaybe<Scalars['DateTime']['input']>;
  date_not: InputMaybe<Scalars['DateTime']['input']>;
  date_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  experienceBlock_exists: InputMaybe<Scalars['Boolean']['input']>;
  formattingOptions_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattingOptions_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattingOptions_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattingOptions_exists: InputMaybe<Scalars['Boolean']['input']>;
  grantInsight: InputMaybe<Scalars['String']['input']>;
  grantInsight_contains: InputMaybe<Scalars['String']['input']>;
  grantInsight_exists: InputMaybe<Scalars['Boolean']['input']>;
  grantInsight_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  grantInsight_not: InputMaybe<Scalars['String']['input']>;
  grantInsight_not_contains: InputMaybe<Scalars['String']['input']>;
  grantInsight_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  grant_exists: InputMaybe<Scalars['Boolean']['input']>;
  granteeCityOverride: InputMaybe<Scalars['String']['input']>;
  granteeCityOverride_contains: InputMaybe<Scalars['String']['input']>;
  granteeCityOverride_exists: InputMaybe<Scalars['Boolean']['input']>;
  granteeCityOverride_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  granteeCityOverride_not: InputMaybe<Scalars['String']['input']>;
  granteeCityOverride_not_contains: InputMaybe<Scalars['String']['input']>;
  granteeCityOverride_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  granteeCountryOverride: InputMaybe<Scalars['String']['input']>;
  granteeCountryOverride_contains: InputMaybe<Scalars['String']['input']>;
  granteeCountryOverride_exists: InputMaybe<Scalars['Boolean']['input']>;
  granteeCountryOverride_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  granteeCountryOverride_not: InputMaybe<Scalars['String']['input']>;
  granteeCountryOverride_not_contains: InputMaybe<Scalars['String']['input']>;
  granteeCountryOverride_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  granteeNameOverride: InputMaybe<Scalars['String']['input']>;
  granteeNameOverride_contains: InputMaybe<Scalars['String']['input']>;
  granteeNameOverride_exists: InputMaybe<Scalars['Boolean']['input']>;
  granteeNameOverride_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  granteeNameOverride_not: InputMaybe<Scalars['String']['input']>;
  granteeNameOverride_not_contains: InputMaybe<Scalars['String']['input']>;
  granteeNameOverride_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  granteeStateOverride: InputMaybe<Scalars['String']['input']>;
  granteeStateOverride_contains: InputMaybe<Scalars['String']['input']>;
  granteeStateOverride_exists: InputMaybe<Scalars['Boolean']['input']>;
  granteeStateOverride_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  granteeStateOverride_not: InputMaybe<Scalars['String']['input']>;
  granteeStateOverride_not_contains: InputMaybe<Scalars['String']['input']>;
  granteeStateOverride_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hero_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideDate: InputMaybe<Scalars['Boolean']['input']>;
  hideDate_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideDate_not: InputMaybe<Scalars['Boolean']['input']>;
  hideShareLink: InputMaybe<Scalars['Boolean']['input']>;
  hideShareLink_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideShareLink_not: InputMaybe<Scalars['Boolean']['input']>;
  leadImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  metadata_exists: InputMaybe<Scalars['Boolean']['input']>;
  photographer: InputMaybe<Scalars['String']['input']>;
  photographer_contains: InputMaybe<Scalars['String']['input']>;
  photographer_exists: InputMaybe<Scalars['Boolean']['input']>;
  photographer_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  photographer_not: InputMaybe<Scalars['String']['input']>;
  photographer_not_contains: InputMaybe<Scalars['String']['input']>;
  photographer_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedArticlesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  thumbnailImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfGrantNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfGrantNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfGrantNestedFilter>>>;
  amount: InputMaybe<Scalars['Float']['input']>;
  amount_exists: InputMaybe<Scalars['Boolean']['input']>;
  amount_gt: InputMaybe<Scalars['Float']['input']>;
  amount_gte: InputMaybe<Scalars['Float']['input']>;
  amount_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  amount_lt: InputMaybe<Scalars['Float']['input']>;
  amount_lte: InputMaybe<Scalars['Float']['input']>;
  amount_not: InputMaybe<Scalars['Float']['input']>;
  amount_not_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  areaOfFocus: InputMaybe<Scalars['String']['input']>;
  areaOfFocus_contains: InputMaybe<Scalars['String']['input']>;
  areaOfFocus_exists: InputMaybe<Scalars['Boolean']['input']>;
  areaOfFocus_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  areaOfFocus_not: InputMaybe<Scalars['String']['input']>;
  areaOfFocus_not_contains: InputMaybe<Scalars['String']['input']>;
  areaOfFocus_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  date: InputMaybe<Scalars['DateTime']['input']>;
  date_exists: InputMaybe<Scalars['Boolean']['input']>;
  date_gt: InputMaybe<Scalars['DateTime']['input']>;
  date_gte: InputMaybe<Scalars['DateTime']['input']>;
  date_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_lt: InputMaybe<Scalars['DateTime']['input']>;
  date_lte: InputMaybe<Scalars['DateTime']['input']>;
  date_not: InputMaybe<Scalars['DateTime']['input']>;
  date_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  durationInMonths: InputMaybe<Scalars['Int']['input']>;
  durationInMonths_exists: InputMaybe<Scalars['Boolean']['input']>;
  durationInMonths_gt: InputMaybe<Scalars['Int']['input']>;
  durationInMonths_gte: InputMaybe<Scalars['Int']['input']>;
  durationInMonths_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  durationInMonths_lt: InputMaybe<Scalars['Int']['input']>;
  durationInMonths_lte: InputMaybe<Scalars['Int']['input']>;
  durationInMonths_not: InputMaybe<Scalars['Int']['input']>;
  durationInMonths_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  grantmakingArea_exists: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['String']['input']>;
  id_contains: InputMaybe<Scalars['String']['input']>;
  id_exists: InputMaybe<Scalars['Boolean']['input']>;
  id_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not: InputMaybe<Scalars['String']['input']>;
  id_not_contains: InputMaybe<Scalars['String']['input']>;
  id_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organization_exists: InputMaybe<Scalars['Boolean']['input']>;
  projectTitle: InputMaybe<Scalars['String']['input']>;
  projectTitle_contains: InputMaybe<Scalars['String']['input']>;
  projectTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  projectTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  projectTitle_not: InputMaybe<Scalars['String']['input']>;
  projectTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  projectTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  referenceId: InputMaybe<Scalars['String']['input']>;
  referenceId_contains: InputMaybe<Scalars['String']['input']>;
  referenceId_exists: InputMaybe<Scalars['Boolean']['input']>;
  referenceId_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  referenceId_not: InputMaybe<Scalars['String']['input']>;
  referenceId_not_contains: InputMaybe<Scalars['String']['input']>;
  referenceId_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  taxonomies_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taxonomies_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taxonomies_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taxonomies_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfGrantmakingAreaDetailsPageNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfGrantmakingAreaDetailsPageNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfGrantmakingAreaDetailsPageNestedFilter>>>;
  body_contains: InputMaybe<Scalars['String']['input']>;
  body_exists: InputMaybe<Scalars['Boolean']['input']>;
  body_not_contains: InputMaybe<Scalars['String']['input']>;
  callForConceptsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  grantMakingArea_exists: InputMaybe<Scalars['Boolean']['input']>;
  grantMakingProcessMessage: InputMaybe<Scalars['String']['input']>;
  grantMakingProcessMessage_contains: InputMaybe<Scalars['String']['input']>;
  grantMakingProcessMessage_exists: InputMaybe<Scalars['Boolean']['input']>;
  grantMakingProcessMessage_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  grantMakingProcessMessage_not: InputMaybe<Scalars['String']['input']>;
  grantMakingProcessMessage_not_contains: InputMaybe<Scalars['String']['input']>;
  grantMakingProcessMessage_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  guidingStrategiesContent: InputMaybe<Scalars['String']['input']>;
  guidingStrategiesContent_contains: InputMaybe<Scalars['String']['input']>;
  guidingStrategiesContent_exists: InputMaybe<Scalars['Boolean']['input']>;
  guidingStrategiesContent_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  guidingStrategiesContent_not: InputMaybe<Scalars['String']['input']>;
  guidingStrategiesContent_not_contains: InputMaybe<Scalars['String']['input']>;
  guidingStrategiesContent_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  guidingStrategiesTitle: InputMaybe<Scalars['String']['input']>;
  guidingStrategiesTitle_contains: InputMaybe<Scalars['String']['input']>;
  guidingStrategiesTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  guidingStrategiesTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  guidingStrategiesTitle_not: InputMaybe<Scalars['String']['input']>;
  guidingStrategiesTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  guidingStrategiesTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heroImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  inFocusContentCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  introDescription: InputMaybe<Scalars['String']['input']>;
  introDescription_contains: InputMaybe<Scalars['String']['input']>;
  introDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  introDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  introDescription_not: InputMaybe<Scalars['String']['input']>;
  introDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  introDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  introductionText: InputMaybe<Scalars['String']['input']>;
  introductionText_contains: InputMaybe<Scalars['String']['input']>;
  introductionText_exists: InputMaybe<Scalars['Boolean']['input']>;
  introductionText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  introductionText_not: InputMaybe<Scalars['String']['input']>;
  introductionText_not_contains: InputMaybe<Scalars['String']['input']>;
  introductionText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quickLinks_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfGrantmakingAreaNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfGrantmakingAreaNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfGrantmakingAreaNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  id: InputMaybe<Scalars['String']['input']>;
  id_contains: InputMaybe<Scalars['String']['input']>;
  id_exists: InputMaybe<Scalars['Boolean']['input']>;
  id_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not: InputMaybe<Scalars['String']['input']>;
  id_not_contains: InputMaybe<Scalars['String']['input']>;
  id_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  tagline: InputMaybe<Scalars['String']['input']>;
  tagline_contains: InputMaybe<Scalars['String']['input']>;
  tagline_exists: InputMaybe<Scalars['Boolean']['input']>;
  tagline_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagline_not: InputMaybe<Scalars['String']['input']>;
  tagline_not_contains: InputMaybe<Scalars['String']['input']>;
  tagline_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfHeroAssetNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfHeroAssetNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfHeroAssetNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  image_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoHasAudio: InputMaybe<Scalars['Boolean']['input']>;
  videoHasAudio_exists: InputMaybe<Scalars['Boolean']['input']>;
  videoHasAudio_not: InputMaybe<Scalars['Boolean']['input']>;
  video_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfHistoryPersonNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfHistoryPersonNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfHistoryPersonNestedFilter>>>;
  biography: InputMaybe<Scalars['String']['input']>;
  biography_contains: InputMaybe<Scalars['String']['input']>;
  biography_exists: InputMaybe<Scalars['Boolean']['input']>;
  biography_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  biography_not: InputMaybe<Scalars['String']['input']>;
  biography_not_contains: InputMaybe<Scalars['String']['input']>;
  biography_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  endYear: InputMaybe<Scalars['String']['input']>;
  endYear_contains: InputMaybe<Scalars['String']['input']>;
  endYear_exists: InputMaybe<Scalars['Boolean']['input']>;
  endYear_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endYear_not: InputMaybe<Scalars['String']['input']>;
  endYear_not_contains: InputMaybe<Scalars['String']['input']>;
  endYear_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startYear: InputMaybe<Scalars['String']['input']>;
  startYear_contains: InputMaybe<Scalars['String']['input']>;
  startYear_exists: InputMaybe<Scalars['Boolean']['input']>;
  startYear_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startYear_not: InputMaybe<Scalars['String']['input']>;
  startYear_not_contains: InputMaybe<Scalars['String']['input']>;
  startYear_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  yearsOfPresidency: InputMaybe<Scalars['String']['input']>;
  yearsOfPresidency_contains: InputMaybe<Scalars['String']['input']>;
  yearsOfPresidency_exists: InputMaybe<Scalars['Boolean']['input']>;
  yearsOfPresidency_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  yearsOfPresidency_not: InputMaybe<Scalars['String']['input']>;
  yearsOfPresidency_not_contains: InputMaybe<Scalars['String']['input']>;
  yearsOfPresidency_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfIdeaNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfIdeaNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfIdeaNestedFilter>>>;
  callForConceptsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  ctaContextualMessage: InputMaybe<Scalars['String']['input']>;
  ctaContextualMessage_contains: InputMaybe<Scalars['String']['input']>;
  ctaContextualMessage_exists: InputMaybe<Scalars['Boolean']['input']>;
  ctaContextualMessage_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaContextualMessage_not: InputMaybe<Scalars['String']['input']>;
  ctaContextualMessage_not_contains: InputMaybe<Scalars['String']['input']>;
  ctaContextualMessage_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludedGrantsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  heroImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  ideaSetupStatement: InputMaybe<Scalars['String']['input']>;
  ideaSetupStatement_contains: InputMaybe<Scalars['String']['input']>;
  ideaSetupStatement_exists: InputMaybe<Scalars['Boolean']['input']>;
  ideaSetupStatement_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ideaSetupStatement_not: InputMaybe<Scalars['String']['input']>;
  ideaSetupStatement_not_contains: InputMaybe<Scalars['String']['input']>;
  ideaSetupStatement_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  includedGrantsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navigationImagePortrait_exists: InputMaybe<Scalars['Boolean']['input']>;
  newsletter_exists: InputMaybe<Scalars['Boolean']['input']>;
  question: InputMaybe<Scalars['String']['input']>;
  question_contains: InputMaybe<Scalars['String']['input']>;
  question_exists: InputMaybe<Scalars['Boolean']['input']>;
  question_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  question_not: InputMaybe<Scalars['String']['input']>;
  question_not_contains: InputMaybe<Scalars['String']['input']>;
  question_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  recommendedGrantsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type CfMetadataNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfMetadataNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfMetadataNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogDescription: InputMaybe<Scalars['String']['input']>;
  ogDescription_contains: InputMaybe<Scalars['String']['input']>;
  ogDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  ogDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogDescription_not: InputMaybe<Scalars['String']['input']>;
  ogDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  ogDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  ogTitle: InputMaybe<Scalars['String']['input']>;
  ogTitle_contains: InputMaybe<Scalars['String']['input']>;
  ogTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  ogTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogTitle_not: InputMaybe<Scalars['String']['input']>;
  ogTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  ogTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfNavigationItemNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfNavigationItemNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfNavigationItemNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  image_exists: InputMaybe<Scalars['Boolean']['input']>;
  label: InputMaybe<Scalars['String']['input']>;
  label_contains: InputMaybe<Scalars['String']['input']>;
  label_exists: InputMaybe<Scalars['Boolean']['input']>;
  label_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not: InputMaybe<Scalars['String']['input']>;
  label_not_contains: InputMaybe<Scalars['String']['input']>;
  label_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reference_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
};

export type CfNewsletterCardNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfNewsletterCardNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfNewsletterCardNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disclaimer: InputMaybe<Scalars['String']['input']>;
  disclaimer_contains: InputMaybe<Scalars['String']['input']>;
  disclaimer_exists: InputMaybe<Scalars['Boolean']['input']>;
  disclaimer_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disclaimer_not: InputMaybe<Scalars['String']['input']>;
  disclaimer_not_contains: InputMaybe<Scalars['String']['input']>;
  disclaimer_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfOrganisationNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfOrganisationNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfOrganisationNestedFilter>>>;
  city: InputMaybe<Scalars['String']['input']>;
  city_contains: InputMaybe<Scalars['String']['input']>;
  city_exists: InputMaybe<Scalars['Boolean']['input']>;
  city_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  city_not: InputMaybe<Scalars['String']['input']>;
  city_not_contains: InputMaybe<Scalars['String']['input']>;
  city_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  country: InputMaybe<Scalars['String']['input']>;
  country_contains: InputMaybe<Scalars['String']['input']>;
  country_exists: InputMaybe<Scalars['Boolean']['input']>;
  country_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  country_not: InputMaybe<Scalars['String']['input']>;
  country_not_contains: InputMaybe<Scalars['String']['input']>;
  country_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id: InputMaybe<Scalars['String']['input']>;
  id_contains: InputMaybe<Scalars['String']['input']>;
  id_exists: InputMaybe<Scalars['Boolean']['input']>;
  id_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not: InputMaybe<Scalars['String']['input']>;
  id_not_contains: InputMaybe<Scalars['String']['input']>;
  id_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  state: InputMaybe<Scalars['String']['input']>;
  state_contains: InputMaybe<Scalars['String']['input']>;
  state_exists: InputMaybe<Scalars['Boolean']['input']>;
  state_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  state_not: InputMaybe<Scalars['String']['input']>;
  state_not_contains: InputMaybe<Scalars['String']['input']>;
  state_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type CfPasswordProtectedPageNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfPasswordProtectedPageNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfPasswordProtectedPageNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  emailHeadline: InputMaybe<Scalars['String']['input']>;
  emailHeadline_contains: InputMaybe<Scalars['String']['input']>;
  emailHeadline_exists: InputMaybe<Scalars['Boolean']['input']>;
  emailHeadline_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  emailHeadline_not: InputMaybe<Scalars['String']['input']>;
  emailHeadline_not_contains: InputMaybe<Scalars['String']['input']>;
  emailHeadline_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfPersonNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfPersonNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfPersonNestedFilter>>>;
  biography: InputMaybe<Scalars['String']['input']>;
  biography_contains: InputMaybe<Scalars['String']['input']>;
  biography_exists: InputMaybe<Scalars['Boolean']['input']>;
  biography_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  biography_not: InputMaybe<Scalars['String']['input']>;
  biography_not_contains: InputMaybe<Scalars['String']['input']>;
  biography_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  contextualMessage: InputMaybe<Scalars['String']['input']>;
  contextualMessage_contains: InputMaybe<Scalars['String']['input']>;
  contextualMessage_exists: InputMaybe<Scalars['Boolean']['input']>;
  contextualMessage_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contextualMessage_not: InputMaybe<Scalars['String']['input']>;
  contextualMessage_not_contains: InputMaybe<Scalars['String']['input']>;
  contextualMessage_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  departmentOrGrantMakingArea_exists: InputMaybe<Scalars['Boolean']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstName: InputMaybe<Scalars['String']['input']>;
  firstName_contains: InputMaybe<Scalars['String']['input']>;
  firstName_exists: InputMaybe<Scalars['Boolean']['input']>;
  firstName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstName_not: InputMaybe<Scalars['String']['input']>;
  firstName_not_contains: InputMaybe<Scalars['String']['input']>;
  firstName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle: InputMaybe<Scalars['String']['input']>;
  jobTitle_contains: InputMaybe<Scalars['String']['input']>;
  jobTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  jobTitle_not: InputMaybe<Scalars['String']['input']>;
  jobTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  jobTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName: InputMaybe<Scalars['String']['input']>;
  lastName_contains: InputMaybe<Scalars['String']['input']>;
  lastName_exists: InputMaybe<Scalars['Boolean']['input']>;
  lastName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName_not: InputMaybe<Scalars['String']['input']>;
  lastName_not_contains: InputMaybe<Scalars['String']['input']>;
  lastName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quickLinksCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  quote_exists: InputMaybe<Scalars['Boolean']['input']>;
  relatedNewsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  relatedSectionTitle: InputMaybe<Scalars['String']['input']>;
  relatedSectionTitle_contains: InputMaybe<Scalars['String']['input']>;
  relatedSectionTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  relatedSectionTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedSectionTitle_not: InputMaybe<Scalars['String']['input']>;
  relatedSectionTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  relatedSectionTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  spotlight_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
};

export type CfQuoteNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfQuoteNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfQuoteNestedFilter>>>;
  attribution: InputMaybe<Scalars['String']['input']>;
  attribution_contains: InputMaybe<Scalars['String']['input']>;
  attribution_exists: InputMaybe<Scalars['Boolean']['input']>;
  attribution_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attribution_not: InputMaybe<Scalars['String']['input']>;
  attribution_not_contains: InputMaybe<Scalars['String']['input']>;
  attribution_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  isTwitterImage: InputMaybe<Scalars['Boolean']['input']>;
  isTwitterImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  isTwitterImage_not: InputMaybe<Scalars['Boolean']['input']>;
  link: InputMaybe<Scalars['String']['input']>;
  linkText: InputMaybe<Scalars['String']['input']>;
  linkText_contains: InputMaybe<Scalars['String']['input']>;
  linkText_exists: InputMaybe<Scalars['Boolean']['input']>;
  linkText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkText_not: InputMaybe<Scalars['String']['input']>;
  linkText_not_contains: InputMaybe<Scalars['String']['input']>;
  linkText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  link_contains: InputMaybe<Scalars['String']['input']>;
  link_exists: InputMaybe<Scalars['Boolean']['input']>;
  link_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  link_not: InputMaybe<Scalars['String']['input']>;
  link_not_contains: InputMaybe<Scalars['String']['input']>;
  link_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quoteAudio_exists: InputMaybe<Scalars['Boolean']['input']>;
  quoteImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  quoteText: InputMaybe<Scalars['String']['input']>;
  quoteText_contains: InputMaybe<Scalars['String']['input']>;
  quoteText_exists: InputMaybe<Scalars['Boolean']['input']>;
  quoteText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quoteText_not: InputMaybe<Scalars['String']['input']>;
  quoteText_not_contains: InputMaybe<Scalars['String']['input']>;
  quoteText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  twitterUsername: InputMaybe<Scalars['String']['input']>;
  twitterUsername_contains: InputMaybe<Scalars['String']['input']>;
  twitterUsername_exists: InputMaybe<Scalars['Boolean']['input']>;
  twitterUsername_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  twitterUsername_not: InputMaybe<Scalars['String']['input']>;
  twitterUsername_not_contains: InputMaybe<Scalars['String']['input']>;
  twitterUsername_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfTrusteeNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfTrusteeNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfTrusteeNestedFilter>>>;
  company: InputMaybe<Scalars['String']['input']>;
  company_contains: InputMaybe<Scalars['String']['input']>;
  company_exists: InputMaybe<Scalars['Boolean']['input']>;
  company_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  company_not: InputMaybe<Scalars['String']['input']>;
  company_not_contains: InputMaybe<Scalars['String']['input']>;
  company_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  image_exists: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle: InputMaybe<Scalars['String']['input']>;
  jobTitle_contains: InputMaybe<Scalars['String']['input']>;
  jobTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  jobTitle_not: InputMaybe<Scalars['String']['input']>;
  jobTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  jobTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type CfVideoNativeNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfVideoNativeNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfVideoNativeNestedFilter>>>;
  caption: InputMaybe<Scalars['String']['input']>;
  caption_contains: InputMaybe<Scalars['String']['input']>;
  caption_exists: InputMaybe<Scalars['Boolean']['input']>;
  caption_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  caption_not: InputMaybe<Scalars['String']['input']>;
  caption_not_contains: InputMaybe<Scalars['String']['input']>;
  caption_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  closedCaptions_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  isAmbient: InputMaybe<Scalars['Boolean']['input']>;
  isAmbient_exists: InputMaybe<Scalars['Boolean']['input']>;
  isAmbient_not: InputMaybe<Scalars['Boolean']['input']>;
  isVertical: InputMaybe<Scalars['Boolean']['input']>;
  isVertical_exists: InputMaybe<Scalars['Boolean']['input']>;
  isVertical_not: InputMaybe<Scalars['Boolean']['input']>;
  preview_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  video_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfamountMultiTypeNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfamountMultiTypeNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfamountMultiTypeNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type: InputMaybe<Scalars['String']['input']>;
  type_contains: InputMaybe<Scalars['String']['input']>;
  type_exists: InputMaybe<Scalars['Boolean']['input']>;
  type_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not: InputMaybe<Scalars['String']['input']>;
  type_not_contains: InputMaybe<Scalars['String']['input']>;
  type_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfarticleMultiTypeNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfarticleMultiTypeNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfarticleMultiTypeNestedFilter>>>;
  audio_exists: InputMaybe<Scalars['Boolean']['input']>;
  author: InputMaybe<Scalars['String']['input']>;
  author_contains: InputMaybe<Scalars['String']['input']>;
  author_exists: InputMaybe<Scalars['Boolean']['input']>;
  author_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  author_not: InputMaybe<Scalars['String']['input']>;
  author_not_contains: InputMaybe<Scalars['String']['input']>;
  author_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_contains: InputMaybe<Scalars['String']['input']>;
  body_exists: InputMaybe<Scalars['Boolean']['input']>;
  body_not_contains: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  creditLabel: InputMaybe<Scalars['String']['input']>;
  creditLabel_contains: InputMaybe<Scalars['String']['input']>;
  creditLabel_exists: InputMaybe<Scalars['Boolean']['input']>;
  creditLabel_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  creditLabel_not: InputMaybe<Scalars['String']['input']>;
  creditLabel_not_contains: InputMaybe<Scalars['String']['input']>;
  creditLabel_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  creditText: InputMaybe<Scalars['String']['input']>;
  creditText_contains: InputMaybe<Scalars['String']['input']>;
  creditText_exists: InputMaybe<Scalars['Boolean']['input']>;
  creditText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  creditText_not: InputMaybe<Scalars['String']['input']>;
  creditText_not_contains: InputMaybe<Scalars['String']['input']>;
  creditText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  date: InputMaybe<Scalars['DateTime']['input']>;
  date_exists: InputMaybe<Scalars['Boolean']['input']>;
  date_gt: InputMaybe<Scalars['DateTime']['input']>;
  date_gte: InputMaybe<Scalars['DateTime']['input']>;
  date_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_lt: InputMaybe<Scalars['DateTime']['input']>;
  date_lte: InputMaybe<Scalars['DateTime']['input']>;
  date_not: InputMaybe<Scalars['DateTime']['input']>;
  date_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattingOptions_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattingOptions_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattingOptions_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattingOptions_exists: InputMaybe<Scalars['Boolean']['input']>;
  hero_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideDate: InputMaybe<Scalars['Boolean']['input']>;
  hideDate_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideDate_not: InputMaybe<Scalars['Boolean']['input']>;
  hideShareLink: InputMaybe<Scalars['Boolean']['input']>;
  hideShareLink_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideShareLink_not: InputMaybe<Scalars['Boolean']['input']>;
  metadata_exists: InputMaybe<Scalars['Boolean']['input']>;
  photographer: InputMaybe<Scalars['String']['input']>;
  photographer_contains: InputMaybe<Scalars['String']['input']>;
  photographer_exists: InputMaybe<Scalars['Boolean']['input']>;
  photographer_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  photographer_not: InputMaybe<Scalars['String']['input']>;
  photographer_not_contains: InputMaybe<Scalars['String']['input']>;
  photographer_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  thumbnailImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfcardsMultiTypeNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfcardsMultiTypeNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfcardsMultiTypeNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
};

export type CfcontentMultiTypeNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfcontentMultiTypeNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfcontentMultiTypeNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
};

export type CfdepartmentOrGrantMakingAreaMultiTypeNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfdepartmentOrGrantMakingAreaMultiTypeNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfdepartmentOrGrantMakingAreaMultiTypeNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type CffeaturedNewsMultiTypeNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CffeaturedNewsMultiTypeNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CffeaturedNewsMultiTypeNestedFilter>>>;
  audio_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  date: InputMaybe<Scalars['DateTime']['input']>;
  date_exists: InputMaybe<Scalars['Boolean']['input']>;
  date_gt: InputMaybe<Scalars['DateTime']['input']>;
  date_gte: InputMaybe<Scalars['DateTime']['input']>;
  date_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_lt: InputMaybe<Scalars['DateTime']['input']>;
  date_lte: InputMaybe<Scalars['DateTime']['input']>;
  date_not: InputMaybe<Scalars['DateTime']['input']>;
  date_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  person_exists: InputMaybe<Scalars['Boolean']['input']>;
  quickLinks_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type CfinFocusContentMultiTypeNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfinFocusContentMultiTypeNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfinFocusContentMultiTypeNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
};

export type CfinTheNewsMultiTypeNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfinTheNewsMultiTypeNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfinTheNewsMultiTypeNestedFilter>>>;
  audio_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  date: InputMaybe<Scalars['DateTime']['input']>;
  date_exists: InputMaybe<Scalars['Boolean']['input']>;
  date_gt: InputMaybe<Scalars['DateTime']['input']>;
  date_gte: InputMaybe<Scalars['DateTime']['input']>;
  date_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_lt: InputMaybe<Scalars['DateTime']['input']>;
  date_lte: InputMaybe<Scalars['DateTime']['input']>;
  date_not: InputMaybe<Scalars['DateTime']['input']>;
  date_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  person_exists: InputMaybe<Scalars['Boolean']['input']>;
  quickLinks_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type CfmoreAnnualReportsMultiTypeNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfmoreAnnualReportsMultiTypeNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfmoreAnnualReportsMultiTypeNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
  year: InputMaybe<Scalars['String']['input']>;
  year_contains: InputMaybe<Scalars['String']['input']>;
  year_exists: InputMaybe<Scalars['Boolean']['input']>;
  year_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  year_not: InputMaybe<Scalars['String']['input']>;
  year_not_contains: InputMaybe<Scalars['String']['input']>;
  year_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfnewsContentMultiTypeNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfnewsContentMultiTypeNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfnewsContentMultiTypeNestedFilter>>>;
  audio_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  date: InputMaybe<Scalars['DateTime']['input']>;
  date_exists: InputMaybe<Scalars['Boolean']['input']>;
  date_gt: InputMaybe<Scalars['DateTime']['input']>;
  date_gte: InputMaybe<Scalars['DateTime']['input']>;
  date_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_lt: InputMaybe<Scalars['DateTime']['input']>;
  date_lte: InputMaybe<Scalars['DateTime']['input']>;
  date_not: InputMaybe<Scalars['DateTime']['input']>;
  date_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  person_exists: InputMaybe<Scalars['Boolean']['input']>;
  quickLinks_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type CfpagesMultiTypeNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfpagesMultiTypeNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfpagesMultiTypeNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  navigationImagePortrait_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfpinnedGrantStoriesMultiTypeNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfpinnedGrantStoriesMultiTypeNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfpinnedGrantStoriesMultiTypeNestedFilter>>>;
  audio_exists: InputMaybe<Scalars['Boolean']['input']>;
  author: InputMaybe<Scalars['String']['input']>;
  author_contains: InputMaybe<Scalars['String']['input']>;
  author_exists: InputMaybe<Scalars['Boolean']['input']>;
  author_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  author_not: InputMaybe<Scalars['String']['input']>;
  author_not_contains: InputMaybe<Scalars['String']['input']>;
  author_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_contains: InputMaybe<Scalars['String']['input']>;
  body_exists: InputMaybe<Scalars['Boolean']['input']>;
  body_not_contains: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  creditLabel: InputMaybe<Scalars['String']['input']>;
  creditLabel_contains: InputMaybe<Scalars['String']['input']>;
  creditLabel_exists: InputMaybe<Scalars['Boolean']['input']>;
  creditLabel_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  creditLabel_not: InputMaybe<Scalars['String']['input']>;
  creditLabel_not_contains: InputMaybe<Scalars['String']['input']>;
  creditLabel_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  creditText: InputMaybe<Scalars['String']['input']>;
  creditText_contains: InputMaybe<Scalars['String']['input']>;
  creditText_exists: InputMaybe<Scalars['Boolean']['input']>;
  creditText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  creditText_not: InputMaybe<Scalars['String']['input']>;
  creditText_not_contains: InputMaybe<Scalars['String']['input']>;
  creditText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  date: InputMaybe<Scalars['DateTime']['input']>;
  date_exists: InputMaybe<Scalars['Boolean']['input']>;
  date_gt: InputMaybe<Scalars['DateTime']['input']>;
  date_gte: InputMaybe<Scalars['DateTime']['input']>;
  date_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_lt: InputMaybe<Scalars['DateTime']['input']>;
  date_lte: InputMaybe<Scalars['DateTime']['input']>;
  date_not: InputMaybe<Scalars['DateTime']['input']>;
  date_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattingOptions_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattingOptions_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattingOptions_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattingOptions_exists: InputMaybe<Scalars['Boolean']['input']>;
  hero_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideDate: InputMaybe<Scalars['Boolean']['input']>;
  hideDate_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideDate_not: InputMaybe<Scalars['Boolean']['input']>;
  hideShareLink: InputMaybe<Scalars['Boolean']['input']>;
  hideShareLink_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideShareLink_not: InputMaybe<Scalars['Boolean']['input']>;
  metadata_exists: InputMaybe<Scalars['Boolean']['input']>;
  photographer: InputMaybe<Scalars['String']['input']>;
  photographer_contains: InputMaybe<Scalars['String']['input']>;
  photographer_exists: InputMaybe<Scalars['Boolean']['input']>;
  photographer_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  photographer_not: InputMaybe<Scalars['String']['input']>;
  photographer_not_contains: InputMaybe<Scalars['String']['input']>;
  photographer_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  thumbnailImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfreferencesMultiTypeNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfreferencesMultiTypeNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfreferencesMultiTypeNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfrelatedActivitiesMultiTypeNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfrelatedActivitiesMultiTypeNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfrelatedActivitiesMultiTypeNestedFilter>>>;
  audio_exists: InputMaybe<Scalars['Boolean']['input']>;
  author: InputMaybe<Scalars['String']['input']>;
  author_contains: InputMaybe<Scalars['String']['input']>;
  author_exists: InputMaybe<Scalars['Boolean']['input']>;
  author_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  author_not: InputMaybe<Scalars['String']['input']>;
  author_not_contains: InputMaybe<Scalars['String']['input']>;
  author_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_contains: InputMaybe<Scalars['String']['input']>;
  body_exists: InputMaybe<Scalars['Boolean']['input']>;
  body_not_contains: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  creditLabel: InputMaybe<Scalars['String']['input']>;
  creditLabel_contains: InputMaybe<Scalars['String']['input']>;
  creditLabel_exists: InputMaybe<Scalars['Boolean']['input']>;
  creditLabel_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  creditLabel_not: InputMaybe<Scalars['String']['input']>;
  creditLabel_not_contains: InputMaybe<Scalars['String']['input']>;
  creditLabel_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  creditText: InputMaybe<Scalars['String']['input']>;
  creditText_contains: InputMaybe<Scalars['String']['input']>;
  creditText_exists: InputMaybe<Scalars['Boolean']['input']>;
  creditText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  creditText_not: InputMaybe<Scalars['String']['input']>;
  creditText_not_contains: InputMaybe<Scalars['String']['input']>;
  creditText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  date: InputMaybe<Scalars['DateTime']['input']>;
  date_exists: InputMaybe<Scalars['Boolean']['input']>;
  date_gt: InputMaybe<Scalars['DateTime']['input']>;
  date_gte: InputMaybe<Scalars['DateTime']['input']>;
  date_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_lt: InputMaybe<Scalars['DateTime']['input']>;
  date_lte: InputMaybe<Scalars['DateTime']['input']>;
  date_not: InputMaybe<Scalars['DateTime']['input']>;
  date_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattingOptions_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattingOptions_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattingOptions_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattingOptions_exists: InputMaybe<Scalars['Boolean']['input']>;
  hero_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideDate: InputMaybe<Scalars['Boolean']['input']>;
  hideDate_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideDate_not: InputMaybe<Scalars['Boolean']['input']>;
  hideShareLink: InputMaybe<Scalars['Boolean']['input']>;
  hideShareLink_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideShareLink_not: InputMaybe<Scalars['Boolean']['input']>;
  metadata_exists: InputMaybe<Scalars['Boolean']['input']>;
  photographer: InputMaybe<Scalars['String']['input']>;
  photographer_contains: InputMaybe<Scalars['String']['input']>;
  photographer_exists: InputMaybe<Scalars['Boolean']['input']>;
  photographer_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  photographer_not: InputMaybe<Scalars['String']['input']>;
  photographer_not_contains: InputMaybe<Scalars['String']['input']>;
  photographer_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  thumbnailImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfrelatedArticlesMultiTypeNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfrelatedArticlesMultiTypeNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfrelatedArticlesMultiTypeNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
};

export type CfrelatedContentMultiTypeNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfrelatedContentMultiTypeNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfrelatedContentMultiTypeNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
};

export type CfrelatedNewsMultiTypeNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfrelatedNewsMultiTypeNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfrelatedNewsMultiTypeNestedFilter>>>;
  audio_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  date: InputMaybe<Scalars['DateTime']['input']>;
  date_exists: InputMaybe<Scalars['Boolean']['input']>;
  date_gt: InputMaybe<Scalars['DateTime']['input']>;
  date_gte: InputMaybe<Scalars['DateTime']['input']>;
  date_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_lt: InputMaybe<Scalars['DateTime']['input']>;
  date_lte: InputMaybe<Scalars['DateTime']['input']>;
  date_not: InputMaybe<Scalars['DateTime']['input']>;
  date_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  person_exists: InputMaybe<Scalars['Boolean']['input']>;
  quickLinks_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type CfresourcesMultiTypeNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfresourcesMultiTypeNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfresourcesMultiTypeNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type CfspotlightCtaLinkMultiTypeNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfspotlightCtaLinkMultiTypeNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfspotlightCtaLinkMultiTypeNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
};

export type CfteamsMultiTypeNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfteamsMultiTypeNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfteamsMultiTypeNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type CfyearMultiTypeNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfyearMultiTypeNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfyearMultiTypeNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type: InputMaybe<Scalars['String']['input']>;
  type_contains: InputMaybe<Scalars['String']['input']>;
  type_exists: InputMaybe<Scalars['Boolean']['input']>;
  type_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not: InputMaybe<Scalars['String']['input']>;
  type_not_contains: InputMaybe<Scalars['String']['input']>;
  type_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AllArticles_QueryQueryVariables = Exact<{
  types: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type AllArticles_QueryQuery = { __typename: 'Query', articleCollection: { __typename: 'ArticleCollection', items: Array<(
      { __typename: 'Article', slug: string | null, sys: { __typename: 'Sys', publishedAt: any | null } }
      & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Article_Fragment': InternalLink_EntryFragment_Article_Fragment;'Localization_EntryFragment_Article_Fragment': Localization_EntryFragment_Article_Fragment;'LocalizationMetadata_EntryFragment_Article_Fragment': LocalizationMetadata_EntryFragment_Article_Fragment } }
    ) | null> } | null };

export type Article_QueryQueryVariables = Exact<{
  types: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  locale: Scalars['String']['input'];
}>;


export type Article_QueryQuery = { __typename: 'Query', articleCollection: { __typename: 'ArticleCollection', items: Array<(
      { __typename: 'Article', title: string | null, description: string | null, date: any | null, hideDate: boolean | null, location: string | null, photographer: string | null, author: string | null, creditLabel: string | null, creditText: string | null, eyebrow: string | null, formattingOptions: Array<string | null> | null, hideShareLink: boolean | null, password: string | null, externalNewsUrl: string | null, hero: (
        { __typename: 'HeroAsset' }
        & { ' $fragmentRefs'?: { 'Header_HeroAssetFragmentFragment': Header_HeroAssetFragmentFragment } }
      ) | null, metadata: (
        { __typename: 'Metadata' }
        & { ' $fragmentRefs'?: { 'Metadata_MetadataFragmentFragment': Metadata_MetadataFragmentFragment } }
      ) | null, heroImage: (
        { __typename: 'Asset' }
        & { ' $fragmentRefs'?: { 'Header_AssetFragmentFragment': Header_AssetFragmentFragment;'Opengraph_AssetFragmentFragment': Opengraph_AssetFragmentFragment } }
      ) | null, grantMakingArea: { __typename: 'GrantmakingArea', name: string | null } | null, quickLinks: (
        { __typename: 'ConnectWith' }
        & { ' $fragmentRefs'?: { 'QuickLinks_ConnectWithFragmentFragment': QuickLinks_ConnectWithFragmentFragment } }
      ) | null, audio: (
        { __typename: 'Asset' }
        & { ' $fragmentRefs'?: { 'AudioPlayer_AssetFragmentFragment': AudioPlayer_AssetFragmentFragment } }
      ) | null, body: (
        { __typename: 'ArticleBody' }
        & { ' $fragmentRefs'?: { 'ArticleBodyRichText_ArticleBodyFragmentFragment': ArticleBodyRichText_ArticleBodyFragmentFragment } }
      ) | null, person: (
        { __typename: 'Person' }
        & { ' $fragmentRefs'?: { 'PersonCard_PersonFragmentFragment': PersonCard_PersonFragmentFragment } }
      ) | null, externalPerson: (
        { __typename: 'ExternalPerson' }
        & { ' $fragmentRefs'?: { 'PersonCard_ExternalPersonFragmentFragment': PersonCard_ExternalPersonFragmentFragment } }
      ) | null, relatedContentCollection: { __typename: 'ArticleRelatedContentCollection', items: Array<(
          { __typename: 'Article' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Article_Fragment': ContentGrid_EntryFragment_Article_Fragment } }
        ) | (
          { __typename: 'ExternalEvent' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_ExternalEvent_Fragment': ContentGrid_EntryFragment_ExternalEvent_Fragment } }
        ) | (
          { __typename: 'Feature' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Feature_Fragment': ContentGrid_EntryFragment_Feature_Fragment } }
        ) | (
          { __typename: 'GrantActivityArticle' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_GrantActivityArticle_Fragment': ContentGrid_EntryFragment_GrantActivityArticle_Fragment } }
        ) | (
          { __typename: 'Idea' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Idea_Fragment': ContentGrid_EntryFragment_Idea_Fragment } }
        ) | null> } | null, faqs: (
        { __typename: 'FaqsModule' }
        & { ' $fragmentRefs'?: { 'Faqs_FaqsModuleFragmentFragment': Faqs_FaqsModuleFragmentFragment } }
      ) | null, passwordProtectedPage: { __typename: 'PasswordProtectedPage', title: string | null, emailHeadline: string | null, email: { __typename: 'ConnectWithLink', label: string | null, externalLink: string | null } | null } | null }
      & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Article_Fragment': InternalLink_EntryFragment_Article_Fragment;'LocalizationMetadata_EntryFragment_Article_Fragment': LocalizationMetadata_EntryFragment_Article_Fragment;'Localization_EntryFragment_Article_Fragment': Localization_EntryFragment_Article_Fragment;'Cache_EntryFragment_Article_Fragment': Cache_EntryFragment_Article_Fragment } }
    ) | null> } | null };

export type GrantSearchFilters_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GrantSearchFilters_QueryQuery = { __typename: 'Query', grantSearchFiltersCollection: { __typename: 'GrantSearchFiltersCollection', items: Array<(
      { __typename: 'GrantSearchFilters', title: string | null, slug: string | null, termsOfUse: string | null, amountCollection: { __typename: 'GrantSearchFiltersAmountCollection', items: Array<(
          { __typename: 'ExplicitValueFilter' }
          & { ' $fragmentRefs'?: { 'Filter_EntryFragment_ExplicitValueFilter_Fragment': Filter_EntryFragment_ExplicitValueFilter_Fragment } }
        ) | (
          { __typename: 'RangeValueFilter' }
          & { ' $fragmentRefs'?: { 'Filter_EntryFragment_RangeValueFilter_Fragment': Filter_EntryFragment_RangeValueFilter_Fragment } }
        ) | null> } | null, yearCollection: { __typename: 'GrantSearchFiltersYearCollection', items: Array<(
          { __typename: 'ExplicitValueFilter' }
          & { ' $fragmentRefs'?: { 'Filter_EntryFragment_ExplicitValueFilter_Fragment': Filter_EntryFragment_ExplicitValueFilter_Fragment } }
        ) | (
          { __typename: 'RangeValueFilter' }
          & { ' $fragmentRefs'?: { 'Filter_EntryFragment_RangeValueFilter_Fragment': Filter_EntryFragment_RangeValueFilter_Fragment } }
        ) | null> } | null }
      & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_GrantSearchFilters_Fragment': InternalLink_EntryFragment_GrantSearchFilters_Fragment;'Cache_EntryFragment_GrantSearchFilters_Fragment': Cache_EntryFragment_GrantSearchFilters_Fragment } }
    ) | null> } | null };

export type SearchFeaturedSearches_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchFeaturedSearches_QueryQuery = { __typename: 'Query', searchPageCollection: { __typename: 'SearchPageCollection', items: Array<(
      { __typename: 'SearchPage', featuredSearches: Array<string | null> | null }
      & { ' $fragmentRefs'?: { 'Cache_EntryFragment_SearchPage_Fragment': Cache_EntryFragment_SearchPage_Fragment } }
    ) | null> } | null };

export type AllRootPages_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type AllRootPages_QueryQuery = { __typename: 'Query', rootPageCollection: { __typename: 'RootPageCollection', items: Array<(
      { __typename: 'RootPage', slug: string | null }
      & { ' $fragmentRefs'?: { 'Localization_EntryFragment_RootPage_Fragment': Localization_EntryFragment_RootPage_Fragment } }
    ) | null> } | null };

export type RootPage_QueryQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  locale: Scalars['String']['input'];
}>;


export type RootPage_QueryQuery = { __typename: 'Query', rootPageCollection: { __typename: 'RootPageCollection', items: Array<(
      { __typename: 'RootPage', title: string | null, includeLegalLogo: boolean | null, lastUpdated: any | null, metaDescription: string | null, sys: { __typename: 'Sys', id: string }, body: (
        { __typename: 'RootPageBody' }
        & { ' $fragmentRefs'?: { 'RootPageBodyRichText_RootPageBodyFragmentFragment': RootPageBodyRichText_RootPageBodyFragmentFragment } }
      ) | null }
      & { ' $fragmentRefs'?: { 'LocalizationMetadata_EntryFragment_RootPage_Fragment': LocalizationMetadata_EntryFragment_RootPage_Fragment;'Localization_EntryFragment_RootPage_Fragment': Localization_EntryFragment_RootPage_Fragment;'Cache_EntryFragment_RootPage_Fragment': Cache_EntryFragment_RootPage_Fragment } }
    ) | null> } | null };

export type AllAnnualReports_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type AllAnnualReports_QueryQuery = { __typename: 'Query', annualReportCollection: { __typename: 'AnnualReportCollection', items: Array<(
      { __typename: 'AnnualReport', year: string | null, sys: { __typename: 'Sys', publishedAt: any | null } }
      & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_AnnualReport_Fragment': InternalLink_EntryFragment_AnnualReport_Fragment } }
    ) | null> } | null };

export type AnnualReport_QueryQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type AnnualReport_QueryQuery = { __typename: 'Query', annualReportCollection: { __typename: 'AnnualReportCollection', items: Array<(
      { __typename: 'AnnualReport', year: string | null, description: string | null, header: string | null, articleBodyPart1: string | null, callToActionText: string | null, callToActionCtaText: string | null, moreAnnualReportsTitle: string | null, isLookingForAnnualReportsSectionVisible: boolean | null, headline: (
        { __typename: 'Asset' }
        & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
      ) | null, introImagesCollection: { __typename: 'AssetCollection', items: Array<(
          { __typename: 'Asset', description: string | null }
          & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
        ) | null> } | null, audio: { __typename: 'Asset', url: string | null } | null, articleBodyPart2: (
        { __typename: 'AnnualReportArticleBodyPart2' }
        & { ' $fragmentRefs'?: { 'AnnualReportBodyRichText_AnnualReportArticleBodyPart2FragmentFragment': AnnualReportBodyRichText_AnnualReportArticleBodyPart2FragmentFragment } }
      ) | null, person: (
        { __typename: 'Person' }
        & { ' $fragmentRefs'?: { 'PersonCard_PersonFragmentFragment': PersonCard_PersonFragmentFragment } }
      ) | null, quickLinks: (
        { __typename: 'ConnectWith' }
        & { ' $fragmentRefs'?: { 'QuickLinks_ConnectWithFragmentFragment': QuickLinks_ConnectWithFragmentFragment } }
      ) | null, moreAnnualReportsCollection: { __typename: 'AnnualReportMoreAnnualReportsCollection', items: Array<(
          { __typename: 'AnnualReport' }
          & { ' $fragmentRefs'?: { 'AnnualReportCard_AnnualReportFragmentFragment': AnnualReportCard_AnnualReportFragmentFragment } }
        ) | (
          { __typename: 'OldAnnualReport' }
          & { ' $fragmentRefs'?: { 'AnnualReportCard_OldAnnualReportFragmentFragment': AnnualReportCard_OldAnnualReportFragmentFragment } }
        ) | null> } | null }
      & { ' $fragmentRefs'?: { 'Cache_EntryFragment_AnnualReport_Fragment': Cache_EntryFragment_AnnualReport_Fragment;'InternalLink_EntryFragment_AnnualReport_Fragment': InternalLink_EntryFragment_AnnualReport_Fragment } }
    ) | null> } | null };

export type ContactPage_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactPage_QueryQuery = { __typename: 'Query', contactCollection: { __typename: 'ContactCollection', items: Array<(
      { __typename: 'Contact', title: string | null, slug: string | null, description: string | null, officeContactInformationHeadline: string | null, officeAddress: string | null, officeAddressGoogleMapsLabel: string | null, officeAddressGoogleMapsLink: string | null, officeTelephoneNumber: string | null, officeFaxNumber: string | null, contactEmailsHeadline: string | null, grantInquiriesHeadline: string | null, grantInquiriesText: string | null, socialMediaHeadline: string | null, socialMediaText: string | null, quickLinks: (
        { __typename: 'ConnectWith' }
        & { ' $fragmentRefs'?: { 'QuickLinks_ConnectWithFragmentFragment': QuickLinks_ConnectWithFragmentFragment } }
      ) | null, emailsCollection: { __typename: 'ContactEmailsCollection', items: Array<(
          { __typename: 'ConnectWithLink' }
          & { ' $fragmentRefs'?: { 'QuickLink_ConnectWithLinkFragmentFragment': QuickLink_ConnectWithLinkFragmentFragment } }
        ) | null> } | null, grantInquiriesLink: (
        { __typename: 'ConnectWithLink' }
        & { ' $fragmentRefs'?: { 'QuickLink_ConnectWithLinkFragmentFragment': QuickLink_ConnectWithLinkFragmentFragment } }
      ) | null, newsletter: (
        { __typename: 'NewsletterCard' }
        & { ' $fragmentRefs'?: { 'Newsletter_NewsletterFragmentFragment': Newsletter_NewsletterFragmentFragment } }
      ) | null }
      & { ' $fragmentRefs'?: { 'Socials_ContactFragmentFragment': Socials_ContactFragmentFragment;'InternalLink_EntryFragment_Contact_Fragment': InternalLink_EntryFragment_Contact_Fragment;'Cache_EntryFragment_Contact_Fragment': Cache_EntryFragment_Contact_Fragment } }
    ) | null> } | null };

export type EventsPage_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type EventsPage_QueryQuery = { __typename: 'Query', eventsPageCollection: { __typename: 'EventsPageCollection', items: Array<(
      { __typename: 'EventsPage', title: string | null, description: string | null, newsletter: (
        { __typename: 'NewsletterCard' }
        & { ' $fragmentRefs'?: { 'Newsletter_NewsletterFragmentFragment': Newsletter_NewsletterFragmentFragment } }
      ) | null, upcomingEventsCollection: { __typename: 'EventsPageUpcomingEventsCollection', items: Array<(
          { __typename: 'ExternalEvent' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_ExternalEvent_Fragment': ContentGrid_EntryFragment_ExternalEvent_Fragment } }
        ) | null> } | null }
      & { ' $fragmentRefs'?: { 'Cache_EntryFragment_EventsPage_Fragment': Cache_EntryFragment_EventsPage_Fragment;'InternalLink_EntryFragment_EventsPage_Fragment': InternalLink_EntryFragment_EventsPage_Fragment } }
    ) | null> } | null };

export type EventsPageEvents_QueryQueryVariables = Exact<{
  skip: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type EventsPageEvents_QueryQuery = { __typename: 'Query', articleCollection: { __typename: 'ArticleCollection', total: number, items: Array<(
      { __typename: 'Article', title: string | null, description: string | null, date: any | null, heroImage: (
        { __typename: 'Asset' }
        & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
      ) | null }
      & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Article_Fragment': InternalLink_EntryFragment_Article_Fragment;'ArticleCard_ArticleFragmentFragment': ArticleCard_ArticleFragmentFragment } }
    ) | null> } | null };

export type AllFeatures_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type AllFeatures_QueryQuery = { __typename: 'Query', featureCollection: { __typename: 'FeatureCollection', items: Array<(
      { __typename: 'Feature', slug: string | null, sys: { __typename: 'Sys', publishedAt: any | null } }
      & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Feature_Fragment': InternalLink_EntryFragment_Feature_Fragment } }
    ) | null> } | null };

export type Feature_QueryQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type Feature_QueryQuery = { __typename: 'Query', featureCollection: { __typename: 'FeatureCollection', items: Array<(
      { __typename: 'Feature', name: string | null, tagline: string | null, date: string | null, ctaContextualMessage: string | null, showSocialCtas: boolean | null, heroImage: (
        { __typename: 'Asset' }
        & { ' $fragmentRefs'?: { 'Header_AssetFragmentFragment': Header_AssetFragmentFragment;'Opengraph_AssetFragmentFragment': Opengraph_AssetFragmentFragment } }
      ) | null, hero: (
        { __typename: 'HeroAsset' }
        & { ' $fragmentRefs'?: { 'Header_HeroAssetFragmentFragment': Header_HeroAssetFragmentFragment;'Opengraph_HeroAssetFragmentFragment': Opengraph_HeroAssetFragmentFragment } }
      ) | null, quickLinks: { __typename: 'ConnectWith', eyebrow: string | null, heading: string | null, linksCollection: { __typename: 'ConnectWithLinksCollection', items: Array<(
            { __typename: 'ConnectWithLink' }
            & { ' $fragmentRefs'?: { 'QuickLink_ConnectWithLinkFragmentFragment': QuickLink_ConnectWithLinkFragmentFragment } }
          ) | null> } | null } | null, intro: (
        { __typename: 'FeatureIntro' }
        & { ' $fragmentRefs'?: { 'FeatureIntroRichText_FeatureIntroFragmentFragment': FeatureIntroRichText_FeatureIntroFragmentFragment } }
      ) | null, newsletter: (
        { __typename: 'NewsletterCard' }
        & { ' $fragmentRefs'?: { 'Newsletter_NewsletterFragmentFragment': Newsletter_NewsletterFragmentFragment } }
      ) | null, callout: (
        { __typename: 'Article', type: string | null, body: { __typename: 'ArticleBody', links: { __typename: 'ArticleBodyLinks', entries: { __typename: 'ArticleBodyEntries', block: Array<{ __typename: 'AnnualReport' } | { __typename: 'Article' } | { __typename: 'AtGlanceCard' } | { __typename: 'CallForConcept' } | { __typename: 'ConnectWith' } | { __typename: 'ConnectWithLink' } | { __typename: 'Contact' } | { __typename: 'ContactPerson' } | { __typename: 'Department' } | { __typename: 'DropCap' } | { __typename: 'EmphasizedArticle' } | { __typename: 'EventsPage' } | { __typename: 'ExperienceBlock' } | { __typename: 'ExplicitValueFilter' } | { __typename: 'ExternalEvent' } | { __typename: 'ExternalPerson' } | { __typename: 'Faq' } | { __typename: 'FaqsModule' } | { __typename: 'Feature' } | { __typename: 'FinancialsPage' } | { __typename: 'Footer' } | { __typename: 'Grant' } | { __typename: 'GrantActivityArticle' } | { __typename: 'GrantDetailsPage' } | { __typename: 'GrantResources' } | { __typename: 'GrantSearchFilters' } | { __typename: 'GrantmakingArea' } | { __typename: 'GrantmakingAreaDetailsPage' } | { __typename: 'GrantmakingAreasPage' } | { __typename: 'HeroAsset' } | { __typename: 'HistoryPage' } | { __typename: 'HistoryPerson' } | { __typename: 'HomePage' } | { __typename: 'Idea' } | { __typename: 'InitiativeQuoteCallOut' } | { __typename: 'InlineCards' } | { __typename: 'InlineImages' } | { __typename: 'MainNavigation' } | { __typename: 'Metadata' } | { __typename: 'MissionPage' } | { __typename: 'Mmuf' } | { __typename: 'NavigationItem' } | { __typename: 'NewsPage' } | { __typename: 'NewsletterCard' } | { __typename: 'NewsletterConfirmPage' } | { __typename: 'NewsletterPage' } | { __typename: 'OldAnnualReport' } | { __typename: 'Organisation' } | { __typename: 'ParallaxImages' } | { __typename: 'PasswordProtectedPage' } | { __typename: 'PeoplePage' } | { __typename: 'Person' } | { __typename: 'PresidentialQuoteCallOut' } | { __typename: 'PressRoom' } | { __typename: 'PrivacyPolicy' } | { __typename: 'QuickLink' } | { __typename: 'Quote' } | { __typename: 'RangeValueFilter' } | { __typename: 'ResourcesCurrentGrantees' } | { __typename: 'ResourcesProspectiveGrantees' } | { __typename: 'RootPage' } | { __typename: 'SearchPage' } | { __typename: 'SpotlightSlideshow' } | (
                { __typename: 'SpotlightVideo' }
                & { ' $fragmentRefs'?: { 'SpotlightVideo_SpotlightVideoFragmentFragment': SpotlightVideo_SpotlightVideoFragmentFragment } }
              ) | { __typename: 'StoriesPage' } | { __typename: 'Taxonomy' } | { __typename: 'TermsOfUse' } | { __typename: 'Theme' } | { __typename: 'Trustee' } | { __typename: 'TrusteesPage' } | { __typename: 'VideoNative' } | { __typename: 'VideoYoutube' } | null> } } } | null }
        & { ' $fragmentRefs'?: { 'ArticleCard_ArticleFragmentFragment': ArticleCard_ArticleFragmentFragment } }
      ) | (
        { __typename: 'ExternalEvent' }
        & { ' $fragmentRefs'?: { 'FutureEventCard_ExternalEventFragmentFragment': FutureEventCard_ExternalEventFragmentFragment } }
      ) | (
        { __typename: 'GrantActivityArticle' }
        & { ' $fragmentRefs'?: { 'GrantStoryCard_GrantActivityArticleFragmentFragment': GrantStoryCard_GrantActivityArticleFragmentFragment } }
      ) | null, content: (
        { __typename: 'FeatureContent' }
        & { ' $fragmentRefs'?: { 'FeatureContentRichText_FeatureBodyFragmentFragment': FeatureContentRichText_FeatureBodyFragmentFragment } }
      ) | null, relatedContentCollection: { __typename: 'FeatureRelatedContentCollection', items: Array<(
          { __typename: 'Article' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Article_Fragment': ContentGrid_EntryFragment_Article_Fragment } }
        ) | (
          { __typename: 'ExternalEvent' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_ExternalEvent_Fragment': ContentGrid_EntryFragment_ExternalEvent_Fragment } }
        ) | (
          { __typename: 'Feature' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Feature_Fragment': ContentGrid_EntryFragment_Feature_Fragment } }
        ) | (
          { __typename: 'GrantActivityArticle' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_GrantActivityArticle_Fragment': ContentGrid_EntryFragment_GrantActivityArticle_Fragment } }
        ) | (
          { __typename: 'Idea' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Idea_Fragment': ContentGrid_EntryFragment_Idea_Fragment } }
        ) | null> } | null, experienceBlock: (
        { __typename: 'ExperienceBlock' }
        & { ' $fragmentRefs'?: { 'ExperienceBlock_ExperienceBlockFragmentFragment': ExperienceBlock_ExperienceBlockFragmentFragment } }
      ) | null }
      & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Feature_Fragment': InternalLink_EntryFragment_Feature_Fragment;'Cache_EntryFragment_Feature_Fragment': Cache_EntryFragment_Feature_Fragment } }
    ) | null> } | null };

export type CbaImages_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type CbaImages_QueryQuery = { __typename: 'Query', assetCollection: { __typename: 'AssetCollection', items: Array<{ __typename: 'Asset', title: string | null, fileName: string | null, url: string | null, width: number | null, height: number | null, contentfulMetadata: { __typename: 'ContentfulMetadata', tags: Array<{ __typename: 'ContentfulTag', id: string | null, name: string | null } | null> } } | null> } | null };

export type FinancialsPage_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type FinancialsPage_QueryQuery = { __typename: 'Query', financialsPageCollection: { __typename: 'FinancialsPageCollection', items: Array<(
      { __typename: 'FinancialsPage', title: string | null, introDescription: string | null, introParagraph: string | null, socialBondFramework: string | null, socialBondFrameworkText: string | null, financialReportsHeader: string | null, auditedFinancialStatementsHeader: string | null, privateFoundationReportsHeader: string | null, navigationImagePortrait: (
        { __typename: 'Asset' }
        & { ' $fragmentRefs'?: { 'Opengraph_AssetFragmentFragment': Opengraph_AssetFragmentFragment } }
      ) | null, quickLinks: (
        { __typename: 'ConnectWith' }
        & { ' $fragmentRefs'?: { 'QuickLinks_ConnectWithFragmentFragment': QuickLinks_ConnectWithFragmentFragment } }
      ) | null, graphsSection: (
        { __typename: 'FinancialsPageGraphsSection' }
        & { ' $fragmentRefs'?: { 'FinancialsGraphSectionRichText_FinancialsPageGraphsSectionFragmentFragment': FinancialsGraphSectionRichText_FinancialsPageGraphsSectionFragmentFragment } }
      ) | null, socialBondFrameworkLink: (
        { __typename: 'ConnectWithLink' }
        & { ' $fragmentRefs'?: { 'QuickLink_ConnectWithLinkFragmentFragment': QuickLink_ConnectWithLinkFragmentFragment } }
      ) | null, financialReportsCollection: { __typename: 'AssetCollection', items: Array<{ __typename: 'Asset', url: string | null, title: string | null } | null> } | null, auditedFinancialStatementsCollection: { __typename: 'AssetCollection', items: Array<{ __typename: 'Asset', url: string | null, title: string | null } | null> } | null, privateFoundationReportsCollection: { __typename: 'AssetCollection', items: Array<{ __typename: 'Asset', url: string | null, title: string | null } | null> } | null }
      & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_FinancialsPage_Fragment': InternalLink_EntryFragment_FinancialsPage_Fragment;'Cache_EntryFragment_FinancialsPage_Fragment': Cache_EntryFragment_FinancialsPage_Fragment } }
    ) | null> } | null };

export type GrantDetailsPageRelatedGrants_GrantFragmentFragment = { __typename: 'Grant', id: string | null, organization: { __typename: 'Organisation', id: string | null } | null } & { ' $fragmentName'?: 'GrantDetailsPageRelatedGrants_GrantFragmentFragment' };

export type GrantDetailsPage_RelatedGrantsQueryQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  grantId: Scalars['String']['input'];
}>;


export type GrantDetailsPage_RelatedGrantsQueryQuery = { __typename: 'Query', grantCollection: { __typename: 'GrantCollection', items: Array<(
      { __typename: 'Grant' }
      & { ' $fragmentRefs'?: { 'GrantCard_GrantFragmentFragment': GrantCard_GrantFragmentFragment } }
    ) | null> } | null };

export type GrantDetails_GrantFragmentFragment = (
  { __typename: 'Grant', id: string | null, description: string | null, amount: number | null, date: any | null, durationInMonths: number | null, grantmakingArea: { __typename: 'GrantmakingArea', name: string | null } | null, organization: { __typename: 'Organisation', name: string | null, city: string | null, state: string | null, country: string | null } | null }
  & { ' $fragmentRefs'?: { 'GrantTitle_GrantFragmentFragment': GrantTitle_GrantFragmentFragment;'GrantSlug_GrantFragmentFragment': GrantSlug_GrantFragmentFragment;'GrantDetailsPageRelatedGrants_GrantFragmentFragment': GrantDetailsPageRelatedGrants_GrantFragmentFragment;'InternalLink_EntryFragment_Grant_Fragment': InternalLink_EntryFragment_Grant_Fragment } }
) & { ' $fragmentName'?: 'GrantDetails_GrantFragmentFragment' };

export type TotalGrants_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type TotalGrants_QueryQuery = { __typename: 'Query', grantCollection: { __typename: 'GrantCollection', total: number } | null };

export type GrantsByPage_QueryQueryVariables = Exact<{
  skip: Scalars['Int']['input'];
}>;


export type GrantsByPage_QueryQuery = { __typename: 'Query', grantCollection: { __typename: 'GrantCollection', items: Array<(
      { __typename: 'Grant' }
      & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Grant_Fragment': InternalLink_EntryFragment_Grant_Fragment } }
    ) | null> } | null };

export type GrantDetails_GrantQueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GrantDetails_GrantQueryQuery = { __typename: 'Query', grantCollection: { __typename: 'GrantCollection', items: Array<(
      { __typename: 'Grant' }
      & { ' $fragmentRefs'?: { 'GrantDetails_GrantFragmentFragment': GrantDetails_GrantFragmentFragment;'Cache_EntryFragment_Grant_Fragment': Cache_EntryFragment_Grant_Fragment } }
    ) | null> } | null };

export type GrantDetails_QueryQueryVariables = Exact<{
  grantId: Scalars['String']['input'];
}>;


export type GrantDetails_QueryQuery = { __typename: 'Query', grantDetailsPageCollection: { __typename: 'GrantDetailsPageCollection', items: Array<(
      { __typename: 'GrantDetailsPage', strategyCopy: string | null, strategyCtaLabel: string | null, relatedActivitiesCollection: { __typename: 'GrantDetailsPageRelatedActivitiesCollection', items: Array<(
          { __typename: 'Article' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Article_Fragment': ContentGrid_EntryFragment_Article_Fragment } }
        ) | (
          { __typename: 'GrantActivityArticle' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_GrantActivityArticle_Fragment': ContentGrid_EntryFragment_GrantActivityArticle_Fragment } }
        ) | null> } | null, granteeInformation: (
        { __typename: 'ConnectWith' }
        & { ' $fragmentRefs'?: { 'QuickLinks_ConnectWithFragmentFragment': QuickLinks_ConnectWithFragmentFragment } }
      ) | null, grant: (
        { __typename: 'Grant' }
        & { ' $fragmentRefs'?: { 'GrantDetails_GrantFragmentFragment': GrantDetails_GrantFragmentFragment } }
      ) | null }
      & { ' $fragmentRefs'?: { 'Cache_EntryFragment_GrantDetailsPage_Fragment': Cache_EntryFragment_GrantDetailsPage_Fragment } }
    ) | null> } | null };

export type AllGrantPrograms_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type AllGrantPrograms_QueryQuery = { __typename: 'Query', grantmakingAreaDetailsPageCollection: { __typename: 'GrantmakingAreaDetailsPageCollection', items: Array<(
      { __typename: 'GrantmakingAreaDetailsPage', slug: string | null, sys: { __typename: 'Sys', publishedAt: any | null } }
      & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_GrantmakingAreaDetailsPage_Fragment': InternalLink_EntryFragment_GrantmakingAreaDetailsPage_Fragment } }
    ) | null> } | null };

export type GrantProgram_QueryQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GrantProgram_QueryQuery = { __typename: 'Query', grantmakingAreaDetailsPageCollection: { __typename: 'GrantmakingAreaDetailsPageCollection', items: Array<(
      { __typename: 'GrantmakingAreaDetailsPage', title: string | null, introDescription: string | null, introductionText: string | null, grantMakingProcessMessage: string | null, heroImage: (
        { __typename: 'Asset' }
        & { ' $fragmentRefs'?: { 'Header_AssetFragmentFragment': Header_AssetFragmentFragment;'Opengraph_AssetFragmentFragment': Opengraph_AssetFragmentFragment } }
      ) | null, quickLinks: (
        { __typename: 'ConnectWith' }
        & { ' $fragmentRefs'?: { 'QuickLinks_ConnectWithFragmentFragment': QuickLinks_ConnectWithFragmentFragment } }
      ) | null, body: (
        { __typename: 'GrantmakingAreaDetailsPageBody' }
        & { ' $fragmentRefs'?: { 'GrantmakingAreaDetailsPageBodyRichText_GrantmakingAreaDetailsPageBodyFragmentFragment': GrantmakingAreaDetailsPageBodyRichText_GrantmakingAreaDetailsPageBodyFragmentFragment } }
      ) | null, inFocusContentCollection: { __typename: 'GrantmakingAreaDetailsPageInFocusContentCollection', items: Array<(
          { __typename: 'Article' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Article_Fragment': ContentGrid_EntryFragment_Article_Fragment } }
        ) | (
          { __typename: 'GrantActivityArticle' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_GrantActivityArticle_Fragment': ContentGrid_EntryFragment_GrantActivityArticle_Fragment } }
        ) | (
          { __typename: 'Mmuf' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Mmuf_Fragment': ContentGrid_EntryFragment_Mmuf_Fragment } }
        ) | (
          { __typename: 'Quote' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Quote_Fragment': ContentGrid_EntryFragment_Quote_Fragment } }
        ) | null> } | null, callForConceptsCollection: { __typename: 'GrantmakingAreaDetailsPageCallForConceptsCollection', items: Array<(
          { __typename: 'CallForConcept' }
          & { ' $fragmentRefs'?: { 'CallForConcepts_CallForConceptFragmentFragment': CallForConcepts_CallForConceptFragmentFragment } }
        ) | null> } | null }
      & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_GrantmakingAreaDetailsPage_Fragment': InternalLink_EntryFragment_GrantmakingAreaDetailsPage_Fragment;'Cache_EntryFragment_GrantmakingAreaDetailsPage_Fragment': Cache_EntryFragment_GrantmakingAreaDetailsPage_Fragment } }
    ) | null> } | null };

export type GrantProgramsPage_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GrantProgramsPage_QueryQuery = { __typename: 'Query', grantmakingAreasPageCollection: { __typename: 'GrantmakingAreasPageCollection', items: Array<(
      { __typename: 'GrantmakingAreasPage', title: string | null, introDescription: string | null, contextualMessage: string | null, navigationImagePortrait: (
        { __typename: 'Asset' }
        & { ' $fragmentRefs'?: { 'Opengraph_AssetFragmentFragment': Opengraph_AssetFragmentFragment } }
      ) | null, grantmakingAreasCollection: { __typename: 'GrantmakingAreasPageGrantmakingAreasCollection', items: Array<(
          { __typename: 'GrantmakingAreaDetailsPage' }
          & { ' $fragmentRefs'?: { 'GrantmakingAreaCard_GrantmakingAreaDetailsPageFragmentFragment': GrantmakingAreaCard_GrantmakingAreaDetailsPageFragmentFragment } }
        ) | null> } | null }
      & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_GrantmakingAreasPage_Fragment': InternalLink_EntryFragment_GrantmakingAreasPage_Fragment;'Cache_EntryFragment_GrantmakingAreasPage_Fragment': Cache_EntryFragment_GrantmakingAreasPage_Fragment } }
    ) | null> } | null };

export type AllGrantStories_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type AllGrantStories_QueryQuery = { __typename: 'Query', grantActivityArticleCollection: { __typename: 'GrantActivityArticleCollection', items: Array<(
      { __typename: 'GrantActivityArticle', slug: string | null, sys: { __typename: 'Sys', publishedAt: any | null } }
      & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_GrantActivityArticle_Fragment': InternalLink_EntryFragment_GrantActivityArticle_Fragment;'Localization_EntryFragment_GrantActivityArticle_Fragment': Localization_EntryFragment_GrantActivityArticle_Fragment;'LocalizationMetadata_EntryFragment_GrantActivityArticle_Fragment': LocalizationMetadata_EntryFragment_GrantActivityArticle_Fragment } }
    ) | null> } | null };

export type GrantStory_QueryQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  locale: Scalars['String']['input'];
}>;


export type GrantStory_QueryQuery = { __typename: 'Query', grantActivityArticleCollection: { __typename: 'GrantActivityArticleCollection', items: Array<(
      { __typename: 'GrantActivityArticle', title: string | null, granteeNameOverride: string | null, granteeCountryOverride: string | null, granteeStateOverride: string | null, granteeCityOverride: string | null, hideDate: boolean | null, date: any | null, photographer: string | null, author: string | null, creditLabel: string | null, creditText: string | null, grantInsight: string | null, hideShareLink: boolean | null, formattingOptions: Array<string | null> | null, sys: { __typename: 'Sys', id: string }, metadata: (
        { __typename: 'Metadata' }
        & { ' $fragmentRefs'?: { 'Metadata_MetadataFragmentFragment': Metadata_MetadataFragmentFragment } }
      ) | null, hero: (
        { __typename: 'HeroAsset' }
        & { ' $fragmentRefs'?: { 'Header_HeroAssetFragmentFragment': Header_HeroAssetFragmentFragment;'Opengraph_HeroAssetFragmentFragment': Opengraph_HeroAssetFragmentFragment } }
      ) | null, leadImage: (
        { __typename: 'Asset' }
        & { ' $fragmentRefs'?: { 'Header_AssetFragmentFragment': Header_AssetFragmentFragment;'Opengraph_AssetFragmentFragment': Opengraph_AssetFragmentFragment } }
      ) | null, grant: (
        { __typename: 'Grant', id: string | null, projectTitle: string | null, organization: { __typename: 'Organisation', name: string | null, city: string | null, state: string | null, country: string | null } | null, grantmakingArea: { __typename: 'GrantmakingArea', name: string | null } | null }
        & { ' $fragmentRefs'?: { 'GrantTitle_GrantFragmentFragment': GrantTitle_GrantFragmentFragment;'InternalLink_EntryFragment_Grant_Fragment': InternalLink_EntryFragment_Grant_Fragment } }
      ) | null, audio: { __typename: 'Asset', url: string | null } | null, body: (
        { __typename: 'GrantActivityArticleBody' }
        & { ' $fragmentRefs'?: { 'GrantStoryBodyRichText_GrantActivityArticleBodyFragmentFragment': GrantStoryBodyRichText_GrantActivityArticleBodyFragmentFragment } }
      ) | null, connectLinksCollection: { __typename: 'GrantActivityArticleConnectLinksCollection', items: Array<(
          { __typename: 'ConnectWithLink' }
          & { ' $fragmentRefs'?: { 'QuickLink_ConnectWithLinkFragmentFragment': QuickLink_ConnectWithLinkFragmentFragment } }
        ) | null> } | null, relatedArticlesCollection: { __typename: 'GrantActivityArticleRelatedArticlesCollection', items: Array<(
          { __typename: 'Article' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Article_Fragment': ContentGrid_EntryFragment_Article_Fragment } }
        ) | (
          { __typename: 'ExternalEvent' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_ExternalEvent_Fragment': ContentGrid_EntryFragment_ExternalEvent_Fragment } }
        ) | (
          { __typename: 'Feature' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Feature_Fragment': ContentGrid_EntryFragment_Feature_Fragment } }
        ) | (
          { __typename: 'GrantActivityArticle' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_GrantActivityArticle_Fragment': ContentGrid_EntryFragment_GrantActivityArticle_Fragment } }
        ) | (
          { __typename: 'Idea' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Idea_Fragment': ContentGrid_EntryFragment_Idea_Fragment } }
        ) | null> } | null, experienceBlock: (
        { __typename: 'ExperienceBlock' }
        & { ' $fragmentRefs'?: { 'ExperienceBlock_ExperienceBlockFragmentFragment': ExperienceBlock_ExperienceBlockFragmentFragment } }
      ) | null }
      & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_GrantActivityArticle_Fragment': InternalLink_EntryFragment_GrantActivityArticle_Fragment;'LocalizationMetadata_EntryFragment_GrantActivityArticle_Fragment': LocalizationMetadata_EntryFragment_GrantActivityArticle_Fragment;'Localization_EntryFragment_GrantActivityArticle_Fragment': Localization_EntryFragment_GrantActivityArticle_Fragment;'Cache_EntryFragment_GrantActivityArticle_Fragment': Cache_EntryFragment_GrantActivityArticle_Fragment } }
    ) | null> } | null };

export type JazzVideo_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type JazzVideo_QueryQuery = { __typename: 'Query', videoNative: (
    { __typename: 'VideoNative' }
    & { ' $fragmentRefs'?: { 'Video_VideoNativeFragmentFragment': Video_VideoNativeFragmentFragment;'Cache_EntryFragment_VideoNative_Fragment': Cache_EntryFragment_VideoNative_Fragment } }
  ) | null };

export type AllHistoryPersons_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type AllHistoryPersons_QueryQuery = { __typename: 'Query', historyPersonCollection: { __typename: 'HistoryPersonCollection', items: Array<(
      { __typename: 'HistoryPerson', slug: string | null, sys: { __typename: 'Sys', publishedAt: any | null } }
      & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_HistoryPerson_Fragment': InternalLink_EntryFragment_HistoryPerson_Fragment } }
    ) | null> } | null };

export type HistoryPerson_QueryQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type HistoryPerson_QueryQuery = { __typename: 'Query', historyPersonCollection: { __typename: 'HistoryPersonCollection', items: Array<(
      { __typename: 'HistoryPerson', biography: string | null, name: string | null, slug: string | null, title: string | null, startYear: string | null, endYear: string | null, image: (
        { __typename: 'Asset' }
        & { ' $fragmentRefs'?: { 'Header_AssetFragmentFragment': Header_AssetFragmentFragment;'Opengraph_AssetFragmentFragment': Opengraph_AssetFragmentFragment } }
      ) | null }
      & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_HistoryPerson_Fragment': InternalLink_EntryFragment_HistoryPerson_Fragment;'Cache_EntryFragment_HistoryPerson_Fragment': Cache_EntryFragment_HistoryPerson_Fragment } }
    ) | null> } | null };

export type HistoryPage_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type HistoryPage_QueryQuery = { __typename: 'Query', historyPageCollection: { __typename: 'HistoryPageCollection', items: Array<(
      { __typename: 'HistoryPage', title: string | null, description: string | null, text: string | null, impactTitle: string | null, explanatoryParagraph: string | null, peopleTitle: string | null, peopleSubtitle: string | null, peopleDescription: string | null, presidentsTitle: string | null, currentPresidentStartYear: string | null, spaceTitle: string | null, spaceDescription: string | null, grantMakingProcessDescription: string | null, grantMakingProcessCtaText: string | null, heroImage: (
        { __typename: 'Asset' }
        & { ' $fragmentRefs'?: { 'Header_AssetFragmentFragment': Header_AssetFragmentFragment;'Opengraph_AssetFragmentFragment': Opengraph_AssetFragmentFragment } }
      ) | null, impactArticlesCollection: { __typename: 'HistoryPageImpactArticlesCollection', items: Array<(
          { __typename: 'Article', title: string | null }
          & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Article_Fragment': InternalLink_EntryFragment_Article_Fragment } }
        ) | null> } | null, foundersCollection: { __typename: 'HistoryPageFoundersCollection', items: Array<(
          { __typename: 'HistoryPerson' }
          & { ' $fragmentRefs'?: { 'LeadershipCard_HistoryPersonFragmentFragment': LeadershipCard_HistoryPersonFragmentFragment } }
        ) | null> } | null, currentPresident: { __typename: 'Person', name: string | null, image: (
          { __typename: 'Asset' }
          & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
        ) | null } | null, previousPresidentsCollection: { __typename: 'HistoryPagePreviousPresidentsCollection', items: Array<(
          { __typename: 'HistoryPerson' }
          & { ' $fragmentRefs'?: { 'PersonCard_HistoryPersonFragmentFragment': PersonCard_HistoryPersonFragmentFragment } }
        ) | null> } | null, spaceImagesCollection: { __typename: 'AssetCollection', items: Array<(
          { __typename: 'Asset', description: string | null }
          & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
        ) | null> } | null }
      & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_HistoryPage_Fragment': InternalLink_EntryFragment_HistoryPage_Fragment;'Cache_EntryFragment_HistoryPage_Fragment': Cache_EntryFragment_HistoryPage_Fragment } }
    ) | null> } | null };

export type AllIdeas_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type AllIdeas_QueryQuery = { __typename: 'Query', ideaCollection: { __typename: 'IdeaCollection', items: Array<(
      { __typename: 'Idea', slug: string | null, sys: { __typename: 'Sys', publishedAt: any | null } }
      & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Idea_Fragment': InternalLink_EntryFragment_Idea_Fragment } }
    ) | null> } | null };

export type Idea_QueryQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type Idea_QueryQuery = { __typename: 'Query', ideaCollection: { __typename: 'IdeaCollection', items: Array<(
      { __typename: 'Idea', question: string | null, name: string | null, ideaSetupStatement: string | null, ctaContextualMessage: string | null, heroImage: (
        { __typename: 'Asset' }
        & { ' $fragmentRefs'?: { 'Header_AssetFragmentFragment': Header_AssetFragmentFragment;'Opengraph_AssetFragmentFragment': Opengraph_AssetFragmentFragment } }
      ) | null, navigationImagePortrait: (
        { __typename: 'Asset' }
        & { ' $fragmentRefs'?: { 'Opengraph_AssetFragmentFragment': Opengraph_AssetFragmentFragment } }
      ) | null, contentCollection: { __typename: 'IdeaContentCollection', items: Array<(
          { __typename: 'Article' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Article_Fragment': ContentGrid_EntryFragment_Article_Fragment } }
        ) | (
          { __typename: 'EmphasizedArticle' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_EmphasizedArticle_Fragment': ContentGrid_EntryFragment_EmphasizedArticle_Fragment;'EmphasizedCard_EmphasizedArticleQueryFragment': EmphasizedCard_EmphasizedArticleQueryFragment } }
        ) | (
          { __typename: 'ExternalEvent' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_ExternalEvent_Fragment': ContentGrid_EntryFragment_ExternalEvent_Fragment } }
        ) | (
          { __typename: 'Feature' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Feature_Fragment': ContentGrid_EntryFragment_Feature_Fragment } }
        ) | (
          { __typename: 'GrantActivityArticle' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_GrantActivityArticle_Fragment': ContentGrid_EntryFragment_GrantActivityArticle_Fragment } }
        ) | (
          { __typename: 'Idea' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Idea_Fragment': ContentGrid_EntryFragment_Idea_Fragment } }
        ) | (
          { __typename: 'InitiativeQuoteCallOut' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_InitiativeQuoteCallOut_Fragment': ContentGrid_EntryFragment_InitiativeQuoteCallOut_Fragment;'InitiativeQuote_InitiativeQuoteCallOutFragmentFragment': InitiativeQuote_InitiativeQuoteCallOutFragmentFragment } }
        ) | (
          { __typename: 'Quote' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Quote_Fragment': ContentGrid_EntryFragment_Quote_Fragment;'QuoteModule_QuoteFragmentFragment': QuoteModule_QuoteFragmentFragment } }
        ) | (
          { __typename: 'SpotlightSlideshow' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_SpotlightSlideshow_Fragment': ContentGrid_EntryFragment_SpotlightSlideshow_Fragment;'SpotlightSlideshow_SpotlightSlideshowFragmentFragment': SpotlightSlideshow_SpotlightSlideshowFragmentFragment } }
        ) | (
          { __typename: 'SpotlightVideo' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_SpotlightVideo_Fragment': ContentGrid_EntryFragment_SpotlightVideo_Fragment;'SpotlightVideo_SpotlightVideoFragmentFragment': SpotlightVideo_SpotlightVideoFragmentFragment } }
        ) | null> } | null, callForConceptsCollection: { __typename: 'IdeaCallForConceptsCollection', items: Array<(
          { __typename: 'CallForConcept' }
          & { ' $fragmentRefs'?: { 'CallForConcepts_CallForConceptFragmentFragment': CallForConcepts_CallForConceptFragmentFragment } }
        ) | null> } | null }
      & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Idea_Fragment': InternalLink_EntryFragment_Idea_Fragment;'Cache_EntryFragment_Idea_Fragment': Cache_EntryFragment_Idea_Fragment } }
    ) | null> } | null };

export type MissionPage_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type MissionPage_QueryQuery = { __typename: 'Query', missionPageCollection: { __typename: 'MissionPageCollection', items: Array<(
      { __typename: 'MissionPage', title: string | null, description: string | null, navigationImagePortrait: (
        { __typename: 'Asset' }
        & { ' $fragmentRefs'?: { 'Opengraph_AssetFragmentFragment': Opengraph_AssetFragmentFragment } }
      ) | null, atGlanceCardsCollection: { __typename: 'MissionPageAtGlanceCardsCollection', items: Array<(
          { __typename: 'AtGlanceCard' }
          & { ' $fragmentRefs'?: { 'HighlightCard_AtGlanceCardFragmentFragment': HighlightCard_AtGlanceCardFragmentFragment } }
        ) | null> } | null, quote: (
        { __typename: 'Quote' }
        & { ' $fragmentRefs'?: { 'QuoteModule_QuoteFragmentFragment': QuoteModule_QuoteFragmentFragment } }
      ) | null }
      & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_MissionPage_Fragment': InternalLink_EntryFragment_MissionPage_Fragment;'Cache_EntryFragment_MissionPage_Fragment': Cache_EntryFragment_MissionPage_Fragment } }
    ) | null> } | null };

export type MmufPage_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type MmufPage_QueryQuery = { __typename: 'Query', mmufCollection: { __typename: 'MmufCollection', items: Array<(
      { __typename: 'Mmuf', title: string | null, introDescription: string | null, articleTitle: string | null, articleText: string | null, graduateInitiativesTitle: string | null, graduateInitiativesText: string | null, atGlanceTitle: string | null, inFocusHeadline: string | null, fellowStoriesMessage: string | null, fellowStoriesCtaLabel: string | null, contactTitle: string | null, contactMessage: string | null, contactEmail: string | null, heroImage: (
        { __typename: 'Asset' }
        & { ' $fragmentRefs'?: { 'Header_AssetFragmentFragment': Header_AssetFragmentFragment;'Opengraph_AssetFragmentFragment': Opengraph_AssetFragmentFragment } }
      ) | null, historyLink: (
        { __typename: 'ConnectWithLink' }
        & { ' $fragmentRefs'?: { 'QuickLink_ConnectWithLinkFragmentFragment': QuickLink_ConnectWithLinkFragmentFragment } }
      ) | null, quickLinks: (
        { __typename: 'ConnectWith' }
        & { ' $fragmentRefs'?: { 'QuickLinks_ConnectWithFragmentFragment': QuickLinks_ConnectWithFragmentFragment } }
      ) | null, spotlight: (
        { __typename: 'SpotlightSlideshow' }
        & { ' $fragmentRefs'?: { 'SpotlightSlideshow_SpotlightSlideshowFragmentFragment': SpotlightSlideshow_SpotlightSlideshowFragmentFragment } }
      ) | (
        { __typename: 'SpotlightVideo' }
        & { ' $fragmentRefs'?: { 'SpotlightVideo_SpotlightVideoFragmentFragment': SpotlightVideo_SpotlightVideoFragmentFragment } }
      ) | null, graduateInitiativesLink: (
        { __typename: 'ConnectWithLink' }
        & { ' $fragmentRefs'?: { 'QuickLink_ConnectWithLinkFragmentFragment': QuickLink_ConnectWithLinkFragmentFragment } }
      ) | null, pullQuote: (
        { __typename: 'Quote' }
        & { ' $fragmentRefs'?: { 'QuoteModule_QuoteFragmentFragment': QuoteModule_QuoteFragmentFragment } }
      ) | null, newsletter: (
        { __typename: 'NewsletterCard' }
        & { ' $fragmentRefs'?: { 'Newsletter_NewsletterFragmentFragment': Newsletter_NewsletterFragmentFragment } }
      ) | null, faqs: (
        { __typename: 'FaqsModule' }
        & { ' $fragmentRefs'?: { 'Faqs_FaqsModuleFragmentFragment': Faqs_FaqsModuleFragmentFragment } }
      ) | null }
      & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Mmuf_Fragment': InternalLink_EntryFragment_Mmuf_Fragment;'Cache_EntryFragment_Mmuf_Fragment': Cache_EntryFragment_Mmuf_Fragment } }
    ) | null> } | null };

export type MmufPageReferences_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type MmufPageReferences_QueryQuery = { __typename: 'Query', mmufCollection: { __typename: 'MmufCollection', items: Array<{ __typename: 'Mmuf', atGlanceCardsCollection: { __typename: 'MmufAtGlanceCardsCollection', items: Array<(
          { __typename: 'AtGlanceCard' }
          & { ' $fragmentRefs'?: { 'HighlightCard_AtGlanceCardFragmentFragment': HighlightCard_AtGlanceCardFragmentFragment } }
        ) | null> } | null, inFocusContentCollection: { __typename: 'MmufInFocusContentCollection', items: Array<(
          { __typename: 'Article' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Article_Fragment': ContentGrid_EntryFragment_Article_Fragment } }
        ) | (
          { __typename: 'ExternalEvent' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_ExternalEvent_Fragment': ContentGrid_EntryFragment_ExternalEvent_Fragment } }
        ) | null> } | null, inTheNewsCollection: { __typename: 'MmufInTheNewsCollection', items: Array<(
          { __typename: 'AnnualReport' }
          & { ' $fragmentRefs'?: { 'AnnualReportCard_AnnualReportFragmentFragment': AnnualReportCard_AnnualReportFragmentFragment } }
        ) | (
          { __typename: 'Article' }
          & { ' $fragmentRefs'?: { 'ArticleCard_ArticleFragmentFragment': ArticleCard_ArticleFragmentFragment } }
        ) | null> } | null } | null> } | null };

export type NewsPage_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type NewsPage_QueryQuery = { __typename: 'Query', newsPageCollection: { __typename: 'NewsPageCollection', items: Array<(
      { __typename: 'NewsPage', title: string | null, description: string | null, pressRoomCopy: string | null, featuredNews: (
        { __typename: 'AnnualReport' }
        & { ' $fragmentRefs'?: { 'AnnualReportCard_AnnualReportFragmentFragment': AnnualReportCard_AnnualReportFragmentFragment } }
      ) | (
        { __typename: 'Article' }
        & { ' $fragmentRefs'?: { 'ArticleCard_ArticleFragmentFragment': ArticleCard_ArticleFragmentFragment } }
      ) | null }
      & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_NewsPage_Fragment': InternalLink_EntryFragment_NewsPage_Fragment;'Cache_EntryFragment_NewsPage_Fragment': Cache_EntryFragment_NewsPage_Fragment } }
    ) | null> } | null };

export type NewsPageNews_QueryQueryVariables = Exact<{
  skip: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  sort: ArticleOrder;
  type: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type NewsPageNews_QueryQuery = { __typename: 'Query', articleCollection: { __typename: 'ArticleCollection', total: number, items: Array<(
      { __typename: 'Article', title: string | null, externalNewsUrl: string | null, date: any | null, hideDate: boolean | null, author: string | null, description: string | null, hero: (
        { __typename: 'HeroAsset' }
        & { ' $fragmentRefs'?: { 'Header_HeroAssetFragmentFragment': Header_HeroAssetFragmentFragment } }
      ) | null, heroImage: (
        { __typename: 'Asset' }
        & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
      ) | null, publisherLogo: (
        { __typename: 'Asset' }
        & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
      ) | null }
      & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Article_Fragment': InternalLink_EntryFragment_Article_Fragment } }
    ) | null> } | null };

export type NewsletterPages_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type NewsletterPages_QueryQuery = { __typename: 'Query', newsletterPageCollection: { __typename: 'NewsletterPageCollection', items: Array<(
      { __typename: 'NewsletterPage', slug: string | null, sys: { __typename: 'Sys', publishedAt: any | null } }
      & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_NewsletterPage_Fragment': InternalLink_EntryFragment_NewsletterPage_Fragment } }
    ) | null> } | null };

export type NewsletterPage_QueryQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type NewsletterPage_QueryQuery = { __typename: 'Query', newsletterPageCollection: { __typename: 'NewsletterPageCollection', items: Array<(
      { __typename: 'NewsletterPage', slug: string | null, title: string | null, description: string | null, signupDescription: string | null, quickLinks: (
        { __typename: 'ConnectWith' }
        & { ' $fragmentRefs'?: { 'QuickLinks_ConnectWithFragmentFragment': QuickLinks_ConnectWithFragmentFragment } }
      ) | null, signupImage: (
        { __typename: 'Asset' }
        & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
      ) | null }
      & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_NewsletterPage_Fragment': InternalLink_EntryFragment_NewsletterPage_Fragment;'Cache_EntryFragment_NewsletterPage_Fragment': Cache_EntryFragment_NewsletterPage_Fragment } }
    ) | null> } | null };

export type NewsletterConfirmPage_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type NewsletterConfirmPage_QueryQuery = { __typename: 'Query', newsletterConfirmPageCollection: { __typename: 'NewsletterConfirmPageCollection', items: Array<{ __typename: 'NewsletterConfirmPage', title: string | null, description: string | null, body: (
        { __typename: 'NewsletterConfirmPageBody' }
        & { ' $fragmentRefs'?: { 'NewsletterConfirmBodyRichText_NewsletterConfirmPageBodyFragmentFragment': NewsletterConfirmBodyRichText_NewsletterConfirmPageBodyFragmentFragment } }
      ) | null } | null> } | null };

export type PeopleQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type PeopleQueryQuery = { __typename: 'Query', peoplePageCollection: { __typename: 'PeoplePageCollection', items: Array<(
      { __typename: 'PeoplePage', title: string | null, description: string | null, trusteesCtaLabel: string | null, trusteesCtaText: string | null, image: (
        { __typename: 'Asset' }
        & { ' $fragmentRefs'?: { 'Header_AssetFragmentFragment': Header_AssetFragmentFragment;'Opengraph_AssetFragmentFragment': Opengraph_AssetFragmentFragment } }
      ) | null, president: (
        { __typename: 'Person', slug: string | null }
        & { ' $fragmentRefs'?: { 'LeadershipCard_PersonFragmentFragment': LeadershipCard_PersonFragmentFragment } }
      ) | null, leadershipCollection: { __typename: 'PeoplePageLeadershipCollection', items: Array<(
          { __typename: 'Person' }
          & { ' $fragmentRefs'?: { 'PersonCard_PersonFragmentFragment': PersonCard_PersonFragmentFragment } }
        ) | null> } | null }
      & { ' $fragmentRefs'?: { 'Cache_EntryFragment_PeoplePage_Fragment': Cache_EntryFragment_PeoplePage_Fragment;'InternalLink_EntryFragment_PeoplePage_Fragment': InternalLink_EntryFragment_PeoplePage_Fragment } }
    ) | null> } | null };

export type TrusteesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type TrusteesQueryQuery = { __typename: 'Query', trusteesPageCollection: { __typename: 'TrusteesPageCollection', items: Array<(
      { __typename: 'TrusteesPage', title: string | null, trusteesCollection: { __typename: 'TrusteesPageTrusteesCollection', items: Array<(
          { __typename: 'Trustee' }
          & { ' $fragmentRefs'?: { 'PersonCard_TrusteeFragmentFragment': PersonCard_TrusteeFragmentFragment } }
        ) | null> } | null }
      & { ' $fragmentRefs'?: { 'Cache_EntryFragment_TrusteesPage_Fragment': Cache_EntryFragment_TrusteesPage_Fragment;'InternalLink_EntryFragment_TrusteesPage_Fragment': InternalLink_EntryFragment_TrusteesPage_Fragment } }
    ) | null> } | null };

export type PressRoomPage_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type PressRoomPage_QueryQuery = { __typename: 'Query', pressRoomCollection: { __typename: 'PressRoomCollection', items: Array<(
      { __typename: 'PressRoom', title: string | null, description: string | null, contactsTitle: string | null, email: string | null, emailLabel: string | null, guidelinesAndMediasHeading: string | null, guidelinesAndMediasDescription: string | null, contactPersonsCollection: { __typename: 'PressRoomContactPersonsCollection', items: Array<{ __typename: 'ContactPerson', name: string | null, role: string | null, email: string | null, phone: string | null } | null> } | null, quickLinks: (
        { __typename: 'ConnectWith' }
        & { ' $fragmentRefs'?: { 'QuickLinks_ConnectWithFragmentFragment': QuickLinks_ConnectWithFragmentFragment } }
      ) | null, atGlanceCardsCollection: { __typename: 'PressRoomAtGlanceCardsCollection', items: Array<(
          { __typename: 'AtGlanceCard' }
          & { ' $fragmentRefs'?: { 'HighlightCard_AtGlanceCardFragmentFragment': HighlightCard_AtGlanceCardFragmentFragment } }
        ) | null> } | null, factSheetLink: { __typename: 'Asset', url: string | null } | null, spotlight: (
        { __typename: 'SpotlightSlideshow' }
        & { ' $fragmentRefs'?: { 'SpotlightSlideshow_SpotlightSlideshowFragmentFragment': SpotlightSlideshow_SpotlightSlideshowFragmentFragment } }
      ) | (
        { __typename: 'SpotlightVideo' }
        & { ' $fragmentRefs'?: { 'SpotlightVideo_SpotlightVideoFragmentFragment': SpotlightVideo_SpotlightVideoFragmentFragment } }
      ) | null, brandGuidelinesAndMediaAssetsLinksCollection: { __typename: 'PressRoomBrandGuidelinesAndMediaAssetsLinksCollection', items: Array<(
          { __typename: 'ConnectWithLink' }
          & { ' $fragmentRefs'?: { 'QuickLink_ConnectWithLinkFragmentFragment': QuickLink_ConnectWithLinkFragmentFragment } }
        ) | null> } | null, newsContentCollection: { __typename: 'PressRoomNewsContentCollection', items: Array<(
          { __typename: 'AnnualReport' }
          & { ' $fragmentRefs'?: { 'AnnualReportCard_AnnualReportFragmentFragment': AnnualReportCard_AnnualReportFragmentFragment } }
        ) | (
          { __typename: 'Article' }
          & { ' $fragmentRefs'?: { 'ArticleCard_ArticleFragmentFragment': ArticleCard_ArticleFragmentFragment } }
        ) | null> } | null }
      & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_PressRoom_Fragment': InternalLink_EntryFragment_PressRoom_Fragment;'Cache_EntryFragment_PressRoom_Fragment': Cache_EntryFragment_PressRoom_Fragment } }
    ) | null> } | null };

export type Layout_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type Layout_QueryQuery = (
  { __typename: 'Query' }
  & { ' $fragmentRefs'?: { 'Navigation_QueryFragmentFragment': Navigation_QueryFragmentFragment;'Footer_QueryFragmentFragment': Footer_QueryFragmentFragment } }
);

export type Home_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type Home_QueryQuery = { __typename: 'Query', homePageCollection: { __typename: 'HomePageCollection', items: Array<(
      { __typename: 'HomePage', spotlightFeature: Array<string | null> | null, ctaText: string | null, storiesCta: string | null, inFocusHeadline: string | null, layout: string | null, missionText: string | null, spotlightImage: (
        { __typename: 'Asset' }
        & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
      ) | null, spotlightVideo: { __typename: 'VideoNative', video: { __typename: 'Asset', url: string | null } | null } | null, spotlightCtaLink: (
        { __typename: 'Article', title: string | null, eyebrow: string | null }
        & { ' $fragmentRefs'?: { 'ArticleCta_ArticleFragmentFragment': ArticleCta_ArticleFragmentFragment;'InternalLink_EntryFragment_Article_Fragment': InternalLink_EntryFragment_Article_Fragment } }
      ) | (
        { __typename: 'ExternalEvent', name: string | null, eventType: string | null }
        & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_ExternalEvent_Fragment': InternalLink_EntryFragment_ExternalEvent_Fragment } }
      ) | (
        { __typename: 'Feature', tagline: string | null, name: string | null }
        & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Feature_Fragment': InternalLink_EntryFragment_Feature_Fragment } }
      ) | (
        { __typename: 'GrantActivityArticle', title: string | null, granteeNameOverride: string | null, grant: { __typename: 'Grant', organization: { __typename: 'Organisation', name: string | null } | null } | null }
        & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_GrantActivityArticle_Fragment': InternalLink_EntryFragment_GrantActivityArticle_Fragment } }
      ) | (
        { __typename: 'Idea', question: string | null, name: string | null }
        & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Idea_Fragment': InternalLink_EntryFragment_Idea_Fragment } }
      ) | null, inFocusContentCollection: { __typename: 'HomePageInFocusContentCollection', items: Array<(
          { __typename: 'AnnualReport' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_AnnualReport_Fragment': ContentGrid_EntryFragment_AnnualReport_Fragment } }
        ) | (
          { __typename: 'Article' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Article_Fragment': ContentGrid_EntryFragment_Article_Fragment } }
        ) | (
          { __typename: 'EmphasizedArticle' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_EmphasizedArticle_Fragment': ContentGrid_EntryFragment_EmphasizedArticle_Fragment;'EmphasizedCard_EmphasizedArticleQueryFragment': EmphasizedCard_EmphasizedArticleQueryFragment } }
        ) | (
          { __typename: 'ExternalEvent' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_ExternalEvent_Fragment': ContentGrid_EntryFragment_ExternalEvent_Fragment } }
        ) | (
          { __typename: 'Feature' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Feature_Fragment': ContentGrid_EntryFragment_Feature_Fragment } }
        ) | (
          { __typename: 'GrantActivityArticle' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_GrantActivityArticle_Fragment': ContentGrid_EntryFragment_GrantActivityArticle_Fragment } }
        ) | (
          { __typename: 'Idea' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Idea_Fragment': ContentGrid_EntryFragment_Idea_Fragment } }
        ) | (
          { __typename: 'Quote' }
          & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Quote_Fragment': ContentGrid_EntryFragment_Quote_Fragment;'QuoteModule_QuoteFragmentFragment': QuoteModule_QuoteFragmentFragment } }
        ) | null> } | null, grantActivityArticlesCollection: { __typename: 'HomePageGrantActivityArticlesCollection', items: Array<(
          { __typename: 'GrantActivityArticle' }
          & { ' $fragmentRefs'?: { 'GrantStoryAccordionCard_GrantActivityArticleFragmentFragment': GrantStoryAccordionCard_GrantActivityArticleFragmentFragment } }
        ) | null> } | null, newsletter: (
        { __typename: 'NewsletterCard' }
        & { ' $fragmentRefs'?: { 'Newsletter_NewsletterFragmentFragment': Newsletter_NewsletterFragmentFragment } }
      ) | null, inTheNewsCollection: { __typename: 'HomePageInTheNewsCollection', items: Array<(
          { __typename: 'AnnualReport' }
          & { ' $fragmentRefs'?: { 'AnnualReportCard_AnnualReportFragmentFragment': AnnualReportCard_AnnualReportFragmentFragment } }
        ) | (
          { __typename: 'Article' }
          & { ' $fragmentRefs'?: { 'ArticleCard_ArticleFragmentFragment': ArticleCard_ArticleFragmentFragment } }
        ) | null> } | null, thematicSpotlight: (
        { __typename: 'SpotlightSlideshow' }
        & { ' $fragmentRefs'?: { 'SpotlightSlideshow_SpotlightSlideshowFragmentFragment': SpotlightSlideshow_SpotlightSlideshowFragmentFragment } }
      ) | (
        { __typename: 'SpotlightVideo' }
        & { ' $fragmentRefs'?: { 'SpotlightVideo_SpotlightVideoFragmentFragment': SpotlightVideo_SpotlightVideoFragmentFragment } }
      ) | null }
      & { ' $fragmentRefs'?: { 'Cache_EntryFragment_HomePage_Fragment': Cache_EntryFragment_HomePage_Fragment } }
    ) | null> } | null };

export type ForGrantSeekers_PageQueryVariables = Exact<{ [key: string]: never; }>;


export type ForGrantSeekers_PageQuery = { __typename: 'Query', resourcesProspectiveGranteesCollection: { __typename: 'ResourcesProspectiveGranteesCollection', items: Array<(
      { __typename: 'ResourcesProspectiveGrantees', title: string | null, description: string | null, callsForConceptsTitle: string | null, newsletterCtaText: string | null, grantmakingAtGlanceTitle: string | null, grantDatabaseCtaText: string | null, quickLinks: (
        { __typename: 'ConnectWith' }
        & { ' $fragmentRefs'?: { 'QuickLinks_ConnectWithFragmentFragment': QuickLinks_ConnectWithFragmentFragment } }
      ) | null, hero: (
        { __typename: 'HeroAsset' }
        & { ' $fragmentRefs'?: { 'Header_HeroAssetFragmentFragment': Header_HeroAssetFragmentFragment } }
      ) | null, callsForConceptsCollection: { __typename: 'ResourcesProspectiveGranteesCallsForConceptsCollection', items: Array<(
          { __typename: 'CallForConcept' }
          & { ' $fragmentRefs'?: { 'CallForConcepts_CallForConceptFragmentFragment': CallForConcepts_CallForConceptFragmentFragment } }
        ) | null> } | null, grantmakingAreasCollection: { __typename: 'ResourcesProspectiveGranteesGrantmakingAreasCollection', items: Array<(
          { __typename: 'GrantmakingAreaDetailsPage' }
          & { ' $fragmentRefs'?: { 'GrantmakingAreaCard_GrantmakingAreaDetailsPageFragmentFragment': GrantmakingAreaCard_GrantmakingAreaDetailsPageFragmentFragment } }
        ) | null> } | null, explanatoryParagraph: (
        { __typename: 'ResourcesProspectiveGranteesExplanatoryParagraph' }
        & { ' $fragmentRefs'?: { 'ResourcesExplanatoryParagraphRichText_ResourcesExplanatoryParagraphFragmentFragment': ResourcesExplanatoryParagraphRichText_ResourcesExplanatoryParagraphFragmentFragment } }
      ) | null, grantmakingAtGlanceCardsCollection: { __typename: 'ResourcesProspectiveGranteesGrantmakingAtGlanceCardsCollection', items: Array<(
          { __typename: 'AtGlanceCard' }
          & { ' $fragmentRefs'?: { 'HighlightCard_AtGlanceCardFragmentFragment': HighlightCard_AtGlanceCardFragmentFragment } }
        ) | null> } | null, faqs: (
        { __typename: 'FaqsModule' }
        & { ' $fragmentRefs'?: { 'Faqs_FaqsModuleFragmentFragment': Faqs_FaqsModuleFragmentFragment } }
      ) | null }
      & { ' $fragmentRefs'?: { 'Cache_EntryFragment_ResourcesProspectiveGrantees_Fragment': Cache_EntryFragment_ResourcesProspectiveGrantees_Fragment } }
    ) | null> } | null };

export type ForGrantPartners_PageQueryVariables = Exact<{ [key: string]: never; }>;


export type ForGrantPartners_PageQuery = { __typename: 'Query', resourcesCurrentGranteesCollection: { __typename: 'ResourcesCurrentGranteesCollection', items: Array<(
      { __typename: 'ResourcesCurrentGrantees', title: string | null, description: string | null, resourcesTitle: string | null, similarGranteesTitle: string | null, grantDatabaseCtaText: string | null, quickLinks: (
        { __typename: 'ConnectWith' }
        & { ' $fragmentRefs'?: { 'QuickLinks_ConnectWithFragmentFragment': QuickLinks_ConnectWithFragmentFragment } }
      ) | null, hero: (
        { __typename: 'HeroAsset' }
        & { ' $fragmentRefs'?: { 'Header_HeroAssetFragmentFragment': Header_HeroAssetFragmentFragment } }
      ) | null, resourcesCollection: { __typename: 'ResourcesCurrentGranteesResourcesCollection', items: Array<(
          { __typename: 'AnnualReport' }
          & { ' $fragmentRefs'?: { 'AnnualReportCard_AnnualReportFragmentFragment': AnnualReportCard_AnnualReportFragmentFragment } }
        ) | (
          { __typename: 'Article' }
          & { ' $fragmentRefs'?: { 'ArticleCard_ArticleFragmentFragment': ArticleCard_ArticleFragmentFragment } }
        ) | { __typename: 'StoriesPage' } | null> } | null, similarGranteesGrantmakingAreasCollection: { __typename: 'ResourcesCurrentGranteesSimilarGranteesGrantmakingAreasCollection', items: Array<{ __typename: 'GrantmakingArea', name: string | null, tagline: string | null } | null> } | null, faqs: (
        { __typename: 'FaqsModule' }
        & { ' $fragmentRefs'?: { 'Faqs_FaqsModuleFragmentFragment': Faqs_FaqsModuleFragmentFragment } }
      ) | null }
      & { ' $fragmentRefs'?: { 'Cache_EntryFragment_ResourcesCurrentGrantees_Fragment': Cache_EntryFragment_ResourcesCurrentGrantees_Fragment } }
    ) | null> } | null };

export type Resources_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type Resources_QueryQuery = { __typename: 'Query', grantResourcesCollection: { __typename: 'GrantResourcesCollection', items: Array<(
      { __typename: 'GrantResources', title: string | null, introDescription: string | null, grantMakingAreasTitle: string | null, explanatoryTitle: string | null, explanatoryParagraph: string | null, searchContextualMessage: string | null, quickLinks: (
        { __typename: 'ConnectWith' }
        & { ' $fragmentRefs'?: { 'QuickLinks_ConnectWithFragmentFragment': QuickLinks_ConnectWithFragmentFragment } }
      ) | null, callForConceptsCollection: { __typename: 'GrantResourcesCallForConceptsCollection', items: Array<(
          { __typename: 'CallForConcept' }
          & { ' $fragmentRefs'?: { 'CallForConcepts_CallForConceptFragmentFragment': CallForConcepts_CallForConceptFragmentFragment } }
        ) | null> } | null, grantMakingAreasCollection: { __typename: 'GrantResourcesGrantMakingAreasCollection', items: Array<(
          { __typename: 'GrantmakingAreaDetailsPage' }
          & { ' $fragmentRefs'?: { 'GrantmakingAreaCard_GrantmakingAreaDetailsPageFragmentFragment': GrantmakingAreaCard_GrantmakingAreaDetailsPageFragmentFragment } }
        ) | null> } | null, grantActivityArticlesCollection: { __typename: 'GrantResourcesGrantActivityArticlesCollection', items: Array<(
          { __typename: 'GrantActivityArticle' }
          & { ' $fragmentRefs'?: { 'GrantStoryAccordionCard_GrantActivityArticleFragmentFragment': GrantStoryAccordionCard_GrantActivityArticleFragmentFragment } }
        ) | null> } | null, spotlight: (
        { __typename: 'SpotlightSlideshow' }
        & { ' $fragmentRefs'?: { 'SpotlightSlideshow_SpotlightSlideshowFragmentFragment': SpotlightSlideshow_SpotlightSlideshowFragmentFragment } }
      ) | (
        { __typename: 'SpotlightVideo' }
        & { ' $fragmentRefs'?: { 'SpotlightVideo_SpotlightVideoFragmentFragment': SpotlightVideo_SpotlightVideoFragmentFragment } }
      ) | null, pullQuote: (
        { __typename: 'Quote' }
        & { ' $fragmentRefs'?: { 'QuoteModule_QuoteFragmentFragment': QuoteModule_QuoteFragmentFragment } }
      ) | null, grantsAtGlanceCollection: { __typename: 'GrantResourcesGrantsAtGlanceCollection', items: Array<(
          { __typename: 'AtGlanceCard' }
          & { ' $fragmentRefs'?: { 'HighlightCard_AtGlanceCardFragmentFragment': HighlightCard_AtGlanceCardFragmentFragment } }
        ) | null> } | null, newsletter: (
        { __typename: 'NewsletterCard' }
        & { ' $fragmentRefs'?: { 'Newsletter_NewsletterFragmentFragment': Newsletter_NewsletterFragmentFragment } }
      ) | null, faqs: (
        { __typename: 'FaqsModule' }
        & { ' $fragmentRefs'?: { 'Faqs_FaqsModuleFragmentFragment': Faqs_FaqsModuleFragmentFragment } }
      ) | null }
      & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_GrantResources_Fragment': InternalLink_EntryFragment_GrantResources_Fragment;'Cache_EntryFragment_GrantResources_Fragment': Cache_EntryFragment_GrantResources_Fragment } }
    ) | null> } | null };

export type StoriesPage_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type StoriesPage_QueryQuery = { __typename: 'Query', storiesPageCollection: { __typename: 'StoriesPageCollection', items: Array<(
      { __typename: 'StoriesPage', title: string | null, description: string | null, highlightedFeature: (
        { __typename: 'Feature' }
        & { ' $fragmentRefs'?: { 'FeatureCard_FeatureFragmentFragment': FeatureCard_FeatureFragmentFragment } }
      ) | null }
      & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_StoriesPage_Fragment': InternalLink_EntryFragment_StoriesPage_Fragment;'Cache_EntryFragment_StoriesPage_Fragment': Cache_EntryFragment_StoriesPage_Fragment } }
    ) | null> } | null };

export type StoriesPageGrantStories_QueryQueryVariables = Exact<{
  skip: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  grantStorySort: GrantActivityArticleOrder;
}>;


export type StoriesPageGrantStories_QueryQuery = { __typename: 'Query', grantActivityArticleCollection: { __typename: 'GrantActivityArticleCollection', total: number, items: Array<(
      { __typename: 'GrantActivityArticle', title: string | null, date: any | null, description: string | null, slug: string | null, leadImage: (
        { __typename: 'Asset' }
        & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
      ) | null }
      & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_GrantActivityArticle_Fragment': InternalLink_EntryFragment_GrantActivityArticle_Fragment } }
    ) | null> } | null };

export type StoriesPageFeatures_QueryQueryVariables = Exact<{
  skip: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  featureSort: FeatureOrder;
}>;


export type StoriesPageFeatures_QueryQuery = { __typename: 'Query', featureCollection: { __typename: 'FeatureCollection', total: number, items: Array<(
      { __typename: 'Feature', date: any | null, grantStoriesSetCollection: { __typename: 'FeatureGrantStoriesSetCollection', items: Array<(
          { __typename: 'GrantActivityArticle', title: string | null, slug: string | null, date: any | null }
          & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_GrantActivityArticle_Fragment': InternalLink_EntryFragment_GrantActivityArticle_Fragment } }
        ) | null> } | null }
      & { ' $fragmentRefs'?: { 'FeatureCard_FeatureFragmentFragment': FeatureCard_FeatureFragmentFragment } }
    ) | null> } | null };

export type StoriesPageArticles_QueryQueryVariables = Exact<{
  skip: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  articleSort: ArticleOrder;
  articleType: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type StoriesPageArticles_QueryQuery = { __typename: 'Query', articleCollection: { __typename: 'ArticleCollection', total: number, items: Array<(
      { __typename: 'Article', title: string | null, externalNewsUrl: string | null, date: any | null, hideDate: boolean | null, author: string | null, description: string | null, hero: (
        { __typename: 'HeroAsset' }
        & { ' $fragmentRefs'?: { 'Header_HeroAssetFragmentFragment': Header_HeroAssetFragmentFragment } }
      ) | null, heroImage: (
        { __typename: 'Asset' }
        & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
      ) | null, publisherLogo: (
        { __typename: 'Asset' }
        & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
      ) | null }
      & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Article_Fragment': InternalLink_EntryFragment_Article_Fragment } }
    ) | null> } | null };

export type Opengraph_AssetFragmentFragment = { __typename: 'Asset', url: string | null, width: number | null, height: number | null } & { ' $fragmentName'?: 'Opengraph_AssetFragmentFragment' };

export type Opengraph_HeroAssetFragmentFragment = { __typename: 'HeroAsset', image: (
    { __typename: 'Asset' }
    & { ' $fragmentRefs'?: { 'Opengraph_AssetFragmentFragment': Opengraph_AssetFragmentFragment } }
  ) | null } & { ' $fragmentName'?: 'Opengraph_HeroAssetFragmentFragment' };

export type AudioPlayer_AssetFragmentFragment = { __typename: 'Asset', url: string | null } & { ' $fragmentName'?: 'AudioPlayer_AssetFragmentFragment' };

export type CallForConcepts_CallForConceptFragmentFragment = { __typename: 'CallForConcept', type: string | null, title: string | null, ctaText: string | null, registrationDeadlineTitle: string | null, registrationDeadlineDate: any | null, article: (
    { __typename: 'Article' }
    & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Article_Fragment': InternalLink_EntryFragment_Article_Fragment } }
  ) | null, grantMakingArea: { __typename: 'GrantmakingArea', name: string | null, image: (
      { __typename: 'Asset' }
      & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
    ) | null } | null } & { ' $fragmentName'?: 'CallForConcepts_CallForConceptFragmentFragment' };

export type AnnualReportCard_AnnualReportFragmentFragment = (
  { __typename: 'AnnualReport', year: string | null, introImagesCollection: { __typename: 'AssetCollection', items: Array<(
      { __typename: 'Asset' }
      & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
    ) | null> } | null }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_AnnualReport_Fragment': InternalLink_EntryFragment_AnnualReport_Fragment } }
) & { ' $fragmentName'?: 'AnnualReportCard_AnnualReportFragmentFragment' };

export type AnnualReportCard_OldAnnualReportFragmentFragment = (
  { __typename: 'OldAnnualReport', year: string | null }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_OldAnnualReport_Fragment': InternalLink_EntryFragment_OldAnnualReport_Fragment } }
) & { ' $fragmentName'?: 'AnnualReportCard_OldAnnualReportFragmentFragment' };

export type ArticleCard_ArticleFragmentFragment = (
  { __typename: 'Article', type: string | null, title: string | null, eyebrow: string | null, externalNewsUrl: string | null, date: any | null, hero: (
    { __typename: 'HeroAsset' }
    & { ' $fragmentRefs'?: { 'Hero_HeroAssetFragmentFragment': Hero_HeroAssetFragmentFragment } }
  ) | null, heroImage: (
    { __typename: 'Asset' }
    & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
  ) | null, publisherLogo: (
    { __typename: 'Asset' }
    & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
  ) | null, person: { __typename: 'Person', name: string | null, jobTitle: string | null, departmentOrGrantMakingArea: { __typename: 'Department', name: string | null } | { __typename: 'GrantmakingArea', name: string | null } | null, image: (
      { __typename: 'Asset' }
      & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
    ) | null } | null, externalPerson: { __typename: 'ExternalPerson', name: string | null, organization: string | null, jobTitle: string | null, image: (
      { __typename: 'Asset' }
      & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
    ) | null } | null }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Article_Fragment': InternalLink_EntryFragment_Article_Fragment } }
) & { ' $fragmentName'?: 'ArticleCard_ArticleFragmentFragment' };

export type EmphasizedCard_EmphasizedArticleQueryFragment = { __typename: 'EmphasizedArticle', article: (
    { __typename: 'Article' }
    & { ' $fragmentRefs'?: { 'ArticleCard_ArticleFragmentFragment': ArticleCard_ArticleFragmentFragment } }
  ) | (
    { __typename: 'GrantActivityArticle' }
    & { ' $fragmentRefs'?: { 'GrantStoryCard_GrantActivityArticleFragmentFragment': GrantStoryCard_GrantActivityArticleFragmentFragment } }
  ) | null } & { ' $fragmentName'?: 'EmphasizedCard_EmphasizedArticleQueryFragment' };

export type FeatureCard_FeatureFragmentFragment = (
  { __typename: 'Feature', name: string | null, slug: string | null, dateString: string | null, heroImage: (
    { __typename: 'Asset' }
    & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
  ) | null, previewVideo: { __typename: 'Asset', url: string | null } | null, pinnedGrantStoriesCollection: { __typename: 'FeaturePinnedGrantStoriesCollection', items: Array<(
      { __typename: 'Article', title: string | null, slug: string | null, hero: { __typename: 'HeroAsset', image: (
          { __typename: 'Asset' }
          & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
        ) | null } | null, heroImage: (
        { __typename: 'Asset' }
        & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
      ) | null }
      & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Article_Fragment': InternalLink_EntryFragment_Article_Fragment } }
    ) | (
      { __typename: 'GrantActivityArticle', title: string | null, slug: string | null, leadImage: (
        { __typename: 'Asset' }
        & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
      ) | null }
      & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_GrantActivityArticle_Fragment': InternalLink_EntryFragment_GrantActivityArticle_Fragment } }
    ) | null> } | null }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Feature_Fragment': InternalLink_EntryFragment_Feature_Fragment } }
) & { ' $fragmentName'?: 'FeatureCard_FeatureFragmentFragment' };

export type FutureEventCard_ExternalEventFragmentFragment = { __typename: 'ExternalEvent', name: string | null, link: string | null, date: any | null, startTime: string | null, endTime: string | null, timeZone: string | null, eventType: string | null, logo: (
    { __typename: 'Asset' }
    & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
  ) | null } & { ' $fragmentName'?: 'FutureEventCard_ExternalEventFragmentFragment' };

export type GrantCard_GrantFragmentFragment = (
  { __typename: 'Grant', date: any | null, organization: { __typename: 'Organisation', name: string | null } | null }
  & { ' $fragmentRefs'?: { 'GrantTitle_GrantFragmentFragment': GrantTitle_GrantFragmentFragment;'InternalLink_EntryFragment_Grant_Fragment': InternalLink_EntryFragment_Grant_Fragment } }
) & { ' $fragmentName'?: 'GrantCard_GrantFragmentFragment' };

export type GrantStoryCard_GrantActivityArticleFragmentFragment = (
  { __typename: 'GrantActivityArticle', title: string | null, granteeNameOverride: string | null, hero: (
    { __typename: 'HeroAsset' }
    & { ' $fragmentRefs'?: { 'Hero_HeroAssetFragmentFragment': Hero_HeroAssetFragmentFragment } }
  ) | null, leadImage: (
    { __typename: 'Asset' }
    & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
  ) | null, grant: { __typename: 'Grant', organization: { __typename: 'Organisation', name: string | null } | null } | null }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_GrantActivityArticle_Fragment': InternalLink_EntryFragment_GrantActivityArticle_Fragment } }
) & { ' $fragmentName'?: 'GrantStoryCard_GrantActivityArticleFragmentFragment' };

export type GrantmakingAreaCard_GrantmakingAreaDetailsPageFragmentFragment = (
  { __typename: 'GrantmakingAreaDetailsPage', title: string | null, introDescription: string | null, slug: string | null, heroImage: (
    { __typename: 'Asset' }
    & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
  ) | null }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_GrantmakingAreaDetailsPage_Fragment': InternalLink_EntryFragment_GrantmakingAreaDetailsPage_Fragment } }
) & { ' $fragmentName'?: 'GrantmakingAreaCard_GrantmakingAreaDetailsPageFragmentFragment' };

export type HighlightCard_AtGlanceCardFragmentFragment = { __typename: 'AtGlanceCard', title: string | null, heading: string | null, bodyText: string | null, type: string | null, ctaText: string | null, typeReference: (
    { __typename: 'Article' }
    & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Article_Fragment': InternalLink_EntryFragment_Article_Fragment } }
  ) | null } & { ' $fragmentName'?: 'HighlightCard_AtGlanceCardFragmentFragment' };

export type IdeaCard_IdeaFragmentFragment = (
  { __typename: 'Idea', question: string | null, name: string | null, navigationImagePortrait: (
    { __typename: 'Asset' }
    & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
  ) | null }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Idea_Fragment': InternalLink_EntryFragment_Idea_Fragment } }
) & { ' $fragmentName'?: 'IdeaCard_IdeaFragmentFragment' };

export type LeadershipCard_PersonFragmentFragment = (
  { __typename: 'Person', name: string | null, jobTitle: string | null, image: (
    { __typename: 'Asset' }
    & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
  ) | null }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Person_Fragment': InternalLink_EntryFragment_Person_Fragment } }
) & { ' $fragmentName'?: 'LeadershipCard_PersonFragmentFragment' };

export type LeadershipCard_HistoryPersonFragmentFragment = (
  { __typename: 'HistoryPerson', name: string | null, title: string | null, image: (
    { __typename: 'Asset' }
    & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
  ) | null }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_HistoryPerson_Fragment': InternalLink_EntryFragment_HistoryPerson_Fragment } }
) & { ' $fragmentName'?: 'LeadershipCard_HistoryPersonFragmentFragment' };

export type MmufCard_MmufFragmentFragment = (
  { __typename: 'Mmuf', title: string | null, introDescription: string | null, heroImage: (
    { __typename: 'Asset' }
    & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
  ) | null }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Mmuf_Fragment': InternalLink_EntryFragment_Mmuf_Fragment } }
) & { ' $fragmentName'?: 'MmufCard_MmufFragmentFragment' };

export type PersonCard_PersonFragmentFragment = (
  { __typename: 'Person', name: string | null, jobTitle: string | null, image: (
    { __typename: 'Asset' }
    & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
  ) | null, departmentOrGrantMakingArea: { __typename: 'Department', name: string | null } | { __typename: 'GrantmakingArea', name: string | null } | null }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Person_Fragment': InternalLink_EntryFragment_Person_Fragment } }
) & { ' $fragmentName'?: 'PersonCard_PersonFragmentFragment' };

export type PersonCard_HistoryPersonFragmentFragment = (
  { __typename: 'HistoryPerson', name: string | null, startYear: string | null, endYear: string | null, image: (
    { __typename: 'Asset' }
    & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
  ) | null }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_HistoryPerson_Fragment': InternalLink_EntryFragment_HistoryPerson_Fragment } }
) & { ' $fragmentName'?: 'PersonCard_HistoryPersonFragmentFragment' };

export type PersonCard_TrusteeFragmentFragment = (
  { __typename: 'Trustee', name: string | null, jobTitle: string | null, company: string | null, image: (
    { __typename: 'Asset' }
    & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
  ) | null }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Trustee_Fragment': InternalLink_EntryFragment_Trustee_Fragment } }
) & { ' $fragmentName'?: 'PersonCard_TrusteeFragmentFragment' };

export type PersonCard_ExternalPersonFragmentFragment = (
  { __typename: 'ExternalPerson', name: string | null, jobTitle: string | null, organizationString: string | null, image: (
    { __typename: 'Asset' }
    & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
  ) | null }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_ExternalPerson_Fragment': InternalLink_EntryFragment_ExternalPerson_Fragment } }
) & { ' $fragmentName'?: 'PersonCard_ExternalPersonFragmentFragment' };

export type NewsCarousel_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type NewsCarousel_QueryQuery = { __typename: 'Query', articleCollection: { __typename: 'ArticleCollection', items: Array<(
      { __typename: 'Article' }
      & { ' $fragmentRefs'?: { 'ArticleCard_ArticleFragmentFragment': ArticleCard_ArticleFragmentFragment } }
    ) | null> } | null };

type ContentGrid_EntryFragment_AnnualReport_Fragment = (
  { __typename: 'AnnualReport' }
  & { ' $fragmentRefs'?: { 'AnnualReportCard_AnnualReportFragmentFragment': AnnualReportCard_AnnualReportFragmentFragment } }
) & { ' $fragmentName'?: 'ContentGrid_EntryFragment_AnnualReport_Fragment' };

type ContentGrid_EntryFragment_Article_Fragment = (
  { __typename: 'Article' }
  & { ' $fragmentRefs'?: { 'ArticleCard_ArticleFragmentFragment': ArticleCard_ArticleFragmentFragment } }
) & { ' $fragmentName'?: 'ContentGrid_EntryFragment_Article_Fragment' };

type ContentGrid_EntryFragment_AtGlanceCard_Fragment = { __typename: 'AtGlanceCard' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_AtGlanceCard_Fragment' };

type ContentGrid_EntryFragment_CallForConcept_Fragment = (
  { __typename: 'CallForConcept' }
  & { ' $fragmentRefs'?: { 'CallForConcepts_CallForConceptFragmentFragment': CallForConcepts_CallForConceptFragmentFragment } }
) & { ' $fragmentName'?: 'ContentGrid_EntryFragment_CallForConcept_Fragment' };

type ContentGrid_EntryFragment_ConnectWith_Fragment = { __typename: 'ConnectWith' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_ConnectWith_Fragment' };

type ContentGrid_EntryFragment_ConnectWithLink_Fragment = { __typename: 'ConnectWithLink' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_ConnectWithLink_Fragment' };

type ContentGrid_EntryFragment_Contact_Fragment = { __typename: 'Contact' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_Contact_Fragment' };

type ContentGrid_EntryFragment_ContactPerson_Fragment = { __typename: 'ContactPerson' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_ContactPerson_Fragment' };

type ContentGrid_EntryFragment_Department_Fragment = { __typename: 'Department' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_Department_Fragment' };

type ContentGrid_EntryFragment_DropCap_Fragment = { __typename: 'DropCap' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_DropCap_Fragment' };

type ContentGrid_EntryFragment_EmphasizedArticle_Fragment = { __typename: 'EmphasizedArticle' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_EmphasizedArticle_Fragment' };

type ContentGrid_EntryFragment_EventsPage_Fragment = { __typename: 'EventsPage' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_EventsPage_Fragment' };

type ContentGrid_EntryFragment_ExperienceBlock_Fragment = { __typename: 'ExperienceBlock' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_ExperienceBlock_Fragment' };

type ContentGrid_EntryFragment_ExplicitValueFilter_Fragment = { __typename: 'ExplicitValueFilter' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_ExplicitValueFilter_Fragment' };

type ContentGrid_EntryFragment_ExternalEvent_Fragment = (
  { __typename: 'ExternalEvent' }
  & { ' $fragmentRefs'?: { 'FutureEventCard_ExternalEventFragmentFragment': FutureEventCard_ExternalEventFragmentFragment } }
) & { ' $fragmentName'?: 'ContentGrid_EntryFragment_ExternalEvent_Fragment' };

type ContentGrid_EntryFragment_ExternalPerson_Fragment = { __typename: 'ExternalPerson' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_ExternalPerson_Fragment' };

type ContentGrid_EntryFragment_Faq_Fragment = { __typename: 'Faq' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_Faq_Fragment' };

type ContentGrid_EntryFragment_FaqsModule_Fragment = { __typename: 'FaqsModule' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_FaqsModule_Fragment' };

type ContentGrid_EntryFragment_Feature_Fragment = (
  { __typename: 'Feature' }
  & { ' $fragmentRefs'?: { 'FeatureCard_FeatureFragmentFragment': FeatureCard_FeatureFragmentFragment } }
) & { ' $fragmentName'?: 'ContentGrid_EntryFragment_Feature_Fragment' };

type ContentGrid_EntryFragment_FinancialsPage_Fragment = { __typename: 'FinancialsPage' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_FinancialsPage_Fragment' };

type ContentGrid_EntryFragment_Footer_Fragment = { __typename: 'Footer' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_Footer_Fragment' };

type ContentGrid_EntryFragment_Grant_Fragment = { __typename: 'Grant' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_Grant_Fragment' };

type ContentGrid_EntryFragment_GrantActivityArticle_Fragment = (
  { __typename: 'GrantActivityArticle' }
  & { ' $fragmentRefs'?: { 'GrantStoryCard_GrantActivityArticleFragmentFragment': GrantStoryCard_GrantActivityArticleFragmentFragment } }
) & { ' $fragmentName'?: 'ContentGrid_EntryFragment_GrantActivityArticle_Fragment' };

type ContentGrid_EntryFragment_GrantDetailsPage_Fragment = { __typename: 'GrantDetailsPage' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_GrantDetailsPage_Fragment' };

type ContentGrid_EntryFragment_GrantResources_Fragment = { __typename: 'GrantResources' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_GrantResources_Fragment' };

type ContentGrid_EntryFragment_GrantSearchFilters_Fragment = { __typename: 'GrantSearchFilters' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_GrantSearchFilters_Fragment' };

type ContentGrid_EntryFragment_GrantmakingArea_Fragment = { __typename: 'GrantmakingArea' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_GrantmakingArea_Fragment' };

type ContentGrid_EntryFragment_GrantmakingAreaDetailsPage_Fragment = { __typename: 'GrantmakingAreaDetailsPage' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_GrantmakingAreaDetailsPage_Fragment' };

type ContentGrid_EntryFragment_GrantmakingAreasPage_Fragment = { __typename: 'GrantmakingAreasPage' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_GrantmakingAreasPage_Fragment' };

type ContentGrid_EntryFragment_HeroAsset_Fragment = { __typename: 'HeroAsset' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_HeroAsset_Fragment' };

type ContentGrid_EntryFragment_HistoryPage_Fragment = { __typename: 'HistoryPage' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_HistoryPage_Fragment' };

type ContentGrid_EntryFragment_HistoryPerson_Fragment = { __typename: 'HistoryPerson' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_HistoryPerson_Fragment' };

type ContentGrid_EntryFragment_HomePage_Fragment = { __typename: 'HomePage' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_HomePage_Fragment' };

type ContentGrid_EntryFragment_Idea_Fragment = (
  { __typename: 'Idea' }
  & { ' $fragmentRefs'?: { 'IdeaCard_IdeaFragmentFragment': IdeaCard_IdeaFragmentFragment } }
) & { ' $fragmentName'?: 'ContentGrid_EntryFragment_Idea_Fragment' };

type ContentGrid_EntryFragment_InitiativeQuoteCallOut_Fragment = { __typename: 'InitiativeQuoteCallOut' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_InitiativeQuoteCallOut_Fragment' };

type ContentGrid_EntryFragment_InlineCards_Fragment = { __typename: 'InlineCards' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_InlineCards_Fragment' };

type ContentGrid_EntryFragment_InlineImages_Fragment = { __typename: 'InlineImages' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_InlineImages_Fragment' };

type ContentGrid_EntryFragment_MainNavigation_Fragment = { __typename: 'MainNavigation' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_MainNavigation_Fragment' };

type ContentGrid_EntryFragment_Metadata_Fragment = { __typename: 'Metadata' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_Metadata_Fragment' };

type ContentGrid_EntryFragment_MissionPage_Fragment = { __typename: 'MissionPage' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_MissionPage_Fragment' };

type ContentGrid_EntryFragment_Mmuf_Fragment = (
  { __typename: 'Mmuf' }
  & { ' $fragmentRefs'?: { 'MmufCard_MmufFragmentFragment': MmufCard_MmufFragmentFragment } }
) & { ' $fragmentName'?: 'ContentGrid_EntryFragment_Mmuf_Fragment' };

type ContentGrid_EntryFragment_NavigationItem_Fragment = { __typename: 'NavigationItem' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_NavigationItem_Fragment' };

type ContentGrid_EntryFragment_NewsPage_Fragment = { __typename: 'NewsPage' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_NewsPage_Fragment' };

type ContentGrid_EntryFragment_NewsletterCard_Fragment = { __typename: 'NewsletterCard' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_NewsletterCard_Fragment' };

type ContentGrid_EntryFragment_NewsletterConfirmPage_Fragment = { __typename: 'NewsletterConfirmPage' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_NewsletterConfirmPage_Fragment' };

type ContentGrid_EntryFragment_NewsletterPage_Fragment = { __typename: 'NewsletterPage' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_NewsletterPage_Fragment' };

type ContentGrid_EntryFragment_OldAnnualReport_Fragment = { __typename: 'OldAnnualReport' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_OldAnnualReport_Fragment' };

type ContentGrid_EntryFragment_Organisation_Fragment = { __typename: 'Organisation' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_Organisation_Fragment' };

type ContentGrid_EntryFragment_ParallaxImages_Fragment = { __typename: 'ParallaxImages' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_ParallaxImages_Fragment' };

type ContentGrid_EntryFragment_PasswordProtectedPage_Fragment = { __typename: 'PasswordProtectedPage' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_PasswordProtectedPage_Fragment' };

type ContentGrid_EntryFragment_PeoplePage_Fragment = { __typename: 'PeoplePage' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_PeoplePage_Fragment' };

type ContentGrid_EntryFragment_Person_Fragment = { __typename: 'Person' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_Person_Fragment' };

type ContentGrid_EntryFragment_PresidentialQuoteCallOut_Fragment = { __typename: 'PresidentialQuoteCallOut' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_PresidentialQuoteCallOut_Fragment' };

type ContentGrid_EntryFragment_PressRoom_Fragment = { __typename: 'PressRoom' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_PressRoom_Fragment' };

type ContentGrid_EntryFragment_PrivacyPolicy_Fragment = { __typename: 'PrivacyPolicy' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_PrivacyPolicy_Fragment' };

type ContentGrid_EntryFragment_QuickLink_Fragment = { __typename: 'QuickLink' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_QuickLink_Fragment' };

type ContentGrid_EntryFragment_Quote_Fragment = (
  { __typename: 'Quote' }
  & { ' $fragmentRefs'?: { 'QuoteModule_QuoteFragmentFragment': QuoteModule_QuoteFragmentFragment } }
) & { ' $fragmentName'?: 'ContentGrid_EntryFragment_Quote_Fragment' };

type ContentGrid_EntryFragment_RangeValueFilter_Fragment = { __typename: 'RangeValueFilter' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_RangeValueFilter_Fragment' };

type ContentGrid_EntryFragment_ResourcesCurrentGrantees_Fragment = { __typename: 'ResourcesCurrentGrantees' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_ResourcesCurrentGrantees_Fragment' };

type ContentGrid_EntryFragment_ResourcesProspectiveGrantees_Fragment = { __typename: 'ResourcesProspectiveGrantees' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_ResourcesProspectiveGrantees_Fragment' };

type ContentGrid_EntryFragment_RootPage_Fragment = { __typename: 'RootPage' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_RootPage_Fragment' };

type ContentGrid_EntryFragment_SearchPage_Fragment = { __typename: 'SearchPage' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_SearchPage_Fragment' };

type ContentGrid_EntryFragment_SpotlightSlideshow_Fragment = { __typename: 'SpotlightSlideshow' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_SpotlightSlideshow_Fragment' };

type ContentGrid_EntryFragment_SpotlightVideo_Fragment = { __typename: 'SpotlightVideo' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_SpotlightVideo_Fragment' };

type ContentGrid_EntryFragment_StoriesPage_Fragment = { __typename: 'StoriesPage' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_StoriesPage_Fragment' };

type ContentGrid_EntryFragment_Taxonomy_Fragment = { __typename: 'Taxonomy' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_Taxonomy_Fragment' };

type ContentGrid_EntryFragment_TermsOfUse_Fragment = { __typename: 'TermsOfUse' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_TermsOfUse_Fragment' };

type ContentGrid_EntryFragment_Theme_Fragment = { __typename: 'Theme' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_Theme_Fragment' };

type ContentGrid_EntryFragment_Trustee_Fragment = { __typename: 'Trustee' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_Trustee_Fragment' };

type ContentGrid_EntryFragment_TrusteesPage_Fragment = { __typename: 'TrusteesPage' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_TrusteesPage_Fragment' };

type ContentGrid_EntryFragment_VideoNative_Fragment = { __typename: 'VideoNative' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_VideoNative_Fragment' };

type ContentGrid_EntryFragment_VideoYoutube_Fragment = { __typename: 'VideoYoutube' } & { ' $fragmentName'?: 'ContentGrid_EntryFragment_VideoYoutube_Fragment' };

export type ContentGrid_EntryFragmentFragment = ContentGrid_EntryFragment_AnnualReport_Fragment | ContentGrid_EntryFragment_Article_Fragment | ContentGrid_EntryFragment_AtGlanceCard_Fragment | ContentGrid_EntryFragment_CallForConcept_Fragment | ContentGrid_EntryFragment_ConnectWith_Fragment | ContentGrid_EntryFragment_ConnectWithLink_Fragment | ContentGrid_EntryFragment_Contact_Fragment | ContentGrid_EntryFragment_ContactPerson_Fragment | ContentGrid_EntryFragment_Department_Fragment | ContentGrid_EntryFragment_DropCap_Fragment | ContentGrid_EntryFragment_EmphasizedArticle_Fragment | ContentGrid_EntryFragment_EventsPage_Fragment | ContentGrid_EntryFragment_ExperienceBlock_Fragment | ContentGrid_EntryFragment_ExplicitValueFilter_Fragment | ContentGrid_EntryFragment_ExternalEvent_Fragment | ContentGrid_EntryFragment_ExternalPerson_Fragment | ContentGrid_EntryFragment_Faq_Fragment | ContentGrid_EntryFragment_FaqsModule_Fragment | ContentGrid_EntryFragment_Feature_Fragment | ContentGrid_EntryFragment_FinancialsPage_Fragment | ContentGrid_EntryFragment_Footer_Fragment | ContentGrid_EntryFragment_Grant_Fragment | ContentGrid_EntryFragment_GrantActivityArticle_Fragment | ContentGrid_EntryFragment_GrantDetailsPage_Fragment | ContentGrid_EntryFragment_GrantResources_Fragment | ContentGrid_EntryFragment_GrantSearchFilters_Fragment | ContentGrid_EntryFragment_GrantmakingArea_Fragment | ContentGrid_EntryFragment_GrantmakingAreaDetailsPage_Fragment | ContentGrid_EntryFragment_GrantmakingAreasPage_Fragment | ContentGrid_EntryFragment_HeroAsset_Fragment | ContentGrid_EntryFragment_HistoryPage_Fragment | ContentGrid_EntryFragment_HistoryPerson_Fragment | ContentGrid_EntryFragment_HomePage_Fragment | ContentGrid_EntryFragment_Idea_Fragment | ContentGrid_EntryFragment_InitiativeQuoteCallOut_Fragment | ContentGrid_EntryFragment_InlineCards_Fragment | ContentGrid_EntryFragment_InlineImages_Fragment | ContentGrid_EntryFragment_MainNavigation_Fragment | ContentGrid_EntryFragment_Metadata_Fragment | ContentGrid_EntryFragment_MissionPage_Fragment | ContentGrid_EntryFragment_Mmuf_Fragment | ContentGrid_EntryFragment_NavigationItem_Fragment | ContentGrid_EntryFragment_NewsPage_Fragment | ContentGrid_EntryFragment_NewsletterCard_Fragment | ContentGrid_EntryFragment_NewsletterConfirmPage_Fragment | ContentGrid_EntryFragment_NewsletterPage_Fragment | ContentGrid_EntryFragment_OldAnnualReport_Fragment | ContentGrid_EntryFragment_Organisation_Fragment | ContentGrid_EntryFragment_ParallaxImages_Fragment | ContentGrid_EntryFragment_PasswordProtectedPage_Fragment | ContentGrid_EntryFragment_PeoplePage_Fragment | ContentGrid_EntryFragment_Person_Fragment | ContentGrid_EntryFragment_PresidentialQuoteCallOut_Fragment | ContentGrid_EntryFragment_PressRoom_Fragment | ContentGrid_EntryFragment_PrivacyPolicy_Fragment | ContentGrid_EntryFragment_QuickLink_Fragment | ContentGrid_EntryFragment_Quote_Fragment | ContentGrid_EntryFragment_RangeValueFilter_Fragment | ContentGrid_EntryFragment_ResourcesCurrentGrantees_Fragment | ContentGrid_EntryFragment_ResourcesProspectiveGrantees_Fragment | ContentGrid_EntryFragment_RootPage_Fragment | ContentGrid_EntryFragment_SearchPage_Fragment | ContentGrid_EntryFragment_SpotlightSlideshow_Fragment | ContentGrid_EntryFragment_SpotlightVideo_Fragment | ContentGrid_EntryFragment_StoriesPage_Fragment | ContentGrid_EntryFragment_Taxonomy_Fragment | ContentGrid_EntryFragment_TermsOfUse_Fragment | ContentGrid_EntryFragment_Theme_Fragment | ContentGrid_EntryFragment_Trustee_Fragment | ContentGrid_EntryFragment_TrusteesPage_Fragment | ContentGrid_EntryFragment_VideoNative_Fragment | ContentGrid_EntryFragment_VideoYoutube_Fragment;

export type ExperienceBlock_ExperienceBlockFragmentFragment = { __typename: 'ExperienceBlock', id: string | null, json: any | null, mediaCollection: { __typename: 'AssetCollection', items: Array<(
      { __typename: 'Asset' }
      & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
    ) | null> } | null, referencesCollection: { __typename: 'ExperienceBlockReferencesCollection', items: Array<(
      { __typename: 'Article' }
      & { ' $fragmentRefs'?: { 'ArticleCard_ArticleFragmentFragment': ArticleCard_ArticleFragmentFragment } }
    ) | (
      { __typename: 'VideoNative' }
      & { ' $fragmentRefs'?: { 'Video_VideoNativeFragmentFragment': Video_VideoNativeFragmentFragment } }
    ) | null> } | null } & { ' $fragmentName'?: 'ExperienceBlock_ExperienceBlockFragmentFragment' };

export type Faq_FaqFragmentFragment = { __typename: 'Faq', question: string | null, answer: string | null } & { ' $fragmentName'?: 'Faq_FaqFragmentFragment' };

export type Faqs_FaqsModuleFragmentFragment = { __typename: 'FaqsModule', title: string | null, faqsCollection: { __typename: 'FaqsModuleFaqsCollection', items: Array<(
      { __typename: 'Faq' }
      & { ' $fragmentRefs'?: { 'Faq_FaqFragmentFragment': Faq_FaqFragmentFragment } }
    ) | null> } | null } & { ' $fragmentName'?: 'Faqs_FaqsModuleFragmentFragment' };

export type GrantStoryAccordionCard_GrantActivityArticleFragmentFragment = (
  { __typename: 'GrantActivityArticle', title: string | null, hero: (
    { __typename: 'HeroAsset' }
    & { ' $fragmentRefs'?: { 'Hero_HeroAssetFragmentFragment': Hero_HeroAssetFragmentFragment } }
  ) | null, leadImage: (
    { __typename: 'Asset' }
    & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
  ) | null, grant: { __typename: 'Grant', organization: { __typename: 'Organisation', name: string | null } | null } | null }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_GrantActivityArticle_Fragment': InternalLink_EntryFragment_GrantActivityArticle_Fragment } }
) & { ' $fragmentName'?: 'GrantStoryAccordionCard_GrantActivityArticleFragmentFragment' };

export type Header_AssetFragmentFragment = (
  { __typename: 'Asset', description: string | null }
  & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
) & { ' $fragmentName'?: 'Header_AssetFragmentFragment' };

export type Header_HeroAssetFragmentFragment = { __typename: 'HeroAsset', videoHasAudio: boolean | null, image: (
    { __typename: 'Asset' }
    & { ' $fragmentRefs'?: { 'Header_AssetFragmentFragment': Header_AssetFragmentFragment } }
  ) | null, video: { __typename: 'Asset', url: string | null } | null } & { ' $fragmentName'?: 'Header_HeroAssetFragmentFragment' };

export type Hero_AssetFragmentFragment = (
  { __typename: 'Asset' }
  & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
) & { ' $fragmentName'?: 'Hero_AssetFragmentFragment' };

export type Hero_HeroAssetFragmentFragment = { __typename: 'HeroAsset', image: (
    { __typename: 'Asset' }
    & { ' $fragmentRefs'?: { 'Hero_AssetFragmentFragment': Hero_AssetFragmentFragment } }
  ) | null, video: { __typename: 'Asset', url: string | null } | null } & { ' $fragmentName'?: 'Hero_HeroAssetFragmentFragment' };

export type Image_AssetFragmentFragment = { __typename: 'Asset', title: string | null, width: number | null, height: number | null, src: string | null } & { ' $fragmentName'?: 'Image_AssetFragmentFragment' };

export type InitiativeQuote_InitiativeQuoteCallOutFragmentFragment = { __typename: 'InitiativeQuoteCallOut', initiativeHeading: string | null, initiativeTitle: string | null, initiativeText: string | null, initiativeCtaText: string | null, searchQuery: string | null, quote: (
    { __typename: 'Quote' }
    & { ' $fragmentRefs'?: { 'QuoteModule_QuoteFragmentFragment': QuoteModule_QuoteFragmentFragment } }
  ) | null } & { ' $fragmentName'?: 'InitiativeQuote_InitiativeQuoteCallOutFragmentFragment' };

export type InlineImages_InlineImagesFragmentFragment = { __typename: 'InlineImages', invert: boolean | null, imagesCollection: { __typename: 'AssetCollection', items: Array<(
      { __typename: 'Asset', description: string | null }
      & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
    ) | null> } | null } & { ' $fragmentName'?: 'InlineImages_InlineImagesFragmentFragment' };

export type Idea_IdeaFragmentFragment = (
  { __typename: 'Idea', name: string | null, slug: string | null, navigationImagePortrait: (
    { __typename: 'Asset' }
    & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
  ) | null }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Idea_Fragment': InternalLink_EntryFragment_Idea_Fragment } }
) & { ' $fragmentName'?: 'Idea_IdeaFragmentFragment' };

export type Ideas_QueryFragmentFragment = { __typename: 'Query', ideaCollection: { __typename: 'IdeaCollection', items: Array<(
      { __typename: 'Idea' }
      & { ' $fragmentRefs'?: { 'Idea_IdeaFragmentFragment': Idea_IdeaFragmentFragment } }
    ) | null> } | null } & { ' $fragmentName'?: 'Ideas_QueryFragmentFragment' };

export type Footer_QueryFragmentFragment = (
  { __typename: 'Query', footerCollection: { __typename: 'FooterCollection', items: Array<{ __typename: 'Footer', slug: string | null, title: string | null, footerLinksCollection: { __typename: 'FooterFooterLinksCollection', items: Array<(
          { __typename: 'ConnectWithLink' }
          & { ' $fragmentRefs'?: { 'QuickLink_ConnectWithLinkFragmentFragment': QuickLink_ConnectWithLinkFragmentFragment } }
        ) | null> } | null, newsletter: (
        { __typename: 'NewsletterCard' }
        & { ' $fragmentRefs'?: { 'Newsletter_NewsletterFragmentFragment': Newsletter_NewsletterFragmentFragment } }
      ) | null } | null> } | null, footerContactCollection: { __typename: 'ContactCollection', items: Array<(
      { __typename: 'Contact' }
      & { ' $fragmentRefs'?: { 'Socials_ContactFragmentFragment': Socials_ContactFragmentFragment } }
    ) | null> } | null }
  & { ' $fragmentRefs'?: { 'Ideas_QueryFragmentFragment': Ideas_QueryFragmentFragment } }
) & { ' $fragmentName'?: 'Footer_QueryFragmentFragment' };

export type Navigation_QueryFragmentFragment = (
  { __typename: 'Query' }
  & { ' $fragmentRefs'?: { 'SecondaryNavigation_QueryFragmentFragment': SecondaryNavigation_QueryFragmentFragment } }
) & { ' $fragmentName'?: 'Navigation_QueryFragmentFragment' };

export type SecondaryNavigationContent_QueryFragmentFragment = { __typename: 'Query', mainNavigationCollection: { __typename: 'MainNavigationCollection', items: Array<{ __typename: 'MainNavigation', babyMissionStatement: string | null, ideasCollection: { __typename: 'MainNavigationIdeasCollection', items: Array<(
          { __typename: 'Idea', name: string | null, navigationImagePortrait: (
            { __typename: 'Asset' }
            & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
          ) | null }
          & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Idea_Fragment': InternalLink_EntryFragment_Idea_Fragment } }
        ) | null> } | null, resourcesCollection: { __typename: 'MainNavigationResourcesCollection', items: Array<{ __typename: 'NavigationItem', label: string | null, image: (
            { __typename: 'Asset' }
            & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
          ) | null, reference: (
            { __typename: 'Article' }
            & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Article_Fragment': InternalLink_EntryFragment_Article_Fragment } }
          ) | (
            { __typename: 'GrantActivityArticle' }
            & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_GrantActivityArticle_Fragment': InternalLink_EntryFragment_GrantActivityArticle_Fragment } }
          ) | (
            { __typename: 'GrantDetailsPage' }
            & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_GrantDetailsPage_Fragment': InternalLink_EntryFragment_GrantDetailsPage_Fragment } }
          ) | (
            { __typename: 'GrantSearchFilters' }
            & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_GrantSearchFilters_Fragment': InternalLink_EntryFragment_GrantSearchFilters_Fragment } }
          ) | (
            { __typename: 'GrantmakingAreaDetailsPage' }
            & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_GrantmakingAreaDetailsPage_Fragment': InternalLink_EntryFragment_GrantmakingAreaDetailsPage_Fragment } }
          ) | (
            { __typename: 'GrantmakingAreasPage' }
            & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_GrantmakingAreasPage_Fragment': InternalLink_EntryFragment_GrantmakingAreasPage_Fragment } }
          ) | (
            { __typename: 'Idea' }
            & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Idea_Fragment': InternalLink_EntryFragment_Idea_Fragment } }
          ) | (
            { __typename: 'ResourcesCurrentGrantees' }
            & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_ResourcesCurrentGrantees_Fragment': InternalLink_EntryFragment_ResourcesCurrentGrantees_Fragment } }
          ) | (
            { __typename: 'ResourcesProspectiveGrantees' }
            & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_ResourcesProspectiveGrantees_Fragment': InternalLink_EntryFragment_ResourcesProspectiveGrantees_Fragment } }
          ) | (
            { __typename: 'StoriesPage' }
            & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_StoriesPage_Fragment': InternalLink_EntryFragment_StoriesPage_Fragment } }
          ) | null } | null> } | null, pagesCollection: { __typename: 'MainNavigationPagesCollection', items: Array<(
          { __typename: 'EventsPage', title: string | null, navigationImagePortrait: (
            { __typename: 'Asset' }
            & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
          ) | null }
          & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_EventsPage_Fragment': InternalLink_EntryFragment_EventsPage_Fragment } }
        ) | (
          { __typename: 'FinancialsPage', title: string | null, navigationImagePortrait: (
            { __typename: 'Asset' }
            & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
          ) | null }
          & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_FinancialsPage_Fragment': InternalLink_EntryFragment_FinancialsPage_Fragment } }
        ) | (
          { __typename: 'GrantmakingAreasPage', title: string | null, navigationImagePortrait: (
            { __typename: 'Asset' }
            & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
          ) | null }
          & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_GrantmakingAreasPage_Fragment': InternalLink_EntryFragment_GrantmakingAreasPage_Fragment } }
        ) | (
          { __typename: 'HistoryPage', title: string | null, navigationImagePortrait: (
            { __typename: 'Asset' }
            & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
          ) | null }
          & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_HistoryPage_Fragment': InternalLink_EntryFragment_HistoryPage_Fragment } }
        ) | (
          { __typename: 'MissionPage', title: string | null, navigationImagePortrait: (
            { __typename: 'Asset' }
            & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
          ) | null }
          & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_MissionPage_Fragment': InternalLink_EntryFragment_MissionPage_Fragment } }
        ) | (
          { __typename: 'NewsPage', title: string | null, navigationImagePortrait: (
            { __typename: 'Asset' }
            & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
          ) | null }
          & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_NewsPage_Fragment': InternalLink_EntryFragment_NewsPage_Fragment } }
        ) | (
          { __typename: 'PeoplePage', title: string | null, navigationImagePortrait: (
            { __typename: 'Asset' }
            & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
          ) | null }
          & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_PeoplePage_Fragment': InternalLink_EntryFragment_PeoplePage_Fragment } }
        ) | null> } | null } | null> } | null } & { ' $fragmentName'?: 'SecondaryNavigationContent_QueryFragmentFragment' };

export type SecondaryNavigation_QueryFragmentFragment = (
  { __typename: 'Query' }
  & { ' $fragmentRefs'?: { 'SecondaryNavigationContent_QueryFragmentFragment': SecondaryNavigationContent_QueryFragmentFragment;'SecondaryNavigationSearch_QueryFragmentFragment': SecondaryNavigationSearch_QueryFragmentFragment } }
) & { ' $fragmentName'?: 'SecondaryNavigation_QueryFragmentFragment' };

export type SecondaryNavigationSearch_QueryFragmentFragment = { __typename: 'Query', searchPageCollection: { __typename: 'SearchPageCollection', items: Array<(
      { __typename: 'SearchPage', featuredSearches: Array<string | null> | null }
      & { ' $fragmentRefs'?: { 'Cache_EntryFragment_SearchPage_Fragment': Cache_EntryFragment_SearchPage_Fragment } }
    ) | null> } | null } & { ' $fragmentName'?: 'SecondaryNavigationSearch_QueryFragmentFragment' };

export type Newsletter_NewsletterFragmentFragment = { __typename: 'NewsletterCard', description: string | null, disclaimer: string | null } & { ' $fragmentName'?: 'Newsletter_NewsletterFragmentFragment' };

export type ParallaxImages_ParallaxImagesQueryFragment = { __typename: 'ParallaxImages', body: string | null, imagesCollection: { __typename: 'AssetCollection', items: Array<(
      { __typename: 'Asset' }
      & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
    ) | null> } | null } & { ' $fragmentName'?: 'ParallaxImages_ParallaxImagesQueryFragment' };

export type QuickLink_ConnectWithLinkFragmentFragment = { __typename: 'ConnectWithLink', label: string | null, externalLink: string | null, internalLink: (
    { __typename: 'AnnualReport' }
    & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_AnnualReport_Fragment': InternalLink_EntryFragment_AnnualReport_Fragment } }
  ) | (
    { __typename: 'Article' }
    & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Article_Fragment': InternalLink_EntryFragment_Article_Fragment } }
  ) | (
    { __typename: 'Contact' }
    & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Contact_Fragment': InternalLink_EntryFragment_Contact_Fragment } }
  ) | (
    { __typename: 'Department' }
    & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Department_Fragment': InternalLink_EntryFragment_Department_Fragment } }
  ) | (
    { __typename: 'EventsPage' }
    & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_EventsPage_Fragment': InternalLink_EntryFragment_EventsPage_Fragment } }
  ) | (
    { __typename: 'Feature' }
    & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Feature_Fragment': InternalLink_EntryFragment_Feature_Fragment } }
  ) | (
    { __typename: 'FinancialsPage' }
    & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_FinancialsPage_Fragment': InternalLink_EntryFragment_FinancialsPage_Fragment } }
  ) | (
    { __typename: 'GrantActivityArticle' }
    & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_GrantActivityArticle_Fragment': InternalLink_EntryFragment_GrantActivityArticle_Fragment } }
  ) | (
    { __typename: 'GrantResources' }
    & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_GrantResources_Fragment': InternalLink_EntryFragment_GrantResources_Fragment } }
  ) | (
    { __typename: 'GrantSearchFilters' }
    & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_GrantSearchFilters_Fragment': InternalLink_EntryFragment_GrantSearchFilters_Fragment } }
  ) | (
    { __typename: 'GrantmakingArea' }
    & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_GrantmakingArea_Fragment': InternalLink_EntryFragment_GrantmakingArea_Fragment } }
  ) | (
    { __typename: 'GrantmakingAreaDetailsPage' }
    & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_GrantmakingAreaDetailsPage_Fragment': InternalLink_EntryFragment_GrantmakingAreaDetailsPage_Fragment } }
  ) | (
    { __typename: 'GrantmakingAreasPage' }
    & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_GrantmakingAreasPage_Fragment': InternalLink_EntryFragment_GrantmakingAreasPage_Fragment } }
  ) | (
    { __typename: 'HistoryPage' }
    & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_HistoryPage_Fragment': InternalLink_EntryFragment_HistoryPage_Fragment } }
  ) | (
    { __typename: 'Idea' }
    & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Idea_Fragment': InternalLink_EntryFragment_Idea_Fragment } }
  ) | (
    { __typename: 'MissionPage' }
    & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_MissionPage_Fragment': InternalLink_EntryFragment_MissionPage_Fragment } }
  ) | (
    { __typename: 'Mmuf' }
    & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Mmuf_Fragment': InternalLink_EntryFragment_Mmuf_Fragment } }
  ) | (
    { __typename: 'NewsPage' }
    & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_NewsPage_Fragment': InternalLink_EntryFragment_NewsPage_Fragment } }
  ) | (
    { __typename: 'PeoplePage' }
    & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_PeoplePage_Fragment': InternalLink_EntryFragment_PeoplePage_Fragment } }
  ) | (
    { __typename: 'Person' }
    & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Person_Fragment': InternalLink_EntryFragment_Person_Fragment } }
  ) | (
    { __typename: 'PressRoom' }
    & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_PressRoom_Fragment': InternalLink_EntryFragment_PressRoom_Fragment } }
  ) | (
    { __typename: 'PrivacyPolicy' }
    & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_PrivacyPolicy_Fragment': InternalLink_EntryFragment_PrivacyPolicy_Fragment } }
  ) | (
    { __typename: 'TermsOfUse' }
    & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_TermsOfUse_Fragment': InternalLink_EntryFragment_TermsOfUse_Fragment } }
  ) | null, asset: { __typename: 'Asset', src: string | null } | null } & { ' $fragmentName'?: 'QuickLink_ConnectWithLinkFragmentFragment' };

export type QuickLinks_ConnectWithFragmentFragment = { __typename: 'ConnectWith', eyebrow: string | null, heading: string | null, linksCollection: { __typename: 'ConnectWithLinksCollection', items: Array<(
      { __typename: 'ConnectWithLink' }
      & { ' $fragmentRefs'?: { 'QuickLink_ConnectWithLinkFragmentFragment': QuickLink_ConnectWithLinkFragmentFragment } }
    ) | null> } | null } & { ' $fragmentName'?: 'QuickLinks_ConnectWithFragmentFragment' };

export type QuoteModule_QuoteFragmentFragment = { __typename: 'Quote', quoteText: string | null, link: string | null, linkText: string | null, attribution: string | null, twitterUsername: string | null, isTwitterImage: boolean | null, quoteImage: (
    { __typename: 'Asset' }
    & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
  ) | null, quoteAudio: { __typename: 'Asset', src: string | null } | null } & { ' $fragmentName'?: 'QuoteModule_QuoteFragmentFragment' };

export type ResourcesExplanatoryParagraphRichText_ResourcesExplanatoryParagraphFragmentFragment = { __typename: 'ResourcesProspectiveGranteesExplanatoryParagraph', json: any, links: { __typename: 'ResourcesProspectiveGranteesExplanatoryParagraphLinks', assets: { __typename: 'ResourcesProspectiveGranteesExplanatoryParagraphAssets', block: Array<(
        { __typename: 'Asset' }
        & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
      ) | null> }, entries: { __typename: 'ResourcesProspectiveGranteesExplanatoryParagraphEntries', block: Array<{ __typename: 'AnnualReport', sys: { __typename: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename: 'Sys', id: string } } | { __typename: 'AtGlanceCard', sys: { __typename: 'Sys', id: string } } | { __typename: 'CallForConcept', sys: { __typename: 'Sys', id: string } } | { __typename: 'ConnectWith', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'ConnectWithLink', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'QuickLink_ConnectWithLinkFragmentFragment': QuickLink_ConnectWithLinkFragmentFragment } }
      ) | { __typename: 'Contact', sys: { __typename: 'Sys', id: string } } | { __typename: 'ContactPerson', sys: { __typename: 'Sys', id: string } } | { __typename: 'Department', sys: { __typename: 'Sys', id: string } } | { __typename: 'DropCap', sys: { __typename: 'Sys', id: string } } | { __typename: 'EmphasizedArticle', sys: { __typename: 'Sys', id: string } } | { __typename: 'EventsPage', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'ExperienceBlock', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'ExperienceBlock_ExperienceBlockFragmentFragment': ExperienceBlock_ExperienceBlockFragmentFragment } }
      ) | { __typename: 'ExplicitValueFilter', sys: { __typename: 'Sys', id: string } } | { __typename: 'ExternalEvent', sys: { __typename: 'Sys', id: string } } | { __typename: 'ExternalPerson', sys: { __typename: 'Sys', id: string } } | { __typename: 'Faq', sys: { __typename: 'Sys', id: string } } | { __typename: 'FaqsModule', sys: { __typename: 'Sys', id: string } } | { __typename: 'Feature', sys: { __typename: 'Sys', id: string } } | { __typename: 'FinancialsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename: 'Sys', id: string } } | { __typename: 'Grant', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantActivityArticle', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantDetailsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantResources', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantSearchFilters', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantmakingArea', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantmakingAreaDetailsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantmakingAreasPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'HeroAsset', sys: { __typename: 'Sys', id: string } } | { __typename: 'HistoryPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'HistoryPerson', sys: { __typename: 'Sys', id: string } } | { __typename: 'HomePage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Idea', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'InitiativeQuoteCallOut', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'InitiativeQuote_InitiativeQuoteCallOutFragmentFragment': InitiativeQuote_InitiativeQuoteCallOutFragmentFragment } }
      ) | { __typename: 'InlineCards', cardsCollection: { __typename: 'InlineCardsCardsCollection', items: Array<(
            { __typename: 'Article' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Article_Fragment': ContentGrid_EntryFragment_Article_Fragment } }
          ) | (
            { __typename: 'EmphasizedArticle' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_EmphasizedArticle_Fragment': ContentGrid_EntryFragment_EmphasizedArticle_Fragment } }
          ) | (
            { __typename: 'ExternalEvent' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_ExternalEvent_Fragment': ContentGrid_EntryFragment_ExternalEvent_Fragment } }
          ) | (
            { __typename: 'Feature' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Feature_Fragment': ContentGrid_EntryFragment_Feature_Fragment } }
          ) | (
            { __typename: 'GrantActivityArticle' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_GrantActivityArticle_Fragment': ContentGrid_EntryFragment_GrantActivityArticle_Fragment } }
          ) | (
            { __typename: 'GrantmakingAreaDetailsPage' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_GrantmakingAreaDetailsPage_Fragment': ContentGrid_EntryFragment_GrantmakingAreaDetailsPage_Fragment } }
          ) | (
            { __typename: 'Idea' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Idea_Fragment': ContentGrid_EntryFragment_Idea_Fragment } }
          ) | null> } | null, sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'InlineImages', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'InlineImages_InlineImagesFragmentFragment': InlineImages_InlineImagesFragmentFragment } }
      ) | { __typename: 'MainNavigation', sys: { __typename: 'Sys', id: string } } | { __typename: 'Metadata', sys: { __typename: 'Sys', id: string } } | { __typename: 'MissionPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Mmuf', sys: { __typename: 'Sys', id: string } } | { __typename: 'NavigationItem', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsletterCard', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsletterConfirmPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsletterPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'OldAnnualReport', sys: { __typename: 'Sys', id: string } } | { __typename: 'Organisation', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'ParallaxImages', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'ParallaxImages_ParallaxImagesQueryFragment': ParallaxImages_ParallaxImagesQueryFragment } }
      ) | { __typename: 'PasswordProtectedPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'PeoplePage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Person', sys: { __typename: 'Sys', id: string } } | { __typename: 'PresidentialQuoteCallOut', sys: { __typename: 'Sys', id: string } } | { __typename: 'PressRoom', sys: { __typename: 'Sys', id: string } } | { __typename: 'PrivacyPolicy', sys: { __typename: 'Sys', id: string } } | { __typename: 'QuickLink', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'Quote', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'QuoteModule_QuoteFragmentFragment': QuoteModule_QuoteFragmentFragment } }
      ) | { __typename: 'RangeValueFilter', sys: { __typename: 'Sys', id: string } } | { __typename: 'ResourcesCurrentGrantees', sys: { __typename: 'Sys', id: string } } | { __typename: 'ResourcesProspectiveGrantees', sys: { __typename: 'Sys', id: string } } | { __typename: 'RootPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'SearchPage', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'SpotlightSlideshow', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'SpotlightSlideshow_SpotlightSlideshowFragmentFragment': SpotlightSlideshow_SpotlightSlideshowFragmentFragment } }
      ) | (
        { __typename: 'SpotlightVideo', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'SpotlightVideo_SpotlightVideoFragmentFragment': SpotlightVideo_SpotlightVideoFragmentFragment } }
      ) | { __typename: 'StoriesPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Taxonomy', sys: { __typename: 'Sys', id: string } } | { __typename: 'TermsOfUse', sys: { __typename: 'Sys', id: string } } | { __typename: 'Theme', sys: { __typename: 'Sys', id: string } } | { __typename: 'Trustee', sys: { __typename: 'Sys', id: string } } | { __typename: 'TrusteesPage', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'VideoNative', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'Video_VideoNativeFragmentFragment': Video_VideoNativeFragmentFragment } }
      ) | (
        { __typename: 'VideoYoutube', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'Video_VideoYoutubeFragmentFragment': Video_VideoYoutubeFragmentFragment } }
      ) | null> } } } & { ' $fragmentName'?: 'ResourcesExplanatoryParagraphRichText_ResourcesExplanatoryParagraphFragmentFragment' };

export type RootPageBodyRichText_RootPageBodyFragmentFragment = { __typename: 'RootPageBody', json: any, links: { __typename: 'RootPageBodyLinks', assets: { __typename: 'RootPageBodyAssets', block: Array<(
        { __typename: 'Asset' }
        & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
      ) | null> }, entries: { __typename: 'RootPageBodyEntries', block: Array<{ __typename: 'AnnualReport', sys: { __typename: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename: 'Sys', id: string } } | { __typename: 'AtGlanceCard', sys: { __typename: 'Sys', id: string } } | { __typename: 'CallForConcept', sys: { __typename: 'Sys', id: string } } | { __typename: 'ConnectWith', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'ConnectWithLink', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'QuickLink_ConnectWithLinkFragmentFragment': QuickLink_ConnectWithLinkFragmentFragment } }
      ) | { __typename: 'Contact', sys: { __typename: 'Sys', id: string } } | { __typename: 'ContactPerson', sys: { __typename: 'Sys', id: string } } | { __typename: 'Department', sys: { __typename: 'Sys', id: string } } | { __typename: 'DropCap', sys: { __typename: 'Sys', id: string } } | { __typename: 'EmphasizedArticle', sys: { __typename: 'Sys', id: string } } | { __typename: 'EventsPage', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'ExperienceBlock', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'ExperienceBlock_ExperienceBlockFragmentFragment': ExperienceBlock_ExperienceBlockFragmentFragment } }
      ) | { __typename: 'ExplicitValueFilter', sys: { __typename: 'Sys', id: string } } | { __typename: 'ExternalEvent', sys: { __typename: 'Sys', id: string } } | { __typename: 'ExternalPerson', sys: { __typename: 'Sys', id: string } } | { __typename: 'Faq', sys: { __typename: 'Sys', id: string } } | { __typename: 'FaqsModule', sys: { __typename: 'Sys', id: string } } | { __typename: 'Feature', sys: { __typename: 'Sys', id: string } } | { __typename: 'FinancialsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename: 'Sys', id: string } } | { __typename: 'Grant', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantActivityArticle', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantDetailsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantResources', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantSearchFilters', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantmakingArea', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantmakingAreaDetailsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantmakingAreasPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'HeroAsset', sys: { __typename: 'Sys', id: string } } | { __typename: 'HistoryPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'HistoryPerson', sys: { __typename: 'Sys', id: string } } | { __typename: 'HomePage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Idea', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'InitiativeQuoteCallOut', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'InitiativeQuote_InitiativeQuoteCallOutFragmentFragment': InitiativeQuote_InitiativeQuoteCallOutFragmentFragment } }
      ) | { __typename: 'InlineCards', cardsCollection: { __typename: 'InlineCardsCardsCollection', items: Array<(
            { __typename: 'Article' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Article_Fragment': ContentGrid_EntryFragment_Article_Fragment } }
          ) | (
            { __typename: 'EmphasizedArticle' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_EmphasizedArticle_Fragment': ContentGrid_EntryFragment_EmphasizedArticle_Fragment } }
          ) | (
            { __typename: 'ExternalEvent' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_ExternalEvent_Fragment': ContentGrid_EntryFragment_ExternalEvent_Fragment } }
          ) | (
            { __typename: 'Feature' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Feature_Fragment': ContentGrid_EntryFragment_Feature_Fragment } }
          ) | (
            { __typename: 'GrantActivityArticle' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_GrantActivityArticle_Fragment': ContentGrid_EntryFragment_GrantActivityArticle_Fragment } }
          ) | (
            { __typename: 'GrantmakingAreaDetailsPage' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_GrantmakingAreaDetailsPage_Fragment': ContentGrid_EntryFragment_GrantmakingAreaDetailsPage_Fragment } }
          ) | (
            { __typename: 'Idea' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Idea_Fragment': ContentGrid_EntryFragment_Idea_Fragment } }
          ) | null> } | null, sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'InlineImages', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'InlineImages_InlineImagesFragmentFragment': InlineImages_InlineImagesFragmentFragment } }
      ) | { __typename: 'MainNavigation', sys: { __typename: 'Sys', id: string } } | { __typename: 'Metadata', sys: { __typename: 'Sys', id: string } } | { __typename: 'MissionPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Mmuf', sys: { __typename: 'Sys', id: string } } | { __typename: 'NavigationItem', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsletterCard', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsletterConfirmPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsletterPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'OldAnnualReport', sys: { __typename: 'Sys', id: string } } | { __typename: 'Organisation', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'ParallaxImages', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'ParallaxImages_ParallaxImagesQueryFragment': ParallaxImages_ParallaxImagesQueryFragment } }
      ) | { __typename: 'PasswordProtectedPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'PeoplePage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Person', sys: { __typename: 'Sys', id: string } } | { __typename: 'PresidentialQuoteCallOut', sys: { __typename: 'Sys', id: string } } | { __typename: 'PressRoom', sys: { __typename: 'Sys', id: string } } | { __typename: 'PrivacyPolicy', sys: { __typename: 'Sys', id: string } } | { __typename: 'QuickLink', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'Quote', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'QuoteModule_QuoteFragmentFragment': QuoteModule_QuoteFragmentFragment } }
      ) | { __typename: 'RangeValueFilter', sys: { __typename: 'Sys', id: string } } | { __typename: 'ResourcesCurrentGrantees', sys: { __typename: 'Sys', id: string } } | { __typename: 'ResourcesProspectiveGrantees', sys: { __typename: 'Sys', id: string } } | { __typename: 'RootPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'SearchPage', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'SpotlightSlideshow', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'SpotlightSlideshow_SpotlightSlideshowFragmentFragment': SpotlightSlideshow_SpotlightSlideshowFragmentFragment } }
      ) | (
        { __typename: 'SpotlightVideo', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'SpotlightVideo_SpotlightVideoFragmentFragment': SpotlightVideo_SpotlightVideoFragmentFragment } }
      ) | { __typename: 'StoriesPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Taxonomy', sys: { __typename: 'Sys', id: string } } | { __typename: 'TermsOfUse', sys: { __typename: 'Sys', id: string } } | { __typename: 'Theme', sys: { __typename: 'Sys', id: string } } | { __typename: 'Trustee', sys: { __typename: 'Sys', id: string } } | { __typename: 'TrusteesPage', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'VideoNative', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'Video_VideoNativeFragmentFragment': Video_VideoNativeFragmentFragment } }
      ) | (
        { __typename: 'VideoYoutube', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'Video_VideoYoutubeFragmentFragment': Video_VideoYoutubeFragmentFragment } }
      ) | null> } } } & { ' $fragmentName'?: 'RootPageBodyRichText_RootPageBodyFragmentFragment' };

export type AnnualReportBodyRichText_AnnualReportArticleBodyPart2FragmentFragment = { __typename: 'AnnualReportArticleBodyPart2', json: any, links: { __typename: 'AnnualReportArticleBodyPart2Links', assets: { __typename: 'AnnualReportArticleBodyPart2Assets', block: Array<(
        { __typename: 'Asset' }
        & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
      ) | null> }, entries: { __typename: 'AnnualReportArticleBodyPart2Entries', block: Array<{ __typename: 'AnnualReport', sys: { __typename: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename: 'Sys', id: string } } | { __typename: 'AtGlanceCard', sys: { __typename: 'Sys', id: string } } | { __typename: 'CallForConcept', sys: { __typename: 'Sys', id: string } } | { __typename: 'ConnectWith', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'ConnectWithLink', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'QuickLink_ConnectWithLinkFragmentFragment': QuickLink_ConnectWithLinkFragmentFragment } }
      ) | { __typename: 'Contact', sys: { __typename: 'Sys', id: string } } | { __typename: 'ContactPerson', sys: { __typename: 'Sys', id: string } } | { __typename: 'Department', sys: { __typename: 'Sys', id: string } } | { __typename: 'DropCap', sys: { __typename: 'Sys', id: string } } | { __typename: 'EmphasizedArticle', sys: { __typename: 'Sys', id: string } } | { __typename: 'EventsPage', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'ExperienceBlock', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'ExperienceBlock_ExperienceBlockFragmentFragment': ExperienceBlock_ExperienceBlockFragmentFragment } }
      ) | { __typename: 'ExplicitValueFilter', sys: { __typename: 'Sys', id: string } } | { __typename: 'ExternalEvent', sys: { __typename: 'Sys', id: string } } | { __typename: 'ExternalPerson', sys: { __typename: 'Sys', id: string } } | { __typename: 'Faq', sys: { __typename: 'Sys', id: string } } | { __typename: 'FaqsModule', sys: { __typename: 'Sys', id: string } } | { __typename: 'Feature', sys: { __typename: 'Sys', id: string } } | { __typename: 'FinancialsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename: 'Sys', id: string } } | { __typename: 'Grant', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantActivityArticle', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantDetailsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantResources', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantSearchFilters', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantmakingArea', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantmakingAreaDetailsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantmakingAreasPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'HeroAsset', sys: { __typename: 'Sys', id: string } } | { __typename: 'HistoryPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'HistoryPerson', sys: { __typename: 'Sys', id: string } } | { __typename: 'HomePage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Idea', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'InitiativeQuoteCallOut', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'InitiativeQuote_InitiativeQuoteCallOutFragmentFragment': InitiativeQuote_InitiativeQuoteCallOutFragmentFragment } }
      ) | { __typename: 'InlineCards', cardsCollection: { __typename: 'InlineCardsCardsCollection', items: Array<(
            { __typename: 'Article' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Article_Fragment': ContentGrid_EntryFragment_Article_Fragment } }
          ) | (
            { __typename: 'EmphasizedArticle' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_EmphasizedArticle_Fragment': ContentGrid_EntryFragment_EmphasizedArticle_Fragment } }
          ) | (
            { __typename: 'ExternalEvent' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_ExternalEvent_Fragment': ContentGrid_EntryFragment_ExternalEvent_Fragment } }
          ) | (
            { __typename: 'Feature' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Feature_Fragment': ContentGrid_EntryFragment_Feature_Fragment } }
          ) | (
            { __typename: 'GrantActivityArticle' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_GrantActivityArticle_Fragment': ContentGrid_EntryFragment_GrantActivityArticle_Fragment } }
          ) | (
            { __typename: 'GrantmakingAreaDetailsPage' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_GrantmakingAreaDetailsPage_Fragment': ContentGrid_EntryFragment_GrantmakingAreaDetailsPage_Fragment } }
          ) | (
            { __typename: 'Idea' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Idea_Fragment': ContentGrid_EntryFragment_Idea_Fragment } }
          ) | null> } | null, sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'InlineImages', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'InlineImages_InlineImagesFragmentFragment': InlineImages_InlineImagesFragmentFragment } }
      ) | { __typename: 'MainNavigation', sys: { __typename: 'Sys', id: string } } | { __typename: 'Metadata', sys: { __typename: 'Sys', id: string } } | { __typename: 'MissionPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Mmuf', sys: { __typename: 'Sys', id: string } } | { __typename: 'NavigationItem', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsletterCard', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsletterConfirmPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsletterPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'OldAnnualReport', sys: { __typename: 'Sys', id: string } } | { __typename: 'Organisation', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'ParallaxImages', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'ParallaxImages_ParallaxImagesQueryFragment': ParallaxImages_ParallaxImagesQueryFragment } }
      ) | { __typename: 'PasswordProtectedPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'PeoplePage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Person', sys: { __typename: 'Sys', id: string } } | { __typename: 'PresidentialQuoteCallOut', sys: { __typename: 'Sys', id: string } } | { __typename: 'PressRoom', sys: { __typename: 'Sys', id: string } } | { __typename: 'PrivacyPolicy', sys: { __typename: 'Sys', id: string } } | { __typename: 'QuickLink', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'Quote', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'QuoteModule_QuoteFragmentFragment': QuoteModule_QuoteFragmentFragment } }
      ) | { __typename: 'RangeValueFilter', sys: { __typename: 'Sys', id: string } } | { __typename: 'ResourcesCurrentGrantees', sys: { __typename: 'Sys', id: string } } | { __typename: 'ResourcesProspectiveGrantees', sys: { __typename: 'Sys', id: string } } | { __typename: 'RootPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'SearchPage', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'SpotlightSlideshow', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'SpotlightSlideshow_SpotlightSlideshowFragmentFragment': SpotlightSlideshow_SpotlightSlideshowFragmentFragment } }
      ) | (
        { __typename: 'SpotlightVideo', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'SpotlightVideo_SpotlightVideoFragmentFragment': SpotlightVideo_SpotlightVideoFragmentFragment } }
      ) | { __typename: 'StoriesPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Taxonomy', sys: { __typename: 'Sys', id: string } } | { __typename: 'TermsOfUse', sys: { __typename: 'Sys', id: string } } | { __typename: 'Theme', sys: { __typename: 'Sys', id: string } } | { __typename: 'Trustee', sys: { __typename: 'Sys', id: string } } | { __typename: 'TrusteesPage', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'VideoNative', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'Video_VideoNativeFragmentFragment': Video_VideoNativeFragmentFragment } }
      ) | (
        { __typename: 'VideoYoutube', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'Video_VideoYoutubeFragmentFragment': Video_VideoYoutubeFragmentFragment } }
      ) | null> } } } & { ' $fragmentName'?: 'AnnualReportBodyRichText_AnnualReportArticleBodyPart2FragmentFragment' };

export type ArticleBodyRichText_ArticleBodyFragmentFragment = { __typename: 'ArticleBody', json: any, links: { __typename: 'ArticleBodyLinks', assets: { __typename: 'ArticleBodyAssets', block: Array<(
        { __typename: 'Asset' }
        & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
      ) | null> }, entries: { __typename: 'ArticleBodyEntries', block: Array<{ __typename: 'AnnualReport', sys: { __typename: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename: 'Sys', id: string } } | { __typename: 'AtGlanceCard', sys: { __typename: 'Sys', id: string } } | { __typename: 'CallForConcept', sys: { __typename: 'Sys', id: string } } | { __typename: 'ConnectWith', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'ConnectWithLink', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'QuickLink_ConnectWithLinkFragmentFragment': QuickLink_ConnectWithLinkFragmentFragment } }
      ) | { __typename: 'Contact', sys: { __typename: 'Sys', id: string } } | { __typename: 'ContactPerson', sys: { __typename: 'Sys', id: string } } | { __typename: 'Department', sys: { __typename: 'Sys', id: string } } | { __typename: 'DropCap', sys: { __typename: 'Sys', id: string } } | { __typename: 'EmphasizedArticle', sys: { __typename: 'Sys', id: string } } | { __typename: 'EventsPage', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'ExperienceBlock', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'ExperienceBlock_ExperienceBlockFragmentFragment': ExperienceBlock_ExperienceBlockFragmentFragment } }
      ) | { __typename: 'ExplicitValueFilter', sys: { __typename: 'Sys', id: string } } | { __typename: 'ExternalEvent', sys: { __typename: 'Sys', id: string } } | { __typename: 'ExternalPerson', sys: { __typename: 'Sys', id: string } } | { __typename: 'Faq', sys: { __typename: 'Sys', id: string } } | { __typename: 'FaqsModule', sys: { __typename: 'Sys', id: string } } | { __typename: 'Feature', sys: { __typename: 'Sys', id: string } } | { __typename: 'FinancialsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename: 'Sys', id: string } } | { __typename: 'Grant', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantActivityArticle', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantDetailsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantResources', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantSearchFilters', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantmakingArea', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantmakingAreaDetailsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantmakingAreasPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'HeroAsset', sys: { __typename: 'Sys', id: string } } | { __typename: 'HistoryPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'HistoryPerson', sys: { __typename: 'Sys', id: string } } | { __typename: 'HomePage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Idea', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'InitiativeQuoteCallOut', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'InitiativeQuote_InitiativeQuoteCallOutFragmentFragment': InitiativeQuote_InitiativeQuoteCallOutFragmentFragment } }
      ) | { __typename: 'InlineCards', cardsCollection: { __typename: 'InlineCardsCardsCollection', items: Array<(
            { __typename: 'Article' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Article_Fragment': ContentGrid_EntryFragment_Article_Fragment } }
          ) | (
            { __typename: 'EmphasizedArticle' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_EmphasizedArticle_Fragment': ContentGrid_EntryFragment_EmphasizedArticle_Fragment } }
          ) | (
            { __typename: 'ExternalEvent' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_ExternalEvent_Fragment': ContentGrid_EntryFragment_ExternalEvent_Fragment } }
          ) | (
            { __typename: 'Feature' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Feature_Fragment': ContentGrid_EntryFragment_Feature_Fragment } }
          ) | (
            { __typename: 'GrantActivityArticle' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_GrantActivityArticle_Fragment': ContentGrid_EntryFragment_GrantActivityArticle_Fragment } }
          ) | (
            { __typename: 'GrantmakingAreaDetailsPage' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_GrantmakingAreaDetailsPage_Fragment': ContentGrid_EntryFragment_GrantmakingAreaDetailsPage_Fragment } }
          ) | (
            { __typename: 'Idea' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Idea_Fragment': ContentGrid_EntryFragment_Idea_Fragment } }
          ) | null> } | null, sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'InlineImages', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'InlineImages_InlineImagesFragmentFragment': InlineImages_InlineImagesFragmentFragment } }
      ) | { __typename: 'MainNavigation', sys: { __typename: 'Sys', id: string } } | { __typename: 'Metadata', sys: { __typename: 'Sys', id: string } } | { __typename: 'MissionPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Mmuf', sys: { __typename: 'Sys', id: string } } | { __typename: 'NavigationItem', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsletterCard', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsletterConfirmPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsletterPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'OldAnnualReport', sys: { __typename: 'Sys', id: string } } | { __typename: 'Organisation', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'ParallaxImages', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'ParallaxImages_ParallaxImagesQueryFragment': ParallaxImages_ParallaxImagesQueryFragment } }
      ) | { __typename: 'PasswordProtectedPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'PeoplePage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Person', sys: { __typename: 'Sys', id: string } } | { __typename: 'PresidentialQuoteCallOut', sys: { __typename: 'Sys', id: string } } | { __typename: 'PressRoom', sys: { __typename: 'Sys', id: string } } | { __typename: 'PrivacyPolicy', sys: { __typename: 'Sys', id: string } } | { __typename: 'QuickLink', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'Quote', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'QuoteModule_QuoteFragmentFragment': QuoteModule_QuoteFragmentFragment } }
      ) | { __typename: 'RangeValueFilter', sys: { __typename: 'Sys', id: string } } | { __typename: 'ResourcesCurrentGrantees', sys: { __typename: 'Sys', id: string } } | { __typename: 'ResourcesProspectiveGrantees', sys: { __typename: 'Sys', id: string } } | { __typename: 'RootPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'SearchPage', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'SpotlightSlideshow', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'SpotlightSlideshow_SpotlightSlideshowFragmentFragment': SpotlightSlideshow_SpotlightSlideshowFragmentFragment } }
      ) | (
        { __typename: 'SpotlightVideo', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'SpotlightVideo_SpotlightVideoFragmentFragment': SpotlightVideo_SpotlightVideoFragmentFragment } }
      ) | { __typename: 'StoriesPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Taxonomy', sys: { __typename: 'Sys', id: string } } | { __typename: 'TermsOfUse', sys: { __typename: 'Sys', id: string } } | { __typename: 'Theme', sys: { __typename: 'Sys', id: string } } | { __typename: 'Trustee', sys: { __typename: 'Sys', id: string } } | { __typename: 'TrusteesPage', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'VideoNative', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'Video_VideoNativeFragmentFragment': Video_VideoNativeFragmentFragment } }
      ) | (
        { __typename: 'VideoYoutube', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'Video_VideoYoutubeFragmentFragment': Video_VideoYoutubeFragmentFragment } }
      ) | null>, hyperlink: Array<{ __typename: 'AnnualReport', sys: { __typename: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename: 'Sys', id: string } } | { __typename: 'AtGlanceCard', sys: { __typename: 'Sys', id: string } } | { __typename: 'CallForConcept', sys: { __typename: 'Sys', id: string } } | { __typename: 'ConnectWith', sys: { __typename: 'Sys', id: string } } | { __typename: 'ConnectWithLink', sys: { __typename: 'Sys', id: string } } | { __typename: 'Contact', sys: { __typename: 'Sys', id: string } } | { __typename: 'ContactPerson', sys: { __typename: 'Sys', id: string } } | { __typename: 'Department', sys: { __typename: 'Sys', id: string } } | { __typename: 'DropCap', sys: { __typename: 'Sys', id: string } } | { __typename: 'EmphasizedArticle', sys: { __typename: 'Sys', id: string } } | { __typename: 'EventsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'ExperienceBlock', sys: { __typename: 'Sys', id: string } } | { __typename: 'ExplicitValueFilter', sys: { __typename: 'Sys', id: string } } | { __typename: 'ExternalEvent', sys: { __typename: 'Sys', id: string } } | { __typename: 'ExternalPerson', sys: { __typename: 'Sys', id: string } } | { __typename: 'Faq', sys: { __typename: 'Sys', id: string } } | { __typename: 'FaqsModule', sys: { __typename: 'Sys', id: string } } | { __typename: 'Feature', sys: { __typename: 'Sys', id: string } } | { __typename: 'FinancialsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename: 'Sys', id: string } } | { __typename: 'Grant', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantActivityArticle', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantDetailsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantResources', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantSearchFilters', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantmakingArea', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantmakingAreaDetailsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantmakingAreasPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'HeroAsset', sys: { __typename: 'Sys', id: string } } | { __typename: 'HistoryPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'HistoryPerson', sys: { __typename: 'Sys', id: string } } | { __typename: 'HomePage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Idea', sys: { __typename: 'Sys', id: string } } | { __typename: 'InitiativeQuoteCallOut', sys: { __typename: 'Sys', id: string } } | { __typename: 'InlineCards', sys: { __typename: 'Sys', id: string } } | { __typename: 'InlineImages', sys: { __typename: 'Sys', id: string } } | { __typename: 'MainNavigation', sys: { __typename: 'Sys', id: string } } | { __typename: 'Metadata', sys: { __typename: 'Sys', id: string } } | { __typename: 'MissionPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Mmuf', sys: { __typename: 'Sys', id: string } } | { __typename: 'NavigationItem', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsletterCard', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsletterConfirmPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsletterPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'OldAnnualReport', sys: { __typename: 'Sys', id: string } } | { __typename: 'Organisation', sys: { __typename: 'Sys', id: string } } | { __typename: 'ParallaxImages', sys: { __typename: 'Sys', id: string } } | { __typename: 'PasswordProtectedPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'PeoplePage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Person', sys: { __typename: 'Sys', id: string } } | { __typename: 'PresidentialQuoteCallOut', sys: { __typename: 'Sys', id: string } } | { __typename: 'PressRoom', sys: { __typename: 'Sys', id: string } } | { __typename: 'PrivacyPolicy', sys: { __typename: 'Sys', id: string } } | { __typename: 'QuickLink', sys: { __typename: 'Sys', id: string } } | { __typename: 'Quote', sys: { __typename: 'Sys', id: string } } | { __typename: 'RangeValueFilter', sys: { __typename: 'Sys', id: string } } | { __typename: 'ResourcesCurrentGrantees', sys: { __typename: 'Sys', id: string } } | { __typename: 'ResourcesProspectiveGrantees', sys: { __typename: 'Sys', id: string } } | { __typename: 'RootPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'SearchPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'SpotlightSlideshow', sys: { __typename: 'Sys', id: string } } | { __typename: 'SpotlightVideo', sys: { __typename: 'Sys', id: string } } | { __typename: 'StoriesPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Taxonomy', sys: { __typename: 'Sys', id: string } } | { __typename: 'TermsOfUse', sys: { __typename: 'Sys', id: string } } | { __typename: 'Theme', sys: { __typename: 'Sys', id: string } } | { __typename: 'Trustee', sys: { __typename: 'Sys', id: string } } | { __typename: 'TrusteesPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'VideoNative', sys: { __typename: 'Sys', id: string } } | { __typename: 'VideoYoutube', sys: { __typename: 'Sys', id: string } } | null> } } } & { ' $fragmentName'?: 'ArticleBodyRichText_ArticleBodyFragmentFragment' };

export type FeatureIntroRichText_FeatureIntroFragmentFragment = { __typename: 'FeatureIntro', json: any, links: { __typename: 'FeatureIntroLinks', assets: { __typename: 'FeatureIntroAssets', block: Array<(
        { __typename: 'Asset' }
        & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
      ) | null> }, entries: { __typename: 'FeatureIntroEntries', block: Array<{ __typename: 'AnnualReport', sys: { __typename: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename: 'Sys', id: string } } | { __typename: 'AtGlanceCard', sys: { __typename: 'Sys', id: string } } | { __typename: 'CallForConcept', sys: { __typename: 'Sys', id: string } } | { __typename: 'ConnectWith', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'ConnectWithLink', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'QuickLink_ConnectWithLinkFragmentFragment': QuickLink_ConnectWithLinkFragmentFragment } }
      ) | { __typename: 'Contact', sys: { __typename: 'Sys', id: string } } | { __typename: 'ContactPerson', sys: { __typename: 'Sys', id: string } } | { __typename: 'Department', sys: { __typename: 'Sys', id: string } } | { __typename: 'DropCap', sys: { __typename: 'Sys', id: string } } | { __typename: 'EmphasizedArticle', sys: { __typename: 'Sys', id: string } } | { __typename: 'EventsPage', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'ExperienceBlock', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'ExperienceBlock_ExperienceBlockFragmentFragment': ExperienceBlock_ExperienceBlockFragmentFragment } }
      ) | { __typename: 'ExplicitValueFilter', sys: { __typename: 'Sys', id: string } } | { __typename: 'ExternalEvent', sys: { __typename: 'Sys', id: string } } | { __typename: 'ExternalPerson', sys: { __typename: 'Sys', id: string } } | { __typename: 'Faq', sys: { __typename: 'Sys', id: string } } | { __typename: 'FaqsModule', sys: { __typename: 'Sys', id: string } } | { __typename: 'Feature', sys: { __typename: 'Sys', id: string } } | { __typename: 'FinancialsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename: 'Sys', id: string } } | { __typename: 'Grant', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantActivityArticle', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantDetailsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantResources', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantSearchFilters', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantmakingArea', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantmakingAreaDetailsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantmakingAreasPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'HeroAsset', sys: { __typename: 'Sys', id: string } } | { __typename: 'HistoryPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'HistoryPerson', sys: { __typename: 'Sys', id: string } } | { __typename: 'HomePage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Idea', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'InitiativeQuoteCallOut', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'InitiativeQuote_InitiativeQuoteCallOutFragmentFragment': InitiativeQuote_InitiativeQuoteCallOutFragmentFragment } }
      ) | { __typename: 'InlineCards', cardsCollection: { __typename: 'InlineCardsCardsCollection', items: Array<(
            { __typename: 'Article' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Article_Fragment': ContentGrid_EntryFragment_Article_Fragment } }
          ) | (
            { __typename: 'EmphasizedArticle' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_EmphasizedArticle_Fragment': ContentGrid_EntryFragment_EmphasizedArticle_Fragment } }
          ) | (
            { __typename: 'ExternalEvent' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_ExternalEvent_Fragment': ContentGrid_EntryFragment_ExternalEvent_Fragment } }
          ) | (
            { __typename: 'Feature' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Feature_Fragment': ContentGrid_EntryFragment_Feature_Fragment } }
          ) | (
            { __typename: 'GrantActivityArticle' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_GrantActivityArticle_Fragment': ContentGrid_EntryFragment_GrantActivityArticle_Fragment } }
          ) | (
            { __typename: 'GrantmakingAreaDetailsPage' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_GrantmakingAreaDetailsPage_Fragment': ContentGrid_EntryFragment_GrantmakingAreaDetailsPage_Fragment } }
          ) | (
            { __typename: 'Idea' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Idea_Fragment': ContentGrid_EntryFragment_Idea_Fragment } }
          ) | null> } | null, sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'InlineImages', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'InlineImages_InlineImagesFragmentFragment': InlineImages_InlineImagesFragmentFragment } }
      ) | { __typename: 'MainNavigation', sys: { __typename: 'Sys', id: string } } | { __typename: 'Metadata', sys: { __typename: 'Sys', id: string } } | { __typename: 'MissionPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Mmuf', sys: { __typename: 'Sys', id: string } } | { __typename: 'NavigationItem', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsletterCard', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsletterConfirmPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsletterPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'OldAnnualReport', sys: { __typename: 'Sys', id: string } } | { __typename: 'Organisation', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'ParallaxImages', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'ParallaxImages_ParallaxImagesQueryFragment': ParallaxImages_ParallaxImagesQueryFragment } }
      ) | { __typename: 'PasswordProtectedPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'PeoplePage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Person', sys: { __typename: 'Sys', id: string } } | { __typename: 'PresidentialQuoteCallOut', sys: { __typename: 'Sys', id: string } } | { __typename: 'PressRoom', sys: { __typename: 'Sys', id: string } } | { __typename: 'PrivacyPolicy', sys: { __typename: 'Sys', id: string } } | { __typename: 'QuickLink', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'Quote', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'QuoteModule_QuoteFragmentFragment': QuoteModule_QuoteFragmentFragment } }
      ) | { __typename: 'RangeValueFilter', sys: { __typename: 'Sys', id: string } } | { __typename: 'ResourcesCurrentGrantees', sys: { __typename: 'Sys', id: string } } | { __typename: 'ResourcesProspectiveGrantees', sys: { __typename: 'Sys', id: string } } | { __typename: 'RootPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'SearchPage', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'SpotlightSlideshow', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'SpotlightSlideshow_SpotlightSlideshowFragmentFragment': SpotlightSlideshow_SpotlightSlideshowFragmentFragment } }
      ) | (
        { __typename: 'SpotlightVideo', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'SpotlightVideo_SpotlightVideoFragmentFragment': SpotlightVideo_SpotlightVideoFragmentFragment } }
      ) | { __typename: 'StoriesPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Taxonomy', sys: { __typename: 'Sys', id: string } } | { __typename: 'TermsOfUse', sys: { __typename: 'Sys', id: string } } | { __typename: 'Theme', sys: { __typename: 'Sys', id: string } } | { __typename: 'Trustee', sys: { __typename: 'Sys', id: string } } | { __typename: 'TrusteesPage', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'VideoNative', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'Video_VideoNativeFragmentFragment': Video_VideoNativeFragmentFragment } }
      ) | (
        { __typename: 'VideoYoutube', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'Video_VideoYoutubeFragmentFragment': Video_VideoYoutubeFragmentFragment } }
      ) | null> } } } & { ' $fragmentName'?: 'FeatureIntroRichText_FeatureIntroFragmentFragment' };

export type FeatureContentRichText_FeatureBodyFragmentFragment = { __typename: 'FeatureContent', json: any, links: { __typename: 'FeatureContentLinks', assets: { __typename: 'FeatureContentAssets', block: Array<(
        { __typename: 'Asset' }
        & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
      ) | null> }, entries: { __typename: 'FeatureContentEntries', block: Array<{ __typename: 'AnnualReport', sys: { __typename: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename: 'Sys', id: string } } | { __typename: 'AtGlanceCard', sys: { __typename: 'Sys', id: string } } | { __typename: 'CallForConcept', sys: { __typename: 'Sys', id: string } } | { __typename: 'ConnectWith', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'ConnectWithLink', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'QuickLink_ConnectWithLinkFragmentFragment': QuickLink_ConnectWithLinkFragmentFragment } }
      ) | { __typename: 'Contact', sys: { __typename: 'Sys', id: string } } | { __typename: 'ContactPerson', sys: { __typename: 'Sys', id: string } } | { __typename: 'Department', sys: { __typename: 'Sys', id: string } } | { __typename: 'DropCap', sys: { __typename: 'Sys', id: string } } | { __typename: 'EmphasizedArticle', sys: { __typename: 'Sys', id: string } } | { __typename: 'EventsPage', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'ExperienceBlock', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'ExperienceBlock_ExperienceBlockFragmentFragment': ExperienceBlock_ExperienceBlockFragmentFragment } }
      ) | { __typename: 'ExplicitValueFilter', sys: { __typename: 'Sys', id: string } } | { __typename: 'ExternalEvent', sys: { __typename: 'Sys', id: string } } | { __typename: 'ExternalPerson', sys: { __typename: 'Sys', id: string } } | { __typename: 'Faq', sys: { __typename: 'Sys', id: string } } | { __typename: 'FaqsModule', sys: { __typename: 'Sys', id: string } } | { __typename: 'Feature', sys: { __typename: 'Sys', id: string } } | { __typename: 'FinancialsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename: 'Sys', id: string } } | { __typename: 'Grant', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantActivityArticle', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantDetailsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantResources', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantSearchFilters', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantmakingArea', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantmakingAreaDetailsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantmakingAreasPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'HeroAsset', sys: { __typename: 'Sys', id: string } } | { __typename: 'HistoryPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'HistoryPerson', sys: { __typename: 'Sys', id: string } } | { __typename: 'HomePage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Idea', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'InitiativeQuoteCallOut', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'InitiativeQuote_InitiativeQuoteCallOutFragmentFragment': InitiativeQuote_InitiativeQuoteCallOutFragmentFragment } }
      ) | { __typename: 'InlineCards', cardsCollection: { __typename: 'InlineCardsCardsCollection', items: Array<(
            { __typename: 'Article' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Article_Fragment': ContentGrid_EntryFragment_Article_Fragment } }
          ) | (
            { __typename: 'EmphasizedArticle' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_EmphasizedArticle_Fragment': ContentGrid_EntryFragment_EmphasizedArticle_Fragment } }
          ) | (
            { __typename: 'ExternalEvent' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_ExternalEvent_Fragment': ContentGrid_EntryFragment_ExternalEvent_Fragment } }
          ) | (
            { __typename: 'Feature' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Feature_Fragment': ContentGrid_EntryFragment_Feature_Fragment } }
          ) | (
            { __typename: 'GrantActivityArticle' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_GrantActivityArticle_Fragment': ContentGrid_EntryFragment_GrantActivityArticle_Fragment } }
          ) | (
            { __typename: 'GrantmakingAreaDetailsPage' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_GrantmakingAreaDetailsPage_Fragment': ContentGrid_EntryFragment_GrantmakingAreaDetailsPage_Fragment } }
          ) | (
            { __typename: 'Idea' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Idea_Fragment': ContentGrid_EntryFragment_Idea_Fragment } }
          ) | null> } | null, sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'InlineImages', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'InlineImages_InlineImagesFragmentFragment': InlineImages_InlineImagesFragmentFragment } }
      ) | { __typename: 'MainNavigation', sys: { __typename: 'Sys', id: string } } | { __typename: 'Metadata', sys: { __typename: 'Sys', id: string } } | { __typename: 'MissionPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Mmuf', sys: { __typename: 'Sys', id: string } } | { __typename: 'NavigationItem', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsletterCard', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsletterConfirmPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsletterPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'OldAnnualReport', sys: { __typename: 'Sys', id: string } } | { __typename: 'Organisation', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'ParallaxImages', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'ParallaxImages_ParallaxImagesQueryFragment': ParallaxImages_ParallaxImagesQueryFragment } }
      ) | { __typename: 'PasswordProtectedPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'PeoplePage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Person', sys: { __typename: 'Sys', id: string } } | { __typename: 'PresidentialQuoteCallOut', sys: { __typename: 'Sys', id: string } } | { __typename: 'PressRoom', sys: { __typename: 'Sys', id: string } } | { __typename: 'PrivacyPolicy', sys: { __typename: 'Sys', id: string } } | { __typename: 'QuickLink', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'Quote', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'QuoteModule_QuoteFragmentFragment': QuoteModule_QuoteFragmentFragment } }
      ) | { __typename: 'RangeValueFilter', sys: { __typename: 'Sys', id: string } } | { __typename: 'ResourcesCurrentGrantees', sys: { __typename: 'Sys', id: string } } | { __typename: 'ResourcesProspectiveGrantees', sys: { __typename: 'Sys', id: string } } | { __typename: 'RootPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'SearchPage', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'SpotlightSlideshow', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'SpotlightSlideshow_SpotlightSlideshowFragmentFragment': SpotlightSlideshow_SpotlightSlideshowFragmentFragment } }
      ) | (
        { __typename: 'SpotlightVideo', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'SpotlightVideo_SpotlightVideoFragmentFragment': SpotlightVideo_SpotlightVideoFragmentFragment } }
      ) | { __typename: 'StoriesPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Taxonomy', sys: { __typename: 'Sys', id: string } } | { __typename: 'TermsOfUse', sys: { __typename: 'Sys', id: string } } | { __typename: 'Theme', sys: { __typename: 'Sys', id: string } } | { __typename: 'Trustee', sys: { __typename: 'Sys', id: string } } | { __typename: 'TrusteesPage', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'VideoNative', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'Video_VideoNativeFragmentFragment': Video_VideoNativeFragmentFragment } }
      ) | (
        { __typename: 'VideoYoutube', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'Video_VideoYoutubeFragmentFragment': Video_VideoYoutubeFragmentFragment } }
      ) | null> } } } & { ' $fragmentName'?: 'FeatureContentRichText_FeatureBodyFragmentFragment' };

export type GrantStoryBodyRichText_GrantActivityArticleBodyFragmentFragment = { __typename: 'GrantActivityArticleBody', json: any, links: { __typename: 'GrantActivityArticleBodyLinks', assets: { __typename: 'GrantActivityArticleBodyAssets', block: Array<(
        { __typename: 'Asset' }
        & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
      ) | null> }, entries: { __typename: 'GrantActivityArticleBodyEntries', block: Array<{ __typename: 'AnnualReport', sys: { __typename: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename: 'Sys', id: string } } | { __typename: 'AtGlanceCard', sys: { __typename: 'Sys', id: string } } | { __typename: 'CallForConcept', sys: { __typename: 'Sys', id: string } } | { __typename: 'ConnectWith', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'ConnectWithLink', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'QuickLink_ConnectWithLinkFragmentFragment': QuickLink_ConnectWithLinkFragmentFragment } }
      ) | { __typename: 'Contact', sys: { __typename: 'Sys', id: string } } | { __typename: 'ContactPerson', sys: { __typename: 'Sys', id: string } } | { __typename: 'Department', sys: { __typename: 'Sys', id: string } } | { __typename: 'DropCap', sys: { __typename: 'Sys', id: string } } | { __typename: 'EmphasizedArticle', sys: { __typename: 'Sys', id: string } } | { __typename: 'EventsPage', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'ExperienceBlock', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'ExperienceBlock_ExperienceBlockFragmentFragment': ExperienceBlock_ExperienceBlockFragmentFragment } }
      ) | { __typename: 'ExplicitValueFilter', sys: { __typename: 'Sys', id: string } } | { __typename: 'ExternalEvent', sys: { __typename: 'Sys', id: string } } | { __typename: 'ExternalPerson', sys: { __typename: 'Sys', id: string } } | { __typename: 'Faq', sys: { __typename: 'Sys', id: string } } | { __typename: 'FaqsModule', sys: { __typename: 'Sys', id: string } } | { __typename: 'Feature', sys: { __typename: 'Sys', id: string } } | { __typename: 'FinancialsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename: 'Sys', id: string } } | { __typename: 'Grant', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantActivityArticle', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantDetailsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantResources', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantSearchFilters', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantmakingArea', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantmakingAreaDetailsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantmakingAreasPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'HeroAsset', sys: { __typename: 'Sys', id: string } } | { __typename: 'HistoryPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'HistoryPerson', sys: { __typename: 'Sys', id: string } } | { __typename: 'HomePage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Idea', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'InitiativeQuoteCallOut', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'InitiativeQuote_InitiativeQuoteCallOutFragmentFragment': InitiativeQuote_InitiativeQuoteCallOutFragmentFragment } }
      ) | { __typename: 'InlineCards', cardsCollection: { __typename: 'InlineCardsCardsCollection', items: Array<(
            { __typename: 'Article' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Article_Fragment': ContentGrid_EntryFragment_Article_Fragment } }
          ) | (
            { __typename: 'EmphasizedArticle' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_EmphasizedArticle_Fragment': ContentGrid_EntryFragment_EmphasizedArticle_Fragment } }
          ) | (
            { __typename: 'ExternalEvent' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_ExternalEvent_Fragment': ContentGrid_EntryFragment_ExternalEvent_Fragment } }
          ) | (
            { __typename: 'Feature' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Feature_Fragment': ContentGrid_EntryFragment_Feature_Fragment } }
          ) | (
            { __typename: 'GrantActivityArticle' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_GrantActivityArticle_Fragment': ContentGrid_EntryFragment_GrantActivityArticle_Fragment } }
          ) | (
            { __typename: 'GrantmakingAreaDetailsPage' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_GrantmakingAreaDetailsPage_Fragment': ContentGrid_EntryFragment_GrantmakingAreaDetailsPage_Fragment } }
          ) | (
            { __typename: 'Idea' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Idea_Fragment': ContentGrid_EntryFragment_Idea_Fragment } }
          ) | null> } | null, sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'InlineImages', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'InlineImages_InlineImagesFragmentFragment': InlineImages_InlineImagesFragmentFragment } }
      ) | { __typename: 'MainNavigation', sys: { __typename: 'Sys', id: string } } | { __typename: 'Metadata', sys: { __typename: 'Sys', id: string } } | { __typename: 'MissionPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Mmuf', sys: { __typename: 'Sys', id: string } } | { __typename: 'NavigationItem', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsletterCard', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsletterConfirmPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsletterPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'OldAnnualReport', sys: { __typename: 'Sys', id: string } } | { __typename: 'Organisation', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'ParallaxImages', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'ParallaxImages_ParallaxImagesQueryFragment': ParallaxImages_ParallaxImagesQueryFragment } }
      ) | { __typename: 'PasswordProtectedPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'PeoplePage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Person', sys: { __typename: 'Sys', id: string } } | { __typename: 'PresidentialQuoteCallOut', sys: { __typename: 'Sys', id: string } } | { __typename: 'PressRoom', sys: { __typename: 'Sys', id: string } } | { __typename: 'PrivacyPolicy', sys: { __typename: 'Sys', id: string } } | { __typename: 'QuickLink', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'Quote', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'QuoteModule_QuoteFragmentFragment': QuoteModule_QuoteFragmentFragment } }
      ) | { __typename: 'RangeValueFilter', sys: { __typename: 'Sys', id: string } } | { __typename: 'ResourcesCurrentGrantees', sys: { __typename: 'Sys', id: string } } | { __typename: 'ResourcesProspectiveGrantees', sys: { __typename: 'Sys', id: string } } | { __typename: 'RootPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'SearchPage', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'SpotlightSlideshow', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'SpotlightSlideshow_SpotlightSlideshowFragmentFragment': SpotlightSlideshow_SpotlightSlideshowFragmentFragment } }
      ) | (
        { __typename: 'SpotlightVideo', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'SpotlightVideo_SpotlightVideoFragmentFragment': SpotlightVideo_SpotlightVideoFragmentFragment } }
      ) | { __typename: 'StoriesPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Taxonomy', sys: { __typename: 'Sys', id: string } } | { __typename: 'TermsOfUse', sys: { __typename: 'Sys', id: string } } | { __typename: 'Theme', sys: { __typename: 'Sys', id: string } } | { __typename: 'Trustee', sys: { __typename: 'Sys', id: string } } | { __typename: 'TrusteesPage', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'VideoNative', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'Video_VideoNativeFragmentFragment': Video_VideoNativeFragmentFragment } }
      ) | (
        { __typename: 'VideoYoutube', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'Video_VideoYoutubeFragmentFragment': Video_VideoYoutubeFragmentFragment } }
      ) | null> } } } & { ' $fragmentName'?: 'GrantStoryBodyRichText_GrantActivityArticleBodyFragmentFragment' };

export type NewsletterConfirmBodyRichText_NewsletterConfirmPageBodyFragmentFragment = { __typename: 'NewsletterConfirmPageBody', json: any, links: { __typename: 'NewsletterConfirmPageBodyLinks', assets: { __typename: 'NewsletterConfirmPageBodyAssets', block: Array<(
        { __typename: 'Asset' }
        & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
      ) | null> }, entries: { __typename: 'NewsletterConfirmPageBodyEntries', block: Array<{ __typename: 'AnnualReport', sys: { __typename: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename: 'Sys', id: string } } | { __typename: 'AtGlanceCard', sys: { __typename: 'Sys', id: string } } | { __typename: 'CallForConcept', sys: { __typename: 'Sys', id: string } } | { __typename: 'ConnectWith', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'ConnectWithLink', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'QuickLink_ConnectWithLinkFragmentFragment': QuickLink_ConnectWithLinkFragmentFragment } }
      ) | { __typename: 'Contact', sys: { __typename: 'Sys', id: string } } | { __typename: 'ContactPerson', sys: { __typename: 'Sys', id: string } } | { __typename: 'Department', sys: { __typename: 'Sys', id: string } } | { __typename: 'DropCap', sys: { __typename: 'Sys', id: string } } | { __typename: 'EmphasizedArticle', sys: { __typename: 'Sys', id: string } } | { __typename: 'EventsPage', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'ExperienceBlock', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'ExperienceBlock_ExperienceBlockFragmentFragment': ExperienceBlock_ExperienceBlockFragmentFragment } }
      ) | { __typename: 'ExplicitValueFilter', sys: { __typename: 'Sys', id: string } } | { __typename: 'ExternalEvent', sys: { __typename: 'Sys', id: string } } | { __typename: 'ExternalPerson', sys: { __typename: 'Sys', id: string } } | { __typename: 'Faq', sys: { __typename: 'Sys', id: string } } | { __typename: 'FaqsModule', sys: { __typename: 'Sys', id: string } } | { __typename: 'Feature', sys: { __typename: 'Sys', id: string } } | { __typename: 'FinancialsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename: 'Sys', id: string } } | { __typename: 'Grant', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantActivityArticle', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantDetailsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantResources', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantSearchFilters', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantmakingArea', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantmakingAreaDetailsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantmakingAreasPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'HeroAsset', sys: { __typename: 'Sys', id: string } } | { __typename: 'HistoryPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'HistoryPerson', sys: { __typename: 'Sys', id: string } } | { __typename: 'HomePage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Idea', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'InitiativeQuoteCallOut', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'InitiativeQuote_InitiativeQuoteCallOutFragmentFragment': InitiativeQuote_InitiativeQuoteCallOutFragmentFragment } }
      ) | { __typename: 'InlineCards', cardsCollection: { __typename: 'InlineCardsCardsCollection', items: Array<(
            { __typename: 'Article' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Article_Fragment': ContentGrid_EntryFragment_Article_Fragment } }
          ) | (
            { __typename: 'EmphasizedArticle' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_EmphasizedArticle_Fragment': ContentGrid_EntryFragment_EmphasizedArticle_Fragment } }
          ) | (
            { __typename: 'ExternalEvent' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_ExternalEvent_Fragment': ContentGrid_EntryFragment_ExternalEvent_Fragment } }
          ) | (
            { __typename: 'Feature' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Feature_Fragment': ContentGrid_EntryFragment_Feature_Fragment } }
          ) | (
            { __typename: 'GrantActivityArticle' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_GrantActivityArticle_Fragment': ContentGrid_EntryFragment_GrantActivityArticle_Fragment } }
          ) | (
            { __typename: 'GrantmakingAreaDetailsPage' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_GrantmakingAreaDetailsPage_Fragment': ContentGrid_EntryFragment_GrantmakingAreaDetailsPage_Fragment } }
          ) | (
            { __typename: 'Idea' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Idea_Fragment': ContentGrid_EntryFragment_Idea_Fragment } }
          ) | null> } | null, sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'InlineImages', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'InlineImages_InlineImagesFragmentFragment': InlineImages_InlineImagesFragmentFragment } }
      ) | { __typename: 'MainNavigation', sys: { __typename: 'Sys', id: string } } | { __typename: 'Metadata', sys: { __typename: 'Sys', id: string } } | { __typename: 'MissionPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Mmuf', sys: { __typename: 'Sys', id: string } } | { __typename: 'NavigationItem', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsletterCard', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsletterConfirmPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsletterPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'OldAnnualReport', sys: { __typename: 'Sys', id: string } } | { __typename: 'Organisation', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'ParallaxImages', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'ParallaxImages_ParallaxImagesQueryFragment': ParallaxImages_ParallaxImagesQueryFragment } }
      ) | { __typename: 'PasswordProtectedPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'PeoplePage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Person', sys: { __typename: 'Sys', id: string } } | { __typename: 'PresidentialQuoteCallOut', sys: { __typename: 'Sys', id: string } } | { __typename: 'PressRoom', sys: { __typename: 'Sys', id: string } } | { __typename: 'PrivacyPolicy', sys: { __typename: 'Sys', id: string } } | { __typename: 'QuickLink', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'Quote', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'QuoteModule_QuoteFragmentFragment': QuoteModule_QuoteFragmentFragment } }
      ) | { __typename: 'RangeValueFilter', sys: { __typename: 'Sys', id: string } } | { __typename: 'ResourcesCurrentGrantees', sys: { __typename: 'Sys', id: string } } | { __typename: 'ResourcesProspectiveGrantees', sys: { __typename: 'Sys', id: string } } | { __typename: 'RootPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'SearchPage', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'SpotlightSlideshow', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'SpotlightSlideshow_SpotlightSlideshowFragmentFragment': SpotlightSlideshow_SpotlightSlideshowFragmentFragment } }
      ) | (
        { __typename: 'SpotlightVideo', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'SpotlightVideo_SpotlightVideoFragmentFragment': SpotlightVideo_SpotlightVideoFragmentFragment } }
      ) | { __typename: 'StoriesPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Taxonomy', sys: { __typename: 'Sys', id: string } } | { __typename: 'TermsOfUse', sys: { __typename: 'Sys', id: string } } | { __typename: 'Theme', sys: { __typename: 'Sys', id: string } } | { __typename: 'Trustee', sys: { __typename: 'Sys', id: string } } | { __typename: 'TrusteesPage', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'VideoNative', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'Video_VideoNativeFragmentFragment': Video_VideoNativeFragmentFragment } }
      ) | (
        { __typename: 'VideoYoutube', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'Video_VideoYoutubeFragmentFragment': Video_VideoYoutubeFragmentFragment } }
      ) | null> } } } & { ' $fragmentName'?: 'NewsletterConfirmBodyRichText_NewsletterConfirmPageBodyFragmentFragment' };

export type FinancialsGraphSectionRichText_FinancialsPageGraphsSectionFragmentFragment = { __typename: 'FinancialsPageGraphsSection', json: any, links: { __typename: 'FinancialsPageGraphsSectionLinks', assets: { __typename: 'FinancialsPageGraphsSectionAssets', block: Array<(
        { __typename: 'Asset' }
        & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
      ) | null> }, entries: { __typename: 'FinancialsPageGraphsSectionEntries', block: Array<{ __typename: 'AnnualReport', sys: { __typename: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename: 'Sys', id: string } } | { __typename: 'AtGlanceCard', sys: { __typename: 'Sys', id: string } } | { __typename: 'CallForConcept', sys: { __typename: 'Sys', id: string } } | { __typename: 'ConnectWith', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'ConnectWithLink', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'QuickLink_ConnectWithLinkFragmentFragment': QuickLink_ConnectWithLinkFragmentFragment } }
      ) | { __typename: 'Contact', sys: { __typename: 'Sys', id: string } } | { __typename: 'ContactPerson', sys: { __typename: 'Sys', id: string } } | { __typename: 'Department', sys: { __typename: 'Sys', id: string } } | { __typename: 'DropCap', sys: { __typename: 'Sys', id: string } } | { __typename: 'EmphasizedArticle', sys: { __typename: 'Sys', id: string } } | { __typename: 'EventsPage', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'ExperienceBlock', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'ExperienceBlock_ExperienceBlockFragmentFragment': ExperienceBlock_ExperienceBlockFragmentFragment } }
      ) | { __typename: 'ExplicitValueFilter', sys: { __typename: 'Sys', id: string } } | { __typename: 'ExternalEvent', sys: { __typename: 'Sys', id: string } } | { __typename: 'ExternalPerson', sys: { __typename: 'Sys', id: string } } | { __typename: 'Faq', sys: { __typename: 'Sys', id: string } } | { __typename: 'FaqsModule', sys: { __typename: 'Sys', id: string } } | { __typename: 'Feature', sys: { __typename: 'Sys', id: string } } | { __typename: 'FinancialsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename: 'Sys', id: string } } | { __typename: 'Grant', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantActivityArticle', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantDetailsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantResources', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantSearchFilters', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantmakingArea', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantmakingAreaDetailsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantmakingAreasPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'HeroAsset', sys: { __typename: 'Sys', id: string } } | { __typename: 'HistoryPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'HistoryPerson', sys: { __typename: 'Sys', id: string } } | { __typename: 'HomePage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Idea', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'InitiativeQuoteCallOut', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'InitiativeQuote_InitiativeQuoteCallOutFragmentFragment': InitiativeQuote_InitiativeQuoteCallOutFragmentFragment } }
      ) | { __typename: 'InlineCards', cardsCollection: { __typename: 'InlineCardsCardsCollection', items: Array<(
            { __typename: 'Article' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Article_Fragment': ContentGrid_EntryFragment_Article_Fragment } }
          ) | (
            { __typename: 'EmphasizedArticle' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_EmphasizedArticle_Fragment': ContentGrid_EntryFragment_EmphasizedArticle_Fragment } }
          ) | (
            { __typename: 'ExternalEvent' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_ExternalEvent_Fragment': ContentGrid_EntryFragment_ExternalEvent_Fragment } }
          ) | (
            { __typename: 'Feature' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Feature_Fragment': ContentGrid_EntryFragment_Feature_Fragment } }
          ) | (
            { __typename: 'GrantActivityArticle' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_GrantActivityArticle_Fragment': ContentGrid_EntryFragment_GrantActivityArticle_Fragment } }
          ) | (
            { __typename: 'GrantmakingAreaDetailsPage' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_GrantmakingAreaDetailsPage_Fragment': ContentGrid_EntryFragment_GrantmakingAreaDetailsPage_Fragment } }
          ) | (
            { __typename: 'Idea' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Idea_Fragment': ContentGrid_EntryFragment_Idea_Fragment } }
          ) | null> } | null, sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'InlineImages', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'InlineImages_InlineImagesFragmentFragment': InlineImages_InlineImagesFragmentFragment } }
      ) | { __typename: 'MainNavigation', sys: { __typename: 'Sys', id: string } } | { __typename: 'Metadata', sys: { __typename: 'Sys', id: string } } | { __typename: 'MissionPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Mmuf', sys: { __typename: 'Sys', id: string } } | { __typename: 'NavigationItem', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsletterCard', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsletterConfirmPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsletterPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'OldAnnualReport', sys: { __typename: 'Sys', id: string } } | { __typename: 'Organisation', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'ParallaxImages', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'ParallaxImages_ParallaxImagesQueryFragment': ParallaxImages_ParallaxImagesQueryFragment } }
      ) | { __typename: 'PasswordProtectedPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'PeoplePage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Person', sys: { __typename: 'Sys', id: string } } | { __typename: 'PresidentialQuoteCallOut', sys: { __typename: 'Sys', id: string } } | { __typename: 'PressRoom', sys: { __typename: 'Sys', id: string } } | { __typename: 'PrivacyPolicy', sys: { __typename: 'Sys', id: string } } | { __typename: 'QuickLink', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'Quote', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'QuoteModule_QuoteFragmentFragment': QuoteModule_QuoteFragmentFragment } }
      ) | { __typename: 'RangeValueFilter', sys: { __typename: 'Sys', id: string } } | { __typename: 'ResourcesCurrentGrantees', sys: { __typename: 'Sys', id: string } } | { __typename: 'ResourcesProspectiveGrantees', sys: { __typename: 'Sys', id: string } } | { __typename: 'RootPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'SearchPage', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'SpotlightSlideshow', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'SpotlightSlideshow_SpotlightSlideshowFragmentFragment': SpotlightSlideshow_SpotlightSlideshowFragmentFragment } }
      ) | (
        { __typename: 'SpotlightVideo', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'SpotlightVideo_SpotlightVideoFragmentFragment': SpotlightVideo_SpotlightVideoFragmentFragment } }
      ) | { __typename: 'StoriesPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Taxonomy', sys: { __typename: 'Sys', id: string } } | { __typename: 'TermsOfUse', sys: { __typename: 'Sys', id: string } } | { __typename: 'Theme', sys: { __typename: 'Sys', id: string } } | { __typename: 'Trustee', sys: { __typename: 'Sys', id: string } } | { __typename: 'TrusteesPage', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'VideoNative', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'Video_VideoNativeFragmentFragment': Video_VideoNativeFragmentFragment } }
      ) | (
        { __typename: 'VideoYoutube', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'Video_VideoYoutubeFragmentFragment': Video_VideoYoutubeFragmentFragment } }
      ) | null> } } } & { ' $fragmentName'?: 'FinancialsGraphSectionRichText_FinancialsPageGraphsSectionFragmentFragment' };

export type GrantmakingAreaDetailsPageBodyRichText_GrantmakingAreaDetailsPageBodyFragmentFragment = { __typename: 'GrantmakingAreaDetailsPageBody', json: any, links: { __typename: 'GrantmakingAreaDetailsPageBodyLinks', assets: { __typename: 'GrantmakingAreaDetailsPageBodyAssets', block: Array<(
        { __typename: 'Asset' }
        & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
      ) | null> }, entries: { __typename: 'GrantmakingAreaDetailsPageBodyEntries', block: Array<{ __typename: 'AnnualReport', sys: { __typename: 'Sys', id: string } } | { __typename: 'Article', sys: { __typename: 'Sys', id: string } } | { __typename: 'AtGlanceCard', sys: { __typename: 'Sys', id: string } } | { __typename: 'CallForConcept', sys: { __typename: 'Sys', id: string } } | { __typename: 'ConnectWith', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'ConnectWithLink', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'QuickLink_ConnectWithLinkFragmentFragment': QuickLink_ConnectWithLinkFragmentFragment } }
      ) | { __typename: 'Contact', sys: { __typename: 'Sys', id: string } } | { __typename: 'ContactPerson', sys: { __typename: 'Sys', id: string } } | { __typename: 'Department', sys: { __typename: 'Sys', id: string } } | { __typename: 'DropCap', sys: { __typename: 'Sys', id: string } } | { __typename: 'EmphasizedArticle', sys: { __typename: 'Sys', id: string } } | { __typename: 'EventsPage', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'ExperienceBlock', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'ExperienceBlock_ExperienceBlockFragmentFragment': ExperienceBlock_ExperienceBlockFragmentFragment } }
      ) | { __typename: 'ExplicitValueFilter', sys: { __typename: 'Sys', id: string } } | { __typename: 'ExternalEvent', sys: { __typename: 'Sys', id: string } } | { __typename: 'ExternalPerson', sys: { __typename: 'Sys', id: string } } | { __typename: 'Faq', sys: { __typename: 'Sys', id: string } } | { __typename: 'FaqsModule', sys: { __typename: 'Sys', id: string } } | { __typename: 'Feature', sys: { __typename: 'Sys', id: string } } | { __typename: 'FinancialsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Footer', sys: { __typename: 'Sys', id: string } } | { __typename: 'Grant', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantActivityArticle', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantDetailsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantResources', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantSearchFilters', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantmakingArea', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantmakingAreaDetailsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'GrantmakingAreasPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'HeroAsset', sys: { __typename: 'Sys', id: string } } | { __typename: 'HistoryPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'HistoryPerson', sys: { __typename: 'Sys', id: string } } | { __typename: 'HomePage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Idea', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'InitiativeQuoteCallOut', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'InitiativeQuote_InitiativeQuoteCallOutFragmentFragment': InitiativeQuote_InitiativeQuoteCallOutFragmentFragment } }
      ) | { __typename: 'InlineCards', cardsCollection: { __typename: 'InlineCardsCardsCollection', items: Array<(
            { __typename: 'Article' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Article_Fragment': ContentGrid_EntryFragment_Article_Fragment } }
          ) | (
            { __typename: 'EmphasizedArticle' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_EmphasizedArticle_Fragment': ContentGrid_EntryFragment_EmphasizedArticle_Fragment } }
          ) | (
            { __typename: 'ExternalEvent' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_ExternalEvent_Fragment': ContentGrid_EntryFragment_ExternalEvent_Fragment } }
          ) | (
            { __typename: 'Feature' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Feature_Fragment': ContentGrid_EntryFragment_Feature_Fragment } }
          ) | (
            { __typename: 'GrantActivityArticle' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_GrantActivityArticle_Fragment': ContentGrid_EntryFragment_GrantActivityArticle_Fragment } }
          ) | (
            { __typename: 'GrantmakingAreaDetailsPage' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_GrantmakingAreaDetailsPage_Fragment': ContentGrid_EntryFragment_GrantmakingAreaDetailsPage_Fragment } }
          ) | (
            { __typename: 'Idea' }
            & { ' $fragmentRefs'?: { 'ContentGrid_EntryFragment_Idea_Fragment': ContentGrid_EntryFragment_Idea_Fragment } }
          ) | null> } | null, sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'InlineImages', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'InlineImages_InlineImagesFragmentFragment': InlineImages_InlineImagesFragmentFragment } }
      ) | { __typename: 'MainNavigation', sys: { __typename: 'Sys', id: string } } | { __typename: 'Metadata', sys: { __typename: 'Sys', id: string } } | { __typename: 'MissionPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Mmuf', sys: { __typename: 'Sys', id: string } } | { __typename: 'NavigationItem', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsletterCard', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsletterConfirmPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'NewsletterPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'OldAnnualReport', sys: { __typename: 'Sys', id: string } } | { __typename: 'Organisation', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'ParallaxImages', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'ParallaxImages_ParallaxImagesQueryFragment': ParallaxImages_ParallaxImagesQueryFragment } }
      ) | { __typename: 'PasswordProtectedPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'PeoplePage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Person', sys: { __typename: 'Sys', id: string } } | { __typename: 'PresidentialQuoteCallOut', sys: { __typename: 'Sys', id: string } } | { __typename: 'PressRoom', sys: { __typename: 'Sys', id: string } } | { __typename: 'PrivacyPolicy', sys: { __typename: 'Sys', id: string } } | { __typename: 'QuickLink', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'Quote', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'QuoteModule_QuoteFragmentFragment': QuoteModule_QuoteFragmentFragment } }
      ) | { __typename: 'RangeValueFilter', sys: { __typename: 'Sys', id: string } } | { __typename: 'ResourcesCurrentGrantees', sys: { __typename: 'Sys', id: string } } | { __typename: 'ResourcesProspectiveGrantees', sys: { __typename: 'Sys', id: string } } | { __typename: 'RootPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'SearchPage', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'SpotlightSlideshow', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'SpotlightSlideshow_SpotlightSlideshowFragmentFragment': SpotlightSlideshow_SpotlightSlideshowFragmentFragment } }
      ) | (
        { __typename: 'SpotlightVideo', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'SpotlightVideo_SpotlightVideoFragmentFragment': SpotlightVideo_SpotlightVideoFragmentFragment } }
      ) | { __typename: 'StoriesPage', sys: { __typename: 'Sys', id: string } } | { __typename: 'Taxonomy', sys: { __typename: 'Sys', id: string } } | { __typename: 'TermsOfUse', sys: { __typename: 'Sys', id: string } } | { __typename: 'Theme', sys: { __typename: 'Sys', id: string } } | { __typename: 'Trustee', sys: { __typename: 'Sys', id: string } } | { __typename: 'TrusteesPage', sys: { __typename: 'Sys', id: string } } | (
        { __typename: 'VideoNative', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'Video_VideoNativeFragmentFragment': Video_VideoNativeFragmentFragment } }
      ) | (
        { __typename: 'VideoYoutube', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'Video_VideoYoutubeFragmentFragment': Video_VideoYoutubeFragmentFragment } }
      ) | null> } } } & { ' $fragmentName'?: 'GrantmakingAreaDetailsPageBodyRichText_GrantmakingAreaDetailsPageBodyFragmentFragment' };

export type Socials_ContactFragmentFragment = { __typename: 'Contact', facebookLink: string | null, instagramLink: string | null, threadsLink: string | null, youtubeLink: string | null, linkedInLink: string | null } & { ' $fragmentName'?: 'Socials_ContactFragmentFragment' };

export type SpotlightSlideshow_SpotlightSlideshowFragmentFragment = { __typename: 'SpotlightSlideshow', headline: string | null, subheadline: string | null, imagesCollection: { __typename: 'AssetCollection', items: Array<(
      { __typename: 'Asset' }
      & { ' $fragmentRefs'?: { 'SpotlightSlideshowSlide_AssetFragmentFragment': SpotlightSlideshowSlide_AssetFragmentFragment } }
    ) | null> } | null } & { ' $fragmentName'?: 'SpotlightSlideshow_SpotlightSlideshowFragmentFragment' };

export type SpotlightSlideshowSlide_AssetFragmentFragment = (
  { __typename: 'Asset', description: string | null }
  & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
) & { ' $fragmentName'?: 'SpotlightSlideshowSlide_AssetFragmentFragment' };

export type SpotlightVideo_SpotlightVideoFragmentFragment = { __typename: 'SpotlightVideo', headline: string | null, subheadline: string | null, videoUrl: string | null, previewVideoUrl: string | null, ctaLabel: string | null, video: { __typename: 'Asset', src: string | null } | null, videoCaptions: { __typename: 'Asset', src: string | null } | null, previewVideo: { __typename: 'Asset', src: string | null } | null, previewStaticImage: (
    { __typename: 'Asset' }
    & { ' $fragmentRefs'?: { 'Image_AssetFragmentFragment': Image_AssetFragmentFragment } }
  ) | null } & { ' $fragmentName'?: 'SpotlightVideo_SpotlightVideoFragmentFragment' };

export type Video_VideoNativeFragmentFragment = { __typename: 'VideoNative', caption: string | null, isAmbient: boolean | null, isVertical: boolean | null, video: { __typename: 'Asset', url: string | null } | null, closedCaptions: { __typename: 'Asset', url: string | null } | null, preview: { __typename: 'Asset', url: string | null } | null } & { ' $fragmentName'?: 'Video_VideoNativeFragmentFragment' };

export type Video_VideoYoutubeFragmentFragment = { __typename: 'VideoYoutube', url: string | null, caption: string | null, preview: { __typename: 'Asset', url: string | null } | null } & { ' $fragmentName'?: 'Video_VideoYoutubeFragmentFragment' };

export type ArticleCta_ArticleFragmentFragment = { __typename: 'Article', type: string | null } & { ' $fragmentName'?: 'ArticleCta_ArticleFragmentFragment' };

type Cache_EntryFragment_AnnualReport_Fragment = { __typename: 'AnnualReport', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_AnnualReport_Fragment' };

type Cache_EntryFragment_Article_Fragment = { __typename: 'Article', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_Article_Fragment' };

type Cache_EntryFragment_AtGlanceCard_Fragment = { __typename: 'AtGlanceCard', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_AtGlanceCard_Fragment' };

type Cache_EntryFragment_CallForConcept_Fragment = { __typename: 'CallForConcept', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_CallForConcept_Fragment' };

type Cache_EntryFragment_ConnectWith_Fragment = { __typename: 'ConnectWith', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_ConnectWith_Fragment' };

type Cache_EntryFragment_ConnectWithLink_Fragment = { __typename: 'ConnectWithLink', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_ConnectWithLink_Fragment' };

type Cache_EntryFragment_Contact_Fragment = { __typename: 'Contact', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_Contact_Fragment' };

type Cache_EntryFragment_ContactPerson_Fragment = { __typename: 'ContactPerson', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_ContactPerson_Fragment' };

type Cache_EntryFragment_Department_Fragment = { __typename: 'Department', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_Department_Fragment' };

type Cache_EntryFragment_DropCap_Fragment = { __typename: 'DropCap', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_DropCap_Fragment' };

type Cache_EntryFragment_EmphasizedArticle_Fragment = { __typename: 'EmphasizedArticle', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_EmphasizedArticle_Fragment' };

type Cache_EntryFragment_EventsPage_Fragment = { __typename: 'EventsPage', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_EventsPage_Fragment' };

type Cache_EntryFragment_ExperienceBlock_Fragment = { __typename: 'ExperienceBlock', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_ExperienceBlock_Fragment' };

type Cache_EntryFragment_ExplicitValueFilter_Fragment = { __typename: 'ExplicitValueFilter', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_ExplicitValueFilter_Fragment' };

type Cache_EntryFragment_ExternalEvent_Fragment = { __typename: 'ExternalEvent', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_ExternalEvent_Fragment' };

type Cache_EntryFragment_ExternalPerson_Fragment = { __typename: 'ExternalPerson', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_ExternalPerson_Fragment' };

type Cache_EntryFragment_Faq_Fragment = { __typename: 'Faq', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_Faq_Fragment' };

type Cache_EntryFragment_FaqsModule_Fragment = { __typename: 'FaqsModule', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_FaqsModule_Fragment' };

type Cache_EntryFragment_Feature_Fragment = { __typename: 'Feature', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_Feature_Fragment' };

type Cache_EntryFragment_FinancialsPage_Fragment = { __typename: 'FinancialsPage', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_FinancialsPage_Fragment' };

type Cache_EntryFragment_Footer_Fragment = { __typename: 'Footer', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_Footer_Fragment' };

type Cache_EntryFragment_Grant_Fragment = { __typename: 'Grant', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_Grant_Fragment' };

type Cache_EntryFragment_GrantActivityArticle_Fragment = { __typename: 'GrantActivityArticle', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_GrantActivityArticle_Fragment' };

type Cache_EntryFragment_GrantDetailsPage_Fragment = { __typename: 'GrantDetailsPage', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_GrantDetailsPage_Fragment' };

type Cache_EntryFragment_GrantResources_Fragment = { __typename: 'GrantResources', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_GrantResources_Fragment' };

type Cache_EntryFragment_GrantSearchFilters_Fragment = { __typename: 'GrantSearchFilters', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_GrantSearchFilters_Fragment' };

type Cache_EntryFragment_GrantmakingArea_Fragment = { __typename: 'GrantmakingArea', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_GrantmakingArea_Fragment' };

type Cache_EntryFragment_GrantmakingAreaDetailsPage_Fragment = { __typename: 'GrantmakingAreaDetailsPage', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_GrantmakingAreaDetailsPage_Fragment' };

type Cache_EntryFragment_GrantmakingAreasPage_Fragment = { __typename: 'GrantmakingAreasPage', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_GrantmakingAreasPage_Fragment' };

type Cache_EntryFragment_HeroAsset_Fragment = { __typename: 'HeroAsset', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_HeroAsset_Fragment' };

type Cache_EntryFragment_HistoryPage_Fragment = { __typename: 'HistoryPage', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_HistoryPage_Fragment' };

type Cache_EntryFragment_HistoryPerson_Fragment = { __typename: 'HistoryPerson', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_HistoryPerson_Fragment' };

type Cache_EntryFragment_HomePage_Fragment = { __typename: 'HomePage', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_HomePage_Fragment' };

type Cache_EntryFragment_Idea_Fragment = { __typename: 'Idea', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_Idea_Fragment' };

type Cache_EntryFragment_InitiativeQuoteCallOut_Fragment = { __typename: 'InitiativeQuoteCallOut', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_InitiativeQuoteCallOut_Fragment' };

type Cache_EntryFragment_InlineCards_Fragment = { __typename: 'InlineCards', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_InlineCards_Fragment' };

type Cache_EntryFragment_InlineImages_Fragment = { __typename: 'InlineImages', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_InlineImages_Fragment' };

type Cache_EntryFragment_MainNavigation_Fragment = { __typename: 'MainNavigation', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_MainNavigation_Fragment' };

type Cache_EntryFragment_Metadata_Fragment = { __typename: 'Metadata', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_Metadata_Fragment' };

type Cache_EntryFragment_MissionPage_Fragment = { __typename: 'MissionPage', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_MissionPage_Fragment' };

type Cache_EntryFragment_Mmuf_Fragment = { __typename: 'Mmuf', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_Mmuf_Fragment' };

type Cache_EntryFragment_NavigationItem_Fragment = { __typename: 'NavigationItem', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_NavigationItem_Fragment' };

type Cache_EntryFragment_NewsPage_Fragment = { __typename: 'NewsPage', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_NewsPage_Fragment' };

type Cache_EntryFragment_NewsletterCard_Fragment = { __typename: 'NewsletterCard', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_NewsletterCard_Fragment' };

type Cache_EntryFragment_NewsletterConfirmPage_Fragment = { __typename: 'NewsletterConfirmPage', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_NewsletterConfirmPage_Fragment' };

type Cache_EntryFragment_NewsletterPage_Fragment = { __typename: 'NewsletterPage', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_NewsletterPage_Fragment' };

type Cache_EntryFragment_OldAnnualReport_Fragment = { __typename: 'OldAnnualReport', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_OldAnnualReport_Fragment' };

type Cache_EntryFragment_Organisation_Fragment = { __typename: 'Organisation', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_Organisation_Fragment' };

type Cache_EntryFragment_ParallaxImages_Fragment = { __typename: 'ParallaxImages', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_ParallaxImages_Fragment' };

type Cache_EntryFragment_PasswordProtectedPage_Fragment = { __typename: 'PasswordProtectedPage', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_PasswordProtectedPage_Fragment' };

type Cache_EntryFragment_PeoplePage_Fragment = { __typename: 'PeoplePage', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_PeoplePage_Fragment' };

type Cache_EntryFragment_Person_Fragment = { __typename: 'Person', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_Person_Fragment' };

type Cache_EntryFragment_PresidentialQuoteCallOut_Fragment = { __typename: 'PresidentialQuoteCallOut', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_PresidentialQuoteCallOut_Fragment' };

type Cache_EntryFragment_PressRoom_Fragment = { __typename: 'PressRoom', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_PressRoom_Fragment' };

type Cache_EntryFragment_PrivacyPolicy_Fragment = { __typename: 'PrivacyPolicy', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_PrivacyPolicy_Fragment' };

type Cache_EntryFragment_QuickLink_Fragment = { __typename: 'QuickLink', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_QuickLink_Fragment' };

type Cache_EntryFragment_Quote_Fragment = { __typename: 'Quote', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_Quote_Fragment' };

type Cache_EntryFragment_RangeValueFilter_Fragment = { __typename: 'RangeValueFilter', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_RangeValueFilter_Fragment' };

type Cache_EntryFragment_ResourcesCurrentGrantees_Fragment = { __typename: 'ResourcesCurrentGrantees', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_ResourcesCurrentGrantees_Fragment' };

type Cache_EntryFragment_ResourcesProspectiveGrantees_Fragment = { __typename: 'ResourcesProspectiveGrantees', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_ResourcesProspectiveGrantees_Fragment' };

type Cache_EntryFragment_RootPage_Fragment = { __typename: 'RootPage', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_RootPage_Fragment' };

type Cache_EntryFragment_SearchPage_Fragment = { __typename: 'SearchPage', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_SearchPage_Fragment' };

type Cache_EntryFragment_SpotlightSlideshow_Fragment = { __typename: 'SpotlightSlideshow', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_SpotlightSlideshow_Fragment' };

type Cache_EntryFragment_SpotlightVideo_Fragment = { __typename: 'SpotlightVideo', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_SpotlightVideo_Fragment' };

type Cache_EntryFragment_StoriesPage_Fragment = { __typename: 'StoriesPage', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_StoriesPage_Fragment' };

type Cache_EntryFragment_Taxonomy_Fragment = { __typename: 'Taxonomy', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_Taxonomy_Fragment' };

type Cache_EntryFragment_TermsOfUse_Fragment = { __typename: 'TermsOfUse', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_TermsOfUse_Fragment' };

type Cache_EntryFragment_Theme_Fragment = { __typename: 'Theme', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_Theme_Fragment' };

type Cache_EntryFragment_Trustee_Fragment = { __typename: 'Trustee', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_Trustee_Fragment' };

type Cache_EntryFragment_TrusteesPage_Fragment = { __typename: 'TrusteesPage', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_TrusteesPage_Fragment' };

type Cache_EntryFragment_VideoNative_Fragment = { __typename: 'VideoNative', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_VideoNative_Fragment' };

type Cache_EntryFragment_VideoYoutube_Fragment = { __typename: 'VideoYoutube', sys: { __typename: 'Sys', id: string } } & { ' $fragmentName'?: 'Cache_EntryFragment_VideoYoutube_Fragment' };

export type Cache_EntryFragmentFragment = Cache_EntryFragment_AnnualReport_Fragment | Cache_EntryFragment_Article_Fragment | Cache_EntryFragment_AtGlanceCard_Fragment | Cache_EntryFragment_CallForConcept_Fragment | Cache_EntryFragment_ConnectWith_Fragment | Cache_EntryFragment_ConnectWithLink_Fragment | Cache_EntryFragment_Contact_Fragment | Cache_EntryFragment_ContactPerson_Fragment | Cache_EntryFragment_Department_Fragment | Cache_EntryFragment_DropCap_Fragment | Cache_EntryFragment_EmphasizedArticle_Fragment | Cache_EntryFragment_EventsPage_Fragment | Cache_EntryFragment_ExperienceBlock_Fragment | Cache_EntryFragment_ExplicitValueFilter_Fragment | Cache_EntryFragment_ExternalEvent_Fragment | Cache_EntryFragment_ExternalPerson_Fragment | Cache_EntryFragment_Faq_Fragment | Cache_EntryFragment_FaqsModule_Fragment | Cache_EntryFragment_Feature_Fragment | Cache_EntryFragment_FinancialsPage_Fragment | Cache_EntryFragment_Footer_Fragment | Cache_EntryFragment_Grant_Fragment | Cache_EntryFragment_GrantActivityArticle_Fragment | Cache_EntryFragment_GrantDetailsPage_Fragment | Cache_EntryFragment_GrantResources_Fragment | Cache_EntryFragment_GrantSearchFilters_Fragment | Cache_EntryFragment_GrantmakingArea_Fragment | Cache_EntryFragment_GrantmakingAreaDetailsPage_Fragment | Cache_EntryFragment_GrantmakingAreasPage_Fragment | Cache_EntryFragment_HeroAsset_Fragment | Cache_EntryFragment_HistoryPage_Fragment | Cache_EntryFragment_HistoryPerson_Fragment | Cache_EntryFragment_HomePage_Fragment | Cache_EntryFragment_Idea_Fragment | Cache_EntryFragment_InitiativeQuoteCallOut_Fragment | Cache_EntryFragment_InlineCards_Fragment | Cache_EntryFragment_InlineImages_Fragment | Cache_EntryFragment_MainNavigation_Fragment | Cache_EntryFragment_Metadata_Fragment | Cache_EntryFragment_MissionPage_Fragment | Cache_EntryFragment_Mmuf_Fragment | Cache_EntryFragment_NavigationItem_Fragment | Cache_EntryFragment_NewsPage_Fragment | Cache_EntryFragment_NewsletterCard_Fragment | Cache_EntryFragment_NewsletterConfirmPage_Fragment | Cache_EntryFragment_NewsletterPage_Fragment | Cache_EntryFragment_OldAnnualReport_Fragment | Cache_EntryFragment_Organisation_Fragment | Cache_EntryFragment_ParallaxImages_Fragment | Cache_EntryFragment_PasswordProtectedPage_Fragment | Cache_EntryFragment_PeoplePage_Fragment | Cache_EntryFragment_Person_Fragment | Cache_EntryFragment_PresidentialQuoteCallOut_Fragment | Cache_EntryFragment_PressRoom_Fragment | Cache_EntryFragment_PrivacyPolicy_Fragment | Cache_EntryFragment_QuickLink_Fragment | Cache_EntryFragment_Quote_Fragment | Cache_EntryFragment_RangeValueFilter_Fragment | Cache_EntryFragment_ResourcesCurrentGrantees_Fragment | Cache_EntryFragment_ResourcesProspectiveGrantees_Fragment | Cache_EntryFragment_RootPage_Fragment | Cache_EntryFragment_SearchPage_Fragment | Cache_EntryFragment_SpotlightSlideshow_Fragment | Cache_EntryFragment_SpotlightVideo_Fragment | Cache_EntryFragment_StoriesPage_Fragment | Cache_EntryFragment_Taxonomy_Fragment | Cache_EntryFragment_TermsOfUse_Fragment | Cache_EntryFragment_Theme_Fragment | Cache_EntryFragment_Trustee_Fragment | Cache_EntryFragment_TrusteesPage_Fragment | Cache_EntryFragment_VideoNative_Fragment | Cache_EntryFragment_VideoYoutube_Fragment;

export type Filter_ExplicitValueFilterFragmentFragment = { __typename: 'ExplicitValueFilter', value: string | null } & { ' $fragmentName'?: 'Filter_ExplicitValueFilterFragmentFragment' };

export type Filter_RangeValueFilterFragmentFragment = { __typename: 'RangeValueFilter', gte: number | null, lte: number | null } & { ' $fragmentName'?: 'Filter_RangeValueFilterFragmentFragment' };

type Filter_EntryFragment_AnnualReport_Fragment = { __typename: 'AnnualReport' } & { ' $fragmentName'?: 'Filter_EntryFragment_AnnualReport_Fragment' };

type Filter_EntryFragment_Article_Fragment = { __typename: 'Article' } & { ' $fragmentName'?: 'Filter_EntryFragment_Article_Fragment' };

type Filter_EntryFragment_AtGlanceCard_Fragment = { __typename: 'AtGlanceCard' } & { ' $fragmentName'?: 'Filter_EntryFragment_AtGlanceCard_Fragment' };

type Filter_EntryFragment_CallForConcept_Fragment = { __typename: 'CallForConcept' } & { ' $fragmentName'?: 'Filter_EntryFragment_CallForConcept_Fragment' };

type Filter_EntryFragment_ConnectWith_Fragment = { __typename: 'ConnectWith' } & { ' $fragmentName'?: 'Filter_EntryFragment_ConnectWith_Fragment' };

type Filter_EntryFragment_ConnectWithLink_Fragment = { __typename: 'ConnectWithLink' } & { ' $fragmentName'?: 'Filter_EntryFragment_ConnectWithLink_Fragment' };

type Filter_EntryFragment_Contact_Fragment = { __typename: 'Contact' } & { ' $fragmentName'?: 'Filter_EntryFragment_Contact_Fragment' };

type Filter_EntryFragment_ContactPerson_Fragment = { __typename: 'ContactPerson' } & { ' $fragmentName'?: 'Filter_EntryFragment_ContactPerson_Fragment' };

type Filter_EntryFragment_Department_Fragment = { __typename: 'Department' } & { ' $fragmentName'?: 'Filter_EntryFragment_Department_Fragment' };

type Filter_EntryFragment_DropCap_Fragment = { __typename: 'DropCap' } & { ' $fragmentName'?: 'Filter_EntryFragment_DropCap_Fragment' };

type Filter_EntryFragment_EmphasizedArticle_Fragment = { __typename: 'EmphasizedArticle' } & { ' $fragmentName'?: 'Filter_EntryFragment_EmphasizedArticle_Fragment' };

type Filter_EntryFragment_EventsPage_Fragment = { __typename: 'EventsPage' } & { ' $fragmentName'?: 'Filter_EntryFragment_EventsPage_Fragment' };

type Filter_EntryFragment_ExperienceBlock_Fragment = { __typename: 'ExperienceBlock' } & { ' $fragmentName'?: 'Filter_EntryFragment_ExperienceBlock_Fragment' };

type Filter_EntryFragment_ExplicitValueFilter_Fragment = (
  { __typename: 'ExplicitValueFilter' }
  & { ' $fragmentRefs'?: { 'Filter_ExplicitValueFilterFragmentFragment': Filter_ExplicitValueFilterFragmentFragment } }
) & { ' $fragmentName'?: 'Filter_EntryFragment_ExplicitValueFilter_Fragment' };

type Filter_EntryFragment_ExternalEvent_Fragment = { __typename: 'ExternalEvent' } & { ' $fragmentName'?: 'Filter_EntryFragment_ExternalEvent_Fragment' };

type Filter_EntryFragment_ExternalPerson_Fragment = { __typename: 'ExternalPerson' } & { ' $fragmentName'?: 'Filter_EntryFragment_ExternalPerson_Fragment' };

type Filter_EntryFragment_Faq_Fragment = { __typename: 'Faq' } & { ' $fragmentName'?: 'Filter_EntryFragment_Faq_Fragment' };

type Filter_EntryFragment_FaqsModule_Fragment = { __typename: 'FaqsModule' } & { ' $fragmentName'?: 'Filter_EntryFragment_FaqsModule_Fragment' };

type Filter_EntryFragment_Feature_Fragment = { __typename: 'Feature' } & { ' $fragmentName'?: 'Filter_EntryFragment_Feature_Fragment' };

type Filter_EntryFragment_FinancialsPage_Fragment = { __typename: 'FinancialsPage' } & { ' $fragmentName'?: 'Filter_EntryFragment_FinancialsPage_Fragment' };

type Filter_EntryFragment_Footer_Fragment = { __typename: 'Footer' } & { ' $fragmentName'?: 'Filter_EntryFragment_Footer_Fragment' };

type Filter_EntryFragment_Grant_Fragment = { __typename: 'Grant' } & { ' $fragmentName'?: 'Filter_EntryFragment_Grant_Fragment' };

type Filter_EntryFragment_GrantActivityArticle_Fragment = { __typename: 'GrantActivityArticle' } & { ' $fragmentName'?: 'Filter_EntryFragment_GrantActivityArticle_Fragment' };

type Filter_EntryFragment_GrantDetailsPage_Fragment = { __typename: 'GrantDetailsPage' } & { ' $fragmentName'?: 'Filter_EntryFragment_GrantDetailsPage_Fragment' };

type Filter_EntryFragment_GrantResources_Fragment = { __typename: 'GrantResources' } & { ' $fragmentName'?: 'Filter_EntryFragment_GrantResources_Fragment' };

type Filter_EntryFragment_GrantSearchFilters_Fragment = { __typename: 'GrantSearchFilters' } & { ' $fragmentName'?: 'Filter_EntryFragment_GrantSearchFilters_Fragment' };

type Filter_EntryFragment_GrantmakingArea_Fragment = { __typename: 'GrantmakingArea' } & { ' $fragmentName'?: 'Filter_EntryFragment_GrantmakingArea_Fragment' };

type Filter_EntryFragment_GrantmakingAreaDetailsPage_Fragment = { __typename: 'GrantmakingAreaDetailsPage' } & { ' $fragmentName'?: 'Filter_EntryFragment_GrantmakingAreaDetailsPage_Fragment' };

type Filter_EntryFragment_GrantmakingAreasPage_Fragment = { __typename: 'GrantmakingAreasPage' } & { ' $fragmentName'?: 'Filter_EntryFragment_GrantmakingAreasPage_Fragment' };

type Filter_EntryFragment_HeroAsset_Fragment = { __typename: 'HeroAsset' } & { ' $fragmentName'?: 'Filter_EntryFragment_HeroAsset_Fragment' };

type Filter_EntryFragment_HistoryPage_Fragment = { __typename: 'HistoryPage' } & { ' $fragmentName'?: 'Filter_EntryFragment_HistoryPage_Fragment' };

type Filter_EntryFragment_HistoryPerson_Fragment = { __typename: 'HistoryPerson' } & { ' $fragmentName'?: 'Filter_EntryFragment_HistoryPerson_Fragment' };

type Filter_EntryFragment_HomePage_Fragment = { __typename: 'HomePage' } & { ' $fragmentName'?: 'Filter_EntryFragment_HomePage_Fragment' };

type Filter_EntryFragment_Idea_Fragment = { __typename: 'Idea' } & { ' $fragmentName'?: 'Filter_EntryFragment_Idea_Fragment' };

type Filter_EntryFragment_InitiativeQuoteCallOut_Fragment = { __typename: 'InitiativeQuoteCallOut' } & { ' $fragmentName'?: 'Filter_EntryFragment_InitiativeQuoteCallOut_Fragment' };

type Filter_EntryFragment_InlineCards_Fragment = { __typename: 'InlineCards' } & { ' $fragmentName'?: 'Filter_EntryFragment_InlineCards_Fragment' };

type Filter_EntryFragment_InlineImages_Fragment = { __typename: 'InlineImages' } & { ' $fragmentName'?: 'Filter_EntryFragment_InlineImages_Fragment' };

type Filter_EntryFragment_MainNavigation_Fragment = { __typename: 'MainNavigation' } & { ' $fragmentName'?: 'Filter_EntryFragment_MainNavigation_Fragment' };

type Filter_EntryFragment_Metadata_Fragment = { __typename: 'Metadata' } & { ' $fragmentName'?: 'Filter_EntryFragment_Metadata_Fragment' };

type Filter_EntryFragment_MissionPage_Fragment = { __typename: 'MissionPage' } & { ' $fragmentName'?: 'Filter_EntryFragment_MissionPage_Fragment' };

type Filter_EntryFragment_Mmuf_Fragment = { __typename: 'Mmuf' } & { ' $fragmentName'?: 'Filter_EntryFragment_Mmuf_Fragment' };

type Filter_EntryFragment_NavigationItem_Fragment = { __typename: 'NavigationItem' } & { ' $fragmentName'?: 'Filter_EntryFragment_NavigationItem_Fragment' };

type Filter_EntryFragment_NewsPage_Fragment = { __typename: 'NewsPage' } & { ' $fragmentName'?: 'Filter_EntryFragment_NewsPage_Fragment' };

type Filter_EntryFragment_NewsletterCard_Fragment = { __typename: 'NewsletterCard' } & { ' $fragmentName'?: 'Filter_EntryFragment_NewsletterCard_Fragment' };

type Filter_EntryFragment_NewsletterConfirmPage_Fragment = { __typename: 'NewsletterConfirmPage' } & { ' $fragmentName'?: 'Filter_EntryFragment_NewsletterConfirmPage_Fragment' };

type Filter_EntryFragment_NewsletterPage_Fragment = { __typename: 'NewsletterPage' } & { ' $fragmentName'?: 'Filter_EntryFragment_NewsletterPage_Fragment' };

type Filter_EntryFragment_OldAnnualReport_Fragment = { __typename: 'OldAnnualReport' } & { ' $fragmentName'?: 'Filter_EntryFragment_OldAnnualReport_Fragment' };

type Filter_EntryFragment_Organisation_Fragment = { __typename: 'Organisation' } & { ' $fragmentName'?: 'Filter_EntryFragment_Organisation_Fragment' };

type Filter_EntryFragment_ParallaxImages_Fragment = { __typename: 'ParallaxImages' } & { ' $fragmentName'?: 'Filter_EntryFragment_ParallaxImages_Fragment' };

type Filter_EntryFragment_PasswordProtectedPage_Fragment = { __typename: 'PasswordProtectedPage' } & { ' $fragmentName'?: 'Filter_EntryFragment_PasswordProtectedPage_Fragment' };

type Filter_EntryFragment_PeoplePage_Fragment = { __typename: 'PeoplePage' } & { ' $fragmentName'?: 'Filter_EntryFragment_PeoplePage_Fragment' };

type Filter_EntryFragment_Person_Fragment = { __typename: 'Person' } & { ' $fragmentName'?: 'Filter_EntryFragment_Person_Fragment' };

type Filter_EntryFragment_PresidentialQuoteCallOut_Fragment = { __typename: 'PresidentialQuoteCallOut' } & { ' $fragmentName'?: 'Filter_EntryFragment_PresidentialQuoteCallOut_Fragment' };

type Filter_EntryFragment_PressRoom_Fragment = { __typename: 'PressRoom' } & { ' $fragmentName'?: 'Filter_EntryFragment_PressRoom_Fragment' };

type Filter_EntryFragment_PrivacyPolicy_Fragment = { __typename: 'PrivacyPolicy' } & { ' $fragmentName'?: 'Filter_EntryFragment_PrivacyPolicy_Fragment' };

type Filter_EntryFragment_QuickLink_Fragment = { __typename: 'QuickLink' } & { ' $fragmentName'?: 'Filter_EntryFragment_QuickLink_Fragment' };

type Filter_EntryFragment_Quote_Fragment = { __typename: 'Quote' } & { ' $fragmentName'?: 'Filter_EntryFragment_Quote_Fragment' };

type Filter_EntryFragment_RangeValueFilter_Fragment = (
  { __typename: 'RangeValueFilter' }
  & { ' $fragmentRefs'?: { 'Filter_RangeValueFilterFragmentFragment': Filter_RangeValueFilterFragmentFragment } }
) & { ' $fragmentName'?: 'Filter_EntryFragment_RangeValueFilter_Fragment' };

type Filter_EntryFragment_ResourcesCurrentGrantees_Fragment = { __typename: 'ResourcesCurrentGrantees' } & { ' $fragmentName'?: 'Filter_EntryFragment_ResourcesCurrentGrantees_Fragment' };

type Filter_EntryFragment_ResourcesProspectiveGrantees_Fragment = { __typename: 'ResourcesProspectiveGrantees' } & { ' $fragmentName'?: 'Filter_EntryFragment_ResourcesProspectiveGrantees_Fragment' };

type Filter_EntryFragment_RootPage_Fragment = { __typename: 'RootPage' } & { ' $fragmentName'?: 'Filter_EntryFragment_RootPage_Fragment' };

type Filter_EntryFragment_SearchPage_Fragment = { __typename: 'SearchPage' } & { ' $fragmentName'?: 'Filter_EntryFragment_SearchPage_Fragment' };

type Filter_EntryFragment_SpotlightSlideshow_Fragment = { __typename: 'SpotlightSlideshow' } & { ' $fragmentName'?: 'Filter_EntryFragment_SpotlightSlideshow_Fragment' };

type Filter_EntryFragment_SpotlightVideo_Fragment = { __typename: 'SpotlightVideo' } & { ' $fragmentName'?: 'Filter_EntryFragment_SpotlightVideo_Fragment' };

type Filter_EntryFragment_StoriesPage_Fragment = { __typename: 'StoriesPage' } & { ' $fragmentName'?: 'Filter_EntryFragment_StoriesPage_Fragment' };

type Filter_EntryFragment_Taxonomy_Fragment = { __typename: 'Taxonomy' } & { ' $fragmentName'?: 'Filter_EntryFragment_Taxonomy_Fragment' };

type Filter_EntryFragment_TermsOfUse_Fragment = { __typename: 'TermsOfUse' } & { ' $fragmentName'?: 'Filter_EntryFragment_TermsOfUse_Fragment' };

type Filter_EntryFragment_Theme_Fragment = { __typename: 'Theme' } & { ' $fragmentName'?: 'Filter_EntryFragment_Theme_Fragment' };

type Filter_EntryFragment_Trustee_Fragment = { __typename: 'Trustee' } & { ' $fragmentName'?: 'Filter_EntryFragment_Trustee_Fragment' };

type Filter_EntryFragment_TrusteesPage_Fragment = { __typename: 'TrusteesPage' } & { ' $fragmentName'?: 'Filter_EntryFragment_TrusteesPage_Fragment' };

type Filter_EntryFragment_VideoNative_Fragment = { __typename: 'VideoNative' } & { ' $fragmentName'?: 'Filter_EntryFragment_VideoNative_Fragment' };

type Filter_EntryFragment_VideoYoutube_Fragment = { __typename: 'VideoYoutube' } & { ' $fragmentName'?: 'Filter_EntryFragment_VideoYoutube_Fragment' };

export type Filter_EntryFragmentFragment = Filter_EntryFragment_AnnualReport_Fragment | Filter_EntryFragment_Article_Fragment | Filter_EntryFragment_AtGlanceCard_Fragment | Filter_EntryFragment_CallForConcept_Fragment | Filter_EntryFragment_ConnectWith_Fragment | Filter_EntryFragment_ConnectWithLink_Fragment | Filter_EntryFragment_Contact_Fragment | Filter_EntryFragment_ContactPerson_Fragment | Filter_EntryFragment_Department_Fragment | Filter_EntryFragment_DropCap_Fragment | Filter_EntryFragment_EmphasizedArticle_Fragment | Filter_EntryFragment_EventsPage_Fragment | Filter_EntryFragment_ExperienceBlock_Fragment | Filter_EntryFragment_ExplicitValueFilter_Fragment | Filter_EntryFragment_ExternalEvent_Fragment | Filter_EntryFragment_ExternalPerson_Fragment | Filter_EntryFragment_Faq_Fragment | Filter_EntryFragment_FaqsModule_Fragment | Filter_EntryFragment_Feature_Fragment | Filter_EntryFragment_FinancialsPage_Fragment | Filter_EntryFragment_Footer_Fragment | Filter_EntryFragment_Grant_Fragment | Filter_EntryFragment_GrantActivityArticle_Fragment | Filter_EntryFragment_GrantDetailsPage_Fragment | Filter_EntryFragment_GrantResources_Fragment | Filter_EntryFragment_GrantSearchFilters_Fragment | Filter_EntryFragment_GrantmakingArea_Fragment | Filter_EntryFragment_GrantmakingAreaDetailsPage_Fragment | Filter_EntryFragment_GrantmakingAreasPage_Fragment | Filter_EntryFragment_HeroAsset_Fragment | Filter_EntryFragment_HistoryPage_Fragment | Filter_EntryFragment_HistoryPerson_Fragment | Filter_EntryFragment_HomePage_Fragment | Filter_EntryFragment_Idea_Fragment | Filter_EntryFragment_InitiativeQuoteCallOut_Fragment | Filter_EntryFragment_InlineCards_Fragment | Filter_EntryFragment_InlineImages_Fragment | Filter_EntryFragment_MainNavigation_Fragment | Filter_EntryFragment_Metadata_Fragment | Filter_EntryFragment_MissionPage_Fragment | Filter_EntryFragment_Mmuf_Fragment | Filter_EntryFragment_NavigationItem_Fragment | Filter_EntryFragment_NewsPage_Fragment | Filter_EntryFragment_NewsletterCard_Fragment | Filter_EntryFragment_NewsletterConfirmPage_Fragment | Filter_EntryFragment_NewsletterPage_Fragment | Filter_EntryFragment_OldAnnualReport_Fragment | Filter_EntryFragment_Organisation_Fragment | Filter_EntryFragment_ParallaxImages_Fragment | Filter_EntryFragment_PasswordProtectedPage_Fragment | Filter_EntryFragment_PeoplePage_Fragment | Filter_EntryFragment_Person_Fragment | Filter_EntryFragment_PresidentialQuoteCallOut_Fragment | Filter_EntryFragment_PressRoom_Fragment | Filter_EntryFragment_PrivacyPolicy_Fragment | Filter_EntryFragment_QuickLink_Fragment | Filter_EntryFragment_Quote_Fragment | Filter_EntryFragment_RangeValueFilter_Fragment | Filter_EntryFragment_ResourcesCurrentGrantees_Fragment | Filter_EntryFragment_ResourcesProspectiveGrantees_Fragment | Filter_EntryFragment_RootPage_Fragment | Filter_EntryFragment_SearchPage_Fragment | Filter_EntryFragment_SpotlightSlideshow_Fragment | Filter_EntryFragment_SpotlightVideo_Fragment | Filter_EntryFragment_StoriesPage_Fragment | Filter_EntryFragment_Taxonomy_Fragment | Filter_EntryFragment_TermsOfUse_Fragment | Filter_EntryFragment_Theme_Fragment | Filter_EntryFragment_Trustee_Fragment | Filter_EntryFragment_TrusteesPage_Fragment | Filter_EntryFragment_VideoNative_Fragment | Filter_EntryFragment_VideoYoutube_Fragment;

export type GrantTitle_GrantFragmentFragment = { __typename: 'Grant', id: string | null, referenceId: string | null, projectTitle: string | null, organization: { __typename: 'Organisation', name: string | null } | null } & { ' $fragmentName'?: 'GrantTitle_GrantFragmentFragment' };

export type GrantSlug_GrantFragmentFragment = (
  { __typename: 'Grant', id: string | null }
  & { ' $fragmentRefs'?: { 'GrantTitle_GrantFragmentFragment': GrantTitle_GrantFragmentFragment } }
) & { ' $fragmentName'?: 'GrantSlug_GrantFragmentFragment' };

type InternalLink_EntryFragment_AnnualReport_Fragment = { __typename: 'AnnualReport', year: string | null } & { ' $fragmentName'?: 'InternalLink_EntryFragment_AnnualReport_Fragment' };

type InternalLink_EntryFragment_Article_Fragment = { __typename: 'Article', slug: string | null, type: string | null, externalNewsUrl: string | null } & { ' $fragmentName'?: 'InternalLink_EntryFragment_Article_Fragment' };

type InternalLink_EntryFragment_AtGlanceCard_Fragment = { __typename: 'AtGlanceCard' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_AtGlanceCard_Fragment' };

type InternalLink_EntryFragment_CallForConcept_Fragment = { __typename: 'CallForConcept' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_CallForConcept_Fragment' };

type InternalLink_EntryFragment_ConnectWith_Fragment = { __typename: 'ConnectWith' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_ConnectWith_Fragment' };

type InternalLink_EntryFragment_ConnectWithLink_Fragment = { __typename: 'ConnectWithLink' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_ConnectWithLink_Fragment' };

type InternalLink_EntryFragment_Contact_Fragment = { __typename: 'Contact' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_Contact_Fragment' };

type InternalLink_EntryFragment_ContactPerson_Fragment = { __typename: 'ContactPerson' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_ContactPerson_Fragment' };

type InternalLink_EntryFragment_Department_Fragment = { __typename: 'Department', name: string | null } & { ' $fragmentName'?: 'InternalLink_EntryFragment_Department_Fragment' };

type InternalLink_EntryFragment_DropCap_Fragment = { __typename: 'DropCap' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_DropCap_Fragment' };

type InternalLink_EntryFragment_EmphasizedArticle_Fragment = { __typename: 'EmphasizedArticle' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_EmphasizedArticle_Fragment' };

type InternalLink_EntryFragment_EventsPage_Fragment = { __typename: 'EventsPage' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_EventsPage_Fragment' };

type InternalLink_EntryFragment_ExperienceBlock_Fragment = { __typename: 'ExperienceBlock' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_ExperienceBlock_Fragment' };

type InternalLink_EntryFragment_ExplicitValueFilter_Fragment = { __typename: 'ExplicitValueFilter' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_ExplicitValueFilter_Fragment' };

type InternalLink_EntryFragment_ExternalEvent_Fragment = { __typename: 'ExternalEvent' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_ExternalEvent_Fragment' };

type InternalLink_EntryFragment_ExternalPerson_Fragment = { __typename: 'ExternalPerson' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_ExternalPerson_Fragment' };

type InternalLink_EntryFragment_Faq_Fragment = { __typename: 'Faq' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_Faq_Fragment' };

type InternalLink_EntryFragment_FaqsModule_Fragment = { __typename: 'FaqsModule' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_FaqsModule_Fragment' };

type InternalLink_EntryFragment_Feature_Fragment = { __typename: 'Feature', slug: string | null } & { ' $fragmentName'?: 'InternalLink_EntryFragment_Feature_Fragment' };

type InternalLink_EntryFragment_FinancialsPage_Fragment = { __typename: 'FinancialsPage' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_FinancialsPage_Fragment' };

type InternalLink_EntryFragment_Footer_Fragment = { __typename: 'Footer' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_Footer_Fragment' };

type InternalLink_EntryFragment_Grant_Fragment = (
  { __typename: 'Grant' }
  & { ' $fragmentRefs'?: { 'GrantSlug_GrantFragmentFragment': GrantSlug_GrantFragmentFragment } }
) & { ' $fragmentName'?: 'InternalLink_EntryFragment_Grant_Fragment' };

type InternalLink_EntryFragment_GrantActivityArticle_Fragment = { __typename: 'GrantActivityArticle', slug: string | null } & { ' $fragmentName'?: 'InternalLink_EntryFragment_GrantActivityArticle_Fragment' };

type InternalLink_EntryFragment_GrantDetailsPage_Fragment = { __typename: 'GrantDetailsPage', grant: (
    { __typename: 'Grant' }
    & { ' $fragmentRefs'?: { 'GrantSlug_GrantFragmentFragment': GrantSlug_GrantFragmentFragment } }
  ) | null } & { ' $fragmentName'?: 'InternalLink_EntryFragment_GrantDetailsPage_Fragment' };

type InternalLink_EntryFragment_GrantResources_Fragment = { __typename: 'GrantResources' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_GrantResources_Fragment' };

type InternalLink_EntryFragment_GrantSearchFilters_Fragment = { __typename: 'GrantSearchFilters', slug: string | null } & { ' $fragmentName'?: 'InternalLink_EntryFragment_GrantSearchFilters_Fragment' };

type InternalLink_EntryFragment_GrantmakingArea_Fragment = { __typename: 'GrantmakingArea', name: string | null } & { ' $fragmentName'?: 'InternalLink_EntryFragment_GrantmakingArea_Fragment' };

type InternalLink_EntryFragment_GrantmakingAreaDetailsPage_Fragment = { __typename: 'GrantmakingAreaDetailsPage', slug: string | null } & { ' $fragmentName'?: 'InternalLink_EntryFragment_GrantmakingAreaDetailsPage_Fragment' };

type InternalLink_EntryFragment_GrantmakingAreasPage_Fragment = { __typename: 'GrantmakingAreasPage' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_GrantmakingAreasPage_Fragment' };

type InternalLink_EntryFragment_HeroAsset_Fragment = { __typename: 'HeroAsset' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_HeroAsset_Fragment' };

type InternalLink_EntryFragment_HistoryPage_Fragment = { __typename: 'HistoryPage' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_HistoryPage_Fragment' };

type InternalLink_EntryFragment_HistoryPerson_Fragment = { __typename: 'HistoryPerson', slug: string | null } & { ' $fragmentName'?: 'InternalLink_EntryFragment_HistoryPerson_Fragment' };

type InternalLink_EntryFragment_HomePage_Fragment = { __typename: 'HomePage' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_HomePage_Fragment' };

type InternalLink_EntryFragment_Idea_Fragment = { __typename: 'Idea', slug: string | null } & { ' $fragmentName'?: 'InternalLink_EntryFragment_Idea_Fragment' };

type InternalLink_EntryFragment_InitiativeQuoteCallOut_Fragment = { __typename: 'InitiativeQuoteCallOut' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_InitiativeQuoteCallOut_Fragment' };

type InternalLink_EntryFragment_InlineCards_Fragment = { __typename: 'InlineCards' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_InlineCards_Fragment' };

type InternalLink_EntryFragment_InlineImages_Fragment = { __typename: 'InlineImages' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_InlineImages_Fragment' };

type InternalLink_EntryFragment_MainNavigation_Fragment = { __typename: 'MainNavigation' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_MainNavigation_Fragment' };

type InternalLink_EntryFragment_Metadata_Fragment = { __typename: 'Metadata' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_Metadata_Fragment' };

type InternalLink_EntryFragment_MissionPage_Fragment = { __typename: 'MissionPage' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_MissionPage_Fragment' };

type InternalLink_EntryFragment_Mmuf_Fragment = { __typename: 'Mmuf' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_Mmuf_Fragment' };

type InternalLink_EntryFragment_NavigationItem_Fragment = { __typename: 'NavigationItem' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_NavigationItem_Fragment' };

type InternalLink_EntryFragment_NewsPage_Fragment = { __typename: 'NewsPage' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_NewsPage_Fragment' };

type InternalLink_EntryFragment_NewsletterCard_Fragment = { __typename: 'NewsletterCard' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_NewsletterCard_Fragment' };

type InternalLink_EntryFragment_NewsletterConfirmPage_Fragment = { __typename: 'NewsletterConfirmPage' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_NewsletterConfirmPage_Fragment' };

type InternalLink_EntryFragment_NewsletterPage_Fragment = { __typename: 'NewsletterPage', slug: string | null } & { ' $fragmentName'?: 'InternalLink_EntryFragment_NewsletterPage_Fragment' };

type InternalLink_EntryFragment_OldAnnualReport_Fragment = { __typename: 'OldAnnualReport', report: { __typename: 'Asset', url: string | null } | null } & { ' $fragmentName'?: 'InternalLink_EntryFragment_OldAnnualReport_Fragment' };

type InternalLink_EntryFragment_Organisation_Fragment = { __typename: 'Organisation' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_Organisation_Fragment' };

type InternalLink_EntryFragment_ParallaxImages_Fragment = { __typename: 'ParallaxImages' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_ParallaxImages_Fragment' };

type InternalLink_EntryFragment_PasswordProtectedPage_Fragment = { __typename: 'PasswordProtectedPage' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_PasswordProtectedPage_Fragment' };

type InternalLink_EntryFragment_PeoplePage_Fragment = { __typename: 'PeoplePage' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_PeoplePage_Fragment' };

type InternalLink_EntryFragment_Person_Fragment = { __typename: 'Person', slug: string | null } & { ' $fragmentName'?: 'InternalLink_EntryFragment_Person_Fragment' };

type InternalLink_EntryFragment_PresidentialQuoteCallOut_Fragment = { __typename: 'PresidentialQuoteCallOut' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_PresidentialQuoteCallOut_Fragment' };

type InternalLink_EntryFragment_PressRoom_Fragment = { __typename: 'PressRoom' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_PressRoom_Fragment' };

type InternalLink_EntryFragment_PrivacyPolicy_Fragment = { __typename: 'PrivacyPolicy' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_PrivacyPolicy_Fragment' };

type InternalLink_EntryFragment_QuickLink_Fragment = { __typename: 'QuickLink' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_QuickLink_Fragment' };

type InternalLink_EntryFragment_Quote_Fragment = { __typename: 'Quote' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_Quote_Fragment' };

type InternalLink_EntryFragment_RangeValueFilter_Fragment = { __typename: 'RangeValueFilter' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_RangeValueFilter_Fragment' };

type InternalLink_EntryFragment_ResourcesCurrentGrantees_Fragment = { __typename: 'ResourcesCurrentGrantees' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_ResourcesCurrentGrantees_Fragment' };

type InternalLink_EntryFragment_ResourcesProspectiveGrantees_Fragment = { __typename: 'ResourcesProspectiveGrantees' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_ResourcesProspectiveGrantees_Fragment' };

type InternalLink_EntryFragment_RootPage_Fragment = { __typename: 'RootPage', slug: string | null } & { ' $fragmentName'?: 'InternalLink_EntryFragment_RootPage_Fragment' };

type InternalLink_EntryFragment_SearchPage_Fragment = { __typename: 'SearchPage' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_SearchPage_Fragment' };

type InternalLink_EntryFragment_SpotlightSlideshow_Fragment = { __typename: 'SpotlightSlideshow' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_SpotlightSlideshow_Fragment' };

type InternalLink_EntryFragment_SpotlightVideo_Fragment = { __typename: 'SpotlightVideo' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_SpotlightVideo_Fragment' };

type InternalLink_EntryFragment_StoriesPage_Fragment = { __typename: 'StoriesPage' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_StoriesPage_Fragment' };

type InternalLink_EntryFragment_Taxonomy_Fragment = { __typename: 'Taxonomy' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_Taxonomy_Fragment' };

type InternalLink_EntryFragment_TermsOfUse_Fragment = { __typename: 'TermsOfUse' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_TermsOfUse_Fragment' };

type InternalLink_EntryFragment_Theme_Fragment = { __typename: 'Theme' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_Theme_Fragment' };

type InternalLink_EntryFragment_Trustee_Fragment = { __typename: 'Trustee' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_Trustee_Fragment' };

type InternalLink_EntryFragment_TrusteesPage_Fragment = { __typename: 'TrusteesPage' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_TrusteesPage_Fragment' };

type InternalLink_EntryFragment_VideoNative_Fragment = { __typename: 'VideoNative' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_VideoNative_Fragment' };

type InternalLink_EntryFragment_VideoYoutube_Fragment = { __typename: 'VideoYoutube' } & { ' $fragmentName'?: 'InternalLink_EntryFragment_VideoYoutube_Fragment' };

export type InternalLink_EntryFragmentFragment = InternalLink_EntryFragment_AnnualReport_Fragment | InternalLink_EntryFragment_Article_Fragment | InternalLink_EntryFragment_AtGlanceCard_Fragment | InternalLink_EntryFragment_CallForConcept_Fragment | InternalLink_EntryFragment_ConnectWith_Fragment | InternalLink_EntryFragment_ConnectWithLink_Fragment | InternalLink_EntryFragment_Contact_Fragment | InternalLink_EntryFragment_ContactPerson_Fragment | InternalLink_EntryFragment_Department_Fragment | InternalLink_EntryFragment_DropCap_Fragment | InternalLink_EntryFragment_EmphasizedArticle_Fragment | InternalLink_EntryFragment_EventsPage_Fragment | InternalLink_EntryFragment_ExperienceBlock_Fragment | InternalLink_EntryFragment_ExplicitValueFilter_Fragment | InternalLink_EntryFragment_ExternalEvent_Fragment | InternalLink_EntryFragment_ExternalPerson_Fragment | InternalLink_EntryFragment_Faq_Fragment | InternalLink_EntryFragment_FaqsModule_Fragment | InternalLink_EntryFragment_Feature_Fragment | InternalLink_EntryFragment_FinancialsPage_Fragment | InternalLink_EntryFragment_Footer_Fragment | InternalLink_EntryFragment_Grant_Fragment | InternalLink_EntryFragment_GrantActivityArticle_Fragment | InternalLink_EntryFragment_GrantDetailsPage_Fragment | InternalLink_EntryFragment_GrantResources_Fragment | InternalLink_EntryFragment_GrantSearchFilters_Fragment | InternalLink_EntryFragment_GrantmakingArea_Fragment | InternalLink_EntryFragment_GrantmakingAreaDetailsPage_Fragment | InternalLink_EntryFragment_GrantmakingAreasPage_Fragment | InternalLink_EntryFragment_HeroAsset_Fragment | InternalLink_EntryFragment_HistoryPage_Fragment | InternalLink_EntryFragment_HistoryPerson_Fragment | InternalLink_EntryFragment_HomePage_Fragment | InternalLink_EntryFragment_Idea_Fragment | InternalLink_EntryFragment_InitiativeQuoteCallOut_Fragment | InternalLink_EntryFragment_InlineCards_Fragment | InternalLink_EntryFragment_InlineImages_Fragment | InternalLink_EntryFragment_MainNavigation_Fragment | InternalLink_EntryFragment_Metadata_Fragment | InternalLink_EntryFragment_MissionPage_Fragment | InternalLink_EntryFragment_Mmuf_Fragment | InternalLink_EntryFragment_NavigationItem_Fragment | InternalLink_EntryFragment_NewsPage_Fragment | InternalLink_EntryFragment_NewsletterCard_Fragment | InternalLink_EntryFragment_NewsletterConfirmPage_Fragment | InternalLink_EntryFragment_NewsletterPage_Fragment | InternalLink_EntryFragment_OldAnnualReport_Fragment | InternalLink_EntryFragment_Organisation_Fragment | InternalLink_EntryFragment_ParallaxImages_Fragment | InternalLink_EntryFragment_PasswordProtectedPage_Fragment | InternalLink_EntryFragment_PeoplePage_Fragment | InternalLink_EntryFragment_Person_Fragment | InternalLink_EntryFragment_PresidentialQuoteCallOut_Fragment | InternalLink_EntryFragment_PressRoom_Fragment | InternalLink_EntryFragment_PrivacyPolicy_Fragment | InternalLink_EntryFragment_QuickLink_Fragment | InternalLink_EntryFragment_Quote_Fragment | InternalLink_EntryFragment_RangeValueFilter_Fragment | InternalLink_EntryFragment_ResourcesCurrentGrantees_Fragment | InternalLink_EntryFragment_ResourcesProspectiveGrantees_Fragment | InternalLink_EntryFragment_RootPage_Fragment | InternalLink_EntryFragment_SearchPage_Fragment | InternalLink_EntryFragment_SpotlightSlideshow_Fragment | InternalLink_EntryFragment_SpotlightVideo_Fragment | InternalLink_EntryFragment_StoriesPage_Fragment | InternalLink_EntryFragment_Taxonomy_Fragment | InternalLink_EntryFragment_TermsOfUse_Fragment | InternalLink_EntryFragment_Theme_Fragment | InternalLink_EntryFragment_Trustee_Fragment | InternalLink_EntryFragment_TrusteesPage_Fragment | InternalLink_EntryFragment_VideoNative_Fragment | InternalLink_EntryFragment_VideoYoutube_Fragment;

type Localization_EntryFragment_AnnualReport_Fragment = (
  { __typename: 'AnnualReport', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_AnnualReport_Fragment': Cache_EntryFragment_AnnualReport_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_AnnualReport_Fragment' };

type Localization_EntryFragment_Article_Fragment = (
  { __typename: 'Article', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_Article_Fragment': Cache_EntryFragment_Article_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_Article_Fragment' };

type Localization_EntryFragment_AtGlanceCard_Fragment = (
  { __typename: 'AtGlanceCard', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_AtGlanceCard_Fragment': Cache_EntryFragment_AtGlanceCard_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_AtGlanceCard_Fragment' };

type Localization_EntryFragment_CallForConcept_Fragment = (
  { __typename: 'CallForConcept', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_CallForConcept_Fragment': Cache_EntryFragment_CallForConcept_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_CallForConcept_Fragment' };

type Localization_EntryFragment_ConnectWith_Fragment = (
  { __typename: 'ConnectWith', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_ConnectWith_Fragment': Cache_EntryFragment_ConnectWith_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_ConnectWith_Fragment' };

type Localization_EntryFragment_ConnectWithLink_Fragment = (
  { __typename: 'ConnectWithLink', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_ConnectWithLink_Fragment': Cache_EntryFragment_ConnectWithLink_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_ConnectWithLink_Fragment' };

type Localization_EntryFragment_Contact_Fragment = (
  { __typename: 'Contact', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_Contact_Fragment': Cache_EntryFragment_Contact_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_Contact_Fragment' };

type Localization_EntryFragment_ContactPerson_Fragment = (
  { __typename: 'ContactPerson', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_ContactPerson_Fragment': Cache_EntryFragment_ContactPerson_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_ContactPerson_Fragment' };

type Localization_EntryFragment_Department_Fragment = (
  { __typename: 'Department', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_Department_Fragment': Cache_EntryFragment_Department_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_Department_Fragment' };

type Localization_EntryFragment_DropCap_Fragment = (
  { __typename: 'DropCap', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_DropCap_Fragment': Cache_EntryFragment_DropCap_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_DropCap_Fragment' };

type Localization_EntryFragment_EmphasizedArticle_Fragment = (
  { __typename: 'EmphasizedArticle', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_EmphasizedArticle_Fragment': Cache_EntryFragment_EmphasizedArticle_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_EmphasizedArticle_Fragment' };

type Localization_EntryFragment_EventsPage_Fragment = (
  { __typename: 'EventsPage', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_EventsPage_Fragment': Cache_EntryFragment_EventsPage_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_EventsPage_Fragment' };

type Localization_EntryFragment_ExperienceBlock_Fragment = (
  { __typename: 'ExperienceBlock', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_ExperienceBlock_Fragment': Cache_EntryFragment_ExperienceBlock_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_ExperienceBlock_Fragment' };

type Localization_EntryFragment_ExplicitValueFilter_Fragment = (
  { __typename: 'ExplicitValueFilter', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_ExplicitValueFilter_Fragment': Cache_EntryFragment_ExplicitValueFilter_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_ExplicitValueFilter_Fragment' };

type Localization_EntryFragment_ExternalEvent_Fragment = (
  { __typename: 'ExternalEvent', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_ExternalEvent_Fragment': Cache_EntryFragment_ExternalEvent_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_ExternalEvent_Fragment' };

type Localization_EntryFragment_ExternalPerson_Fragment = (
  { __typename: 'ExternalPerson', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_ExternalPerson_Fragment': Cache_EntryFragment_ExternalPerson_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_ExternalPerson_Fragment' };

type Localization_EntryFragment_Faq_Fragment = (
  { __typename: 'Faq', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_Faq_Fragment': Cache_EntryFragment_Faq_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_Faq_Fragment' };

type Localization_EntryFragment_FaqsModule_Fragment = (
  { __typename: 'FaqsModule', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_FaqsModule_Fragment': Cache_EntryFragment_FaqsModule_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_FaqsModule_Fragment' };

type Localization_EntryFragment_Feature_Fragment = (
  { __typename: 'Feature', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_Feature_Fragment': Cache_EntryFragment_Feature_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_Feature_Fragment' };

type Localization_EntryFragment_FinancialsPage_Fragment = (
  { __typename: 'FinancialsPage', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_FinancialsPage_Fragment': Cache_EntryFragment_FinancialsPage_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_FinancialsPage_Fragment' };

type Localization_EntryFragment_Footer_Fragment = (
  { __typename: 'Footer', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_Footer_Fragment': Cache_EntryFragment_Footer_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_Footer_Fragment' };

type Localization_EntryFragment_Grant_Fragment = (
  { __typename: 'Grant', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_Grant_Fragment': Cache_EntryFragment_Grant_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_Grant_Fragment' };

type Localization_EntryFragment_GrantActivityArticle_Fragment = (
  { __typename: 'GrantActivityArticle', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_GrantActivityArticle_Fragment': Cache_EntryFragment_GrantActivityArticle_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_GrantActivityArticle_Fragment' };

type Localization_EntryFragment_GrantDetailsPage_Fragment = (
  { __typename: 'GrantDetailsPage', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_GrantDetailsPage_Fragment': Cache_EntryFragment_GrantDetailsPage_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_GrantDetailsPage_Fragment' };

type Localization_EntryFragment_GrantResources_Fragment = (
  { __typename: 'GrantResources', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_GrantResources_Fragment': Cache_EntryFragment_GrantResources_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_GrantResources_Fragment' };

type Localization_EntryFragment_GrantSearchFilters_Fragment = (
  { __typename: 'GrantSearchFilters', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_GrantSearchFilters_Fragment': Cache_EntryFragment_GrantSearchFilters_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_GrantSearchFilters_Fragment' };

type Localization_EntryFragment_GrantmakingArea_Fragment = (
  { __typename: 'GrantmakingArea', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_GrantmakingArea_Fragment': Cache_EntryFragment_GrantmakingArea_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_GrantmakingArea_Fragment' };

type Localization_EntryFragment_GrantmakingAreaDetailsPage_Fragment = (
  { __typename: 'GrantmakingAreaDetailsPage', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_GrantmakingAreaDetailsPage_Fragment': Cache_EntryFragment_GrantmakingAreaDetailsPage_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_GrantmakingAreaDetailsPage_Fragment' };

type Localization_EntryFragment_GrantmakingAreasPage_Fragment = (
  { __typename: 'GrantmakingAreasPage', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_GrantmakingAreasPage_Fragment': Cache_EntryFragment_GrantmakingAreasPage_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_GrantmakingAreasPage_Fragment' };

type Localization_EntryFragment_HeroAsset_Fragment = (
  { __typename: 'HeroAsset', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_HeroAsset_Fragment': Cache_EntryFragment_HeroAsset_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_HeroAsset_Fragment' };

type Localization_EntryFragment_HistoryPage_Fragment = (
  { __typename: 'HistoryPage', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_HistoryPage_Fragment': Cache_EntryFragment_HistoryPage_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_HistoryPage_Fragment' };

type Localization_EntryFragment_HistoryPerson_Fragment = (
  { __typename: 'HistoryPerson', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_HistoryPerson_Fragment': Cache_EntryFragment_HistoryPerson_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_HistoryPerson_Fragment' };

type Localization_EntryFragment_HomePage_Fragment = (
  { __typename: 'HomePage', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_HomePage_Fragment': Cache_EntryFragment_HomePage_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_HomePage_Fragment' };

type Localization_EntryFragment_Idea_Fragment = (
  { __typename: 'Idea', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_Idea_Fragment': Cache_EntryFragment_Idea_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_Idea_Fragment' };

type Localization_EntryFragment_InitiativeQuoteCallOut_Fragment = (
  { __typename: 'InitiativeQuoteCallOut', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_InitiativeQuoteCallOut_Fragment': Cache_EntryFragment_InitiativeQuoteCallOut_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_InitiativeQuoteCallOut_Fragment' };

type Localization_EntryFragment_InlineCards_Fragment = (
  { __typename: 'InlineCards', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_InlineCards_Fragment': Cache_EntryFragment_InlineCards_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_InlineCards_Fragment' };

type Localization_EntryFragment_InlineImages_Fragment = (
  { __typename: 'InlineImages', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_InlineImages_Fragment': Cache_EntryFragment_InlineImages_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_InlineImages_Fragment' };

type Localization_EntryFragment_MainNavigation_Fragment = (
  { __typename: 'MainNavigation', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_MainNavigation_Fragment': Cache_EntryFragment_MainNavigation_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_MainNavigation_Fragment' };

type Localization_EntryFragment_Metadata_Fragment = (
  { __typename: 'Metadata', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_Metadata_Fragment': Cache_EntryFragment_Metadata_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_Metadata_Fragment' };

type Localization_EntryFragment_MissionPage_Fragment = (
  { __typename: 'MissionPage', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_MissionPage_Fragment': Cache_EntryFragment_MissionPage_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_MissionPage_Fragment' };

type Localization_EntryFragment_Mmuf_Fragment = (
  { __typename: 'Mmuf', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_Mmuf_Fragment': Cache_EntryFragment_Mmuf_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_Mmuf_Fragment' };

type Localization_EntryFragment_NavigationItem_Fragment = (
  { __typename: 'NavigationItem', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_NavigationItem_Fragment': Cache_EntryFragment_NavigationItem_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_NavigationItem_Fragment' };

type Localization_EntryFragment_NewsPage_Fragment = (
  { __typename: 'NewsPage', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_NewsPage_Fragment': Cache_EntryFragment_NewsPage_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_NewsPage_Fragment' };

type Localization_EntryFragment_NewsletterCard_Fragment = (
  { __typename: 'NewsletterCard', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_NewsletterCard_Fragment': Cache_EntryFragment_NewsletterCard_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_NewsletterCard_Fragment' };

type Localization_EntryFragment_NewsletterConfirmPage_Fragment = (
  { __typename: 'NewsletterConfirmPage', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_NewsletterConfirmPage_Fragment': Cache_EntryFragment_NewsletterConfirmPage_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_NewsletterConfirmPage_Fragment' };

type Localization_EntryFragment_NewsletterPage_Fragment = (
  { __typename: 'NewsletterPage', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_NewsletterPage_Fragment': Cache_EntryFragment_NewsletterPage_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_NewsletterPage_Fragment' };

type Localization_EntryFragment_OldAnnualReport_Fragment = (
  { __typename: 'OldAnnualReport', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_OldAnnualReport_Fragment': Cache_EntryFragment_OldAnnualReport_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_OldAnnualReport_Fragment' };

type Localization_EntryFragment_Organisation_Fragment = (
  { __typename: 'Organisation', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_Organisation_Fragment': Cache_EntryFragment_Organisation_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_Organisation_Fragment' };

type Localization_EntryFragment_ParallaxImages_Fragment = (
  { __typename: 'ParallaxImages', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_ParallaxImages_Fragment': Cache_EntryFragment_ParallaxImages_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_ParallaxImages_Fragment' };

type Localization_EntryFragment_PasswordProtectedPage_Fragment = (
  { __typename: 'PasswordProtectedPage', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_PasswordProtectedPage_Fragment': Cache_EntryFragment_PasswordProtectedPage_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_PasswordProtectedPage_Fragment' };

type Localization_EntryFragment_PeoplePage_Fragment = (
  { __typename: 'PeoplePage', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_PeoplePage_Fragment': Cache_EntryFragment_PeoplePage_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_PeoplePage_Fragment' };

type Localization_EntryFragment_Person_Fragment = (
  { __typename: 'Person', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_Person_Fragment': Cache_EntryFragment_Person_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_Person_Fragment' };

type Localization_EntryFragment_PresidentialQuoteCallOut_Fragment = (
  { __typename: 'PresidentialQuoteCallOut', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_PresidentialQuoteCallOut_Fragment': Cache_EntryFragment_PresidentialQuoteCallOut_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_PresidentialQuoteCallOut_Fragment' };

type Localization_EntryFragment_PressRoom_Fragment = (
  { __typename: 'PressRoom', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_PressRoom_Fragment': Cache_EntryFragment_PressRoom_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_PressRoom_Fragment' };

type Localization_EntryFragment_PrivacyPolicy_Fragment = (
  { __typename: 'PrivacyPolicy', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_PrivacyPolicy_Fragment': Cache_EntryFragment_PrivacyPolicy_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_PrivacyPolicy_Fragment' };

type Localization_EntryFragment_QuickLink_Fragment = (
  { __typename: 'QuickLink', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_QuickLink_Fragment': Cache_EntryFragment_QuickLink_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_QuickLink_Fragment' };

type Localization_EntryFragment_Quote_Fragment = (
  { __typename: 'Quote', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_Quote_Fragment': Cache_EntryFragment_Quote_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_Quote_Fragment' };

type Localization_EntryFragment_RangeValueFilter_Fragment = (
  { __typename: 'RangeValueFilter', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_RangeValueFilter_Fragment': Cache_EntryFragment_RangeValueFilter_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_RangeValueFilter_Fragment' };

type Localization_EntryFragment_ResourcesCurrentGrantees_Fragment = (
  { __typename: 'ResourcesCurrentGrantees', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_ResourcesCurrentGrantees_Fragment': Cache_EntryFragment_ResourcesCurrentGrantees_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_ResourcesCurrentGrantees_Fragment' };

type Localization_EntryFragment_ResourcesProspectiveGrantees_Fragment = (
  { __typename: 'ResourcesProspectiveGrantees', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_ResourcesProspectiveGrantees_Fragment': Cache_EntryFragment_ResourcesProspectiveGrantees_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_ResourcesProspectiveGrantees_Fragment' };

type Localization_EntryFragment_RootPage_Fragment = (
  { __typename: 'RootPage', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_RootPage_Fragment': Cache_EntryFragment_RootPage_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_RootPage_Fragment' };

type Localization_EntryFragment_SearchPage_Fragment = (
  { __typename: 'SearchPage', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_SearchPage_Fragment': Cache_EntryFragment_SearchPage_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_SearchPage_Fragment' };

type Localization_EntryFragment_SpotlightSlideshow_Fragment = (
  { __typename: 'SpotlightSlideshow', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_SpotlightSlideshow_Fragment': Cache_EntryFragment_SpotlightSlideshow_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_SpotlightSlideshow_Fragment' };

type Localization_EntryFragment_SpotlightVideo_Fragment = (
  { __typename: 'SpotlightVideo', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_SpotlightVideo_Fragment': Cache_EntryFragment_SpotlightVideo_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_SpotlightVideo_Fragment' };

type Localization_EntryFragment_StoriesPage_Fragment = (
  { __typename: 'StoriesPage', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_StoriesPage_Fragment': Cache_EntryFragment_StoriesPage_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_StoriesPage_Fragment' };

type Localization_EntryFragment_Taxonomy_Fragment = (
  { __typename: 'Taxonomy', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_Taxonomy_Fragment': Cache_EntryFragment_Taxonomy_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_Taxonomy_Fragment' };

type Localization_EntryFragment_TermsOfUse_Fragment = (
  { __typename: 'TermsOfUse', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_TermsOfUse_Fragment': Cache_EntryFragment_TermsOfUse_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_TermsOfUse_Fragment' };

type Localization_EntryFragment_Theme_Fragment = (
  { __typename: 'Theme', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_Theme_Fragment': Cache_EntryFragment_Theme_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_Theme_Fragment' };

type Localization_EntryFragment_Trustee_Fragment = (
  { __typename: 'Trustee', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_Trustee_Fragment': Cache_EntryFragment_Trustee_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_Trustee_Fragment' };

type Localization_EntryFragment_TrusteesPage_Fragment = (
  { __typename: 'TrusteesPage', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_TrusteesPage_Fragment': Cache_EntryFragment_TrusteesPage_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_TrusteesPage_Fragment' };

type Localization_EntryFragment_VideoNative_Fragment = (
  { __typename: 'VideoNative', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_VideoNative_Fragment': Cache_EntryFragment_VideoNative_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_VideoNative_Fragment' };

type Localization_EntryFragment_VideoYoutube_Fragment = (
  { __typename: 'VideoYoutube', sys: { __typename: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'Cache_EntryFragment_VideoYoutube_Fragment': Cache_EntryFragment_VideoYoutube_Fragment } }
) & { ' $fragmentName'?: 'Localization_EntryFragment_VideoYoutube_Fragment' };

export type Localization_EntryFragmentFragment = Localization_EntryFragment_AnnualReport_Fragment | Localization_EntryFragment_Article_Fragment | Localization_EntryFragment_AtGlanceCard_Fragment | Localization_EntryFragment_CallForConcept_Fragment | Localization_EntryFragment_ConnectWith_Fragment | Localization_EntryFragment_ConnectWithLink_Fragment | Localization_EntryFragment_Contact_Fragment | Localization_EntryFragment_ContactPerson_Fragment | Localization_EntryFragment_Department_Fragment | Localization_EntryFragment_DropCap_Fragment | Localization_EntryFragment_EmphasizedArticle_Fragment | Localization_EntryFragment_EventsPage_Fragment | Localization_EntryFragment_ExperienceBlock_Fragment | Localization_EntryFragment_ExplicitValueFilter_Fragment | Localization_EntryFragment_ExternalEvent_Fragment | Localization_EntryFragment_ExternalPerson_Fragment | Localization_EntryFragment_Faq_Fragment | Localization_EntryFragment_FaqsModule_Fragment | Localization_EntryFragment_Feature_Fragment | Localization_EntryFragment_FinancialsPage_Fragment | Localization_EntryFragment_Footer_Fragment | Localization_EntryFragment_Grant_Fragment | Localization_EntryFragment_GrantActivityArticle_Fragment | Localization_EntryFragment_GrantDetailsPage_Fragment | Localization_EntryFragment_GrantResources_Fragment | Localization_EntryFragment_GrantSearchFilters_Fragment | Localization_EntryFragment_GrantmakingArea_Fragment | Localization_EntryFragment_GrantmakingAreaDetailsPage_Fragment | Localization_EntryFragment_GrantmakingAreasPage_Fragment | Localization_EntryFragment_HeroAsset_Fragment | Localization_EntryFragment_HistoryPage_Fragment | Localization_EntryFragment_HistoryPerson_Fragment | Localization_EntryFragment_HomePage_Fragment | Localization_EntryFragment_Idea_Fragment | Localization_EntryFragment_InitiativeQuoteCallOut_Fragment | Localization_EntryFragment_InlineCards_Fragment | Localization_EntryFragment_InlineImages_Fragment | Localization_EntryFragment_MainNavigation_Fragment | Localization_EntryFragment_Metadata_Fragment | Localization_EntryFragment_MissionPage_Fragment | Localization_EntryFragment_Mmuf_Fragment | Localization_EntryFragment_NavigationItem_Fragment | Localization_EntryFragment_NewsPage_Fragment | Localization_EntryFragment_NewsletterCard_Fragment | Localization_EntryFragment_NewsletterConfirmPage_Fragment | Localization_EntryFragment_NewsletterPage_Fragment | Localization_EntryFragment_OldAnnualReport_Fragment | Localization_EntryFragment_Organisation_Fragment | Localization_EntryFragment_ParallaxImages_Fragment | Localization_EntryFragment_PasswordProtectedPage_Fragment | Localization_EntryFragment_PeoplePage_Fragment | Localization_EntryFragment_Person_Fragment | Localization_EntryFragment_PresidentialQuoteCallOut_Fragment | Localization_EntryFragment_PressRoom_Fragment | Localization_EntryFragment_PrivacyPolicy_Fragment | Localization_EntryFragment_QuickLink_Fragment | Localization_EntryFragment_Quote_Fragment | Localization_EntryFragment_RangeValueFilter_Fragment | Localization_EntryFragment_ResourcesCurrentGrantees_Fragment | Localization_EntryFragment_ResourcesProspectiveGrantees_Fragment | Localization_EntryFragment_RootPage_Fragment | Localization_EntryFragment_SearchPage_Fragment | Localization_EntryFragment_SpotlightSlideshow_Fragment | Localization_EntryFragment_SpotlightVideo_Fragment | Localization_EntryFragment_StoriesPage_Fragment | Localization_EntryFragment_Taxonomy_Fragment | Localization_EntryFragment_TermsOfUse_Fragment | Localization_EntryFragment_Theme_Fragment | Localization_EntryFragment_Trustee_Fragment | Localization_EntryFragment_TrusteesPage_Fragment | Localization_EntryFragment_VideoNative_Fragment | Localization_EntryFragment_VideoYoutube_Fragment;

type LocalizationMetadata_EntryFragment_AnnualReport_Fragment = (
  { __typename: 'AnnualReport' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_AnnualReport_Fragment': InternalLink_EntryFragment_AnnualReport_Fragment;'Localization_EntryFragment_AnnualReport_Fragment': Localization_EntryFragment_AnnualReport_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_AnnualReport_Fragment' };

type LocalizationMetadata_EntryFragment_Article_Fragment = (
  { __typename: 'Article' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Article_Fragment': InternalLink_EntryFragment_Article_Fragment;'Localization_EntryFragment_Article_Fragment': Localization_EntryFragment_Article_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_Article_Fragment' };

type LocalizationMetadata_EntryFragment_AtGlanceCard_Fragment = (
  { __typename: 'AtGlanceCard' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_AtGlanceCard_Fragment': InternalLink_EntryFragment_AtGlanceCard_Fragment;'Localization_EntryFragment_AtGlanceCard_Fragment': Localization_EntryFragment_AtGlanceCard_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_AtGlanceCard_Fragment' };

type LocalizationMetadata_EntryFragment_CallForConcept_Fragment = (
  { __typename: 'CallForConcept' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_CallForConcept_Fragment': InternalLink_EntryFragment_CallForConcept_Fragment;'Localization_EntryFragment_CallForConcept_Fragment': Localization_EntryFragment_CallForConcept_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_CallForConcept_Fragment' };

type LocalizationMetadata_EntryFragment_ConnectWith_Fragment = (
  { __typename: 'ConnectWith' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_ConnectWith_Fragment': InternalLink_EntryFragment_ConnectWith_Fragment;'Localization_EntryFragment_ConnectWith_Fragment': Localization_EntryFragment_ConnectWith_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_ConnectWith_Fragment' };

type LocalizationMetadata_EntryFragment_ConnectWithLink_Fragment = (
  { __typename: 'ConnectWithLink' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_ConnectWithLink_Fragment': InternalLink_EntryFragment_ConnectWithLink_Fragment;'Localization_EntryFragment_ConnectWithLink_Fragment': Localization_EntryFragment_ConnectWithLink_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_ConnectWithLink_Fragment' };

type LocalizationMetadata_EntryFragment_Contact_Fragment = (
  { __typename: 'Contact' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Contact_Fragment': InternalLink_EntryFragment_Contact_Fragment;'Localization_EntryFragment_Contact_Fragment': Localization_EntryFragment_Contact_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_Contact_Fragment' };

type LocalizationMetadata_EntryFragment_ContactPerson_Fragment = (
  { __typename: 'ContactPerson' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_ContactPerson_Fragment': InternalLink_EntryFragment_ContactPerson_Fragment;'Localization_EntryFragment_ContactPerson_Fragment': Localization_EntryFragment_ContactPerson_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_ContactPerson_Fragment' };

type LocalizationMetadata_EntryFragment_Department_Fragment = (
  { __typename: 'Department' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Department_Fragment': InternalLink_EntryFragment_Department_Fragment;'Localization_EntryFragment_Department_Fragment': Localization_EntryFragment_Department_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_Department_Fragment' };

type LocalizationMetadata_EntryFragment_DropCap_Fragment = (
  { __typename: 'DropCap' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_DropCap_Fragment': InternalLink_EntryFragment_DropCap_Fragment;'Localization_EntryFragment_DropCap_Fragment': Localization_EntryFragment_DropCap_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_DropCap_Fragment' };

type LocalizationMetadata_EntryFragment_EmphasizedArticle_Fragment = (
  { __typename: 'EmphasizedArticle' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_EmphasizedArticle_Fragment': InternalLink_EntryFragment_EmphasizedArticle_Fragment;'Localization_EntryFragment_EmphasizedArticle_Fragment': Localization_EntryFragment_EmphasizedArticle_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_EmphasizedArticle_Fragment' };

type LocalizationMetadata_EntryFragment_EventsPage_Fragment = (
  { __typename: 'EventsPage' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_EventsPage_Fragment': InternalLink_EntryFragment_EventsPage_Fragment;'Localization_EntryFragment_EventsPage_Fragment': Localization_EntryFragment_EventsPage_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_EventsPage_Fragment' };

type LocalizationMetadata_EntryFragment_ExperienceBlock_Fragment = (
  { __typename: 'ExperienceBlock' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_ExperienceBlock_Fragment': InternalLink_EntryFragment_ExperienceBlock_Fragment;'Localization_EntryFragment_ExperienceBlock_Fragment': Localization_EntryFragment_ExperienceBlock_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_ExperienceBlock_Fragment' };

type LocalizationMetadata_EntryFragment_ExplicitValueFilter_Fragment = (
  { __typename: 'ExplicitValueFilter' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_ExplicitValueFilter_Fragment': InternalLink_EntryFragment_ExplicitValueFilter_Fragment;'Localization_EntryFragment_ExplicitValueFilter_Fragment': Localization_EntryFragment_ExplicitValueFilter_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_ExplicitValueFilter_Fragment' };

type LocalizationMetadata_EntryFragment_ExternalEvent_Fragment = (
  { __typename: 'ExternalEvent' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_ExternalEvent_Fragment': InternalLink_EntryFragment_ExternalEvent_Fragment;'Localization_EntryFragment_ExternalEvent_Fragment': Localization_EntryFragment_ExternalEvent_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_ExternalEvent_Fragment' };

type LocalizationMetadata_EntryFragment_ExternalPerson_Fragment = (
  { __typename: 'ExternalPerson' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_ExternalPerson_Fragment': InternalLink_EntryFragment_ExternalPerson_Fragment;'Localization_EntryFragment_ExternalPerson_Fragment': Localization_EntryFragment_ExternalPerson_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_ExternalPerson_Fragment' };

type LocalizationMetadata_EntryFragment_Faq_Fragment = (
  { __typename: 'Faq' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Faq_Fragment': InternalLink_EntryFragment_Faq_Fragment;'Localization_EntryFragment_Faq_Fragment': Localization_EntryFragment_Faq_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_Faq_Fragment' };

type LocalizationMetadata_EntryFragment_FaqsModule_Fragment = (
  { __typename: 'FaqsModule' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_FaqsModule_Fragment': InternalLink_EntryFragment_FaqsModule_Fragment;'Localization_EntryFragment_FaqsModule_Fragment': Localization_EntryFragment_FaqsModule_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_FaqsModule_Fragment' };

type LocalizationMetadata_EntryFragment_Feature_Fragment = (
  { __typename: 'Feature' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Feature_Fragment': InternalLink_EntryFragment_Feature_Fragment;'Localization_EntryFragment_Feature_Fragment': Localization_EntryFragment_Feature_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_Feature_Fragment' };

type LocalizationMetadata_EntryFragment_FinancialsPage_Fragment = (
  { __typename: 'FinancialsPage' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_FinancialsPage_Fragment': InternalLink_EntryFragment_FinancialsPage_Fragment;'Localization_EntryFragment_FinancialsPage_Fragment': Localization_EntryFragment_FinancialsPage_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_FinancialsPage_Fragment' };

type LocalizationMetadata_EntryFragment_Footer_Fragment = (
  { __typename: 'Footer' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Footer_Fragment': InternalLink_EntryFragment_Footer_Fragment;'Localization_EntryFragment_Footer_Fragment': Localization_EntryFragment_Footer_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_Footer_Fragment' };

type LocalizationMetadata_EntryFragment_Grant_Fragment = (
  { __typename: 'Grant' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Grant_Fragment': InternalLink_EntryFragment_Grant_Fragment;'Localization_EntryFragment_Grant_Fragment': Localization_EntryFragment_Grant_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_Grant_Fragment' };

type LocalizationMetadata_EntryFragment_GrantActivityArticle_Fragment = (
  { __typename: 'GrantActivityArticle' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_GrantActivityArticle_Fragment': InternalLink_EntryFragment_GrantActivityArticle_Fragment;'Localization_EntryFragment_GrantActivityArticle_Fragment': Localization_EntryFragment_GrantActivityArticle_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_GrantActivityArticle_Fragment' };

type LocalizationMetadata_EntryFragment_GrantDetailsPage_Fragment = (
  { __typename: 'GrantDetailsPage' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_GrantDetailsPage_Fragment': InternalLink_EntryFragment_GrantDetailsPage_Fragment;'Localization_EntryFragment_GrantDetailsPage_Fragment': Localization_EntryFragment_GrantDetailsPage_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_GrantDetailsPage_Fragment' };

type LocalizationMetadata_EntryFragment_GrantResources_Fragment = (
  { __typename: 'GrantResources' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_GrantResources_Fragment': InternalLink_EntryFragment_GrantResources_Fragment;'Localization_EntryFragment_GrantResources_Fragment': Localization_EntryFragment_GrantResources_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_GrantResources_Fragment' };

type LocalizationMetadata_EntryFragment_GrantSearchFilters_Fragment = (
  { __typename: 'GrantSearchFilters' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_GrantSearchFilters_Fragment': InternalLink_EntryFragment_GrantSearchFilters_Fragment;'Localization_EntryFragment_GrantSearchFilters_Fragment': Localization_EntryFragment_GrantSearchFilters_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_GrantSearchFilters_Fragment' };

type LocalizationMetadata_EntryFragment_GrantmakingArea_Fragment = (
  { __typename: 'GrantmakingArea' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_GrantmakingArea_Fragment': InternalLink_EntryFragment_GrantmakingArea_Fragment;'Localization_EntryFragment_GrantmakingArea_Fragment': Localization_EntryFragment_GrantmakingArea_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_GrantmakingArea_Fragment' };

type LocalizationMetadata_EntryFragment_GrantmakingAreaDetailsPage_Fragment = (
  { __typename: 'GrantmakingAreaDetailsPage' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_GrantmakingAreaDetailsPage_Fragment': InternalLink_EntryFragment_GrantmakingAreaDetailsPage_Fragment;'Localization_EntryFragment_GrantmakingAreaDetailsPage_Fragment': Localization_EntryFragment_GrantmakingAreaDetailsPage_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_GrantmakingAreaDetailsPage_Fragment' };

type LocalizationMetadata_EntryFragment_GrantmakingAreasPage_Fragment = (
  { __typename: 'GrantmakingAreasPage' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_GrantmakingAreasPage_Fragment': InternalLink_EntryFragment_GrantmakingAreasPage_Fragment;'Localization_EntryFragment_GrantmakingAreasPage_Fragment': Localization_EntryFragment_GrantmakingAreasPage_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_GrantmakingAreasPage_Fragment' };

type LocalizationMetadata_EntryFragment_HeroAsset_Fragment = (
  { __typename: 'HeroAsset' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_HeroAsset_Fragment': InternalLink_EntryFragment_HeroAsset_Fragment;'Localization_EntryFragment_HeroAsset_Fragment': Localization_EntryFragment_HeroAsset_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_HeroAsset_Fragment' };

type LocalizationMetadata_EntryFragment_HistoryPage_Fragment = (
  { __typename: 'HistoryPage' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_HistoryPage_Fragment': InternalLink_EntryFragment_HistoryPage_Fragment;'Localization_EntryFragment_HistoryPage_Fragment': Localization_EntryFragment_HistoryPage_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_HistoryPage_Fragment' };

type LocalizationMetadata_EntryFragment_HistoryPerson_Fragment = (
  { __typename: 'HistoryPerson' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_HistoryPerson_Fragment': InternalLink_EntryFragment_HistoryPerson_Fragment;'Localization_EntryFragment_HistoryPerson_Fragment': Localization_EntryFragment_HistoryPerson_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_HistoryPerson_Fragment' };

type LocalizationMetadata_EntryFragment_HomePage_Fragment = (
  { __typename: 'HomePage' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_HomePage_Fragment': InternalLink_EntryFragment_HomePage_Fragment;'Localization_EntryFragment_HomePage_Fragment': Localization_EntryFragment_HomePage_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_HomePage_Fragment' };

type LocalizationMetadata_EntryFragment_Idea_Fragment = (
  { __typename: 'Idea' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Idea_Fragment': InternalLink_EntryFragment_Idea_Fragment;'Localization_EntryFragment_Idea_Fragment': Localization_EntryFragment_Idea_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_Idea_Fragment' };

type LocalizationMetadata_EntryFragment_InitiativeQuoteCallOut_Fragment = (
  { __typename: 'InitiativeQuoteCallOut' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_InitiativeQuoteCallOut_Fragment': InternalLink_EntryFragment_InitiativeQuoteCallOut_Fragment;'Localization_EntryFragment_InitiativeQuoteCallOut_Fragment': Localization_EntryFragment_InitiativeQuoteCallOut_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_InitiativeQuoteCallOut_Fragment' };

type LocalizationMetadata_EntryFragment_InlineCards_Fragment = (
  { __typename: 'InlineCards' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_InlineCards_Fragment': InternalLink_EntryFragment_InlineCards_Fragment;'Localization_EntryFragment_InlineCards_Fragment': Localization_EntryFragment_InlineCards_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_InlineCards_Fragment' };

type LocalizationMetadata_EntryFragment_InlineImages_Fragment = (
  { __typename: 'InlineImages' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_InlineImages_Fragment': InternalLink_EntryFragment_InlineImages_Fragment;'Localization_EntryFragment_InlineImages_Fragment': Localization_EntryFragment_InlineImages_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_InlineImages_Fragment' };

type LocalizationMetadata_EntryFragment_MainNavigation_Fragment = (
  { __typename: 'MainNavigation' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_MainNavigation_Fragment': InternalLink_EntryFragment_MainNavigation_Fragment;'Localization_EntryFragment_MainNavigation_Fragment': Localization_EntryFragment_MainNavigation_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_MainNavigation_Fragment' };

type LocalizationMetadata_EntryFragment_Metadata_Fragment = (
  { __typename: 'Metadata' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Metadata_Fragment': InternalLink_EntryFragment_Metadata_Fragment;'Localization_EntryFragment_Metadata_Fragment': Localization_EntryFragment_Metadata_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_Metadata_Fragment' };

type LocalizationMetadata_EntryFragment_MissionPage_Fragment = (
  { __typename: 'MissionPage' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_MissionPage_Fragment': InternalLink_EntryFragment_MissionPage_Fragment;'Localization_EntryFragment_MissionPage_Fragment': Localization_EntryFragment_MissionPage_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_MissionPage_Fragment' };

type LocalizationMetadata_EntryFragment_Mmuf_Fragment = (
  { __typename: 'Mmuf' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Mmuf_Fragment': InternalLink_EntryFragment_Mmuf_Fragment;'Localization_EntryFragment_Mmuf_Fragment': Localization_EntryFragment_Mmuf_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_Mmuf_Fragment' };

type LocalizationMetadata_EntryFragment_NavigationItem_Fragment = (
  { __typename: 'NavigationItem' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_NavigationItem_Fragment': InternalLink_EntryFragment_NavigationItem_Fragment;'Localization_EntryFragment_NavigationItem_Fragment': Localization_EntryFragment_NavigationItem_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_NavigationItem_Fragment' };

type LocalizationMetadata_EntryFragment_NewsPage_Fragment = (
  { __typename: 'NewsPage' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_NewsPage_Fragment': InternalLink_EntryFragment_NewsPage_Fragment;'Localization_EntryFragment_NewsPage_Fragment': Localization_EntryFragment_NewsPage_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_NewsPage_Fragment' };

type LocalizationMetadata_EntryFragment_NewsletterCard_Fragment = (
  { __typename: 'NewsletterCard' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_NewsletterCard_Fragment': InternalLink_EntryFragment_NewsletterCard_Fragment;'Localization_EntryFragment_NewsletterCard_Fragment': Localization_EntryFragment_NewsletterCard_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_NewsletterCard_Fragment' };

type LocalizationMetadata_EntryFragment_NewsletterConfirmPage_Fragment = (
  { __typename: 'NewsletterConfirmPage' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_NewsletterConfirmPage_Fragment': InternalLink_EntryFragment_NewsletterConfirmPage_Fragment;'Localization_EntryFragment_NewsletterConfirmPage_Fragment': Localization_EntryFragment_NewsletterConfirmPage_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_NewsletterConfirmPage_Fragment' };

type LocalizationMetadata_EntryFragment_NewsletterPage_Fragment = (
  { __typename: 'NewsletterPage' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_NewsletterPage_Fragment': InternalLink_EntryFragment_NewsletterPage_Fragment;'Localization_EntryFragment_NewsletterPage_Fragment': Localization_EntryFragment_NewsletterPage_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_NewsletterPage_Fragment' };

type LocalizationMetadata_EntryFragment_OldAnnualReport_Fragment = (
  { __typename: 'OldAnnualReport' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_OldAnnualReport_Fragment': InternalLink_EntryFragment_OldAnnualReport_Fragment;'Localization_EntryFragment_OldAnnualReport_Fragment': Localization_EntryFragment_OldAnnualReport_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_OldAnnualReport_Fragment' };

type LocalizationMetadata_EntryFragment_Organisation_Fragment = (
  { __typename: 'Organisation' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Organisation_Fragment': InternalLink_EntryFragment_Organisation_Fragment;'Localization_EntryFragment_Organisation_Fragment': Localization_EntryFragment_Organisation_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_Organisation_Fragment' };

type LocalizationMetadata_EntryFragment_ParallaxImages_Fragment = (
  { __typename: 'ParallaxImages' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_ParallaxImages_Fragment': InternalLink_EntryFragment_ParallaxImages_Fragment;'Localization_EntryFragment_ParallaxImages_Fragment': Localization_EntryFragment_ParallaxImages_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_ParallaxImages_Fragment' };

type LocalizationMetadata_EntryFragment_PasswordProtectedPage_Fragment = (
  { __typename: 'PasswordProtectedPage' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_PasswordProtectedPage_Fragment': InternalLink_EntryFragment_PasswordProtectedPage_Fragment;'Localization_EntryFragment_PasswordProtectedPage_Fragment': Localization_EntryFragment_PasswordProtectedPage_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_PasswordProtectedPage_Fragment' };

type LocalizationMetadata_EntryFragment_PeoplePage_Fragment = (
  { __typename: 'PeoplePage' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_PeoplePage_Fragment': InternalLink_EntryFragment_PeoplePage_Fragment;'Localization_EntryFragment_PeoplePage_Fragment': Localization_EntryFragment_PeoplePage_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_PeoplePage_Fragment' };

type LocalizationMetadata_EntryFragment_Person_Fragment = (
  { __typename: 'Person' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Person_Fragment': InternalLink_EntryFragment_Person_Fragment;'Localization_EntryFragment_Person_Fragment': Localization_EntryFragment_Person_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_Person_Fragment' };

type LocalizationMetadata_EntryFragment_PresidentialQuoteCallOut_Fragment = (
  { __typename: 'PresidentialQuoteCallOut' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_PresidentialQuoteCallOut_Fragment': InternalLink_EntryFragment_PresidentialQuoteCallOut_Fragment;'Localization_EntryFragment_PresidentialQuoteCallOut_Fragment': Localization_EntryFragment_PresidentialQuoteCallOut_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_PresidentialQuoteCallOut_Fragment' };

type LocalizationMetadata_EntryFragment_PressRoom_Fragment = (
  { __typename: 'PressRoom' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_PressRoom_Fragment': InternalLink_EntryFragment_PressRoom_Fragment;'Localization_EntryFragment_PressRoom_Fragment': Localization_EntryFragment_PressRoom_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_PressRoom_Fragment' };

type LocalizationMetadata_EntryFragment_PrivacyPolicy_Fragment = (
  { __typename: 'PrivacyPolicy' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_PrivacyPolicy_Fragment': InternalLink_EntryFragment_PrivacyPolicy_Fragment;'Localization_EntryFragment_PrivacyPolicy_Fragment': Localization_EntryFragment_PrivacyPolicy_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_PrivacyPolicy_Fragment' };

type LocalizationMetadata_EntryFragment_QuickLink_Fragment = (
  { __typename: 'QuickLink' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_QuickLink_Fragment': InternalLink_EntryFragment_QuickLink_Fragment;'Localization_EntryFragment_QuickLink_Fragment': Localization_EntryFragment_QuickLink_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_QuickLink_Fragment' };

type LocalizationMetadata_EntryFragment_Quote_Fragment = (
  { __typename: 'Quote' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Quote_Fragment': InternalLink_EntryFragment_Quote_Fragment;'Localization_EntryFragment_Quote_Fragment': Localization_EntryFragment_Quote_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_Quote_Fragment' };

type LocalizationMetadata_EntryFragment_RangeValueFilter_Fragment = (
  { __typename: 'RangeValueFilter' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_RangeValueFilter_Fragment': InternalLink_EntryFragment_RangeValueFilter_Fragment;'Localization_EntryFragment_RangeValueFilter_Fragment': Localization_EntryFragment_RangeValueFilter_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_RangeValueFilter_Fragment' };

type LocalizationMetadata_EntryFragment_ResourcesCurrentGrantees_Fragment = (
  { __typename: 'ResourcesCurrentGrantees' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_ResourcesCurrentGrantees_Fragment': InternalLink_EntryFragment_ResourcesCurrentGrantees_Fragment;'Localization_EntryFragment_ResourcesCurrentGrantees_Fragment': Localization_EntryFragment_ResourcesCurrentGrantees_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_ResourcesCurrentGrantees_Fragment' };

type LocalizationMetadata_EntryFragment_ResourcesProspectiveGrantees_Fragment = (
  { __typename: 'ResourcesProspectiveGrantees' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_ResourcesProspectiveGrantees_Fragment': InternalLink_EntryFragment_ResourcesProspectiveGrantees_Fragment;'Localization_EntryFragment_ResourcesProspectiveGrantees_Fragment': Localization_EntryFragment_ResourcesProspectiveGrantees_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_ResourcesProspectiveGrantees_Fragment' };

type LocalizationMetadata_EntryFragment_RootPage_Fragment = (
  { __typename: 'RootPage' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_RootPage_Fragment': InternalLink_EntryFragment_RootPage_Fragment;'Localization_EntryFragment_RootPage_Fragment': Localization_EntryFragment_RootPage_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_RootPage_Fragment' };

type LocalizationMetadata_EntryFragment_SearchPage_Fragment = (
  { __typename: 'SearchPage' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_SearchPage_Fragment': InternalLink_EntryFragment_SearchPage_Fragment;'Localization_EntryFragment_SearchPage_Fragment': Localization_EntryFragment_SearchPage_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_SearchPage_Fragment' };

type LocalizationMetadata_EntryFragment_SpotlightSlideshow_Fragment = (
  { __typename: 'SpotlightSlideshow' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_SpotlightSlideshow_Fragment': InternalLink_EntryFragment_SpotlightSlideshow_Fragment;'Localization_EntryFragment_SpotlightSlideshow_Fragment': Localization_EntryFragment_SpotlightSlideshow_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_SpotlightSlideshow_Fragment' };

type LocalizationMetadata_EntryFragment_SpotlightVideo_Fragment = (
  { __typename: 'SpotlightVideo' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_SpotlightVideo_Fragment': InternalLink_EntryFragment_SpotlightVideo_Fragment;'Localization_EntryFragment_SpotlightVideo_Fragment': Localization_EntryFragment_SpotlightVideo_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_SpotlightVideo_Fragment' };

type LocalizationMetadata_EntryFragment_StoriesPage_Fragment = (
  { __typename: 'StoriesPage' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_StoriesPage_Fragment': InternalLink_EntryFragment_StoriesPage_Fragment;'Localization_EntryFragment_StoriesPage_Fragment': Localization_EntryFragment_StoriesPage_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_StoriesPage_Fragment' };

type LocalizationMetadata_EntryFragment_Taxonomy_Fragment = (
  { __typename: 'Taxonomy' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Taxonomy_Fragment': InternalLink_EntryFragment_Taxonomy_Fragment;'Localization_EntryFragment_Taxonomy_Fragment': Localization_EntryFragment_Taxonomy_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_Taxonomy_Fragment' };

type LocalizationMetadata_EntryFragment_TermsOfUse_Fragment = (
  { __typename: 'TermsOfUse' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_TermsOfUse_Fragment': InternalLink_EntryFragment_TermsOfUse_Fragment;'Localization_EntryFragment_TermsOfUse_Fragment': Localization_EntryFragment_TermsOfUse_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_TermsOfUse_Fragment' };

type LocalizationMetadata_EntryFragment_Theme_Fragment = (
  { __typename: 'Theme' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Theme_Fragment': InternalLink_EntryFragment_Theme_Fragment;'Localization_EntryFragment_Theme_Fragment': Localization_EntryFragment_Theme_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_Theme_Fragment' };

type LocalizationMetadata_EntryFragment_Trustee_Fragment = (
  { __typename: 'Trustee' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_Trustee_Fragment': InternalLink_EntryFragment_Trustee_Fragment;'Localization_EntryFragment_Trustee_Fragment': Localization_EntryFragment_Trustee_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_Trustee_Fragment' };

type LocalizationMetadata_EntryFragment_TrusteesPage_Fragment = (
  { __typename: 'TrusteesPage' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_TrusteesPage_Fragment': InternalLink_EntryFragment_TrusteesPage_Fragment;'Localization_EntryFragment_TrusteesPage_Fragment': Localization_EntryFragment_TrusteesPage_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_TrusteesPage_Fragment' };

type LocalizationMetadata_EntryFragment_VideoNative_Fragment = (
  { __typename: 'VideoNative' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_VideoNative_Fragment': InternalLink_EntryFragment_VideoNative_Fragment;'Localization_EntryFragment_VideoNative_Fragment': Localization_EntryFragment_VideoNative_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_VideoNative_Fragment' };

type LocalizationMetadata_EntryFragment_VideoYoutube_Fragment = (
  { __typename: 'VideoYoutube' }
  & { ' $fragmentRefs'?: { 'InternalLink_EntryFragment_VideoYoutube_Fragment': InternalLink_EntryFragment_VideoYoutube_Fragment;'Localization_EntryFragment_VideoYoutube_Fragment': Localization_EntryFragment_VideoYoutube_Fragment } }
) & { ' $fragmentName'?: 'LocalizationMetadata_EntryFragment_VideoYoutube_Fragment' };

export type LocalizationMetadata_EntryFragmentFragment = LocalizationMetadata_EntryFragment_AnnualReport_Fragment | LocalizationMetadata_EntryFragment_Article_Fragment | LocalizationMetadata_EntryFragment_AtGlanceCard_Fragment | LocalizationMetadata_EntryFragment_CallForConcept_Fragment | LocalizationMetadata_EntryFragment_ConnectWith_Fragment | LocalizationMetadata_EntryFragment_ConnectWithLink_Fragment | LocalizationMetadata_EntryFragment_Contact_Fragment | LocalizationMetadata_EntryFragment_ContactPerson_Fragment | LocalizationMetadata_EntryFragment_Department_Fragment | LocalizationMetadata_EntryFragment_DropCap_Fragment | LocalizationMetadata_EntryFragment_EmphasizedArticle_Fragment | LocalizationMetadata_EntryFragment_EventsPage_Fragment | LocalizationMetadata_EntryFragment_ExperienceBlock_Fragment | LocalizationMetadata_EntryFragment_ExplicitValueFilter_Fragment | LocalizationMetadata_EntryFragment_ExternalEvent_Fragment | LocalizationMetadata_EntryFragment_ExternalPerson_Fragment | LocalizationMetadata_EntryFragment_Faq_Fragment | LocalizationMetadata_EntryFragment_FaqsModule_Fragment | LocalizationMetadata_EntryFragment_Feature_Fragment | LocalizationMetadata_EntryFragment_FinancialsPage_Fragment | LocalizationMetadata_EntryFragment_Footer_Fragment | LocalizationMetadata_EntryFragment_Grant_Fragment | LocalizationMetadata_EntryFragment_GrantActivityArticle_Fragment | LocalizationMetadata_EntryFragment_GrantDetailsPage_Fragment | LocalizationMetadata_EntryFragment_GrantResources_Fragment | LocalizationMetadata_EntryFragment_GrantSearchFilters_Fragment | LocalizationMetadata_EntryFragment_GrantmakingArea_Fragment | LocalizationMetadata_EntryFragment_GrantmakingAreaDetailsPage_Fragment | LocalizationMetadata_EntryFragment_GrantmakingAreasPage_Fragment | LocalizationMetadata_EntryFragment_HeroAsset_Fragment | LocalizationMetadata_EntryFragment_HistoryPage_Fragment | LocalizationMetadata_EntryFragment_HistoryPerson_Fragment | LocalizationMetadata_EntryFragment_HomePage_Fragment | LocalizationMetadata_EntryFragment_Idea_Fragment | LocalizationMetadata_EntryFragment_InitiativeQuoteCallOut_Fragment | LocalizationMetadata_EntryFragment_InlineCards_Fragment | LocalizationMetadata_EntryFragment_InlineImages_Fragment | LocalizationMetadata_EntryFragment_MainNavigation_Fragment | LocalizationMetadata_EntryFragment_Metadata_Fragment | LocalizationMetadata_EntryFragment_MissionPage_Fragment | LocalizationMetadata_EntryFragment_Mmuf_Fragment | LocalizationMetadata_EntryFragment_NavigationItem_Fragment | LocalizationMetadata_EntryFragment_NewsPage_Fragment | LocalizationMetadata_EntryFragment_NewsletterCard_Fragment | LocalizationMetadata_EntryFragment_NewsletterConfirmPage_Fragment | LocalizationMetadata_EntryFragment_NewsletterPage_Fragment | LocalizationMetadata_EntryFragment_OldAnnualReport_Fragment | LocalizationMetadata_EntryFragment_Organisation_Fragment | LocalizationMetadata_EntryFragment_ParallaxImages_Fragment | LocalizationMetadata_EntryFragment_PasswordProtectedPage_Fragment | LocalizationMetadata_EntryFragment_PeoplePage_Fragment | LocalizationMetadata_EntryFragment_Person_Fragment | LocalizationMetadata_EntryFragment_PresidentialQuoteCallOut_Fragment | LocalizationMetadata_EntryFragment_PressRoom_Fragment | LocalizationMetadata_EntryFragment_PrivacyPolicy_Fragment | LocalizationMetadata_EntryFragment_QuickLink_Fragment | LocalizationMetadata_EntryFragment_Quote_Fragment | LocalizationMetadata_EntryFragment_RangeValueFilter_Fragment | LocalizationMetadata_EntryFragment_ResourcesCurrentGrantees_Fragment | LocalizationMetadata_EntryFragment_ResourcesProspectiveGrantees_Fragment | LocalizationMetadata_EntryFragment_RootPage_Fragment | LocalizationMetadata_EntryFragment_SearchPage_Fragment | LocalizationMetadata_EntryFragment_SpotlightSlideshow_Fragment | LocalizationMetadata_EntryFragment_SpotlightVideo_Fragment | LocalizationMetadata_EntryFragment_StoriesPage_Fragment | LocalizationMetadata_EntryFragment_Taxonomy_Fragment | LocalizationMetadata_EntryFragment_TermsOfUse_Fragment | LocalizationMetadata_EntryFragment_Theme_Fragment | LocalizationMetadata_EntryFragment_Trustee_Fragment | LocalizationMetadata_EntryFragment_TrusteesPage_Fragment | LocalizationMetadata_EntryFragment_VideoNative_Fragment | LocalizationMetadata_EntryFragment_VideoYoutube_Fragment;

export type Metadata_MetadataFragmentFragment = { __typename: 'Metadata', title: string | null, description: string | null, ogTitle: string | null, ogDescription: string | null, ogImage: { __typename: 'Asset', url: string | null, width: number | null, height: number | null } | null } & { ' $fragmentName'?: 'Metadata_MetadataFragmentFragment' };

export type Theme_QueryFragmentFragment = { __typename: 'Query', themeCollection: { __typename: 'ThemeCollection', items: Array<{ __typename: 'Theme', primary: string | null, secondary: string | null, copy: string | null, fullScreenAnimation: boolean | null } | null> } | null } & { ' $fragmentName'?: 'Theme_QueryFragmentFragment' };

export type Theme_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type Theme_QueryQuery = { __typename: 'Query', themeCollection: { __typename: 'ThemeCollection', items: Array<(
      { __typename: 'Theme', primary: string | null, secondary: string | null, copy: string | null, fullScreenAnimation: boolean | null }
      & { ' $fragmentRefs'?: { 'Cache_EntryFragment_Theme_Fragment': Cache_EntryFragment_Theme_Fragment } }
    ) | null> } | null };

export type Social_QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type Social_QueryQuery = { __typename: 'Query', socialContactCollection: { __typename: 'ContactCollection', items: Array<(
      { __typename: 'Contact' }
      & { ' $fragmentRefs'?: { 'Socials_ContactFragmentFragment': Socials_ContactFragmentFragment } }
    ) | null> } | null };

export const GrantTitle_GrantFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GrantTitle_GrantFragmentFragment, unknown>;
export const GrantSlug_GrantFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GrantSlug_GrantFragmentFragment, unknown>;
export const GrantDetailsPageRelatedGrants_GrantFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantDetailsPageRelatedGrants_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GrantDetailsPageRelatedGrants_GrantFragmentFragment, unknown>;
export const InternalLink_EntryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}}]} as unknown as DocumentNode<InternalLink_EntryFragmentFragment, unknown>;
export const GrantDetails_GrantFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantDetails_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"grantmakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMonths"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantDetailsPageRelatedGrants_GrantFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantDetailsPageRelatedGrants_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<GrantDetails_GrantFragmentFragment, unknown>;
export const Opengraph_AssetFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Opengraph_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]} as unknown as DocumentNode<Opengraph_AssetFragmentFragment, unknown>;
export const Opengraph_HeroAssetFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Opengraph_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Opengraph_AssetFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Opengraph_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]} as unknown as DocumentNode<Opengraph_HeroAssetFragmentFragment, unknown>;
export const AudioPlayer_AssetFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AudioPlayer_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]} as unknown as DocumentNode<AudioPlayer_AssetFragmentFragment, unknown>;
export const AnnualReportCard_OldAnnualReportFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AnnualReportCard_OldAnnualReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<AnnualReportCard_OldAnnualReportFragmentFragment, unknown>;
export const Image_AssetFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]} as unknown as DocumentNode<Image_AssetFragmentFragment, unknown>;
export const Hero_AssetFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]} as unknown as DocumentNode<Hero_AssetFragmentFragment, unknown>;
export const Hero_HeroAssetFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]} as unknown as DocumentNode<Hero_HeroAssetFragmentFragment, unknown>;
export const ArticleCard_ArticleFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentOrGrantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<ArticleCard_ArticleFragmentFragment, unknown>;
export const GrantStoryCard_GrantActivityArticleFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"granteeNameOverride"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<GrantStoryCard_GrantActivityArticleFragmentFragment, unknown>;
export const EmphasizedCard_EmphasizedArticleQueryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmphasizedCard_EmphasizedArticleQuery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmphasizedArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentOrGrantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"granteeNameOverride"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]} as unknown as DocumentNode<EmphasizedCard_EmphasizedArticleQueryFragment, unknown>;
export const GrantCard_GrantFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantCard_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<GrantCard_GrantFragmentFragment, unknown>;
export const GrantmakingAreaCard_GrantmakingAreaDetailsPageFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantmakingAreaCard_GrantmakingAreaDetailsPageFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"introDescription"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<GrantmakingAreaCard_GrantmakingAreaDetailsPageFragmentFragment, unknown>;
export const HighlightCard_AtGlanceCardFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HighlightCard_AtGlanceCardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AtGlanceCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"bodyText"}},{"kind":"Field","name":{"kind":"Name","value":"typeReference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<HighlightCard_AtGlanceCardFragmentFragment, unknown>;
export const LeadershipCard_PersonFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadershipCard_PersonFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<LeadershipCard_PersonFragmentFragment, unknown>;
export const LeadershipCard_HistoryPersonFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadershipCard_HistoryPersonFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<LeadershipCard_HistoryPersonFragmentFragment, unknown>;
export const PersonCard_PersonFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PersonCard_PersonFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departmentOrGrantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<PersonCard_PersonFragmentFragment, unknown>;
export const PersonCard_HistoryPersonFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PersonCard_HistoryPersonFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startYear"}},{"kind":"Field","name":{"kind":"Name","value":"endYear"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<PersonCard_HistoryPersonFragmentFragment, unknown>;
export const PersonCard_TrusteeFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PersonCard_TrusteeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Trustee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<PersonCard_TrusteeFragmentFragment, unknown>;
export const PersonCard_ExternalPersonFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PersonCard_ExternalPersonFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","alias":{"kind":"Name","value":"organizationString"},"name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<PersonCard_ExternalPersonFragmentFragment, unknown>;
export const Faq_FaqFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Faq_FaqFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Faq"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}}]} as unknown as DocumentNode<Faq_FaqFragmentFragment, unknown>;
export const Faqs_FaqsModuleFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Faqs_FaqsModuleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FaqsModule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"faqsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Faq_FaqFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Faq_FaqFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Faq"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}}]} as unknown as DocumentNode<Faqs_FaqsModuleFragmentFragment, unknown>;
export const GrantStoryAccordionCard_GrantActivityArticleFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantStoryAccordionCard_GrantActivityArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<GrantStoryAccordionCard_GrantActivityArticleFragmentFragment, unknown>;
export const Header_AssetFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Header_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]} as unknown as DocumentNode<Header_AssetFragmentFragment, unknown>;
export const Header_HeroAssetFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Header_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Header_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoHasAudio"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Header_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]} as unknown as DocumentNode<Header_HeroAssetFragmentFragment, unknown>;
export const QuickLink_ConnectWithLinkFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWithLink"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"internalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<QuickLink_ConnectWithLinkFragmentFragment, unknown>;
export const Newsletter_NewsletterFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Newsletter_NewsletterFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"disclaimer"}}]}}]} as unknown as DocumentNode<Newsletter_NewsletterFragmentFragment, unknown>;
export const Socials_ContactFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Socials_ContactFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facebookLink"}},{"kind":"Field","name":{"kind":"Name","value":"instagramLink"}},{"kind":"Field","name":{"kind":"Name","value":"threadsLink"}},{"kind":"Field","name":{"kind":"Name","value":"youtubeLink"}},{"kind":"Field","name":{"kind":"Name","value":"linkedInLink"}}]}}]} as unknown as DocumentNode<Socials_ContactFragmentFragment, unknown>;
export const Idea_IdeaFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Idea_IdeaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<Idea_IdeaFragmentFragment, unknown>;
export const Ideas_QueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Ideas_QueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ideaCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Idea_IdeaFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Idea_IdeaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]} as unknown as DocumentNode<Ideas_QueryFragmentFragment, unknown>;
export const Footer_QueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Footer_QueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"footerCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"footerLinksCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"newsletter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Newsletter_NewsletterFragment"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"footerContactCollection"},"name":{"kind":"Name","value":"contactCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Socials_ContactFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Ideas_QueryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Idea_IdeaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWithLink"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"internalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Newsletter_NewsletterFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"disclaimer"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Socials_ContactFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facebookLink"}},{"kind":"Field","name":{"kind":"Name","value":"instagramLink"}},{"kind":"Field","name":{"kind":"Name","value":"threadsLink"}},{"kind":"Field","name":{"kind":"Name","value":"youtubeLink"}},{"kind":"Field","name":{"kind":"Name","value":"linkedInLink"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Ideas_QueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ideaCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Idea_IdeaFragment"}}]}}]}}]}}]} as unknown as DocumentNode<Footer_QueryFragmentFragment, unknown>;
export const SecondaryNavigationContent_QueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecondaryNavigationContent_QueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mainNavigationCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"babyMissionStatement"}},{"kind":"Field","name":{"kind":"Name","value":"ideasCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"resourcesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinancialsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreasPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MissionPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PeoplePage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]} as unknown as DocumentNode<SecondaryNavigationContent_QueryFragmentFragment, unknown>;
export const Cache_EntryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<Cache_EntryFragmentFragment, unknown>;
export const SecondaryNavigationSearch_QueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecondaryNavigationSearch_QueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchPageCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featuredSearches"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SecondaryNavigationSearch_QueryFragmentFragment, unknown>;
export const SecondaryNavigation_QueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecondaryNavigation_QueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SecondaryNavigationContent_QueryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SecondaryNavigationSearch_QueryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecondaryNavigationContent_QueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mainNavigationCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"babyMissionStatement"}},{"kind":"Field","name":{"kind":"Name","value":"ideasCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"resourcesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinancialsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreasPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MissionPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PeoplePage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecondaryNavigationSearch_QueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchPageCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featuredSearches"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}}]}}]}}]} as unknown as DocumentNode<SecondaryNavigation_QueryFragmentFragment, unknown>;
export const Navigation_QueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Navigation_QueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SecondaryNavigation_QueryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecondaryNavigationContent_QueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mainNavigationCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"babyMissionStatement"}},{"kind":"Field","name":{"kind":"Name","value":"ideasCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"resourcesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinancialsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreasPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MissionPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PeoplePage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecondaryNavigationSearch_QueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchPageCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featuredSearches"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecondaryNavigation_QueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SecondaryNavigationContent_QueryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SecondaryNavigationSearch_QueryFragment"}}]}}]} as unknown as DocumentNode<Navigation_QueryFragmentFragment, unknown>;
export const QuickLinks_ConnectWithFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLinks_ConnectWithFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWith"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"linksCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWithLink"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"internalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<QuickLinks_ConnectWithFragmentFragment, unknown>;
export const IdeaCard_IdeaFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<IdeaCard_IdeaFragmentFragment, unknown>;
export const QuoteModule_QuoteFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteText"}},{"kind":"Field","name":{"kind":"Name","value":"quoteImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quoteAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"twitterUsername"}},{"kind":"Field","name":{"kind":"Name","value":"isTwitterImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]} as unknown as DocumentNode<QuoteModule_QuoteFragmentFragment, unknown>;
export const FutureEventCard_ExternalEventFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]} as unknown as DocumentNode<FutureEventCard_ExternalEventFragmentFragment, unknown>;
export const FeatureCard_FeatureFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"dateString"},"name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pinnedGrantStoriesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<FeatureCard_FeatureFragmentFragment, unknown>;
export const MmufCard_MmufFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MmufCard_MmufFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mmuf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"introDescription"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<MmufCard_MmufFragmentFragment, unknown>;
export const AnnualReportCard_AnnualReportFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"introImagesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<AnnualReportCard_AnnualReportFragmentFragment, unknown>;
export const CallForConcepts_CallForConceptFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CallForConcept"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineTitle"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]} as unknown as DocumentNode<CallForConcepts_CallForConceptFragmentFragment, unknown>;
export const ContentGrid_EntryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContentGrid_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MmufCard_MmufFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentOrGrantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"granteeNameOverride"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteText"}},{"kind":"Field","name":{"kind":"Name","value":"quoteImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quoteAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"twitterUsername"}},{"kind":"Field","name":{"kind":"Name","value":"isTwitterImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"dateString"},"name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pinnedGrantStoriesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MmufCard_MmufFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mmuf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"introDescription"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"introImagesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CallForConcept"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineTitle"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineDate"}}]}}]} as unknown as DocumentNode<ContentGrid_EntryFragmentFragment, unknown>;
export const InlineImages_InlineImagesFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invert"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]} as unknown as DocumentNode<InlineImages_InlineImagesFragmentFragment, unknown>;
export const SpotlightSlideshowSlide_AssetFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]} as unknown as DocumentNode<SpotlightSlideshowSlide_AssetFragmentFragment, unknown>;
export const SpotlightSlideshow_SpotlightSlideshowFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightSlideshow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]} as unknown as DocumentNode<SpotlightSlideshow_SpotlightSlideshowFragmentFragment, unknown>;
export const SpotlightVideo_SpotlightVideoFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightVideo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"videoCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"previewStaticImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ctaLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]} as unknown as DocumentNode<SpotlightVideo_SpotlightVideoFragmentFragment, unknown>;
export const Video_VideoNativeFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoNativeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoNative"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"closedCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAmbient"}},{"kind":"Field","name":{"kind":"Name","value":"isVertical"}}]}}]} as unknown as DocumentNode<Video_VideoNativeFragmentFragment, unknown>;
export const Video_VideoYoutubeFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoYoutube"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<Video_VideoYoutubeFragmentFragment, unknown>;
export const InitiativeQuote_InitiativeQuoteCallOutFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InitiativeQuoteCallOut"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initiativeHeading"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeTitle"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeText"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeCtaText"}},{"kind":"Field","name":{"kind":"Name","value":"searchQuery"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteText"}},{"kind":"Field","name":{"kind":"Name","value":"quoteImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quoteAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"twitterUsername"}},{"kind":"Field","name":{"kind":"Name","value":"isTwitterImage"}}]}}]} as unknown as DocumentNode<InitiativeQuote_InitiativeQuoteCallOutFragmentFragment, unknown>;
export const ParallaxImages_ParallaxImagesQueryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ParallaxImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]} as unknown as DocumentNode<ParallaxImages_ParallaxImagesQueryFragment, unknown>;
export const ExperienceBlock_ExperienceBlockFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExperienceBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"mediaCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"referencesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoNativeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoNative"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"closedCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAmbient"}},{"kind":"Field","name":{"kind":"Name","value":"isVertical"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentOrGrantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]} as unknown as DocumentNode<ExperienceBlock_ExperienceBlockFragmentFragment, unknown>;
export const ResourcesExplanatoryParagraphRichText_ResourcesExplanatoryParagraphFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResourcesExplanatoryParagraphRichText_ResourcesExplanatoryParagraphFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ResourcesProspectiveGranteesExplanatoryParagraph"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineCards"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContentGrid_EntryFragment"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentOrGrantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"granteeNameOverride"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteText"}},{"kind":"Field","name":{"kind":"Name","value":"quoteImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quoteAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"twitterUsername"}},{"kind":"Field","name":{"kind":"Name","value":"isTwitterImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"dateString"},"name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pinnedGrantStoriesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MmufCard_MmufFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mmuf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"introDescription"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"introImagesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CallForConcept"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineTitle"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoNativeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoNative"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"closedCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAmbient"}},{"kind":"Field","name":{"kind":"Name","value":"isVertical"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContentGrid_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MmufCard_MmufFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invert"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightSlideshow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightVideo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"videoCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"previewStaticImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ctaLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWithLink"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"internalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoYoutube"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InitiativeQuoteCallOut"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initiativeHeading"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeTitle"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeText"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeCtaText"}},{"kind":"Field","name":{"kind":"Name","value":"searchQuery"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ParallaxImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExperienceBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"mediaCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"referencesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}}]}}]}}]}}]} as unknown as DocumentNode<ResourcesExplanatoryParagraphRichText_ResourcesExplanatoryParagraphFragmentFragment, unknown>;
export const RootPageBodyRichText_RootPageBodyFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RootPageBodyRichText_RootPageBodyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPageBody"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineCards"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContentGrid_EntryFragment"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentOrGrantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"granteeNameOverride"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteText"}},{"kind":"Field","name":{"kind":"Name","value":"quoteImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quoteAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"twitterUsername"}},{"kind":"Field","name":{"kind":"Name","value":"isTwitterImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"dateString"},"name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pinnedGrantStoriesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MmufCard_MmufFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mmuf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"introDescription"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"introImagesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CallForConcept"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineTitle"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoNativeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoNative"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"closedCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAmbient"}},{"kind":"Field","name":{"kind":"Name","value":"isVertical"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContentGrid_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MmufCard_MmufFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invert"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightSlideshow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightVideo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"videoCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"previewStaticImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ctaLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWithLink"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"internalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoYoutube"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InitiativeQuoteCallOut"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initiativeHeading"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeTitle"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeText"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeCtaText"}},{"kind":"Field","name":{"kind":"Name","value":"searchQuery"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ParallaxImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExperienceBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"mediaCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"referencesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}}]}}]}}]}}]} as unknown as DocumentNode<RootPageBodyRichText_RootPageBodyFragmentFragment, unknown>;
export const AnnualReportBodyRichText_AnnualReportArticleBodyPart2FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AnnualReportBodyRichText_AnnualReportArticleBodyPart2Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReportArticleBodyPart2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineCards"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContentGrid_EntryFragment"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentOrGrantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"granteeNameOverride"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteText"}},{"kind":"Field","name":{"kind":"Name","value":"quoteImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quoteAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"twitterUsername"}},{"kind":"Field","name":{"kind":"Name","value":"isTwitterImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"dateString"},"name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pinnedGrantStoriesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MmufCard_MmufFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mmuf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"introDescription"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"introImagesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CallForConcept"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineTitle"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoNativeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoNative"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"closedCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAmbient"}},{"kind":"Field","name":{"kind":"Name","value":"isVertical"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContentGrid_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MmufCard_MmufFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invert"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightSlideshow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightVideo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"videoCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"previewStaticImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ctaLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWithLink"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"internalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoYoutube"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InitiativeQuoteCallOut"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initiativeHeading"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeTitle"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeText"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeCtaText"}},{"kind":"Field","name":{"kind":"Name","value":"searchQuery"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ParallaxImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExperienceBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"mediaCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"referencesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}}]}}]}}]}}]} as unknown as DocumentNode<AnnualReportBodyRichText_AnnualReportArticleBodyPart2FragmentFragment, unknown>;
export const ArticleBodyRichText_ArticleBodyFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleBodyRichText_ArticleBodyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleBody"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineCards"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContentGrid_EntryFragment"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hyperlink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentOrGrantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"granteeNameOverride"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteText"}},{"kind":"Field","name":{"kind":"Name","value":"quoteImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quoteAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"twitterUsername"}},{"kind":"Field","name":{"kind":"Name","value":"isTwitterImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"dateString"},"name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pinnedGrantStoriesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MmufCard_MmufFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mmuf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"introDescription"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"introImagesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CallForConcept"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineTitle"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoNativeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoNative"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"closedCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAmbient"}},{"kind":"Field","name":{"kind":"Name","value":"isVertical"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContentGrid_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MmufCard_MmufFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invert"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightSlideshow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightVideo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"videoCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"previewStaticImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ctaLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWithLink"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"internalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoYoutube"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InitiativeQuoteCallOut"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initiativeHeading"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeTitle"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeText"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeCtaText"}},{"kind":"Field","name":{"kind":"Name","value":"searchQuery"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ParallaxImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExperienceBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"mediaCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"referencesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}}]}}]}}]}}]} as unknown as DocumentNode<ArticleBodyRichText_ArticleBodyFragmentFragment, unknown>;
export const FeatureIntroRichText_FeatureIntroFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeatureIntroRichText_FeatureIntroFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeatureIntro"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineCards"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContentGrid_EntryFragment"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentOrGrantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"granteeNameOverride"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteText"}},{"kind":"Field","name":{"kind":"Name","value":"quoteImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quoteAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"twitterUsername"}},{"kind":"Field","name":{"kind":"Name","value":"isTwitterImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"dateString"},"name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pinnedGrantStoriesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MmufCard_MmufFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mmuf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"introDescription"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"introImagesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CallForConcept"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineTitle"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoNativeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoNative"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"closedCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAmbient"}},{"kind":"Field","name":{"kind":"Name","value":"isVertical"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContentGrid_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MmufCard_MmufFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invert"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightSlideshow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightVideo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"videoCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"previewStaticImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ctaLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWithLink"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"internalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoYoutube"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InitiativeQuoteCallOut"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initiativeHeading"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeTitle"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeText"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeCtaText"}},{"kind":"Field","name":{"kind":"Name","value":"searchQuery"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ParallaxImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExperienceBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"mediaCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"referencesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}}]}}]}}]}}]} as unknown as DocumentNode<FeatureIntroRichText_FeatureIntroFragmentFragment, unknown>;
export const FeatureContentRichText_FeatureBodyFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeatureContentRichText_FeatureBodyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeatureContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineCards"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContentGrid_EntryFragment"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentOrGrantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"granteeNameOverride"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteText"}},{"kind":"Field","name":{"kind":"Name","value":"quoteImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quoteAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"twitterUsername"}},{"kind":"Field","name":{"kind":"Name","value":"isTwitterImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"dateString"},"name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pinnedGrantStoriesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MmufCard_MmufFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mmuf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"introDescription"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"introImagesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CallForConcept"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineTitle"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoNativeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoNative"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"closedCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAmbient"}},{"kind":"Field","name":{"kind":"Name","value":"isVertical"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContentGrid_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MmufCard_MmufFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invert"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightSlideshow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightVideo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"videoCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"previewStaticImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ctaLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWithLink"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"internalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoYoutube"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InitiativeQuoteCallOut"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initiativeHeading"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeTitle"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeText"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeCtaText"}},{"kind":"Field","name":{"kind":"Name","value":"searchQuery"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ParallaxImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExperienceBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"mediaCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"referencesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}}]}}]}}]}}]} as unknown as DocumentNode<FeatureContentRichText_FeatureBodyFragmentFragment, unknown>;
export const GrantStoryBodyRichText_GrantActivityArticleBodyFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantStoryBodyRichText_GrantActivityArticleBodyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticleBody"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineCards"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContentGrid_EntryFragment"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentOrGrantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"granteeNameOverride"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteText"}},{"kind":"Field","name":{"kind":"Name","value":"quoteImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quoteAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"twitterUsername"}},{"kind":"Field","name":{"kind":"Name","value":"isTwitterImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"dateString"},"name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pinnedGrantStoriesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MmufCard_MmufFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mmuf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"introDescription"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"introImagesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CallForConcept"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineTitle"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoNativeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoNative"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"closedCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAmbient"}},{"kind":"Field","name":{"kind":"Name","value":"isVertical"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContentGrid_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MmufCard_MmufFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invert"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightSlideshow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightVideo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"videoCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"previewStaticImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ctaLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWithLink"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"internalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoYoutube"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InitiativeQuoteCallOut"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initiativeHeading"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeTitle"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeText"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeCtaText"}},{"kind":"Field","name":{"kind":"Name","value":"searchQuery"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ParallaxImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExperienceBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"mediaCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"referencesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}}]}}]}}]}}]} as unknown as DocumentNode<GrantStoryBodyRichText_GrantActivityArticleBodyFragmentFragment, unknown>;
export const NewsletterConfirmBodyRichText_NewsletterConfirmPageBodyFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NewsletterConfirmBodyRichText_NewsletterConfirmPageBodyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterConfirmPageBody"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineCards"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContentGrid_EntryFragment"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentOrGrantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"granteeNameOverride"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteText"}},{"kind":"Field","name":{"kind":"Name","value":"quoteImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quoteAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"twitterUsername"}},{"kind":"Field","name":{"kind":"Name","value":"isTwitterImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"dateString"},"name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pinnedGrantStoriesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MmufCard_MmufFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mmuf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"introDescription"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"introImagesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CallForConcept"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineTitle"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoNativeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoNative"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"closedCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAmbient"}},{"kind":"Field","name":{"kind":"Name","value":"isVertical"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContentGrid_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MmufCard_MmufFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invert"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightSlideshow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightVideo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"videoCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"previewStaticImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ctaLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWithLink"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"internalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoYoutube"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InitiativeQuoteCallOut"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initiativeHeading"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeTitle"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeText"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeCtaText"}},{"kind":"Field","name":{"kind":"Name","value":"searchQuery"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ParallaxImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExperienceBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"mediaCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"referencesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}}]}}]}}]}}]} as unknown as DocumentNode<NewsletterConfirmBodyRichText_NewsletterConfirmPageBodyFragmentFragment, unknown>;
export const FinancialsGraphSectionRichText_FinancialsPageGraphsSectionFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FinancialsGraphSectionRichText_FinancialsPageGraphsSectionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinancialsPageGraphsSection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineCards"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContentGrid_EntryFragment"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentOrGrantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"granteeNameOverride"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteText"}},{"kind":"Field","name":{"kind":"Name","value":"quoteImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quoteAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"twitterUsername"}},{"kind":"Field","name":{"kind":"Name","value":"isTwitterImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"dateString"},"name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pinnedGrantStoriesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MmufCard_MmufFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mmuf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"introDescription"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"introImagesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CallForConcept"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineTitle"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoNativeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoNative"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"closedCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAmbient"}},{"kind":"Field","name":{"kind":"Name","value":"isVertical"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContentGrid_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MmufCard_MmufFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invert"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightSlideshow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightVideo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"videoCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"previewStaticImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ctaLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWithLink"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"internalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoYoutube"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InitiativeQuoteCallOut"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initiativeHeading"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeTitle"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeText"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeCtaText"}},{"kind":"Field","name":{"kind":"Name","value":"searchQuery"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ParallaxImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExperienceBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"mediaCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"referencesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}}]}}]}}]}}]} as unknown as DocumentNode<FinancialsGraphSectionRichText_FinancialsPageGraphsSectionFragmentFragment, unknown>;
export const GrantmakingAreaDetailsPageBodyRichText_GrantmakingAreaDetailsPageBodyFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantmakingAreaDetailsPageBodyRichText_GrantmakingAreaDetailsPageBodyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPageBody"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineCards"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContentGrid_EntryFragment"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentOrGrantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"granteeNameOverride"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteText"}},{"kind":"Field","name":{"kind":"Name","value":"quoteImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quoteAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"twitterUsername"}},{"kind":"Field","name":{"kind":"Name","value":"isTwitterImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"dateString"},"name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pinnedGrantStoriesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MmufCard_MmufFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mmuf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"introDescription"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"introImagesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CallForConcept"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineTitle"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoNativeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoNative"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"closedCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAmbient"}},{"kind":"Field","name":{"kind":"Name","value":"isVertical"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContentGrid_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MmufCard_MmufFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invert"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightSlideshow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightVideo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"videoCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"previewStaticImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ctaLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWithLink"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"internalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoYoutube"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InitiativeQuoteCallOut"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initiativeHeading"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeTitle"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeText"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeCtaText"}},{"kind":"Field","name":{"kind":"Name","value":"searchQuery"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ParallaxImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExperienceBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"mediaCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"referencesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}}]}}]}}]}}]} as unknown as DocumentNode<GrantmakingAreaDetailsPageBodyRichText_GrantmakingAreaDetailsPageBodyFragmentFragment, unknown>;
export const ArticleCta_ArticleFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCta_ArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<ArticleCta_ArticleFragmentFragment, unknown>;
export const Filter_ExplicitValueFilterFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Filter_ExplicitValueFilterFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExplicitValueFilter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]} as unknown as DocumentNode<Filter_ExplicitValueFilterFragmentFragment, unknown>;
export const Filter_RangeValueFilterFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Filter_RangeValueFilterFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RangeValueFilter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gte"}},{"kind":"Field","name":{"kind":"Name","value":"lte"}}]}}]} as unknown as DocumentNode<Filter_RangeValueFilterFragmentFragment, unknown>;
export const Filter_EntryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Filter_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Filter_ExplicitValueFilterFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Filter_RangeValueFilterFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Filter_ExplicitValueFilterFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExplicitValueFilter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Filter_RangeValueFilterFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RangeValueFilter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gte"}},{"kind":"Field","name":{"kind":"Name","value":"lte"}}]}}]} as unknown as DocumentNode<Filter_EntryFragmentFragment, unknown>;
export const Localization_EntryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Localization_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<Localization_EntryFragmentFragment, unknown>;
export const LocalizationMetadata_EntryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocalizationMetadata_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Localization_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Localization_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}}]} as unknown as DocumentNode<LocalizationMetadata_EntryFragmentFragment, unknown>;
export const Metadata_MetadataFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Metadata_MetadataFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Metadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ogTitle"}},{"kind":"Field","name":{"kind":"Name","value":"ogDescription"}},{"kind":"Field","name":{"kind":"Name","value":"ogImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}}]} as unknown as DocumentNode<Metadata_MetadataFragmentFragment, unknown>;
export const Theme_QueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Theme_QueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"themeCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"secondary"}},{"kind":"Field","name":{"kind":"Name","value":"copy"}},{"kind":"Field","name":{"kind":"Name","value":"fullScreenAnimation"}}]}}]}}]}}]} as unknown as DocumentNode<Theme_QueryFragmentFragment, unknown>;
export const AllArticles_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllArticles_Query"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"types"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"articleCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1000"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"types"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Localization_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocalizationMetadata_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Localization_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocalizationMetadata_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Localization_EntryFragment"}}]}}]} as unknown as DocumentNode<AllArticles_QueryQuery, AllArticles_QueryQueryVariables>;
export const Article_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Article_Query"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"types"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"articleCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"type_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"types"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Header_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Metadata_MetadataFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Header_AssetFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Opengraph_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"hideDate"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"grantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"photographer"}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"creditLabel"}},{"kind":"Field","name":{"kind":"Name","value":"creditText"}},{"kind":"Field","name":{"kind":"Name","value":"quickLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLinks_ConnectWithFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"audio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AudioPlayer_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattingOptions"}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleBodyRichText_ArticleBodyFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hideShareLink"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PersonCard_PersonFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PersonCard_ExternalPersonFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"relatedContentCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContentGrid_EntryFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"faqs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Faqs_FaqsModuleFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"password"}},{"kind":"Field","name":{"kind":"Name","value":"passwordProtectedPage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emailHeadline"}},{"kind":"Field","name":{"kind":"Name","value":"email"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocalizationMetadata_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Localization_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Header_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWithLink"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"internalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentOrGrantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"granteeNameOverride"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteText"}},{"kind":"Field","name":{"kind":"Name","value":"quoteImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quoteAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"twitterUsername"}},{"kind":"Field","name":{"kind":"Name","value":"isTwitterImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"dateString"},"name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pinnedGrantStoriesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MmufCard_MmufFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mmuf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"introDescription"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"introImagesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CallForConcept"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineTitle"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContentGrid_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MmufCard_MmufFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invert"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightSlideshow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightVideo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"videoCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"previewStaticImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ctaLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoNativeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoNative"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"closedCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAmbient"}},{"kind":"Field","name":{"kind":"Name","value":"isVertical"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoYoutube"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InitiativeQuoteCallOut"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initiativeHeading"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeTitle"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeText"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeCtaText"}},{"kind":"Field","name":{"kind":"Name","value":"searchQuery"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ParallaxImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExperienceBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"mediaCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"referencesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Faq_FaqFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Faq"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Localization_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Header_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Header_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoHasAudio"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Metadata_MetadataFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Metadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ogTitle"}},{"kind":"Field","name":{"kind":"Name","value":"ogDescription"}},{"kind":"Field","name":{"kind":"Name","value":"ogImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Opengraph_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLinks_ConnectWithFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWith"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"linksCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AudioPlayer_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleBodyRichText_ArticleBodyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleBody"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineCards"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContentGrid_EntryFragment"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hyperlink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PersonCard_PersonFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departmentOrGrantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PersonCard_ExternalPersonFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","alias":{"kind":"Name","value":"organizationString"},"name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Faqs_FaqsModuleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FaqsModule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"faqsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Faq_FaqFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocalizationMetadata_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Localization_EntryFragment"}}]}}]} as unknown as DocumentNode<Article_QueryQuery, Article_QueryQueryVariables>;
export const GrantSearchFilters_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GrantSearchFilters_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grantSearchFiltersCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"termsOfUse"}},{"kind":"Field","name":{"kind":"Name","value":"amountCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"5"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Filter_EntryFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"yearCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"5"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Filter_EntryFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Filter_ExplicitValueFilterFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExplicitValueFilter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Filter_RangeValueFilterFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RangeValueFilter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gte"}},{"kind":"Field","name":{"kind":"Name","value":"lte"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Filter_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Filter_ExplicitValueFilterFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Filter_RangeValueFilterFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GrantSearchFilters_QueryQuery, GrantSearchFilters_QueryQueryVariables>;
export const SearchFeaturedSearches_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchFeaturedSearches_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchPageCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featuredSearches"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SearchFeaturedSearches_QueryQuery, SearchFeaturedSearches_QueryQueryVariables>;
export const AllRootPages_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllRootPages_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rootPageCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Localization_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Localization_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}}]} as unknown as DocumentNode<AllRootPages_QueryQuery, AllRootPages_QueryQueryVariables>;
export const RootPage_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RootPage_Query"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rootPageCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RootPageBodyRichText_RootPageBodyFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"includeLegalLogo"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"metaDescription"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocalizationMetadata_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Localization_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentOrGrantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"granteeNameOverride"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteText"}},{"kind":"Field","name":{"kind":"Name","value":"quoteImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quoteAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"twitterUsername"}},{"kind":"Field","name":{"kind":"Name","value":"isTwitterImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"dateString"},"name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pinnedGrantStoriesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MmufCard_MmufFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mmuf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"introDescription"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"introImagesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CallForConcept"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineTitle"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContentGrid_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MmufCard_MmufFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invert"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightSlideshow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightVideo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"videoCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"previewStaticImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ctaLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWithLink"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"internalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoNativeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoNative"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"closedCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAmbient"}},{"kind":"Field","name":{"kind":"Name","value":"isVertical"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoYoutube"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InitiativeQuoteCallOut"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initiativeHeading"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeTitle"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeText"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeCtaText"}},{"kind":"Field","name":{"kind":"Name","value":"searchQuery"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ParallaxImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExperienceBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"mediaCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"referencesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Localization_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RootPageBodyRichText_RootPageBodyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPageBody"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineCards"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContentGrid_EntryFragment"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocalizationMetadata_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Localization_EntryFragment"}}]}}]} as unknown as DocumentNode<RootPage_QueryQuery, RootPage_QueryQueryVariables>;
export const AllAnnualReports_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllAnnualReports_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"annualReportCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<AllAnnualReports_QueryQuery, AllAnnualReports_QueryQueryVariables>;
export const AnnualReport_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AnnualReport_Query"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"annualReportCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"headline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"introImagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"audio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"header"}},{"kind":"Field","name":{"kind":"Name","value":"articleBodyPart1"}},{"kind":"Field","name":{"kind":"Name","value":"articleBodyPart2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AnnualReportBodyRichText_AnnualReportArticleBodyPart2Fragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PersonCard_PersonFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quickLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLinks_ConnectWithFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"callToActionText"}},{"kind":"Field","name":{"kind":"Name","value":"callToActionCtaText"}},{"kind":"Field","name":{"kind":"Name","value":"moreAnnualReportsTitle"}},{"kind":"Field","name":{"kind":"Name","value":"moreAnnualReportsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AnnualReportCard_OldAnnualReportFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isLookingForAnnualReportsSectionVisible"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentOrGrantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"granteeNameOverride"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteText"}},{"kind":"Field","name":{"kind":"Name","value":"quoteImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quoteAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"twitterUsername"}},{"kind":"Field","name":{"kind":"Name","value":"isTwitterImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"dateString"},"name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pinnedGrantStoriesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MmufCard_MmufFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mmuf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"introDescription"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"introImagesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CallForConcept"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineTitle"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContentGrid_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MmufCard_MmufFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invert"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightSlideshow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightVideo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"videoCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"previewStaticImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ctaLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWithLink"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"internalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoNativeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoNative"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"closedCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAmbient"}},{"kind":"Field","name":{"kind":"Name","value":"isVertical"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoYoutube"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InitiativeQuoteCallOut"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initiativeHeading"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeTitle"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeText"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeCtaText"}},{"kind":"Field","name":{"kind":"Name","value":"searchQuery"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ParallaxImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExperienceBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"mediaCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"referencesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AnnualReportBodyRichText_AnnualReportArticleBodyPart2Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReportArticleBodyPart2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineCards"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContentGrid_EntryFragment"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PersonCard_PersonFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departmentOrGrantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLinks_ConnectWithFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWith"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"linksCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AnnualReportCard_OldAnnualReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AnnualReport_QueryQuery, AnnualReport_QueryQueryVariables>;
export const ContactPage_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ContactPage_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quickLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLinks_ConnectWithFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"officeContactInformationHeadline"}},{"kind":"Field","name":{"kind":"Name","value":"officeAddress"}},{"kind":"Field","name":{"kind":"Name","value":"officeAddressGoogleMapsLabel"}},{"kind":"Field","name":{"kind":"Name","value":"officeAddressGoogleMapsLink"}},{"kind":"Field","name":{"kind":"Name","value":"officeTelephoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"officeFaxNumber"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmailsHeadline"}},{"kind":"Field","name":{"kind":"Name","value":"emailsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantInquiriesHeadline"}},{"kind":"Field","name":{"kind":"Name","value":"grantInquiriesText"}},{"kind":"Field","name":{"kind":"Name","value":"grantInquiriesLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"socialMediaHeadline"}},{"kind":"Field","name":{"kind":"Name","value":"socialMediaText"}},{"kind":"Field","name":{"kind":"Name","value":"newsletter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Newsletter_NewsletterFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Socials_ContactFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWithLink"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"internalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLinks_ConnectWithFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWith"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"linksCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Newsletter_NewsletterFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"disclaimer"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Socials_ContactFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facebookLink"}},{"kind":"Field","name":{"kind":"Name","value":"instagramLink"}},{"kind":"Field","name":{"kind":"Name","value":"threadsLink"}},{"kind":"Field","name":{"kind":"Name","value":"youtubeLink"}},{"kind":"Field","name":{"kind":"Name","value":"linkedInLink"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ContactPage_QueryQuery, ContactPage_QueryQueryVariables>;
export const EventsPage_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventsPage_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventsPageCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"newsletter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Newsletter_NewsletterFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"upcomingEventsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContentGrid_EntryFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentOrGrantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"granteeNameOverride"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteText"}},{"kind":"Field","name":{"kind":"Name","value":"quoteImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quoteAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"twitterUsername"}},{"kind":"Field","name":{"kind":"Name","value":"isTwitterImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"dateString"},"name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pinnedGrantStoriesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MmufCard_MmufFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mmuf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"introDescription"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"introImagesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CallForConcept"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineTitle"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Newsletter_NewsletterFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"disclaimer"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContentGrid_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MmufCard_MmufFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<EventsPage_QueryQuery, EventsPage_QueryQueryVariables>;
export const EventsPageEvents_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventsPageEvents_Query"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"articleCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"date_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"Past event","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentOrGrantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]} as unknown as DocumentNode<EventsPageEvents_QueryQuery, EventsPageEvents_QueryQueryVariables>;
export const AllFeatures_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllFeatures_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featureCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<AllFeatures_QueryQuery, AllFeatures_QueryQueryVariables>;
export const Feature_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Feature_Query"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featureCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tagline"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Header_AssetFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Opengraph_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Header_HeroAssetFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Opengraph_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"quickLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"linksCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"intro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeatureIntroRichText_FeatureIntroFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newsletter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Newsletter_NewsletterFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"callout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"}}]}}]}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeatureContentRichText_FeatureBodyFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ctaContextualMessage"}},{"kind":"Field","name":{"kind":"Name","value":"showSocialCtas"}},{"kind":"Field","name":{"kind":"Name","value":"relatedContentCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContentGrid_EntryFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"experienceBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Header_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Opengraph_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentOrGrantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"granteeNameOverride"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteText"}},{"kind":"Field","name":{"kind":"Name","value":"quoteImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quoteAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"twitterUsername"}},{"kind":"Field","name":{"kind":"Name","value":"isTwitterImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"dateString"},"name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pinnedGrantStoriesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MmufCard_MmufFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mmuf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"introDescription"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"introImagesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CallForConcept"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineTitle"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContentGrid_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MmufCard_MmufFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invert"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightSlideshow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightVideo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"videoCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"previewStaticImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ctaLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWithLink"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"internalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoNativeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoNative"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"closedCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAmbient"}},{"kind":"Field","name":{"kind":"Name","value":"isVertical"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoYoutube"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InitiativeQuoteCallOut"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initiativeHeading"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeTitle"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeText"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeCtaText"}},{"kind":"Field","name":{"kind":"Name","value":"searchQuery"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ParallaxImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExperienceBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"mediaCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"referencesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Header_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Header_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoHasAudio"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Opengraph_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Opengraph_AssetFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeatureIntroRichText_FeatureIntroFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeatureIntro"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineCards"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContentGrid_EntryFragment"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Newsletter_NewsletterFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"disclaimer"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeatureContentRichText_FeatureBodyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeatureContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineCards"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContentGrid_EntryFragment"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<Feature_QueryQuery, Feature_QueryQueryVariables>;
export const CbaImages_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CbaImages_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentfulMetadata"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tags"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id_contains_some"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"cba","block":false}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentfulMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}}]}}]} as unknown as DocumentNode<CbaImages_QueryQuery, CbaImages_QueryQueryVariables>;
export const FinancialsPage_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FinancialsPage_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"financialsPageCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"introDescription"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Opengraph_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"introParagraph"}},{"kind":"Field","name":{"kind":"Name","value":"quickLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLinks_ConnectWithFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"graphsSection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FinancialsGraphSectionRichText_FinancialsPageGraphsSectionFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"socialBondFramework"}},{"kind":"Field","name":{"kind":"Name","value":"socialBondFrameworkText"}},{"kind":"Field","name":{"kind":"Name","value":"socialBondFrameworkLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"financialReportsHeader"}},{"kind":"Field","name":{"kind":"Name","value":"financialReportsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"auditedFinancialStatementsHeader"}},{"kind":"Field","name":{"kind":"Name","value":"auditedFinancialStatementsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"privateFoundationReportsHeader"}},{"kind":"Field","name":{"kind":"Name","value":"privateFoundationReportsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWithLink"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"internalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentOrGrantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"granteeNameOverride"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteText"}},{"kind":"Field","name":{"kind":"Name","value":"quoteImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quoteAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"twitterUsername"}},{"kind":"Field","name":{"kind":"Name","value":"isTwitterImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"dateString"},"name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pinnedGrantStoriesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MmufCard_MmufFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mmuf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"introDescription"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"introImagesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CallForConcept"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineTitle"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContentGrid_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MmufCard_MmufFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invert"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightSlideshow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightVideo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"videoCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"previewStaticImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ctaLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoNativeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoNative"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"closedCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAmbient"}},{"kind":"Field","name":{"kind":"Name","value":"isVertical"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoYoutube"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InitiativeQuoteCallOut"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initiativeHeading"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeTitle"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeText"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeCtaText"}},{"kind":"Field","name":{"kind":"Name","value":"searchQuery"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ParallaxImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExperienceBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"mediaCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"referencesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Opengraph_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLinks_ConnectWithFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWith"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"linksCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FinancialsGraphSectionRichText_FinancialsPageGraphsSectionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinancialsPageGraphsSection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineCards"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContentGrid_EntryFragment"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<FinancialsPage_QueryQuery, FinancialsPage_QueryQueryVariables>;
export const GrantDetailsPage_RelatedGrantsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GrantDetailsPage_RelatedGrantsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"grantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grantCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"5"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"AND"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organization"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id_not"},"value":{"kind":"Variable","name":{"kind":"Name","value":"grantId"}}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"date_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantCard_GrantFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantCard_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GrantDetailsPage_RelatedGrantsQueryQuery, GrantDetailsPage_RelatedGrantsQueryQueryVariables>;
export const TotalGrants_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TotalGrants_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grantCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<TotalGrants_QueryQuery, TotalGrants_QueryQueryVariables>;
export const GrantsByPage_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GrantsByPage_Query"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grantCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1000"}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<GrantsByPage_QueryQuery, GrantsByPage_QueryQueryVariables>;
export const GrantDetails_GrantQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GrantDetails_GrantQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grantCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantDetails_GrantFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantDetailsPageRelatedGrants_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantDetails_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"grantmakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMonths"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantDetailsPageRelatedGrants_GrantFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GrantDetails_GrantQueryQuery, GrantDetails_GrantQueryQueryVariables>;
export const GrantDetails_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GrantDetails_Query"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"grantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grantDetailsPageCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"grant"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"grantId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relatedActivitiesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContentGrid_EntryFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"granteeInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLinks_ConnectWithFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"strategyCopy"}},{"kind":"Field","name":{"kind":"Name","value":"strategyCtaLabel"}},{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantDetails_GrantFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentOrGrantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"granteeNameOverride"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteText"}},{"kind":"Field","name":{"kind":"Name","value":"quoteImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quoteAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"twitterUsername"}},{"kind":"Field","name":{"kind":"Name","value":"isTwitterImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"dateString"},"name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pinnedGrantStoriesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MmufCard_MmufFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mmuf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"introDescription"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"introImagesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CallForConcept"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineTitle"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWithLink"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"internalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantDetailsPageRelatedGrants_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContentGrid_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MmufCard_MmufFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLinks_ConnectWithFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWith"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"linksCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantDetails_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"grantmakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMonths"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantDetailsPageRelatedGrants_GrantFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GrantDetails_QueryQuery, GrantDetails_QueryQueryVariables>;
export const AllGrantPrograms_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllGrantPrograms_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grantmakingAreaDetailsPageCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<AllGrantPrograms_QueryQuery, AllGrantPrograms_QueryQueryVariables>;
export const GrantProgram_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GrantProgram_Query"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grantmakingAreaDetailsPageCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"introDescription"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Header_AssetFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Opengraph_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"introductionText"}},{"kind":"Field","name":{"kind":"Name","value":"quickLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLinks_ConnectWithFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantmakingAreaDetailsPageBodyRichText_GrantmakingAreaDetailsPageBodyFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inFocusContentCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContentGrid_EntryFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantMakingProcessMessage"}},{"kind":"Field","name":{"kind":"Name","value":"callForConceptsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWithLink"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"internalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentOrGrantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"granteeNameOverride"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteText"}},{"kind":"Field","name":{"kind":"Name","value":"quoteImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quoteAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"twitterUsername"}},{"kind":"Field","name":{"kind":"Name","value":"isTwitterImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"dateString"},"name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pinnedGrantStoriesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MmufCard_MmufFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mmuf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"introDescription"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"introImagesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CallForConcept"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineTitle"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContentGrid_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MmufCard_MmufFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invert"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightSlideshow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightVideo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"videoCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"previewStaticImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ctaLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoNativeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoNative"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"closedCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAmbient"}},{"kind":"Field","name":{"kind":"Name","value":"isVertical"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoYoutube"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InitiativeQuoteCallOut"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initiativeHeading"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeTitle"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeText"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeCtaText"}},{"kind":"Field","name":{"kind":"Name","value":"searchQuery"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ParallaxImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExperienceBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"mediaCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"referencesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Header_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Opengraph_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLinks_ConnectWithFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWith"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"linksCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantmakingAreaDetailsPageBodyRichText_GrantmakingAreaDetailsPageBodyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPageBody"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineCards"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContentGrid_EntryFragment"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GrantProgram_QueryQuery, GrantProgram_QueryQueryVariables>;
export const GrantProgramsPage_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GrantProgramsPage_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grantmakingAreasPageCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"introDescription"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Opengraph_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantmakingAreasCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantmakingAreaCard_GrantmakingAreaDetailsPageFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contextualMessage"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Opengraph_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantmakingAreaCard_GrantmakingAreaDetailsPageFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"introDescription"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GrantProgramsPage_QueryQuery, GrantProgramsPage_QueryQueryVariables>;
export const AllGrantStories_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllGrantStories_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grantActivityArticleCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Localization_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocalizationMetadata_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Localization_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocalizationMetadata_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Localization_EntryFragment"}}]}}]} as unknown as DocumentNode<AllGrantStories_QueryQuery, AllGrantStories_QueryQueryVariables>;
export const GrantStory_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GrantStory_Query"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grantActivityArticleCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Metadata_MetadataFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Header_HeroAssetFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Opengraph_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Header_AssetFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Opengraph_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantmakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"granteeNameOverride"}},{"kind":"Field","name":{"kind":"Name","value":"granteeCountryOverride"}},{"kind":"Field","name":{"kind":"Name","value":"granteeStateOverride"}},{"kind":"Field","name":{"kind":"Name","value":"granteeCityOverride"}},{"kind":"Field","name":{"kind":"Name","value":"hideDate"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"photographer"}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"audio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creditLabel"}},{"kind":"Field","name":{"kind":"Name","value":"creditText"}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantStoryBodyRichText_GrantActivityArticleBodyFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantInsight"}},{"kind":"Field","name":{"kind":"Name","value":"connectLinksCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"hideShareLink"}},{"kind":"Field","name":{"kind":"Name","value":"relatedArticlesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContentGrid_EntryFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"experienceBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattingOptions"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocalizationMetadata_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Localization_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Header_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Opengraph_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentOrGrantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"granteeNameOverride"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteText"}},{"kind":"Field","name":{"kind":"Name","value":"quoteImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quoteAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"twitterUsername"}},{"kind":"Field","name":{"kind":"Name","value":"isTwitterImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"dateString"},"name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pinnedGrantStoriesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MmufCard_MmufFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mmuf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"introDescription"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"introImagesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CallForConcept"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineTitle"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContentGrid_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MmufCard_MmufFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invert"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightSlideshow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightVideo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"videoCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"previewStaticImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ctaLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWithLink"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"internalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoNativeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoNative"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"closedCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAmbient"}},{"kind":"Field","name":{"kind":"Name","value":"isVertical"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoYoutube"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InitiativeQuoteCallOut"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initiativeHeading"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeTitle"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeText"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeCtaText"}},{"kind":"Field","name":{"kind":"Name","value":"searchQuery"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ParallaxImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExperienceBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"mediaCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"referencesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Localization_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Metadata_MetadataFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Metadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ogTitle"}},{"kind":"Field","name":{"kind":"Name","value":"ogDescription"}},{"kind":"Field","name":{"kind":"Name","value":"ogImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Header_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Header_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoHasAudio"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Opengraph_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Opengraph_AssetFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantStoryBodyRichText_GrantActivityArticleBodyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticleBody"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineCards"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContentGrid_EntryFragment"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocalizationMetadata_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Localization_EntryFragment"}}]}}]} as unknown as DocumentNode<GrantStory_QueryQuery, GrantStory_QueryQueryVariables>;
export const JazzVideo_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JazzVideo_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videoNative"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"StringValue","value":"4KmsC0xuU1hLv8ltVmHheV","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoNativeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoNative"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"closedCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAmbient"}},{"kind":"Field","name":{"kind":"Name","value":"isVertical"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<JazzVideo_QueryQuery, JazzVideo_QueryQueryVariables>;
export const AllHistoryPersons_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllHistoryPersons_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"historyPersonCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<AllHistoryPersons_QueryQuery, AllHistoryPersons_QueryQueryVariables>;
export const HistoryPerson_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HistoryPerson_Query"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"historyPersonCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"biography"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Header_AssetFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Opengraph_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"startYear"}},{"kind":"Field","name":{"kind":"Name","value":"endYear"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Header_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Opengraph_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<HistoryPerson_QueryQuery, HistoryPerson_QueryQueryVariables>;
export const HistoryPage_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HistoryPage_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"historyPageCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Header_AssetFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Opengraph_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"impactTitle"}},{"kind":"Field","name":{"kind":"Name","value":"impactArticlesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"explanatoryParagraph"}},{"kind":"Field","name":{"kind":"Name","value":"peopleTitle"}},{"kind":"Field","name":{"kind":"Name","value":"peopleSubtitle"}},{"kind":"Field","name":{"kind":"Name","value":"peopleDescription"}},{"kind":"Field","name":{"kind":"Name","value":"foundersCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadershipCard_HistoryPersonFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"presidentsTitle"}},{"kind":"Field","name":{"kind":"Name","value":"currentPresident"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentPresidentStartYear"}},{"kind":"Field","name":{"kind":"Name","value":"previousPresidentsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PersonCard_HistoryPersonFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"spaceTitle"}},{"kind":"Field","name":{"kind":"Name","value":"spaceDescription"}},{"kind":"Field","name":{"kind":"Name","value":"spaceImagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantMakingProcessDescription"}},{"kind":"Field","name":{"kind":"Name","value":"grantMakingProcessCtaText"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Header_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Opengraph_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadershipCard_HistoryPersonFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PersonCard_HistoryPersonFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startYear"}},{"kind":"Field","name":{"kind":"Name","value":"endYear"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<HistoryPage_QueryQuery, HistoryPage_QueryQueryVariables>;
export const AllIdeas_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllIdeas_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ideaCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<AllIdeas_QueryQuery, AllIdeas_QueryQueryVariables>;
export const Idea_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Idea_Query"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ideaCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Header_AssetFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Opengraph_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Opengraph_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ideaSetupStatement"}},{"kind":"Field","name":{"kind":"Name","value":"contentCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContentGrid_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmphasizedCard_EmphasizedArticleQuery"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"callForConceptsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ctaContextualMessage"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentOrGrantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"granteeNameOverride"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteText"}},{"kind":"Field","name":{"kind":"Name","value":"quoteImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quoteAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"twitterUsername"}},{"kind":"Field","name":{"kind":"Name","value":"isTwitterImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"dateString"},"name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pinnedGrantStoriesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MmufCard_MmufFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mmuf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"introDescription"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"introImagesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CallForConcept"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineTitle"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Header_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Opengraph_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContentGrid_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MmufCard_MmufFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InitiativeQuoteCallOut"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initiativeHeading"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeTitle"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeText"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeCtaText"}},{"kind":"Field","name":{"kind":"Name","value":"searchQuery"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightSlideshow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightVideo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"videoCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"previewStaticImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ctaLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmphasizedCard_EmphasizedArticleQuery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmphasizedArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<Idea_QueryQuery, Idea_QueryQueryVariables>;
export const MissionPage_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MissionPage_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"missionPageCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Opengraph_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"atGlanceCardsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HighlightCard_AtGlanceCardFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Opengraph_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HighlightCard_AtGlanceCardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AtGlanceCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"bodyText"}},{"kind":"Field","name":{"kind":"Name","value":"typeReference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteText"}},{"kind":"Field","name":{"kind":"Name","value":"quoteImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quoteAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"twitterUsername"}},{"kind":"Field","name":{"kind":"Name","value":"isTwitterImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<MissionPage_QueryQuery, MissionPage_QueryQueryVariables>;
export const MmufPage_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MMUFPage_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mmufCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"introDescription"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Header_AssetFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Opengraph_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"articleTitle"}},{"kind":"Field","name":{"kind":"Name","value":"articleText"}},{"kind":"Field","name":{"kind":"Name","value":"historyLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quickLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLinks_ConnectWithFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"spotlight"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"graduateInitiativesTitle"}},{"kind":"Field","name":{"kind":"Name","value":"graduateInitiativesText"}},{"kind":"Field","name":{"kind":"Name","value":"graduateInitiativesLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"atGlanceTitle"}},{"kind":"Field","name":{"kind":"Name","value":"pullQuote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inFocusHeadline"}},{"kind":"Field","name":{"kind":"Name","value":"fellowStoriesMessage"}},{"kind":"Field","name":{"kind":"Name","value":"fellowStoriesCtaLabel"}},{"kind":"Field","name":{"kind":"Name","value":"newsletter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Newsletter_NewsletterFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"faqs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Faqs_FaqsModuleFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactTitle"}},{"kind":"Field","name":{"kind":"Name","value":"contactMessage"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWithLink"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"internalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Faq_FaqFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Faq"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Header_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Opengraph_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLinks_ConnectWithFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWith"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"linksCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightSlideshow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightVideo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"videoCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"previewStaticImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ctaLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteText"}},{"kind":"Field","name":{"kind":"Name","value":"quoteImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quoteAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"twitterUsername"}},{"kind":"Field","name":{"kind":"Name","value":"isTwitterImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Newsletter_NewsletterFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"disclaimer"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Faqs_FaqsModuleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FaqsModule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"faqsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Faq_FaqFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<MmufPage_QueryQuery, MmufPage_QueryQueryVariables>;
export const MmufPageReferences_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MMUFPageReferences_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mmufCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"atGlanceCardsCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"4"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HighlightCard_AtGlanceCardFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"inFocusContentCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"4"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContentGrid_EntryFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"inTheNewsCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"5"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentOrGrantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"granteeNameOverride"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteText"}},{"kind":"Field","name":{"kind":"Name","value":"quoteImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quoteAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"twitterUsername"}},{"kind":"Field","name":{"kind":"Name","value":"isTwitterImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"dateString"},"name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pinnedGrantStoriesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MmufCard_MmufFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mmuf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"introDescription"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"introImagesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CallForConcept"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineTitle"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HighlightCard_AtGlanceCardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AtGlanceCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"bodyText"}},{"kind":"Field","name":{"kind":"Name","value":"typeReference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContentGrid_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MmufCard_MmufFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"}}]}}]} as unknown as DocumentNode<MmufPageReferences_QueryQuery, MmufPageReferences_QueryQueryVariables>;
export const NewsPage_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NewsPage_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newsPageCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"featuredNews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pressRoomCopy"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"introImagesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentOrGrantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<NewsPage_QueryQuery, NewsPage_QueryQueryVariables>;
export const NewsPageNews_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NewsPageNews_Query"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleOrder"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"articleCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"sort"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"hideDate"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Header_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Header_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Header_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Header_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoHasAudio"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<NewsPageNews_QueryQuery, NewsPageNews_QueryQueryVariables>;
export const NewsletterPages_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NewsletterPages_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newsletterPageCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<NewsletterPages_QueryQuery, NewsletterPages_QueryQueryVariables>;
export const NewsletterPage_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NewsletterPage_Query"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newsletterPageCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quickLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLinks_ConnectWithFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signupDescription"}},{"kind":"Field","name":{"kind":"Name","value":"signupImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWithLink"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"internalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLinks_ConnectWithFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWith"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"linksCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<NewsletterPage_QueryQuery, NewsletterPage_QueryQueryVariables>;
export const NewsletterConfirmPage_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NewsletterConfirmPage_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newsletterConfirmPageCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NewsletterConfirmBodyRichText_NewsletterConfirmPageBodyFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentOrGrantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"granteeNameOverride"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteText"}},{"kind":"Field","name":{"kind":"Name","value":"quoteImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quoteAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"twitterUsername"}},{"kind":"Field","name":{"kind":"Name","value":"isTwitterImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"dateString"},"name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pinnedGrantStoriesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MmufCard_MmufFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mmuf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"introDescription"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"introImagesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CallForConcept"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineTitle"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContentGrid_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MmufCard_MmufFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invert"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightSlideshow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightVideo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"videoCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"previewStaticImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ctaLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWithLink"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"internalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoNativeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoNative"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"closedCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAmbient"}},{"kind":"Field","name":{"kind":"Name","value":"isVertical"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoYoutube"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InitiativeQuoteCallOut"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initiativeHeading"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeTitle"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeText"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeCtaText"}},{"kind":"Field","name":{"kind":"Name","value":"searchQuery"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ParallaxImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExperienceBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"mediaCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"referencesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NewsletterConfirmBodyRichText_NewsletterConfirmPageBodyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterConfirmPageBody"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineCards"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContentGrid_EntryFragment"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"}}]}}]}}]}}]}}]} as unknown as DocumentNode<NewsletterConfirmPage_QueryQuery, NewsletterConfirmPage_QueryQueryVariables>;
export const PeopleQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PeopleQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"peoplePageCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Header_AssetFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Opengraph_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"president"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadershipCard_PersonFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadershipCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PersonCard_PersonFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"trusteesCtaLabel"}},{"kind":"Field","name":{"kind":"Name","value":"trusteesCtaText"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Header_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Opengraph_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadershipCard_PersonFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PersonCard_PersonFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departmentOrGrantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<PeopleQueryQuery, PeopleQueryQueryVariables>;
export const TrusteesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TrusteesQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trusteesPageCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"trusteesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PersonCard_TrusteeFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PersonCard_TrusteeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Trustee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<TrusteesQueryQuery, TrusteesQueryQueryVariables>;
export const PressRoomPage_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PressRoomPage_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pressRoomCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"contactsTitle"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"emailLabel"}},{"kind":"Field","name":{"kind":"Name","value":"contactPersonsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"quickLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLinks_ConnectWithFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"atGlanceCardsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HighlightCard_AtGlanceCardFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"factSheetLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"spotlight"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"guidelinesAndMediasHeading"}},{"kind":"Field","name":{"kind":"Name","value":"guidelinesAndMediasDescription"}},{"kind":"Field","name":{"kind":"Name","value":"brandGuidelinesAndMediaAssetsLinksCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"newsContentCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWithLink"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"internalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLinks_ConnectWithFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWith"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"linksCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HighlightCard_AtGlanceCardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AtGlanceCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"bodyText"}},{"kind":"Field","name":{"kind":"Name","value":"typeReference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightSlideshow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightVideo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"videoCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"previewStaticImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ctaLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"introImagesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentOrGrantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<PressRoomPage_QueryQuery, PressRoomPage_QueryQueryVariables>;
export const Layout_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Layout_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Navigation_QueryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Footer_QueryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecondaryNavigationContent_QueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mainNavigationCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"babyMissionStatement"}},{"kind":"Field","name":{"kind":"Name","value":"ideasCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"resourcesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinancialsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreasPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MissionPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PeoplePage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecondaryNavigationSearch_QueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchPageCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featuredSearches"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecondaryNavigation_QueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SecondaryNavigationContent_QueryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SecondaryNavigationSearch_QueryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWithLink"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"internalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Newsletter_NewsletterFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"disclaimer"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Socials_ContactFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facebookLink"}},{"kind":"Field","name":{"kind":"Name","value":"instagramLink"}},{"kind":"Field","name":{"kind":"Name","value":"threadsLink"}},{"kind":"Field","name":{"kind":"Name","value":"youtubeLink"}},{"kind":"Field","name":{"kind":"Name","value":"linkedInLink"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Idea_IdeaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Ideas_QueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ideaCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Idea_IdeaFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Navigation_QueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SecondaryNavigation_QueryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Footer_QueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"footerCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"footerLinksCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"newsletter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Newsletter_NewsletterFragment"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"footerContactCollection"},"name":{"kind":"Name","value":"contactCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Socials_ContactFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Ideas_QueryFragment"}}]}}]} as unknown as DocumentNode<Layout_QueryQuery, Layout_QueryQueryVariables>;
export const Home_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Home_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"homePageCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spotlightImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"spotlightVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"spotlightFeature"}},{"kind":"Field","name":{"kind":"Name","value":"spotlightCtaLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCta_ArticleFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tagline"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"granteeNameOverride"}},{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}},{"kind":"Field","name":{"kind":"Name","value":"storiesCta"}},{"kind":"Field","name":{"kind":"Name","value":"inFocusHeadline"}},{"kind":"Field","name":{"kind":"Name","value":"inFocusContentCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContentGrid_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmphasizedCard_EmphasizedArticleQuery"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"layout"}},{"kind":"Field","name":{"kind":"Name","value":"grantActivityArticlesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantStoryAccordionCard_GrantActivityArticleFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"missionText"}},{"kind":"Field","name":{"kind":"Name","value":"newsletter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Newsletter_NewsletterFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inTheNewsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"thematicSpotlight"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentOrGrantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"granteeNameOverride"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteText"}},{"kind":"Field","name":{"kind":"Name","value":"quoteImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quoteAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"twitterUsername"}},{"kind":"Field","name":{"kind":"Name","value":"isTwitterImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"dateString"},"name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pinnedGrantStoriesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MmufCard_MmufFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mmuf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"introDescription"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"introImagesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CallForConcept"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineTitle"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCta_ArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContentGrid_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MmufCard_MmufFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmphasizedCard_EmphasizedArticleQuery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmphasizedArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantStoryAccordionCard_GrantActivityArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Newsletter_NewsletterFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"disclaimer"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightSlideshow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightVideo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"videoCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"previewStaticImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ctaLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<Home_QueryQuery, Home_QueryQueryVariables>;
export const ForGrantSeekers_PageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ForGrantSeekers_Page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resourcesProspectiveGranteesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quickLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLinks_ConnectWithFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Header_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"callsForConceptsTitle"}},{"kind":"Field","name":{"kind":"Name","value":"callsForConceptsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"newsletterCtaText"}},{"kind":"Field","name":{"kind":"Name","value":"grantmakingAreasCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantmakingAreaCard_GrantmakingAreaDetailsPageFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"explanatoryParagraph"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResourcesExplanatoryParagraphRichText_ResourcesExplanatoryParagraphFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantmakingAtGlanceTitle"}},{"kind":"Field","name":{"kind":"Name","value":"grantmakingAtGlanceCardsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HighlightCard_AtGlanceCardFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantDatabaseCtaText"}},{"kind":"Field","name":{"kind":"Name","value":"faqs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Faqs_FaqsModuleFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWithLink"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"internalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Header_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentOrGrantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"granteeNameOverride"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navigationImagePortrait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteText"}},{"kind":"Field","name":{"kind":"Name","value":"quoteImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quoteAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"twitterUsername"}},{"kind":"Field","name":{"kind":"Name","value":"isTwitterImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"dateString"},"name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pinnedGrantStoriesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MmufCard_MmufFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mmuf"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"introDescription"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"introImagesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CallForConcept"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineTitle"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContentGrid_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantStoryCard_GrantActivityArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdeaCard_IdeaFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FutureEventCard_ExternalEventFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MmufCard_MmufFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invert"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightSlideshow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightVideo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"videoCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"previewStaticImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ctaLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoNativeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoNative"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"closedCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAmbient"}},{"kind":"Field","name":{"kind":"Name","value":"isVertical"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoYoutube"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InitiativeQuoteCallOut"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initiativeHeading"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeTitle"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeText"}},{"kind":"Field","name":{"kind":"Name","value":"initiativeCtaText"}},{"kind":"Field","name":{"kind":"Name","value":"searchQuery"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ParallaxImages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExperienceBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"mediaCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"referencesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Faq_FaqFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Faq"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLinks_ConnectWithFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWith"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"linksCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Header_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Header_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoHasAudio"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantmakingAreaCard_GrantmakingAreaDetailsPageFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"introDescription"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResourcesExplanatoryParagraphRichText_ResourcesExplanatoryParagraphFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ResourcesProspectiveGranteesExplanatoryParagraph"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InlineCards"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContentGrid_EntryFragment"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InlineImages_InlineImagesFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoNativeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Video_VideoYoutubeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InitiativeQuote_InitiativeQuoteCallOutFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParallaxImages_ParallaxImagesQuery"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExperienceBlock_ExperienceBlockFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HighlightCard_AtGlanceCardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AtGlanceCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"bodyText"}},{"kind":"Field","name":{"kind":"Name","value":"typeReference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Faqs_FaqsModuleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FaqsModule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"faqsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Faq_FaqFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ForGrantSeekers_PageQuery, ForGrantSeekers_PageQueryVariables>;
export const ForGrantPartners_PageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ForGrantPartners_Page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resourcesCurrentGranteesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quickLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLinks_ConnectWithFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Header_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resourcesTitle"}},{"kind":"Field","name":{"kind":"Name","value":"resourcesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"similarGranteesTitle"}},{"kind":"Field","name":{"kind":"Name","value":"similarGranteesGrantmakingAreasCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tagline"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantDatabaseCtaText"}},{"kind":"Field","name":{"kind":"Name","value":"faqs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Faqs_FaqsModuleFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWithLink"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"internalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Header_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Faq_FaqFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Faq"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLinks_ConnectWithFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWith"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"linksCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Header_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Header_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoHasAudio"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentOrGrantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AnnualReportCard_AnnualReportFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"introImagesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Faqs_FaqsModuleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FaqsModule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"faqsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Faq_FaqFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ForGrantPartners_PageQuery, ForGrantPartners_PageQueryVariables>;
export const Resources_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Resources_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grantResourcesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"introDescription"}},{"kind":"Field","name":{"kind":"Name","value":"quickLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLinks_ConnectWithFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"callForConceptsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantMakingAreasTitle"}},{"kind":"Field","name":{"kind":"Name","value":"grantMakingAreasCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantmakingAreaCard_GrantmakingAreaDetailsPageFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"explanatoryTitle"}},{"kind":"Field","name":{"kind":"Name","value":"explanatoryParagraph"}},{"kind":"Field","name":{"kind":"Name","value":"grantActivityArticlesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantStoryAccordionCard_GrantActivityArticleFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"spotlight"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pullQuote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantsAtGlanceCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HighlightCard_AtGlanceCardFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"newsletter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Newsletter_NewsletterFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"searchContextualMessage"}},{"kind":"Field","name":{"kind":"Name","value":"faqs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Faqs_FaqsModuleFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWithLink"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"internalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Faq_FaqFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Faq"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuickLinks_ConnectWithFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectWith"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"linksCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuickLink_ConnectWithLinkFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallForConcepts_CallForConceptFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CallForConcept"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}},{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineTitle"}},{"kind":"Field","name":{"kind":"Name","value":"registrationDeadlineDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantmakingAreaCard_GrantmakingAreaDetailsPageFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"introDescription"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantStoryAccordionCard_GrantActivityArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightVideo_SpotlightVideoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightVideo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"videoCaptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"previewStaticImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ctaLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotlightSlideshow_SpotlightSlideshowFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpotlightSlideshow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"subheadline"}},{"kind":"Field","name":{"kind":"Name","value":"imagesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotlightSlideshowSlide_AssetFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuoteModule_QuoteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Quote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quoteText"}},{"kind":"Field","name":{"kind":"Name","value":"quoteImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quoteAudio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"attribution"}},{"kind":"Field","name":{"kind":"Name","value":"twitterUsername"}},{"kind":"Field","name":{"kind":"Name","value":"isTwitterImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HighlightCard_AtGlanceCardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AtGlanceCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"bodyText"}},{"kind":"Field","name":{"kind":"Name","value":"typeReference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"ctaText"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Newsletter_NewsletterFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"disclaimer"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Faqs_FaqsModuleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FaqsModule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"faqsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Faq_FaqFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<Resources_QueryQuery, Resources_QueryQueryVariables>;
export const StoriesPage_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StoriesPage_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storiesPageCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"highlightedFeature"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"dateString"},"name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pinnedGrantStoriesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<StoriesPage_QueryQuery, StoriesPage_QueryQueryVariables>;
export const StoriesPageGrantStories_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StoriesPageGrantStories_Query"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"grantStorySort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticleOrder"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grantActivityArticleCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"grantStorySort"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<StoriesPageGrantStories_QueryQuery, StoriesPageGrantStories_QueryQueryVariables>;
export const StoriesPageFeatures_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StoriesPageFeatures_Query"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"featureSort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FeatureOrder"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featureCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"featureSort"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"}},{"kind":"Field","alias":{"kind":"Name","value":"date"},"name":{"kind":"Name","value":"dateTime"}},{"kind":"Field","name":{"kind":"Name","value":"grantStoriesSetCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeatureCard_FeatureFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"dateString"},"name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pinnedGrantStoriesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"leadImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]} as unknown as DocumentNode<StoriesPageFeatures_QueryQuery, StoriesPageFeatures_QueryQueryVariables>;
export const StoriesPageArticles_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StoriesPageArticles_Query"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"articleSort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleOrder"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"articleType"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"articleCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"articleSort"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"articleType"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"hideDate"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Header_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Header_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Header_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Header_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoHasAudio"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<StoriesPageArticles_QueryQuery, StoriesPageArticles_QueryQueryVariables>;
export const NewsCarousel_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NewsCarousel_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"articleCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"Grantee news","block":false},{"kind":"StringValue","value":"Mellon news","block":false},{"kind":"StringValue","value":"Report","block":false}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"date_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"5"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"src"},"name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_AssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Hero_HeroAssetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeroAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantTitle_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"projectTitle"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GrantSlug_GrantFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantTitle_GrantFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalLink_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantActivityArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingAreaDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Grant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantDetailsPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GrantSlug_GrantFragment"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSearchFilters"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryPerson"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewsletterPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OldAnnualReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RootPage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCard_ArticleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Hero_HeroAssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisherLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentOrGrantMakingArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GrantmakingArea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image_AssetFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalNewsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalLink_EntryFragment"}}]}}]} as unknown as DocumentNode<NewsCarousel_QueryQuery, NewsCarousel_QueryQueryVariables>;
export const Theme_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Theme_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"themeCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"secondary"}},{"kind":"Field","name":{"kind":"Name","value":"copy"}},{"kind":"Field","name":{"kind":"Name","value":"fullScreenAnimation"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cache_EntryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cache_EntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<Theme_QueryQuery, Theme_QueryQueryVariables>;
export const Social_QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Social_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"socialContactCollection"},"name":{"kind":"Name","value":"contactCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_publishedAt_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Socials_ContactFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Socials_ContactFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facebookLink"}},{"kind":"Field","name":{"kind":"Name","value":"instagramLink"}},{"kind":"Field","name":{"kind":"Name","value":"threadsLink"}},{"kind":"Field","name":{"kind":"Name","value":"youtubeLink"}},{"kind":"Field","name":{"kind":"Name","value":"linkedInLink"}}]}}]} as unknown as DocumentNode<Social_QueryQuery, Social_QueryQueryVariables>;